var KO = Object.defineProperty;
var XO = (e, t, n) => t in e ? KO(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Ne = (e, t, n) => (XO(e, typeof t != "symbol" ? t + "" : t, n), n);
import { Fragment as Le, reactive as Ma, computed as I, watchEffect as Xn, toRefs as am, capitalize as za, isVNode as JO, Comment as QO, shallowRef as Ie, unref as je, warn as qc, getCurrentInstance as E0, ref as ue, provide as jt, inject as gt, defineComponent as Je, camelize as A0, h as br, createVNode as b, isRef as qi, resolveDynamicComponent as eE, toRef as ce, nextTick as Ct, onScopeDispose as gn, mergeProps as fe, Text as tE, watch as Se, effectScope as om, toRaw as Pt, TransitionGroup as lm, Transition as Hs, onBeforeMount as _l, onBeforeUnmount as kn, withDirectives as rn, resolveDirective as ji, vShow as qs, openBlock as le, createBlock as Te, withCtx as Z, renderSlot as wt, createCommentVNode as it, createElementVNode as St, onMounted as Jn, readonly as jc, Teleport as nE, onDeactivated as M0, withModifiers as Dt, createElementBlock as nt, normalizeStyle as Qr, toDisplayString as At, createTextVNode as Ee, pushScopeId as iE, popScopeId as rE, onUpdated as sE, onActivated as aE, createSlots as oE, normalizeClass as D0, onBeforeUpdate as lE, markRaw as uE, cloneVNode as cE, renderList as um, getCurrentScope as dE, vModelText as fE, useCssVars as hE, onUnmounted as V0, isReactive as mE, version as gE, isProxy as L0 } from "vue";
function ee(e, t) {
  return (n) => Object.keys(e).reduce((i, r) => {
    const a = typeof e[r] == "object" && e[r] != null && !Array.isArray(e[r]) ? e[r] : {
      type: e[r]
    };
    return n && r in n ? i[r] = {
      ...a,
      default: n[r]
    } : i[r] = a, t && !i[r].source && (i[r].source = t), i;
  }, {});
}
const Ae = ee({
  class: [String, Array, Object],
  style: {
    type: [String, Array, Object],
    default: null
  }
}, "component"), Bt = typeof window < "u", cm = Bt && "IntersectionObserver" in window, Ty = Bt && "EyeDropper" in window;
function F0(e, t, n) {
  const i = t.length - 1;
  if (i < 0)
    return e === void 0 ? n : e;
  for (let r = 0; r < i; r++) {
    if (e == null)
      return n;
    e = e[t[r]];
  }
  return e == null || e[t[i]] === void 0 ? n : e[t[i]];
}
function Sr(e, t) {
  if (e === t)
    return !0;
  if (e instanceof Date && t instanceof Date && e.getTime() !== t.getTime() || e !== Object(e) || t !== Object(t))
    return !1;
  const n = Object.keys(e);
  return n.length !== Object.keys(t).length ? !1 : n.every((i) => Sr(e[i], t[i]));
}
function rl(e, t, n) {
  return e == null || !t || typeof t != "string" ? n : e[t] !== void 0 ? e[t] : (t = t.replace(/\[(\w+)\]/g, ".$1"), t = t.replace(/^\./, ""), F0(e, t.split("."), n));
}
function Fn(e, t, n) {
  if (t === !0)
    return e === void 0 ? n : e;
  if (t == null || typeof t == "boolean")
    return n;
  if (e !== Object(e)) {
    if (typeof t != "function")
      return n;
    const r = t(e, n);
    return typeof r > "u" ? n : r;
  }
  if (typeof t == "string")
    return rl(e, t, n);
  if (Array.isArray(t))
    return F0(e, t, n);
  if (typeof t != "function")
    return n;
  const i = t(e, n);
  return typeof i > "u" ? n : i;
}
function Ho(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return Array.from({
    length: e
  }, (n, i) => t + i);
}
function Ce(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "px";
  if (!(e == null || e === ""))
    return isNaN(+e) ? String(e) : isFinite(+e) ? `${Number(e)}${t}` : void 0;
}
function R0(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function Iy(e) {
  let t;
  return e !== null && typeof e == "object" && ((t = Object.getPrototypeOf(e)) === Object.prototype || t === null);
}
function dm(e) {
  if (e && "$el" in e) {
    const t = e.$el;
    return (t == null ? void 0 : t.nodeType) === Node.TEXT_NODE ? t.nextElementSibling : t;
  }
  return e;
}
const Py = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34,
  shift: 16
}), xh = Object.freeze({
  enter: "Enter",
  tab: "Tab",
  delete: "Delete",
  esc: "Escape",
  space: "Space",
  up: "ArrowUp",
  down: "ArrowDown",
  left: "ArrowLeft",
  right: "ArrowRight",
  end: "End",
  home: "Home",
  del: "Delete",
  backspace: "Backspace",
  insert: "Insert",
  pageup: "PageUp",
  pagedown: "PageDown",
  shift: "Shift"
});
function Ds(e, t) {
  return t.every((n) => e.hasOwnProperty(n));
}
function B0(e, t) {
  const n = {}, i = new Set(Object.keys(e));
  for (const r of t)
    i.has(r) && (n[r] = e[r]);
  return n;
}
function Oy(e, t, n) {
  const i = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  for (const s in e)
    t.some((a) => a instanceof RegExp ? a.test(s) : a === s) && !(n != null && n.some((a) => a === s)) ? i[s] = e[s] : r[s] = e[s];
  return [i, r];
}
function Gi(e, t) {
  const n = {
    ...e
  };
  return t.forEach((i) => delete n[i]), n;
}
function vE(e, t) {
  const n = {};
  return t.forEach((i) => n[i] = e[i]), n;
}
const N0 = /^on[^a-z]/, Gc = (e) => N0.test(e), yE = ["onAfterscriptexecute", "onAnimationcancel", "onAnimationend", "onAnimationiteration", "onAnimationstart", "onAuxclick", "onBeforeinput", "onBeforescriptexecute", "onChange", "onClick", "onCompositionend", "onCompositionstart", "onCompositionupdate", "onContextmenu", "onCopy", "onCut", "onDblclick", "onFocusin", "onFocusout", "onFullscreenchange", "onFullscreenerror", "onGesturechange", "onGestureend", "onGesturestart", "onGotpointercapture", "onInput", "onKeydown", "onKeypress", "onKeyup", "onLostpointercapture", "onMousedown", "onMousemove", "onMouseout", "onMouseover", "onMouseup", "onMousewheel", "onPaste", "onPointercancel", "onPointerdown", "onPointerenter", "onPointerleave", "onPointermove", "onPointerout", "onPointerover", "onPointerup", "onReset", "onSelect", "onSubmit", "onTouchcancel", "onTouchend", "onTouchmove", "onTouchstart", "onTransitioncancel", "onTransitionend", "onTransitionrun", "onTransitionstart", "onWheel"];
function Yc(e) {
  const [t, n] = Oy(e, [N0]), i = Gi(t, yE), [r, s] = Oy(n, ["class", "style", "id", /^data-/]);
  return Object.assign(r, t), Object.assign(s, i), [r, s];
}
function mn(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function pE(e, t) {
  let n = 0;
  const i = function() {
    for (var r = arguments.length, s = new Array(r), a = 0; a < r; a++)
      s[a] = arguments[a];
    clearTimeout(n), n = setTimeout(() => e(...s), je(t));
  };
  return i.clear = () => {
    clearTimeout(n);
  }, i.immediate = e, i;
}
function Jt(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return Math.max(t, Math.min(n, e));
}
function Ey(e) {
  const t = e.toString().trim();
  return t.includes(".") ? t.length - t.indexOf(".") - 1 : 0;
}
function Ay(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
  return e + n.repeat(Math.max(0, t - e.length));
}
function bE(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  const n = [];
  let i = 0;
  for (; i < e.length; )
    n.push(e.substr(i, t)), i += t;
  return n;
}
function vr() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
  const i = {};
  for (const r in e)
    i[r] = e[r];
  for (const r in t) {
    const s = e[r], a = t[r];
    if (Iy(s) && Iy(a)) {
      i[r] = vr(s, a, n);
      continue;
    }
    if (n && Array.isArray(s) && Array.isArray(a)) {
      i[r] = n(s, a);
      continue;
    }
    i[r] = a;
  }
  return i;
}
function $0(e) {
  return e.map((t) => t.type === Le ? $0(t.children) : t).flat();
}
function Fs() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  if (Fs.cache.has(e))
    return Fs.cache.get(e);
  const t = e.replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase();
  return Fs.cache.set(e, t), t;
}
Fs.cache = /* @__PURE__ */ new Map();
function Wo(e, t) {
  if (!t || typeof t != "object")
    return [];
  if (Array.isArray(t))
    return t.map((n) => Wo(e, n)).flat(1);
  if (t.suspense)
    return Wo(e, t.ssContent);
  if (Array.isArray(t.children))
    return t.children.map((n) => Wo(e, n)).flat(1);
  if (t.component) {
    if (Object.getOwnPropertySymbols(t.component.provides).includes(e))
      return [t.component];
    if (t.component.subTree)
      return Wo(e, t.component.subTree).flat(1);
  }
  return [];
}
function xE(e) {
  return "touches" in e ? {
    clientX: e.touches[0].clientX,
    clientY: e.touches[0].clientY
  } : {
    clientX: e.clientX,
    clientY: e.clientY
  };
}
function fm(e) {
  const t = Ma({}), n = I(e);
  return Xn(() => {
    for (const i in n.value)
      t[i] = n.value[i];
  }, {
    flush: "sync"
  }), am(t);
}
function xc(e, t) {
  return e.includes(t);
}
function z0(e) {
  return e[2].toLowerCase() + e.slice(3);
}
const cn = () => [Function, Array];
function My(e, t) {
  return t = "on" + za(t), !!(e[t] || e[`${t}Once`] || e[`${t}Capture`] || e[`${t}OnceCapture`] || e[`${t}CaptureOnce`]);
}
function hm(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  if (Array.isArray(e))
    for (const r of e)
      r(...n);
  else
    typeof e == "function" && e(...n);
}
function sl(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  const n = ["button", "[href]", 'input:not([type="hidden"])', "select", "textarea", "[tabindex]"].map((i) => `${i}${t ? ':not([tabindex="-1"])' : ""}:not([disabled])`).join(", ");
  return [...e.querySelectorAll(n)];
}
function H0(e, t, n) {
  let i, r = e.indexOf(document.activeElement);
  const s = t === "next" ? 1 : -1;
  do
    r += s, i = e[r];
  while ((!i || i.offsetParent == null || !((n == null ? void 0 : n(i)) ?? !0)) && r < e.length && r >= 0);
  return i;
}
function Ko(e, t) {
  var i, r, s, a;
  const n = sl(e);
  if (!t)
    (e === document.activeElement || !e.contains(document.activeElement)) && ((i = n[0]) == null || i.focus());
  else if (t === "first")
    (r = n[0]) == null || r.focus();
  else if (t === "last")
    (s = n.at(-1)) == null || s.focus();
  else if (typeof t == "number")
    (a = n[t]) == null || a.focus();
  else {
    const l = H0(n, t);
    l ? l.focus() : Ko(e, t === "next" ? "first" : "last");
  }
}
function Du(e) {
  return e == null || typeof e == "string" && e.trim() === "";
}
function _c(e, t) {
  if (!(Bt && typeof CSS < "u" && typeof CSS.supports < "u" && CSS.supports(`selector(${t})`)))
    return null;
  try {
    return !!e && e.matches(t);
  } catch {
    return null;
  }
}
function W0(e) {
  return e.some((t) => JO(t) ? t.type === QO ? !1 : t.type !== Le || W0(t.children) : !0) ? e : null;
}
function _E(e, t) {
  if (!Bt || e === 0)
    return t(), () => {
    };
  const n = window.setTimeout(t, e);
  return () => window.clearTimeout(n);
}
function wE(e, t) {
  const n = e.clientX, i = e.clientY, r = t.getBoundingClientRect(), s = r.left, a = r.top, l = r.right, c = r.bottom;
  return n >= s && n <= l && i >= a && i <= c;
}
function _h() {
  const e = Ie(), t = (n) => {
    e.value = n;
  };
  return Object.defineProperty(t, "value", {
    enumerable: !0,
    get: () => e.value,
    set: (n) => e.value = n
  }), Object.defineProperty(t, "el", {
    enumerable: !0,
    get: () => dm(e.value)
  }), t;
}
function Dy(e) {
  const t = e.key.length === 1, n = !e.ctrlKey && !e.metaKey && !e.altKey;
  return t && n;
}
const U0 = ["top", "bottom"], SE = ["start", "end", "left", "right"];
function wh(e, t) {
  let [n, i] = e.split(" ");
  return i || (i = xc(U0, n) ? "start" : xc(SE, n) ? "top" : "center"), {
    side: Vy(n, t),
    align: Vy(i, t)
  };
}
function Vy(e, t) {
  return e === "start" ? t ? "right" : "left" : e === "end" ? t ? "left" : "right" : e;
}
function Hf(e) {
  return {
    side: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.side],
    align: e.align
  };
}
function Wf(e) {
  return {
    side: e.side,
    align: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.align]
  };
}
function Ly(e) {
  return {
    side: e.align,
    align: e.side
  };
}
function Fy(e) {
  return xc(U0, e.side) ? "y" : "x";
}
class Rs {
  constructor(t) {
    let {
      x: n,
      y: i,
      width: r,
      height: s
    } = t;
    this.x = n, this.y = i, this.width = r, this.height = s;
  }
  get top() {
    return this.y;
  }
  get bottom() {
    return this.y + this.height;
  }
  get left() {
    return this.x;
  }
  get right() {
    return this.x + this.width;
  }
}
function Ry(e, t) {
  return {
    x: {
      before: Math.max(0, t.left - e.left),
      after: Math.max(0, e.right - t.right)
    },
    y: {
      before: Math.max(0, t.top - e.top),
      after: Math.max(0, e.bottom - t.bottom)
    }
  };
}
function q0(e) {
  return Array.isArray(e) ? new Rs({
    x: e[0],
    y: e[1],
    width: 0,
    height: 0
  }) : e.getBoundingClientRect();
}
function mm(e) {
  const t = e.getBoundingClientRect(), n = getComputedStyle(e), i = n.transform;
  if (i) {
    let r, s, a, l, c;
    if (i.startsWith("matrix3d("))
      r = i.slice(9, -1).split(/, /), s = +r[0], a = +r[5], l = +r[12], c = +r[13];
    else if (i.startsWith("matrix("))
      r = i.slice(7, -1).split(/, /), s = +r[0], a = +r[3], l = +r[4], c = +r[5];
    else
      return new Rs(t);
    const d = n.transformOrigin, f = t.x - l - (1 - s) * parseFloat(d), m = t.y - c - (1 - a) * parseFloat(d.slice(d.indexOf(" ") + 1)), g = s ? t.width / s : e.offsetWidth + 1, v = a ? t.height / a : e.offsetHeight + 1;
    return new Rs({
      x: f,
      y: m,
      width: g,
      height: v
    });
  } else
    return new Rs(t);
}
function Ca(e, t, n) {
  if (typeof e.animate > "u")
    return {
      finished: Promise.resolve()
    };
  let i;
  try {
    i = e.animate(t, n);
  } catch {
    return {
      finished: Promise.resolve()
    };
  }
  return typeof i.finished > "u" && (i.finished = new Promise((r) => {
    i.onfinish = () => {
      r(i);
    };
  })), i;
}
const dc = /* @__PURE__ */ new WeakMap();
function kE(e, t) {
  Object.keys(t).forEach((n) => {
    if (Gc(n)) {
      const i = z0(n), r = dc.get(e);
      if (t[n] == null)
        r == null || r.forEach((s) => {
          const [a, l] = s;
          a === i && (e.removeEventListener(i, l), r.delete(s));
        });
      else if (!r || ![...r].some((s) => s[0] === i && s[1] === t[n])) {
        e.addEventListener(i, t[n]);
        const s = r || /* @__PURE__ */ new Set();
        s.add([i, t[n]]), dc.has(e) || dc.set(e, s);
      }
    } else
      t[n] == null ? e.removeAttribute(n) : e.setAttribute(n, t[n]);
  });
}
function CE(e, t) {
  Object.keys(t).forEach((n) => {
    if (Gc(n)) {
      const i = z0(n), r = dc.get(e);
      r == null || r.forEach((s) => {
        const [a, l] = s;
        a === i && (e.removeEventListener(i, l), r.delete(s));
      });
    } else
      e.removeAttribute(n);
  });
}
const xa = 2.4, By = 0.2126729, Ny = 0.7151522, $y = 0.072175, TE = 0.55, IE = 0.58, PE = 0.57, OE = 0.62, Vu = 0.03, zy = 1.45, EE = 5e-4, AE = 1.25, ME = 1.25, Hy = 0.078, Wy = 12.82051282051282, Lu = 0.06, Uy = 1e-3;
function qy(e, t) {
  const n = (e.r / 255) ** xa, i = (e.g / 255) ** xa, r = (e.b / 255) ** xa, s = (t.r / 255) ** xa, a = (t.g / 255) ** xa, l = (t.b / 255) ** xa;
  let c = n * By + i * Ny + r * $y, d = s * By + a * Ny + l * $y;
  if (c <= Vu && (c += (Vu - c) ** zy), d <= Vu && (d += (Vu - d) ** zy), Math.abs(d - c) < EE)
    return 0;
  let f;
  if (d > c) {
    const m = (d ** TE - c ** IE) * AE;
    f = m < Uy ? 0 : m < Hy ? m - m * Wy * Lu : m - Lu;
  } else {
    const m = (d ** OE - c ** PE) * ME;
    f = m > -Uy ? 0 : m > -Hy ? m - m * Wy * Lu : m + Lu;
  }
  return f * 100;
}
function Ui(e) {
  qc(`Vuetify: ${e}`);
}
function gm(e) {
  qc(`Vuetify error: ${e}`);
}
function DE(e, t) {
  t = Array.isArray(t) ? t.slice(0, -1).map((n) => `'${n}'`).join(", ") + ` or '${t.at(-1)}'` : `'${t}'`, qc(`[Vuetify UPGRADE] '${e}' is deprecated, use ${t} instead.`);
}
const VE = [[0.4124, 0.3576, 0.1805], [0.2126, 0.7152, 0.0722], [0.0193, 0.1192, 0.9505]], LE = (e) => e <= 0.04045 ? e / 12.92 : ((e + 0.055) / 1.055) ** 2.4;
function FE(e) {
  let {
    r: t,
    g: n,
    b: i
  } = e;
  const r = [0, 0, 0], s = LE, a = VE;
  t = s(t / 255), n = s(n / 255), i = s(i / 255);
  for (let l = 0; l < 3; ++l)
    r[l] = a[l][0] * t + a[l][1] * n + a[l][2] * i;
  return r;
}
function Sh(e) {
  return !!e && /^(#|var\(--|(rgb|hsl)a?\()/.test(e);
}
function RE(e) {
  return Sh(e) && !/^((rgb|hsl)a?\()?var\(--/.test(e);
}
const jy = /^(?<fn>(?:rgb|hsl)a?)\((?<values>.+)\)/, BE = {
  rgb: (e, t, n, i) => ({
    r: e,
    g: t,
    b: n,
    a: i
  }),
  rgba: (e, t, n, i) => ({
    r: e,
    g: t,
    b: n,
    a: i
  }),
  hsl: (e, t, n, i) => Gy({
    h: e,
    s: t,
    l: n,
    a: i
  }),
  hsla: (e, t, n, i) => Gy({
    h: e,
    s: t,
    l: n,
    a: i
  }),
  hsv: (e, t, n, i) => xr({
    h: e,
    s: t,
    v: n,
    a: i
  }),
  hsva: (e, t, n, i) => xr({
    h: e,
    s: t,
    v: n,
    a: i
  })
};
function yr(e) {
  if (typeof e == "number")
    return (isNaN(e) || e < 0 || e > 16777215) && Ui(`'${e}' is not a valid hex color`), {
      r: (e & 16711680) >> 16,
      g: (e & 65280) >> 8,
      b: e & 255
    };
  if (typeof e == "string" && jy.test(e)) {
    const {
      groups: t
    } = e.match(jy), {
      fn: n,
      values: i
    } = t, r = i.split(/,\s*/).map((s) => s.endsWith("%") && ["hsl", "hsla", "hsv", "hsva"].includes(n) ? parseFloat(s) / 100 : parseFloat(s));
    return BE[n](...r);
  } else if (typeof e == "string") {
    let t = e.startsWith("#") ? e.slice(1) : e;
    [3, 4].includes(t.length) ? t = t.split("").map((i) => i + i).join("") : [6, 8].includes(t.length) || Ui(`'${e}' is not a valid hex(a) color`);
    const n = parseInt(t, 16);
    return (isNaN(n) || n < 0 || n > 4294967295) && Ui(`'${e}' is not a valid hex(a) color`), Z0(t);
  } else if (typeof e == "object") {
    if (Ds(e, ["r", "g", "b"]))
      return e;
    if (Ds(e, ["h", "s", "l"]))
      return xr(vm(e));
    if (Ds(e, ["h", "s", "v"]))
      return xr(e);
  }
  throw new TypeError(`Invalid color: ${e == null ? e : String(e) || e.constructor.name}
Expected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number`);
}
function xr(e) {
  const {
    h: t,
    s: n,
    v: i,
    a: r
  } = e, s = (l) => {
    const c = (l + t / 60) % 6;
    return i - i * n * Math.max(Math.min(c, 4 - c, 1), 0);
  }, a = [s(5), s(3), s(1)].map((l) => Math.round(l * 255));
  return {
    r: a[0],
    g: a[1],
    b: a[2],
    a: r
  };
}
function Gy(e) {
  return xr(vm(e));
}
function wl(e) {
  if (!e)
    return {
      h: 0,
      s: 1,
      v: 1,
      a: 1
    };
  const t = e.r / 255, n = e.g / 255, i = e.b / 255, r = Math.max(t, n, i), s = Math.min(t, n, i);
  let a = 0;
  r !== s && (r === t ? a = 60 * (0 + (n - i) / (r - s)) : r === n ? a = 60 * (2 + (i - t) / (r - s)) : r === i && (a = 60 * (4 + (t - n) / (r - s)))), a < 0 && (a = a + 360);
  const l = r === 0 ? 0 : (r - s) / r, c = [a, l, r];
  return {
    h: c[0],
    s: c[1],
    v: c[2],
    a: e.a
  };
}
function j0(e) {
  const {
    h: t,
    s: n,
    v: i,
    a: r
  } = e, s = i - i * n / 2, a = s === 1 || s === 0 ? 0 : (i - s) / Math.min(s, 1 - s);
  return {
    h: t,
    s: a,
    l: s,
    a: r
  };
}
function vm(e) {
  const {
    h: t,
    s: n,
    l: i,
    a: r
  } = e, s = i + n * Math.min(i, 1 - i), a = s === 0 ? 0 : 2 - 2 * i / s;
  return {
    h: t,
    s: a,
    v: s,
    a: r
  };
}
function G0(e) {
  let {
    r: t,
    g: n,
    b: i,
    a: r
  } = e;
  return r === void 0 ? `rgb(${t}, ${n}, ${i})` : `rgba(${t}, ${n}, ${i}, ${r})`;
}
function Y0(e) {
  return G0(xr(e));
}
function Fu(e) {
  const t = Math.round(e).toString(16);
  return ("00".substr(0, 2 - t.length) + t).toUpperCase();
}
function NE(e) {
  let {
    r: t,
    g: n,
    b: i,
    a: r
  } = e;
  return `#${[Fu(t), Fu(n), Fu(i), r !== void 0 ? Fu(Math.round(r * 255)) : ""].join("")}`;
}
function Z0(e) {
  e = zE(e);
  let [t, n, i, r] = bE(e, 2).map((s) => parseInt(s, 16));
  return r = r === void 0 ? r : r / 255, {
    r: t,
    g: n,
    b: i,
    a: r
  };
}
function $E(e) {
  const t = Z0(e);
  return wl(t);
}
function K0(e) {
  return NE(xr(e));
}
function zE(e) {
  return e.startsWith("#") && (e = e.slice(1)), e = e.replace(/([^0-9a-f])/gi, "F"), (e.length === 3 || e.length === 4) && (e = e.split("").map((t) => t + t).join("")), e.length !== 6 && (e = Ay(Ay(e, 6), 8, "F")), e;
}
function Yy(e) {
  const t = yr(e);
  return FE(t)[1];
}
function HE(e, t) {
  const n = Yy(e), i = Yy(t), r = Math.max(n, i), s = Math.min(n, i);
  return (r + 0.05) / (s + 0.05);
}
function WE(e) {
  const t = Math.abs(qy(yr(0), yr(e)));
  return Math.abs(qy(yr(16777215), yr(e))) > Math.min(t, 50) ? "#fff" : "#000";
}
function Nt(e, t) {
  const n = E0();
  if (!n)
    throw new Error(`[Vuetify] ${e} must be called from inside a setup function`);
  return n;
}
function Yi() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "composables";
  const t = Nt(e).type;
  return Fs((t == null ? void 0 : t.aliasName) || (t == null ? void 0 : t.name));
}
let X0 = 0, fc = /* @__PURE__ */ new WeakMap();
function pi() {
  const e = Nt("getUid");
  if (fc.has(e))
    return fc.get(e);
  {
    const t = X0++;
    return fc.set(e, t), t;
  }
}
pi.reset = () => {
  X0 = 0, fc = /* @__PURE__ */ new WeakMap();
};
function UE(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Nt("injectSelf");
  const {
    provides: n
  } = t;
  if (n && e in n)
    return n[e];
}
const wc = Symbol.for("vuetify:defaults");
function ym() {
  const e = gt(wc);
  if (!e)
    throw new Error("[Vuetify] Could not find defaults instance");
  return e;
}
function yi(e, t) {
  const n = ym(), i = ue(e), r = I(() => {
    if (je(t == null ? void 0 : t.disabled))
      return n.value;
    const a = je(t == null ? void 0 : t.scoped), l = je(t == null ? void 0 : t.reset), c = je(t == null ? void 0 : t.root);
    if (i.value == null && !(a || l || c))
      return n.value;
    let d = vr(i.value, {
      prev: n.value
    });
    if (a)
      return d;
    if (l || c) {
      const f = Number(l || 1 / 0);
      for (let m = 0; m <= f && !(!d || !("prev" in d)); m++)
        d = d.prev;
      return d && typeof c == "string" && c in d && (d = vr(vr(d, {
        prev: d
      }), d[c])), d;
    }
    return d.prev ? vr(d.prev, d) : d;
  });
  return jt(wc, r), r;
}
function qE(e, t) {
  var n, i;
  return typeof ((n = e.props) == null ? void 0 : n[t]) < "u" || typeof ((i = e.props) == null ? void 0 : i[Fs(t)]) < "u";
}
function jE() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ym();
  const i = Nt("useDefaults");
  if (t = t ?? i.type.name ?? i.type.__name, !t)
    throw new Error("[Vuetify] Could not determine component name");
  const r = I(() => {
    var c;
    return (c = n.value) == null ? void 0 : c[e._as ?? t];
  }), s = new Proxy(e, {
    get(c, d) {
      var m, g, v, p, _, x, S;
      const f = Reflect.get(c, d);
      return d === "class" || d === "style" ? [(m = r.value) == null ? void 0 : m[d], f].filter((T) => T != null) : typeof d == "string" && !qE(i.vnode, d) ? ((g = r.value) == null ? void 0 : g[d]) !== void 0 ? (v = r.value) == null ? void 0 : v[d] : ((_ = (p = n.value) == null ? void 0 : p.global) == null ? void 0 : _[d]) !== void 0 ? (S = (x = n.value) == null ? void 0 : x.global) == null ? void 0 : S[d] : f : f;
    }
  }), a = Ie();
  Xn(() => {
    if (r.value) {
      const c = Object.entries(r.value).filter((d) => {
        let [f] = d;
        return f.startsWith(f[0].toUpperCase());
      });
      a.value = c.length ? Object.fromEntries(c) : void 0;
    } else
      a.value = void 0;
  });
  function l() {
    const c = UE(wc, i);
    jt(wc, I(() => a.value ? vr((c == null ? void 0 : c.value) ?? {}, a.value) : c == null ? void 0 : c.value));
  }
  return {
    props: s,
    provideSubDefaults: l
  };
}
function Zi(e) {
  if (e._setup = e._setup ?? e.setup, !e.name)
    return Ui("The component is missing an explicit name, unable to generate default prop value"), e;
  if (e._setup) {
    e.props = ee(e.props ?? {}, e.name)();
    const t = Object.keys(e.props).filter((n) => n !== "class" && n !== "style");
    e.filterProps = function(i) {
      return B0(i, t);
    }, e.props._as = String, e.setup = function(i, r) {
      const s = ym();
      if (!s.value)
        return e._setup(i, r);
      const {
        props: a,
        provideSubDefaults: l
      } = jE(i, i._as ?? e.name, s), c = e._setup(a, r);
      return l(), c;
    };
  }
  return e;
}
function pe() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  return (t) => (e ? Zi : Je)(t);
}
function GE(e, t) {
  return t.props = e, t;
}
function pm(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "div", n = arguments.length > 2 ? arguments[2] : void 0;
  return pe()({
    name: n ?? za(A0(e.replace(/__/g, "-"))),
    props: {
      tag: {
        type: String,
        default: t
      },
      ...Ae()
    },
    setup(i, r) {
      let {
        slots: s
      } = r;
      return () => {
        var a;
        return br(i.tag, {
          class: [e, i.class],
          style: i.style
        }, (a = s.default) == null ? void 0 : a.call(s));
      };
    }
  });
}
function J0(e) {
  if (typeof e.getRootNode != "function") {
    for (; e.parentNode; )
      e = e.parentNode;
    return e !== document ? null : document;
  }
  const t = e.getRootNode();
  return t !== document && t.getRootNode({
    composed: !0
  }) !== document ? null : t;
}
const Sc = "cubic-bezier(0.4, 0, 0.2, 1)", YE = "cubic-bezier(0.0, 0, 0.2, 1)", ZE = "cubic-bezier(0.4, 0, 1, 1)";
function Zy(e, t, n) {
  return Object.keys(e).filter((i) => Gc(i) && i.endsWith(t)).reduce((i, r) => (i[r.slice(0, -t.length)] = (s) => e[r](s, n(s)), i), {});
}
function Q0(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  for (; e; ) {
    if (t ? KE(e) : bm(e))
      return e;
    e = e.parentElement;
  }
  return document.scrollingElement;
}
function kc(e, t) {
  const n = [];
  if (t && e && !t.contains(e))
    return n;
  for (; e && (bm(e) && n.push(e), e !== t); )
    e = e.parentElement;
  return n;
}
function bm(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const t = window.getComputedStyle(e);
  return t.overflowY === "scroll" || t.overflowY === "auto" && e.scrollHeight > e.clientHeight;
}
function KE(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const t = window.getComputedStyle(e);
  return ["scroll", "auto"].includes(t.overflowY);
}
function XE(e) {
  for (; e; ) {
    if (window.getComputedStyle(e).position === "fixed")
      return !0;
    e = e.offsetParent;
  }
  return !1;
}
function ke(e) {
  const t = Nt("useRender");
  t.render = e;
}
const JE = ee({
  divider: [Number, String],
  ...Ae()
}, "VBreadcrumbsDivider"), QE = pe()({
  name: "VBreadcrumbsDivider",
  props: JE(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return ke(() => {
      var i;
      return b("li", {
        "aria-hidden": "true",
        class: ["v-breadcrumbs-divider", e.class],
        style: e.style
      }, [((i = n == null ? void 0 : n.default) == null ? void 0 : i.call(n)) ?? e.divider]);
    }), {};
  }
});
function xm(e) {
  return fm(() => {
    const t = [], n = {};
    if (e.value.background)
      if (Sh(e.value.background)) {
        if (n.backgroundColor = e.value.background, !e.value.text && RE(e.value.background)) {
          const i = yr(e.value.background);
          if (i.a == null || i.a === 1) {
            const r = WE(i);
            n.color = r, n.caretColor = r;
          }
        }
      } else
        t.push(`bg-${e.value.background}`);
    return e.value.text && (Sh(e.value.text) ? (n.color = e.value.text, n.caretColor = e.value.text) : t.push(`text-${e.value.text}`)), {
      colorClasses: t,
      colorStyles: n
    };
  });
}
function Ei(e, t) {
  const n = I(() => ({
    text: qi(e) ? e.value : t ? e[t] : null
  })), {
    colorClasses: i,
    colorStyles: r
  } = xm(n);
  return {
    textColorClasses: i,
    textColorStyles: r
  };
}
function Bn(e, t) {
  const n = I(() => ({
    background: qi(e) ? e.value : t ? e[t] : null
  })), {
    colorClasses: i,
    colorStyles: r
  } = xm(n);
  return {
    backgroundColorClasses: i,
    backgroundColorStyles: r
  };
}
function eA() {
  const e = Nt("useRoute");
  return I(() => {
    var t;
    return (t = e == null ? void 0 : e.proxy) == null ? void 0 : t.$route;
  });
}
function tA() {
  var e, t;
  return (t = (e = Nt("useRouter")) == null ? void 0 : e.proxy) == null ? void 0 : t.$router;
}
function Sl(e, t) {
  var m, g;
  const n = eE("RouterLink"), i = I(() => !!(e.href || e.to)), r = I(() => (i == null ? void 0 : i.value) || My(t, "click") || My(e, "click"));
  if (typeof n == "string" || !("useLink" in n)) {
    const v = ce(e, "href");
    return {
      isLink: i,
      isClickable: r,
      href: v,
      linkProps: Ma({
        href: v
      })
    };
  }
  const s = I(() => ({
    ...e,
    to: ce(() => e.to || "")
  })), a = n.useLink(s.value), l = I(() => e.to ? a : void 0), c = eA(), d = I(() => {
    var v, p, _;
    return l.value ? e.exact ? c.value ? ((_ = l.value.isExactActive) == null ? void 0 : _.value) && Sr(l.value.route.value.query, c.value.query) : ((p = l.value.isExactActive) == null ? void 0 : p.value) ?? !1 : ((v = l.value.isActive) == null ? void 0 : v.value) ?? !1 : !1;
  }), f = I(() => {
    var v;
    return e.to ? (v = l.value) == null ? void 0 : v.route.value.href : e.href;
  });
  return {
    isLink: i,
    isClickable: r,
    isActive: d,
    route: (m = l.value) == null ? void 0 : m.route,
    navigate: (g = l.value) == null ? void 0 : g.navigate,
    href: f,
    linkProps: Ma({
      href: f,
      "aria-current": I(() => d.value ? "page" : void 0)
    })
  };
}
const kl = ee({
  href: String,
  replace: Boolean,
  to: [String, Object],
  exact: Boolean
}, "router");
let Uf = !1;
function nA(e, t) {
  let n = !1, i, r;
  Bt && (e != null && e.beforeEach) && (Ct(() => {
    window.addEventListener("popstate", s), i = e.beforeEach((a, l, c) => {
      Uf ? n ? t(c) : c() : setTimeout(() => n ? t(c) : c()), Uf = !0;
    }), r = e == null ? void 0 : e.afterEach(() => {
      Uf = !1;
    });
  }), gn(() => {
    window.removeEventListener("popstate", s), i == null || i(), r == null || r();
  }));
  function s(a) {
    var l;
    (l = a.state) != null && l.replaced || (n = !0, setTimeout(() => n = !1));
  }
}
const pt = ee({
  tag: {
    type: String,
    default: "div"
  }
}, "tag"), iA = ee({
  active: Boolean,
  activeClass: String,
  activeColor: String,
  color: String,
  disabled: Boolean,
  title: String,
  ...Ae(),
  ...kl(),
  ...pt({
    tag: "li"
  })
}, "VBreadcrumbsItem"), rA = pe()({
  name: "VBreadcrumbsItem",
  props: iA(),
  setup(e, t) {
    let {
      slots: n,
      attrs: i
    } = t;
    const r = Sl(e, i), s = I(() => {
      var d;
      return e.active || ((d = r.isActive) == null ? void 0 : d.value);
    }), a = I(() => s.value ? e.activeColor : e.color), {
      textColorClasses: l,
      textColorStyles: c
    } = Ei(a);
    return ke(() => b(e.tag, {
      class: ["v-breadcrumbs-item", {
        "v-breadcrumbs-item--active": s.value,
        "v-breadcrumbs-item--disabled": e.disabled,
        [`${e.activeClass}`]: s.value && e.activeClass
      }, l.value, e.class],
      style: [c.value, e.style],
      "aria-current": s.value ? "page" : void 0
    }, {
      default: () => {
        var d, f;
        return [r.isLink.value ? b("a", fe({
          class: "v-breadcrumbs-item--link",
          onClick: r.navigate
        }, r.linkProps), [((f = n.default) == null ? void 0 : f.call(n)) ?? e.title]) : ((d = n.default) == null ? void 0 : d.call(n)) ?? e.title];
      }
    })), {};
  }
}), sA = ee({
  defaults: Object,
  disabled: Boolean,
  reset: [Number, String],
  root: [Boolean, String],
  scoped: Boolean
}, "VDefaultsProvider"), Mt = pe(!1)({
  name: "VDefaultsProvider",
  props: sA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      defaults: i,
      disabled: r,
      reset: s,
      root: a,
      scoped: l
    } = am(e);
    return yi(i, {
      reset: s,
      root: a,
      scoped: l,
      disabled: r
    }), () => {
      var c;
      return (c = n.default) == null ? void 0 : c.call(n);
    };
  }
}), He = [String, Function, Object, Array], aA = Symbol.for("vuetify:icons"), Zc = ee({
  icon: {
    type: He
  },
  // Could not remove this and use makeTagProps, types complained because it is not required
  tag: {
    type: String,
    required: !0
  }
}, "icon"), Ky = pe()({
  name: "VComponentIcon",
  props: Zc(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return () => {
      const i = e.icon;
      return b(e.tag, null, {
        default: () => {
          var r;
          return [e.icon ? b(i, null, null) : (r = n.default) == null ? void 0 : r.call(n)];
        }
      });
    };
  }
}), oA = Zi({
  name: "VSvgIcon",
  inheritAttrs: !1,
  props: Zc(),
  setup(e, t) {
    let {
      attrs: n
    } = t;
    return () => b(e.tag, fe(n, {
      style: null
    }), {
      default: () => [b("svg", {
        class: "v-icon__svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        role: "img",
        "aria-hidden": "true"
      }, [Array.isArray(e.icon) ? e.icon.map((i) => Array.isArray(i) ? b("path", {
        d: i[0],
        "fill-opacity": i[1]
      }, null) : b("path", {
        d: i
      }, null)) : b("path", {
        d: e.icon
      }, null)])]
    });
  }
});
Zi({
  name: "VLigatureIcon",
  props: Zc(),
  setup(e) {
    return () => b(e.tag, null, {
      default: () => [e.icon]
    });
  }
});
Zi({
  name: "VClassIcon",
  props: Zc(),
  setup(e) {
    return () => b(e.tag, {
      class: e.icon
    }, null);
  }
});
const lA = (e) => {
  const t = gt(aA);
  if (!t)
    throw new Error("Missing Vuetify Icons provide!");
  return {
    iconData: I(() => {
      var c;
      const i = je(e);
      if (!i)
        return {
          component: Ky
        };
      let r = i;
      if (typeof r == "string" && (r = r.trim(), r.startsWith("$") && (r = (c = t.aliases) == null ? void 0 : c[r.slice(1)])), r || Ui(`Could not find aliased icon "${i}"`), Array.isArray(r))
        return {
          component: oA,
          icon: r
        };
      if (typeof r != "string")
        return {
          component: Ky,
          icon: r
        };
      const s = Object.keys(t.sets).find((d) => typeof r == "string" && r.startsWith(`${d}:`)), a = s ? r.slice(s.length + 1) : r;
      return {
        component: t.sets[s ?? t.defaultSet].component,
        icon: a
      };
    })
  };
}, uA = ["x-small", "small", "default", "large", "x-large"], Ha = ee({
  size: {
    type: [String, Number],
    default: "default"
  }
}, "size");
function Cl(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Yi();
  return fm(() => {
    let n, i;
    return xc(uA, e.size) ? n = `${t}--size-${e.size}` : e.size && (i = {
      width: Ce(e.size),
      height: Ce(e.size)
    }), {
      sizeClasses: n,
      sizeStyles: i
    };
  });
}
const Xy = Symbol.for("vuetify:theme"), $t = ee({
  theme: String
}, "theme");
function Zt(e) {
  Nt("provideTheme");
  const t = gt(Xy, null);
  if (!t)
    throw new Error("Could not find Vuetify theme injection");
  const n = I(() => e.theme ?? t.name.value), i = I(() => t.themes.value[n.value]), r = I(() => t.isDisabled ? void 0 : `v-theme--${n.value}`), s = {
    ...t,
    name: n,
    current: i,
    themeClasses: r
  };
  return jt(Xy, s), s;
}
const cA = ee({
  color: String,
  disabled: Boolean,
  start: Boolean,
  end: Boolean,
  icon: He,
  ...Ae(),
  ...Ha(),
  ...pt({
    tag: "i"
  }),
  ...$t()
}, "VIcon"), dt = pe()({
  name: "VIcon",
  props: cA(),
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const r = ue(), {
      themeClasses: s
    } = Zt(e), {
      iconData: a
    } = lA(I(() => r.value || e.icon)), {
      sizeClasses: l
    } = Cl(e), {
      textColorClasses: c,
      textColorStyles: d
    } = Ei(ce(e, "color"));
    return ke(() => {
      var g, v;
      const f = (g = i.default) == null ? void 0 : g.call(i);
      f && (r.value = (v = $0(f).filter((p) => p.type === tE && p.children && typeof p.children == "string")[0]) == null ? void 0 : v.children);
      const m = !!(n.onClick || n.onClickOnce);
      return b(a.value.component, {
        tag: e.tag,
        icon: a.value.icon,
        class: ["v-icon", "notranslate", s.value, l.value, c.value, {
          "v-icon--clickable": m,
          "v-icon--disabled": e.disabled,
          "v-icon--start": e.start,
          "v-icon--end": e.end
        }, e.class],
        style: [l.value ? void 0 : {
          fontSize: Ce(e.size),
          height: Ce(e.size),
          width: Ce(e.size)
        }, d.value, e.style],
        role: m ? "button" : void 0,
        "aria-hidden": !m,
        tabindex: m ? e.disabled ? -1 : 0 : void 0
      }, {
        default: () => [f]
      });
    }), {};
  }
}), dA = [null, "default", "comfortable", "compact"], Qn = ee({
  density: {
    type: String,
    default: "default",
    validator: (e) => dA.includes(e)
  }
}, "density");
function Mi(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Yi();
  return {
    densityClasses: I(() => `${t}--density-${e.density}`)
  };
}
const vn = ee({
  rounded: {
    type: [Boolean, Number, String],
    default: void 0
  },
  tile: Boolean
}, "rounded");
function Cn(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Yi();
  return {
    roundedClasses: I(() => {
      const i = qi(e) ? e.value : e.rounded, r = qi(e) ? e.value : e.tile, s = [];
      if (i === !0 || i === "")
        s.push(`${t}--rounded`);
      else if (typeof i == "string" || i === 0)
        for (const a of String(i).split(" "))
          s.push(`rounded-${a}`);
      else
        (r || i === !1) && s.push("rounded-0");
      return s;
    })
  };
}
const fA = ee({
  activeClass: String,
  activeColor: String,
  bgColor: String,
  color: String,
  disabled: Boolean,
  divider: {
    type: String,
    default: "/"
  },
  icon: He,
  items: {
    type: Array,
    default: () => []
  },
  ...Ae(),
  ...Qn(),
  ...vn(),
  ...pt({
    tag: "ul"
  })
}, "VBreadcrumbs"), hA = pe()({
  name: "VBreadcrumbs",
  props: fA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      backgroundColorClasses: i,
      backgroundColorStyles: r
    } = Bn(ce(e, "bgColor")), {
      densityClasses: s
    } = Mi(e), {
      roundedClasses: a
    } = Cn(e);
    yi({
      VBreadcrumbsDivider: {
        divider: ce(e, "divider")
      },
      VBreadcrumbsItem: {
        activeClass: ce(e, "activeClass"),
        activeColor: ce(e, "activeColor"),
        color: ce(e, "color"),
        disabled: ce(e, "disabled")
      }
    });
    const l = I(() => e.items.map((c) => typeof c == "string" ? {
      item: {
        title: c
      },
      raw: c
    } : {
      item: c,
      raw: c
    }));
    return ke(() => {
      const c = !!(n.prepend || e.icon);
      return b(e.tag, {
        class: ["v-breadcrumbs", i.value, s.value, a.value, e.class],
        style: [r.value, e.style]
      }, {
        default: () => {
          var d;
          return [c && b("li", {
            key: "prepend",
            class: "v-breadcrumbs__prepend"
          }, [n.prepend ? b(Mt, {
            key: "prepend-defaults",
            disabled: !e.icon,
            defaults: {
              VIcon: {
                icon: e.icon,
                start: !0
              }
            }
          }, n.prepend) : b(dt, {
            key: "prepend-icon",
            start: !0,
            icon: e.icon
          }, null)]), l.value.map((f, m, g) => {
            var _;
            let {
              item: v,
              raw: p
            } = f;
            return b(Le, null, [((_ = n.item) == null ? void 0 : _.call(n, {
              item: v,
              index: m
            })) ?? b(rA, fe({
              key: m,
              disabled: m >= g.length - 1
            }, typeof v == "string" ? {
              title: v
            } : v), {
              default: n.title ? () => {
                var x;
                return (x = n.title) == null ? void 0 : x.call(n, {
                  item: v,
                  index: m
                });
              } : void 0
            }), m < g.length - 1 && b(QE, null, {
              default: n.divider ? () => {
                var x;
                return (x = n.divider) == null ? void 0 : x.call(n, {
                  item: p,
                  index: m
                });
              } : void 0
            })]);
          }), (d = n.default) == null ? void 0 : d.call(n)];
        }
      });
    }), {};
  }
}), mA = ee({
  color: String,
  inset: Boolean,
  length: [Number, String],
  opacity: [Number, String],
  thickness: [Number, String],
  vertical: Boolean,
  ...Ae(),
  ...$t()
}, "VDivider"), Kc = pe()({
  name: "VDivider",
  props: mA(),
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const {
      themeClasses: r
    } = Zt(e), {
      textColorClasses: s,
      textColorStyles: a
    } = Ei(ce(e, "color")), l = I(() => {
      const c = {};
      return e.length && (c[e.vertical ? "height" : "width"] = Ce(e.length)), e.thickness && (c[e.vertical ? "borderRightWidth" : "borderTopWidth"] = Ce(e.thickness)), c;
    });
    return ke(() => {
      const c = b("hr", {
        class: [{
          "v-divider": !0,
          "v-divider--inset": e.inset,
          "v-divider--vertical": e.vertical
        }, r.value, s.value, e.class],
        style: [l.value, a.value, {
          "--v-border-opacity": e.opacity
        }, e.style],
        "aria-orientation": !n.role || n.role === "separator" ? e.vertical ? "vertical" : "horizontal" : void 0,
        role: `${n.role || "separator"}`
      }, null);
      return i.default ? b("div", {
        class: ["v-divider__wrapper", {
          "v-divider__wrapper--vertical": e.vertical,
          "v-divider__wrapper--inset": e.inset
        }]
      }, [c, b("div", {
        class: "v-divider__content"
      }, [i.default()]), c]) : c;
    }), {};
  }
}), Di = ee({
  height: [Number, String],
  maxHeight: [Number, String],
  maxWidth: [Number, String],
  minHeight: [Number, String],
  minWidth: [Number, String],
  width: [Number, String]
}, "dimension");
function Vi(e) {
  return {
    dimensionStyles: I(() => {
      const n = {}, i = Ce(e.height), r = Ce(e.maxHeight), s = Ce(e.maxWidth), a = Ce(e.minHeight), l = Ce(e.minWidth), c = Ce(e.width);
      return i != null && (n.height = i), r != null && (n.maxHeight = r), s != null && (n.maxWidth = s), a != null && (n.minHeight = a), l != null && (n.minWidth = l), c != null && (n.width = c), n;
    })
  };
}
function _r(e, t) {
  let n;
  function i() {
    n = om(), n.run(() => t.length ? t(() => {
      n == null || n.stop(), i();
    }) : t());
  }
  Se(e, (r) => {
    r && !n ? i() : r || (n == null || n.stop(), n = void 0);
  }, {
    immediate: !0
  }), gn(() => {
    n == null || n.stop();
  });
}
function at(e, t, n) {
  let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (m) => m, r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (m) => m;
  const s = Nt("useProxiedModel"), a = ue(e[t] !== void 0 ? e[t] : n), l = Fs(t), d = l !== t ? I(() => {
    var m, g, v, p;
    return e[t], !!(((m = s.vnode.props) != null && m.hasOwnProperty(t) || (g = s.vnode.props) != null && g.hasOwnProperty(l)) && ((v = s.vnode.props) != null && v.hasOwnProperty(`onUpdate:${t}`) || (p = s.vnode.props) != null && p.hasOwnProperty(`onUpdate:${l}`)));
  }) : I(() => {
    var m, g;
    return e[t], !!((m = s.vnode.props) != null && m.hasOwnProperty(t) && ((g = s.vnode.props) != null && g.hasOwnProperty(`onUpdate:${t}`)));
  });
  _r(() => !d.value, () => {
    Se(() => e[t], (m) => {
      a.value = m;
    });
  });
  const f = I({
    get() {
      const m = e[t];
      return i(d.value ? m : a.value);
    },
    set(m) {
      const g = r(m), v = Pt(d.value ? e[t] : a.value);
      v === g || i(v) === m || (a.value = g, s == null || s.emit(`update:${t}`, g));
    }
  });
  return Object.defineProperty(f, "externalValue", {
    get: () => d.value ? e[t] : a.value
  }), f;
}
const ex = Symbol.for("vuetify:locale");
function os() {
  const e = gt(ex);
  if (!e)
    throw new Error("[Vuetify] Could not find injected locale instance");
  return e;
}
function Tn() {
  const e = gt(ex);
  if (!e)
    throw new Error("[Vuetify] Could not find injected rtl instance");
  return {
    isRtl: e.isRtl,
    rtlClasses: e.rtlClasses
  };
}
const gA = ee({
  fluid: {
    type: Boolean,
    default: !1
  },
  ...Ae(),
  ...Di(),
  ...pt()
}, "VContainer"), vA = pe()({
  name: "VContainer",
  props: gA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      rtlClasses: i
    } = Tn(), {
      dimensionStyles: r
    } = Vi(e);
    return ke(() => b(e.tag, {
      class: ["v-container", {
        "v-container--fluid": e.fluid
      }, i.value, e.class],
      style: [r.value, e.style]
    }, n)), {};
  }
}), Xc = ["sm", "md", "lg", "xl", "xxl"], yA = Symbol.for("vuetify:display"), Jc = ee({
  mobile: {
    type: Boolean,
    default: !1
  },
  mobileBreakpoint: [Number, String]
}, "display");
function js() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    mobile: null
  }, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Yi();
  const n = gt(yA);
  if (!n)
    throw new Error("Could not find Vuetify display injection");
  const i = I(() => e.mobile ? !0 : typeof e.mobileBreakpoint == "number" ? n.width.value < e.mobileBreakpoint : e.mobileBreakpoint ? n.width.value < n.thresholds.value[e.mobileBreakpoint] : e.mobile === null ? n.mobile.value : !1), r = I(() => t ? {
    [`${t}--mobile`]: i.value
  } : {});
  return {
    ...n,
    displayClasses: r,
    mobile: i
  };
}
const tx = Xc.reduce((e, t) => (e[t] = {
  type: [Boolean, String, Number],
  default: !1
}, e), {}), nx = Xc.reduce((e, t) => {
  const n = "offset" + za(t);
  return e[n] = {
    type: [String, Number],
    default: null
  }, e;
}, {}), ix = Xc.reduce((e, t) => {
  const n = "order" + za(t);
  return e[n] = {
    type: [String, Number],
    default: null
  }, e;
}, {}), Jy = {
  col: Object.keys(tx),
  offset: Object.keys(nx),
  order: Object.keys(ix)
};
function pA(e, t, n) {
  let i = e;
  if (!(n == null || n === !1)) {
    if (t) {
      const r = t.replace(e, "");
      i += `-${r}`;
    }
    return e === "col" && (i = "v-" + i), e === "col" && (n === "" || n === !0) || (i += `-${n}`), i.toLowerCase();
  }
}
const bA = ["auto", "start", "end", "center", "baseline", "stretch"], xA = ee({
  cols: {
    type: [Boolean, String, Number],
    default: !1
  },
  ...tx,
  offset: {
    type: [String, Number],
    default: null
  },
  ...nx,
  order: {
    type: [String, Number],
    default: null
  },
  ...ix,
  alignSelf: {
    type: String,
    default: null,
    validator: (e) => bA.includes(e)
  },
  ...Ae(),
  ...pt()
}, "VCol"), hi = pe()({
  name: "VCol",
  props: xA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = I(() => {
      const r = [];
      let s;
      for (s in Jy)
        Jy[s].forEach((l) => {
          const c = e[l], d = pA(s, l, c);
          d && r.push(d);
        });
      const a = r.some((l) => l.startsWith("v-col-"));
      return r.push({
        // Default to .v-col if no other col-{bp}-* classes generated nor `cols` specified.
        "v-col": !a || !e.cols,
        [`v-col-${e.cols}`]: e.cols,
        [`offset-${e.offset}`]: e.offset,
        [`order-${e.order}`]: e.order,
        [`align-self-${e.alignSelf}`]: e.alignSelf
      }), r;
    });
    return () => {
      var r;
      return br(e.tag, {
        class: [i.value, e.class],
        style: e.style
      }, (r = n.default) == null ? void 0 : r.call(n));
    };
  }
}), _m = ["start", "end", "center"], rx = ["space-between", "space-around", "space-evenly"];
function wm(e, t) {
  return Xc.reduce((n, i) => {
    const r = e + za(i);
    return n[r] = t(), n;
  }, {});
}
const _A = [..._m, "baseline", "stretch"], sx = (e) => _A.includes(e), ax = wm("align", () => ({
  type: String,
  default: null,
  validator: sx
})), wA = [..._m, ...rx], ox = (e) => wA.includes(e), lx = wm("justify", () => ({
  type: String,
  default: null,
  validator: ox
})), SA = [..._m, ...rx, "stretch"], ux = (e) => SA.includes(e), cx = wm("alignContent", () => ({
  type: String,
  default: null,
  validator: ux
})), Qy = {
  align: Object.keys(ax),
  justify: Object.keys(lx),
  alignContent: Object.keys(cx)
}, kA = {
  align: "align",
  justify: "justify",
  alignContent: "align-content"
};
function CA(e, t, n) {
  let i = kA[e];
  if (n != null) {
    if (t) {
      const r = t.replace(e, "");
      i += `-${r}`;
    }
    return i += `-${n}`, i.toLowerCase();
  }
}
const TA = ee({
  dense: Boolean,
  noGutters: Boolean,
  align: {
    type: String,
    default: null,
    validator: sx
  },
  ...ax,
  justify: {
    type: String,
    default: null,
    validator: ox
  },
  ...lx,
  alignContent: {
    type: String,
    default: null,
    validator: ux
  },
  ...cx,
  ...Ae(),
  ...pt()
}, "VRow"), Da = pe()({
  name: "VRow",
  props: TA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = I(() => {
      const r = [];
      let s;
      for (s in Qy)
        Qy[s].forEach((a) => {
          const l = e[a], c = CA(s, a, l);
          c && r.push(c);
        });
      return r.push({
        "v-row--no-gutters": e.noGutters,
        "v-row--dense": e.dense,
        [`align-${e.align}`]: e.align,
        [`justify-${e.justify}`]: e.justify,
        [`align-content-${e.alignContent}`]: e.alignContent
      }), r;
    });
    return () => {
      var r;
      return br(e.tag, {
        class: ["v-row", i.value, e.class],
        style: e.style
      }, (r = n.default) == null ? void 0 : r.call(n));
    };
  }
}), Qc = pm("v-spacer", "div", "VSpacer"), IA = ee({
  text: String,
  ...Ae(),
  ...pt()
}, "VToolbarTitle"), dx = pe()({
  name: "VToolbarTitle",
  props: IA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return ke(() => {
      const i = !!(n.default || n.text || e.text);
      return b(e.tag, {
        class: ["v-toolbar-title", e.class],
        style: e.style
      }, {
        default: () => {
          var r;
          return [i && b("div", {
            class: "v-toolbar-title__placeholder"
          }, [n.text ? n.text() : e.text, (r = n.default) == null ? void 0 : r.call(n)])];
        }
      });
    }), {};
  }
}), PA = ee({
  disabled: Boolean,
  group: Boolean,
  hideOnLeave: Boolean,
  leaveAbsolute: Boolean,
  mode: String,
  origin: String
}, "transition");
function ei(e, t, n) {
  return pe()({
    name: e,
    props: PA({
      mode: n,
      origin: t
    }),
    setup(i, r) {
      let {
        slots: s
      } = r;
      const a = {
        onBeforeEnter(l) {
          i.origin && (l.style.transformOrigin = i.origin);
        },
        onLeave(l) {
          if (i.leaveAbsolute) {
            const {
              offsetTop: c,
              offsetLeft: d,
              offsetWidth: f,
              offsetHeight: m
            } = l;
            l._transitionInitialStyles = {
              position: l.style.position,
              top: l.style.top,
              left: l.style.left,
              width: l.style.width,
              height: l.style.height
            }, l.style.position = "absolute", l.style.top = `${c}px`, l.style.left = `${d}px`, l.style.width = `${f}px`, l.style.height = `${m}px`;
          }
          i.hideOnLeave && l.style.setProperty("display", "none", "important");
        },
        onAfterLeave(l) {
          if (i.leaveAbsolute && (l != null && l._transitionInitialStyles)) {
            const {
              position: c,
              top: d,
              left: f,
              width: m,
              height: g
            } = l._transitionInitialStyles;
            delete l._transitionInitialStyles, l.style.position = c || "", l.style.top = d || "", l.style.left = f || "", l.style.width = m || "", l.style.height = g || "";
          }
        }
      };
      return () => {
        const l = i.group ? lm : Hs;
        return br(l, {
          name: i.disabled ? "" : e,
          css: !i.disabled,
          ...i.group ? void 0 : {
            mode: i.mode
          },
          ...i.disabled ? {} : a
        }, s.default);
      };
    }
  });
}
function fx(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "in-out";
  return pe()({
    name: e,
    props: {
      mode: {
        type: String,
        default: n
      },
      disabled: Boolean,
      group: Boolean
    },
    setup(i, r) {
      let {
        slots: s
      } = r;
      const a = i.group ? lm : Hs;
      return () => br(a, {
        name: i.disabled ? "" : e,
        css: !i.disabled,
        // mode: props.mode, // TODO: vuejs/vue-next#3104
        ...i.disabled ? {} : t
      }, s.default);
    }
  });
}
function hx() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  const n = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1) ? "width" : "height", i = A0(`offset-${n}`);
  return {
    onBeforeEnter(a) {
      a._parent = a.parentNode, a._initialStyle = {
        transition: a.style.transition,
        overflow: a.style.overflow,
        [n]: a.style[n]
      };
    },
    onEnter(a) {
      const l = a._initialStyle;
      a.style.setProperty("transition", "none", "important"), a.style.overflow = "hidden";
      const c = `${a[i]}px`;
      a.style[n] = "0", a.offsetHeight, a.style.transition = l.transition, e && a._parent && a._parent.classList.add(e), requestAnimationFrame(() => {
        a.style[n] = c;
      });
    },
    onAfterEnter: s,
    onEnterCancelled: s,
    onLeave(a) {
      a._initialStyle = {
        transition: "",
        overflow: a.style.overflow,
        [n]: a.style[n]
      }, a.style.overflow = "hidden", a.style[n] = `${a[i]}px`, a.offsetHeight, requestAnimationFrame(() => a.style[n] = "0");
    },
    onAfterLeave: r,
    onLeaveCancelled: r
  };
  function r(a) {
    e && a._parent && a._parent.classList.remove(e), s(a);
  }
  function s(a) {
    const l = a._initialStyle[n];
    a.style.overflow = a._initialStyle.overflow, l != null && (a.style[n] = l), delete a._initialStyle;
  }
}
const OA = ee({
  target: [Object, Array]
}, "v-dialog-transition"), Sm = pe()({
  name: "VDialogTransition",
  props: OA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = {
      onBeforeEnter(r) {
        r.style.pointerEvents = "none", r.style.visibility = "hidden";
      },
      async onEnter(r, s) {
        var g;
        await new Promise((v) => requestAnimationFrame(v)), await new Promise((v) => requestAnimationFrame(v)), r.style.visibility = "";
        const {
          x: a,
          y: l,
          sx: c,
          sy: d,
          speed: f
        } = tp(e.target, r), m = Ca(r, [{
          transform: `translate(${a}px, ${l}px) scale(${c}, ${d})`,
          opacity: 0
        }, {}], {
          duration: 225 * f,
          easing: YE
        });
        (g = ep(r)) == null || g.forEach((v) => {
          Ca(v, [{
            opacity: 0
          }, {
            opacity: 0,
            offset: 0.33
          }, {}], {
            duration: 225 * 2 * f,
            easing: Sc
          });
        }), m.finished.then(() => s());
      },
      onAfterEnter(r) {
        r.style.removeProperty("pointer-events");
      },
      onBeforeLeave(r) {
        r.style.pointerEvents = "none";
      },
      async onLeave(r, s) {
        var g;
        await new Promise((v) => requestAnimationFrame(v));
        const {
          x: a,
          y: l,
          sx: c,
          sy: d,
          speed: f
        } = tp(e.target, r);
        Ca(r, [{}, {
          transform: `translate(${a}px, ${l}px) scale(${c}, ${d})`,
          opacity: 0
        }], {
          duration: 125 * f,
          easing: ZE
        }).finished.then(() => s()), (g = ep(r)) == null || g.forEach((v) => {
          Ca(v, [{}, {
            opacity: 0,
            offset: 0.2
          }, {
            opacity: 0
          }], {
            duration: 125 * 2 * f,
            easing: Sc
          });
        });
      },
      onAfterLeave(r) {
        r.style.removeProperty("pointer-events");
      }
    };
    return () => e.target ? b(Hs, fe({
      name: "dialog-transition"
    }, i, {
      css: !1
    }), n) : b(Hs, {
      name: "dialog-transition"
    }, n);
  }
});
function ep(e) {
  var n;
  const t = (n = e.querySelector(":scope > .v-card, :scope > .v-sheet, :scope > .v-list")) == null ? void 0 : n.children;
  return t && [...t];
}
function tp(e, t) {
  const n = q0(e), i = mm(t), [r, s] = getComputedStyle(t).transformOrigin.split(" ").map((S) => parseFloat(S)), [a, l] = getComputedStyle(t).getPropertyValue("--v-overlay-anchor-origin").split(" ");
  let c = n.left + n.width / 2;
  a === "left" || l === "left" ? c -= n.width / 2 : (a === "right" || l === "right") && (c += n.width / 2);
  let d = n.top + n.height / 2;
  a === "top" || l === "top" ? d -= n.height / 2 : (a === "bottom" || l === "bottom") && (d += n.height / 2);
  const f = n.width / i.width, m = n.height / i.height, g = Math.max(1, f, m), v = f / g || 0, p = m / g || 0, _ = i.width * i.height / (window.innerWidth * window.innerHeight), x = _ > 0.12 ? Math.min(1.5, (_ - 0.12) * 10 + 1) : 1;
  return {
    x: c - (r + i.left),
    y: d - (s + i.top),
    sx: v,
    sy: p,
    speed: x
  };
}
ei("fab-transition", "center center", "out-in");
ei("dialog-bottom-transition");
ei("dialog-top-transition");
const np = ei("fade-transition"), EA = ei("scale-transition");
ei("scroll-x-transition");
ei("scroll-x-reverse-transition");
ei("scroll-y-transition");
ei("scroll-y-reverse-transition");
ei("slide-x-transition");
ei("slide-x-reverse-transition");
const mx = ei("slide-y-transition");
ei("slide-y-reverse-transition");
const gx = fx("expand-transition", hx()), vx = fx("expand-x-transition", hx("", !0));
function AA(e) {
  return {
    aspectStyles: I(() => {
      const t = Number(e.aspectRatio);
      return t ? {
        paddingBottom: String(1 / t * 100) + "%"
      } : void 0;
    })
  };
}
const yx = ee({
  aspectRatio: [String, Number],
  contentClass: null,
  inline: Boolean,
  ...Ae(),
  ...Di()
}, "VResponsive"), ip = pe()({
  name: "VResponsive",
  props: yx(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      aspectStyles: i
    } = AA(e), {
      dimensionStyles: r
    } = Vi(e);
    return ke(() => {
      var s;
      return b("div", {
        class: ["v-responsive", {
          "v-responsive--inline": e.inline
        }, e.class],
        style: [r.value, e.style]
      }, [b("div", {
        class: "v-responsive__sizer",
        style: i.value
      }, null), (s = n.additional) == null ? void 0 : s.call(n), n.default && b("div", {
        class: ["v-responsive__content", e.contentClass]
      }, [n.default()])]);
    }), {};
  }
}), Wa = ee({
  transition: {
    type: [Boolean, String, Object],
    default: "fade-transition",
    validator: (e) => e !== !0
  }
}, "transition"), pr = (e, t) => {
  let {
    slots: n
  } = t;
  const {
    transition: i,
    disabled: r,
    group: s,
    ...a
  } = e, {
    component: l = s ? lm : Hs,
    ...c
  } = typeof i == "object" ? i : {};
  return br(l, fe(typeof i == "string" ? {
    name: r ? "" : i
  } : c, typeof i == "string" ? {} : Object.fromEntries(Object.entries({
    disabled: r,
    group: s
  }).filter((d) => {
    let [f, m] = d;
    return m !== void 0;
  })), a), n);
};
function MA(e, t) {
  if (!cm)
    return;
  const n = t.modifiers || {}, i = t.value, {
    handler: r,
    options: s
  } = typeof i == "object" ? i : {
    handler: i,
    options: {}
  }, a = new IntersectionObserver(function() {
    var m;
    let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], c = arguments.length > 1 ? arguments[1] : void 0;
    const d = (m = e._observe) == null ? void 0 : m[t.instance.$.uid];
    if (!d)
      return;
    const f = l.some((g) => g.isIntersecting);
    r && (!n.quiet || d.init) && (!n.once || f || d.init) && r(f, l, c), f && n.once ? px(e, t) : d.init = !0;
  }, s);
  e._observe = Object(e._observe), e._observe[t.instance.$.uid] = {
    init: !1,
    observer: a
  }, a.observe(e);
}
function px(e, t) {
  var i;
  const n = (i = e._observe) == null ? void 0 : i[t.instance.$.uid];
  n && (n.observer.unobserve(e), delete e._observe[t.instance.$.uid]);
}
const ed = {
  mounted: MA,
  unmounted: px
}, DA = ee({
  absolute: Boolean,
  alt: String,
  cover: Boolean,
  color: String,
  draggable: {
    type: [Boolean, String],
    default: void 0
  },
  eager: Boolean,
  gradient: String,
  lazySrc: String,
  options: {
    type: Object,
    // For more information on types, navigate to:
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    default: () => ({
      root: void 0,
      rootMargin: void 0,
      threshold: void 0
    })
  },
  sizes: String,
  src: {
    type: [String, Object],
    default: ""
  },
  crossorigin: String,
  referrerpolicy: String,
  srcset: String,
  position: String,
  ...yx(),
  ...Ae(),
  ...vn(),
  ...Wa()
}, "VImg"), Tl = pe()({
  name: "VImg",
  directives: {
    intersect: ed
  },
  props: DA(),
  emits: {
    loadstart: (e) => !0,
    load: (e) => !0,
    error: (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: i
    } = t;
    const {
      backgroundColorClasses: r,
      backgroundColorStyles: s
    } = Bn(ce(e, "color")), {
      roundedClasses: a
    } = Cn(e), l = Nt("VImg"), c = Ie(""), d = ue(), f = Ie(e.eager ? "loading" : "idle"), m = Ie(), g = Ie(), v = I(() => e.src && typeof e.src == "object" ? {
      src: e.src.src,
      srcset: e.srcset || e.src.srcset,
      lazySrc: e.lazySrc || e.src.lazySrc,
      aspect: Number(e.aspectRatio || e.src.aspect || 0)
    } : {
      src: e.src,
      srcset: e.srcset,
      lazySrc: e.lazySrc,
      aspect: Number(e.aspectRatio || 0)
    }), p = I(() => v.value.aspect || m.value / g.value || 0);
    Se(() => e.src, () => {
      _(f.value !== "idle");
    }), Se(p, (N, q) => {
      !N && q && d.value && E(d.value);
    }), _l(() => _());
    function _(N) {
      if (!(e.eager && N) && !(cm && !N && !e.eager)) {
        if (f.value = "loading", v.value.lazySrc) {
          const q = new Image();
          q.src = v.value.lazySrc, E(q, null);
        }
        v.value.src && Ct(() => {
          var q;
          n("loadstart", ((q = d.value) == null ? void 0 : q.currentSrc) || v.value.src), setTimeout(() => {
            var X;
            if (!l.isUnmounted)
              if ((X = d.value) != null && X.complete) {
                if (d.value.naturalWidth || S(), f.value === "error")
                  return;
                p.value || E(d.value, null), f.value === "loading" && x();
              } else
                p.value || E(d.value), T();
          });
        });
      }
    }
    function x() {
      var N;
      l.isUnmounted || (T(), E(d.value), f.value = "loaded", n("load", ((N = d.value) == null ? void 0 : N.currentSrc) || v.value.src));
    }
    function S() {
      var N;
      l.isUnmounted || (f.value = "error", n("error", ((N = d.value) == null ? void 0 : N.currentSrc) || v.value.src));
    }
    function T() {
      const N = d.value;
      N && (c.value = N.currentSrc || N.src);
    }
    let M = -1;
    kn(() => {
      clearTimeout(M);
    });
    function E(N) {
      let q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      const X = () => {
        if (clearTimeout(M), l.isUnmounted)
          return;
        const {
          naturalHeight: se,
          naturalWidth: de
        } = N;
        se || de ? (m.value = de, g.value = se) : !N.complete && f.value === "loading" && q != null ? M = window.setTimeout(X, q) : (N.currentSrc.endsWith(".svg") || N.currentSrc.startsWith("data:image/svg+xml")) && (m.value = 1, g.value = 1);
      };
      X();
    }
    const D = I(() => ({
      "v-img__img--cover": e.cover,
      "v-img__img--contain": !e.cover
    })), R = () => {
      var X;
      if (!v.value.src || f.value === "idle")
        return null;
      const N = b("img", {
        class: ["v-img__img", D.value],
        style: {
          objectPosition: e.position
        },
        crossorigin: e.crossorigin,
        src: v.value.src,
        srcset: v.value.srcset,
        alt: e.alt,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable,
        sizes: e.sizes,
        ref: d,
        onLoad: x,
        onError: S
      }, null), q = (X = i.sources) == null ? void 0 : X.call(i);
      return b(pr, {
        transition: e.transition,
        appear: !0
      }, {
        default: () => [rn(q ? b("picture", {
          class: "v-img__picture"
        }, [q, N]) : N, [[qs, f.value === "loaded"]])]
      });
    }, $ = () => b(pr, {
      transition: e.transition
    }, {
      default: () => [v.value.lazySrc && f.value !== "loaded" && b("img", {
        class: ["v-img__img", "v-img__img--preload", D.value],
        style: {
          objectPosition: e.position
        },
        crossorigin: e.crossorigin,
        src: v.value.lazySrc,
        alt: e.alt,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable
      }, null)]
    }), A = () => i.placeholder ? b(pr, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [(f.value === "loading" || f.value === "error" && !i.error) && b("div", {
        class: "v-img__placeholder"
      }, [i.placeholder()])]
    }) : null, V = () => i.error ? b(pr, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [f.value === "error" && b("div", {
        class: "v-img__error"
      }, [i.error()])]
    }) : null, H = () => e.gradient ? b("div", {
      class: "v-img__gradient",
      style: {
        backgroundImage: `linear-gradient(${e.gradient})`
      }
    }, null) : null, B = Ie(!1);
    {
      const N = Se(p, (q) => {
        q && (requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            B.value = !0;
          });
        }), N());
      });
    }
    return ke(() => {
      const N = ip.filterProps(e);
      return rn(b(ip, fe({
        class: ["v-img", {
          "v-img--absolute": e.absolute,
          "v-img--booting": !B.value
        }, r.value, a.value, e.class],
        style: [{
          width: Ce(e.width === "auto" ? m.value : e.width)
        }, s.value, e.style]
      }, N, {
        aspectRatio: p.value,
        "aria-label": e.alt,
        role: e.alt ? "img" : void 0
      }), {
        additional: () => b(Le, null, [b(R, null, null), b($, null, null), b(H, null, null), b(A, null, null), b(V, null, null)]),
        default: i.default
      }), [[ji("intersect"), {
        handler: _,
        options: e.options
      }, null, {
        once: !0
      }]]);
    }), {
      currentSrc: c,
      image: d,
      state: f,
      naturalWidth: m,
      naturalHeight: g
    };
  }
}), Ki = ee({
  border: [Boolean, Number, String]
}, "border");
function kr(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Yi();
  return {
    borderClasses: I(() => {
      const i = qi(e) ? e.value : e.border, r = [];
      if (i === !0 || i === "")
        r.push(`${t}--border`);
      else if (typeof i == "string" || i === 0)
        for (const s of String(i).split(" "))
          r.push(`border-${s}`);
      return r;
    })
  };
}
const Xi = ee({
  elevation: {
    type: [Number, String],
    validator(e) {
      const t = parseInt(e);
      return !isNaN(t) && t >= 0 && // Material Design has a maximum elevation of 24
      // https://material.io/design/environment/elevation.html#default-elevations
      t <= 24;
    }
  }
}, "elevation");
function Cr(e) {
  return {
    elevationClasses: I(() => {
      const n = qi(e) ? e.value : e.elevation, i = [];
      return n == null || i.push(`elevation-${n}`), i;
    })
  };
}
const VA = [null, "prominent", "default", "comfortable", "compact"], bx = ee({
  absolute: Boolean,
  collapse: Boolean,
  color: String,
  density: {
    type: String,
    default: "default",
    validator: (e) => VA.includes(e)
  },
  extended: Boolean,
  extensionHeight: {
    type: [Number, String],
    default: 48
  },
  flat: Boolean,
  floating: Boolean,
  height: {
    type: [Number, String],
    default: 64
  },
  image: String,
  title: String,
  ...Ki(),
  ...Ae(),
  ...Xi(),
  ...vn(),
  ...pt({
    tag: "header"
  }),
  ...$t()
}, "VToolbar"), kh = pe()({
  name: "VToolbar",
  props: bx(),
  setup(e, t) {
    var v;
    let {
      slots: n
    } = t;
    const {
      backgroundColorClasses: i,
      backgroundColorStyles: r
    } = Bn(ce(e, "color")), {
      borderClasses: s
    } = kr(e), {
      elevationClasses: a
    } = Cr(e), {
      roundedClasses: l
    } = Cn(e), {
      themeClasses: c
    } = Zt(e), {
      rtlClasses: d
    } = Tn(), f = Ie(!!(e.extended || (v = n.extension) != null && v.call(n))), m = I(() => parseInt(Number(e.height) + (e.density === "prominent" ? Number(e.height) : 0) - (e.density === "comfortable" ? 8 : 0) - (e.density === "compact" ? 16 : 0), 10)), g = I(() => f.value ? parseInt(Number(e.extensionHeight) + (e.density === "prominent" ? Number(e.extensionHeight) : 0) - (e.density === "comfortable" ? 4 : 0) - (e.density === "compact" ? 8 : 0), 10) : 0);
    return yi({
      VBtn: {
        variant: "text"
      }
    }), ke(() => {
      var S;
      const p = !!(e.title || n.title), _ = !!(n.image || e.image), x = (S = n.extension) == null ? void 0 : S.call(n);
      return f.value = !!(e.extended || x), b(e.tag, {
        class: ["v-toolbar", {
          "v-toolbar--absolute": e.absolute,
          "v-toolbar--collapse": e.collapse,
          "v-toolbar--flat": e.flat,
          "v-toolbar--floating": e.floating,
          [`v-toolbar--density-${e.density}`]: !0
        }, i.value, s.value, a.value, l.value, c.value, d.value, e.class],
        style: [r.value, e.style]
      }, {
        default: () => [_ && b("div", {
          key: "image",
          class: "v-toolbar__image"
        }, [n.image ? b(Mt, {
          key: "image-defaults",
          disabled: !e.image,
          defaults: {
            VImg: {
              cover: !0,
              src: e.image
            }
          }
        }, n.image) : b(Tl, {
          key: "image-img",
          cover: !0,
          src: e.image
        }, null)]), b(Mt, {
          defaults: {
            VTabs: {
              height: Ce(m.value)
            }
          }
        }, {
          default: () => {
            var T, M, E;
            return [b("div", {
              class: "v-toolbar__content",
              style: {
                height: Ce(m.value)
              }
            }, [n.prepend && b("div", {
              class: "v-toolbar__prepend"
            }, [(T = n.prepend) == null ? void 0 : T.call(n)]), p && b(dx, {
              key: "title",
              text: e.title
            }, {
              text: n.title
            }), (M = n.default) == null ? void 0 : M.call(n), n.append && b("div", {
              class: "v-toolbar__append"
            }, [(E = n.append) == null ? void 0 : E.call(n)])])];
          }
        }), b(Mt, {
          defaults: {
            VTabs: {
              height: Ce(g.value)
            }
          }
        }, {
          default: () => [b(gx, null, {
            default: () => [f.value && b("div", {
              class: "v-toolbar__extension",
              style: {
                height: Ce(g.value)
              }
            }, [x])]
          })]
        })]
      });
    }), {
      contentHeight: m,
      extensionHeight: g
    };
  }
}), LA = ["elevated", "flat", "tonal", "outlined", "text", "plain"];
function Ua(e, t) {
  return b(Le, null, [e && b("span", {
    key: "overlay",
    class: `${t}__overlay`
  }, null), b("span", {
    key: "underlay",
    class: `${t}__underlay`
  }, null)]);
}
const Ji = ee({
  color: String,
  variant: {
    type: String,
    default: "elevated",
    validator: (e) => LA.includes(e)
  }
}, "variant");
function qa(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Yi();
  const n = I(() => {
    const {
      variant: s
    } = je(e);
    return `${t}--variant-${s}`;
  }), {
    colorClasses: i,
    colorStyles: r
  } = xm(I(() => {
    const {
      variant: s,
      color: a
    } = je(e);
    return {
      [["elevated", "flat"].includes(s) ? "background" : "text"]: a
    };
  }));
  return {
    colorClasses: i,
    colorStyles: r,
    variantClasses: n
  };
}
const FA = {
  class: "d-flex justify-center align-center",
  style: { position: "absolute", left: "50%", transform: "translateX(-50%)" }
}, RA = {
  class: "d-flex justify-center align-center scrollable-slot",
  style: { position: "absolute", left: "75%", transform: "translateX(-75%)" }
}, xx = /* @__PURE__ */ Je({
  __name: "RHDHVToolbar",
  setup(e) {
    return (t, n) => (le(), Te(kh, fe(t.$attrs, {
      density: "compact",
      color: "secondary",
      style: { width: "100%" }
    }), {
      default: Z(() => [
        wt(t.$slots, "toolbar-prepend"),
        t.$slots["toolbar-prepend"] ? (le(), Te(Kc, {
          key: 0,
          vertical: "",
          class: "px-2"
        })) : it("", !0),
        b(hA, null, {
          default: Z(() => [
            wt(t.$slots, "breadcrumbs-items")
          ]),
          _: 3
        }),
        St("div", FA, [
          wt(t.$slots, "toolbar-title")
        ]),
        St("div", RA, [
          wt(t.$slots, "toolbar-actions")
        ]),
        b(Qc),
        wt(t.$slots, "toolbar-extension")
      ]),
      _: 3
    }, 16));
  }
}), BA = ee({
  start: Boolean,
  end: Boolean,
  icon: He,
  image: String,
  text: String,
  ...Ki(),
  ...Ae(),
  ...Qn(),
  ...vn(),
  ...Ha(),
  ...pt(),
  ...$t(),
  ...Ji({
    variant: "flat"
  })
}, "VAvatar"), es = pe()({
  name: "VAvatar",
  props: BA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: i
    } = Zt(e), {
      borderClasses: r
    } = kr(e), {
      colorClasses: s,
      colorStyles: a,
      variantClasses: l
    } = qa(e), {
      densityClasses: c
    } = Mi(e), {
      roundedClasses: d
    } = Cn(e), {
      sizeClasses: f,
      sizeStyles: m
    } = Cl(e);
    return ke(() => b(e.tag, {
      class: ["v-avatar", {
        "v-avatar--start": e.start,
        "v-avatar--end": e.end
      }, i.value, r.value, s.value, c.value, d.value, f.value, l.value, e.class],
      style: [a.value, m.value, e.style]
    }, {
      default: () => [n.default ? b(Mt, {
        key: "content-defaults",
        defaults: {
          VImg: {
            cover: !0,
            src: e.image
          },
          VIcon: {
            icon: e.icon
          }
        }
      }, {
        default: () => [n.default()]
      }) : e.image ? b(Tl, {
        key: "image",
        src: e.image,
        alt: "",
        cover: !0
      }, null) : e.icon ? b(dt, {
        key: "icon",
        icon: e.icon
      }, null) : e.text, Ua(!1, "v-avatar")]
    })), {};
  }
}), Ch = Symbol.for("vuetify:list");
function _x() {
  const e = gt(Ch, {
    hasPrepend: Ie(!1),
    updateHasPrepend: () => null
  }), t = {
    hasPrepend: Ie(!1),
    updateHasPrepend: (n) => {
      n && (t.hasPrepend.value = n);
    }
  };
  return jt(Ch, t), e;
}
function wx() {
  return gt(Ch, null);
}
const km = (e) => {
  const t = {
    activate: (n) => {
      let {
        id: i,
        value: r,
        activated: s
      } = n;
      return i = Pt(i), e && !r && s.size === 1 && s.has(i) || (r ? s.add(i) : s.delete(i)), s;
    },
    in: (n, i, r) => {
      let s = /* @__PURE__ */ new Set();
      if (n != null)
        for (const a of mn(n))
          s = t.activate({
            id: a,
            value: !0,
            activated: new Set(s),
            children: i,
            parents: r
          });
      return s;
    },
    out: (n) => Array.from(n)
  };
  return t;
}, Sx = (e) => {
  const t = km(e);
  return {
    activate: (i) => {
      let {
        activated: r,
        id: s,
        ...a
      } = i;
      s = Pt(s);
      const l = r.has(s) ? /* @__PURE__ */ new Set([s]) : /* @__PURE__ */ new Set();
      return t.activate({
        ...a,
        id: s,
        activated: l
      });
    },
    in: (i, r, s) => {
      let a = /* @__PURE__ */ new Set();
      if (i != null) {
        const l = mn(i);
        l.length && (a = t.in(l.slice(0, 1), r, s));
      }
      return a;
    },
    out: (i, r, s) => t.out(i, r, s)
  };
}, NA = (e) => {
  const t = km(e);
  return {
    activate: (i) => {
      let {
        id: r,
        activated: s,
        children: a,
        ...l
      } = i;
      return r = Pt(r), a.has(r) ? s : t.activate({
        id: r,
        activated: s,
        children: a,
        ...l
      });
    },
    in: t.in,
    out: t.out
  };
}, $A = (e) => {
  const t = Sx(e);
  return {
    activate: (i) => {
      let {
        id: r,
        activated: s,
        children: a,
        ...l
      } = i;
      return r = Pt(r), a.has(r) ? s : t.activate({
        id: r,
        activated: s,
        children: a,
        ...l
      });
    },
    in: t.in,
    out: t.out
  };
}, zA = {
  open: (e) => {
    let {
      id: t,
      value: n,
      opened: i,
      parents: r
    } = e;
    if (n) {
      const s = /* @__PURE__ */ new Set();
      s.add(t);
      let a = r.get(t);
      for (; a != null; )
        s.add(a), a = r.get(a);
      return s;
    } else
      return i.delete(t), i;
  },
  select: () => null
}, kx = {
  open: (e) => {
    let {
      id: t,
      value: n,
      opened: i,
      parents: r
    } = e;
    if (n) {
      let s = r.get(t);
      for (i.add(t); s != null && s !== t; )
        i.add(s), s = r.get(s);
      return i;
    } else
      i.delete(t);
    return i;
  },
  select: () => null
}, HA = {
  open: kx.open,
  select: (e) => {
    let {
      id: t,
      value: n,
      opened: i,
      parents: r
    } = e;
    if (!n)
      return i;
    const s = [];
    let a = r.get(t);
    for (; a != null; )
      s.push(a), a = r.get(a);
    return new Set(s);
  }
}, Cm = (e) => {
  const t = {
    select: (n) => {
      let {
        id: i,
        value: r,
        selected: s
      } = n;
      if (i = Pt(i), e && !r) {
        const a = Array.from(s.entries()).reduce((l, c) => {
          let [d, f] = c;
          return f === "on" && l.push(d), l;
        }, []);
        if (a.length === 1 && a[0] === i)
          return s;
      }
      return s.set(i, r ? "on" : "off"), s;
    },
    in: (n, i, r) => {
      let s = /* @__PURE__ */ new Map();
      for (const a of n || [])
        s = t.select({
          id: a,
          value: !0,
          selected: new Map(s),
          children: i,
          parents: r
        });
      return s;
    },
    out: (n) => {
      const i = [];
      for (const [r, s] of n.entries())
        s === "on" && i.push(r);
      return i;
    }
  };
  return t;
}, Cx = (e) => {
  const t = Cm(e);
  return {
    select: (i) => {
      let {
        selected: r,
        id: s,
        ...a
      } = i;
      s = Pt(s);
      const l = r.has(s) ? /* @__PURE__ */ new Map([[s, r.get(s)]]) : /* @__PURE__ */ new Map();
      return t.select({
        ...a,
        id: s,
        selected: l
      });
    },
    in: (i, r, s) => {
      let a = /* @__PURE__ */ new Map();
      return i != null && i.length && (a = t.in(i.slice(0, 1), r, s)), a;
    },
    out: (i, r, s) => t.out(i, r, s)
  };
}, WA = (e) => {
  const t = Cm(e);
  return {
    select: (i) => {
      let {
        id: r,
        selected: s,
        children: a,
        ...l
      } = i;
      return r = Pt(r), a.has(r) ? s : t.select({
        id: r,
        selected: s,
        children: a,
        ...l
      });
    },
    in: t.in,
    out: t.out
  };
}, UA = (e) => {
  const t = Cx(e);
  return {
    select: (i) => {
      let {
        id: r,
        selected: s,
        children: a,
        ...l
      } = i;
      return r = Pt(r), a.has(r) ? s : t.select({
        id: r,
        selected: s,
        children: a,
        ...l
      });
    },
    in: t.in,
    out: t.out
  };
}, qA = (e) => {
  const t = {
    select: (n) => {
      let {
        id: i,
        value: r,
        selected: s,
        children: a,
        parents: l
      } = n;
      i = Pt(i);
      const c = new Map(s), d = [i];
      for (; d.length; ) {
        const m = d.shift();
        s.set(Pt(m), r ? "on" : "off"), a.has(m) && d.push(...a.get(m));
      }
      let f = Pt(l.get(i));
      for (; f; ) {
        const m = a.get(f), g = m.every((p) => s.get(Pt(p)) === "on"), v = m.every((p) => !s.has(Pt(p)) || s.get(Pt(p)) === "off");
        s.set(f, g ? "on" : v ? "off" : "indeterminate"), f = Pt(l.get(f));
      }
      return e && !r && Array.from(s.entries()).reduce((g, v) => {
        let [p, _] = v;
        return _ === "on" && g.push(p), g;
      }, []).length === 0 ? c : s;
    },
    in: (n, i, r) => {
      let s = /* @__PURE__ */ new Map();
      for (const a of n || [])
        s = t.select({
          id: a,
          value: !0,
          selected: new Map(s),
          children: i,
          parents: r
        });
      return s;
    },
    out: (n, i) => {
      const r = [];
      for (const [s, a] of n.entries())
        a === "on" && !i.has(s) && r.push(s);
      return r;
    }
  };
  return t;
}, al = Symbol.for("vuetify:nested"), Tx = {
  id: Ie(),
  root: {
    register: () => null,
    unregister: () => null,
    parents: ue(/* @__PURE__ */ new Map()),
    children: ue(/* @__PURE__ */ new Map()),
    open: () => null,
    openOnSelect: () => null,
    activate: () => null,
    select: () => null,
    activatable: ue(!1),
    selectable: ue(!1),
    opened: ue(/* @__PURE__ */ new Set()),
    activated: ue(/* @__PURE__ */ new Set()),
    selected: ue(/* @__PURE__ */ new Map()),
    selectedValues: ue([]),
    getPath: () => []
  }
}, jA = ee({
  activatable: Boolean,
  selectable: Boolean,
  activeStrategy: [String, Function, Object],
  selectStrategy: [String, Function, Object],
  openStrategy: [String, Object],
  opened: null,
  activated: null,
  selected: null,
  mandatory: Boolean
}, "nested"), GA = (e) => {
  let t = !1;
  const n = ue(/* @__PURE__ */ new Map()), i = ue(/* @__PURE__ */ new Map()), r = at(e, "opened", e.opened, (p) => new Set(p), (p) => [...p.values()]), s = I(() => {
    if (typeof e.activeStrategy == "object")
      return e.activeStrategy;
    if (typeof e.activeStrategy == "function")
      return e.activeStrategy(e.mandatory);
    switch (e.activeStrategy) {
      case "leaf":
        return NA(e.mandatory);
      case "single-leaf":
        return $A(e.mandatory);
      case "independent":
        return km(e.mandatory);
      case "single-independent":
      default:
        return Sx(e.mandatory);
    }
  }), a = I(() => {
    if (typeof e.selectStrategy == "object")
      return e.selectStrategy;
    if (typeof e.selectStrategy == "function")
      return e.selectStrategy(e.mandatory);
    switch (e.selectStrategy) {
      case "single-leaf":
        return UA(e.mandatory);
      case "leaf":
        return WA(e.mandatory);
      case "independent":
        return Cm(e.mandatory);
      case "single-independent":
        return Cx(e.mandatory);
      case "classic":
      default:
        return qA(e.mandatory);
    }
  }), l = I(() => {
    if (typeof e.openStrategy == "object")
      return e.openStrategy;
    switch (e.openStrategy) {
      case "list":
        return HA;
      case "single":
        return zA;
      case "multiple":
      default:
        return kx;
    }
  }), c = at(e, "activated", e.activated, (p) => s.value.in(p, n.value, i.value), (p) => s.value.out(p, n.value, i.value)), d = at(e, "selected", e.selected, (p) => a.value.in(p, n.value, i.value), (p) => a.value.out(p, n.value, i.value));
  kn(() => {
    t = !0;
  });
  function f(p) {
    const _ = [];
    let x = p;
    for (; x != null; )
      _.unshift(x), x = i.value.get(x);
    return _;
  }
  const m = Nt("nested"), g = /* @__PURE__ */ new Set(), v = {
    id: Ie(),
    root: {
      opened: r,
      activatable: ce(e, "activatable"),
      selectable: ce(e, "selectable"),
      activated: c,
      selected: d,
      selectedValues: I(() => {
        const p = [];
        for (const [_, x] of d.value.entries())
          x === "on" && p.push(_);
        return p;
      }),
      register: (p, _, x) => {
        if (g.has(p)) {
          const S = f(p).map(String).join(" -> "), T = f(_).concat(p).map(String).join(" -> ");
          gm(`Multiple nodes with the same ID
	${S}
	${T}`);
          return;
        } else
          g.add(p);
        _ && p !== _ && i.value.set(p, _), x && n.value.set(p, []), _ != null && n.value.set(_, [...n.value.get(_) || [], p]);
      },
      unregister: (p) => {
        if (t)
          return;
        g.delete(p), n.value.delete(p);
        const _ = i.value.get(p);
        if (_) {
          const x = n.value.get(_) ?? [];
          n.value.set(_, x.filter((S) => S !== p));
        }
        i.value.delete(p);
      },
      open: (p, _, x) => {
        m.emit("click:open", {
          id: p,
          value: _,
          path: f(p),
          event: x
        });
        const S = l.value.open({
          id: p,
          value: _,
          opened: new Set(r.value),
          children: n.value,
          parents: i.value,
          event: x
        });
        S && (r.value = S);
      },
      openOnSelect: (p, _, x) => {
        const S = l.value.select({
          id: p,
          value: _,
          selected: new Map(d.value),
          opened: new Set(r.value),
          children: n.value,
          parents: i.value,
          event: x
        });
        S && (r.value = S);
      },
      select: (p, _, x) => {
        m.emit("click:select", {
          id: p,
          value: _,
          path: f(p),
          event: x
        });
        const S = a.value.select({
          id: p,
          value: _,
          selected: new Map(d.value),
          children: n.value,
          parents: i.value,
          event: x
        });
        S && (d.value = S), v.root.openOnSelect(p, _, x);
      },
      activate: (p, _, x) => {
        if (!e.activatable)
          return v.root.select(p, !0, x);
        m.emit("click:activate", {
          id: p,
          value: _,
          path: f(p),
          event: x
        });
        const S = s.value.activate({
          id: p,
          value: _,
          activated: new Set(c.value),
          children: n.value,
          parents: i.value,
          event: x
        });
        S && (c.value = S);
      },
      children: n,
      parents: i,
      getPath: f
    }
  };
  return jt(al, v), v.root;
}, Ix = (e, t) => {
  const n = gt(al, Tx), i = Symbol(pi()), r = I(() => e.value !== void 0 ? e.value : i), s = {
    ...n,
    id: r,
    open: (a, l) => n.root.open(r.value, a, l),
    openOnSelect: (a, l) => n.root.openOnSelect(r.value, a, l),
    isOpen: I(() => n.root.opened.value.has(r.value)),
    parent: I(() => n.root.parents.value.get(r.value)),
    activate: (a, l) => n.root.activate(r.value, a, l),
    isActivated: I(() => n.root.activated.value.has(Pt(r.value))),
    select: (a, l) => n.root.select(r.value, a, l),
    isSelected: I(() => n.root.selected.value.get(Pt(r.value)) === "on"),
    isIndeterminate: I(() => n.root.selected.value.get(Pt(r.value)) === "indeterminate"),
    isLeaf: I(() => !n.root.children.value.get(r.value)),
    isGroupActivator: n.isGroupActivator
  };
  return _l(() => {
    !n.isGroupActivator && n.root.register(r.value, n.id.value, t);
  }), kn(() => {
    !n.isGroupActivator && n.root.unregister(r.value);
  }), t && jt(al, s), s;
}, YA = () => {
  const e = gt(al, Tx);
  jt(al, {
    ...e,
    isGroupActivator: !0
  });
};
function Px() {
  const e = Ie(!1);
  return Jn(() => {
    window.requestAnimationFrame(() => {
      e.value = !0;
    });
  }), {
    ssrBootStyles: I(() => e.value ? void 0 : {
      transition: "none !important"
    }),
    isBooted: jc(e)
  };
}
const ZA = Zi({
  name: "VListGroupActivator",
  setup(e, t) {
    let {
      slots: n
    } = t;
    return YA(), () => {
      var i;
      return (i = n.default) == null ? void 0 : i.call(n);
    };
  }
}), KA = ee({
  /* @deprecated */
  activeColor: String,
  baseColor: String,
  color: String,
  collapseIcon: {
    type: He,
    default: "$collapse"
  },
  expandIcon: {
    type: He,
    default: "$expand"
  },
  prependIcon: He,
  appendIcon: He,
  fluid: Boolean,
  subgroup: Boolean,
  title: String,
  value: null,
  ...Ae(),
  ...pt()
}, "VListGroup"), rp = pe()({
  name: "VListGroup",
  props: KA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      isOpen: i,
      open: r,
      id: s
    } = Ix(ce(e, "value"), !0), a = I(() => `v-list-group--id-${String(s.value)}`), l = wx(), {
      isBooted: c
    } = Px();
    function d(v) {
      v.stopPropagation(), r(!i.value, v);
    }
    const f = I(() => ({
      onClick: d,
      class: "v-list-group__header",
      id: a.value
    })), m = I(() => i.value ? e.collapseIcon : e.expandIcon), g = I(() => ({
      VListItem: {
        active: i.value,
        activeColor: e.activeColor,
        baseColor: e.baseColor,
        color: e.color,
        prependIcon: e.prependIcon || e.subgroup && m.value,
        appendIcon: e.appendIcon || !e.subgroup && m.value,
        title: e.title,
        value: e.value
      }
    }));
    return ke(() => b(e.tag, {
      class: ["v-list-group", {
        "v-list-group--prepend": l == null ? void 0 : l.hasPrepend.value,
        "v-list-group--fluid": e.fluid,
        "v-list-group--subgroup": e.subgroup,
        "v-list-group--open": i.value
      }, e.class],
      style: e.style
    }, {
      default: () => [n.activator && b(Mt, {
        defaults: g.value
      }, {
        default: () => [b(ZA, null, {
          default: () => [n.activator({
            props: f.value,
            isOpen: i.value
          })]
        })]
      }), b(pr, {
        transition: {
          component: gx
        },
        disabled: !c.value
      }, {
        default: () => {
          var v;
          return [rn(b("div", {
            class: "v-list-group__items",
            role: "group",
            "aria-labelledby": a.value
          }, [(v = n.default) == null ? void 0 : v.call(n)]), [[qs, i.value]])];
        }
      })]
    })), {
      isOpen: i
    };
  }
}), XA = ee({
  opacity: [Number, String],
  ...Ae(),
  ...pt()
}, "VListItemSubtitle"), JA = pe()({
  name: "VListItemSubtitle",
  props: XA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return ke(() => b(e.tag, {
      class: ["v-list-item-subtitle", e.class],
      style: [{
        "--v-list-item-subtitle-opacity": e.opacity
      }, e.style]
    }, n)), {};
  }
}), ol = pm("v-list-item-title"), Th = Symbol("rippleStop"), QA = 80;
function sp(e, t) {
  e.style.transform = t, e.style.webkitTransform = t;
}
function Ih(e) {
  return e.constructor.name === "TouchEvent";
}
function Ox(e) {
  return e.constructor.name === "KeyboardEvent";
}
const eM = function(e, t) {
  var m;
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = 0, r = 0;
  if (!Ox(e)) {
    const g = t.getBoundingClientRect(), v = Ih(e) ? e.touches[e.touches.length - 1] : e;
    i = v.clientX - g.left, r = v.clientY - g.top;
  }
  let s = 0, a = 0.3;
  (m = t._ripple) != null && m.circle ? (a = 0.15, s = t.clientWidth / 2, s = n.center ? s : s + Math.sqrt((i - s) ** 2 + (r - s) ** 2) / 4) : s = Math.sqrt(t.clientWidth ** 2 + t.clientHeight ** 2) / 2;
  const l = `${(t.clientWidth - s * 2) / 2}px`, c = `${(t.clientHeight - s * 2) / 2}px`, d = n.center ? l : `${i - s}px`, f = n.center ? c : `${r - s}px`;
  return {
    radius: s,
    scale: a,
    x: d,
    y: f,
    centerX: l,
    centerY: c
  };
}, Cc = {
  /* eslint-disable max-statements */
  show(e, t) {
    var v;
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!((v = t == null ? void 0 : t._ripple) != null && v.enabled))
      return;
    const i = document.createElement("span"), r = document.createElement("span");
    i.appendChild(r), i.className = "v-ripple__container", n.class && (i.className += ` ${n.class}`);
    const {
      radius: s,
      scale: a,
      x: l,
      y: c,
      centerX: d,
      centerY: f
    } = eM(e, t, n), m = `${s * 2}px`;
    r.className = "v-ripple__animation", r.style.width = m, r.style.height = m, t.appendChild(i);
    const g = window.getComputedStyle(t);
    g && g.position === "static" && (t.style.position = "relative", t.dataset.previousPosition = "static"), r.classList.add("v-ripple__animation--enter"), r.classList.add("v-ripple__animation--visible"), sp(r, `translate(${l}, ${c}) scale3d(${a},${a},${a})`), r.dataset.activated = String(performance.now()), setTimeout(() => {
      r.classList.remove("v-ripple__animation--enter"), r.classList.add("v-ripple__animation--in"), sp(r, `translate(${d}, ${f}) scale3d(1,1,1)`);
    }, 0);
  },
  hide(e) {
    var s;
    if (!((s = e == null ? void 0 : e._ripple) != null && s.enabled))
      return;
    const t = e.getElementsByClassName("v-ripple__animation");
    if (t.length === 0)
      return;
    const n = t[t.length - 1];
    if (n.dataset.isHiding)
      return;
    n.dataset.isHiding = "true";
    const i = performance.now() - Number(n.dataset.activated), r = Math.max(250 - i, 0);
    setTimeout(() => {
      n.classList.remove("v-ripple__animation--in"), n.classList.add("v-ripple__animation--out"), setTimeout(() => {
        var l;
        e.getElementsByClassName("v-ripple__animation").length === 1 && e.dataset.previousPosition && (e.style.position = e.dataset.previousPosition, delete e.dataset.previousPosition), ((l = n.parentNode) == null ? void 0 : l.parentNode) === e && e.removeChild(n.parentNode);
      }, 300);
    }, r);
  }
};
function Ex(e) {
  return typeof e > "u" || !!e;
}
function ll(e) {
  const t = {}, n = e.currentTarget;
  if (!(!(n != null && n._ripple) || n._ripple.touched || e[Th])) {
    if (e[Th] = !0, Ih(e))
      n._ripple.touched = !0, n._ripple.isTouch = !0;
    else if (n._ripple.isTouch)
      return;
    if (t.center = n._ripple.centered || Ox(e), n._ripple.class && (t.class = n._ripple.class), Ih(e)) {
      if (n._ripple.showTimerCommit)
        return;
      n._ripple.showTimerCommit = () => {
        Cc.show(e, n, t);
      }, n._ripple.showTimer = window.setTimeout(() => {
        var i;
        (i = n == null ? void 0 : n._ripple) != null && i.showTimerCommit && (n._ripple.showTimerCommit(), n._ripple.showTimerCommit = null);
      }, QA);
    } else
      Cc.show(e, n, t);
  }
}
function ap(e) {
  e[Th] = !0;
}
function Yn(e) {
  const t = e.currentTarget;
  if (t != null && t._ripple) {
    if (window.clearTimeout(t._ripple.showTimer), e.type === "touchend" && t._ripple.showTimerCommit) {
      t._ripple.showTimerCommit(), t._ripple.showTimerCommit = null, t._ripple.showTimer = window.setTimeout(() => {
        Yn(e);
      });
      return;
    }
    window.setTimeout(() => {
      t._ripple && (t._ripple.touched = !1);
    }), Cc.hide(t);
  }
}
function Ax(e) {
  const t = e.currentTarget;
  t != null && t._ripple && (t._ripple.showTimerCommit && (t._ripple.showTimerCommit = null), window.clearTimeout(t._ripple.showTimer));
}
let ul = !1;
function Mx(e) {
  !ul && (e.keyCode === Py.enter || e.keyCode === Py.space) && (ul = !0, ll(e));
}
function Dx(e) {
  ul = !1, Yn(e);
}
function Vx(e) {
  ul && (ul = !1, Yn(e));
}
function Lx(e, t, n) {
  const {
    value: i,
    modifiers: r
  } = t, s = Ex(i);
  if (s || Cc.hide(e), e._ripple = e._ripple ?? {}, e._ripple.enabled = s, e._ripple.centered = r.center, e._ripple.circle = r.circle, R0(i) && i.class && (e._ripple.class = i.class), s && !n) {
    if (r.stop) {
      e.addEventListener("touchstart", ap, {
        passive: !0
      }), e.addEventListener("mousedown", ap);
      return;
    }
    e.addEventListener("touchstart", ll, {
      passive: !0
    }), e.addEventListener("touchend", Yn, {
      passive: !0
    }), e.addEventListener("touchmove", Ax, {
      passive: !0
    }), e.addEventListener("touchcancel", Yn), e.addEventListener("mousedown", ll), e.addEventListener("mouseup", Yn), e.addEventListener("mouseleave", Yn), e.addEventListener("keydown", Mx), e.addEventListener("keyup", Dx), e.addEventListener("blur", Vx), e.addEventListener("dragstart", Yn, {
      passive: !0
    });
  } else
    !s && n && Fx(e);
}
function Fx(e) {
  e.removeEventListener("mousedown", ll), e.removeEventListener("touchstart", ll), e.removeEventListener("touchend", Yn), e.removeEventListener("touchmove", Ax), e.removeEventListener("touchcancel", Yn), e.removeEventListener("mouseup", Yn), e.removeEventListener("mouseleave", Yn), e.removeEventListener("keydown", Mx), e.removeEventListener("keyup", Dx), e.removeEventListener("dragstart", Yn), e.removeEventListener("blur", Vx);
}
function tM(e, t) {
  Lx(e, t, !1);
}
function nM(e) {
  delete e._ripple, Fx(e);
}
function iM(e, t) {
  if (t.value === t.oldValue)
    return;
  const n = Ex(t.oldValue);
  Lx(e, t, n);
}
const ja = {
  mounted: tM,
  unmounted: nM,
  updated: iM
}, rM = ee({
  active: {
    type: Boolean,
    default: void 0
  },
  activeClass: String,
  /* @deprecated */
  activeColor: String,
  appendAvatar: String,
  appendIcon: He,
  baseColor: String,
  disabled: Boolean,
  lines: [Boolean, String],
  link: {
    type: Boolean,
    default: void 0
  },
  nav: Boolean,
  prependAvatar: String,
  prependIcon: He,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  slim: Boolean,
  subtitle: [String, Number],
  title: [String, Number],
  value: null,
  onClick: cn(),
  onClickOnce: cn(),
  ...Ki(),
  ...Ae(),
  ...Qn(),
  ...Di(),
  ...Xi(),
  ...vn(),
  ...kl(),
  ...pt(),
  ...$t(),
  ...Ji({
    variant: "text"
  })
}, "VListItem"), ts = pe()({
  name: "VListItem",
  directives: {
    Ripple: ja
  },
  props: rM(),
  emits: {
    click: (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: i,
      emit: r
    } = t;
    const s = Sl(e, n), a = I(() => e.value === void 0 ? s.href.value : e.value), {
      activate: l,
      isActivated: c,
      select: d,
      isOpen: f,
      isSelected: m,
      isIndeterminate: g,
      isGroupActivator: v,
      root: p,
      parent: _,
      openOnSelect: x,
      id: S
    } = Ix(a, !1), T = wx(), M = I(() => {
      var he;
      return e.active !== !1 && (e.active || ((he = s.isActive) == null ? void 0 : he.value) || (p.activatable.value ? c.value : m.value));
    }), E = I(() => e.link !== !1 && s.isLink.value), D = I(() => !!T && (p.selectable.value || p.activatable.value || e.value != null)), R = I(() => !e.disabled && e.link !== !1 && (e.link || s.isClickable.value || D.value)), $ = I(() => e.rounded || e.nav), A = I(() => e.color ?? e.activeColor), V = I(() => ({
      color: M.value ? A.value ?? e.baseColor : e.baseColor,
      variant: e.variant
    }));
    Se(() => {
      var he;
      return (he = s.isActive) == null ? void 0 : he.value;
    }, (he) => {
      he && H();
    }), _l(() => {
      var he;
      (he = s.isActive) != null && he.value && H();
    });
    function H() {
      _.value != null && p.open(_.value, !0), x(!0);
    }
    const {
      themeClasses: B
    } = Zt(e), {
      borderClasses: N
    } = kr(e), {
      colorClasses: q,
      colorStyles: X,
      variantClasses: se
    } = qa(V), {
      densityClasses: de
    } = Mi(e), {
      dimensionStyles: _e
    } = Vi(e), {
      elevationClasses: be
    } = Cr(e), {
      roundedClasses: oe
    } = Cn($), J = I(() => e.lines ? `v-list-item--${e.lines}-line` : void 0), G = I(() => ({
      isActive: M.value,
      select: d,
      isOpen: f.value,
      isSelected: m.value,
      isIndeterminate: g.value
    }));
    function ie(he) {
      var Oe;
      r("click", he), R.value && ((Oe = s.navigate) == null || Oe.call(s, he), !v && (p.activatable.value ? l(!c.value, he) : (p.selectable.value || e.value != null) && d(!m.value, he)));
    }
    function ge(he) {
      (he.key === "Enter" || he.key === " ") && (he.preventDefault(), he.target.dispatchEvent(new MouseEvent("click", he)));
    }
    return ke(() => {
      const he = E.value ? "a" : e.tag, Oe = i.title || e.title != null, Q = i.subtitle || e.subtitle != null, me = !!(e.appendAvatar || e.appendIcon), Ze = !!(me || i.append), We = !!(e.prependAvatar || e.prependIcon), Ue = !!(We || i.prepend);
      return T == null || T.updateHasPrepend(Ue), e.activeColor && DE("active-color", ["color", "base-color"]), rn(b(he, fe({
        class: ["v-list-item", {
          "v-list-item--active": M.value,
          "v-list-item--disabled": e.disabled,
          "v-list-item--link": R.value,
          "v-list-item--nav": e.nav,
          "v-list-item--prepend": !Ue && (T == null ? void 0 : T.hasPrepend.value),
          "v-list-item--slim": e.slim,
          [`${e.activeClass}`]: e.activeClass && M.value
        }, B.value, N.value, q.value, de.value, be.value, J.value, oe.value, se.value, e.class],
        style: [X.value, _e.value, e.style],
        tabindex: R.value ? T ? -2 : 0 : void 0,
        "aria-selected": D.value ? p.activatable.value ? c.value : p.selectable.value ? m.value : M.value : void 0,
        onClick: ie,
        onKeydown: R.value && !E.value && ge
      }, s.linkProps), {
        default: () => {
          var Ot;
          return [Ua(R.value || M.value, "v-list-item"), Ue && b("div", {
            key: "prepend",
            class: "v-list-item__prepend"
          }, [i.prepend ? b(Mt, {
            key: "prepend-defaults",
            disabled: !We,
            defaults: {
              VAvatar: {
                density: e.density,
                image: e.prependAvatar
              },
              VIcon: {
                density: e.density,
                icon: e.prependIcon
              },
              VListItemAction: {
                start: !0
              }
            }
          }, {
            default: () => {
              var ft;
              return [(ft = i.prepend) == null ? void 0 : ft.call(i, G.value)];
            }
          }) : b(Le, null, [e.prependAvatar && b(es, {
            key: "prepend-avatar",
            density: e.density,
            image: e.prependAvatar
          }, null), e.prependIcon && b(dt, {
            key: "prepend-icon",
            density: e.density,
            icon: e.prependIcon
          }, null)]), b("div", {
            class: "v-list-item__spacer"
          }, null)]), b("div", {
            class: "v-list-item__content",
            "data-no-activator": ""
          }, [Oe && b(ol, {
            key: "title"
          }, {
            default: () => {
              var ft;
              return [((ft = i.title) == null ? void 0 : ft.call(i, {
                title: e.title
              })) ?? e.title];
            }
          }), Q && b(JA, {
            key: "subtitle"
          }, {
            default: () => {
              var ft;
              return [((ft = i.subtitle) == null ? void 0 : ft.call(i, {
                subtitle: e.subtitle
              })) ?? e.subtitle];
            }
          }), (Ot = i.default) == null ? void 0 : Ot.call(i, G.value)]), Ze && b("div", {
            key: "append",
            class: "v-list-item__append"
          }, [i.append ? b(Mt, {
            key: "append-defaults",
            disabled: !me,
            defaults: {
              VAvatar: {
                density: e.density,
                image: e.appendAvatar
              },
              VIcon: {
                density: e.density,
                icon: e.appendIcon
              },
              VListItemAction: {
                end: !0
              }
            }
          }, {
            default: () => {
              var ft;
              return [(ft = i.append) == null ? void 0 : ft.call(i, G.value)];
            }
          }) : b(Le, null, [e.appendIcon && b(dt, {
            key: "append-icon",
            density: e.density,
            icon: e.appendIcon
          }, null), e.appendAvatar && b(es, {
            key: "append-avatar",
            density: e.density,
            image: e.appendAvatar
          }, null)]), b("div", {
            class: "v-list-item__spacer"
          }, null)])];
        }
      }), [[ji("ripple"), R.value && e.ripple]]);
    }), {
      activate: l,
      isActivated: c,
      isGroupActivator: v,
      isSelected: m,
      list: T,
      select: d,
      root: p,
      id: S
    };
  }
}), sM = ee({
  color: String,
  inset: Boolean,
  sticky: Boolean,
  title: String,
  ...Ae(),
  ...pt()
}, "VListSubheader"), aM = pe()({
  name: "VListSubheader",
  props: sM(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      textColorClasses: i,
      textColorStyles: r
    } = Ei(ce(e, "color"));
    return ke(() => {
      const s = !!(n.default || e.title);
      return b(e.tag, {
        class: ["v-list-subheader", {
          "v-list-subheader--inset": e.inset,
          "v-list-subheader--sticky": e.sticky
        }, i.value, e.class],
        style: [{
          textColorStyles: r
        }, e.style]
      }, {
        default: () => {
          var a;
          return [s && b("div", {
            class: "v-list-subheader__text"
          }, [((a = n.default) == null ? void 0 : a.call(n)) ?? e.title])];
        }
      });
    }), {};
  }
}), oM = ee({
  items: Array,
  returnObject: Boolean
}, "VListChildren"), Rx = pe()({
  name: "VListChildren",
  props: oM(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return _x(), () => {
      var i, r;
      return ((i = n.default) == null ? void 0 : i.call(n)) ?? ((r = e.items) == null ? void 0 : r.map((s) => {
        var g, v;
        let {
          children: a,
          props: l,
          type: c,
          raw: d
        } = s;
        if (c === "divider")
          return ((g = n.divider) == null ? void 0 : g.call(n, {
            props: l
          })) ?? b(Kc, l, null);
        if (c === "subheader")
          return ((v = n.subheader) == null ? void 0 : v.call(n, {
            props: l
          })) ?? b(aM, l, null);
        const f = {
          subtitle: n.subtitle ? (p) => {
            var _;
            return (_ = n.subtitle) == null ? void 0 : _.call(n, {
              ...p,
              item: d
            });
          } : void 0,
          prepend: n.prepend ? (p) => {
            var _;
            return (_ = n.prepend) == null ? void 0 : _.call(n, {
              ...p,
              item: d
            });
          } : void 0,
          append: n.append ? (p) => {
            var _;
            return (_ = n.append) == null ? void 0 : _.call(n, {
              ...p,
              item: d
            });
          } : void 0,
          title: n.title ? (p) => {
            var _;
            return (_ = n.title) == null ? void 0 : _.call(n, {
              ...p,
              item: d
            });
          } : void 0
        }, m = rp.filterProps(l);
        return a ? b(rp, fe({
          value: l == null ? void 0 : l.value
        }, m), {
          activator: (p) => {
            let {
              props: _
            } = p;
            const x = {
              ...l,
              ..._,
              value: e.returnObject ? d : l.value
            };
            return n.header ? n.header({
              props: x
            }) : b(ts, x, f);
          },
          default: () => b(Rx, {
            items: a,
            returnObject: e.returnObject
          }, n)
        }) : n.item ? n.item({
          props: l
        }) : b(ts, fe(l, {
          value: e.returnObject ? d : l.value
        }), f);
      }));
    };
  }
}), Bx = ee({
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: [String, Array, Function],
    default: "title"
  },
  itemValue: {
    type: [String, Array, Function],
    default: "value"
  },
  itemChildren: {
    type: [Boolean, String, Array, Function],
    default: "children"
  },
  itemProps: {
    type: [Boolean, String, Array, Function],
    default: "props"
  },
  returnObject: Boolean,
  valueComparator: {
    type: Function,
    default: Sr
  }
}, "list-items");
function Ph(e, t) {
  const n = Fn(t, e.itemTitle, t), i = Fn(t, e.itemValue, n), r = Fn(t, e.itemChildren), s = e.itemProps === !0 ? typeof t == "object" && t != null && !Array.isArray(t) ? "children" in t ? Gi(t, ["children"]) : t : void 0 : Fn(t, e.itemProps), a = {
    title: n,
    value: i,
    ...s
  };
  return {
    title: String(a.title ?? ""),
    value: a.value,
    props: a,
    children: Array.isArray(r) ? Nx(e, r) : void 0,
    raw: t
  };
}
function Nx(e, t) {
  const n = [];
  for (const i of t)
    n.push(Ph(e, i));
  return n;
}
function lM(e) {
  const t = I(() => Nx(e, e.items)), n = I(() => t.value.some((s) => s.value === null));
  function i(s) {
    return n.value || (s = s.filter((a) => a !== null)), s.map((a) => e.returnObject && typeof a == "string" ? Ph(e, a) : t.value.find((l) => e.valueComparator(a, l.value)) || Ph(e, a));
  }
  function r(s) {
    return e.returnObject ? s.map((a) => {
      let {
        raw: l
      } = a;
      return l;
    }) : s.map((a) => {
      let {
        value: l
      } = a;
      return l;
    });
  }
  return {
    items: t,
    transformIn: i,
    transformOut: r
  };
}
function uM(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean";
}
function cM(e, t) {
  const n = Fn(t, e.itemType, "item"), i = uM(t) ? t : Fn(t, e.itemTitle), r = Fn(t, e.itemValue, void 0), s = Fn(t, e.itemChildren), a = e.itemProps === !0 ? Gi(t, ["children"]) : Fn(t, e.itemProps), l = {
    title: i,
    value: r,
    ...a
  };
  return {
    type: n,
    title: l.title,
    value: l.value,
    props: l,
    children: n === "item" && s ? $x(e, s) : void 0,
    raw: t
  };
}
function $x(e, t) {
  const n = [];
  for (const i of t)
    n.push(cM(e, i));
  return n;
}
function dM(e) {
  return {
    items: I(() => $x(e, e.items))
  };
}
const fM = ee({
  baseColor: String,
  /* @deprecated */
  activeColor: String,
  activeClass: String,
  bgColor: String,
  disabled: Boolean,
  expandIcon: He,
  collapseIcon: He,
  lines: {
    type: [Boolean, String],
    default: "one"
  },
  slim: Boolean,
  nav: Boolean,
  "onClick:open": cn(),
  "onClick:select": cn(),
  "onUpdate:opened": cn(),
  ...jA({
    selectStrategy: "single-leaf",
    openStrategy: "list"
  }),
  ...Ki(),
  ...Ae(),
  ...Qn(),
  ...Di(),
  ...Xi(),
  itemType: {
    type: String,
    default: "type"
  },
  ...Bx(),
  ...vn(),
  ...pt(),
  ...$t(),
  ...Ji({
    variant: "text"
  })
}, "VList"), Tm = pe()({
  name: "VList",
  props: fM(),
  emits: {
    "update:selected": (e) => !0,
    "update:activated": (e) => !0,
    "update:opened": (e) => !0,
    "click:open": (e) => !0,
    "click:activate": (e) => !0,
    "click:select": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      items: i
    } = dM(e), {
      themeClasses: r
    } = Zt(e), {
      backgroundColorClasses: s,
      backgroundColorStyles: a
    } = Bn(ce(e, "bgColor")), {
      borderClasses: l
    } = kr(e), {
      densityClasses: c
    } = Mi(e), {
      dimensionStyles: d
    } = Vi(e), {
      elevationClasses: f
    } = Cr(e), {
      roundedClasses: m
    } = Cn(e), {
      children: g,
      open: v,
      parents: p,
      select: _,
      getPath: x
    } = GA(e), S = I(() => e.lines ? `v-list--${e.lines}-line` : void 0), T = ce(e, "activeColor"), M = ce(e, "baseColor"), E = ce(e, "color");
    _x(), yi({
      VListGroup: {
        activeColor: T,
        baseColor: M,
        color: E,
        expandIcon: ce(e, "expandIcon"),
        collapseIcon: ce(e, "collapseIcon")
      },
      VListItem: {
        activeClass: ce(e, "activeClass"),
        activeColor: T,
        baseColor: M,
        color: E,
        density: ce(e, "density"),
        disabled: ce(e, "disabled"),
        lines: ce(e, "lines"),
        nav: ce(e, "nav"),
        slim: ce(e, "slim"),
        variant: ce(e, "variant")
      }
    });
    const D = Ie(!1), R = ue();
    function $(q) {
      D.value = !0;
    }
    function A(q) {
      D.value = !1;
    }
    function V(q) {
      var X;
      !D.value && !(q.relatedTarget && ((X = R.value) != null && X.contains(q.relatedTarget))) && N();
    }
    function H(q) {
      const X = q.target;
      if (!(!R.value || ["INPUT", "TEXTAREA"].includes(X.tagName))) {
        if (q.key === "ArrowDown")
          N("next");
        else if (q.key === "ArrowUp")
          N("prev");
        else if (q.key === "Home")
          N("first");
        else if (q.key === "End")
          N("last");
        else
          return;
        q.preventDefault();
      }
    }
    function B(q) {
      D.value = !0;
    }
    function N(q) {
      if (R.value)
        return Ko(R.value, q);
    }
    return ke(() => b(e.tag, {
      ref: R,
      class: ["v-list", {
        "v-list--disabled": e.disabled,
        "v-list--nav": e.nav,
        "v-list--slim": e.slim
      }, r.value, s.value, l.value, c.value, f.value, S.value, m.value, e.class],
      style: [a.value, d.value, e.style],
      tabindex: e.disabled || D.value ? -1 : 0,
      role: "listbox",
      "aria-activedescendant": void 0,
      onFocusin: $,
      onFocusout: A,
      onFocus: V,
      onKeydown: H,
      onMousedown: B
    }, {
      default: () => [b(Rx, {
        items: i.value,
        returnObject: e.returnObject
      }, n)]
    })), {
      open: v,
      select: _,
      focus: N,
      children: g,
      parents: p,
      getPath: x
    };
  }
});
function qf(e, t) {
  return {
    x: e.x + t.x,
    y: e.y + t.y
  };
}
function hM(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y
  };
}
function op(e, t) {
  if (e.side === "top" || e.side === "bottom") {
    const {
      side: n,
      align: i
    } = e, r = i === "left" ? 0 : i === "center" ? t.width / 2 : i === "right" ? t.width : i, s = n === "top" ? 0 : n === "bottom" ? t.height : n;
    return qf({
      x: r,
      y: s
    }, t);
  } else if (e.side === "left" || e.side === "right") {
    const {
      side: n,
      align: i
    } = e, r = n === "left" ? 0 : n === "right" ? t.width : n, s = i === "top" ? 0 : i === "center" ? t.height / 2 : i === "bottom" ? t.height : i;
    return qf({
      x: r,
      y: s
    }, t);
  }
  return qf({
    x: t.width / 2,
    y: t.height / 2
  }, t);
}
const zx = {
  static: vM,
  // specific viewport position, usually centered
  connected: pM
  // connected to a certain element
}, mM = ee({
  locationStrategy: {
    type: [String, Function],
    default: "static",
    validator: (e) => typeof e == "function" || e in zx
  },
  location: {
    type: String,
    default: "bottom"
  },
  origin: {
    type: String,
    default: "auto"
  },
  offset: [Number, String, Array]
}, "VOverlay-location-strategies");
function gM(e, t) {
  const n = ue({}), i = ue();
  Bt && _r(() => !!(t.isActive.value && e.locationStrategy), (s) => {
    var a, l;
    Se(() => e.locationStrategy, s), gn(() => {
      window.removeEventListener("resize", r), i.value = void 0;
    }), window.addEventListener("resize", r, {
      passive: !0
    }), typeof e.locationStrategy == "function" ? i.value = (a = e.locationStrategy(t, e, n)) == null ? void 0 : a.updateLocation : i.value = (l = zx[e.locationStrategy](t, e, n)) == null ? void 0 : l.updateLocation;
  });
  function r(s) {
    var a;
    (a = i.value) == null || a.call(i, s);
  }
  return {
    contentStyles: n,
    updateLocation: i
  };
}
function vM() {
}
function yM(e, t) {
  const n = mm(e);
  return t ? n.x += parseFloat(e.style.right || 0) : n.x -= parseFloat(e.style.left || 0), n.y -= parseFloat(e.style.top || 0), n;
}
function pM(e, t, n) {
  (Array.isArray(e.target.value) || XE(e.target.value)) && Object.assign(n.value, {
    position: "fixed",
    top: 0,
    [e.isRtl.value ? "right" : "left"]: 0
  });
  const {
    preferredAnchor: r,
    preferredOrigin: s
  } = fm(() => {
    const p = wh(t.location, e.isRtl.value), _ = t.origin === "overlap" ? p : t.origin === "auto" ? Hf(p) : wh(t.origin, e.isRtl.value);
    return p.side === _.side && p.align === Wf(_).align ? {
      preferredAnchor: Ly(p),
      preferredOrigin: Ly(_)
    } : {
      preferredAnchor: p,
      preferredOrigin: _
    };
  }), [a, l, c, d] = ["minWidth", "minHeight", "maxWidth", "maxHeight"].map((p) => I(() => {
    const _ = parseFloat(t[p]);
    return isNaN(_) ? 1 / 0 : _;
  })), f = I(() => {
    if (Array.isArray(t.offset))
      return t.offset;
    if (typeof t.offset == "string") {
      const p = t.offset.split(" ").map(parseFloat);
      return p.length < 2 && p.push(0), p;
    }
    return typeof t.offset == "number" ? [t.offset, 0] : [0, 0];
  });
  let m = !1;
  const g = new ResizeObserver(() => {
    m && v();
  });
  Se([e.target, e.contentEl], (p, _) => {
    let [x, S] = p, [T, M] = _;
    T && !Array.isArray(T) && g.unobserve(T), x && !Array.isArray(x) && g.observe(x), M && g.unobserve(M), S && g.observe(S);
  }, {
    immediate: !0
  }), gn(() => {
    g.disconnect();
  });
  function v() {
    if (m = !1, requestAnimationFrame(() => m = !0), !e.target.value || !e.contentEl.value)
      return;
    const p = q0(e.target.value), _ = yM(e.contentEl.value, e.isRtl.value), x = kc(e.contentEl.value), S = 12;
    x.length || (x.push(document.documentElement), e.contentEl.value.style.top && e.contentEl.value.style.left || (_.x -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-x") || 0), _.y -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-y") || 0)));
    const T = x.reduce((B, N) => {
      const q = N.getBoundingClientRect(), X = new Rs({
        x: N === document.documentElement ? 0 : q.x,
        y: N === document.documentElement ? 0 : q.y,
        width: N.clientWidth,
        height: N.clientHeight
      });
      return B ? new Rs({
        x: Math.max(B.left, X.left),
        y: Math.max(B.top, X.top),
        width: Math.min(B.right, X.right) - Math.max(B.left, X.left),
        height: Math.min(B.bottom, X.bottom) - Math.max(B.top, X.top)
      }) : X;
    }, void 0);
    T.x += S, T.y += S, T.width -= S * 2, T.height -= S * 2;
    let M = {
      anchor: r.value,
      origin: s.value
    };
    function E(B) {
      const N = new Rs(_), q = op(B.anchor, p), X = op(B.origin, N);
      let {
        x: se,
        y: de
      } = hM(q, X);
      switch (B.anchor.side) {
        case "top":
          de -= f.value[0];
          break;
        case "bottom":
          de += f.value[0];
          break;
        case "left":
          se -= f.value[0];
          break;
        case "right":
          se += f.value[0];
          break;
      }
      switch (B.anchor.align) {
        case "top":
          de -= f.value[1];
          break;
        case "bottom":
          de += f.value[1];
          break;
        case "left":
          se -= f.value[1];
          break;
        case "right":
          se += f.value[1];
          break;
      }
      return N.x += se, N.y += de, N.width = Math.min(N.width, c.value), N.height = Math.min(N.height, d.value), {
        overflows: Ry(N, T),
        x: se,
        y: de
      };
    }
    let D = 0, R = 0;
    const $ = {
      x: 0,
      y: 0
    }, A = {
      x: !1,
      y: !1
    };
    let V = -1;
    for (; ; ) {
      if (V++ > 10) {
        gm("Infinite loop detected in connectedLocationStrategy");
        break;
      }
      const {
        x: B,
        y: N,
        overflows: q
      } = E(M);
      D += B, R += N, _.x += B, _.y += N;
      {
        const X = Fy(M.anchor), se = q.x.before || q.x.after, de = q.y.before || q.y.after;
        let _e = !1;
        if (["x", "y"].forEach((be) => {
          if (be === "x" && se && !A.x || be === "y" && de && !A.y) {
            const oe = {
              anchor: {
                ...M.anchor
              },
              origin: {
                ...M.origin
              }
            }, J = be === "x" ? X === "y" ? Wf : Hf : X === "y" ? Hf : Wf;
            oe.anchor = J(oe.anchor), oe.origin = J(oe.origin);
            const {
              overflows: G
            } = E(oe);
            (G[be].before <= q[be].before && G[be].after <= q[be].after || G[be].before + G[be].after < (q[be].before + q[be].after) / 2) && (M = oe, _e = A[be] = !0);
          }
        }), _e)
          continue;
      }
      q.x.before && (D += q.x.before, _.x += q.x.before), q.x.after && (D -= q.x.after, _.x -= q.x.after), q.y.before && (R += q.y.before, _.y += q.y.before), q.y.after && (R -= q.y.after, _.y -= q.y.after);
      {
        const X = Ry(_, T);
        $.x = T.width - X.x.before - X.x.after, $.y = T.height - X.y.before - X.y.after, D += X.x.before, _.x += X.x.before, R += X.y.before, _.y += X.y.before;
      }
      break;
    }
    const H = Fy(M.anchor);
    return Object.assign(n.value, {
      "--v-overlay-anchor-origin": `${M.anchor.side} ${M.anchor.align}`,
      transformOrigin: `${M.origin.side} ${M.origin.align}`,
      // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
      top: Ce(jf(R)),
      left: e.isRtl.value ? void 0 : Ce(jf(D)),
      right: e.isRtl.value ? Ce(jf(-D)) : void 0,
      minWidth: Ce(H === "y" ? Math.min(a.value, p.width) : a.value),
      maxWidth: Ce(lp(Jt($.x, a.value === 1 / 0 ? 0 : a.value, c.value))),
      maxHeight: Ce(lp(Jt($.y, l.value === 1 / 0 ? 0 : l.value, d.value)))
    }), {
      available: $,
      contentBox: _
    };
  }
  return Se(() => [r.value, s.value, t.offset, t.minWidth, t.minHeight, t.maxWidth, t.maxHeight], () => v()), Ct(() => {
    const p = v();
    if (!p)
      return;
    const {
      available: _,
      contentBox: x
    } = p;
    x.height > _.y && requestAnimationFrame(() => {
      v(), requestAnimationFrame(() => {
        v();
      });
    });
  }), {
    updateLocation: v
  };
}
function jf(e) {
  return Math.round(e * devicePixelRatio) / devicePixelRatio;
}
function lp(e) {
  return Math.ceil(e * devicePixelRatio) / devicePixelRatio;
}
let Oh = !0;
const Tc = [];
function bM(e) {
  !Oh || Tc.length ? (Tc.push(e), Eh()) : (Oh = !1, e(), Eh());
}
let up = -1;
function Eh() {
  cancelAnimationFrame(up), up = requestAnimationFrame(() => {
    const e = Tc.shift();
    e && e(), Tc.length ? Eh() : Oh = !0;
  });
}
const hc = {
  none: null,
  close: wM,
  block: SM,
  reposition: kM
}, xM = ee({
  scrollStrategy: {
    type: [String, Function],
    default: "block",
    validator: (e) => typeof e == "function" || e in hc
  }
}, "VOverlay-scroll-strategies");
function _M(e, t) {
  if (!Bt)
    return;
  let n;
  Xn(async () => {
    n == null || n.stop(), t.isActive.value && e.scrollStrategy && (n = om(), await new Promise((i) => setTimeout(i)), n.active && n.run(() => {
      var i;
      typeof e.scrollStrategy == "function" ? e.scrollStrategy(t, e, n) : (i = hc[e.scrollStrategy]) == null || i.call(hc, t, e, n);
    }));
  }), gn(() => {
    n == null || n.stop();
  });
}
function wM(e) {
  function t(n) {
    e.isActive.value = !1;
  }
  Hx(e.targetEl.value ?? e.contentEl.value, t);
}
function SM(e, t) {
  var a;
  const n = (a = e.root.value) == null ? void 0 : a.offsetParent, i = [.../* @__PURE__ */ new Set([...kc(e.targetEl.value, t.contained ? n : void 0), ...kc(e.contentEl.value, t.contained ? n : void 0)])].filter((l) => !l.classList.contains("v-overlay-scroll-blocked")), r = window.innerWidth - document.documentElement.offsetWidth, s = ((l) => bm(l) && l)(n || document.documentElement);
  s && e.root.value.classList.add("v-overlay--scroll-blocked"), i.forEach((l, c) => {
    l.style.setProperty("--v-body-scroll-x", Ce(-l.scrollLeft)), l.style.setProperty("--v-body-scroll-y", Ce(-l.scrollTop)), l !== document.documentElement && l.style.setProperty("--v-scrollbar-offset", Ce(r)), l.classList.add("v-overlay-scroll-blocked");
  }), gn(() => {
    i.forEach((l, c) => {
      const d = parseFloat(l.style.getPropertyValue("--v-body-scroll-x")), f = parseFloat(l.style.getPropertyValue("--v-body-scroll-y")), m = l.style.scrollBehavior;
      l.style.scrollBehavior = "auto", l.style.removeProperty("--v-body-scroll-x"), l.style.removeProperty("--v-body-scroll-y"), l.style.removeProperty("--v-scrollbar-offset"), l.classList.remove("v-overlay-scroll-blocked"), l.scrollLeft = -d, l.scrollTop = -f, l.style.scrollBehavior = m;
    }), s && e.root.value.classList.remove("v-overlay--scroll-blocked");
  });
}
function kM(e, t, n) {
  let i = !1, r = -1, s = -1;
  function a(l) {
    bM(() => {
      var f, m;
      const c = performance.now();
      (m = (f = e.updateLocation).value) == null || m.call(f, l), i = (performance.now() - c) / (1e3 / 60) > 2;
    });
  }
  s = (typeof requestIdleCallback > "u" ? (l) => l() : requestIdleCallback)(() => {
    n.run(() => {
      Hx(e.targetEl.value ?? e.contentEl.value, (l) => {
        i ? (cancelAnimationFrame(r), r = requestAnimationFrame(() => {
          r = requestAnimationFrame(() => {
            a(l);
          });
        })) : a(l);
      });
    });
  }), gn(() => {
    typeof cancelIdleCallback < "u" && cancelIdleCallback(s), cancelAnimationFrame(r);
  });
}
function Hx(e, t) {
  const n = [document, ...kc(e)];
  n.forEach((i) => {
    i.addEventListener("scroll", t, {
      passive: !0
    });
  }), gn(() => {
    n.forEach((i) => {
      i.removeEventListener("scroll", t);
    });
  });
}
const Ah = Symbol.for("vuetify:v-menu"), CM = ee({
  closeDelay: [Number, String],
  openDelay: [Number, String]
}, "delay");
function TM(e, t) {
  let n = () => {
  };
  function i(a) {
    n == null || n();
    const l = Number(a ? e.openDelay : e.closeDelay);
    return new Promise((c) => {
      n = _E(l, () => {
        t == null || t(a), c(a);
      });
    });
  }
  function r() {
    return i(!0);
  }
  function s() {
    return i(!1);
  }
  return {
    clearDelay: n,
    runOpenDelay: r,
    runCloseDelay: s
  };
}
const IM = ee({
  target: [String, Object],
  activator: [String, Object],
  activatorProps: {
    type: Object,
    default: () => ({})
  },
  openOnClick: {
    type: Boolean,
    default: void 0
  },
  openOnHover: Boolean,
  openOnFocus: {
    type: Boolean,
    default: void 0
  },
  closeOnContentClick: Boolean,
  ...CM()
}, "VOverlay-activator");
function PM(e, t) {
  let {
    isActive: n,
    isTop: i,
    contentEl: r
  } = t;
  const s = Nt("useActivator"), a = ue();
  let l = !1, c = !1, d = !0;
  const f = I(() => e.openOnFocus || e.openOnFocus == null && e.openOnHover), m = I(() => e.openOnClick || e.openOnClick == null && !e.openOnHover && !f.value), {
    runOpenDelay: g,
    runCloseDelay: v
  } = TM(e, (A) => {
    A === (e.openOnHover && l || f.value && c) && !(e.openOnHover && n.value && !i.value) && (n.value !== A && (d = !0), n.value = A);
  }), p = ue(), _ = {
    onClick: (A) => {
      A.stopPropagation(), a.value = A.currentTarget || A.target, n.value || (p.value = [A.clientX, A.clientY]), n.value = !n.value;
    },
    onMouseenter: (A) => {
      var V;
      (V = A.sourceCapabilities) != null && V.firesTouchEvents || (l = !0, a.value = A.currentTarget || A.target, g());
    },
    onMouseleave: (A) => {
      l = !1, v();
    },
    onFocus: (A) => {
      _c(A.target, ":focus-visible") !== !1 && (c = !0, A.stopPropagation(), a.value = A.currentTarget || A.target, g());
    },
    onBlur: (A) => {
      c = !1, A.stopPropagation(), v();
    }
  }, x = I(() => {
    const A = {};
    return m.value && (A.onClick = _.onClick), e.openOnHover && (A.onMouseenter = _.onMouseenter, A.onMouseleave = _.onMouseleave), f.value && (A.onFocus = _.onFocus, A.onBlur = _.onBlur), A;
  }), S = I(() => {
    const A = {};
    if (e.openOnHover && (A.onMouseenter = () => {
      l = !0, g();
    }, A.onMouseleave = () => {
      l = !1, v();
    }), f.value && (A.onFocusin = () => {
      c = !0, g();
    }, A.onFocusout = () => {
      c = !1, v();
    }), e.closeOnContentClick) {
      const V = gt(Ah, null);
      A.onClick = () => {
        n.value = !1, V == null || V.closeParents();
      };
    }
    return A;
  }), T = I(() => {
    const A = {};
    return e.openOnHover && (A.onMouseenter = () => {
      d && (l = !0, d = !1, g());
    }, A.onMouseleave = () => {
      l = !1, v();
    }), A;
  });
  Se(i, (A) => {
    var V;
    A && (e.openOnHover && !l && (!f.value || !c) || f.value && !c && (!e.openOnHover || !l)) && !((V = r.value) != null && V.contains(document.activeElement)) && (n.value = !1);
  }), Se(n, (A) => {
    A || setTimeout(() => {
      p.value = void 0;
    });
  }, {
    flush: "post"
  });
  const M = _h();
  Xn(() => {
    M.value && Ct(() => {
      a.value = M.el;
    });
  });
  const E = _h(), D = I(() => e.target === "cursor" && p.value ? p.value : E.value ? E.el : Wx(e.target, s) || a.value), R = I(() => Array.isArray(D.value) ? void 0 : D.value);
  let $;
  return Se(() => !!e.activator, (A) => {
    A && Bt ? ($ = om(), $.run(() => {
      OM(e, s, {
        activatorEl: a,
        activatorEvents: x
      });
    })) : $ && $.stop();
  }, {
    flush: "post",
    immediate: !0
  }), gn(() => {
    $ == null || $.stop();
  }), {
    activatorEl: a,
    activatorRef: M,
    target: D,
    targetEl: R,
    targetRef: E,
    activatorEvents: x,
    contentEvents: S,
    scrimEvents: T
  };
}
function OM(e, t, n) {
  let {
    activatorEl: i,
    activatorEvents: r
  } = n;
  Se(() => e.activator, (c, d) => {
    if (d && c !== d) {
      const f = l(d);
      f && a(f);
    }
    c && Ct(() => s());
  }, {
    immediate: !0
  }), Se(() => e.activatorProps, () => {
    s();
  }), gn(() => {
    a();
  });
  function s() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : l(), d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    c && kE(c, fe(r.value, d));
  }
  function a() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : l(), d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    c && CE(c, fe(r.value, d));
  }
  function l() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e.activator;
    const d = Wx(c, t);
    return i.value = (d == null ? void 0 : d.nodeType) === Node.ELEMENT_NODE ? d : void 0, i.value;
  }
}
function Wx(e, t) {
  var i, r;
  if (!e)
    return;
  let n;
  if (e === "parent") {
    let s = (r = (i = t == null ? void 0 : t.proxy) == null ? void 0 : i.$el) == null ? void 0 : r.parentNode;
    for (; s != null && s.hasAttribute("data-no-activator"); )
      s = s.parentNode;
    n = s;
  } else
    typeof e == "string" ? n = document.querySelector(e) : "$el" in e ? n = e.$el : n = e;
  return n;
}
function EM() {
  if (!Bt)
    return Ie(!1);
  const {
    ssr: e
  } = js();
  if (e) {
    const t = Ie(!1);
    return Jn(() => {
      t.value = !0;
    }), t;
  } else
    return Ie(!0);
}
const AM = ee({
  eager: Boolean
}, "lazy");
function MM(e, t) {
  const n = Ie(!1), i = I(() => n.value || e.eager || t.value);
  Se(t, () => n.value = !0);
  function r() {
    e.eager || (n.value = !1);
  }
  return {
    isBooted: n,
    hasContent: i,
    onAfterLeave: r
  };
}
function Il() {
  const t = Nt("useScopeId").vnode.scopeId;
  return {
    scopeId: t ? {
      [t]: ""
    } : void 0
  };
}
const cp = Symbol.for("vuetify:stack"), Do = Ma([]);
function DM(e, t, n) {
  const i = Nt("useStack"), r = !n, s = gt(cp, void 0), a = Ma({
    activeChildren: /* @__PURE__ */ new Set()
  });
  jt(cp, a);
  const l = Ie(+t.value);
  _r(e, () => {
    var m;
    const f = (m = Do.at(-1)) == null ? void 0 : m[1];
    l.value = f ? f + 10 : +t.value, r && Do.push([i.uid, l.value]), s == null || s.activeChildren.add(i.uid), gn(() => {
      if (r) {
        const g = Pt(Do).findIndex((v) => v[0] === i.uid);
        Do.splice(g, 1);
      }
      s == null || s.activeChildren.delete(i.uid);
    });
  });
  const c = Ie(!0);
  r && Xn(() => {
    var m;
    const f = ((m = Do.at(-1)) == null ? void 0 : m[0]) === i.uid;
    setTimeout(() => c.value = f);
  });
  const d = I(() => !a.activeChildren.size);
  return {
    globalTop: jc(c),
    localTop: d,
    stackStyles: I(() => ({
      zIndex: l.value
    }))
  };
}
function VM(e) {
  return {
    teleportTarget: I(() => {
      const n = e();
      if (n === !0 || !Bt)
        return;
      const i = n === !1 ? document.body : typeof n == "string" ? document.querySelector(n) : n;
      if (i == null) {
        qc(`Unable to locate target ${n}`);
        return;
      }
      let r = [...i.children].find((s) => s.matches(".v-overlay-container"));
      return r || (r = document.createElement("div"), r.className = "v-overlay-container", i.appendChild(r)), r;
    })
  };
}
function LM() {
  return !0;
}
function Ux(e, t, n) {
  if (!e || qx(e, n) === !1)
    return !1;
  const i = J0(t);
  if (typeof ShadowRoot < "u" && i instanceof ShadowRoot && i.host === e.target)
    return !1;
  const r = (typeof n.value == "object" && n.value.include || (() => []))();
  return r.push(t), !r.some((s) => s == null ? void 0 : s.contains(e.target));
}
function qx(e, t) {
  return (typeof t.value == "object" && t.value.closeConditional || LM)(e);
}
function FM(e, t, n) {
  const i = typeof n.value == "function" ? n.value : n.value.handler;
  e.shadowTarget = e.target, t._clickOutside.lastMousedownWasOutside && Ux(e, t, n) && setTimeout(() => {
    qx(e, n) && i && i(e);
  }, 0);
}
function dp(e, t) {
  const n = J0(e);
  t(document), typeof ShadowRoot < "u" && n instanceof ShadowRoot && t(n);
}
const RM = {
  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  mounted(e, t) {
    const n = (r) => FM(r, e, t), i = (r) => {
      e._clickOutside.lastMousedownWasOutside = Ux(r, e, t);
    };
    dp(e, (r) => {
      r.addEventListener("click", n, !0), r.addEventListener("mousedown", i, !0);
    }), e._clickOutside || (e._clickOutside = {
      lastMousedownWasOutside: !1
    }), e._clickOutside[t.instance.$.uid] = {
      onClick: n,
      onMousedown: i
    };
  },
  beforeUnmount(e, t) {
    e._clickOutside && (dp(e, (n) => {
      var s;
      if (!n || !((s = e._clickOutside) != null && s[t.instance.$.uid]))
        return;
      const {
        onClick: i,
        onMousedown: r
      } = e._clickOutside[t.instance.$.uid];
      n.removeEventListener("click", i, !0), n.removeEventListener("mousedown", r, !0);
    }), delete e._clickOutside[t.instance.$.uid]);
  }
};
function BM(e) {
  const {
    modelValue: t,
    color: n,
    ...i
  } = e;
  return b(Hs, {
    name: "fade-transition",
    appear: !0
  }, {
    default: () => [e.modelValue && b("div", fe({
      class: ["v-overlay__scrim", e.color.backgroundColorClasses.value],
      style: e.color.backgroundColorStyles.value
    }, i), null)]
  });
}
const Pl = ee({
  absolute: Boolean,
  attach: [Boolean, String, Object],
  closeOnBack: {
    type: Boolean,
    default: !0
  },
  contained: Boolean,
  contentClass: null,
  contentProps: null,
  disabled: Boolean,
  opacity: [Number, String],
  noClickAnimation: Boolean,
  modelValue: Boolean,
  persistent: Boolean,
  scrim: {
    type: [Boolean, String],
    default: !0
  },
  zIndex: {
    type: [Number, String],
    default: 2e3
  },
  ...IM(),
  ...Ae(),
  ...Di(),
  ...AM(),
  ...mM(),
  ...xM(),
  ...$t(),
  ...Wa()
}, "VOverlay"), ns = pe()({
  name: "VOverlay",
  directives: {
    ClickOutside: RM
  },
  inheritAttrs: !1,
  props: {
    _disableGlobalStack: Boolean,
    ...Pl()
  },
  emits: {
    "click:outside": (e) => !0,
    "update:modelValue": (e) => !0,
    afterEnter: () => !0,
    afterLeave: () => !0
  },
  setup(e, t) {
    let {
      slots: n,
      attrs: i,
      emit: r
    } = t;
    const s = Nt("VOverlay"), a = ue(), l = ue(), c = ue(), d = at(e, "modelValue"), f = I({
      get: () => d.value,
      set: (Q) => {
        Q && e.disabled || (d.value = Q);
      }
    }), {
      themeClasses: m
    } = Zt(e), {
      rtlClasses: g,
      isRtl: v
    } = Tn(), {
      hasContent: p,
      onAfterLeave: _
    } = MM(e, f), x = Bn(I(() => typeof e.scrim == "string" ? e.scrim : null)), {
      globalTop: S,
      localTop: T,
      stackStyles: M
    } = DM(f, ce(e, "zIndex"), e._disableGlobalStack), {
      activatorEl: E,
      activatorRef: D,
      target: R,
      targetEl: $,
      targetRef: A,
      activatorEvents: V,
      contentEvents: H,
      scrimEvents: B
    } = PM(e, {
      isActive: f,
      isTop: T,
      contentEl: c
    }), {
      teleportTarget: N
    } = VM(() => {
      var Ze, We, Ue;
      const Q = e.attach || e.contained;
      if (Q)
        return Q;
      const me = ((Ze = E == null ? void 0 : E.value) == null ? void 0 : Ze.getRootNode()) || ((Ue = (We = s.proxy) == null ? void 0 : We.$el) == null ? void 0 : Ue.getRootNode());
      return me instanceof ShadowRoot ? me : !1;
    }), {
      dimensionStyles: q
    } = Vi(e), X = EM(), {
      scopeId: se
    } = Il();
    Se(() => e.disabled, (Q) => {
      Q && (f.value = !1);
    });
    const {
      contentStyles: de,
      updateLocation: _e
    } = gM(e, {
      isRtl: v,
      contentEl: c,
      target: R,
      isActive: f
    });
    _M(e, {
      root: a,
      contentEl: c,
      targetEl: $,
      isActive: f,
      updateLocation: _e
    });
    function be(Q) {
      r("click:outside", Q), e.persistent ? ge() : f.value = !1;
    }
    function oe(Q) {
      return f.value && S.value && // If using scrim, only close if clicking on it rather than anything opened on top
      (!e.scrim || Q.target === l.value || Q instanceof MouseEvent && Q.shadowTarget === l.value);
    }
    Bt && Se(f, (Q) => {
      Q ? window.addEventListener("keydown", J) : window.removeEventListener("keydown", J);
    }, {
      immediate: !0
    }), kn(() => {
      Bt && window.removeEventListener("keydown", J);
    });
    function J(Q) {
      var me, Ze;
      Q.key === "Escape" && S.value && (e.persistent ? ge() : (f.value = !1, (me = c.value) != null && me.contains(document.activeElement) && ((Ze = E.value) == null || Ze.focus())));
    }
    const G = tA();
    _r(() => e.closeOnBack, () => {
      nA(G, (Q) => {
        S.value && f.value ? (Q(!1), e.persistent ? ge() : f.value = !1) : Q();
      });
    });
    const ie = ue();
    Se(() => f.value && (e.absolute || e.contained) && N.value == null, (Q) => {
      if (Q) {
        const me = Q0(a.value);
        me && me !== document.scrollingElement && (ie.value = me.scrollTop);
      }
    });
    function ge() {
      e.noClickAnimation || c.value && Ca(c.value, [{
        transformOrigin: "center"
      }, {
        transform: "scale(1.03)"
      }, {
        transformOrigin: "center"
      }], {
        duration: 150,
        easing: Sc
      });
    }
    function he() {
      r("afterEnter");
    }
    function Oe() {
      _(), r("afterLeave");
    }
    return ke(() => {
      var Q;
      return b(Le, null, [(Q = n.activator) == null ? void 0 : Q.call(n, {
        isActive: f.value,
        targetRef: A,
        props: fe({
          ref: D
        }, V.value, e.activatorProps)
      }), X.value && p.value && b(nE, {
        disabled: !N.value,
        to: N.value
      }, {
        default: () => [b("div", fe({
          class: ["v-overlay", {
            "v-overlay--absolute": e.absolute || e.contained,
            "v-overlay--active": f.value,
            "v-overlay--contained": e.contained
          }, m.value, g.value, e.class],
          style: [M.value, {
            "--v-overlay-opacity": e.opacity,
            top: Ce(ie.value)
          }, e.style],
          ref: a
        }, se, i), [b(BM, fe({
          color: x,
          modelValue: f.value && !!e.scrim,
          ref: l
        }, B.value), null), b(pr, {
          appear: !0,
          persisted: !0,
          transition: e.transition,
          target: R.value,
          onAfterEnter: he,
          onAfterLeave: Oe
        }, {
          default: () => {
            var me;
            return [rn(b("div", fe({
              ref: c,
              class: ["v-overlay__content", e.contentClass],
              style: [q.value, de.value]
            }, H.value, e.contentProps), [(me = n.default) == null ? void 0 : me.call(n, {
              isActive: f
            })]), [[qs, f.value], [ji("click-outside"), {
              handler: be,
              closeConditional: oe,
              include: () => [E.value]
            }]])];
          }
        })])]
      })]);
    }), {
      activatorEl: E,
      scrimEl: l,
      target: R,
      animateClick: ge,
      contentEl: c,
      globalTop: S,
      localTop: T,
      updateLocation: _e
    };
  }
}), Gf = Symbol("Forwarded refs");
function Yf(e, t) {
  let n = e;
  for (; n; ) {
    const i = Reflect.getOwnPropertyDescriptor(n, t);
    if (i)
      return i;
    n = Object.getPrototypeOf(n);
  }
}
function ls(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  return e[Gf] = n, new Proxy(e, {
    get(r, s) {
      if (Reflect.has(r, s))
        return Reflect.get(r, s);
      if (!(typeof s == "symbol" || s.startsWith("$") || s.startsWith("__"))) {
        for (const a of n)
          if (a.value && Reflect.has(a.value, s)) {
            const l = Reflect.get(a.value, s);
            return typeof l == "function" ? l.bind(a.value) : l;
          }
      }
    },
    has(r, s) {
      if (Reflect.has(r, s))
        return !0;
      if (typeof s == "symbol" || s.startsWith("$") || s.startsWith("__"))
        return !1;
      for (const a of n)
        if (a.value && Reflect.has(a.value, s))
          return !0;
      return !1;
    },
    set(r, s, a) {
      if (Reflect.has(r, s))
        return Reflect.set(r, s, a);
      if (typeof s == "symbol" || s.startsWith("$") || s.startsWith("__"))
        return !1;
      for (const l of n)
        if (l.value && Reflect.has(l.value, s))
          return Reflect.set(l.value, s, a);
      return !1;
    },
    getOwnPropertyDescriptor(r, s) {
      var l;
      const a = Reflect.getOwnPropertyDescriptor(r, s);
      if (a)
        return a;
      if (!(typeof s == "symbol" || s.startsWith("$") || s.startsWith("__"))) {
        for (const c of n) {
          if (!c.value)
            continue;
          const d = Yf(c.value, s) ?? ("_" in c.value ? Yf((l = c.value._) == null ? void 0 : l.setupState, s) : void 0);
          if (d)
            return d;
        }
        for (const c of n) {
          const d = c.value && c.value[Gf];
          if (!d)
            continue;
          const f = d.slice();
          for (; f.length; ) {
            const m = f.shift(), g = Yf(m.value, s);
            if (g)
              return g;
            const v = m.value && m.value[Gf];
            v && f.push(...v);
          }
        }
      }
    }
  });
}
const NM = ee({
  // TODO
  // disableKeys: Boolean,
  id: String,
  submenu: Boolean,
  ...Gi(Pl({
    closeDelay: 250,
    closeOnContentClick: !0,
    locationStrategy: "connected",
    location: void 0,
    openDelay: 300,
    scrim: !1,
    scrollStrategy: "reposition",
    transition: {
      component: Sm
    }
  }), ["absolute"])
}, "VMenu"), td = pe()({
  name: "VMenu",
  props: NM(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = at(e, "modelValue"), {
      scopeId: r
    } = Il(), {
      isRtl: s
    } = Tn(), a = pi(), l = I(() => e.id || `v-menu-${a}`), c = ue(), d = gt(Ah, null), f = Ie(/* @__PURE__ */ new Set());
    jt(Ah, {
      register() {
        f.value.add(a);
      },
      unregister() {
        f.value.delete(a);
      },
      closeParents(x) {
        setTimeout(() => {
          var S;
          !f.value.size && !e.persistent && (x == null || (S = c.value) != null && S.contentEl && !wE(x, c.value.contentEl)) && (i.value = !1, d == null || d.closeParents());
        }, 40);
      }
    }), kn(() => {
      d == null || d.unregister(), document.removeEventListener("focusin", m);
    }), M0(() => i.value = !1);
    async function m(x) {
      var M, E, D;
      const S = x.relatedTarget, T = x.target;
      await Ct(), i.value && S !== T && ((M = c.value) != null && M.contentEl) && // We're the topmost menu
      ((E = c.value) != null && E.globalTop) && // It isn't the document or the menu body
      ![document, c.value.contentEl].includes(T) && // It isn't inside the menu body
      !c.value.contentEl.contains(T) && ((D = sl(c.value.contentEl)[0]) == null || D.focus());
    }
    Se(i, (x) => {
      x ? (d == null || d.register(), Bt && document.addEventListener("focusin", m, {
        once: !0
      })) : (d == null || d.unregister(), Bt && document.removeEventListener("focusin", m));
    }, {
      immediate: !0
    });
    function g(x) {
      d == null || d.closeParents(x);
    }
    function v(x) {
      var S, T, M, E, D;
      if (!e.disabled)
        if (x.key === "Tab" || x.key === "Enter" && !e.closeOnContentClick) {
          if (x.key === "Enter" && (x.target instanceof HTMLTextAreaElement || x.target instanceof HTMLInputElement && x.target.closest("form")))
            return;
          x.key === "Enter" && x.preventDefault(), H0(sl((S = c.value) == null ? void 0 : S.contentEl, !1), x.shiftKey ? "prev" : "next", ($) => $.tabIndex >= 0) || (i.value = !1, (M = (T = c.value) == null ? void 0 : T.activatorEl) == null || M.focus());
        } else
          e.submenu && x.key === (s.value ? "ArrowRight" : "ArrowLeft") && (i.value = !1, (D = (E = c.value) == null ? void 0 : E.activatorEl) == null || D.focus());
    }
    function p(x) {
      var T;
      if (e.disabled)
        return;
      const S = (T = c.value) == null ? void 0 : T.contentEl;
      S && i.value ? x.key === "ArrowDown" ? (x.preventDefault(), x.stopImmediatePropagation(), Ko(S, "next")) : x.key === "ArrowUp" ? (x.preventDefault(), x.stopImmediatePropagation(), Ko(S, "prev")) : e.submenu && (x.key === (s.value ? "ArrowRight" : "ArrowLeft") ? i.value = !1 : x.key === (s.value ? "ArrowLeft" : "ArrowRight") && (x.preventDefault(), Ko(S, "first"))) : (e.submenu ? x.key === (s.value ? "ArrowLeft" : "ArrowRight") : ["ArrowDown", "ArrowUp"].includes(x.key)) && (i.value = !0, x.preventDefault(), setTimeout(() => setTimeout(() => p(x))));
    }
    const _ = I(() => fe({
      "aria-haspopup": "menu",
      "aria-expanded": String(i.value),
      "aria-controls": l.value,
      onKeydown: p
    }, e.activatorProps));
    return ke(() => {
      const x = ns.filterProps(e);
      return b(ns, fe({
        ref: c,
        id: l.value,
        class: ["v-menu", e.class],
        style: e.style
      }, x, {
        modelValue: i.value,
        "onUpdate:modelValue": (S) => i.value = S,
        absolute: !0,
        activatorProps: _.value,
        location: e.location ?? (e.submenu ? "end" : "bottom"),
        "onClick:outside": g,
        onKeydown: v
      }, r), {
        activator: n.activator,
        default: function() {
          for (var S = arguments.length, T = new Array(S), M = 0; M < S; M++)
            T[M] = arguments[M];
          return b(Mt, {
            root: "VMenu"
          }, {
            default: () => {
              var E;
              return [(E = n.default) == null ? void 0 : E.call(n, ...T)];
            }
          });
        }
      });
    }), ls({
      id: l,
      ΨopenChildren: f
    }, c);
  }
}), $M = (e) => (iE("data-v-e0fd5283"), e = e(), rE(), e), zM = { class: "d-flex ga-4" }, HM = { class: "text-medium-emphasis" }, WM = { class: "d-flex ga-4" }, UM = /* @__PURE__ */ $M(() => /* @__PURE__ */ St("div", { class: "text-medium-emphasis" }, "Log out", -1)), qM = /* @__PURE__ */ Je({
  __name: "RHDHVHeaderMenu",
  props: {
    user: {},
    color: {},
    textColor: {}
  },
  emits: ["logout"],
  setup(e, { emit: t }) {
    const n = e, i = ["#00AA55", "#009FD4", "#B381B3", "#939393", "#E3BC00", "#D47500", "#DC2A2A"], r = (c) => n.color ? n.color : c ? i[s(c) % i.length] : i[0], s = (c) => {
      const d = c.split("").map((f) => f.charCodeAt(0)).join("");
      return parseInt(d, 10);
    }, a = I(() => {
      var p;
      if (!n.user)
        return null;
      const { first_name: c, last_name: d, username: f, email: m } = n.user, g = [c, d].filter(Boolean).join(" ").trim() || f || (m ? m.split("@")[0] : "");
      if (!g)
        return null;
      const v = g.split(" ");
      if (v.length === 1)
        return ((p = v[0].substring(0, 2)) == null ? void 0 : p.toUpperCase()) ?? null;
      {
        const _ = v[0][0], x = v[v.length - 1][0];
        return (_ + x).toUpperCase() ?? null;
      }
    }), l = t;
    return (c, d) => (le(), Te(td, fe(c.$attrs, {
      class: "center",
      "offset-x": !0
    }), {
      activator: Z(({ props: f }) => [
        b(es, fe({
          color: r(a.value),
          size: 36,
          class: "mx-2 cursor-pointer"
        }, f, {
          onMousedown: d[0] || (d[0] = Dt(() => {
          }, ["stop"]))
        }), {
          default: Z(() => [
            a.value ? (le(), nt("div", {
              key: 0,
              style: Qr(`color: ${c.textColor}`)
            }, At(a.value), 5)) : (le(), Te(dt, {
              key: 1,
              color: c.textColor
            }, {
              default: Z(() => [
                Ee(" mdi-account")
              ]),
              _: 1
            }, 8, ["color"]))
          ]),
          _: 2
        }, 1040, ["color"])
      ]),
      default: Z(() => [
        b(Tm, { density: "comfortable" }, {
          default: Z(() => {
            var f;
            return [
              (f = n.user) != null && f.email ? (le(), Te(ts, { key: 0 }, {
                default: Z(() => [
                  b(ol, null, {
                    default: Z(() => [
                      St("div", zM, [
                        b(dt, { class: "text-grey-darken-1" }, {
                          default: Z(() => [
                            Ee(" mdi-account")
                          ]),
                          _: 1
                        }),
                        St("div", HM, At(n.user.email), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })) : it("", !0),
              wt(c.$slots, "menu-list-items", {}, void 0, !0),
              b(ts, {
                onClick: d[1] || (d[1] = (m) => l("logout"))
              }, {
                default: Z(() => [
                  b(ol, null, {
                    default: Z(() => [
                      St("div", WM, [
                        b(dt, { class: "text-grey-darken-1" }, {
                          default: Z(() => [
                            Ee(" mdi-logout-variant")
                          ]),
                          _: 1
                        }),
                        UM
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ];
          }),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
}), Tr = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [i, r] of t)
    n[i] = r;
  return n;
}, jx = /* @__PURE__ */ Tr(qM, [["__scopeId", "data-v-e0fd5283"]]), jM = /* @__PURE__ */ Je({
  __name: "RHDHVHeaderLogo",
  props: {
    imageSrc: { type: String, required: !1, default: "logo-rhdhv-white.png" }
  },
  emits: ["logo-click"],
  setup(e, { emit: t }) {
    const n = e, i = t;
    return (r, s) => (le(), nt("div", {
      class: "cursor-pointer",
      onClick: s[0] || (s[0] = (a) => i("logo-click"))
    }, [
      b(Tl, fe({
        alt: "Logo",
        class: "shrink",
        src: n.imageSrc,
        contain: "",
        transition: "scale-transition",
        width: "30"
      }, r.$attrs), null, 16, ["src"])
    ]));
  }
}), Gx = /* @__PURE__ */ Tr(jM, [["__scopeId", "data-v-436cceea"]]), Ol = pe()({
  name: "VCardActions",
  props: Ae(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return yi({
      VBtn: {
        slim: !0,
        variant: "text"
      }
    }), ke(() => {
      var i;
      return b("div", {
        class: ["v-card-actions", e.class],
        style: e.style
      }, [(i = n.default) == null ? void 0 : i.call(n)]);
    }), {};
  }
}), GM = ee({
  opacity: [Number, String],
  ...Ae(),
  ...pt()
}, "VCardSubtitle"), Va = pe()({
  name: "VCardSubtitle",
  props: GM(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return ke(() => b(e.tag, {
      class: ["v-card-subtitle", e.class],
      style: [{
        "--v-card-subtitle-opacity": e.opacity
      }, e.style]
    }, n)), {};
  }
}), Gs = pm("v-card-title"), YM = ee({
  appendAvatar: String,
  appendIcon: He,
  prependAvatar: String,
  prependIcon: He,
  subtitle: [String, Number],
  title: [String, Number],
  ...Ae(),
  ...Qn()
}, "VCardItem"), ZM = pe()({
  name: "VCardItem",
  props: YM(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return ke(() => {
      var d;
      const i = !!(e.prependAvatar || e.prependIcon), r = !!(i || n.prepend), s = !!(e.appendAvatar || e.appendIcon), a = !!(s || n.append), l = !!(e.title != null || n.title), c = !!(e.subtitle != null || n.subtitle);
      return b("div", {
        class: ["v-card-item", e.class],
        style: e.style
      }, [r && b("div", {
        key: "prepend",
        class: "v-card-item__prepend"
      }, [n.prepend ? b(Mt, {
        key: "prepend-defaults",
        disabled: !i,
        defaults: {
          VAvatar: {
            density: e.density,
            image: e.prependAvatar
          },
          VIcon: {
            density: e.density,
            icon: e.prependIcon
          }
        }
      }, n.prepend) : b(Le, null, [e.prependAvatar && b(es, {
        key: "prepend-avatar",
        density: e.density,
        image: e.prependAvatar
      }, null), e.prependIcon && b(dt, {
        key: "prepend-icon",
        density: e.density,
        icon: e.prependIcon
      }, null)])]), b("div", {
        class: "v-card-item__content"
      }, [l && b(Gs, {
        key: "title"
      }, {
        default: () => {
          var f;
          return [((f = n.title) == null ? void 0 : f.call(n)) ?? e.title];
        }
      }), c && b(Va, {
        key: "subtitle"
      }, {
        default: () => {
          var f;
          return [((f = n.subtitle) == null ? void 0 : f.call(n)) ?? e.subtitle];
        }
      }), (d = n.default) == null ? void 0 : d.call(n)]), a && b("div", {
        key: "append",
        class: "v-card-item__append"
      }, [n.append ? b(Mt, {
        key: "append-defaults",
        disabled: !s,
        defaults: {
          VAvatar: {
            density: e.density,
            image: e.appendAvatar
          },
          VIcon: {
            density: e.density,
            icon: e.appendIcon
          }
        }
      }, n.append) : b(Le, null, [e.appendIcon && b(dt, {
        key: "append-icon",
        density: e.density,
        icon: e.appendIcon
      }, null), e.appendAvatar && b(es, {
        key: "append-avatar",
        density: e.density,
        image: e.appendAvatar
      }, null)])])]);
    }), {};
  }
}), KM = ee({
  opacity: [Number, String],
  ...Ae(),
  ...pt()
}, "VCardText"), La = pe()({
  name: "VCardText",
  props: KM(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return ke(() => b(e.tag, {
      class: ["v-card-text", e.class],
      style: [{
        "--v-card-text-opacity": e.opacity
      }, e.style]
    }, n)), {};
  }
});
function Yx(e, t) {
  const n = ue(), i = Ie(!1);
  if (cm) {
    const r = new IntersectionObserver((s) => {
      i.value = !!s.find((a) => a.isIntersecting);
    }, t);
    kn(() => {
      r.disconnect();
    }), Se(n, (s, a) => {
      a && (r.unobserve(a), i.value = !1), s && r.observe(s);
    }, {
      flush: "post"
    });
  }
  return {
    intersectionRef: n,
    isIntersecting: i
  };
}
const fp = {
  center: "center",
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, El = ee({
  location: String
}, "location");
function nd(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = arguments.length > 2 ? arguments[2] : void 0;
  const {
    isRtl: i
  } = Tn();
  return {
    locationStyles: I(() => {
      if (!e.location)
        return {};
      const {
        side: s,
        align: a
      } = wh(e.location.split(" ").length > 1 ? e.location : `${e.location} center`, i.value);
      function l(d) {
        return n ? n(d) : 0;
      }
      const c = {};
      return s !== "center" && (t ? c[fp[s]] = `calc(100% - ${l(s)}px)` : c[s] = 0), a !== "center" ? t ? c[fp[a]] = `calc(100% - ${l(a)}px)` : c[a] = 0 : (s === "center" ? c.top = c.left = "50%" : c[{
        top: "left",
        bottom: "left",
        left: "top",
        right: "top"
      }[s]] = "50%", c.transform = {
        top: "translateX(-50%)",
        bottom: "translateX(-50%)",
        left: "translateY(-50%)",
        right: "translateY(-50%)",
        center: "translate(-50%, -50%)"
      }[s]), c;
    })
  };
}
const XM = ee({
  absolute: Boolean,
  active: {
    type: Boolean,
    default: !0
  },
  bgColor: String,
  bgOpacity: [Number, String],
  bufferValue: {
    type: [Number, String],
    default: 0
  },
  bufferColor: String,
  bufferOpacity: [Number, String],
  clickable: Boolean,
  color: String,
  height: {
    type: [Number, String],
    default: 4
  },
  indeterminate: Boolean,
  max: {
    type: [Number, String],
    default: 100
  },
  modelValue: {
    type: [Number, String],
    default: 0
  },
  opacity: [Number, String],
  reverse: Boolean,
  stream: Boolean,
  striped: Boolean,
  roundedBar: Boolean,
  ...Ae(),
  ...El({
    location: "top"
  }),
  ...vn(),
  ...pt(),
  ...$t()
}, "VProgressLinear"), id = pe()({
  name: "VProgressLinear",
  props: XM(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    var B;
    let {
      slots: n
    } = t;
    const i = at(e, "modelValue"), {
      isRtl: r,
      rtlClasses: s
    } = Tn(), {
      themeClasses: a
    } = Zt(e), {
      locationStyles: l
    } = nd(e), {
      textColorClasses: c,
      textColorStyles: d
    } = Ei(e, "color"), {
      backgroundColorClasses: f,
      backgroundColorStyles: m
    } = Bn(I(() => e.bgColor || e.color)), {
      backgroundColorClasses: g,
      backgroundColorStyles: v
    } = Bn(I(() => e.bufferColor || e.bgColor || e.color)), {
      backgroundColorClasses: p,
      backgroundColorStyles: _
    } = Bn(e, "color"), {
      roundedClasses: x
    } = Cn(e), {
      intersectionRef: S,
      isIntersecting: T
    } = Yx(), M = I(() => parseFloat(e.max)), E = I(() => parseFloat(e.height)), D = I(() => Jt(parseFloat(e.bufferValue) / M.value * 100, 0, 100)), R = I(() => Jt(parseFloat(i.value) / M.value * 100, 0, 100)), $ = I(() => r.value !== e.reverse), A = I(() => e.indeterminate ? "fade-transition" : "slide-x-transition"), V = Bt && ((B = window.matchMedia) == null ? void 0 : B.call(window, "(forced-colors: active)").matches);
    function H(N) {
      if (!S.value)
        return;
      const {
        left: q,
        right: X,
        width: se
      } = S.value.getBoundingClientRect(), de = $.value ? se - N.clientX + (X - se) : N.clientX - q;
      i.value = Math.round(de / se * M.value);
    }
    return ke(() => b(e.tag, {
      ref: S,
      class: ["v-progress-linear", {
        "v-progress-linear--absolute": e.absolute,
        "v-progress-linear--active": e.active && T.value,
        "v-progress-linear--reverse": $.value,
        "v-progress-linear--rounded": e.rounded,
        "v-progress-linear--rounded-bar": e.roundedBar,
        "v-progress-linear--striped": e.striped
      }, x.value, a.value, s.value, e.class],
      style: [{
        bottom: e.location === "bottom" ? 0 : void 0,
        top: e.location === "top" ? 0 : void 0,
        height: e.active ? Ce(E.value) : 0,
        "--v-progress-linear-height": Ce(E.value),
        ...e.absolute ? l.value : {}
      }, e.style],
      role: "progressbar",
      "aria-hidden": e.active ? "false" : "true",
      "aria-valuemin": "0",
      "aria-valuemax": e.max,
      "aria-valuenow": e.indeterminate ? void 0 : Math.min(parseFloat(i.value), M.value),
      onClick: e.clickable && H
    }, {
      default: () => [e.stream && b("div", {
        key: "stream",
        class: ["v-progress-linear__stream", c.value],
        style: {
          ...d.value,
          [$.value ? "left" : "right"]: Ce(-E.value),
          borderTop: `${Ce(E.value / 2)} dotted`,
          opacity: parseFloat(e.bufferOpacity),
          top: `calc(50% - ${Ce(E.value / 4)})`,
          width: Ce(100 - D.value, "%"),
          "--v-progress-linear-stream-to": Ce(E.value * ($.value ? 1 : -1))
        }
      }, null), b("div", {
        class: ["v-progress-linear__background", V ? void 0 : f.value],
        style: [m.value, {
          opacity: parseFloat(e.bgOpacity),
          width: e.stream ? 0 : void 0
        }]
      }, null), b("div", {
        class: ["v-progress-linear__buffer", V ? void 0 : g.value],
        style: [v.value, {
          opacity: parseFloat(e.bufferOpacity),
          width: Ce(D.value, "%")
        }]
      }, null), b(Hs, {
        name: A.value
      }, {
        default: () => [e.indeterminate ? b("div", {
          class: "v-progress-linear__indeterminate"
        }, [["long", "short"].map((N) => b("div", {
          key: N,
          class: ["v-progress-linear__indeterminate", N, V ? void 0 : p.value],
          style: _.value
        }, null))]) : b("div", {
          class: ["v-progress-linear__determinate", V ? void 0 : p.value],
          style: [_.value, {
            width: Ce(R.value, "%")
          }]
        }, null)]
      }), n.default && b("div", {
        class: "v-progress-linear__content"
      }, [n.default({
        value: R.value,
        buffer: D.value
      })])]
    })), {};
  }
}), rd = ee({
  loading: [Boolean, String]
}, "loader");
function sd(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Yi();
  return {
    loaderClasses: I(() => ({
      [`${t}--loading`]: e.loading
    }))
  };
}
function Im(e, t) {
  var i;
  let {
    slots: n
  } = t;
  return b("div", {
    class: `${e.name}__loader`
  }, [((i = n.default) == null ? void 0 : i.call(n, {
    color: e.color,
    isActive: e.active
  })) || b(id, {
    absolute: e.absolute,
    active: e.active,
    color: e.color,
    height: "2",
    indeterminate: !0
  }, null)]);
}
const JM = ["static", "relative", "fixed", "absolute", "sticky"], ad = ee({
  position: {
    type: String,
    validator: (
      /* istanbul ignore next */
      (e) => JM.includes(e)
    )
  }
}, "position");
function od(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Yi();
  return {
    positionClasses: I(() => e.position ? `${t}--${e.position}` : void 0)
  };
}
const QM = ee({
  appendAvatar: String,
  appendIcon: He,
  disabled: Boolean,
  flat: Boolean,
  hover: Boolean,
  image: String,
  link: {
    type: Boolean,
    default: void 0
  },
  prependAvatar: String,
  prependIcon: He,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  subtitle: [String, Number],
  text: [String, Number],
  title: [String, Number],
  ...Ki(),
  ...Ae(),
  ...Qn(),
  ...Di(),
  ...Xi(),
  ...rd(),
  ...El(),
  ...ad(),
  ...vn(),
  ...kl(),
  ...pt(),
  ...$t(),
  ...Ji({
    variant: "elevated"
  })
}, "VCard"), Ir = pe()({
  name: "VCard",
  directives: {
    Ripple: ja
  },
  props: QM(),
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const {
      themeClasses: r
    } = Zt(e), {
      borderClasses: s
    } = kr(e), {
      colorClasses: a,
      colorStyles: l,
      variantClasses: c
    } = qa(e), {
      densityClasses: d
    } = Mi(e), {
      dimensionStyles: f
    } = Vi(e), {
      elevationClasses: m
    } = Cr(e), {
      loaderClasses: g
    } = sd(e), {
      locationStyles: v
    } = nd(e), {
      positionClasses: p
    } = od(e), {
      roundedClasses: _
    } = Cn(e), x = Sl(e, n), S = I(() => e.link !== !1 && x.isLink.value), T = I(() => !e.disabled && e.link !== !1 && (e.link || x.isClickable.value));
    return ke(() => {
      const M = S.value ? "a" : e.tag, E = !!(i.title || e.title != null), D = !!(i.subtitle || e.subtitle != null), R = E || D, $ = !!(i.append || e.appendAvatar || e.appendIcon), A = !!(i.prepend || e.prependAvatar || e.prependIcon), V = !!(i.image || e.image), H = R || A || $, B = !!(i.text || e.text != null);
      return rn(b(M, fe({
        class: ["v-card", {
          "v-card--disabled": e.disabled,
          "v-card--flat": e.flat,
          "v-card--hover": e.hover && !(e.disabled || e.flat),
          "v-card--link": T.value
        }, r.value, s.value, a.value, d.value, m.value, g.value, p.value, _.value, c.value, e.class],
        style: [l.value, f.value, v.value, e.style],
        onClick: T.value && x.navigate,
        tabindex: e.disabled ? -1 : void 0
      }, x.linkProps), {
        default: () => {
          var N;
          return [V && b("div", {
            key: "image",
            class: "v-card__image"
          }, [i.image ? b(Mt, {
            key: "image-defaults",
            disabled: !e.image,
            defaults: {
              VImg: {
                cover: !0,
                src: e.image
              }
            }
          }, i.image) : b(Tl, {
            key: "image-img",
            cover: !0,
            src: e.image
          }, null)]), b(Im, {
            name: "v-card",
            active: !!e.loading,
            color: typeof e.loading == "boolean" ? void 0 : e.loading
          }, {
            default: i.loader
          }), H && b(ZM, {
            key: "item",
            prependAvatar: e.prependAvatar,
            prependIcon: e.prependIcon,
            title: e.title,
            subtitle: e.subtitle,
            appendAvatar: e.appendAvatar,
            appendIcon: e.appendIcon
          }, {
            default: i.item,
            prepend: i.prepend,
            title: i.title,
            subtitle: i.subtitle,
            append: i.append
          }), B && b(La, {
            key: "text"
          }, {
            default: () => {
              var q;
              return [((q = i.text) == null ? void 0 : q.call(i)) ?? e.text];
            }
          }), (N = i.default) == null ? void 0 : N.call(i), i.actions && b(Ol, null, {
            default: i.actions
          }), Ua(T.value, "v-card")];
        }
      }), [[ji("ripple"), T.value && e.ripple]]);
    }), {};
  }
});
function Ws(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "content";
  const n = _h(), i = ue();
  if (Bt) {
    const r = new ResizeObserver((s) => {
      e == null || e(s, r), s.length && (t === "content" ? i.value = s[0].contentRect : i.value = s[0].target.getBoundingClientRect());
    });
    kn(() => {
      r.disconnect();
    }), Se(() => n.el, (s, a) => {
      a && (r.unobserve(a), i.value = void 0), s && r.observe(s);
    }, {
      flush: "post"
    });
  }
  return {
    resizeRef: n,
    contentRect: jc(i)
  };
}
const eD = ee({
  bgColor: String,
  color: String,
  indeterminate: [Boolean, String],
  modelValue: {
    type: [Number, String],
    default: 0
  },
  rotate: {
    type: [Number, String],
    default: 0
  },
  width: {
    type: [Number, String],
    default: 4
  },
  ...Ae(),
  ...Ha(),
  ...pt({
    tag: "div"
  }),
  ...$t()
}, "VProgressCircular"), Pm = pe()({
  name: "VProgressCircular",
  props: eD(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = 20, r = 2 * Math.PI * i, s = ue(), {
      themeClasses: a
    } = Zt(e), {
      sizeClasses: l,
      sizeStyles: c
    } = Cl(e), {
      textColorClasses: d,
      textColorStyles: f
    } = Ei(ce(e, "color")), {
      textColorClasses: m,
      textColorStyles: g
    } = Ei(ce(e, "bgColor")), {
      intersectionRef: v,
      isIntersecting: p
    } = Yx(), {
      resizeRef: _,
      contentRect: x
    } = Ws(), S = I(() => Math.max(0, Math.min(100, parseFloat(e.modelValue)))), T = I(() => Number(e.width)), M = I(() => c.value ? Number(e.size) : x.value ? x.value.width : Math.max(T.value, 32)), E = I(() => i / (1 - T.value / M.value) * 2), D = I(() => T.value / M.value * E.value), R = I(() => Ce((100 - S.value) / 100 * r));
    return Xn(() => {
      v.value = s.value, _.value = s.value;
    }), ke(() => b(e.tag, {
      ref: s,
      class: ["v-progress-circular", {
        "v-progress-circular--indeterminate": !!e.indeterminate,
        "v-progress-circular--visible": p.value,
        "v-progress-circular--disable-shrink": e.indeterminate === "disable-shrink"
      }, a.value, l.value, d.value, e.class],
      style: [c.value, f.value, e.style],
      role: "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-valuenow": e.indeterminate ? void 0 : S.value
    }, {
      default: () => [b("svg", {
        style: {
          transform: `rotate(calc(-90deg + ${Number(e.rotate)}deg))`
        },
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: `0 0 ${E.value} ${E.value}`
      }, [b("circle", {
        class: ["v-progress-circular__underlay", m.value],
        style: g.value,
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: i,
        "stroke-width": D.value,
        "stroke-dasharray": r,
        "stroke-dashoffset": 0
      }, null), b("circle", {
        class: "v-progress-circular__overlay",
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: i,
        "stroke-width": D.value,
        "stroke-dasharray": r,
        "stroke-dashoffset": R.value
      }, null)]), n.default && b("div", {
        class: "v-progress-circular__content"
      }, [n.default({
        value: S.value
      })])]
    })), {};
  }
}), Zx = /* @__PURE__ */ Je({
  __name: "RHDHVLoader",
  props: {
    loading: { type: Boolean, required: !0 },
    setTimeoutDuration: { type: Number, default: 3e3 }
  },
  setup(e) {
    const t = e, n = ue(!1);
    let i = null;
    return Se(
      () => t.loading,
      (r, s) => {
        i && (clearTimeout(i), i = null), s && !r && (n.value = !0, i = setTimeout(() => {
          n.value = !1, i = null;
        }, t.setTimeoutDuration));
      }
    ), (r, s) => (le(), nt("div", fe({ class: "d-flex ga-1" }, r.$attrs), [
      t.loading ? (le(), Te(Pm, {
        key: 0,
        indeterminate: "",
        color: "#FFFFFF",
        size: 25,
        width: 3
      })) : it("", !0),
      b(Va, {
        class: "text-white pl-1",
        style: { "padding-top": "2px" }
      }, {
        default: Z(() => [
          t.loading ? (le(), nt(Le, { key: 0 }, [
            Ee("Loading...")
          ], 64)) : it("", !0),
          n.value && !t.loading ? (le(), nt(Le, { key: 1 }, [
            Ee("All changes saved.")
          ], 64)) : it("", !0)
        ]),
        _: 1
      })
    ], 16));
  }
}), Kx = ee({
  baseColor: String,
  divided: Boolean,
  ...Ki(),
  ...Ae(),
  ...Qn(),
  ...Xi(),
  ...vn(),
  ...pt(),
  ...$t(),
  ...Ji()
}, "VBtnGroup"), hp = pe()({
  name: "VBtnGroup",
  props: Kx(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: i
    } = Zt(e), {
      densityClasses: r
    } = Mi(e), {
      borderClasses: s
    } = kr(e), {
      elevationClasses: a
    } = Cr(e), {
      roundedClasses: l
    } = Cn(e);
    yi({
      VBtn: {
        height: "auto",
        baseColor: ce(e, "baseColor"),
        color: ce(e, "color"),
        density: ce(e, "density"),
        flat: !0,
        variant: ce(e, "variant")
      }
    }), ke(() => b(e.tag, {
      class: ["v-btn-group", {
        "v-btn-group--divided": e.divided
      }, i.value, s.value, r.value, a.value, l.value, e.class],
      style: e.style
    }, n));
  }
}), Om = ee({
  modelValue: {
    type: null,
    default: void 0
  },
  multiple: Boolean,
  mandatory: [Boolean, String],
  max: Number,
  selectedClass: String,
  disabled: Boolean
}, "group"), Xx = ee({
  value: null,
  disabled: Boolean,
  selectedClass: String
}, "group-item");
function Jx(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  const i = Nt("useGroupItem");
  if (!i)
    throw new Error("[Vuetify] useGroupItem composable must be used inside a component setup function");
  const r = pi();
  jt(Symbol.for(`${t.description}:id`), r);
  const s = gt(t, null);
  if (!s) {
    if (!n)
      return s;
    throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${t.description}`);
  }
  const a = ce(e, "value"), l = I(() => !!(s.disabled.value || e.disabled));
  s.register({
    id: r,
    value: a,
    disabled: l
  }, i), kn(() => {
    s.unregister(r);
  });
  const c = I(() => s.isSelected(r)), d = I(() => s.items.value[0].id === r), f = I(() => s.items.value[s.items.value.length - 1].id === r), m = I(() => c.value && [s.selectedClass.value, e.selectedClass]);
  return Se(c, (g) => {
    i.emit("group:selected", {
      value: g
    });
  }, {
    flush: "sync"
  }), {
    id: r,
    isSelected: c,
    isFirst: d,
    isLast: f,
    toggle: () => s.select(r, !c.value),
    select: (g) => s.select(r, g),
    selectedClass: m,
    value: a,
    disabled: l,
    group: s
  };
}
function Em(e, t) {
  let n = !1;
  const i = Ma([]), r = at(e, "modelValue", [], (g) => g == null ? [] : Qx(i, mn(g)), (g) => {
    const v = nD(i, g);
    return e.multiple ? v : v[0];
  }), s = Nt("useGroup");
  function a(g, v) {
    const p = g, _ = Symbol.for(`${t.description}:id`), S = Wo(_, s == null ? void 0 : s.vnode).indexOf(v);
    je(p.value) == null && (p.value = S, p.useIndexAsValue = !0), S > -1 ? i.splice(S, 0, p) : i.push(p);
  }
  function l(g) {
    if (n)
      return;
    c();
    const v = i.findIndex((p) => p.id === g);
    i.splice(v, 1);
  }
  function c() {
    const g = i.find((v) => !v.disabled);
    g && e.mandatory === "force" && !r.value.length && (r.value = [g.id]);
  }
  Jn(() => {
    c();
  }), kn(() => {
    n = !0;
  }), sE(() => {
    for (let g = 0; g < i.length; g++)
      i[g].useIndexAsValue && (i[g].value = g);
  });
  function d(g, v) {
    const p = i.find((_) => _.id === g);
    if (!(v && (p != null && p.disabled)))
      if (e.multiple) {
        const _ = r.value.slice(), x = _.findIndex((T) => T === g), S = ~x;
        if (v = v ?? !S, S && e.mandatory && _.length <= 1 || !S && e.max != null && _.length + 1 > e.max)
          return;
        x < 0 && v ? _.push(g) : x >= 0 && !v && _.splice(x, 1), r.value = _;
      } else {
        const _ = r.value.includes(g);
        if (e.mandatory && _)
          return;
        r.value = v ?? !_ ? [g] : [];
      }
  }
  function f(g) {
    if (e.multiple && Ui('This method is not supported when using "multiple" prop'), r.value.length) {
      const v = r.value[0], p = i.findIndex((S) => S.id === v);
      let _ = (p + g) % i.length, x = i[_];
      for (; x.disabled && _ !== p; )
        _ = (_ + g) % i.length, x = i[_];
      if (x.disabled)
        return;
      r.value = [i[_].id];
    } else {
      const v = i.find((p) => !p.disabled);
      v && (r.value = [v.id]);
    }
  }
  const m = {
    register: a,
    unregister: l,
    selected: r,
    select: d,
    disabled: ce(e, "disabled"),
    prev: () => f(i.length - 1),
    next: () => f(1),
    isSelected: (g) => r.value.includes(g),
    selectedClass: I(() => e.selectedClass),
    items: I(() => i),
    getItemIndex: (g) => tD(i, g)
  };
  return jt(t, m), m;
}
function tD(e, t) {
  const n = Qx(e, [t]);
  return n.length ? e.findIndex((i) => i.id === n[0]) : -1;
}
function Qx(e, t) {
  const n = [];
  return t.forEach((i) => {
    const r = e.find((a) => Sr(i, a.value)), s = e[i];
    (r == null ? void 0 : r.value) != null ? n.push(r.id) : s != null && n.push(s.id);
  }), n;
}
function nD(e, t) {
  const n = [];
  return t.forEach((i) => {
    const r = e.findIndex((s) => s.id === i);
    if (~r) {
      const s = e[r];
      n.push(s.value != null ? s.value : r);
    }
  }), n;
}
const e_ = Symbol.for("vuetify:v-btn-toggle"), iD = ee({
  ...Kx(),
  ...Om()
}, "VBtnToggle"), rD = pe()({
  name: "VBtnToggle",
  props: iD(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      isSelected: i,
      next: r,
      prev: s,
      select: a,
      selected: l
    } = Em(e, e_);
    return ke(() => {
      const c = hp.filterProps(e);
      return b(hp, fe({
        class: ["v-btn-toggle", e.class]
      }, c, {
        style: e.style
      }), {
        default: () => {
          var d;
          return [(d = n.default) == null ? void 0 : d.call(n, {
            isSelected: i,
            next: r,
            prev: s,
            select: a,
            selected: l
          })];
        }
      });
    }), {
      next: r,
      prev: s,
      select: a
    };
  }
});
function sD(e, t) {
  Se(() => {
    var n;
    return (n = e.isActive) == null ? void 0 : n.value;
  }, (n) => {
    e.isLink.value && n && t && Ct(() => {
      t(!0);
    });
  }, {
    immediate: !0
  });
}
const aD = ee({
  active: {
    type: Boolean,
    default: void 0
  },
  activeColor: String,
  baseColor: String,
  symbol: {
    type: null,
    default: e_
  },
  flat: Boolean,
  icon: [Boolean, String, Function, Object],
  prependIcon: He,
  appendIcon: He,
  block: Boolean,
  readonly: Boolean,
  slim: Boolean,
  stacked: Boolean,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  text: String,
  ...Ki(),
  ...Ae(),
  ...Qn(),
  ...Di(),
  ...Xi(),
  ...Xx(),
  ...rd(),
  ...El(),
  ...ad(),
  ...vn(),
  ...kl(),
  ...Ha(),
  ...pt({
    tag: "button"
  }),
  ...$t(),
  ...Ji({
    variant: "elevated"
  })
}, "VBtn"), rt = pe()({
  name: "VBtn",
  props: aD(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const {
      themeClasses: r
    } = Zt(e), {
      borderClasses: s
    } = kr(e), {
      densityClasses: a
    } = Mi(e), {
      dimensionStyles: l
    } = Vi(e), {
      elevationClasses: c
    } = Cr(e), {
      loaderClasses: d
    } = sd(e), {
      locationStyles: f
    } = nd(e), {
      positionClasses: m
    } = od(e), {
      roundedClasses: g
    } = Cn(e), {
      sizeClasses: v,
      sizeStyles: p
    } = Cl(e), _ = Jx(e, e.symbol, !1), x = Sl(e, n), S = I(() => {
      var B;
      return e.active !== void 0 ? e.active : x.isLink.value ? (B = x.isActive) == null ? void 0 : B.value : _ == null ? void 0 : _.isSelected.value;
    }), T = I(() => S.value ? e.activeColor ?? e.color : e.color), M = I(() => {
      var N, q;
      return {
        color: (_ == null ? void 0 : _.isSelected.value) && (!x.isLink.value || ((N = x.isActive) == null ? void 0 : N.value)) || !_ || ((q = x.isActive) == null ? void 0 : q.value) ? T.value ?? e.baseColor : e.baseColor,
        variant: e.variant
      };
    }), {
      colorClasses: E,
      colorStyles: D,
      variantClasses: R
    } = qa(M), $ = I(() => (_ == null ? void 0 : _.disabled.value) || e.disabled), A = I(() => e.variant === "elevated" && !(e.disabled || e.flat || e.border)), V = I(() => {
      if (!(e.value === void 0 || typeof e.value == "symbol"))
        return Object(e.value) === e.value ? JSON.stringify(e.value, null, 0) : e.value;
    });
    function H(B) {
      var N;
      $.value || x.isLink.value && (B.metaKey || B.ctrlKey || B.shiftKey || B.button !== 0 || n.target === "_blank") || ((N = x.navigate) == null || N.call(x, B), _ == null || _.toggle());
    }
    return sD(x, _ == null ? void 0 : _.select), ke(() => {
      const B = x.isLink.value ? "a" : e.tag, N = !!(e.prependIcon || i.prepend), q = !!(e.appendIcon || i.append), X = !!(e.icon && e.icon !== !0);
      return rn(b(B, fe({
        type: B === "a" ? void 0 : "button",
        class: ["v-btn", _ == null ? void 0 : _.selectedClass.value, {
          "v-btn--active": S.value,
          "v-btn--block": e.block,
          "v-btn--disabled": $.value,
          "v-btn--elevated": A.value,
          "v-btn--flat": e.flat,
          "v-btn--icon": !!e.icon,
          "v-btn--loading": e.loading,
          "v-btn--readonly": e.readonly,
          "v-btn--slim": e.slim,
          "v-btn--stacked": e.stacked
        }, r.value, s.value, E.value, a.value, c.value, d.value, m.value, g.value, v.value, R.value, e.class],
        style: [D.value, l.value, f.value, p.value, e.style],
        "aria-busy": e.loading ? !0 : void 0,
        disabled: $.value || void 0,
        tabindex: e.loading || e.readonly ? -1 : void 0,
        onClick: H,
        value: V.value
      }, x.linkProps), {
        default: () => {
          var se;
          return [Ua(!0, "v-btn"), !e.icon && N && b("span", {
            key: "prepend",
            class: "v-btn__prepend"
          }, [i.prepend ? b(Mt, {
            key: "prepend-defaults",
            disabled: !e.prependIcon,
            defaults: {
              VIcon: {
                icon: e.prependIcon
              }
            }
          }, i.prepend) : b(dt, {
            key: "prepend-icon",
            icon: e.prependIcon
          }, null)]), b("span", {
            class: "v-btn__content",
            "data-no-activator": ""
          }, [!i.default && X ? b(dt, {
            key: "content-icon",
            icon: e.icon
          }, null) : b(Mt, {
            key: "content-defaults",
            disabled: !X,
            defaults: {
              VIcon: {
                icon: e.icon
              }
            }
          }, {
            default: () => {
              var de;
              return [((de = i.default) == null ? void 0 : de.call(i)) ?? e.text];
            }
          })]), !e.icon && q && b("span", {
            key: "append",
            class: "v-btn__append"
          }, [i.append ? b(Mt, {
            key: "append-defaults",
            disabled: !e.appendIcon,
            defaults: {
              VIcon: {
                icon: e.appendIcon
              }
            }
          }, i.append) : b(dt, {
            key: "append-icon",
            icon: e.appendIcon
          }, null)]), !!e.loading && b("span", {
            key: "loader",
            class: "v-btn__loader"
          }, [((se = i.loader) == null ? void 0 : se.call(i)) ?? b(Pm, {
            color: typeof e.loading == "boolean" ? void 0 : e.loading,
            indeterminate: !0,
            width: "2"
          }, null)])];
        }
      }), [[ja, !$.value && e.ripple, "", {
        center: !!e.icon
      }]]);
    }), {
      group: _
    };
  }
}), t_ = /* @__PURE__ */ Je({
  __name: "DocumentationButton",
  props: {
    url: { type: String, required: !1, default: "/docs/" },
    icon: { type: String, required: !1, default: "mdi-information" }
  },
  setup(e) {
    return (t, n) => (le(), Te(rt, {
      class: "text-none",
      color: "#FFFFFF",
      "prepend-icon": e.icon,
      "append-icon": "mdi-open-in-new",
      to: e.url,
      target: "_blank"
    }, {
      default: Z(() => [
        Ee(" Documentation ")
      ]),
      _: 1
    }, 8, ["prepend-icon", "to"]));
  }
}), Am = Symbol.for("vuetify:layout"), oD = Symbol.for("vuetify:layout-item"), lD = ee({
  name: {
    type: String
  },
  order: {
    type: [Number, String],
    default: 0
  },
  absolute: Boolean
}, "layout-item");
function uD() {
  const e = gt(Am);
  if (!e)
    throw new Error("[Vuetify] Could not find injected layout");
  return {
    getLayoutItem: e.getLayoutItem,
    mainRect: e.mainRect,
    mainStyles: e.mainStyles
  };
}
function cD(e) {
  const t = gt(Am);
  if (!t)
    throw new Error("[Vuetify] Could not find injected layout");
  const n = e.id ?? `layout-item-${pi()}`, i = Nt("useLayoutItem");
  jt(oD, {
    id: n
  });
  const r = Ie(!1);
  M0(() => r.value = !0), aE(() => r.value = !1);
  const {
    layoutItemStyles: s,
    layoutItemScrimStyles: a
  } = t.register(i, {
    ...e,
    active: I(() => r.value ? !1 : e.active.value),
    id: n
  });
  return kn(() => t.unregister(n)), {
    layoutItemStyles: s,
    layoutRect: t.layoutRect,
    layoutItemScrimStyles: a
  };
}
const dD = ee({
  scrollTarget: {
    type: String
  },
  scrollThreshold: {
    type: [String, Number],
    default: 300
  }
}, "scroll");
function fD(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    canScroll: n
  } = t;
  let i = 0, r = 0;
  const s = ue(null), a = Ie(0), l = Ie(0), c = Ie(0), d = Ie(!1), f = Ie(!1), m = I(() => Number(e.scrollThreshold)), g = I(() => Jt((m.value - a.value) / m.value || 0)), v = () => {
    const p = s.value;
    if (!p || n && !n.value)
      return;
    i = a.value, a.value = "window" in p ? p.pageYOffset : p.scrollTop;
    const _ = p instanceof Window ? document.documentElement.scrollHeight : p.scrollHeight;
    if (r !== _) {
      r = _;
      return;
    }
    f.value = a.value < i, c.value = Math.abs(a.value - m.value);
  };
  return Se(f, () => {
    l.value = l.value || a.value;
  }), Se(d, () => {
    l.value = 0;
  }), Jn(() => {
    Se(() => e.scrollTarget, (p) => {
      var x;
      const _ = p ? document.querySelector(p) : window;
      if (!_) {
        Ui(`Unable to locate element with identifier ${p}`);
        return;
      }
      _ !== s.value && ((x = s.value) == null || x.removeEventListener("scroll", v), s.value = _, s.value.addEventListener("scroll", v, {
        passive: !0
      }));
    }, {
      immediate: !0
    });
  }), kn(() => {
    var p;
    (p = s.value) == null || p.removeEventListener("scroll", v);
  }), n && Se(n, v, {
    immediate: !0
  }), {
    scrollThreshold: m,
    currentScroll: a,
    currentThreshold: c,
    isScrollActive: d,
    scrollRatio: g,
    // required only for testing
    // probably can be removed
    // later (2 chars chlng)
    isScrollingUp: f,
    savedScroll: l
  };
}
const hD = ee({
  scrollBehavior: String,
  modelValue: {
    type: Boolean,
    default: !0
  },
  location: {
    type: String,
    default: "top",
    validator: (e) => ["top", "bottom"].includes(e)
  },
  ...bx(),
  ...lD(),
  ...dD(),
  height: {
    type: [Number, String],
    default: 64
  }
}, "VAppBar"), mD = pe()({
  name: "VAppBar",
  props: hD(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = ue(), r = at(e, "modelValue"), s = I(() => {
      var M;
      const T = new Set(((M = e.scrollBehavior) == null ? void 0 : M.split(" ")) ?? []);
      return {
        hide: T.has("hide"),
        fullyHide: T.has("fully-hide"),
        inverted: T.has("inverted"),
        collapse: T.has("collapse"),
        elevate: T.has("elevate"),
        fadeImage: T.has("fade-image")
        // shrink: behavior.has('shrink'),
      };
    }), a = I(() => {
      const T = s.value;
      return T.hide || T.fullyHide || T.inverted || T.collapse || T.elevate || T.fadeImage || // behavior.shrink ||
      !r.value;
    }), {
      currentScroll: l,
      scrollThreshold: c,
      isScrollingUp: d,
      scrollRatio: f
    } = fD(e, {
      canScroll: a
    }), m = I(() => s.value.hide || s.value.fullyHide), g = I(() => e.collapse || s.value.collapse && (s.value.inverted ? f.value > 0 : f.value === 0)), v = I(() => e.flat || s.value.fullyHide && !r.value || s.value.elevate && (s.value.inverted ? l.value > 0 : l.value === 0)), p = I(() => s.value.fadeImage ? s.value.inverted ? 1 - f.value : f.value : void 0), _ = I(() => {
      var E, D;
      if (s.value.hide && s.value.inverted)
        return 0;
      const T = ((E = i.value) == null ? void 0 : E.contentHeight) ?? 0, M = ((D = i.value) == null ? void 0 : D.extensionHeight) ?? 0;
      return m.value ? l.value < c.value || s.value.fullyHide ? T + M : T : T + M;
    });
    _r(I(() => !!e.scrollBehavior), () => {
      Xn(() => {
        m.value ? s.value.inverted ? r.value = l.value > c.value : r.value = d.value || l.value < c.value : r.value = !0;
      });
    });
    const {
      ssrBootStyles: x
    } = Px(), {
      layoutItemStyles: S
    } = cD({
      id: e.name,
      order: I(() => parseInt(e.order, 10)),
      position: ce(e, "location"),
      layoutSize: _,
      elementSize: Ie(void 0),
      active: r,
      absolute: ce(e, "absolute")
    });
    return ke(() => {
      const T = kh.filterProps(e);
      return b(kh, fe({
        ref: i,
        class: ["v-app-bar", {
          "v-app-bar--bottom": e.location === "bottom"
        }, e.class],
        style: [{
          ...S.value,
          "--v-toolbar-image-opacity": p.value,
          height: void 0,
          ...x.value
        }, e.style]
      }, T, {
        collapse: g.value,
        flat: v.value
      }), n);
    }), {};
  }
}), gD = { class: "d-flex justify-center align-center" }, vD = /* @__PURE__ */ Je({
  __name: "RHDHVHeader",
  props: {
    title: { type: String, required: !0 },
    user: { type: Object, required: !0 },
    imageSrc: { type: String, required: !0, default: "/logo-rhdhv-white.png" },
    loading: { type: Boolean, required: !1, default: !1 },
    menuColor: { type: String, required: !1, default: "#FFFFFF" },
    menuTextColor: { type: String, required: !1, default: "#0186A7" },
    hideDoc: { type: Boolean, required: !1, default: !1 },
    docUrl: { type: String, required: !1, default: "/docs/" },
    docIcon: { type: String, required: !1, default: "mdi-information" }
  },
  emits: ["logo-click", "logout"],
  setup(e, { emit: t }) {
    const n = e, i = t;
    return (r, s) => (le(), Te(mD, fe({
      class: "pa-0",
      height: "48",
      app: "",
      fixed: "",
      dark: ""
    }, r.$attrs), {
      default: Z(() => [
        b(xx, null, oE({
          "breadcrumbs-items": Z(() => [
            wt(r.$slots, "breadcrumbs-items", {}, void 0, !0)
          ]),
          "toolbar-title": Z(() => [
            St("div", gD, [
              b(Gx, {
                "image-src": n.imageSrc,
                onLogoClick: s[0] || (s[0] = (a) => i("logo-click"))
              }, null, 8, ["image-src"]),
              b(dx, { class: "app-title ml-2" }, {
                default: Z(() => [
                  Ee(At(n.title), 1)
                ]),
                _: 1
              })
            ])
          ]),
          "toolbar-actions": Z(() => [
            wt(r.$slots, "toolbar-actions", {}, void 0, !0)
          ]),
          "toolbar-extension": Z(() => [
            b(Zx, {
              loading: n.loading,
              color: "red",
              size: "25",
              width: "3"
            }, null, 8, ["loading"]),
            e.hideDoc ? it("", !0) : (le(), Te(t_, {
              key: 0,
              url: e.docUrl,
              icon: e.docIcon
            }, null, 8, ["url", "icon"])),
            wt(r.$slots, "toolbar-extension", {}, void 0, !0),
            b(jx, {
              color: n.menuColor,
              "text-color": n.menuTextColor,
              user: e.user,
              onLogout: s[1] || (s[1] = (a) => i("logout"))
            }, {
              "menu-list-items": Z(() => [
                wt(r.$slots, "menu-list-items", {}, void 0, !0)
              ]),
              _: 3
            }, 8, ["color", "text-color", "user"])
          ]),
          _: 2
        }, [
          r.$slots["toolbar-prepend"] ? {
            name: "toolbar-prepend",
            fn: Z(() => [
              wt(r.$slots, "toolbar-prepend", {}, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1024)
      ]),
      _: 3
    }, 16));
  }
}), yD = /* @__PURE__ */ Tr(vD, [["__scopeId", "data-v-a3dd09df"]]), pD = (e, t) => {
  if (t === "OK" || t === "No Content" || t === "Created")
    switch (e) {
      case 201:
        return "Item created successfully!";
      case 202:
        return "Accepted!";
      case 204:
        return "Item deleted successfully!";
      default:
        return "Item updated successfully!";
    }
  else
    return t;
}, bD = (e) => {
  if (typeof e == "string")
    return e;
  if (typeof e != "object")
    return "Error occurred!";
  const t = [];
  for (const [n, i] of Object.entries(e))
    if (Array.isArray(i))
      if (typeof i[0] == "string")
        t.push(`${n}: ${i[0]}`);
      else
        for (const [r, s] of Object.entries(i[0]))
          t.push(`${r}: ${s}`);
    else
      typeof i == "string" && t.push(`${n}: ${i}`);
  return t.join("; ");
}, mp = ue(/* @__PURE__ */ new Map());
function n_() {
  function e(t, ...n) {
    mp.value.set(t, n);
  }
  return {
    emit: e,
    bus: mp
  };
}
const xD = Symbol.for("vuetify:goto");
function _D() {
  return {
    container: void 0,
    duration: 300,
    layout: !1,
    offset: 0,
    easing: "easeInOutCubic",
    patterns: {
      linear: (e) => e,
      easeInQuad: (e) => e ** 2,
      easeOutQuad: (e) => e * (2 - e),
      easeInOutQuad: (e) => e < 0.5 ? 2 * e ** 2 : -1 + (4 - 2 * e) * e,
      easeInCubic: (e) => e ** 3,
      easeOutCubic: (e) => --e ** 3 + 1,
      easeInOutCubic: (e) => e < 0.5 ? 4 * e ** 3 : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1,
      easeInQuart: (e) => e ** 4,
      easeOutQuart: (e) => 1 - --e ** 4,
      easeInOutQuart: (e) => e < 0.5 ? 8 * e ** 4 : 1 - 8 * --e ** 4,
      easeInQuint: (e) => e ** 5,
      easeOutQuint: (e) => 1 + --e ** 5,
      easeInOutQuint: (e) => e < 0.5 ? 16 * e ** 5 : 1 + 16 * --e ** 5
    }
  };
}
function wD(e) {
  return Mm(e) ?? (document.scrollingElement || document.body);
}
function Mm(e) {
  return typeof e == "string" ? document.querySelector(e) : dm(e);
}
function Zf(e, t, n) {
  if (typeof e == "number")
    return t && n ? -e : e;
  let i = Mm(e), r = 0;
  for (; i; )
    r += t ? i.offsetLeft : i.offsetTop, i = i.offsetParent;
  return r;
}
async function gp(e, t, n, i) {
  const r = n ? "scrollLeft" : "scrollTop", s = vr((i == null ? void 0 : i.options) ?? _D(), t), a = i == null ? void 0 : i.rtl.value, l = (typeof e == "number" ? e : Mm(e)) ?? 0, c = s.container === "parent" && l instanceof HTMLElement ? l.parentElement : wD(s.container), d = typeof s.easing == "function" ? s.easing : s.patterns[s.easing];
  if (!d)
    throw new TypeError(`Easing function "${s.easing}" not found.`);
  let f;
  if (typeof l == "number")
    f = Zf(l, n, a);
  else if (f = Zf(l, n, a) - Zf(c, n, a), s.layout) {
    const p = window.getComputedStyle(l).getPropertyValue("--v-layout-top");
    p && (f -= parseInt(p, 10));
  }
  f += s.offset, f = kD(c, f, !!a, !!n);
  const m = c[r] ?? 0;
  if (f === m)
    return Promise.resolve(f);
  const g = performance.now();
  return new Promise((v) => requestAnimationFrame(function p(_) {
    const S = (_ - g) / s.duration, T = Math.floor(m + (f - m) * d(Jt(S, 0, 1)));
    if (c[r] = T, S >= 1 && Math.abs(T - c[r]) < 10)
      return v(f);
    if (S > 2)
      return Ui("Scroll target is not reachable"), v(c[r]);
    requestAnimationFrame(p);
  }));
}
function SD() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const t = gt(xD), {
    isRtl: n
  } = Tn();
  if (!t)
    throw new Error("[Vuetify] Could not find injected goto instance");
  const i = {
    ...t,
    // can be set via VLocaleProvider
    rtl: I(() => t.rtl.value || n.value)
  };
  async function r(s, a) {
    return gp(s, vr(e, a), !1, i);
  }
  return r.horizontal = async (s, a) => gp(s, vr(e, a), !0, i), r;
}
function kD(e, t, n, i) {
  const {
    scrollWidth: r,
    scrollHeight: s
  } = e, [a, l] = e === document.scrollingElement ? [window.innerWidth, window.innerHeight] : [e.offsetWidth, e.offsetHeight];
  let c, d;
  return i ? n ? (c = -(r - a), d = 0) : (c = 0, d = r - a) : (c = 0, d = s + -l), Math.max(Math.min(t, d), c);
}
function CD(e) {
  const t = Ie(e());
  let n = -1;
  function i() {
    clearInterval(n);
  }
  function r() {
    i(), Ct(() => t.value = e());
  }
  function s(a) {
    const l = a ? getComputedStyle(a) : {
      transitionDuration: 0.2
    }, c = parseFloat(l.transitionDuration) * 1e3 || 200;
    if (i(), t.value <= 0)
      return;
    const d = performance.now();
    n = window.setInterval(() => {
      const f = performance.now() - d + c;
      t.value = Math.max(e() - f, 0), t.value <= 0 && i();
    }, c);
  }
  return gn(i), {
    clear: i,
    time: t,
    start: s,
    reset: r
  };
}
const TD = ee({
  multiLine: Boolean,
  text: String,
  timer: [Boolean, String],
  timeout: {
    type: [Number, String],
    default: 5e3
  },
  vertical: Boolean,
  ...El({
    location: "bottom"
  }),
  ...ad(),
  ...vn(),
  ...Ji(),
  ...$t(),
  ...Gi(Pl({
    transition: "v-snackbar-transition"
  }), ["persistent", "noClickAnimation", "scrim", "scrollStrategy"])
}, "VSnackbar"), ID = pe()({
  name: "VSnackbar",
  props: TD(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = at(e, "modelValue"), {
      positionClasses: r
    } = od(e), {
      scopeId: s
    } = Il(), {
      themeClasses: a
    } = Zt(e), {
      colorClasses: l,
      colorStyles: c,
      variantClasses: d
    } = qa(e), {
      roundedClasses: f
    } = Cn(e), m = CD(() => Number(e.timeout)), g = ue(), v = ue(), p = Ie(!1), _ = Ie(0), x = ue(), S = gt(Am, void 0);
    _r(() => !!S, () => {
      const B = uD();
      Xn(() => {
        x.value = B.mainStyles.value;
      });
    }), Se(i, M), Se(() => e.timeout, M), Jn(() => {
      i.value && M();
    });
    let T = -1;
    function M() {
      m.reset(), window.clearTimeout(T);
      const B = Number(e.timeout);
      if (!i.value || B === -1)
        return;
      const N = dm(v.value);
      m.start(N), T = window.setTimeout(() => {
        i.value = !1;
      }, B);
    }
    function E() {
      m.reset(), window.clearTimeout(T);
    }
    function D() {
      p.value = !0, E();
    }
    function R() {
      p.value = !1, M();
    }
    function $(B) {
      _.value = B.touches[0].clientY;
    }
    function A(B) {
      Math.abs(_.value - B.changedTouches[0].clientY) > 50 && (i.value = !1);
    }
    function V() {
      p.value && R();
    }
    const H = I(() => e.location.split(" ").reduce((B, N) => (B[`v-snackbar--${N}`] = !0, B), {}));
    return ke(() => {
      const B = ns.filterProps(e), N = !!(n.default || n.text || e.text);
      return b(ns, fe({
        ref: g,
        class: ["v-snackbar", {
          "v-snackbar--active": i.value,
          "v-snackbar--multi-line": e.multiLine && !e.vertical,
          "v-snackbar--timer": !!e.timer,
          "v-snackbar--vertical": e.vertical
        }, H.value, r.value, e.class],
        style: [x.value, e.style]
      }, B, {
        modelValue: i.value,
        "onUpdate:modelValue": (q) => i.value = q,
        contentProps: fe({
          class: ["v-snackbar__wrapper", a.value, l.value, f.value, d.value],
          style: [c.value],
          onPointerenter: D,
          onPointerleave: R
        }, B.contentProps),
        persistent: !0,
        noClickAnimation: !0,
        scrim: !1,
        scrollStrategy: "none",
        _disableGlobalStack: !0,
        onTouchstartPassive: $,
        onTouchend: A,
        onAfterLeave: V
      }, s), {
        default: () => {
          var q, X;
          return [Ua(!1, "v-snackbar"), e.timer && !p.value && b("div", {
            key: "timer",
            class: "v-snackbar__timer"
          }, [b(id, {
            ref: v,
            color: typeof e.timer == "string" ? e.timer : "info",
            max: e.timeout,
            "model-value": m.time.value
          }, null)]), N && b("div", {
            key: "content",
            class: "v-snackbar__content",
            role: "status",
            "aria-live": "polite"
          }, [((q = n.text) == null ? void 0 : q.call(n)) ?? e.text, (X = n.default) == null ? void 0 : X.call(n)]), n.actions && b(Mt, {
            defaults: {
              VBtn: {
                variant: "text",
                ripple: !1,
                slim: !0
              }
            }
          }, {
            default: () => [b("div", {
              class: "v-snackbar__actions"
            }, [n.actions({
              isActive: i
            })])]
          })];
        },
        activator: n.activator
      });
    }), ls({}, g);
  }
}), PD = /* @__PURE__ */ Je({
  __name: "RHDHVSnackbar",
  props: {
    excludedHttpMethods: {
      type: Array,
      default: () => []
    },
    successColor: {
      type: String,
      default: "#2AA18D"
    },
    errorColor: {
      type: String,
      default: "#D70C00"
    }
  },
  setup(e) {
    const t = e, n = ue(""), i = ue(""), r = ue(null), s = ue(!1), a = ue(5e3);
    let l = gt("eventBus");
    l || (l = n_().bus);
    const c = ({
      inputMessage: d,
      inputStatusCode: f,
      inputHttpMethod: m,
      inputTimeout: g = 5e3,
      inputStatusText: v
    }) => {
      m && t.excludedHttpMethods.includes(m.toUpperCase()) || (f >= 200 && f < 300 ? (n.value = pD(f, v), i.value = t.successColor) : f >= 400 && (n.value = bD(d), i.value = t.errorColor), a.value = g, s.value = !0, r.value = f);
    };
    return Se(
      () => l.value.get("error"),
      async (d) => {
        if (d) {
          const f = await d[0];
          c({
            inputMessage: f.statusText,
            inputStatusCode: f.status,
            inputHttpMethod: f.method,
            inputStatusText: f.statusText
          });
        } else
          return;
      }
    ), Se(
      () => l.value.get("success"),
      async (d) => {
        if (d) {
          const f = await d[0];
          c({
            inputMessage: "",
            inputStatusCode: f.status,
            inputHttpMethod: f.method,
            inputStatusText: f.statusText
          });
        } else
          return;
      }
    ), (d, f) => (le(), Te(ID, fe({
      color: i.value,
      timeout: a.value,
      modelValue: s.value,
      "onUpdate:modelValue": f[1] || (f[1] = (m) => s.value = m),
      class: "opacity"
    }, d.$attrs), {
      actions: Z(() => [
        b(rt, {
          icon: "mdi-close",
          color: "text-white",
          size: "small",
          onClick: f[0] || (f[0] = Dt((m) => s.value = !1, ["stop"]))
        })
      ]),
      default: Z(() => [
        Ee(At(n.value) + " ", 1)
      ]),
      _: 1
    }, 16, ["color", "timeout", "modelValue"]));
  }
}), OD = /* @__PURE__ */ Tr(PD, [["__scopeId", "data-v-3ccd7a39"]]), i_ = /* @__PURE__ */ Je({
  inheritAttrs: !1,
  __name: "AppBackground",
  props: {
    backgroundColor: { type: String, required: !1, default: " #f6f6f6" }
  },
  setup(e) {
    return (t, n) => (le(), nt("div", {
      style: Qr({
        backgroundColor: e.backgroundColor
      }),
      class: "fill-height"
    }, [
      b(Ir, {
        class: D0(["fill-height", t.$attrs.class]),
        style: Qr({
          border: `24px solid ${e.backgroundColor}`,
          "border-radius": "32px !important"
        }),
        flat: ""
      }, {
        default: Z(() => [
          wt(t.$slots, "default")
        ]),
        _: 3
      }, 8, ["style", "class"])
    ], 4));
  }
});
function ED(e) {
  let {
    selectedElement: t,
    containerElement: n,
    isRtl: i,
    isHorizontal: r
  } = e;
  const s = cl(r, n), a = r_(r, i, n), l = cl(r, t), c = s_(r, t), d = l * 0.4;
  return a > c ? c - d : a + s < c + l ? c - s + l + d : a;
}
function AD(e) {
  let {
    selectedElement: t,
    containerElement: n,
    isHorizontal: i
  } = e;
  const r = cl(i, n), s = s_(i, t), a = cl(i, t);
  return s - r / 2 + a / 2;
}
function vp(e, t) {
  const n = e ? "scrollWidth" : "scrollHeight";
  return (t == null ? void 0 : t[n]) || 0;
}
function MD(e, t) {
  const n = e ? "clientWidth" : "clientHeight";
  return (t == null ? void 0 : t[n]) || 0;
}
function r_(e, t, n) {
  if (!n)
    return 0;
  const {
    scrollLeft: i,
    offsetWidth: r,
    scrollWidth: s
  } = n;
  return e ? t ? s - r + i : i : n.scrollTop;
}
function cl(e, t) {
  const n = e ? "offsetWidth" : "offsetHeight";
  return (t == null ? void 0 : t[n]) || 0;
}
function s_(e, t) {
  const n = e ? "offsetLeft" : "offsetTop";
  return (t == null ? void 0 : t[n]) || 0;
}
const DD = Symbol.for("vuetify:v-slide-group"), a_ = ee({
  centerActive: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  symbol: {
    type: null,
    default: DD
  },
  nextIcon: {
    type: He,
    default: "$next"
  },
  prevIcon: {
    type: He,
    default: "$prev"
  },
  showArrows: {
    type: [Boolean, String],
    validator: (e) => typeof e == "boolean" || ["always", "desktop", "mobile"].includes(e)
  },
  ...Ae(),
  ...Jc({
    mobile: null
  }),
  ...pt(),
  ...Om({
    selectedClass: "v-slide-group-item--active"
  })
}, "VSlideGroup"), yp = pe()({
  name: "VSlideGroup",
  props: a_(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      isRtl: i
    } = Tn(), {
      displayClasses: r,
      mobile: s
    } = js(e), a = Em(e, e.symbol), l = Ie(!1), c = Ie(0), d = Ie(0), f = Ie(0), m = I(() => e.direction === "horizontal"), {
      resizeRef: g,
      contentRect: v
    } = Ws(), {
      resizeRef: p,
      contentRect: _
    } = Ws(), x = SD(), S = I(() => ({
      container: g.el,
      duration: 200,
      easing: "easeOutQuart"
    })), T = I(() => a.selected.value.length ? a.items.value.findIndex((G) => G.id === a.selected.value[0]) : -1), M = I(() => a.selected.value.length ? a.items.value.findIndex((G) => G.id === a.selected.value[a.selected.value.length - 1]) : -1);
    if (Bt) {
      let G = -1;
      Se(() => [a.selected.value, v.value, _.value, m.value], () => {
        cancelAnimationFrame(G), G = requestAnimationFrame(() => {
          if (v.value && _.value) {
            const ie = m.value ? "width" : "height";
            d.value = v.value[ie], f.value = _.value[ie], l.value = d.value + 1 < f.value;
          }
          if (T.value >= 0 && p.el) {
            const ie = p.el.children[M.value];
            D(ie, e.centerActive);
          }
        });
      });
    }
    const E = Ie(!1);
    function D(G, ie) {
      let ge = 0;
      ie ? ge = AD({
        containerElement: g.el,
        isHorizontal: m.value,
        selectedElement: G
      }) : ge = ED({
        containerElement: g.el,
        isHorizontal: m.value,
        isRtl: i.value,
        selectedElement: G
      }), R(ge);
    }
    function R(G) {
      if (!Bt || !g.el)
        return;
      const ie = cl(m.value, g.el), ge = r_(m.value, i.value, g.el);
      if (!(vp(m.value, g.el) <= ie || // Prevent scrolling by only a couple of pixels, which doesn't look smooth
      Math.abs(G - ge) < 16)) {
        if (m.value && i.value && g.el) {
          const {
            scrollWidth: Oe,
            offsetWidth: Q
          } = g.el;
          G = Oe - Q - G;
        }
        m.value ? x.horizontal(G, S.value) : x(G, S.value);
      }
    }
    function $(G) {
      const {
        scrollTop: ie,
        scrollLeft: ge
      } = G.target;
      c.value = m.value ? ge : ie;
    }
    function A(G) {
      if (E.value = !0, !(!l.value || !p.el)) {
        for (const ie of G.composedPath())
          for (const ge of p.el.children)
            if (ge === ie) {
              D(ge);
              return;
            }
      }
    }
    function V(G) {
      E.value = !1;
    }
    let H = !1;
    function B(G) {
      var ie;
      !H && !E.value && !(G.relatedTarget && ((ie = p.el) != null && ie.contains(G.relatedTarget))) && se(), H = !1;
    }
    function N() {
      H = !0;
    }
    function q(G) {
      if (!p.el)
        return;
      function ie(ge) {
        G.preventDefault(), se(ge);
      }
      m.value ? G.key === "ArrowRight" ? ie(i.value ? "prev" : "next") : G.key === "ArrowLeft" && ie(i.value ? "next" : "prev") : G.key === "ArrowDown" ? ie("next") : G.key === "ArrowUp" && ie("prev"), G.key === "Home" ? ie("first") : G.key === "End" && ie("last");
    }
    function X(G, ie) {
      if (!G)
        return;
      let ge = G;
      do
        ge = ge == null ? void 0 : ge[ie === "next" ? "nextElementSibling" : "previousElementSibling"];
      while (ge != null && ge.hasAttribute("disabled"));
      return ge;
    }
    function se(G) {
      if (!p.el)
        return;
      let ie;
      if (!G)
        ie = sl(p.el)[0];
      else if (G === "next") {
        if (ie = X(p.el.querySelector(":focus"), G), !ie)
          return se("first");
      } else if (G === "prev") {
        if (ie = X(p.el.querySelector(":focus"), G), !ie)
          return se("last");
      } else
        G === "first" ? (ie = p.el.firstElementChild, ie != null && ie.hasAttribute("disabled") && (ie = X(ie, "next"))) : G === "last" && (ie = p.el.lastElementChild, ie != null && ie.hasAttribute("disabled") && (ie = X(ie, "prev")));
      ie && ie.focus({
        preventScroll: !0
      });
    }
    function de(G) {
      const ie = m.value && i.value ? -1 : 1, ge = (G === "prev" ? -ie : ie) * d.value;
      let he = c.value + ge;
      if (m.value && i.value && g.el) {
        const {
          scrollWidth: Oe,
          offsetWidth: Q
        } = g.el;
        he += Oe - Q;
      }
      R(he);
    }
    const _e = I(() => ({
      next: a.next,
      prev: a.prev,
      select: a.select,
      isSelected: a.isSelected
    })), be = I(() => {
      switch (e.showArrows) {
        case "always":
          return !0;
        case "desktop":
          return !s.value;
        case !0:
          return l.value || Math.abs(c.value) > 0;
        case "mobile":
          return s.value || l.value || Math.abs(c.value) > 0;
        default:
          return !s.value && (l.value || Math.abs(c.value) > 0);
      }
    }), oe = I(() => Math.abs(c.value) > 1), J = I(() => {
      if (!g.value)
        return !1;
      const G = vp(m.value, g.el), ie = MD(m.value, g.el);
      return G - ie - Math.abs(c.value) > 1;
    });
    return ke(() => b(e.tag, {
      class: ["v-slide-group", {
        "v-slide-group--vertical": !m.value,
        "v-slide-group--has-affixes": be.value,
        "v-slide-group--is-overflowing": l.value
      }, r.value, e.class],
      style: e.style,
      tabindex: E.value || a.selected.value.length ? -1 : 0,
      onFocus: B
    }, {
      default: () => {
        var G, ie, ge;
        return [be.value && b("div", {
          key: "prev",
          class: ["v-slide-group__prev", {
            "v-slide-group__prev--disabled": !oe.value
          }],
          onMousedown: N,
          onClick: () => oe.value && de("prev")
        }, [((G = n.prev) == null ? void 0 : G.call(n, _e.value)) ?? b(np, null, {
          default: () => [b(dt, {
            icon: i.value ? e.nextIcon : e.prevIcon
          }, null)]
        })]), b("div", {
          key: "container",
          ref: g,
          class: "v-slide-group__container",
          onScroll: $
        }, [b("div", {
          ref: p,
          class: "v-slide-group__content",
          onFocusin: A,
          onFocusout: V,
          onKeydown: q
        }, [(ie = n.default) == null ? void 0 : ie.call(n, _e.value)])]), be.value && b("div", {
          key: "next",
          class: ["v-slide-group__next", {
            "v-slide-group__next--disabled": !J.value
          }],
          onMousedown: N,
          onClick: () => J.value && de("next")
        }, [((ge = n.next) == null ? void 0 : ge.call(n, _e.value)) ?? b(np, null, {
          default: () => [b(dt, {
            icon: i.value ? e.prevIcon : e.nextIcon
          }, null)]
        })])];
      }
    })), {
      selected: a.selected,
      scrollTo: de,
      scrollOffset: c,
      focus: se,
      hasPrev: oe,
      hasNext: J
    };
  }
}), o_ = Symbol.for("vuetify:v-chip-group"), VD = ee({
  column: Boolean,
  filter: Boolean,
  valueComparator: {
    type: Function,
    default: Sr
  },
  ...a_(),
  ...Ae(),
  ...Om({
    selectedClass: "v-chip--selected"
  }),
  ...pt(),
  ...$t(),
  ...Ji({
    variant: "tonal"
  })
}, "VChipGroup");
pe()({
  name: "VChipGroup",
  props: VD(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: i
    } = Zt(e), {
      isSelected: r,
      select: s,
      next: a,
      prev: l,
      selected: c
    } = Em(e, o_);
    return yi({
      VChip: {
        color: ce(e, "color"),
        disabled: ce(e, "disabled"),
        filter: ce(e, "filter"),
        variant: ce(e, "variant")
      }
    }), ke(() => {
      const d = yp.filterProps(e);
      return b(yp, fe(d, {
        class: ["v-chip-group", {
          "v-chip-group--column": e.column
        }, i.value, e.class],
        style: e.style
      }), {
        default: () => {
          var f;
          return [(f = n.default) == null ? void 0 : f.call(n, {
            isSelected: r,
            select: s,
            next: a,
            prev: l,
            selected: c.value
          })];
        }
      });
    }), {};
  }
});
const LD = ee({
  activeClass: String,
  appendAvatar: String,
  appendIcon: He,
  closable: Boolean,
  closeIcon: {
    type: He,
    default: "$delete"
  },
  closeLabel: {
    type: String,
    default: "$vuetify.close"
  },
  draggable: Boolean,
  filter: Boolean,
  filterIcon: {
    type: He,
    default: "$complete"
  },
  label: Boolean,
  link: {
    type: Boolean,
    default: void 0
  },
  pill: Boolean,
  prependAvatar: String,
  prependIcon: He,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  text: String,
  modelValue: {
    type: Boolean,
    default: !0
  },
  onClick: cn(),
  onClickOnce: cn(),
  ...Ki(),
  ...Ae(),
  ...Qn(),
  ...Xi(),
  ...Xx(),
  ...vn(),
  ...kl(),
  ...Ha(),
  ...pt({
    tag: "span"
  }),
  ...$t(),
  ...Ji({
    variant: "tonal"
  })
}, "VChip"), Ic = pe()({
  name: "VChip",
  directives: {
    Ripple: ja
  },
  props: LD(),
  emits: {
    "click:close": (e) => !0,
    "update:modelValue": (e) => !0,
    "group:selected": (e) => !0,
    click: (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: i,
      slots: r
    } = t;
    const {
      t: s
    } = os(), {
      borderClasses: a
    } = kr(e), {
      colorClasses: l,
      colorStyles: c,
      variantClasses: d
    } = qa(e), {
      densityClasses: f
    } = Mi(e), {
      elevationClasses: m
    } = Cr(e), {
      roundedClasses: g
    } = Cn(e), {
      sizeClasses: v
    } = Cl(e), {
      themeClasses: p
    } = Zt(e), _ = at(e, "modelValue"), x = Jx(e, o_, !1), S = Sl(e, n), T = I(() => e.link !== !1 && S.isLink.value), M = I(() => !e.disabled && e.link !== !1 && (!!x || e.link || S.isClickable.value)), E = I(() => ({
      "aria-label": s(e.closeLabel),
      onClick($) {
        $.preventDefault(), $.stopPropagation(), _.value = !1, i("click:close", $);
      }
    }));
    function D($) {
      var A;
      i("click", $), M.value && ((A = S.navigate) == null || A.call(S, $), x == null || x.toggle());
    }
    function R($) {
      ($.key === "Enter" || $.key === " ") && ($.preventDefault(), D($));
    }
    return () => {
      var se;
      const $ = S.isLink.value ? "a" : e.tag, A = !!(e.appendIcon || e.appendAvatar), V = !!(A || r.append), H = !!(r.close || e.closable), B = !!(r.filter || e.filter) && x, N = !!(e.prependIcon || e.prependAvatar), q = !!(N || r.prepend), X = !x || x.isSelected.value;
      return _.value && rn(b($, fe({
        class: ["v-chip", {
          "v-chip--disabled": e.disabled,
          "v-chip--label": e.label,
          "v-chip--link": M.value,
          "v-chip--filter": B,
          "v-chip--pill": e.pill,
          [`${e.activeClass}`]: e.activeClass && ((se = S.isActive) == null ? void 0 : se.value)
        }, p.value, a.value, X ? l.value : void 0, f.value, m.value, g.value, v.value, d.value, x == null ? void 0 : x.selectedClass.value, e.class],
        style: [X ? c.value : void 0, e.style],
        disabled: e.disabled || void 0,
        draggable: e.draggable,
        tabindex: M.value ? 0 : void 0,
        onClick: D,
        onKeydown: M.value && !T.value && R
      }, S.linkProps), {
        default: () => {
          var de;
          return [Ua(M.value, "v-chip"), B && b(vx, {
            key: "filter"
          }, {
            default: () => [rn(b("div", {
              class: "v-chip__filter"
            }, [r.filter ? b(Mt, {
              key: "filter-defaults",
              disabled: !e.filterIcon,
              defaults: {
                VIcon: {
                  icon: e.filterIcon
                }
              }
            }, r.filter) : b(dt, {
              key: "filter-icon",
              icon: e.filterIcon
            }, null)]), [[qs, x.isSelected.value]])]
          }), q && b("div", {
            key: "prepend",
            class: "v-chip__prepend"
          }, [r.prepend ? b(Mt, {
            key: "prepend-defaults",
            disabled: !N,
            defaults: {
              VAvatar: {
                image: e.prependAvatar,
                start: !0
              },
              VIcon: {
                icon: e.prependIcon,
                start: !0
              }
            }
          }, r.prepend) : b(Le, null, [e.prependIcon && b(dt, {
            key: "prepend-icon",
            icon: e.prependIcon,
            start: !0
          }, null), e.prependAvatar && b(es, {
            key: "prepend-avatar",
            image: e.prependAvatar,
            start: !0
          }, null)])]), b("div", {
            class: "v-chip__content",
            "data-no-activator": ""
          }, [((de = r.default) == null ? void 0 : de.call(r, {
            isSelected: x == null ? void 0 : x.isSelected.value,
            selectedClass: x == null ? void 0 : x.selectedClass.value,
            select: x == null ? void 0 : x.select,
            toggle: x == null ? void 0 : x.toggle,
            value: x == null ? void 0 : x.value.value,
            disabled: e.disabled
          })) ?? e.text]), V && b("div", {
            key: "append",
            class: "v-chip__append"
          }, [r.append ? b(Mt, {
            key: "append-defaults",
            disabled: !A,
            defaults: {
              VAvatar: {
                end: !0,
                image: e.appendAvatar
              },
              VIcon: {
                end: !0,
                icon: e.appendIcon
              }
            }
          }, r.append) : b(Le, null, [e.appendIcon && b(dt, {
            key: "append-icon",
            end: !0,
            icon: e.appendIcon
          }, null), e.appendAvatar && b(es, {
            key: "append-avatar",
            end: !0,
            image: e.appendAvatar
          }, null)])]), H && b("button", fe({
            key: "close",
            class: "v-chip__close",
            type: "button",
            "data-testid": "close-chip"
          }, E.value), [r.close ? b(Mt, {
            key: "close-defaults",
            defaults: {
              VIcon: {
                icon: e.closeIcon,
                size: "x-small"
              }
            }
          }, r.close) : b(dt, {
            key: "close-icon",
            icon: e.closeIcon,
            size: "x-small"
          }, null)])];
        }
      }), [[ji("ripple"), M.value && e.ripple, null]]);
    };
  }
}), FD = ee({
  id: String,
  text: String,
  ...Gi(Pl({
    closeOnBack: !1,
    location: "end",
    locationStrategy: "connected",
    eager: !0,
    minWidth: 0,
    offset: 10,
    openOnClick: !1,
    openOnHover: !0,
    origin: "auto",
    scrim: !1,
    scrollStrategy: "reposition",
    transition: !1
  }), ["absolute", "persistent"])
}, "VTooltip"), dl = pe()({
  name: "VTooltip",
  props: FD(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = at(e, "modelValue"), {
      scopeId: r
    } = Il(), s = pi(), a = I(() => e.id || `v-tooltip-${s}`), l = ue(), c = I(() => e.location.split(" ").length > 1 ? e.location : e.location + " center"), d = I(() => e.origin === "auto" || e.origin === "overlap" || e.origin.split(" ").length > 1 || e.location.split(" ").length > 1 ? e.origin : e.origin + " center"), f = I(() => e.transition ? e.transition : i.value ? "scale-transition" : "fade-transition"), m = I(() => fe({
      "aria-describedby": a.value
    }, e.activatorProps));
    return ke(() => {
      const g = ns.filterProps(e);
      return b(ns, fe({
        ref: l,
        class: ["v-tooltip", e.class],
        style: e.style,
        id: a.value
      }, g, {
        modelValue: i.value,
        "onUpdate:modelValue": (v) => i.value = v,
        transition: f.value,
        absolute: !0,
        location: c.value,
        origin: d.value,
        persistent: !0,
        role: "tooltip",
        activatorProps: m.value,
        _disableGlobalStack: !0
      }, r), {
        activator: n.activator,
        default: function() {
          var x;
          for (var v = arguments.length, p = new Array(v), _ = 0; _ < v; _++)
            p[_] = arguments[_];
          return ((x = n.default) == null ? void 0 : x.call(n, ...p)) ?? e.text;
        }
      });
    }), ls({}, l);
  }
}), RD = { style: { "font-weight": "400", opacity: "1" } }, BD = { class: "pl-4" }, ND = { style: { color: "rgba(0, 0, 0, 0.7)", "font-size": "14px", "font-family": "Roboto, sans-serif" } }, $D = { key: 1 }, l_ = /* @__PURE__ */ Je({
  __name: "ProjectCard",
  props: {
    item: { type: Object, required: !0 },
    workOrderKey: { type: String, required: !1, default: "work_order" },
    canEdit: { type: Boolean, required: !1, default: !0 },
    canDelete: { type: Boolean, required: !1, default: !0 },
    disableDelete: { type: Boolean, required: !1, default: !1 }
  },
  emits: ["navigateToProject", "edit", "delete"],
  setup(e, { emit: t }) {
    const n = e, i = ue(!1), r = t;
    return (s, a) => (le(), Te(Ir, fe({
      class: "d-flex flex-column fill-height",
      onClick: a[2] || (a[2] = Dt((l) => r("navigateToProject", e.item.id), ["stop"])),
      elevation: i.value ? 4 : 2,
      hover: ""
    }, n, {
      onMouseout: a[3] || (a[3] = (l) => i.value = !1),
      onMouseover: a[4] || (a[4] = (l) => i.value = !0)
    }), {
      default: Z(() => {
        var l, c, d;
        return [
          b(Va, { class: "pt-4" }, {
            default: Z(() => [
              St("span", RD, At(e.item[n.workOrderKey]), 1)
            ]),
            _: 1
          }),
          b(Gs, { class: "pt-1" }, {
            default: Z(() => [
              St("span", null, At(e.item.name), 1)
            ]),
            _: 1
          }),
          St("div", BD, [
            (l = e.item) != null && l.location ? (le(), Te(Ic, {
              key: 0,
              class: "mr-3",
              label: "",
              "prepend-icon": "mdi-map-marker",
              size: "x-small"
            }, {
              default: Z(() => [
                Ee(At(e.item.location), 1)
              ]),
              _: 1
            })) : it("", !0),
            (c = e.item) != null && c.sourceApplication && ((d = e.item) == null ? void 0 : d.sourceApplication) !== " " ? (le(), Te(Ic, {
              key: 1,
              class: "mr-3",
              label: "",
              "prepend-icon": "mdi-calculator",
              size: "x-small"
            }, {
              default: Z(() => [
                Ee(At(e.item.sourceApplication), 1)
              ]),
              _: 1
            })) : it("", !0),
            St("span", ND, At(e.item.client), 1)
          ]),
          e.item.description ? (le(), Te(dl, {
            key: 0,
            location: "bottom",
            "max-width": "400px",
            style: { "overflow-wrap": "break-word" }
          }, {
            activator: Z(({ props: f }) => [
              b(La, fe({ class: "elip pt-4 pb-2" }, f), {
                default: Z(() => [
                  Ee(At(e.item.description), 1)
                ]),
                _: 2
              }, 1040)
            ]),
            default: Z(() => [
              St("span", { ref: "element" }, At(e.item.description), 513)
            ]),
            _: 1
          })) : (le(), Te(La, {
            key: 1,
            class: "elip pt-4 pb-2"
          }, {
            default: Z(() => [
              Ee("-")
            ]),
            _: 1
          })),
          b(Ol, {
            class: "justify-end",
            style: { "background-color": "#f6f6f6" }
          }, {
            default: Z(() => [
              e.canEdit ? (le(), Te(rt, {
                key: 0,
                icon: "mdi-pencil",
                onClick: a[0] || (a[0] = Dt(() => r("edit", e.item), ["stop"])),
                flat: "",
                size: "24",
                variant: "text"
              })) : it("", !0),
              e.disableDelete ? it("", !0) : (le(), nt("div", $D, [
                e.canDelete ? (le(), Te(rt, {
                  key: 0,
                  icon: "mdi-delete-outline",
                  onClick: a[1] || (a[1] = Dt(() => r("delete", e.item), ["stop"])),
                  flat: "",
                  size: "24",
                  variant: "text",
                  class: "ml-2"
                })) : it("", !0)
              ]))
            ]),
            _: 1
          })
        ];
      }),
      _: 1
    }, 16, ["elevation"]));
  }
}), zD = /* @__PURE__ */ Je({
  __name: "MenuButton",
  props: {
    loading: { type: Boolean, required: !1, default: !1 },
    canEdit: { type: Boolean, required: !1, default: !0 },
    canDelete: { type: Boolean, required: !1, default: !0 }
  },
  emits: ["edit", "delete"],
  setup(e, { emit: t }) {
    const n = t;
    return (i, r) => (le(), Te(td, null, {
      activator: Z(({ props: s }) => [
        b(rt, fe({
          icon: "mdi-dots-vertical",
          loading: e.loading,
          size: "small",
          variant: "text",
          onMousedown: r[0] || (r[0] = Dt(() => {
          }, ["stop"]))
        }, s), null, 16, ["loading"])
      ]),
      default: Z(() => [
        e.loading ? it("", !0) : (le(), Te(Tm, {
          key: 0,
          density: "compact"
        }, {
          default: Z(() => [
            b(ts, {
              onClick: r[1] || (r[1] = (s) => n("edit")),
              disabled: !e.canEdit
            }, {
              default: Z(() => [
                b(ol, null, {
                  default: Z(() => [
                    b(Da, null, {
                      default: Z(() => [
                        b(hi, { cols: "4" }, {
                          default: Z(() => [
                            b(dt, null, {
                              default: Z(() => [
                                Ee(" mdi-pencil")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        b(hi, null, {
                          default: Z(() => [
                            Ee(" Edit")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            wt(i.$slots, "menu-list-items"),
            b(ts, {
              onClick: r[2] || (r[2] = (s) => n("delete")),
              disabled: !e.canDelete
            }, {
              default: Z(() => [
                b(ol, null, {
                  default: Z(() => [
                    b(Da, null, {
                      default: Z(() => [
                        b(hi, { cols: "4" }, {
                          default: Z(() => [
                            b(dt, null, {
                              default: Z(() => [
                                Ee(" mdi-delete")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        b(hi, null, {
                          default: Z(() => [
                            Ee(" Delete")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 3
        }))
      ]),
      _: 3
    }));
  }
});
class Ys extends Error {
}
class HD extends Ys {
  constructor(t) {
    super(`Invalid DateTime: ${t.toMessage()}`);
  }
}
class WD extends Ys {
  constructor(t) {
    super(`Invalid Interval: ${t.toMessage()}`);
  }
}
class UD extends Ys {
  constructor(t) {
    super(`Invalid Duration: ${t.toMessage()}`);
  }
}
class Ta extends Ys {
}
class u_ extends Ys {
  constructor(t) {
    super(`Invalid unit ${t}`);
  }
}
class Vn extends Ys {
}
class Hr extends Ys {
  constructor() {
    super("Zone is an abstract class");
  }
}
const ye = "numeric", Ai = "short", Kn = "long", Pc = {
  year: ye,
  month: ye,
  day: ye
}, c_ = {
  year: ye,
  month: Ai,
  day: ye
}, qD = {
  year: ye,
  month: Ai,
  day: ye,
  weekday: Ai
}, d_ = {
  year: ye,
  month: Kn,
  day: ye
}, f_ = {
  year: ye,
  month: Kn,
  day: ye,
  weekday: Kn
}, h_ = {
  hour: ye,
  minute: ye
}, m_ = {
  hour: ye,
  minute: ye,
  second: ye
}, g_ = {
  hour: ye,
  minute: ye,
  second: ye,
  timeZoneName: Ai
}, v_ = {
  hour: ye,
  minute: ye,
  second: ye,
  timeZoneName: Kn
}, y_ = {
  hour: ye,
  minute: ye,
  hourCycle: "h23"
}, p_ = {
  hour: ye,
  minute: ye,
  second: ye,
  hourCycle: "h23"
}, b_ = {
  hour: ye,
  minute: ye,
  second: ye,
  hourCycle: "h23",
  timeZoneName: Ai
}, x_ = {
  hour: ye,
  minute: ye,
  second: ye,
  hourCycle: "h23",
  timeZoneName: Kn
}, __ = {
  year: ye,
  month: ye,
  day: ye,
  hour: ye,
  minute: ye
}, w_ = {
  year: ye,
  month: ye,
  day: ye,
  hour: ye,
  minute: ye,
  second: ye
}, S_ = {
  year: ye,
  month: Ai,
  day: ye,
  hour: ye,
  minute: ye
}, k_ = {
  year: ye,
  month: Ai,
  day: ye,
  hour: ye,
  minute: ye,
  second: ye
}, jD = {
  year: ye,
  month: Ai,
  day: ye,
  weekday: Ai,
  hour: ye,
  minute: ye
}, C_ = {
  year: ye,
  month: Kn,
  day: ye,
  hour: ye,
  minute: ye,
  timeZoneName: Ai
}, T_ = {
  year: ye,
  month: Kn,
  day: ye,
  hour: ye,
  minute: ye,
  second: ye,
  timeZoneName: Ai
}, I_ = {
  year: ye,
  month: Kn,
  day: ye,
  weekday: Kn,
  hour: ye,
  minute: ye,
  timeZoneName: Kn
}, P_ = {
  year: ye,
  month: Kn,
  day: ye,
  weekday: Kn,
  hour: ye,
  minute: ye,
  second: ye,
  timeZoneName: Kn
};
class Al {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new Hr();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new Hr();
  }
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new Hr();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, n) {
    throw new Hr();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    throw new Hr();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    throw new Hr();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    throw new Hr();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new Hr();
  }
}
let Kf = null;
class ld extends Al {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return Kf === null && (Kf = new ld()), Kf;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(t, { format: n, locale: i }) {
    return R_(t, n, i);
  }
  /** @override **/
  formatOffset(t, n) {
    return Xo(this.offset(t), n);
  }
  /** @override **/
  offset(t) {
    return -new Date(t).getTimezoneOffset();
  }
  /** @override **/
  equals(t) {
    return t.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
let mc = {};
function GD(e) {
  return mc[e] || (mc[e] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), mc[e];
}
const YD = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function ZD(e, t) {
  const n = e.format(t).replace(/\u200E/g, ""), i = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, r, s, a, l, c, d, f] = i;
  return [a, r, s, l, c, d, f];
}
function KD(e, t) {
  const n = e.formatToParts(t), i = [];
  for (let r = 0; r < n.length; r++) {
    const { type: s, value: a } = n[r], l = YD[s];
    s === "era" ? i[l] = a : $e(l) || (i[l] = parseInt(a, 10));
  }
  return i;
}
let Ru = {};
class wr extends Al {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(t) {
    return Ru[t] || (Ru[t] = new wr(t)), Ru[t];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    Ru = {}, mc = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */
  static isValidSpecifier(t) {
    return this.isValidZone(t);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(t) {
    if (!t)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: t }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(t) {
    super(), this.zoneName = t, this.valid = wr.isValidZone(t);
  }
  /** @override **/
  get type() {
    return "iana";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(t, { format: n, locale: i }) {
    return R_(t, n, i, this.name);
  }
  /** @override **/
  formatOffset(t, n) {
    return Xo(this.offset(t), n);
  }
  /** @override **/
  offset(t) {
    const n = new Date(t);
    if (isNaN(n))
      return NaN;
    const i = GD(this.name);
    let [r, s, a, l, c, d, f] = i.formatToParts ? KD(i, n) : ZD(i, n);
    l === "BC" && (r = -Math.abs(r) + 1);
    const g = cd({
      year: r,
      month: s,
      day: a,
      hour: c === 24 ? 0 : c,
      minute: d,
      second: f,
      millisecond: 0
    });
    let v = +n;
    const p = v % 1e3;
    return v -= p >= 0 ? p : 1e3 + p, (g - v) / (60 * 1e3);
  }
  /** @override **/
  equals(t) {
    return t.type === "iana" && t.name === this.name;
  }
  /** @override **/
  get isValid() {
    return this.valid;
  }
}
let pp = {};
function XD(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let i = pp[n];
  return i || (i = new Intl.ListFormat(e, t), pp[n] = i), i;
}
let Mh = {};
function Dh(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let i = Mh[n];
  return i || (i = new Intl.DateTimeFormat(e, t), Mh[n] = i), i;
}
let Vh = {};
function JD(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let i = Vh[n];
  return i || (i = new Intl.NumberFormat(e, t), Vh[n] = i), i;
}
let Lh = {};
function QD(e, t = {}) {
  const { base: n, ...i } = t, r = JSON.stringify([e, i]);
  let s = Lh[r];
  return s || (s = new Intl.RelativeTimeFormat(e, t), Lh[r] = s), s;
}
let Uo = null;
function e2() {
  return Uo || (Uo = new Intl.DateTimeFormat().resolvedOptions().locale, Uo);
}
let bp = {};
function t2(e) {
  let t = bp[e];
  if (!t) {
    const n = new Intl.Locale(e);
    t = "getWeekInfo" in n ? n.getWeekInfo() : n.weekInfo, bp[e] = t;
  }
  return t;
}
function n2(e) {
  const t = e.indexOf("-x-");
  t !== -1 && (e = e.substring(0, t));
  const n = e.indexOf("-u-");
  if (n === -1)
    return [e];
  {
    let i, r;
    try {
      i = Dh(e).resolvedOptions(), r = e;
    } catch {
      const c = e.substring(0, n);
      i = Dh(c).resolvedOptions(), r = c;
    }
    const { numberingSystem: s, calendar: a } = i;
    return [r, s, a];
  }
}
function i2(e, t, n) {
  return (n || t) && (e.includes("-u-") || (e += "-u"), n && (e += `-ca-${n}`), t && (e += `-nu-${t}`)), e;
}
function r2(e) {
  const t = [];
  for (let n = 1; n <= 12; n++) {
    const i = Re.utc(2009, n, 1);
    t.push(e(i));
  }
  return t;
}
function s2(e) {
  const t = [];
  for (let n = 1; n <= 7; n++) {
    const i = Re.utc(2016, 11, 13 + n);
    t.push(e(i));
  }
  return t;
}
function Bu(e, t, n, i) {
  const r = e.listingMode();
  return r === "error" ? null : r === "en" ? n(t) : i(t);
}
function a2(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || new Intl.DateTimeFormat(e.intl).resolvedOptions().numberingSystem === "latn";
}
class o2 {
  constructor(t, n, i) {
    this.padTo = i.padTo || 0, this.floor = i.floor || !1;
    const { padTo: r, floor: s, ...a } = i;
    if (!n || Object.keys(a).length > 0) {
      const l = { useGrouping: !1, ...i };
      i.padTo > 0 && (l.minimumIntegerDigits = i.padTo), this.inf = JD(t, l);
    }
  }
  format(t) {
    if (this.inf) {
      const n = this.floor ? Math.floor(t) : t;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(t) : Fm(t, 3);
      return Yt(n, this.padTo);
    }
  }
}
class l2 {
  constructor(t, n, i) {
    this.opts = i, this.originalZone = void 0;
    let r;
    if (this.opts.timeZone)
      this.dt = t;
    else if (t.zone.type === "fixed") {
      const a = -1 * (t.offset / 60), l = a >= 0 ? `Etc/GMT+${a}` : `Etc/GMT${a}`;
      t.offset !== 0 && wr.create(l).valid ? (r = l, this.dt = t) : (r = "UTC", this.dt = t.offset === 0 ? t : t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    } else
      t.zone.type === "system" ? this.dt = t : t.zone.type === "iana" ? (this.dt = t, r = t.zone.name) : (r = "UTC", this.dt = t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    const s = { ...this.opts };
    s.timeZone = s.timeZone || r, this.dtf = Dh(n, s);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: t }) => t).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const t = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? t.map((n) => {
      if (n.type === "timeZoneName") {
        const i = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...n,
          value: i
        };
      } else
        return n;
    }) : t;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class u2 {
  constructor(t, n, i) {
    this.opts = { style: "long", ...i }, !n && L_() && (this.rtf = QD(t, i));
  }
  format(t, n) {
    return this.rtf ? this.rtf.format(t, n) : O2(n, t, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(t, n) {
    return this.rtf ? this.rtf.formatToParts(t, n) : [];
  }
}
const c2 = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class vt {
  static fromOpts(t) {
    return vt.create(
      t.locale,
      t.numberingSystem,
      t.outputCalendar,
      t.weekSettings,
      t.defaultToEN
    );
  }
  static create(t, n, i, r, s = !1) {
    const a = t || Ut.defaultLocale, l = a || (s ? "en-US" : e2()), c = n || Ut.defaultNumberingSystem, d = i || Ut.defaultOutputCalendar, f = Fh(r) || Ut.defaultWeekSettings;
    return new vt(l, c, d, f, a);
  }
  static resetCache() {
    Uo = null, Mh = {}, Vh = {}, Lh = {};
  }
  static fromObject({ locale: t, numberingSystem: n, outputCalendar: i, weekSettings: r } = {}) {
    return vt.create(t, n, i, r);
  }
  constructor(t, n, i, r, s) {
    const [a, l, c] = n2(t);
    this.locale = a, this.numberingSystem = n || l || null, this.outputCalendar = i || c || null, this.weekSettings = r, this.intl = i2(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = s, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = a2(this)), this.fastNumbersCached;
  }
  listingMode() {
    const t = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return t && n ? "en" : "intl";
  }
  clone(t) {
    return !t || Object.getOwnPropertyNames(t).length === 0 ? this : vt.create(
      t.locale || this.specifiedLocale,
      t.numberingSystem || this.numberingSystem,
      t.outputCalendar || this.outputCalendar,
      Fh(t.weekSettings) || this.weekSettings,
      t.defaultToEN || !1
    );
  }
  redefaultToEN(t = {}) {
    return this.clone({ ...t, defaultToEN: !0 });
  }
  redefaultToSystem(t = {}) {
    return this.clone({ ...t, defaultToEN: !1 });
  }
  months(t, n = !1) {
    return Bu(this, t, $_, () => {
      const i = n ? { month: t, day: "numeric" } : { month: t }, r = n ? "format" : "standalone";
      return this.monthsCache[r][t] || (this.monthsCache[r][t] = r2((s) => this.extract(s, i, "month"))), this.monthsCache[r][t];
    });
  }
  weekdays(t, n = !1) {
    return Bu(this, t, W_, () => {
      const i = n ? { weekday: t, year: "numeric", month: "long", day: "numeric" } : { weekday: t }, r = n ? "format" : "standalone";
      return this.weekdaysCache[r][t] || (this.weekdaysCache[r][t] = s2(
        (s) => this.extract(s, i, "weekday")
      )), this.weekdaysCache[r][t];
    });
  }
  meridiems() {
    return Bu(
      this,
      void 0,
      () => U_,
      () => {
        if (!this.meridiemCache) {
          const t = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [Re.utc(2016, 11, 13, 9), Re.utc(2016, 11, 13, 19)].map(
            (n) => this.extract(n, t, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(t) {
    return Bu(this, t, q_, () => {
      const n = { era: t };
      return this.eraCache[t] || (this.eraCache[t] = [Re.utc(-40, 1, 1), Re.utc(2017, 1, 1)].map(
        (i) => this.extract(i, n, "era")
      )), this.eraCache[t];
    });
  }
  extract(t, n, i) {
    const r = this.dtFormatter(t, n), s = r.formatToParts(), a = s.find((l) => l.type.toLowerCase() === i);
    return a ? a.value : null;
  }
  numberFormatter(t = {}) {
    return new o2(this.intl, t.forceSimple || this.fastNumbers, t);
  }
  dtFormatter(t, n = {}) {
    return new l2(t, this.intl, n);
  }
  relFormatter(t = {}) {
    return new u2(this.intl, this.isEnglish(), t);
  }
  listFormatter(t = {}) {
    return XD(this.intl, t);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : F_() ? t2(this.locale) : c2;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(t) {
    return this.locale === t.locale && this.numberingSystem === t.numberingSystem && this.outputCalendar === t.outputCalendar;
  }
}
let Xf = null;
class wn extends Al {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return Xf === null && (Xf = new wn(0)), Xf;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(t) {
    return t === 0 ? wn.utcInstance : new wn(t);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(t) {
    if (t) {
      const n = t.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new wn(dd(n[1], n[2]));
    }
    return null;
  }
  constructor(t) {
    super(), this.fixed = t;
  }
  /** @override **/
  get type() {
    return "fixed";
  }
  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Xo(this.fixed, "narrow")}`;
  }
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Xo(-this.fixed, "narrow")}`;
  }
  /** @override **/
  offsetName() {
    return this.name;
  }
  /** @override **/
  formatOffset(t, n) {
    return Xo(this.fixed, n);
  }
  /** @override **/
  get isUniversal() {
    return !0;
  }
  /** @override **/
  offset() {
    return this.fixed;
  }
  /** @override **/
  equals(t) {
    return t.type === "fixed" && t.fixed === this.fixed;
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
class d2 extends Al {
  constructor(t) {
    super(), this.zoneName = t;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function Gr(e, t) {
  if ($e(e) || e === null)
    return t;
  if (e instanceof Al)
    return e;
  if (m2(e)) {
    const n = e.toLowerCase();
    return n === "default" ? t : n === "local" || n === "system" ? ld.instance : n === "utc" || n === "gmt" ? wn.utcInstance : wn.parseSpecifier(n) || wr.create(e);
  } else
    return Bs(e) ? wn.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new d2(e);
}
let xp = () => Date.now(), _p = "system", wp = null, Sp = null, kp = null, Cp = 60, Tp, Ip = null;
class Ut {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return xp;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(t) {
    xp = t;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(t) {
    _p = t;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return Gr(_p, ld.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return wp;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(t) {
    wp = t;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return Sp;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(t) {
    Sp = t;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return kp;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(t) {
    kp = t;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return Ip;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(t) {
    Ip = Fh(t);
  }
  /**
   * Get the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return Cp;
  }
  /**
   * Set the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // cut-off year is 0, so all 'yy' are interpreted as current century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 1949; '50' -> 2050
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(t) {
    Cp = t % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return Tp;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    Tp = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    vt.resetCache(), wr.resetCache();
  }
}
class Pi {
  constructor(t, n) {
    this.reason = t, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const O_ = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], E_ = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function mi(e, t) {
  return new Pi(
    "unit out of range",
    `you specified ${t} (of type ${typeof t}) as a ${e}, which is invalid`
  );
}
function Dm(e, t, n) {
  const i = new Date(Date.UTC(e, t - 1, n));
  e < 100 && e >= 0 && i.setUTCFullYear(i.getUTCFullYear() - 1900);
  const r = i.getUTCDay();
  return r === 0 ? 7 : r;
}
function A_(e, t, n) {
  return n + (Ml(e) ? E_ : O_)[t - 1];
}
function M_(e, t) {
  const n = Ml(e) ? E_ : O_, i = n.findIndex((s) => s < t), r = t - n[i];
  return { month: i + 1, day: r };
}
function Vm(e, t) {
  return (e - t + 7) % 7 + 1;
}
function Oc(e, t = 4, n = 1) {
  const { year: i, month: r, day: s } = e, a = A_(i, r, s), l = Vm(Dm(i, r, s), n);
  let c = Math.floor((a - l + 14 - t) / 7), d;
  return c < 1 ? (d = i - 1, c = fl(d, t, n)) : c > fl(i, t, n) ? (d = i + 1, c = 1) : d = i, { weekYear: d, weekNumber: c, weekday: l, ...fd(e) };
}
function Pp(e, t = 4, n = 1) {
  const { weekYear: i, weekNumber: r, weekday: s } = e, a = Vm(Dm(i, 1, t), n), l = Pa(i);
  let c = r * 7 + s - a - 7 + t, d;
  c < 1 ? (d = i - 1, c += Pa(d)) : c > l ? (d = i + 1, c -= Pa(i)) : d = i;
  const { month: f, day: m } = M_(d, c);
  return { year: d, month: f, day: m, ...fd(e) };
}
function Jf(e) {
  const { year: t, month: n, day: i } = e, r = A_(t, n, i);
  return { year: t, ordinal: r, ...fd(e) };
}
function Op(e) {
  const { year: t, ordinal: n } = e, { month: i, day: r } = M_(t, n);
  return { year: t, month: i, day: r, ...fd(e) };
}
function Ep(e, t) {
  if (!$e(e.localWeekday) || !$e(e.localWeekNumber) || !$e(e.localWeekYear)) {
    if (!$e(e.weekday) || !$e(e.weekNumber) || !$e(e.weekYear))
      throw new Ta(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return $e(e.localWeekday) || (e.weekday = e.localWeekday), $e(e.localWeekNumber) || (e.weekNumber = e.localWeekNumber), $e(e.localWeekYear) || (e.weekYear = e.localWeekYear), delete e.localWeekday, delete e.localWeekNumber, delete e.localWeekYear, {
      minDaysInFirstWeek: t.getMinDaysInFirstWeek(),
      startOfWeek: t.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function f2(e, t = 4, n = 1) {
  const i = ud(e.weekYear), r = gi(
    e.weekNumber,
    1,
    fl(e.weekYear, t, n)
  ), s = gi(e.weekday, 1, 7);
  return i ? r ? s ? !1 : mi("weekday", e.weekday) : mi("week", e.weekNumber) : mi("weekYear", e.weekYear);
}
function h2(e) {
  const t = ud(e.year), n = gi(e.ordinal, 1, Pa(e.year));
  return t ? n ? !1 : mi("ordinal", e.ordinal) : mi("year", e.year);
}
function D_(e) {
  const t = ud(e.year), n = gi(e.month, 1, 12), i = gi(e.day, 1, Ec(e.year, e.month));
  return t ? n ? i ? !1 : mi("day", e.day) : mi("month", e.month) : mi("year", e.year);
}
function V_(e) {
  const { hour: t, minute: n, second: i, millisecond: r } = e, s = gi(t, 0, 23) || t === 24 && n === 0 && i === 0 && r === 0, a = gi(n, 0, 59), l = gi(i, 0, 59), c = gi(r, 0, 999);
  return s ? a ? l ? c ? !1 : mi("millisecond", r) : mi("second", i) : mi("minute", n) : mi("hour", t);
}
function $e(e) {
  return typeof e > "u";
}
function Bs(e) {
  return typeof e == "number";
}
function ud(e) {
  return typeof e == "number" && e % 1 === 0;
}
function m2(e) {
  return typeof e == "string";
}
function g2(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function L_() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function F_() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function v2(e) {
  return Array.isArray(e) ? e : [e];
}
function Ap(e, t, n) {
  if (e.length !== 0)
    return e.reduce((i, r) => {
      const s = [t(r), r];
      return i && n(i[0], s[0]) === i[0] ? i : s;
    }, null)[1];
}
function y2(e, t) {
  return t.reduce((n, i) => (n[i] = e[i], n), {});
}
function Fa(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Fh(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new Vn("Week settings must be an object");
  if (!gi(e.firstDay, 1, 7) || !gi(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((t) => !gi(t, 1, 7)))
    throw new Vn("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function gi(e, t, n) {
  return ud(e) && e >= t && e <= n;
}
function p2(e, t) {
  return e - t * Math.floor(e / t);
}
function Yt(e, t = 2) {
  const n = e < 0;
  let i;
  return n ? i = "-" + ("" + -e).padStart(t, "0") : i = ("" + e).padStart(t, "0"), i;
}
function jr(e) {
  if (!($e(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function Ts(e) {
  if (!($e(e) || e === null || e === ""))
    return parseFloat(e);
}
function Lm(e) {
  if (!($e(e) || e === null || e === "")) {
    const t = parseFloat("0." + e) * 1e3;
    return Math.floor(t);
  }
}
function Fm(e, t, n = !1) {
  const i = 10 ** t;
  return (n ? Math.trunc : Math.round)(e * i) / i;
}
function Ml(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function Pa(e) {
  return Ml(e) ? 366 : 365;
}
function Ec(e, t) {
  const n = p2(t - 1, 12) + 1, i = e + (t - n) / 12;
  return n === 2 ? Ml(i) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function cd(e) {
  let t = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (t = new Date(t), t.setUTCFullYear(e.year, e.month - 1, e.day)), +t;
}
function Mp(e, t, n) {
  return -Vm(Dm(e, 1, t), n) + t - 1;
}
function fl(e, t = 4, n = 1) {
  const i = Mp(e, t, n), r = Mp(e + 1, t, n);
  return (Pa(e) - i + r) / 7;
}
function Rh(e) {
  return e > 99 ? e : e > Ut.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function R_(e, t, n, i = null) {
  const r = new Date(e), s = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  i && (s.timeZone = i);
  const a = { timeZoneName: t, ...s }, l = new Intl.DateTimeFormat(n, a).formatToParts(r).find((c) => c.type.toLowerCase() === "timezonename");
  return l ? l.value : null;
}
function dd(e, t) {
  let n = parseInt(e, 10);
  Number.isNaN(n) && (n = 0);
  const i = parseInt(t, 10) || 0, r = n < 0 || Object.is(n, -0) ? -i : i;
  return n * 60 + r;
}
function B_(e) {
  const t = Number(e);
  if (typeof e == "boolean" || e === "" || Number.isNaN(t))
    throw new Vn(`Invalid unit value ${e}`);
  return t;
}
function Ac(e, t) {
  const n = {};
  for (const i in e)
    if (Fa(e, i)) {
      const r = e[i];
      if (r == null)
        continue;
      n[t(i)] = B_(r);
    }
  return n;
}
function Xo(e, t) {
  const n = Math.trunc(Math.abs(e / 60)), i = Math.trunc(Math.abs(e % 60)), r = e >= 0 ? "+" : "-";
  switch (t) {
    case "short":
      return `${r}${Yt(n, 2)}:${Yt(i, 2)}`;
    case "narrow":
      return `${r}${n}${i > 0 ? `:${i}` : ""}`;
    case "techie":
      return `${r}${Yt(n, 2)}${Yt(i, 2)}`;
    default:
      throw new RangeError(`Value format ${t} is out of range for property format`);
  }
}
function fd(e) {
  return y2(e, ["hour", "minute", "second", "millisecond"]);
}
const b2 = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], N_ = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], x2 = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function $_(e) {
  switch (e) {
    case "narrow":
      return [...x2];
    case "short":
      return [...N_];
    case "long":
      return [...b2];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const z_ = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], H_ = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], _2 = ["M", "T", "W", "T", "F", "S", "S"];
function W_(e) {
  switch (e) {
    case "narrow":
      return [..._2];
    case "short":
      return [...H_];
    case "long":
      return [...z_];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const U_ = ["AM", "PM"], w2 = ["Before Christ", "Anno Domini"], S2 = ["BC", "AD"], k2 = ["B", "A"];
function q_(e) {
  switch (e) {
    case "narrow":
      return [...k2];
    case "short":
      return [...S2];
    case "long":
      return [...w2];
    default:
      return null;
  }
}
function C2(e) {
  return U_[e.hour < 12 ? 0 : 1];
}
function T2(e, t) {
  return W_(t)[e.weekday - 1];
}
function I2(e, t) {
  return $_(t)[e.month - 1];
}
function P2(e, t) {
  return q_(t)[e.year < 0 ? 0 : 1];
}
function O2(e, t, n = "always", i = !1) {
  const r = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, s = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (n === "auto" && s) {
    const m = e === "days";
    switch (t) {
      case 1:
        return m ? "tomorrow" : `next ${r[e][0]}`;
      case -1:
        return m ? "yesterday" : `last ${r[e][0]}`;
      case 0:
        return m ? "today" : `this ${r[e][0]}`;
    }
  }
  const a = Object.is(t, -0) || t < 0, l = Math.abs(t), c = l === 1, d = r[e], f = i ? c ? d[1] : d[2] || d[1] : c ? r[e][0] : e;
  return a ? `${l} ${f} ago` : `in ${l} ${f}`;
}
function Dp(e, t) {
  let n = "";
  for (const i of e)
    i.literal ? n += i.val : n += t(i.val);
  return n;
}
const E2 = {
  D: Pc,
  DD: c_,
  DDD: d_,
  DDDD: f_,
  t: h_,
  tt: m_,
  ttt: g_,
  tttt: v_,
  T: y_,
  TT: p_,
  TTT: b_,
  TTTT: x_,
  f: __,
  ff: S_,
  fff: C_,
  ffff: I_,
  F: w_,
  FF: k_,
  FFF: T_,
  FFFF: P_
};
class hn {
  static create(t, n = {}) {
    return new hn(t, n);
  }
  static parseFormat(t) {
    let n = null, i = "", r = !1;
    const s = [];
    for (let a = 0; a < t.length; a++) {
      const l = t.charAt(a);
      l === "'" ? (i.length > 0 && s.push({ literal: r || /^\s+$/.test(i), val: i }), n = null, i = "", r = !r) : r || l === n ? i += l : (i.length > 0 && s.push({ literal: /^\s+$/.test(i), val: i }), i = l, n = l);
    }
    return i.length > 0 && s.push({ literal: r || /^\s+$/.test(i), val: i }), s;
  }
  static macroTokenToFormatOpts(t) {
    return E2[t];
  }
  constructor(t, n) {
    this.opts = n, this.loc = t, this.systemLoc = null;
  }
  formatWithSystemDefault(t, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(t, { ...this.opts, ...n }).format();
  }
  dtFormatter(t, n = {}) {
    return this.loc.dtFormatter(t, { ...this.opts, ...n });
  }
  formatDateTime(t, n) {
    return this.dtFormatter(t, n).format();
  }
  formatDateTimeParts(t, n) {
    return this.dtFormatter(t, n).formatToParts();
  }
  formatInterval(t, n) {
    return this.dtFormatter(t.start, n).dtf.formatRange(t.start.toJSDate(), t.end.toJSDate());
  }
  resolvedOptions(t, n) {
    return this.dtFormatter(t, n).resolvedOptions();
  }
  num(t, n = 0) {
    if (this.opts.forceSimple)
      return Yt(t, n);
    const i = { ...this.opts };
    return n > 0 && (i.padTo = n), this.loc.numberFormatter(i).format(t);
  }
  formatDateTimeFromString(t, n) {
    const i = this.loc.listingMode() === "en", r = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", s = (v, p) => this.loc.extract(t, v, p), a = (v) => t.isOffsetFixed && t.offset === 0 && v.allowZ ? "Z" : t.isValid ? t.zone.formatOffset(t.ts, v.format) : "", l = () => i ? C2(t) : s({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), c = (v, p) => i ? I2(t, v) : s(p ? { month: v } : { month: v, day: "numeric" }, "month"), d = (v, p) => i ? T2(t, v) : s(
      p ? { weekday: v } : { weekday: v, month: "long", day: "numeric" },
      "weekday"
    ), f = (v) => {
      const p = hn.macroTokenToFormatOpts(v);
      return p ? this.formatWithSystemDefault(t, p) : v;
    }, m = (v) => i ? P2(t, v) : s({ era: v }, "era"), g = (v) => {
      switch (v) {
        case "S":
          return this.num(t.millisecond);
        case "u":
        case "SSS":
          return this.num(t.millisecond, 3);
        case "s":
          return this.num(t.second);
        case "ss":
          return this.num(t.second, 2);
        case "uu":
          return this.num(Math.floor(t.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(t.millisecond / 100));
        case "m":
          return this.num(t.minute);
        case "mm":
          return this.num(t.minute, 2);
        case "h":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12);
        case "hh":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12, 2);
        case "H":
          return this.num(t.hour);
        case "HH":
          return this.num(t.hour, 2);
        case "Z":
          return a({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return a({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return a({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return t.zone.offsetName(t.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return t.zone.offsetName(t.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return t.zoneName;
        case "a":
          return l();
        case "d":
          return r ? s({ day: "numeric" }, "day") : this.num(t.day);
        case "dd":
          return r ? s({ day: "2-digit" }, "day") : this.num(t.day, 2);
        case "c":
          return this.num(t.weekday);
        case "ccc":
          return d("short", !0);
        case "cccc":
          return d("long", !0);
        case "ccccc":
          return d("narrow", !0);
        case "E":
          return this.num(t.weekday);
        case "EEE":
          return d("short", !1);
        case "EEEE":
          return d("long", !1);
        case "EEEEE":
          return d("narrow", !1);
        case "L":
          return r ? s({ month: "numeric", day: "numeric" }, "month") : this.num(t.month);
        case "LL":
          return r ? s({ month: "2-digit", day: "numeric" }, "month") : this.num(t.month, 2);
        case "LLL":
          return c("short", !0);
        case "LLLL":
          return c("long", !0);
        case "LLLLL":
          return c("narrow", !0);
        case "M":
          return r ? s({ month: "numeric" }, "month") : this.num(t.month);
        case "MM":
          return r ? s({ month: "2-digit" }, "month") : this.num(t.month, 2);
        case "MMM":
          return c("short", !1);
        case "MMMM":
          return c("long", !1);
        case "MMMMM":
          return c("narrow", !1);
        case "y":
          return r ? s({ year: "numeric" }, "year") : this.num(t.year);
        case "yy":
          return r ? s({ year: "2-digit" }, "year") : this.num(t.year.toString().slice(-2), 2);
        case "yyyy":
          return r ? s({ year: "numeric" }, "year") : this.num(t.year, 4);
        case "yyyyyy":
          return r ? s({ year: "numeric" }, "year") : this.num(t.year, 6);
        case "G":
          return m("short");
        case "GG":
          return m("long");
        case "GGGGG":
          return m("narrow");
        case "kk":
          return this.num(t.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(t.weekYear, 4);
        case "W":
          return this.num(t.weekNumber);
        case "WW":
          return this.num(t.weekNumber, 2);
        case "n":
          return this.num(t.localWeekNumber);
        case "nn":
          return this.num(t.localWeekNumber, 2);
        case "ii":
          return this.num(t.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(t.localWeekYear, 4);
        case "o":
          return this.num(t.ordinal);
        case "ooo":
          return this.num(t.ordinal, 3);
        case "q":
          return this.num(t.quarter);
        case "qq":
          return this.num(t.quarter, 2);
        case "X":
          return this.num(Math.floor(t.ts / 1e3));
        case "x":
          return this.num(t.ts);
        default:
          return f(v);
      }
    };
    return Dp(hn.parseFormat(n), g);
  }
  formatDurationFromString(t, n) {
    const i = (c) => {
      switch (c[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, r = (c) => (d) => {
      const f = i(d);
      return f ? this.num(c.get(f), d.length) : d;
    }, s = hn.parseFormat(n), a = s.reduce(
      (c, { literal: d, val: f }) => d ? c : c.concat(f),
      []
    ), l = t.shiftTo(...a.map(i).filter((c) => c));
    return Dp(s, r(l));
  }
}
const j_ = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function Ga(...e) {
  const t = e.reduce((n, i) => n + i.source, "");
  return RegExp(`^${t}$`);
}
function Ya(...e) {
  return (t) => e.reduce(
    ([n, i, r], s) => {
      const [a, l, c] = s(t, r);
      return [{ ...n, ...a }, l || i, c];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function Za(e, ...t) {
  if (e == null)
    return [null, null];
  for (const [n, i] of t) {
    const r = n.exec(e);
    if (r)
      return i(r);
  }
  return [null, null];
}
function G_(...e) {
  return (t, n) => {
    const i = {};
    let r;
    for (r = 0; r < e.length; r++)
      i[e[r]] = jr(t[n + r]);
    return [i, null, n + r];
  };
}
const Y_ = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, A2 = `(?:${Y_.source}?(?:\\[(${j_.source})\\])?)?`, Rm = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, Z_ = RegExp(`${Rm.source}${A2}`), Bm = RegExp(`(?:T${Z_.source})?`), M2 = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, D2 = /(\d{4})-?W(\d\d)(?:-?(\d))?/, V2 = /(\d{4})-?(\d{3})/, L2 = G_("weekYear", "weekNumber", "weekDay"), F2 = G_("year", "ordinal"), R2 = /(\d{4})-(\d\d)-(\d\d)/, K_ = RegExp(
  `${Rm.source} ?(?:${Y_.source}|(${j_.source}))?`
), B2 = RegExp(`(?: ${K_.source})?`);
function Oa(e, t, n) {
  const i = e[t];
  return $e(i) ? n : jr(i);
}
function N2(e, t) {
  return [{
    year: Oa(e, t),
    month: Oa(e, t + 1, 1),
    day: Oa(e, t + 2, 1)
  }, null, t + 3];
}
function Ka(e, t) {
  return [{
    hours: Oa(e, t, 0),
    minutes: Oa(e, t + 1, 0),
    seconds: Oa(e, t + 2, 0),
    milliseconds: Lm(e[t + 3])
  }, null, t + 4];
}
function Dl(e, t) {
  const n = !e[t] && !e[t + 1], i = dd(e[t + 1], e[t + 2]), r = n ? null : wn.instance(i);
  return [{}, r, t + 3];
}
function Vl(e, t) {
  const n = e[t] ? wr.create(e[t]) : null;
  return [{}, n, t + 1];
}
const $2 = RegExp(`^T?${Rm.source}$`), z2 = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function H2(e) {
  const [t, n, i, r, s, a, l, c, d] = e, f = t[0] === "-", m = c && c[0] === "-", g = (v, p = !1) => v !== void 0 && (p || v && f) ? -v : v;
  return [
    {
      years: g(Ts(n)),
      months: g(Ts(i)),
      weeks: g(Ts(r)),
      days: g(Ts(s)),
      hours: g(Ts(a)),
      minutes: g(Ts(l)),
      seconds: g(Ts(c), c === "-0"),
      milliseconds: g(Lm(d), m)
    }
  ];
}
const W2 = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Nm(e, t, n, i, r, s, a) {
  const l = {
    year: t.length === 2 ? Rh(jr(t)) : jr(t),
    month: N_.indexOf(n) + 1,
    day: jr(i),
    hour: jr(r),
    minute: jr(s)
  };
  return a && (l.second = jr(a)), e && (l.weekday = e.length > 3 ? z_.indexOf(e) + 1 : H_.indexOf(e) + 1), l;
}
const U2 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function q2(e) {
  const [
    ,
    t,
    n,
    i,
    r,
    s,
    a,
    l,
    c,
    d,
    f,
    m
  ] = e, g = Nm(t, r, i, n, s, a, l);
  let v;
  return c ? v = W2[c] : d ? v = 0 : v = dd(f, m), [g, new wn(v)];
}
function j2(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const G2 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, Y2 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, Z2 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function Vp(e) {
  const [, t, n, i, r, s, a, l] = e;
  return [Nm(t, r, i, n, s, a, l), wn.utcInstance];
}
function K2(e) {
  const [, t, n, i, r, s, a, l] = e;
  return [Nm(t, l, n, i, r, s, a), wn.utcInstance];
}
const X2 = Ga(M2, Bm), J2 = Ga(D2, Bm), Q2 = Ga(V2, Bm), eV = Ga(Z_), X_ = Ya(
  N2,
  Ka,
  Dl,
  Vl
), tV = Ya(
  L2,
  Ka,
  Dl,
  Vl
), nV = Ya(
  F2,
  Ka,
  Dl,
  Vl
), iV = Ya(
  Ka,
  Dl,
  Vl
);
function rV(e) {
  return Za(
    e,
    [X2, X_],
    [J2, tV],
    [Q2, nV],
    [eV, iV]
  );
}
function sV(e) {
  return Za(j2(e), [U2, q2]);
}
function aV(e) {
  return Za(
    e,
    [G2, Vp],
    [Y2, Vp],
    [Z2, K2]
  );
}
function oV(e) {
  return Za(e, [z2, H2]);
}
const lV = Ya(Ka);
function uV(e) {
  return Za(e, [$2, lV]);
}
const cV = Ga(R2, B2), dV = Ga(K_), fV = Ya(
  Ka,
  Dl,
  Vl
);
function hV(e) {
  return Za(
    e,
    [cV, X_],
    [dV, fV]
  );
}
const Lp = "Invalid Duration", J_ = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, mV = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...J_
}, di = 146097 / 400, _a = 146097 / 4800, gV = {
  years: {
    quarters: 4,
    months: 12,
    weeks: di / 7,
    days: di,
    hours: di * 24,
    minutes: di * 24 * 60,
    seconds: di * 24 * 60 * 60,
    milliseconds: di * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: di / 28,
    days: di / 4,
    hours: di * 24 / 4,
    minutes: di * 24 * 60 / 4,
    seconds: di * 24 * 60 * 60 / 4,
    milliseconds: di * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: _a / 7,
    days: _a,
    hours: _a * 24,
    minutes: _a * 24 * 60,
    seconds: _a * 24 * 60 * 60,
    milliseconds: _a * 24 * 60 * 60 * 1e3
  },
  ...J_
}, Vs = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], vV = Vs.slice(0).reverse();
function Wr(e, t, n = !1) {
  const i = {
    values: n ? t.values : { ...e.values, ...t.values || {} },
    loc: e.loc.clone(t.loc),
    conversionAccuracy: t.conversionAccuracy || e.conversionAccuracy,
    matrix: t.matrix || e.matrix
  };
  return new ot(i);
}
function Q_(e, t) {
  let n = t.milliseconds ?? 0;
  for (const i of vV.slice(1))
    t[i] && (n += t[i] * e[i].milliseconds);
  return n;
}
function Fp(e, t) {
  const n = Q_(e, t) < 0 ? -1 : 1;
  Vs.reduceRight((i, r) => {
    if ($e(t[r]))
      return i;
    if (i) {
      const s = t[i] * n, a = e[r][i], l = Math.floor(s / a);
      t[r] += l * n, t[i] -= l * a * n;
    }
    return r;
  }, null), Vs.reduce((i, r) => {
    if ($e(t[r]))
      return i;
    if (i) {
      const s = t[i] % 1;
      t[i] -= s, t[r] += s * e[i][r];
    }
    return r;
  }, null);
}
function yV(e) {
  const t = {};
  for (const [n, i] of Object.entries(e))
    i !== 0 && (t[n] = i);
  return t;
}
class ot {
  /**
   * @private
   */
  constructor(t) {
    const n = t.conversionAccuracy === "longterm" || !1;
    let i = n ? gV : mV;
    t.matrix && (i = t.matrix), this.values = t.values, this.loc = t.loc || vt.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = t.invalid || null, this.matrix = i, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(t, n) {
    return ot.fromObject({ milliseconds: t }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(t, n = {}) {
    if (t == null || typeof t != "object")
      throw new Vn(
        `Duration.fromObject: argument expected to be an object, got ${t === null ? "null" : typeof t}`
      );
    return new ot({
      values: Ac(t, ot.normalizeUnit),
      loc: vt.fromObject(n),
      conversionAccuracy: n.conversionAccuracy,
      matrix: n.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(t) {
    if (Bs(t))
      return ot.fromMillis(t);
    if (ot.isDuration(t))
      return t;
    if (typeof t == "object")
      return ot.fromObject(t);
    throw new Vn(
      `Unknown duration argument ${t} of type ${typeof t}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(t, n) {
    const [i] = oV(t);
    return i ? ot.fromObject(i, n) : ot.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(t, n) {
    const [i] = uV(t);
    return i ? ot.fromObject(i, n) : ot.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new Vn("need to specify a reason the Duration is invalid");
    const i = t instanceof Pi ? t : new Pi(t, n);
    if (Ut.throwOnInvalid)
      throw new UD(i);
    return new ot({ invalid: i });
  }
  /**
   * @private
   */
  static normalizeUnit(t) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[t && t.toLowerCase()];
    if (!n)
      throw new u_(t);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(t) {
    return t && t.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(t, n = {}) {
    const i = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? hn.create(this.loc, i).formatDurationFromString(this, t) : Lp;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(t = {}) {
    if (!this.isValid)
      return Lp;
    const n = Vs.map((i) => {
      const r = this.values[i];
      return $e(r) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...t, unit: i.slice(0, -1) }).format(r);
    }).filter((i) => i);
    return this.loc.listFormatter({ type: "conjunction", style: t.listStyle || "narrow", ...t }).format(n);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid)
      return null;
    let t = "P";
    return this.years !== 0 && (t += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (t += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (t += this.weeks + "W"), this.days !== 0 && (t += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (t += "T"), this.hours !== 0 && (t += this.hours + "H"), this.minutes !== 0 && (t += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (t += Fm(this.seconds + this.milliseconds / 1e3, 3) + "S"), t === "P" && (t += "T0S"), t;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(t = {}) {
    if (!this.isValid)
      return null;
    const n = this.toMillis();
    return n < 0 || n >= 864e5 ? null : (t = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...t,
      includeOffset: !1
    }, Re.fromMillis(n, { zone: "UTC" }).toISOTime(t));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? Q_(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(t) {
    if (!this.isValid)
      return this;
    const n = ot.fromDurationLike(t), i = {};
    for (const r of Vs)
      (Fa(n.values, r) || Fa(this.values, r)) && (i[r] = n.get(r) + this.get(r));
    return Wr(this, { values: i }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(t) {
    if (!this.isValid)
      return this;
    const n = ot.fromDurationLike(t);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(t) {
    if (!this.isValid)
      return this;
    const n = {};
    for (const i of Object.keys(this.values))
      n[i] = B_(t(this.values[i], i));
    return Wr(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(t) {
    return this[ot.normalizeUnit(t)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(t) {
    if (!this.isValid)
      return this;
    const n = { ...this.values, ...Ac(t, ot.normalizeUnit) };
    return Wr(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: t, numberingSystem: n, conversionAccuracy: i, matrix: r } = {}) {
    const a = { loc: this.loc.clone({ locale: t, numberingSystem: n }), matrix: r, conversionAccuracy: i };
    return Wr(this, a);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(t) {
    return this.isValid ? this.shiftTo(t).get(t) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid)
      return this;
    const t = this.toObject();
    return Fp(this.matrix, t), Wr(this, { values: t }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid)
      return this;
    const t = yV(this.normalize().shiftToAll().toObject());
    return Wr(this, { values: t }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...t) {
    if (!this.isValid)
      return this;
    if (t.length === 0)
      return this;
    t = t.map((a) => ot.normalizeUnit(a));
    const n = {}, i = {}, r = this.toObject();
    let s;
    for (const a of Vs)
      if (t.indexOf(a) >= 0) {
        s = a;
        let l = 0;
        for (const d in i)
          l += this.matrix[d][a] * i[d], i[d] = 0;
        Bs(r[a]) && (l += r[a]);
        const c = Math.trunc(l);
        n[a] = c, i[a] = (l * 1e3 - c * 1e3) / 1e3;
      } else
        Bs(r[a]) && (i[a] = r[a]);
    for (const a in i)
      i[a] !== 0 && (n[s] += a === s ? i[a] : i[a] / this.matrix[s][a]);
    return Fp(this.matrix, n), Wr(this, { values: n }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid)
      return this;
    const t = {};
    for (const n of Object.keys(this.values))
      t[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return Wr(this, { values: t }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(t) {
    if (!this.isValid || !t.isValid || !this.loc.equals(t.loc))
      return !1;
    function n(i, r) {
      return i === void 0 || i === 0 ? r === void 0 || r === 0 : i === r;
    }
    for (const i of Vs)
      if (!n(this.values[i], t.values[i]))
        return !1;
    return !0;
  }
}
const wa = "Invalid Interval";
function pV(e, t) {
  return !e || !e.isValid ? Ft.invalid("missing or invalid start") : !t || !t.isValid ? Ft.invalid("missing or invalid end") : t < e ? Ft.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${t.toISO()}`
  ) : null;
}
class Ft {
  /**
   * @private
   */
  constructor(t) {
    this.s = t.start, this.e = t.end, this.invalid = t.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new Vn("need to specify a reason the Interval is invalid");
    const i = t instanceof Pi ? t : new Pi(t, n);
    if (Ut.throwOnInvalid)
      throw new WD(i);
    return new Ft({ invalid: i });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(t, n) {
    const i = Lo(t), r = Lo(n), s = pV(i, r);
    return s ?? new Ft({
      start: i,
      end: r
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(t, n) {
    const i = ot.fromDurationLike(n), r = Lo(t);
    return Ft.fromDateTimes(r, r.plus(i));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(t, n) {
    const i = ot.fromDurationLike(n), r = Lo(t);
    return Ft.fromDateTimes(r.minus(i), r);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(t, n) {
    const [i, r] = (t || "").split("/", 2);
    if (i && r) {
      let s, a;
      try {
        s = Re.fromISO(i, n), a = s.isValid;
      } catch {
        a = !1;
      }
      let l, c;
      try {
        l = Re.fromISO(r, n), c = l.isValid;
      } catch {
        c = !1;
      }
      if (a && c)
        return Ft.fromDateTimes(s, l);
      if (a) {
        const d = ot.fromISO(r, n);
        if (d.isValid)
          return Ft.after(s, d);
      } else if (c) {
        const d = ot.fromISO(i, n);
        if (d.isValid)
          return Ft.before(l, d);
      }
    }
    return Ft.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(t) {
    return t && t.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(t = "milliseconds") {
    return this.isValid ? this.toDuration(t).get(t) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(t = "milliseconds", n) {
    if (!this.isValid)
      return NaN;
    const i = this.start.startOf(t, n);
    let r;
    return n != null && n.useLocaleWeeks ? r = this.end.reconfigure({ locale: i.locale }) : r = this.end, r = r.startOf(t, n), Math.floor(r.diff(i, t).get(t)) + (r.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(t) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, t) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(t) {
    return this.isValid ? this.s > t : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(t) {
    return this.isValid ? this.e <= t : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(t) {
    return this.isValid ? this.s <= t && this.e > t : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: t, end: n } = {}) {
    return this.isValid ? Ft.fromDateTimes(t || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...t) {
    if (!this.isValid)
      return [];
    const n = t.map(Lo).filter((a) => this.contains(a)).sort((a, l) => a.toMillis() - l.toMillis()), i = [];
    let { s: r } = this, s = 0;
    for (; r < this.e; ) {
      const a = n[s] || this.e, l = +a > +this.e ? this.e : a;
      i.push(Ft.fromDateTimes(r, l)), r = l, s += 1;
    }
    return i;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(t) {
    const n = ot.fromDurationLike(t);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: i } = this, r = 1, s;
    const a = [];
    for (; i < this.e; ) {
      const l = this.start.plus(n.mapUnits((c) => c * r));
      s = +l > +this.e ? this.e : l, a.push(Ft.fromDateTimes(i, s)), i = s, r += 1;
    }
    return a;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(t) {
    return this.isValid ? this.splitBy(this.length() / t).slice(0, t) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(t) {
    return this.e > t.s && this.s < t.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(t) {
    return this.isValid ? +this.e == +t.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(t) {
    return this.isValid ? +t.e == +this.s : !1;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(t) {
    return this.isValid ? this.s <= t.s && this.e >= t.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(t) {
    return !this.isValid || !t.isValid ? !1 : this.s.equals(t.s) && this.e.equals(t.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(t) {
    if (!this.isValid)
      return this;
    const n = this.s > t.s ? this.s : t.s, i = this.e < t.e ? this.e : t.e;
    return n >= i ? null : Ft.fromDateTimes(n, i);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(t) {
    if (!this.isValid)
      return this;
    const n = this.s < t.s ? this.s : t.s, i = this.e > t.e ? this.e : t.e;
    return Ft.fromDateTimes(n, i);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(t) {
    const [n, i] = t.sort((r, s) => r.s - s.s).reduce(
      ([r, s], a) => s ? s.overlaps(a) || s.abutsStart(a) ? [r, s.union(a)] : [r.concat([s]), a] : [r, a],
      [[], null]
    );
    return i && n.push(i), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(t) {
    let n = null, i = 0;
    const r = [], s = t.map((c) => [
      { time: c.s, type: "s" },
      { time: c.e, type: "e" }
    ]), a = Array.prototype.concat(...s), l = a.sort((c, d) => c.time - d.time);
    for (const c of l)
      i += c.type === "s" ? 1 : -1, i === 1 ? n = c.time : (n && +n != +c.time && r.push(Ft.fromDateTimes(n, c.time)), n = null);
    return Ft.merge(r);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...t) {
    return Ft.xor([this].concat(t)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : wa;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(t = Pc, n = {}) {
    return this.isValid ? hn.create(this.s.loc.clone(n), t).formatInterval(this) : wa;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(t) {
    return this.isValid ? `${this.s.toISO(t)}/${this.e.toISO(t)}` : wa;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : wa;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(t) {
    return this.isValid ? `${this.s.toISOTime(t)}/${this.e.toISOTime(t)}` : wa;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(t, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(t)}${n}${this.e.toFormat(t)}` : wa;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(t, n) {
    return this.isValid ? this.e.diff(this.s, t, n) : ot.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(t) {
    return Ft.fromDateTimes(t(this.s), t(this.e));
  }
}
class Nu {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(t = Ut.defaultZone) {
    const n = Re.now().setZone(t).set({ month: 12 });
    return !t.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(t) {
    return wr.isValidZone(t);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(t) {
    return Gr(t, Ut.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || vt.create(t)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || vt.create(t)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: t = null, locObj: n = null } = {}) {
    return (n || vt.create(t)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(t = "long", { locale: n = null, numberingSystem: i = null, locObj: r = null, outputCalendar: s = "gregory" } = {}) {
    return (r || vt.create(n, i, s)).months(t);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(t = "long", { locale: n = null, numberingSystem: i = null, locObj: r = null, outputCalendar: s = "gregory" } = {}) {
    return (r || vt.create(n, i, s)).months(t, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(t = "long", { locale: n = null, numberingSystem: i = null, locObj: r = null } = {}) {
    return (r || vt.create(n, i, null)).weekdays(t);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(t = "long", { locale: n = null, numberingSystem: i = null, locObj: r = null } = {}) {
    return (r || vt.create(n, i, null)).weekdays(t, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: t = null } = {}) {
    return vt.create(t).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(t = "short", { locale: n = null } = {}) {
    return vt.create(n, null, "gregory").eras(t);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: L_(), localeWeek: F_() };
  }
}
function Rp(e, t) {
  const n = (r) => r.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), i = n(t) - n(e);
  return Math.floor(ot.fromMillis(i).as("days"));
}
function bV(e, t, n) {
  const i = [
    ["years", (c, d) => d.year - c.year],
    ["quarters", (c, d) => d.quarter - c.quarter + (d.year - c.year) * 4],
    ["months", (c, d) => d.month - c.month + (d.year - c.year) * 12],
    [
      "weeks",
      (c, d) => {
        const f = Rp(c, d);
        return (f - f % 7) / 7;
      }
    ],
    ["days", Rp]
  ], r = {}, s = e;
  let a, l;
  for (const [c, d] of i)
    n.indexOf(c) >= 0 && (a = c, r[c] = d(e, t), l = s.plus(r), l > t ? (r[c]--, e = s.plus(r), e > t && (l = e, r[c]--, e = s.plus(r))) : e = l);
  return [e, r, l, a];
}
function xV(e, t, n, i) {
  let [r, s, a, l] = bV(e, t, n);
  const c = t - r, d = n.filter(
    (m) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(m) >= 0
  );
  d.length === 0 && (a < t && (a = r.plus({ [l]: 1 })), a !== r && (s[l] = (s[l] || 0) + c / (a - r)));
  const f = ot.fromObject(s, i);
  return d.length > 0 ? ot.fromMillis(c, i).shiftTo(...d).plus(f) : f;
}
const $m = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, Bp = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, _V = $m.hanidec.replace(/[\[|\]]/g, "").split("");
function wV(e) {
  let t = parseInt(e, 10);
  if (isNaN(t)) {
    t = "";
    for (let n = 0; n < e.length; n++) {
      const i = e.charCodeAt(n);
      if (e[n].search($m.hanidec) !== -1)
        t += _V.indexOf(e[n]);
      else
        for (const r in Bp) {
          const [s, a] = Bp[r];
          i >= s && i <= a && (t += i - s);
        }
    }
    return parseInt(t, 10);
  } else
    return t;
}
function Ci({ numberingSystem: e }, t = "") {
  return new RegExp(`${$m[e || "latn"]}${t}`);
}
const SV = "missing Intl.DateTimeFormat.formatToParts support";
function ut(e, t = (n) => n) {
  return { regex: e, deser: ([n]) => t(wV(n)) };
}
const kV = " ", ew = `[ ${kV}]`, tw = new RegExp(ew, "g");
function CV(e) {
  return e.replace(/\./g, "\\.?").replace(tw, ew);
}
function Np(e) {
  return e.replace(/\./g, "").replace(tw, " ").toLowerCase();
}
function Ti(e, t) {
  return e === null ? null : {
    regex: RegExp(e.map(CV).join("|")),
    deser: ([n]) => e.findIndex((i) => Np(n) === Np(i)) + t
  };
}
function $p(e, t) {
  return { regex: e, deser: ([, n, i]) => dd(n, i), groups: t };
}
function $u(e) {
  return { regex: e, deser: ([t]) => t };
}
function TV(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function IV(e, t) {
  const n = Ci(t), i = Ci(t, "{2}"), r = Ci(t, "{3}"), s = Ci(t, "{4}"), a = Ci(t, "{6}"), l = Ci(t, "{1,2}"), c = Ci(t, "{1,3}"), d = Ci(t, "{1,6}"), f = Ci(t, "{1,9}"), m = Ci(t, "{2,4}"), g = Ci(t, "{4,6}"), v = (x) => ({ regex: RegExp(TV(x.val)), deser: ([S]) => S, literal: !0 }), _ = ((x) => {
    if (e.literal)
      return v(x);
    switch (x.val) {
      case "G":
        return Ti(t.eras("short"), 0);
      case "GG":
        return Ti(t.eras("long"), 0);
      case "y":
        return ut(d);
      case "yy":
        return ut(m, Rh);
      case "yyyy":
        return ut(s);
      case "yyyyy":
        return ut(g);
      case "yyyyyy":
        return ut(a);
      case "M":
        return ut(l);
      case "MM":
        return ut(i);
      case "MMM":
        return Ti(t.months("short", !0), 1);
      case "MMMM":
        return Ti(t.months("long", !0), 1);
      case "L":
        return ut(l);
      case "LL":
        return ut(i);
      case "LLL":
        return Ti(t.months("short", !1), 1);
      case "LLLL":
        return Ti(t.months("long", !1), 1);
      case "d":
        return ut(l);
      case "dd":
        return ut(i);
      case "o":
        return ut(c);
      case "ooo":
        return ut(r);
      case "HH":
        return ut(i);
      case "H":
        return ut(l);
      case "hh":
        return ut(i);
      case "h":
        return ut(l);
      case "mm":
        return ut(i);
      case "m":
        return ut(l);
      case "q":
        return ut(l);
      case "qq":
        return ut(i);
      case "s":
        return ut(l);
      case "ss":
        return ut(i);
      case "S":
        return ut(c);
      case "SSS":
        return ut(r);
      case "u":
        return $u(f);
      case "uu":
        return $u(l);
      case "uuu":
        return ut(n);
      case "a":
        return Ti(t.meridiems(), 0);
      case "kkkk":
        return ut(s);
      case "kk":
        return ut(m, Rh);
      case "W":
        return ut(l);
      case "WW":
        return ut(i);
      case "E":
      case "c":
        return ut(n);
      case "EEE":
        return Ti(t.weekdays("short", !1), 1);
      case "EEEE":
        return Ti(t.weekdays("long", !1), 1);
      case "ccc":
        return Ti(t.weekdays("short", !0), 1);
      case "cccc":
        return Ti(t.weekdays("long", !0), 1);
      case "Z":
      case "ZZ":
        return $p(new RegExp(`([+-]${l.source})(?::(${i.source}))?`), 2);
      case "ZZZ":
        return $p(new RegExp(`([+-]${l.source})(${i.source})?`), 2);
      case "z":
        return $u(/[a-z_+-/]{1,256}?/i);
      case " ":
        return $u(/[^\S\n\r]/);
      default:
        return v(x);
    }
  })(e) || {
    invalidReason: SV
  };
  return _.token = e, _;
}
const PV = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function OV(e, t, n) {
  const { type: i, value: r } = e;
  if (i === "literal") {
    const c = /^\s+$/.test(r);
    return {
      literal: !c,
      val: c ? " " : r
    };
  }
  const s = t[i];
  let a = i;
  i === "hour" && (t.hour12 != null ? a = t.hour12 ? "hour12" : "hour24" : t.hourCycle != null ? t.hourCycle === "h11" || t.hourCycle === "h12" ? a = "hour12" : a = "hour24" : a = n.hour12 ? "hour12" : "hour24");
  let l = PV[a];
  if (typeof l == "object" && (l = l[s]), l)
    return {
      literal: !1,
      val: l
    };
}
function EV(e) {
  return [`^${e.map((n) => n.regex).reduce((n, i) => `${n}(${i.source})`, "")}$`, e];
}
function AV(e, t, n) {
  const i = e.match(t);
  if (i) {
    const r = {};
    let s = 1;
    for (const a in n)
      if (Fa(n, a)) {
        const l = n[a], c = l.groups ? l.groups + 1 : 1;
        !l.literal && l.token && (r[l.token.val[0]] = l.deser(i.slice(s, s + c))), s += c;
      }
    return [i, r];
  } else
    return [i, {}];
}
function MV(e) {
  const t = (s) => {
    switch (s) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, i;
  return $e(e.z) || (n = wr.create(e.z)), $e(e.Z) || (n || (n = new wn(e.Z)), i = e.Z), $e(e.q) || (e.M = (e.q - 1) * 3 + 1), $e(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), $e(e.u) || (e.S = Lm(e.u)), [Object.keys(e).reduce((s, a) => {
    const l = t(a);
    return l && (s[l] = e[a]), s;
  }, {}), n, i];
}
let Qf = null;
function DV() {
  return Qf || (Qf = Re.fromMillis(1555555555555)), Qf;
}
function VV(e, t) {
  if (e.literal)
    return e;
  const n = hn.macroTokenToFormatOpts(e.val), i = rw(n, t);
  return i == null || i.includes(void 0) ? e : i;
}
function nw(e, t) {
  return Array.prototype.concat(...e.map((n) => VV(n, t)));
}
function iw(e, t, n) {
  const i = nw(hn.parseFormat(n), e), r = i.map((a) => IV(a, e)), s = r.find((a) => a.invalidReason);
  if (s)
    return { input: t, tokens: i, invalidReason: s.invalidReason };
  {
    const [a, l] = EV(r), c = RegExp(a, "i"), [d, f] = AV(t, c, l), [m, g, v] = f ? MV(f) : [null, null, void 0];
    if (Fa(f, "a") && Fa(f, "H"))
      throw new Ta(
        "Can't include meridiem when specifying 24-hour format"
      );
    return { input: t, tokens: i, regex: c, rawMatches: d, matches: f, result: m, zone: g, specificOffset: v };
  }
}
function LV(e, t, n) {
  const { result: i, zone: r, specificOffset: s, invalidReason: a } = iw(e, t, n);
  return [i, r, s, a];
}
function rw(e, t) {
  if (!e)
    return null;
  const i = hn.create(t, e).dtFormatter(DV()), r = i.formatToParts(), s = i.resolvedOptions();
  return r.map((a) => OV(a, e, s));
}
const eh = "Invalid DateTime", zp = 864e13;
function zu(e) {
  return new Pi("unsupported zone", `the zone "${e.name}" is not supported`);
}
function th(e) {
  return e.weekData === null && (e.weekData = Oc(e.c)), e.weekData;
}
function nh(e) {
  return e.localWeekData === null && (e.localWeekData = Oc(
    e.c,
    e.loc.getMinDaysInFirstWeek(),
    e.loc.getStartOfWeek()
  )), e.localWeekData;
}
function Is(e, t) {
  const n = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new Re({ ...n, ...t, old: n });
}
function sw(e, t, n) {
  let i = e - t * 60 * 1e3;
  const r = n.offset(i);
  if (t === r)
    return [i, t];
  i -= (r - t) * 60 * 1e3;
  const s = n.offset(i);
  return r === s ? [i, r] : [e - Math.min(r, s) * 60 * 1e3, Math.max(r, s)];
}
function Hu(e, t) {
  e += t * 60 * 1e3;
  const n = new Date(e);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function gc(e, t, n) {
  return sw(cd(e), t, n);
}
function Hp(e, t) {
  const n = e.o, i = e.c.year + Math.trunc(t.years), r = e.c.month + Math.trunc(t.months) + Math.trunc(t.quarters) * 3, s = {
    ...e.c,
    year: i,
    month: r,
    day: Math.min(e.c.day, Ec(i, r)) + Math.trunc(t.days) + Math.trunc(t.weeks) * 7
  }, a = ot.fromObject({
    years: t.years - Math.trunc(t.years),
    quarters: t.quarters - Math.trunc(t.quarters),
    months: t.months - Math.trunc(t.months),
    weeks: t.weeks - Math.trunc(t.weeks),
    days: t.days - Math.trunc(t.days),
    hours: t.hours,
    minutes: t.minutes,
    seconds: t.seconds,
    milliseconds: t.milliseconds
  }).as("milliseconds"), l = cd(s);
  let [c, d] = sw(l, n, e.zone);
  return a !== 0 && (c += a, d = e.zone.offset(c)), { ts: c, o: d };
}
function Vo(e, t, n, i, r, s) {
  const { setZone: a, zone: l } = n;
  if (e && Object.keys(e).length !== 0 || t) {
    const c = t || l, d = Re.fromObject(e, {
      ...n,
      zone: c,
      specificOffset: s
    });
    return a ? d : d.setZone(l);
  } else
    return Re.invalid(
      new Pi("unparsable", `the input "${r}" can't be parsed as ${i}`)
    );
}
function Wu(e, t, n = !0) {
  return e.isValid ? hn.create(vt.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(e, t) : null;
}
function ih(e, t) {
  const n = e.c.year > 9999 || e.c.year < 0;
  let i = "";
  return n && e.c.year >= 0 && (i += "+"), i += Yt(e.c.year, n ? 6 : 4), t ? (i += "-", i += Yt(e.c.month), i += "-", i += Yt(e.c.day)) : (i += Yt(e.c.month), i += Yt(e.c.day)), i;
}
function Wp(e, t, n, i, r, s) {
  let a = Yt(e.c.hour);
  return t ? (a += ":", a += Yt(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (a += ":")) : a += Yt(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (a += Yt(e.c.second), (e.c.millisecond !== 0 || !i) && (a += ".", a += Yt(e.c.millisecond, 3))), r && (e.isOffsetFixed && e.offset === 0 && !s ? a += "Z" : e.o < 0 ? (a += "-", a += Yt(Math.trunc(-e.o / 60)), a += ":", a += Yt(Math.trunc(-e.o % 60))) : (a += "+", a += Yt(Math.trunc(e.o / 60)), a += ":", a += Yt(Math.trunc(e.o % 60)))), s && (a += "[" + e.zone.ianaName + "]"), a;
}
const aw = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, FV = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, RV = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, ow = ["year", "month", "day", "hour", "minute", "second", "millisecond"], BV = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], NV = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function $V(e) {
  const t = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!t)
    throw new u_(e);
  return t;
}
function Up(e) {
  switch (e.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return $V(e);
  }
}
function qp(e, t) {
  const n = Gr(t.zone, Ut.defaultZone), i = vt.fromObject(t), r = Ut.now();
  let s, a;
  if ($e(e.year))
    s = r;
  else {
    for (const d of ow)
      $e(e[d]) && (e[d] = aw[d]);
    const l = D_(e) || V_(e);
    if (l)
      return Re.invalid(l);
    const c = n.offset(r);
    [s, a] = gc(e, c, n);
  }
  return new Re({ ts: s, zone: n, loc: i, o: a });
}
function jp(e, t, n) {
  const i = $e(n.round) ? !0 : n.round, r = (a, l) => (a = Fm(a, i || n.calendary ? 0 : 2, !0), t.loc.clone(n).relFormatter(n).format(a, l)), s = (a) => n.calendary ? t.hasSame(e, a) ? 0 : t.startOf(a).diff(e.startOf(a), a).get(a) : t.diff(e, a).get(a);
  if (n.unit)
    return r(s(n.unit), n.unit);
  for (const a of n.units) {
    const l = s(a);
    if (Math.abs(l) >= 1)
      return r(l, a);
  }
  return r(e > t ? -0 : 0, n.units[n.units.length - 1]);
}
function Gp(e) {
  let t = {}, n;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (t = e[e.length - 1], n = Array.from(e).slice(0, e.length - 1)) : n = Array.from(e), [t, n];
}
class Re {
  /**
   * @access private
   */
  constructor(t) {
    const n = t.zone || Ut.defaultZone;
    let i = t.invalid || (Number.isNaN(t.ts) ? new Pi("invalid input") : null) || (n.isValid ? null : zu(n));
    this.ts = $e(t.ts) ? Ut.now() : t.ts;
    let r = null, s = null;
    if (!i)
      if (t.old && t.old.ts === this.ts && t.old.zone.equals(n))
        [r, s] = [t.old.c, t.old.o];
      else {
        const l = n.offset(this.ts);
        r = Hu(this.ts, l), i = Number.isNaN(r.year) ? new Pi("invalid input") : null, r = i ? null : r, s = i ? null : l;
      }
    this._zone = n, this.loc = t.loc || vt.create(), this.invalid = i, this.weekData = null, this.localWeekData = null, this.c = r, this.o = s, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new Re({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [t, n] = Gp(arguments), [i, r, s, a, l, c, d] = n;
    return qp({ year: i, month: r, day: s, hour: a, minute: l, second: c, millisecond: d }, t);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [t, n] = Gp(arguments), [i, r, s, a, l, c, d] = n;
    return t.zone = wn.utcInstance, qp({ year: i, month: r, day: s, hour: a, minute: l, second: c, millisecond: d }, t);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(t, n = {}) {
    const i = g2(t) ? t.valueOf() : NaN;
    if (Number.isNaN(i))
      return Re.invalid("invalid input");
    const r = Gr(n.zone, Ut.defaultZone);
    return r.isValid ? new Re({
      ts: i,
      zone: r,
      loc: vt.fromObject(n)
    }) : Re.invalid(zu(r));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(t, n = {}) {
    if (Bs(t))
      return t < -zp || t > zp ? Re.invalid("Timestamp out of range") : new Re({
        ts: t,
        zone: Gr(n.zone, Ut.defaultZone),
        loc: vt.fromObject(n)
      });
    throw new Vn(
      `fromMillis requires a numerical input, but received a ${typeof t} with value ${t}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(t, n = {}) {
    if (Bs(t))
      return new Re({
        ts: t * 1e3,
        zone: Gr(n.zone, Ut.defaultZone),
        loc: vt.fromObject(n)
      });
    throw new Vn("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(t, n = {}) {
    t = t || {};
    const i = Gr(n.zone, Ut.defaultZone);
    if (!i.isValid)
      return Re.invalid(zu(i));
    const r = vt.fromObject(n), s = Ac(t, Up), { minDaysInFirstWeek: a, startOfWeek: l } = Ep(s, r), c = Ut.now(), d = $e(n.specificOffset) ? i.offset(c) : n.specificOffset, f = !$e(s.ordinal), m = !$e(s.year), g = !$e(s.month) || !$e(s.day), v = m || g, p = s.weekYear || s.weekNumber;
    if ((v || f) && p)
      throw new Ta(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (g && f)
      throw new Ta("Can't mix ordinal dates with month/day");
    const _ = p || s.weekday && !v;
    let x, S, T = Hu(c, d);
    _ ? (x = BV, S = FV, T = Oc(T, a, l)) : f ? (x = NV, S = RV, T = Jf(T)) : (x = ow, S = aw);
    let M = !1;
    for (const H of x) {
      const B = s[H];
      $e(B) ? M ? s[H] = S[H] : s[H] = T[H] : M = !0;
    }
    const E = _ ? f2(s, a, l) : f ? h2(s) : D_(s), D = E || V_(s);
    if (D)
      return Re.invalid(D);
    const R = _ ? Pp(s, a, l) : f ? Op(s) : s, [$, A] = gc(R, d, i), V = new Re({
      ts: $,
      zone: i,
      o: A,
      loc: r
    });
    return s.weekday && v && t.weekday !== V.weekday ? Re.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${s.weekday} and a date of ${V.toISO()}`
    ) : V;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(t, n = {}) {
    const [i, r] = rV(t);
    return Vo(i, r, n, "ISO 8601", t);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(t, n = {}) {
    const [i, r] = sV(t);
    return Vo(i, r, n, "RFC 2822", t);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(t, n = {}) {
    const [i, r] = aV(t);
    return Vo(i, r, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(t, n, i = {}) {
    if ($e(t) || $e(n))
      throw new Vn("fromFormat requires an input string and a format");
    const { locale: r = null, numberingSystem: s = null } = i, a = vt.fromOpts({
      locale: r,
      numberingSystem: s,
      defaultToEN: !0
    }), [l, c, d, f] = LV(a, t, n);
    return f ? Re.invalid(f) : Vo(l, c, i, `format ${n}`, t, d);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(t, n, i = {}) {
    return Re.fromFormat(t, n, i);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(t, n = {}) {
    const [i, r] = hV(t);
    return Vo(i, r, n, "SQL", t);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new Vn("need to specify a reason the DateTime is invalid");
    const i = t instanceof Pi ? t : new Pi(t, n);
    if (Ut.throwOnInvalid)
      throw new HD(i);
    return new Re({ invalid: i });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(t) {
    return t && t.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(t, n = {}) {
    const i = rw(t, vt.fromObject(n));
    return i ? i.map((r) => r ? r.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(t, n = {}) {
    return nw(hn.parseFormat(t), vt.fromObject(n)).map((r) => r.val).join("");
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(t) {
    return this[t];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? th(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? th(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? th(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? nh(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? nh(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? nh(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? Jf(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Nu.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Nu.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Nu.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Nu.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const t = 864e5, n = 6e4, i = cd(this.c), r = this.zone.offset(i - t), s = this.zone.offset(i + t), a = this.zone.offset(i - r * n), l = this.zone.offset(i - s * n);
    if (a === l)
      return [this];
    const c = i - a * n, d = i - l * n, f = Hu(c, a), m = Hu(d, l);
    return f.hour === m.hour && f.minute === m.minute && f.second === m.second && f.millisecond === m.millisecond ? [Is(this, { ts: c }), Is(this, { ts: d })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Ml(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return Ec(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? Pa(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? fl(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? fl(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(t = {}) {
    const { locale: n, numberingSystem: i, calendar: r } = hn.create(
      this.loc.clone(t),
      t
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: i, outputCalendar: r };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(t = 0, n = {}) {
    return this.setZone(wn.instance(t), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Ut.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(t, { keepLocalTime: n = !1, keepCalendarTime: i = !1 } = {}) {
    if (t = Gr(t, Ut.defaultZone), t.equals(this.zone))
      return this;
    if (t.isValid) {
      let r = this.ts;
      if (n || i) {
        const s = t.offset(this.ts), a = this.toObject();
        [r] = gc(a, s, t);
      }
      return Is(this, { ts: r, zone: t });
    } else
      return Re.invalid(zu(t));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: t, numberingSystem: n, outputCalendar: i } = {}) {
    const r = this.loc.clone({ locale: t, numberingSystem: n, outputCalendar: i });
    return Is(this, { loc: r });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(t) {
    return this.reconfigure({ locale: t });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(t) {
    if (!this.isValid)
      return this;
    const n = Ac(t, Up), { minDaysInFirstWeek: i, startOfWeek: r } = Ep(n, this.loc), s = !$e(n.weekYear) || !$e(n.weekNumber) || !$e(n.weekday), a = !$e(n.ordinal), l = !$e(n.year), c = !$e(n.month) || !$e(n.day), d = l || c, f = n.weekYear || n.weekNumber;
    if ((d || a) && f)
      throw new Ta(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (c && a)
      throw new Ta("Can't mix ordinal dates with month/day");
    let m;
    s ? m = Pp(
      { ...Oc(this.c, i, r), ...n },
      i,
      r
    ) : $e(n.ordinal) ? (m = { ...this.toObject(), ...n }, $e(n.day) && (m.day = Math.min(Ec(m.year, m.month), m.day))) : m = Op({ ...Jf(this.c), ...n });
    const [g, v] = gc(m, this.o, this.zone);
    return Is(this, { ts: g, o: v });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(t) {
    if (!this.isValid)
      return this;
    const n = ot.fromDurationLike(t);
    return Is(this, Hp(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(t) {
    if (!this.isValid)
      return this;
    const n = ot.fromDurationLike(t).negate();
    return Is(this, Hp(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(t, { useLocaleWeeks: n = !1 } = {}) {
    if (!this.isValid)
      return this;
    const i = {}, r = ot.normalizeUnit(t);
    switch (r) {
      case "years":
        i.month = 1;
      case "quarters":
      case "months":
        i.day = 1;
      case "weeks":
      case "days":
        i.hour = 0;
      case "hours":
        i.minute = 0;
      case "minutes":
        i.second = 0;
      case "seconds":
        i.millisecond = 0;
        break;
    }
    if (r === "weeks")
      if (n) {
        const s = this.loc.getStartOfWeek(), { weekday: a } = this;
        a < s && (i.weekNumber = this.weekNumber - 1), i.weekday = s;
      } else
        i.weekday = 1;
    if (r === "quarters") {
      const s = Math.ceil(this.month / 3);
      i.month = (s - 1) * 3 + 1;
    }
    return this.set(i);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(t, n) {
    return this.isValid ? this.plus({ [t]: 1 }).startOf(t, n).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(t, n = {}) {
    return this.isValid ? hn.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, t) : eh;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(t = Pc, n = {}) {
    return this.isValid ? hn.create(this.loc.clone(n), t).formatDateTime(this) : eh;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(t = {}) {
    return this.isValid ? hn.create(this.loc.clone(t), t).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: t = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: i = !1,
    includeOffset: r = !0,
    extendedZone: s = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const a = t === "extended";
    let l = ih(this, a);
    return l += "T", l += Wp(this, a, n, i, r, s), l;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: t = "extended" } = {}) {
    return this.isValid ? ih(this, t === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return Wu(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: t = !1,
    suppressSeconds: n = !1,
    includeOffset: i = !0,
    includePrefix: r = !1,
    extendedZone: s = !1,
    format: a = "extended"
  } = {}) {
    return this.isValid ? (r ? "T" : "") + Wp(
      this,
      a === "extended",
      n,
      t,
      i,
      s
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return Wu(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return Wu(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? ih(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: t = !0, includeZone: n = !1, includeOffsetSpace: i = !0 } = {}) {
    let r = "HH:mm:ss.SSS";
    return (n || t) && (i && (r += " "), n ? r += "z" : t && (r += "ZZ")), Wu(this, r, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(t = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(t)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : eh;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(t = {}) {
    if (!this.isValid)
      return {};
    const n = { ...this.c };
    return t.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(t, n = "milliseconds", i = {}) {
    if (!this.isValid || !t.isValid)
      return ot.invalid("created by diffing an invalid DateTime");
    const r = { locale: this.locale, numberingSystem: this.numberingSystem, ...i }, s = v2(n).map(ot.normalizeUnit), a = t.valueOf() > this.valueOf(), l = a ? this : t, c = a ? t : this, d = xV(l, c, s, r);
    return a ? d.negate() : d;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(t = "milliseconds", n = {}) {
    return this.diff(Re.now(), t, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(t) {
    return this.isValid ? Ft.fromDateTimes(this, t) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(t, n, i) {
    if (!this.isValid)
      return !1;
    const r = t.valueOf(), s = this.setZone(t.zone, { keepLocalTime: !0 });
    return s.startOf(n, i) <= r && r <= s.endOf(n, i);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(t) {
    return this.isValid && t.isValid && this.valueOf() === t.valueOf() && this.zone.equals(t.zone) && this.loc.equals(t.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(t = {}) {
    if (!this.isValid)
      return null;
    const n = t.base || Re.fromObject({}, { zone: this.zone }), i = t.padding ? this < n ? -t.padding : t.padding : 0;
    let r = ["years", "months", "days", "hours", "minutes", "seconds"], s = t.unit;
    return Array.isArray(t.unit) && (r = t.unit, s = void 0), jp(n, this.plus(i), {
      ...t,
      numeric: "always",
      units: r,
      unit: s
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(t = {}) {
    return this.isValid ? jp(t.base || Re.fromObject({}, { zone: this.zone }), this, {
      ...t,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...t) {
    if (!t.every(Re.isDateTime))
      throw new Vn("min requires all arguments be DateTimes");
    return Ap(t, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...t) {
    if (!t.every(Re.isDateTime))
      throw new Vn("max requires all arguments be DateTimes");
    return Ap(t, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(t, n, i = {}) {
    const { locale: r = null, numberingSystem: s = null } = i, a = vt.fromOpts({
      locale: r,
      numberingSystem: s,
      defaultToEN: !0
    });
    return iw(a, t, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(t, n, i = {}) {
    return Re.fromFormatExplain(t, n, i);
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return Pc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return c_;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return qD;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return d_;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return f_;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return h_;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return m_;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return g_;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return v_;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return y_;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return p_;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return b_;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return x_;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return __;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return w_;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return S_;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return k_;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return jD;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return C_;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return T_;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return I_;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return P_;
  }
}
function Lo(e) {
  if (Re.isDateTime(e))
    return e;
  if (e && e.valueOf && Bs(e.valueOf()))
    return Re.fromJSDate(e);
  if (e && typeof e == "object")
    return Re.fromObject(e);
  throw new Vn(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
function zV() {
  const e = ue([]);
  lE(() => e.value = []);
  function t(n, i) {
    e.value[i] = n;
  }
  return {
    refs: e,
    updateRef: t
  };
}
const HV = ee({
  activeColor: String,
  start: {
    type: [Number, String],
    default: 1
  },
  modelValue: {
    type: Number,
    default: (e) => e.start
  },
  disabled: Boolean,
  length: {
    type: [Number, String],
    default: 1,
    validator: (e) => e % 1 === 0
  },
  totalVisible: [Number, String],
  firstIcon: {
    type: He,
    default: "$first"
  },
  prevIcon: {
    type: He,
    default: "$prev"
  },
  nextIcon: {
    type: He,
    default: "$next"
  },
  lastIcon: {
    type: He,
    default: "$last"
  },
  ariaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.root"
  },
  pageAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.page"
  },
  currentPageAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.currentPage"
  },
  firstAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.first"
  },
  previousAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.previous"
  },
  nextAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.next"
  },
  lastAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.last"
  },
  ellipsis: {
    type: String,
    default: "..."
  },
  showFirstLastPage: Boolean,
  ...Ki(),
  ...Ae(),
  ...Qn(),
  ...Xi(),
  ...vn(),
  ...Ha(),
  ...pt({
    tag: "nav"
  }),
  ...$t(),
  ...Ji({
    variant: "text"
  })
}, "VPagination"), Bh = pe()({
  name: "VPagination",
  props: HV(),
  emits: {
    "update:modelValue": (e) => !0,
    first: (e) => !0,
    prev: (e) => !0,
    next: (e) => !0,
    last: (e) => !0
  },
  setup(e, t) {
    let {
      slots: n,
      emit: i
    } = t;
    const r = at(e, "modelValue"), {
      t: s,
      n: a
    } = os(), {
      isRtl: l
    } = Tn(), {
      themeClasses: c
    } = Zt(e), {
      width: d
    } = js(), f = Ie(-1);
    yi(void 0, {
      scoped: !0
    });
    const {
      resizeRef: m
    } = Ws((A) => {
      if (!A.length)
        return;
      const {
        target: V,
        contentRect: H
      } = A[0], B = V.querySelector(".v-pagination__list > *");
      if (!B)
        return;
      const N = H.width, q = B.offsetWidth + parseFloat(getComputedStyle(B).marginRight) * 2;
      f.value = _(N, q);
    }), g = I(() => parseInt(e.length, 10)), v = I(() => parseInt(e.start, 10)), p = I(() => e.totalVisible != null ? parseInt(e.totalVisible, 10) : f.value >= 0 ? f.value : _(d.value, 58));
    function _(A, V) {
      const H = e.showFirstLastPage ? 5 : 3;
      return Math.max(0, Math.floor(
        // Round to two decimal places to avoid floating point errors
        +((A - V * H) / V).toFixed(2)
      ));
    }
    const x = I(() => {
      if (g.value <= 0 || isNaN(g.value) || g.value > Number.MAX_SAFE_INTEGER)
        return [];
      if (p.value <= 0)
        return [];
      if (p.value === 1)
        return [r.value];
      if (g.value <= p.value)
        return Ho(g.value, v.value);
      const A = p.value % 2 === 0, V = A ? p.value / 2 : Math.floor(p.value / 2), H = A ? V : V + 1, B = g.value - V;
      if (H - r.value >= 0)
        return [...Ho(Math.max(1, p.value - 1), v.value), e.ellipsis, g.value];
      if (r.value - B >= (A ? 1 : 0)) {
        const N = p.value - 1, q = g.value - N + v.value;
        return [v.value, e.ellipsis, ...Ho(N, q)];
      } else {
        const N = Math.max(1, p.value - 2), q = N === 1 ? r.value : r.value - Math.ceil(N / 2) + v.value;
        return [v.value, e.ellipsis, ...Ho(N, q), e.ellipsis, g.value];
      }
    });
    function S(A, V, H) {
      A.preventDefault(), r.value = V, H && i(H, V);
    }
    const {
      refs: T,
      updateRef: M
    } = zV();
    yi({
      VPaginationBtn: {
        color: ce(e, "color"),
        border: ce(e, "border"),
        density: ce(e, "density"),
        size: ce(e, "size"),
        variant: ce(e, "variant"),
        rounded: ce(e, "rounded"),
        elevation: ce(e, "elevation")
      }
    });
    const E = I(() => x.value.map((A, V) => {
      const H = (B) => M(B, V);
      if (typeof A == "string")
        return {
          isActive: !1,
          key: `ellipsis-${V}`,
          page: A,
          props: {
            ref: H,
            ellipsis: !0,
            icon: !0,
            disabled: !0
          }
        };
      {
        const B = A === r.value;
        return {
          isActive: B,
          key: A,
          page: a(A),
          props: {
            ref: H,
            ellipsis: !1,
            icon: !0,
            disabled: !!e.disabled || +e.length < 2,
            color: B ? e.activeColor : e.color,
            "aria-current": B,
            "aria-label": s(B ? e.currentPageAriaLabel : e.pageAriaLabel, A),
            onClick: (N) => S(N, A)
          }
        };
      }
    })), D = I(() => {
      const A = !!e.disabled || r.value <= v.value, V = !!e.disabled || r.value >= v.value + g.value - 1;
      return {
        first: e.showFirstLastPage ? {
          icon: l.value ? e.lastIcon : e.firstIcon,
          onClick: (H) => S(H, v.value, "first"),
          disabled: A,
          "aria-label": s(e.firstAriaLabel),
          "aria-disabled": A
        } : void 0,
        prev: {
          icon: l.value ? e.nextIcon : e.prevIcon,
          onClick: (H) => S(H, r.value - 1, "prev"),
          disabled: A,
          "aria-label": s(e.previousAriaLabel),
          "aria-disabled": A
        },
        next: {
          icon: l.value ? e.prevIcon : e.nextIcon,
          onClick: (H) => S(H, r.value + 1, "next"),
          disabled: V,
          "aria-label": s(e.nextAriaLabel),
          "aria-disabled": V
        },
        last: e.showFirstLastPage ? {
          icon: l.value ? e.firstIcon : e.lastIcon,
          onClick: (H) => S(H, v.value + g.value - 1, "last"),
          disabled: V,
          "aria-label": s(e.lastAriaLabel),
          "aria-disabled": V
        } : void 0
      };
    });
    function R() {
      var V;
      const A = r.value - v.value;
      (V = T.value[A]) == null || V.$el.focus();
    }
    function $(A) {
      A.key === xh.left && !e.disabled && r.value > +e.start ? (r.value = r.value - 1, Ct(R)) : A.key === xh.right && !e.disabled && r.value < v.value + g.value - 1 && (r.value = r.value + 1, Ct(R));
    }
    return ke(() => b(e.tag, {
      ref: m,
      class: ["v-pagination", c.value, e.class],
      style: e.style,
      role: "navigation",
      "aria-label": s(e.ariaLabel),
      onKeydown: $,
      "data-test": "v-pagination-root"
    }, {
      default: () => [b("ul", {
        class: "v-pagination__list"
      }, [e.showFirstLastPage && b("li", {
        key: "first",
        class: "v-pagination__first",
        "data-test": "v-pagination-first"
      }, [n.first ? n.first(D.value.first) : b(rt, fe({
        _as: "VPaginationBtn"
      }, D.value.first), null)]), b("li", {
        key: "prev",
        class: "v-pagination__prev",
        "data-test": "v-pagination-prev"
      }, [n.prev ? n.prev(D.value.prev) : b(rt, fe({
        _as: "VPaginationBtn"
      }, D.value.prev), null)]), E.value.map((A, V) => b("li", {
        key: A.key,
        class: ["v-pagination__item", {
          "v-pagination__item--is-active": A.isActive
        }],
        "data-test": "v-pagination-item"
      }, [n.item ? n.item(A) : b(rt, fe({
        _as: "VPaginationBtn"
      }, A.props), {
        default: () => [A.page]
      })])), b("li", {
        key: "next",
        class: "v-pagination__next",
        "data-test": "v-pagination-next"
      }, [n.next ? n.next(D.value.next) : b(rt, fe({
        _as: "VPaginationBtn"
      }, D.value.next), null)]), e.showFirstLastPage && b("li", {
        key: "last",
        class: "v-pagination__last",
        "data-test": "v-pagination-last"
      }, [n.last ? n.last(D.value.last) : b(rt, fe({
        _as: "VPaginationBtn"
      }, D.value.last), null)])])]
    })), {};
  }
}), WV = ee({
  text: String,
  onClick: cn(),
  ...Ae(),
  ...$t()
}, "VLabel"), zm = pe()({
  name: "VLabel",
  props: WV(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return ke(() => {
      var i;
      return b("label", {
        class: ["v-label", {
          "v-label--clickable": !!e.onClick
        }, e.class],
        style: e.style,
        onClick: e.onClick
      }, [e.text, (i = n.default) == null ? void 0 : i.call(n)]);
    }), {};
  }
}), lw = Symbol.for("vuetify:selection-control-group"), uw = ee({
  color: String,
  disabled: {
    type: Boolean,
    default: null
  },
  defaultsTarget: String,
  error: Boolean,
  id: String,
  inline: Boolean,
  falseIcon: He,
  trueIcon: He,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  multiple: {
    type: Boolean,
    default: null
  },
  name: String,
  readonly: {
    type: Boolean,
    default: null
  },
  modelValue: null,
  type: String,
  valueComparator: {
    type: Function,
    default: Sr
  },
  ...Ae(),
  ...Qn(),
  ...$t()
}, "SelectionControlGroup"), UV = ee({
  ...uw({
    defaultsTarget: "VSelectionControl"
  })
}, "VSelectionControlGroup");
pe()({
  name: "VSelectionControlGroup",
  props: UV(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = at(e, "modelValue"), r = pi(), s = I(() => e.id || `v-selection-control-group-${r}`), a = I(() => e.name || s.value), l = /* @__PURE__ */ new Set();
    return jt(lw, {
      modelValue: i,
      forceUpdate: () => {
        l.forEach((c) => c());
      },
      onForceUpdate: (c) => {
        l.add(c), gn(() => {
          l.delete(c);
        });
      }
    }), yi({
      [e.defaultsTarget]: {
        color: ce(e, "color"),
        disabled: ce(e, "disabled"),
        density: ce(e, "density"),
        error: ce(e, "error"),
        inline: ce(e, "inline"),
        modelValue: i,
        multiple: I(() => !!e.multiple || e.multiple == null && Array.isArray(i.value)),
        name: a,
        falseIcon: ce(e, "falseIcon"),
        trueIcon: ce(e, "trueIcon"),
        readonly: ce(e, "readonly"),
        ripple: ce(e, "ripple"),
        type: ce(e, "type"),
        valueComparator: ce(e, "valueComparator")
      }
    }), ke(() => {
      var c;
      return b("div", {
        class: ["v-selection-control-group", {
          "v-selection-control-group--inline": e.inline
        }, e.class],
        style: e.style,
        role: e.type === "radio" ? "radiogroup" : void 0
      }, [(c = n.default) == null ? void 0 : c.call(n)]);
    }), {};
  }
});
const cw = ee({
  label: String,
  baseColor: String,
  trueValue: null,
  falseValue: null,
  value: null,
  ...Ae(),
  ...uw()
}, "VSelectionControl");
function qV(e) {
  const t = gt(lw, void 0), {
    densityClasses: n
  } = Mi(e), i = at(e, "modelValue"), r = I(() => e.trueValue !== void 0 ? e.trueValue : e.value !== void 0 ? e.value : !0), s = I(() => e.falseValue !== void 0 ? e.falseValue : !1), a = I(() => !!e.multiple || e.multiple == null && Array.isArray(i.value)), l = I({
    get() {
      const v = t ? t.modelValue.value : i.value;
      return a.value ? mn(v).some((p) => e.valueComparator(p, r.value)) : e.valueComparator(v, r.value);
    },
    set(v) {
      if (e.readonly)
        return;
      const p = v ? r.value : s.value;
      let _ = p;
      a.value && (_ = v ? [...mn(i.value), p] : mn(i.value).filter((x) => !e.valueComparator(x, r.value))), t ? t.modelValue.value = _ : i.value = _;
    }
  }), {
    textColorClasses: c,
    textColorStyles: d
  } = Ei(I(() => {
    if (!(e.error || e.disabled))
      return l.value ? e.color : e.baseColor;
  })), {
    backgroundColorClasses: f,
    backgroundColorStyles: m
  } = Bn(I(() => l.value && !e.error && !e.disabled ? e.color : e.baseColor)), g = I(() => l.value ? e.trueIcon : e.falseIcon);
  return {
    group: t,
    densityClasses: n,
    trueValue: r,
    falseValue: s,
    model: l,
    textColorClasses: c,
    textColorStyles: d,
    backgroundColorClasses: f,
    backgroundColorStyles: m,
    icon: g
  };
}
const Yp = pe()({
  name: "VSelectionControl",
  directives: {
    Ripple: ja
  },
  inheritAttrs: !1,
  props: cw(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const {
      group: r,
      densityClasses: s,
      icon: a,
      model: l,
      textColorClasses: c,
      textColorStyles: d,
      backgroundColorClasses: f,
      backgroundColorStyles: m,
      trueValue: g
    } = qV(e), v = pi(), p = Ie(!1), _ = Ie(!1), x = ue(), S = I(() => e.id || `input-${v}`), T = I(() => !e.disabled && !e.readonly);
    r == null || r.onForceUpdate(() => {
      x.value && (x.value.checked = l.value);
    });
    function M($) {
      T.value && (p.value = !0, _c($.target, ":focus-visible") !== !1 && (_.value = !0));
    }
    function E() {
      p.value = !1, _.value = !1;
    }
    function D($) {
      $.stopPropagation();
    }
    function R($) {
      if (!T.value) {
        x.value && (x.value.checked = l.value);
        return;
      }
      e.readonly && r && Ct(() => r.forceUpdate()), l.value = $.target.checked;
    }
    return ke(() => {
      var B, N;
      const $ = i.label ? i.label({
        label: e.label,
        props: {
          for: S.value
        }
      }) : e.label, [A, V] = Yc(n), H = b("input", fe({
        ref: x,
        checked: l.value,
        disabled: !!e.disabled,
        id: S.value,
        onBlur: E,
        onFocus: M,
        onInput: R,
        "aria-disabled": !!e.disabled,
        "aria-label": e.label,
        type: e.type,
        value: g.value,
        name: e.name,
        "aria-checked": e.type === "checkbox" ? l.value : void 0
      }, V), null);
      return b("div", fe({
        class: ["v-selection-control", {
          "v-selection-control--dirty": l.value,
          "v-selection-control--disabled": e.disabled,
          "v-selection-control--error": e.error,
          "v-selection-control--focused": p.value,
          "v-selection-control--focus-visible": _.value,
          "v-selection-control--inline": e.inline
        }, s.value, e.class]
      }, A, {
        style: e.style
      }), [b("div", {
        class: ["v-selection-control__wrapper", c.value],
        style: d.value
      }, [(B = i.default) == null ? void 0 : B.call(i, {
        backgroundColorClasses: f,
        backgroundColorStyles: m
      }), rn(b("div", {
        class: ["v-selection-control__input"]
      }, [((N = i.input) == null ? void 0 : N.call(i, {
        model: l,
        textColorClasses: c,
        textColorStyles: d,
        backgroundColorClasses: f,
        backgroundColorStyles: m,
        inputNode: H,
        icon: a.value,
        props: {
          onFocus: M,
          onBlur: E,
          id: S.value
        }
      })) ?? b(Le, null, [a.value && b(dt, {
        key: "icon",
        icon: a.value
      }, null), H])]), [[ji("ripple"), e.ripple && [!e.disabled && !e.readonly, null, ["center", "circle"]]]])]), $ && b(zm, {
        for: S.value,
        onClick: D
      }, {
        default: () => [$]
      })]);
    }), {
      isFocused: p,
      input: x
    };
  }
}), dw = ee({
  indeterminate: Boolean,
  indeterminateIcon: {
    type: He,
    default: "$checkboxIndeterminate"
  },
  ...cw({
    falseIcon: "$checkboxOff",
    trueIcon: "$checkboxOn"
  })
}, "VCheckboxBtn"), Ra = pe()({
  name: "VCheckboxBtn",
  props: dw(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:indeterminate": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = at(e, "indeterminate"), r = at(e, "modelValue");
    function s(c) {
      i.value && (i.value = !1);
    }
    const a = I(() => i.value ? e.indeterminateIcon : e.falseIcon), l = I(() => i.value ? e.indeterminateIcon : e.trueIcon);
    return ke(() => {
      const c = Gi(Yp.filterProps(e), ["modelValue"]);
      return b(Yp, fe(c, {
        modelValue: r.value,
        "onUpdate:modelValue": [(d) => r.value = d, s],
        class: ["v-checkbox-btn", e.class],
        style: e.style,
        type: "checkbox",
        falseIcon: a.value,
        trueIcon: l.value,
        "aria-checked": i.value ? "mixed" : void 0
      }), n);
    }), {};
  }
});
function fw(e) {
  const {
    t
  } = os();
  function n(i) {
    let {
      name: r
    } = i;
    const s = {
      prepend: "prependAction",
      prependInner: "prependAction",
      append: "appendAction",
      appendInner: "appendAction",
      clear: "clear"
    }[r], a = e[`onClick:${r}`];
    function l(d) {
      d.key !== "Enter" && d.key !== " " || (d.preventDefault(), d.stopPropagation(), hm(a, new PointerEvent("click", d)));
    }
    const c = a && s ? t(`$vuetify.input.${s}`, e.label ?? "") : void 0;
    return b(dt, {
      icon: e[`${r}Icon`],
      "aria-label": c,
      onClick: a,
      onKeydown: l
    }, null);
  }
  return {
    InputIcon: n
  };
}
const jV = ee({
  active: Boolean,
  color: String,
  messages: {
    type: [Array, String],
    default: () => []
  },
  ...Ae(),
  ...Wa({
    transition: {
      component: mx,
      leaveAbsolute: !0,
      group: !0
    }
  })
}, "VMessages"), GV = pe()({
  name: "VMessages",
  props: jV(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = I(() => mn(e.messages)), {
      textColorClasses: r,
      textColorStyles: s
    } = Ei(I(() => e.color));
    return ke(() => b(pr, {
      transition: e.transition,
      tag: "div",
      class: ["v-messages", r.value, e.class],
      style: [s.value, e.style]
    }, {
      default: () => [e.active && i.value.map((a, l) => b("div", {
        class: "v-messages__message",
        key: `${l}-${i.value}`
      }, [n.message ? n.message({
        message: a
      }) : a]))]
    })), {};
  }
}), Hm = ee({
  focused: Boolean,
  "onUpdate:focused": cn()
}, "focus");
function Ll(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Yi();
  const n = at(e, "focused"), i = I(() => ({
    [`${t}--focused`]: n.value
  }));
  function r() {
    n.value = !0;
  }
  function s() {
    n.value = !1;
  }
  return {
    focusClasses: i,
    isFocused: n,
    focus: r,
    blur: s
  };
}
const hw = Symbol.for("vuetify:form"), YV = ee({
  disabled: Boolean,
  fastFail: Boolean,
  readonly: Boolean,
  modelValue: {
    type: Boolean,
    default: null
  },
  validateOn: {
    type: String,
    default: "input"
  }
}, "form");
function ZV(e) {
  const t = at(e, "modelValue"), n = I(() => e.disabled), i = I(() => e.readonly), r = Ie(!1), s = ue([]), a = ue([]);
  async function l() {
    const f = [];
    let m = !0;
    a.value = [], r.value = !0;
    for (const g of s.value) {
      const v = await g.validate();
      if (v.length > 0 && (m = !1, f.push({
        id: g.id,
        errorMessages: v
      })), !m && e.fastFail)
        break;
    }
    return a.value = f, r.value = !1, {
      valid: m,
      errors: a.value
    };
  }
  function c() {
    s.value.forEach((f) => f.reset());
  }
  function d() {
    s.value.forEach((f) => f.resetValidation());
  }
  return Se(s, () => {
    let f = 0, m = 0;
    const g = [];
    for (const v of s.value)
      v.isValid === !1 ? (m++, g.push({
        id: v.id,
        errorMessages: v.errorMessages
      })) : v.isValid === !0 && f++;
    a.value = g, t.value = m > 0 ? !1 : f === s.value.length ? !0 : null;
  }, {
    deep: !0,
    flush: "post"
  }), jt(hw, {
    register: (f) => {
      let {
        id: m,
        vm: g,
        validate: v,
        reset: p,
        resetValidation: _
      } = f;
      s.value.some((x) => x.id === m) && Ui(`Duplicate input name "${m}"`), s.value.push({
        id: m,
        validate: v,
        reset: p,
        resetValidation: _,
        vm: uE(g),
        isValid: null,
        errorMessages: []
      });
    },
    unregister: (f) => {
      s.value = s.value.filter((m) => m.id !== f);
    },
    update: (f, m, g) => {
      const v = s.value.find((p) => p.id === f);
      v && (v.isValid = m, v.errorMessages = g);
    },
    isDisabled: n,
    isReadonly: i,
    isValidating: r,
    isValid: t,
    items: s,
    validateOn: ce(e, "validateOn")
  }), {
    errors: a,
    isDisabled: n,
    isReadonly: i,
    isValidating: r,
    isValid: t,
    items: s,
    validate: l,
    reset: c,
    resetValidation: d
  };
}
function mw(e) {
  const t = gt(hw, null);
  return {
    ...t,
    isReadonly: I(() => !!((e == null ? void 0 : e.readonly) ?? (t == null ? void 0 : t.isReadonly.value))),
    isDisabled: I(() => !!((e == null ? void 0 : e.disabled) ?? (t == null ? void 0 : t.isDisabled.value)))
  };
}
const KV = ee({
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  errorMessages: {
    type: [Array, String],
    default: () => []
  },
  maxErrors: {
    type: [Number, String],
    default: 1
  },
  name: String,
  label: String,
  readonly: {
    type: Boolean,
    default: null
  },
  rules: {
    type: Array,
    default: () => []
  },
  modelValue: null,
  validateOn: String,
  validationValue: null,
  ...Hm()
}, "validation");
function XV(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Yi(), n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : pi();
  const i = at(e, "modelValue"), r = I(() => e.validationValue === void 0 ? i.value : e.validationValue), s = mw(e), a = ue([]), l = Ie(!0), c = I(() => !!(mn(i.value === "" ? null : i.value).length || mn(r.value === "" ? null : r.value).length)), d = I(() => {
    var M;
    return (M = e.errorMessages) != null && M.length ? mn(e.errorMessages).concat(a.value).slice(0, Math.max(0, +e.maxErrors)) : a.value;
  }), f = I(() => {
    var D;
    let M = (e.validateOn ?? ((D = s.validateOn) == null ? void 0 : D.value)) || "input";
    M === "lazy" && (M = "input lazy"), M === "eager" && (M = "input eager");
    const E = new Set((M == null ? void 0 : M.split(" ")) ?? []);
    return {
      input: E.has("input"),
      blur: E.has("blur") || E.has("input") || E.has("invalid-input"),
      invalidInput: E.has("invalid-input"),
      lazy: E.has("lazy"),
      eager: E.has("eager")
    };
  }), m = I(() => {
    var M;
    return e.error || (M = e.errorMessages) != null && M.length ? !1 : e.rules.length ? l.value ? a.value.length || f.value.lazy ? null : !0 : !a.value.length : !0;
  }), g = Ie(!1), v = I(() => ({
    [`${t}--error`]: m.value === !1,
    [`${t}--dirty`]: c.value,
    [`${t}--disabled`]: s.isDisabled.value,
    [`${t}--readonly`]: s.isReadonly.value
  })), p = Nt("validation"), _ = I(() => e.name ?? je(n));
  _l(() => {
    var M;
    (M = s.register) == null || M.call(s, {
      id: _.value,
      vm: p,
      validate: T,
      reset: x,
      resetValidation: S
    });
  }), kn(() => {
    var M;
    (M = s.unregister) == null || M.call(s, _.value);
  }), Jn(async () => {
    var M;
    f.value.lazy || await T(!f.value.eager), (M = s.update) == null || M.call(s, _.value, m.value, d.value);
  }), _r(() => f.value.input || f.value.invalidInput && m.value === !1, () => {
    Se(r, () => {
      if (r.value != null)
        T();
      else if (e.focused) {
        const M = Se(() => e.focused, (E) => {
          E || T(), M();
        });
      }
    });
  }), _r(() => f.value.blur, () => {
    Se(() => e.focused, (M) => {
      M || T();
    });
  }), Se([m, d], () => {
    var M;
    (M = s.update) == null || M.call(s, _.value, m.value, d.value);
  });
  async function x() {
    i.value = null, await Ct(), await S();
  }
  async function S() {
    l.value = !0, f.value.lazy ? a.value = [] : await T(!f.value.eager);
  }
  async function T() {
    let M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    const E = [];
    g.value = !0;
    for (const D of e.rules) {
      if (E.length >= +(e.maxErrors ?? 1))
        break;
      const $ = await (typeof D == "function" ? D : () => D)(r.value);
      if ($ !== !0) {
        if ($ !== !1 && typeof $ != "string") {
          console.warn(`${$} is not a valid value. Rule functions must return boolean true or a string.`);
          continue;
        }
        E.push($ || "");
      }
    }
    return a.value = E, g.value = !1, l.value = M, a.value;
  }
  return {
    errorMessages: d,
    isDirty: c,
    isDisabled: s.isDisabled,
    isReadonly: s.isReadonly,
    isPristine: l,
    isValid: m,
    isValidating: g,
    reset: x,
    resetValidation: S,
    validate: T,
    validationClasses: v
  };
}
const Fl = ee({
  id: String,
  appendIcon: He,
  centerAffix: {
    type: Boolean,
    default: !0
  },
  prependIcon: He,
  hideDetails: [Boolean, String],
  hideSpinButtons: Boolean,
  hint: String,
  persistentHint: Boolean,
  messages: {
    type: [Array, String],
    default: () => []
  },
  direction: {
    type: String,
    default: "horizontal",
    validator: (e) => ["horizontal", "vertical"].includes(e)
  },
  "onClick:prepend": cn(),
  "onClick:append": cn(),
  ...Ae(),
  ...Qn(),
  ...vE(Di(), ["maxWidth", "minWidth", "width"]),
  ...$t(),
  ...KV()
}, "VInput"), is = pe()({
  name: "VInput",
  props: {
    ...Fl()
  },
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: i,
      emit: r
    } = t;
    const {
      densityClasses: s
    } = Mi(e), {
      dimensionStyles: a
    } = Vi(e), {
      themeClasses: l
    } = Zt(e), {
      rtlClasses: c
    } = Tn(), {
      InputIcon: d
    } = fw(e), f = pi(), m = I(() => e.id || `input-${f}`), g = I(() => `${m.value}-messages`), {
      errorMessages: v,
      isDirty: p,
      isDisabled: _,
      isReadonly: x,
      isPristine: S,
      isValid: T,
      isValidating: M,
      reset: E,
      resetValidation: D,
      validate: R,
      validationClasses: $
    } = XV(e, "v-input", m), A = I(() => ({
      id: m,
      messagesId: g,
      isDirty: p,
      isDisabled: _,
      isReadonly: x,
      isPristine: S,
      isValid: T,
      isValidating: M,
      reset: E,
      resetValidation: D,
      validate: R
    })), V = I(() => {
      var H;
      return (H = e.errorMessages) != null && H.length || !S.value && v.value.length ? v.value : e.hint && (e.persistentHint || e.focused) ? e.hint : e.messages;
    });
    return ke(() => {
      var X, se, de, _e;
      const H = !!(i.prepend || e.prependIcon), B = !!(i.append || e.appendIcon), N = V.value.length > 0, q = !e.hideDetails || e.hideDetails === "auto" && (N || !!i.details);
      return b("div", {
        class: ["v-input", `v-input--${e.direction}`, {
          "v-input--center-affix": e.centerAffix,
          "v-input--hide-spin-buttons": e.hideSpinButtons
        }, s.value, l.value, c.value, $.value, e.class],
        style: [a.value, e.style]
      }, [H && b("div", {
        key: "prepend",
        class: "v-input__prepend"
      }, [(X = i.prepend) == null ? void 0 : X.call(i, A.value), e.prependIcon && b(d, {
        key: "prepend-icon",
        name: "prepend"
      }, null)]), i.default && b("div", {
        class: "v-input__control"
      }, [(se = i.default) == null ? void 0 : se.call(i, A.value)]), B && b("div", {
        key: "append",
        class: "v-input__append"
      }, [e.appendIcon && b(d, {
        key: "append-icon",
        name: "append"
      }, null), (de = i.append) == null ? void 0 : de.call(i, A.value)]), q && b("div", {
        id: g.value,
        class: "v-input__details",
        role: "alert",
        "aria-live": "polite"
      }, [b(GV, {
        active: N,
        messages: V.value
      }, {
        message: i.message
      }), (_e = i.details) == null ? void 0 : _e.call(i, A.value)])]);
    }), {
      reset: E,
      resetValidation: D,
      validate: R,
      isValid: T,
      errorMessages: v
    };
  }
}), JV = ee({
  ...Fl(),
  ...Gi(dw(), ["inline"])
}, "VCheckbox"), Wm = pe()({
  name: "VCheckbox",
  inheritAttrs: !1,
  props: JV(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:focused": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const r = at(e, "modelValue"), {
      isFocused: s,
      focus: a,
      blur: l
    } = Ll(e), c = pi(), d = I(() => e.id || `checkbox-${c}`);
    return ke(() => {
      const [f, m] = Yc(n), g = is.filterProps(e), v = Ra.filterProps(e);
      return b(is, fe({
        class: ["v-checkbox", e.class]
      }, f, g, {
        modelValue: r.value,
        "onUpdate:modelValue": (p) => r.value = p,
        id: d.value,
        focused: s.value,
        style: e.style
      }), {
        ...i,
        default: (p) => {
          let {
            id: _,
            messagesId: x,
            isDisabled: S,
            isReadonly: T,
            isValid: M
          } = p;
          return b(Ra, fe(v, {
            id: _.value,
            "aria-describedby": x.value,
            disabled: S.value,
            readonly: T.value
          }, m, {
            error: M.value === !1,
            modelValue: r.value,
            "onUpdate:modelValue": (E) => r.value = E,
            onFocus: a,
            onBlur: l
          }), i);
        }
      });
    }), {};
  }
}), QV = ee({
  active: Boolean,
  disabled: Boolean,
  max: [Number, String],
  value: {
    type: [Number, String],
    default: 0
  },
  ...Ae(),
  ...Wa({
    transition: {
      component: mx
    }
  })
}, "VCounter"), gw = pe()({
  name: "VCounter",
  functional: !0,
  props: QV(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = I(() => e.max ? `${e.value} / ${e.max}` : String(e.value));
    return ke(() => b(pr, {
      transition: e.transition
    }, {
      default: () => [rn(b("div", {
        class: ["v-counter", {
          "text-error": e.max && !e.disabled && parseFloat(e.value) > parseFloat(e.max)
        }, e.class],
        style: e.style
      }, [n.default ? n.default({
        counter: i.value,
        max: e.max,
        value: e.value
      }) : i.value]), [[qs, e.active]])]
    })), {};
  }
}), eL = ee({
  floating: Boolean,
  ...Ae()
}, "VFieldLabel"), Uu = pe()({
  name: "VFieldLabel",
  props: eL(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return ke(() => b(zm, {
      class: ["v-field-label", {
        "v-field-label--floating": e.floating
      }, e.class],
      style: e.style,
      "aria-hidden": e.floating || void 0
    }, n)), {};
  }
}), tL = ["underlined", "outlined", "filled", "solo", "solo-inverted", "solo-filled", "plain"], Um = ee({
  appendInnerIcon: He,
  bgColor: String,
  clearable: Boolean,
  clearIcon: {
    type: He,
    default: "$clear"
  },
  active: Boolean,
  centerAffix: {
    type: Boolean,
    default: void 0
  },
  color: String,
  baseColor: String,
  dirty: Boolean,
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  flat: Boolean,
  label: String,
  persistentClear: Boolean,
  prependInnerIcon: He,
  reverse: Boolean,
  singleLine: Boolean,
  variant: {
    type: String,
    default: "filled",
    validator: (e) => tL.includes(e)
  },
  "onClick:clear": cn(),
  "onClick:appendInner": cn(),
  "onClick:prependInner": cn(),
  ...Ae(),
  ...rd(),
  ...vn(),
  ...$t()
}, "VField"), qm = pe()({
  name: "VField",
  inheritAttrs: !1,
  props: {
    id: String,
    ...Hm(),
    ...Um()
  },
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: i,
      slots: r
    } = t;
    const {
      themeClasses: s
    } = Zt(e), {
      loaderClasses: a
    } = sd(e), {
      focusClasses: l,
      isFocused: c,
      focus: d,
      blur: f
    } = Ll(e), {
      InputIcon: m
    } = fw(e), {
      roundedClasses: g
    } = Cn(e), {
      rtlClasses: v
    } = Tn(), p = I(() => e.dirty || e.active), _ = I(() => !!(e.label || r.label)), x = I(() => !e.singleLine && _.value), S = pi(), T = I(() => e.id || `input-${S}`), M = I(() => `${T.value}-messages`), E = ue(), D = ue(), R = ue(), $ = I(() => ["plain", "underlined"].includes(e.variant)), {
      backgroundColorClasses: A,
      backgroundColorStyles: V
    } = Bn(ce(e, "bgColor")), {
      textColorClasses: H,
      textColorStyles: B
    } = Ei(I(() => e.error || e.disabled ? void 0 : p.value && c.value ? e.color : e.baseColor));
    Se(p, (X) => {
      if (x.value) {
        const se = E.value.$el, de = D.value.$el;
        requestAnimationFrame(() => {
          const _e = mm(se), be = de.getBoundingClientRect(), oe = be.x - _e.x, J = be.y - _e.y - (_e.height / 2 - be.height / 2), G = be.width / 0.75, ie = Math.abs(G - _e.width) > 1 ? {
            maxWidth: Ce(G)
          } : void 0, ge = getComputedStyle(se), he = getComputedStyle(de), Oe = parseFloat(ge.transitionDuration) * 1e3 || 150, Q = parseFloat(he.getPropertyValue("--v-field-label-scale")), me = he.getPropertyValue("color");
          se.style.visibility = "visible", de.style.visibility = "hidden", Ca(se, {
            transform: `translate(${oe}px, ${J}px) scale(${Q})`,
            color: me,
            ...ie
          }, {
            duration: Oe,
            easing: Sc,
            direction: X ? "normal" : "reverse"
          }).finished.then(() => {
            se.style.removeProperty("visibility"), de.style.removeProperty("visibility");
          });
        });
      }
    }, {
      flush: "post"
    });
    const N = I(() => ({
      isActive: p,
      isFocused: c,
      controlRef: R,
      blur: f,
      focus: d
    }));
    function q(X) {
      X.target !== document.activeElement && X.preventDefault();
    }
    return ke(() => {
      var oe, J, G;
      const X = e.variant === "outlined", se = !!(r["prepend-inner"] || e.prependInnerIcon), de = !!(e.clearable || r.clear) && !e.disabled, _e = !!(r["append-inner"] || e.appendInnerIcon || de), be = () => r.label ? r.label({
        ...N.value,
        label: e.label,
        props: {
          for: T.value
        }
      }) : e.label;
      return b("div", fe({
        class: ["v-field", {
          "v-field--active": p.value,
          "v-field--appended": _e,
          "v-field--center-affix": e.centerAffix ?? !$.value,
          "v-field--disabled": e.disabled,
          "v-field--dirty": e.dirty,
          "v-field--error": e.error,
          "v-field--flat": e.flat,
          "v-field--has-background": !!e.bgColor,
          "v-field--persistent-clear": e.persistentClear,
          "v-field--prepended": se,
          "v-field--reverse": e.reverse,
          "v-field--single-line": e.singleLine,
          "v-field--no-label": !be(),
          [`v-field--variant-${e.variant}`]: !0
        }, s.value, A.value, l.value, a.value, g.value, v.value, e.class],
        style: [V.value, e.style],
        onClick: q
      }, n), [b("div", {
        class: "v-field__overlay"
      }, null), b(Im, {
        name: "v-field",
        active: !!e.loading,
        color: e.error ? "error" : typeof e.loading == "string" ? e.loading : e.color
      }, {
        default: r.loader
      }), se && b("div", {
        key: "prepend",
        class: "v-field__prepend-inner"
      }, [e.prependInnerIcon && b(m, {
        key: "prepend-icon",
        name: "prependInner"
      }, null), (oe = r["prepend-inner"]) == null ? void 0 : oe.call(r, N.value)]), b("div", {
        class: "v-field__field",
        "data-no-activator": ""
      }, [["filled", "solo", "solo-inverted", "solo-filled"].includes(e.variant) && x.value && b(Uu, {
        key: "floating-label",
        ref: D,
        class: [H.value],
        floating: !0,
        for: T.value,
        style: B.value
      }, {
        default: () => [be()]
      }), _.value && b(Uu, {
        key: "label",
        ref: E,
        for: T.value
      }, {
        default: () => [be()]
      }), (J = r.default) == null ? void 0 : J.call(r, {
        ...N.value,
        props: {
          id: T.value,
          class: "v-field__input",
          "aria-describedby": M.value
        },
        focus: d,
        blur: f
      })]), de && b(vx, {
        key: "clear"
      }, {
        default: () => [rn(b("div", {
          class: "v-field__clearable",
          onMousedown: (ie) => {
            ie.preventDefault(), ie.stopPropagation();
          }
        }, [b(Mt, {
          defaults: {
            VIcon: {
              icon: e.clearIcon
            }
          }
        }, {
          default: () => [r.clear ? r.clear({
            ...N.value,
            props: {
              onFocus: d,
              onBlur: f,
              onClick: e["onClick:clear"]
            }
          }) : b(m, {
            name: "clear",
            onFocus: d,
            onBlur: f
          }, null)]
        })]), [[qs, e.dirty]])]
      }), _e && b("div", {
        key: "append",
        class: "v-field__append-inner"
      }, [(G = r["append-inner"]) == null ? void 0 : G.call(r, N.value), e.appendInnerIcon && b(m, {
        key: "append-icon",
        name: "appendInner"
      }, null)]), b("div", {
        class: ["v-field__outline", H.value],
        style: B.value
      }, [X && b(Le, null, [b("div", {
        class: "v-field__outline__start"
      }, null), x.value && b("div", {
        class: "v-field__outline__notch"
      }, [b(Uu, {
        ref: D,
        floating: !0,
        for: T.value
      }, {
        default: () => [be()]
      })]), b("div", {
        class: "v-field__outline__end"
      }, null)]), $.value && x.value && b(Uu, {
        ref: D,
        floating: !0,
        for: T.value
      }, {
        default: () => [be()]
      })])]);
    }), {
      controlRef: R
    };
  }
});
function vw(e) {
  const t = Object.keys(qm.props).filter((n) => !Gc(n) && n !== "class" && n !== "style");
  return B0(e, t);
}
const nL = ["color", "file", "time", "date", "datetime-local", "week", "month"], yw = ee({
  autofocus: Boolean,
  counter: [Boolean, Number, String],
  counterValue: [Number, Function],
  prefix: String,
  placeholder: String,
  persistentPlaceholder: Boolean,
  persistentCounter: Boolean,
  suffix: String,
  role: String,
  type: {
    type: String,
    default: "text"
  },
  modelModifiers: Object,
  ...Fl(),
  ...Um()
}, "VTextField"), hl = pe()({
  name: "VTextField",
  directives: {
    Intersect: ed
  },
  inheritAttrs: !1,
  props: yw(),
  emits: {
    "click:control": (e) => !0,
    "mousedown:control": (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: i,
      slots: r
    } = t;
    const s = at(e, "modelValue"), {
      isFocused: a,
      focus: l,
      blur: c
    } = Ll(e), d = I(() => typeof e.counterValue == "function" ? e.counterValue(s.value) : typeof e.counterValue == "number" ? e.counterValue : (s.value ?? "").toString().length), f = I(() => {
      if (n.maxlength)
        return n.maxlength;
      if (!(!e.counter || typeof e.counter != "number" && typeof e.counter != "string"))
        return e.counter;
    }), m = I(() => ["plain", "underlined"].includes(e.variant));
    function g(R, $) {
      var A, V;
      !e.autofocus || !R || (V = (A = $[0].target) == null ? void 0 : A.focus) == null || V.call(A);
    }
    const v = ue(), p = ue(), _ = ue(), x = I(() => nL.includes(e.type) || e.persistentPlaceholder || a.value || e.active);
    function S() {
      var R;
      _.value !== document.activeElement && ((R = _.value) == null || R.focus()), a.value || l();
    }
    function T(R) {
      i("mousedown:control", R), R.target !== _.value && (S(), R.preventDefault());
    }
    function M(R) {
      S(), i("click:control", R);
    }
    function E(R) {
      R.stopPropagation(), S(), Ct(() => {
        s.value = null, hm(e["onClick:clear"], R);
      });
    }
    function D(R) {
      var A;
      const $ = R.target;
      if (s.value = $.value, (A = e.modelModifiers) != null && A.trim && ["text", "search", "password", "tel", "url"].includes(e.type)) {
        const V = [$.selectionStart, $.selectionEnd];
        Ct(() => {
          $.selectionStart = V[0], $.selectionEnd = V[1];
        });
      }
    }
    return ke(() => {
      const R = !!(r.counter || e.counter !== !1 && e.counter != null), $ = !!(R || r.details), [A, V] = Yc(n), {
        modelValue: H,
        ...B
      } = is.filterProps(e), N = vw(e);
      return b(is, fe({
        ref: v,
        modelValue: s.value,
        "onUpdate:modelValue": (q) => s.value = q,
        class: ["v-text-field", {
          "v-text-field--prefixed": e.prefix,
          "v-text-field--suffixed": e.suffix,
          "v-input--plain-underlined": m.value
        }, e.class],
        style: e.style
      }, A, B, {
        centerAffix: !m.value,
        focused: a.value
      }), {
        ...r,
        default: (q) => {
          let {
            id: X,
            isDisabled: se,
            isDirty: de,
            isReadonly: _e,
            isValid: be
          } = q;
          return b(qm, fe({
            ref: p,
            onMousedown: T,
            onClick: M,
            "onClick:clear": E,
            "onClick:prependInner": e["onClick:prependInner"],
            "onClick:appendInner": e["onClick:appendInner"],
            role: e.role
          }, N, {
            id: X.value,
            active: x.value || de.value,
            dirty: de.value || e.dirty,
            disabled: se.value,
            focused: a.value,
            error: be.value === !1
          }), {
            ...r,
            default: (oe) => {
              let {
                props: {
                  class: J,
                  ...G
                }
              } = oe;
              const ie = rn(b("input", fe({
                ref: _,
                value: s.value,
                onInput: D,
                autofocus: e.autofocus,
                readonly: _e.value,
                disabled: se.value,
                name: e.name,
                placeholder: e.placeholder,
                size: 1,
                type: e.type,
                onFocus: S,
                onBlur: c
              }, G, V), null), [[ji("intersect"), {
                handler: g
              }, null, {
                once: !0
              }]]);
              return b(Le, null, [e.prefix && b("span", {
                class: "v-text-field__prefix"
              }, [b("span", {
                class: "v-text-field__prefix__text"
              }, [e.prefix])]), r.default ? b("div", {
                class: J,
                "data-no-activator": ""
              }, [r.default(), ie]) : cE(ie, {
                class: J
              }), e.suffix && b("span", {
                class: "v-text-field__suffix"
              }, [b("span", {
                class: "v-text-field__suffix__text"
              }, [e.suffix])])]);
            }
          });
        },
        details: $ ? (q) => {
          var X;
          return b(Le, null, [(X = r.details) == null ? void 0 : X.call(r, q), R && b(Le, null, [b("span", null, null), b(gw, {
            active: e.persistentCounter || a.value,
            value: d.value,
            max: f.value,
            disabled: e.disabled
          }, r.counter)])]);
        } : void 0
      });
    }), ls({}, v, p, _);
  }
}), iL = ee({
  renderless: Boolean,
  ...Ae()
}, "VVirtualScrollItem"), rL = pe()({
  name: "VVirtualScrollItem",
  inheritAttrs: !1,
  props: iL(),
  emits: {
    "update:height": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: i,
      slots: r
    } = t;
    const {
      resizeRef: s,
      contentRect: a
    } = Ws(void 0, "border");
    Se(() => {
      var l;
      return (l = a.value) == null ? void 0 : l.height;
    }, (l) => {
      l != null && i("update:height", l);
    }), ke(() => {
      var l, c;
      return e.renderless ? b(Le, null, [(l = r.default) == null ? void 0 : l.call(r, {
        itemRef: s
      })]) : b("div", fe({
        ref: s,
        class: ["v-virtual-scroll__item", e.class],
        style: e.style
      }, n), [(c = r.default) == null ? void 0 : c.call(r)]);
    });
  }
}), sL = -1, aL = 1, rh = 100, oL = ee({
  itemHeight: {
    type: [Number, String],
    default: null
  },
  height: [Number, String]
}, "virtual");
function lL(e, t) {
  const n = js(), i = Ie(0);
  Xn(() => {
    i.value = parseFloat(e.itemHeight || 0);
  });
  const r = Ie(0), s = Ie(Math.ceil(
    // Assume 16px items filling the entire screen height if
    // not provided. This is probably incorrect but it minimises
    // the chance of ending up with empty space at the bottom.
    // The default value is set here to avoid poisoning getSize()
    (parseInt(e.height) || n.height.value) / (i.value || 16)
  ) || 1), a = Ie(0), l = Ie(0), c = ue(), d = ue();
  let f = 0;
  const {
    resizeRef: m,
    contentRect: g
  } = Ws();
  Xn(() => {
    m.value = c.value;
  });
  const v = I(() => {
    var J;
    return c.value === document.documentElement ? n.height.value : ((J = g.value) == null ? void 0 : J.height) || parseInt(e.height) || 0;
  }), p = I(() => !!(c.value && d.value && v.value && i.value));
  let _ = Array.from({
    length: t.value.length
  }), x = Array.from({
    length: t.value.length
  });
  const S = Ie(0);
  let T = -1;
  function M(J) {
    return _[J] || i.value;
  }
  const E = pE(() => {
    const J = performance.now();
    x[0] = 0;
    const G = t.value.length;
    for (let ie = 1; ie <= G - 1; ie++)
      x[ie] = (x[ie - 1] || 0) + M(ie - 1);
    S.value = Math.max(S.value, performance.now() - J);
  }, S), D = Se(p, (J) => {
    J && (D(), f = d.value.offsetTop, E.immediate(), de(), ~T && Ct(() => {
      Bt && window.requestAnimationFrame(() => {
        be(T), T = -1;
      });
    }));
  });
  gn(() => {
    E.clear();
  });
  function R(J, G) {
    const ie = _[J], ge = i.value;
    i.value = ge ? Math.min(i.value, G) : G, (ie !== G || ge !== i.value) && (_[J] = G, E());
  }
  function $(J) {
    return J = Jt(J, 0, t.value.length - 1), x[J] || 0;
  }
  function A(J) {
    return uL(x, J);
  }
  let V = 0, H = 0, B = 0;
  Se(v, (J, G) => {
    G && (de(), J < G && requestAnimationFrame(() => {
      H = 0, de();
    }));
  });
  let N = -1;
  function q() {
    if (!c.value || !d.value)
      return;
    const J = c.value.scrollTop, G = performance.now();
    G - B > 500 ? (H = Math.sign(J - V), f = d.value.offsetTop) : H = J - V, V = J, B = G, window.clearTimeout(N), N = window.setTimeout(X, 500), de();
  }
  function X() {
    !c.value || !d.value || (H = 0, B = 0, window.clearTimeout(N), de());
  }
  let se = -1;
  function de() {
    cancelAnimationFrame(se), se = requestAnimationFrame(_e);
  }
  function _e() {
    if (!c.value || !v.value)
      return;
    const J = V - f, G = Math.sign(H), ie = Math.max(0, J - rh), ge = Jt(A(ie), 0, t.value.length), he = J + v.value + rh, Oe = Jt(A(he) + 1, ge + 1, t.value.length);
    if (
      // Only update the side we're scrolling towards,
      // the other side will be updated incidentally
      (G !== sL || ge < r.value) && (G !== aL || Oe > s.value)
    ) {
      const Q = $(r.value) - $(ge), me = $(Oe) - $(s.value);
      Math.max(Q, me) > rh ? (r.value = ge, s.value = Oe) : (ge <= 0 && (r.value = ge), Oe >= t.value.length && (s.value = Oe));
    }
    a.value = $(r.value), l.value = $(t.value.length) - $(s.value);
  }
  function be(J) {
    const G = $(J);
    !c.value || J && !G ? T = J : c.value.scrollTop = G;
  }
  const oe = I(() => t.value.slice(r.value, s.value).map((J, G) => ({
    raw: J,
    index: G + r.value,
    key: R0(J) && "value" in J ? J.value : G + r.value
  })));
  return Se(t, () => {
    _ = Array.from({
      length: t.value.length
    }), x = Array.from({
      length: t.value.length
    }), E.immediate(), de();
  }, {
    deep: !0
  }), {
    calculateVisibleItems: de,
    containerRef: c,
    markerRef: d,
    computedItems: oe,
    paddingTop: a,
    paddingBottom: l,
    scrollToIndex: be,
    handleScroll: q,
    handleScrollend: X,
    handleItemResize: R
  };
}
function uL(e, t) {
  let n = e.length - 1, i = 0, r = 0, s = null, a = -1;
  if (e[n] < t)
    return n;
  for (; i <= n; )
    if (r = i + n >> 1, s = e[r], s > t)
      n = r - 1;
    else if (s < t)
      a = r, i = r + 1;
    else
      return s === t ? r : i;
  return a;
}
const cL = ee({
  items: {
    type: Array,
    default: () => []
  },
  renderless: Boolean,
  ...oL(),
  ...Ae(),
  ...Di()
}, "VVirtualScroll"), dL = pe()({
  name: "VVirtualScroll",
  props: cL(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = Nt("VVirtualScroll"), {
      dimensionStyles: r
    } = Vi(e), {
      calculateVisibleItems: s,
      containerRef: a,
      markerRef: l,
      handleScroll: c,
      handleScrollend: d,
      handleItemResize: f,
      scrollToIndex: m,
      paddingTop: g,
      paddingBottom: v,
      computedItems: p
    } = lL(e, ce(e, "items"));
    return _r(() => e.renderless, () => {
      function _() {
        var T, M;
        const S = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1) ? "addEventListener" : "removeEventListener";
        a.value === document.documentElement ? (document[S]("scroll", c, {
          passive: !0
        }), document[S]("scrollend", d)) : ((T = a.value) == null || T[S]("scroll", c, {
          passive: !0
        }), (M = a.value) == null || M[S]("scrollend", d));
      }
      Jn(() => {
        a.value = Q0(i.vnode.el, !0), _(!0);
      }), gn(_);
    }), ke(() => {
      const _ = p.value.map((x) => b(rL, {
        key: x.key,
        renderless: e.renderless,
        "onUpdate:height": (S) => f(x.index, S)
      }, {
        default: (S) => {
          var T;
          return (T = n.default) == null ? void 0 : T.call(n, {
            item: x.raw,
            index: x.index,
            ...S
          });
        }
      }));
      return e.renderless ? b(Le, null, [b("div", {
        ref: l,
        class: "v-virtual-scroll__spacer",
        style: {
          paddingTop: Ce(g.value)
        }
      }, null), _, b("div", {
        class: "v-virtual-scroll__spacer",
        style: {
          paddingBottom: Ce(v.value)
        }
      }, null)]) : b("div", {
        ref: a,
        class: ["v-virtual-scroll", e.class],
        onScrollPassive: c,
        onScrollend: d,
        style: [r.value, e.style]
      }, [b("div", {
        ref: l,
        class: "v-virtual-scroll__container",
        style: {
          paddingTop: Ce(g.value),
          paddingBottom: Ce(v.value)
        }
      }, [_])]);
    }), {
      calculateVisibleItems: s,
      scrollToIndex: m
    };
  }
});
function fL(e, t) {
  const n = Ie(!1);
  let i;
  function r(l) {
    cancelAnimationFrame(i), n.value = !0, i = requestAnimationFrame(() => {
      i = requestAnimationFrame(() => {
        n.value = !1;
      });
    });
  }
  async function s() {
    await new Promise((l) => requestAnimationFrame(l)), await new Promise((l) => requestAnimationFrame(l)), await new Promise((l) => requestAnimationFrame(l)), await new Promise((l) => {
      if (n.value) {
        const c = Se(n, () => {
          c(), l();
        });
      } else
        l();
    });
  }
  async function a(l) {
    var f, m;
    if (l.key === "Tab" && ((f = t.value) == null || f.focus()), !["PageDown", "PageUp", "Home", "End"].includes(l.key))
      return;
    const c = (m = e.value) == null ? void 0 : m.$el;
    if (!c)
      return;
    (l.key === "Home" || l.key === "End") && c.scrollTo({
      top: l.key === "Home" ? 0 : c.scrollHeight,
      behavior: "smooth"
    }), await s();
    const d = c.querySelectorAll(":scope > :not(.v-virtual-scroll__spacer)");
    if (l.key === "PageDown" || l.key === "Home") {
      const g = c.getBoundingClientRect().top;
      for (const v of d)
        if (v.getBoundingClientRect().top >= g) {
          v.focus();
          break;
        }
    } else {
      const g = c.getBoundingClientRect().bottom;
      for (const v of [...d].reverse())
        if (v.getBoundingClientRect().bottom <= g) {
          v.focus();
          break;
        }
    }
  }
  return {
    onScrollPassive: r,
    onKeydown: a
  };
}
const hL = ee({
  chips: Boolean,
  closableChips: Boolean,
  closeText: {
    type: String,
    default: "$vuetify.close"
  },
  openText: {
    type: String,
    default: "$vuetify.open"
  },
  eager: Boolean,
  hideNoData: Boolean,
  hideSelected: Boolean,
  listProps: {
    type: Object
  },
  menu: Boolean,
  menuIcon: {
    type: He,
    default: "$dropdown"
  },
  menuProps: {
    type: Object
  },
  multiple: Boolean,
  noDataText: {
    type: String,
    default: "$vuetify.noDataText"
  },
  openOnClear: Boolean,
  itemColor: String,
  ...Bx({
    itemChildren: !1
  })
}, "Select"), mL = ee({
  ...hL(),
  ...Gi(yw({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty", "appendInnerIcon"]),
  ...Wa({
    transition: {
      component: Sm
    }
  })
}, "VSelect"), hd = pe()({
  name: "VSelect",
  props: mL(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:menu": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      t: i
    } = os(), r = ue(), s = ue(), a = ue(), l = at(e, "menu"), c = I({
      get: () => l.value,
      set: (oe) => {
        var J;
        l.value && !oe && ((J = s.value) != null && J.ΨopenChildren.size) || (l.value = oe);
      }
    }), {
      items: d,
      transformIn: f,
      transformOut: m
    } = lM(e), g = at(e, "modelValue", [], (oe) => f(oe === null ? [null] : mn(oe)), (oe) => {
      const J = m(oe);
      return e.multiple ? J : J[0] ?? null;
    }), v = I(() => typeof e.counterValue == "function" ? e.counterValue(g.value) : typeof e.counterValue == "number" ? e.counterValue : g.value.length), p = mw(e), _ = I(() => g.value.map((oe) => oe.value)), x = Ie(!1), S = I(() => c.value ? e.closeText : e.openText);
    let T = "", M;
    const E = I(() => e.hideSelected ? d.value.filter((oe) => !g.value.some((J) => e.valueComparator(J, oe))) : d.value), D = I(() => e.hideNoData && !E.value.length || p.isReadonly.value || p.isDisabled.value), R = I(() => {
      var oe;
      return {
        ...e.menuProps,
        activatorProps: {
          ...((oe = e.menuProps) == null ? void 0 : oe.activatorProps) || {},
          "aria-haspopup": "listbox"
          // Set aria-haspopup to 'listbox'
        }
      };
    }), $ = ue(), A = fL($, r);
    function V(oe) {
      e.openOnClear && (c.value = !0);
    }
    function H() {
      D.value || (c.value = !c.value);
    }
    function B(oe) {
      Dy(oe) && N(oe);
    }
    function N(oe) {
      var ge, he;
      if (!oe.key || p.isReadonly.value)
        return;
      ["Enter", " ", "ArrowDown", "ArrowUp", "Home", "End"].includes(oe.key) && oe.preventDefault(), ["Enter", "ArrowDown", " "].includes(oe.key) && (c.value = !0), ["Escape", "Tab"].includes(oe.key) && (c.value = !1), oe.key === "Home" ? (ge = $.value) == null || ge.focus("first") : oe.key === "End" && ((he = $.value) == null || he.focus("last"));
      const J = 1e3;
      if (!Dy(oe))
        return;
      const G = performance.now();
      G - M > J && (T = ""), T += oe.key.toLowerCase(), M = G;
      const ie = d.value.find((Oe) => Oe.title.toLowerCase().startsWith(T));
      if (ie !== void 0) {
        g.value = [ie];
        const Oe = E.value.indexOf(ie);
        Bt && window.requestAnimationFrame(() => {
          var Q;
          Oe >= 0 && ((Q = a.value) == null || Q.scrollToIndex(Oe));
        });
      }
    }
    function q(oe) {
      let J = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!oe.props.disabled)
        if (e.multiple) {
          const G = g.value.findIndex((ge) => e.valueComparator(ge.value, oe.value)), ie = J ?? !~G;
          if (~G) {
            const ge = ie ? [...g.value, oe] : [...g.value];
            ge.splice(G, 1), g.value = ge;
          } else
            ie && (g.value = [...g.value, oe]);
        } else {
          const G = J !== !1;
          g.value = G ? [oe] : [], Ct(() => {
            c.value = !1;
          });
        }
    }
    function X(oe) {
      var J;
      (J = $.value) != null && J.$el.contains(oe.relatedTarget) || (c.value = !1);
    }
    function se() {
      var oe;
      e.eager && ((oe = a.value) == null || oe.calculateVisibleItems());
    }
    function de() {
      var oe;
      x.value && ((oe = r.value) == null || oe.focus());
    }
    function _e(oe) {
      x.value = !0;
    }
    function be(oe) {
      if (oe == null)
        g.value = [];
      else if (_c(r.value, ":autofill") || _c(r.value, ":-webkit-autofill")) {
        const J = d.value.find((G) => G.title === oe);
        J && q(J);
      } else
        r.value && (r.value.value = "");
    }
    return Se(c, () => {
      if (!e.hideSelected && c.value && g.value.length) {
        const oe = E.value.findIndex((J) => g.value.some((G) => e.valueComparator(G.value, J.value)));
        Bt && window.requestAnimationFrame(() => {
          var J;
          oe >= 0 && ((J = a.value) == null || J.scrollToIndex(oe));
        });
      }
    }), Se(() => e.items, (oe, J) => {
      c.value || x.value && !J.length && oe.length && (c.value = !0);
    }), ke(() => {
      const oe = !!(e.chips || n.chip), J = !!(!e.hideNoData || E.value.length || n["prepend-item"] || n["append-item"] || n["no-data"]), G = g.value.length > 0, ie = hl.filterProps(e), ge = G || !x.value && e.label && !e.persistentPlaceholder ? void 0 : e.placeholder;
      return b(hl, fe({
        ref: r
      }, ie, {
        modelValue: g.value.map((he) => he.props.value).join(", "),
        "onUpdate:modelValue": be,
        focused: x.value,
        "onUpdate:focused": (he) => x.value = he,
        validationValue: g.externalValue,
        counterValue: v.value,
        dirty: G,
        class: ["v-select", {
          "v-select--active-menu": c.value,
          "v-select--chips": !!e.chips,
          [`v-select--${e.multiple ? "multiple" : "single"}`]: !0,
          "v-select--selected": g.value.length,
          "v-select--selection-slot": !!n.selection
        }, e.class],
        style: e.style,
        inputmode: "none",
        placeholder: ge,
        "onClick:clear": V,
        "onMousedown:control": H,
        onBlur: X,
        onKeydown: N,
        "aria-label": i(S.value),
        title: i(S.value)
      }), {
        ...n,
        default: () => b(Le, null, [b(td, fe({
          ref: s,
          modelValue: c.value,
          "onUpdate:modelValue": (he) => c.value = he,
          activator: "parent",
          contentClass: "v-select__content",
          disabled: D.value,
          eager: e.eager,
          maxHeight: 310,
          openOnClick: !1,
          closeOnContentClick: !1,
          transition: e.transition,
          onAfterEnter: se,
          onAfterLeave: de
        }, R.value), {
          default: () => [J && b(Tm, fe({
            ref: $,
            selected: _.value,
            selectStrategy: e.multiple ? "independent" : "single-independent",
            onMousedown: (he) => he.preventDefault(),
            onKeydown: B,
            onFocusin: _e,
            tabindex: "-1",
            "aria-live": "polite",
            color: e.itemColor ?? e.color
          }, A, e.listProps), {
            default: () => {
              var he, Oe, Q;
              return [(he = n["prepend-item"]) == null ? void 0 : he.call(n), !E.value.length && !e.hideNoData && (((Oe = n["no-data"]) == null ? void 0 : Oe.call(n)) ?? b(ts, {
                key: "no-data",
                title: i(e.noDataText)
              }, null)), b(dL, {
                ref: a,
                renderless: !0,
                items: E.value
              }, {
                default: (me) => {
                  var ft;
                  let {
                    item: Ze,
                    index: We,
                    itemRef: Ue
                  } = me;
                  const Ot = fe(Ze.props, {
                    ref: Ue,
                    key: Ze.value,
                    onClick: () => q(Ze, null)
                  });
                  return ((ft = n.item) == null ? void 0 : ft.call(n, {
                    item: Ze,
                    index: We,
                    props: Ot
                  })) ?? b(ts, fe(Ot, {
                    role: "option"
                  }), {
                    prepend: (yn) => {
                      let {
                        isSelected: xt
                      } = yn;
                      return b(Le, null, [e.multiple && !e.hideSelected ? b(Ra, {
                        key: Ze.value,
                        modelValue: xt,
                        ripple: !1,
                        tabindex: "-1"
                      }, null) : void 0, Ze.props.prependAvatar && b(es, {
                        image: Ze.props.prependAvatar
                      }, null), Ze.props.prependIcon && b(dt, {
                        icon: Ze.props.prependIcon
                      }, null)]);
                    }
                  });
                }
              }), (Q = n["append-item"]) == null ? void 0 : Q.call(n)];
            }
          })]
        }), g.value.map((he, Oe) => {
          function Q(Ue) {
            Ue.stopPropagation(), Ue.preventDefault(), q(he, !1);
          }
          const me = {
            "onClick:close": Q,
            onKeydown(Ue) {
              Ue.key !== "Enter" && Ue.key !== " " || (Ue.preventDefault(), Ue.stopPropagation(), Q(Ue));
            },
            onMousedown(Ue) {
              Ue.preventDefault(), Ue.stopPropagation();
            },
            modelValue: !0,
            "onUpdate:modelValue": void 0
          }, Ze = oe ? !!n.chip : !!n.selection, We = Ze ? W0(oe ? n.chip({
            item: he,
            index: Oe,
            props: me
          }) : n.selection({
            item: he,
            index: Oe
          })) : void 0;
          if (!(Ze && !We))
            return b("div", {
              key: he.value,
              class: "v-select__selection"
            }, [oe ? n.chip ? b(Mt, {
              key: "chip-defaults",
              defaults: {
                VChip: {
                  closable: e.closableChips,
                  size: "small",
                  text: he.title
                }
              }
            }, {
              default: () => [We]
            }) : b(Ic, fe({
              key: "chip",
              closable: e.closableChips,
              size: "small",
              text: he.title,
              disabled: he.props.disabled
            }, me), null) : We ?? b("span", {
              class: "v-select__selection-text"
            }, [he.title, e.multiple && Oe < g.value.length - 1 && b("span", {
              class: "v-select__selection-comma"
            }, [Ee(",")])])]);
        })]),
        "append-inner": function() {
          var me;
          for (var he = arguments.length, Oe = new Array(he), Q = 0; Q < he; Q++)
            Oe[Q] = arguments[Q];
          return b(Le, null, [(me = n["append-inner"]) == null ? void 0 : me.call(n, ...Oe), e.menuIcon ? b(dt, {
            class: "v-select__menu-icon",
            icon: e.menuIcon
          }, null) : void 0]);
        }
      });
    }), ls({
      isFocused: x,
      menu: c,
      select: q
    }, r);
  }
}), gL = ee({
  page: {
    type: [Number, String],
    default: 1
  },
  itemsPerPage: {
    type: [Number, String],
    default: 10
  }
}, "DataTable-paginate"), pw = Symbol.for("vuetify:data-table-pagination");
function vL(e) {
  const t = at(e, "page", void 0, (i) => +(i ?? 1)), n = at(e, "itemsPerPage", void 0, (i) => +(i ?? 10));
  return {
    page: t,
    itemsPerPage: n
  };
}
function yL(e) {
  const {
    page: t,
    itemsPerPage: n,
    itemsLength: i
  } = e, r = I(() => n.value === -1 ? 0 : n.value * (t.value - 1)), s = I(() => n.value === -1 ? i.value : Math.min(i.value, r.value + n.value)), a = I(() => n.value === -1 || i.value === 0 ? 1 : Math.ceil(i.value / n.value));
  Se([t, a], () => {
    t.value > a.value && (t.value = a.value);
  });
  function l(g) {
    n.value = g, t.value = 1;
  }
  function c() {
    t.value = Jt(t.value + 1, 1, a.value);
  }
  function d() {
    t.value = Jt(t.value - 1, 1, a.value);
  }
  function f(g) {
    t.value = Jt(g, 1, a.value);
  }
  const m = {
    page: t,
    itemsPerPage: n,
    startIndex: r,
    stopIndex: s,
    pageCount: a,
    itemsLength: i,
    nextPage: c,
    prevPage: d,
    setPage: f,
    setItemsPerPage: l
  };
  return jt(pw, m), m;
}
function pL() {
  const e = gt(pw);
  if (!e)
    throw new Error("Missing pagination!");
  return e;
}
function bL(e) {
  const t = Nt("usePaginatedItems"), {
    items: n,
    startIndex: i,
    stopIndex: r,
    itemsPerPage: s
  } = e, a = I(() => s.value <= 0 ? n.value : n.value.slice(i.value, r.value));
  return Se(a, (l) => {
    t.emit("update:currentItems", l);
  }, {
    immediate: !0
  }), {
    paginatedItems: a
  };
}
const bw = ee({
  prevIcon: {
    type: He,
    default: "$prev"
  },
  nextIcon: {
    type: He,
    default: "$next"
  },
  firstIcon: {
    type: He,
    default: "$first"
  },
  lastIcon: {
    type: He,
    default: "$last"
  },
  itemsPerPageText: {
    type: String,
    default: "$vuetify.dataFooter.itemsPerPageText"
  },
  pageText: {
    type: String,
    default: "$vuetify.dataFooter.pageText"
  },
  firstPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.firstPage"
  },
  prevPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.prevPage"
  },
  nextPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.nextPage"
  },
  lastPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.lastPage"
  },
  itemsPerPageOptions: {
    type: Array,
    default: () => [{
      value: 10,
      title: "10"
    }, {
      value: 25,
      title: "25"
    }, {
      value: 50,
      title: "50"
    }, {
      value: 100,
      title: "100"
    }, {
      value: -1,
      title: "$vuetify.dataFooter.itemsPerPageAll"
    }]
  },
  showCurrentPage: Boolean
}, "VDataTableFooter"), Zp = pe()({
  name: "VDataTableFooter",
  props: bw(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      t: i
    } = os(), {
      page: r,
      pageCount: s,
      startIndex: a,
      stopIndex: l,
      itemsLength: c,
      itemsPerPage: d,
      setItemsPerPage: f
    } = pL(), m = I(() => e.itemsPerPageOptions.map((g) => typeof g == "number" ? {
      value: g,
      title: g === -1 ? i("$vuetify.dataFooter.itemsPerPageAll") : String(g)
    } : {
      ...g,
      title: isNaN(Number(g.title)) ? i(g.title) : g.title
    }));
    return ke(() => {
      var v;
      const g = Bh.filterProps(e);
      return b("div", {
        class: "v-data-table-footer"
      }, [(v = n.prepend) == null ? void 0 : v.call(n), b("div", {
        class: "v-data-table-footer__items-per-page"
      }, [b("span", null, [i(e.itemsPerPageText)]), b(hd, {
        items: m.value,
        modelValue: d.value,
        "onUpdate:modelValue": (p) => f(Number(p)),
        density: "compact",
        variant: "outlined",
        "hide-details": !0
      }, null)]), b("div", {
        class: "v-data-table-footer__info"
      }, [b("div", null, [i(e.pageText, c.value ? a.value + 1 : 0, l.value, c.value)])]), b("div", {
        class: "v-data-table-footer__pagination"
      }, [b(Bh, fe({
        modelValue: r.value,
        "onUpdate:modelValue": (p) => r.value = p,
        density: "comfortable",
        "first-aria-label": e.firstPageLabel,
        "last-aria-label": e.lastPageLabel,
        length: s.value,
        "next-aria-label": e.nextPageLabel,
        "previous-aria-label": e.prevPageLabel,
        rounded: !0,
        "show-first-last-page": !0,
        "total-visible": e.showCurrentPage ? 1 : 0,
        variant: "plain"
      }, g), null)])]);
    }), {};
  }
}), Mc = GE({
  align: {
    type: String,
    default: "start"
  },
  fixed: Boolean,
  fixedOffset: [Number, String],
  height: [Number, String],
  lastFixed: Boolean,
  noPadding: Boolean,
  tag: String,
  width: [Number, String],
  maxWidth: [Number, String],
  nowrap: Boolean
}, (e, t) => {
  let {
    slots: n
  } = t;
  const i = e.tag ?? "td";
  return b(i, {
    class: ["v-data-table__td", {
      "v-data-table-column--fixed": e.fixed,
      "v-data-table-column--last-fixed": e.lastFixed,
      "v-data-table-column--no-padding": e.noPadding,
      "v-data-table-column--nowrap": e.nowrap
    }, `v-data-table-column--align-${e.align}`],
    style: {
      height: Ce(e.height),
      width: Ce(e.width),
      maxWidth: Ce(e.maxWidth),
      left: Ce(e.fixedOffset || null)
    }
  }, {
    default: () => {
      var r;
      return [(r = n.default) == null ? void 0 : r.call(n)];
    }
  });
}), xL = ee({
  headers: Array
}, "DataTable-header"), xw = Symbol.for("vuetify:data-table-headers"), _w = {
  title: "",
  sortable: !1
}, _L = {
  ..._w,
  width: 48
};
function wL() {
  const t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).map((n) => ({
    element: n,
    priority: 0
  }));
  return {
    enqueue: (n, i) => {
      let r = !1;
      for (let s = 0; s < t.length; s++)
        if (t[s].priority > i) {
          t.splice(s, 0, {
            element: n,
            priority: i
          }), r = !0;
          break;
        }
      r || t.push({
        element: n,
        priority: i
      });
    },
    size: () => t.length,
    count: () => {
      let n = 0;
      if (!t.length)
        return 0;
      const i = Math.floor(t[0].priority);
      for (let r = 0; r < t.length; r++)
        Math.floor(t[r].priority) === i && (n += 1);
      return n;
    },
    dequeue: () => t.shift()
  };
}
function Nh(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  if (!e.children)
    t.push(e);
  else
    for (const n of e.children)
      Nh(n, t);
  return t;
}
function ww(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /* @__PURE__ */ new Set();
  for (const n of e)
    n.key && t.add(n.key), n.children && ww(n.children, t);
  return t;
}
function SL(e) {
  if (e.key) {
    if (e.key === "data-table-group")
      return _w;
    if (["data-table-expand", "data-table-select"].includes(e.key))
      return _L;
  }
}
function jm(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return e.children ? Math.max(t, ...e.children.map((n) => jm(n, t + 1))) : t;
}
function kL(e) {
  let t = !1;
  function n(s) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (s)
      if (a && (s.fixed = !0), s.fixed)
        if (s.children)
          for (let l = s.children.length - 1; l >= 0; l--)
            n(s.children[l], !0);
        else
          t ? isNaN(+s.width) && gm(`Multiple fixed columns should have a static width (key: ${s.key})`) : s.lastFixed = !0, t = !0;
      else if (s.children)
        for (let l = s.children.length - 1; l >= 0; l--)
          n(s.children[l]);
      else
        t = !1;
  }
  for (let s = e.length - 1; s >= 0; s--)
    n(e[s]);
  function i(s) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!s)
      return a;
    if (s.children) {
      s.fixedOffset = a;
      for (const l of s.children)
        a = i(l, a);
    } else
      s.fixed && (s.fixedOffset = a, a += parseFloat(s.width || "0") || 0);
    return a;
  }
  let r = 0;
  for (const s of e)
    r = i(s, r);
}
function CL(e, t) {
  const n = [];
  let i = 0;
  const r = wL(e);
  for (; r.size() > 0; ) {
    let a = r.count();
    const l = [];
    let c = 1;
    for (; a > 0; ) {
      const {
        element: d,
        priority: f
      } = r.dequeue(), m = t - i - jm(d);
      if (l.push({
        ...d,
        rowspan: m ?? 1,
        colspan: d.children ? Nh(d).length : 1
      }), d.children)
        for (const g of d.children) {
          const v = f % 1 + c / Math.pow(10, i + 2);
          r.enqueue(g, i + m + v);
        }
      c += 1, a -= 1;
    }
    i += 1, n.push(l);
  }
  return {
    columns: e.map((a) => Nh(a)).flat(),
    headers: n
  };
}
function Sw(e) {
  const t = [];
  for (const n of e) {
    const i = {
      ...SL(n),
      ...n
    }, r = i.key ?? (typeof i.value == "string" ? i.value : null), s = i.value ?? r ?? null, a = {
      ...i,
      key: r,
      value: s,
      sortable: i.sortable ?? (i.key != null || !!i.sort),
      children: i.children ? Sw(i.children) : void 0
    };
    t.push(a);
  }
  return t;
}
function TL(e, t) {
  const n = ue([]), i = ue([]), r = ue({}), s = ue({}), a = ue({});
  Xn(() => {
    var _, x, S;
    const d = (e.headers || Object.keys(e.items[0] ?? {}).map((T) => ({
      key: T,
      title: za(T)
    }))).slice(), f = ww(d);
    (_ = t == null ? void 0 : t.groupBy) != null && _.value.length && !f.has("data-table-group") && d.unshift({
      key: "data-table-group",
      title: "Group"
    }), (x = t == null ? void 0 : t.showSelect) != null && x.value && !f.has("data-table-select") && d.unshift({
      key: "data-table-select"
    }), (S = t == null ? void 0 : t.showExpand) != null && S.value && !f.has("data-table-expand") && d.push({
      key: "data-table-expand"
    });
    const m = Sw(d);
    kL(m);
    const g = Math.max(...m.map((T) => jm(T))) + 1, v = CL(m, g);
    n.value = v.headers, i.value = v.columns;
    const p = v.headers.flat(1);
    for (const T of p)
      T.key && (T.sortable && (T.sort && (r.value[T.key] = T.sort), T.sortRaw && (s.value[T.key] = T.sortRaw)), T.filter && (a.value[T.key] = T.filter));
  });
  const l = {
    headers: n,
    columns: i,
    sortFunctions: r,
    sortRawFunctions: s,
    filterFunctions: a
  };
  return jt(xw, l), l;
}
function md() {
  const e = gt(xw);
  if (!e)
    throw new Error("Missing headers!");
  return e;
}
const IL = {
  showSelectAll: !1,
  allSelected: () => [],
  select: (e) => {
    var i;
    let {
      items: t,
      value: n
    } = e;
    return new Set(n ? [(i = t[0]) == null ? void 0 : i.value] : []);
  },
  selectAll: (e) => {
    let {
      selected: t
    } = e;
    return t;
  }
}, kw = {
  showSelectAll: !0,
  allSelected: (e) => {
    let {
      currentPage: t
    } = e;
    return t;
  },
  select: (e) => {
    let {
      items: t,
      value: n,
      selected: i
    } = e;
    for (const r of t)
      n ? i.add(r.value) : i.delete(r.value);
    return i;
  },
  selectAll: (e) => {
    let {
      value: t,
      currentPage: n,
      selected: i
    } = e;
    return kw.select({
      items: n,
      value: t,
      selected: i
    });
  }
}, Cw = {
  showSelectAll: !0,
  allSelected: (e) => {
    let {
      allItems: t
    } = e;
    return t;
  },
  select: (e) => {
    let {
      items: t,
      value: n,
      selected: i
    } = e;
    for (const r of t)
      n ? i.add(r.value) : i.delete(r.value);
    return i;
  },
  selectAll: (e) => {
    let {
      value: t,
      allItems: n,
      selected: i
    } = e;
    return Cw.select({
      items: n,
      value: t,
      selected: i
    });
  }
}, PL = ee({
  showSelect: Boolean,
  selectStrategy: {
    type: [String, Object],
    default: "page"
  },
  modelValue: {
    type: Array,
    default: () => []
  },
  valueComparator: {
    type: Function,
    default: Sr
  }
}, "DataTable-select"), Tw = Symbol.for("vuetify:data-table-selection");
function OL(e, t) {
  let {
    allItems: n,
    currentPage: i
  } = t;
  const r = at(e, "modelValue", e.modelValue, (S) => new Set(mn(S).map((T) => {
    var M;
    return ((M = n.value.find((E) => e.valueComparator(T, E.value))) == null ? void 0 : M.value) ?? T;
  })), (S) => [...S.values()]), s = I(() => n.value.filter((S) => S.selectable)), a = I(() => i.value.filter((S) => S.selectable)), l = I(() => {
    if (typeof e.selectStrategy == "object")
      return e.selectStrategy;
    switch (e.selectStrategy) {
      case "single":
        return IL;
      case "all":
        return Cw;
      case "page":
      default:
        return kw;
    }
  });
  function c(S) {
    return mn(S).every((T) => r.value.has(T.value));
  }
  function d(S) {
    return mn(S).some((T) => r.value.has(T.value));
  }
  function f(S, T) {
    const M = l.value.select({
      items: S,
      value: T,
      selected: new Set(r.value)
    });
    r.value = M;
  }
  function m(S) {
    f([S], !c([S]));
  }
  function g(S) {
    const T = l.value.selectAll({
      value: S,
      allItems: s.value,
      currentPage: a.value,
      selected: new Set(r.value)
    });
    r.value = T;
  }
  const v = I(() => r.value.size > 0), p = I(() => {
    const S = l.value.allSelected({
      allItems: s.value,
      currentPage: a.value
    });
    return !!S.length && c(S);
  }), _ = I(() => l.value.showSelectAll), x = {
    toggleSelect: m,
    select: f,
    selectAll: g,
    isSelected: c,
    isSomeSelected: d,
    someSelected: v,
    allSelected: p,
    showSelectAll: _
  };
  return jt(Tw, x), x;
}
function gd() {
  const e = gt(Tw);
  if (!e)
    throw new Error("Missing selection!");
  return e;
}
const EL = ee({
  sortBy: {
    type: Array,
    default: () => []
  },
  customKeySort: Object,
  multiSort: Boolean,
  mustSort: Boolean
}, "DataTable-sort"), Iw = Symbol.for("vuetify:data-table-sort");
function AL(e) {
  const t = at(e, "sortBy"), n = ce(e, "mustSort"), i = ce(e, "multiSort");
  return {
    sortBy: t,
    mustSort: n,
    multiSort: i
  };
}
function ML(e) {
  const {
    sortBy: t,
    mustSort: n,
    multiSort: i,
    page: r
  } = e, s = (c) => {
    if (c.key == null)
      return;
    let d = t.value.map((m) => ({
      ...m
    })) ?? [];
    const f = d.find((m) => m.key === c.key);
    f ? f.order === "desc" ? n.value ? f.order = "asc" : d = d.filter((m) => m.key !== c.key) : f.order = "desc" : i.value ? d = [...d, {
      key: c.key,
      order: "asc"
    }] : d = [{
      key: c.key,
      order: "asc"
    }], t.value = d, r && (r.value = 1);
  };
  function a(c) {
    return !!t.value.find((d) => d.key === c.key);
  }
  const l = {
    sortBy: t,
    toggleSort: s,
    isSorted: a
  };
  return jt(Iw, l), l;
}
function Pw() {
  const e = gt(Iw);
  if (!e)
    throw new Error("Missing sort!");
  return e;
}
function DL(e, t, n, i) {
  const r = os();
  return {
    sortedItems: I(() => {
      var a, l;
      return n.value.length ? VL(t.value, n.value, r.current.value, {
        transform: i == null ? void 0 : i.transform,
        sortFunctions: {
          ...e.customKeySort,
          ...(a = i == null ? void 0 : i.sortFunctions) == null ? void 0 : a.value
        },
        sortRawFunctions: (l = i == null ? void 0 : i.sortRawFunctions) == null ? void 0 : l.value
      }) : t.value;
    })
  };
}
function VL(e, t, n, i) {
  const r = new Intl.Collator(n, {
    sensitivity: "accent",
    usage: "sort"
  });
  return e.map((a) => [a, i != null && i.transform ? i.transform(a) : a]).sort((a, l) => {
    var c, d;
    for (let f = 0; f < t.length; f++) {
      let m = !1;
      const g = t[f].key, v = t[f].order ?? "asc";
      if (v === !1)
        continue;
      let p = rl(a[1], g), _ = rl(l[1], g), x = a[0].raw, S = l[0].raw;
      if (v === "desc" && ([p, _] = [_, p], [x, S] = [S, x]), (c = i == null ? void 0 : i.sortRawFunctions) != null && c[g]) {
        const T = i.sortRawFunctions[g](x, S);
        if (T == null)
          continue;
        if (m = !0, T)
          return T;
      }
      if ((d = i == null ? void 0 : i.sortFunctions) != null && d[g]) {
        const T = i.sortFunctions[g](p, _);
        if (T == null)
          continue;
        if (m = !0, T)
          return T;
      }
      if (!m) {
        if (p instanceof Date && _ instanceof Date)
          return p.getTime() - _.getTime();
        if ([p, _] = [p, _].map((T) => T != null ? T.toString().toLocaleLowerCase() : T), p !== _)
          return Du(p) && Du(_) ? 0 : Du(p) ? -1 : Du(_) ? 1 : !isNaN(p) && !isNaN(_) ? Number(p) - Number(_) : r.compare(p, _);
      }
    }
    return 0;
  }).map((a) => {
    let [l] = a;
    return l;
  });
}
const Ow = ee({
  color: String,
  disableSort: Boolean,
  fixedHeader: Boolean,
  multiSort: Boolean,
  sortAscIcon: {
    type: He,
    default: "$sortAsc"
  },
  sortDescIcon: {
    type: He,
    default: "$sortDesc"
  },
  headerProps: {
    type: Object
  },
  /** @deprecated */
  sticky: Boolean,
  ...Jc(),
  ...rd()
}, "VDataTableHeaders"), $h = pe()({
  name: "VDataTableHeaders",
  props: Ow(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      t: i
    } = os(), {
      toggleSort: r,
      sortBy: s,
      isSorted: a
    } = Pw(), {
      someSelected: l,
      allSelected: c,
      selectAll: d,
      showSelectAll: f
    } = gd(), {
      columns: m,
      headers: g
    } = md(), {
      loaderClasses: v
    } = sd(e);
    function p(A, V) {
      if (!(!(e.sticky || e.fixedHeader) && !A.fixed))
        return {
          position: "sticky",
          left: A.fixed ? Ce(A.fixedOffset) : void 0,
          top: e.sticky || e.fixedHeader ? `calc(var(--v-table-header-height) * ${V})` : void 0
        };
    }
    function _(A) {
      const V = s.value.find((H) => H.key === A.key);
      return V ? V.order === "asc" ? e.sortAscIcon : e.sortDescIcon : e.sortAscIcon;
    }
    const {
      backgroundColorClasses: x,
      backgroundColorStyles: S
    } = Bn(e, "color"), {
      displayClasses: T,
      mobile: M
    } = js(e), E = I(() => ({
      headers: g.value,
      columns: m.value,
      toggleSort: r,
      isSorted: a,
      sortBy: s.value,
      someSelected: l.value,
      allSelected: c.value,
      selectAll: d,
      getSortIcon: _
    })), D = I(() => ["v-data-table__th", {
      "v-data-table__th--sticky": e.sticky || e.fixedHeader
    }, T.value, v.value]), R = (A) => {
      let {
        column: V,
        x: H,
        y: B
      } = A;
      const N = V.key === "data-table-select" || V.key === "data-table-expand", q = fe(e.headerProps ?? {}, V.headerProps ?? {});
      return b(Mc, fe({
        tag: "th",
        align: V.align,
        class: [{
          "v-data-table__th--sortable": V.sortable && !e.disableSort,
          "v-data-table__th--sorted": a(V),
          "v-data-table__th--fixed": V.fixed
        }, ...D.value],
        style: {
          width: Ce(V.width),
          minWidth: Ce(V.minWidth),
          maxWidth: Ce(V.maxWidth),
          ...p(V, B)
        },
        colspan: V.colspan,
        rowspan: V.rowspan,
        onClick: V.sortable ? () => r(V) : void 0,
        fixed: V.fixed,
        nowrap: V.nowrap,
        lastFixed: V.lastFixed,
        noPadding: N
      }, q), {
        default: () => {
          var de;
          const X = `header.${V.key}`, se = {
            column: V,
            selectAll: d,
            isSorted: a,
            toggleSort: r,
            sortBy: s.value,
            someSelected: l.value,
            allSelected: c.value,
            getSortIcon: _
          };
          return n[X] ? n[X](se) : V.key === "data-table-select" ? ((de = n["header.data-table-select"]) == null ? void 0 : de.call(n, se)) ?? (f.value && b(Ra, {
            modelValue: c.value,
            indeterminate: l.value && !c.value,
            "onUpdate:modelValue": d
          }, null)) : b("div", {
            class: "v-data-table-header__content"
          }, [b("span", null, [V.title]), V.sortable && !e.disableSort && b(dt, {
            key: "icon",
            class: "v-data-table-header__sort-icon",
            icon: _(V)
          }, null), e.multiSort && a(V) && b("div", {
            key: "badge",
            class: ["v-data-table-header__sort-badge", ...x.value],
            style: S.value
          }, [s.value.findIndex((_e) => _e.key === V.key) + 1])]);
        }
      });
    }, $ = () => {
      const A = fe(e.headerProps ?? {} ?? {}), V = I(() => m.value.filter((B) => (B == null ? void 0 : B.sortable) && !e.disableSort)), H = I(() => {
        if (m.value.find((N) => N.key === "data-table-select") != null)
          return c.value ? "$checkboxOn" : l.value ? "$checkboxIndeterminate" : "$checkboxOff";
      });
      return b(Mc, fe({
        tag: "th",
        class: [...D.value],
        colspan: g.value.length + 1
      }, A), {
        default: () => [b("div", {
          class: "v-data-table-header__content"
        }, [b(hd, {
          chips: !0,
          class: "v-data-table__td-sort-select",
          clearable: !0,
          density: "default",
          items: V.value,
          label: i("$vuetify.dataTable.sortBy"),
          multiple: e.multiSort,
          variant: "underlined",
          "onClick:clear": () => s.value = [],
          appendIcon: H.value,
          "onClick:append": () => d(!c.value)
        }, {
          ...n,
          chip: (B) => {
            var N;
            return b(Ic, {
              onClick: (N = B.item.raw) != null && N.sortable ? () => r(B.item.raw) : void 0,
              onMousedown: (q) => {
                q.preventDefault(), q.stopPropagation();
              }
            }, {
              default: () => [B.item.title, b(dt, {
                class: ["v-data-table__td-sort-icon", a(B.item.raw) && "v-data-table__td-sort-icon-active"],
                icon: _(B.item.raw),
                size: "small"
              }, null)]
            });
          }
        })])]
      });
    };
    ke(() => M.value ? b("tr", null, [b($, null, null)]) : b(Le, null, [n.headers ? n.headers(E.value) : g.value.map((A, V) => b("tr", null, [A.map((H, B) => b(R, {
      column: H,
      x: B,
      y: V
    }, null))])), e.loading && b("tr", {
      class: "v-data-table-progress"
    }, [b("th", {
      colspan: m.value.length
    }, [b(Im, {
      name: "v-data-table-progress",
      absolute: !0,
      active: !0,
      color: typeof e.loading == "boolean" ? void 0 : e.loading,
      indeterminate: !0
    }, {
      default: n.loader
    })])])]));
  }
}), LL = ee({
  groupBy: {
    type: Array,
    default: () => []
  }
}, "DataTable-group"), Ew = Symbol.for("vuetify:data-table-group");
function FL(e) {
  return {
    groupBy: at(e, "groupBy")
  };
}
function RL(e) {
  const {
    disableSort: t,
    groupBy: n,
    sortBy: i
  } = e, r = ue(/* @__PURE__ */ new Set()), s = I(() => n.value.map((f) => ({
    ...f,
    order: f.order ?? !1
  })).concat(t != null && t.value ? [] : i.value));
  function a(f) {
    return r.value.has(f.id);
  }
  function l(f) {
    const m = new Set(r.value);
    a(f) ? m.delete(f.id) : m.add(f.id), r.value = m;
  }
  function c(f) {
    function m(g) {
      const v = [];
      for (const p of g.items)
        "type" in p && p.type === "group" ? v.push(...m(p)) : v.push(p);
      return [...new Set(v)];
    }
    return m({
      type: "group",
      items: f,
      id: "dummy",
      key: "dummy",
      value: "dummy",
      depth: 0
    });
  }
  const d = {
    sortByWithGroups: s,
    toggleGroup: l,
    opened: r,
    groupBy: n,
    extractRows: c,
    isGroupOpen: a
  };
  return jt(Ew, d), d;
}
function Aw() {
  const e = gt(Ew);
  if (!e)
    throw new Error("Missing group!");
  return e;
}
function BL(e, t) {
  if (!e.length)
    return [];
  const n = /* @__PURE__ */ new Map();
  for (const i of e) {
    const r = rl(i.raw, t);
    n.has(r) || n.set(r, []), n.get(r).push(i);
  }
  return n;
}
function Mw(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "root";
  if (!t.length)
    return [];
  const r = BL(e, t[0]), s = [], a = t.slice(1);
  return r.forEach((l, c) => {
    const d = t[0], f = `${i}_${d}_${c}`;
    s.push({
      depth: n,
      id: f,
      key: d,
      value: c,
      items: a.length ? Mw(l, a, n + 1, f) : l,
      type: "group"
    });
  }), s;
}
function Dw(e, t) {
  const n = [];
  for (const i of e)
    "type" in i && i.type === "group" ? (i.value != null && n.push(i), (t.has(i.id) || i.value == null) && n.push(...Dw(i.items, t))) : n.push(i);
  return n;
}
function NL(e, t, n) {
  return {
    flatItems: I(() => {
      if (!t.value.length)
        return e.value;
      const r = Mw(e.value, t.value.map((s) => s.key));
      return Dw(r, n.value);
    })
  };
}
const $L = ee({
  item: {
    type: Object,
    required: !0
  }
}, "VDataTableGroupHeaderRow"), zL = pe()({
  name: "VDataTableGroupHeaderRow",
  props: $L(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      isGroupOpen: i,
      toggleGroup: r,
      extractRows: s
    } = Aw(), {
      isSelected: a,
      isSomeSelected: l,
      select: c
    } = gd(), {
      columns: d
    } = md(), f = I(() => s([e.item]));
    return () => b("tr", {
      class: "v-data-table-group-header-row",
      style: {
        "--v-data-table-group-header-row-depth": e.item.depth
      }
    }, [d.value.map((m) => {
      var g, v;
      if (m.key === "data-table-group") {
        const p = i(e.item) ? "$expand" : "$next", _ = () => r(e.item);
        return ((g = n["data-table-group"]) == null ? void 0 : g.call(n, {
          item: e.item,
          count: f.value.length,
          props: {
            icon: p,
            onClick: _
          }
        })) ?? b(Mc, {
          class: "v-data-table-group-header-row__column"
        }, {
          default: () => [b(rt, {
            size: "small",
            variant: "text",
            icon: p,
            onClick: _
          }, null), b("span", null, [e.item.value]), b("span", null, [Ee("("), f.value.length, Ee(")")])]
        });
      }
      if (m.key === "data-table-select") {
        const p = a(f.value), _ = l(f.value) && !p, x = (S) => c(f.value, S);
        return ((v = n["data-table-select"]) == null ? void 0 : v.call(n, {
          props: {
            modelValue: p,
            indeterminate: _,
            "onUpdate:modelValue": x
          }
        })) ?? b("td", null, [b(Ra, {
          modelValue: p,
          indeterminate: _,
          "onUpdate:modelValue": x
        }, null)]);
      }
      return b("td", null, null);
    })]);
  }
}), HL = ee({
  expandOnClick: Boolean,
  showExpand: Boolean,
  expanded: {
    type: Array,
    default: () => []
  }
}, "DataTable-expand"), Vw = Symbol.for("vuetify:datatable:expanded");
function WL(e) {
  const t = ce(e, "expandOnClick"), n = at(e, "expanded", e.expanded, (l) => new Set(l), (l) => [...l.values()]);
  function i(l, c) {
    const d = new Set(n.value);
    c ? d.add(l.value) : d.delete(l.value), n.value = d;
  }
  function r(l) {
    return n.value.has(l.value);
  }
  function s(l) {
    i(l, !r(l));
  }
  const a = {
    expand: i,
    expanded: n,
    expandOnClick: t,
    isExpanded: r,
    toggleExpand: s
  };
  return jt(Vw, a), a;
}
function Lw() {
  const e = gt(Vw);
  if (!e)
    throw new Error("foo");
  return e;
}
const UL = ee({
  index: Number,
  item: Object,
  cellProps: [Object, Function],
  onClick: cn(),
  onContextmenu: cn(),
  onDblclick: cn(),
  ...Jc()
}, "VDataTableRow"), qL = pe()({
  name: "VDataTableRow",
  props: UL(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      displayClasses: i,
      mobile: r
    } = js(e, "v-data-table__tr"), {
      isSelected: s,
      toggleSelect: a,
      someSelected: l,
      allSelected: c,
      selectAll: d
    } = gd(), {
      isExpanded: f,
      toggleExpand: m
    } = Lw(), {
      toggleSort: g,
      sortBy: v,
      isSorted: p
    } = Pw(), {
      columns: _
    } = md();
    ke(() => b("tr", {
      class: ["v-data-table__tr", {
        "v-data-table__tr--clickable": !!(e.onClick || e.onContextmenu || e.onDblclick)
      }, i.value],
      onClick: e.onClick,
      onContextmenu: e.onContextmenu,
      onDblclick: e.onDblclick
    }, [e.item && _.value.map((x, S) => {
      const T = e.item, M = `item.${x.key}`, E = `header.${x.key}`, D = {
        index: e.index,
        item: T.raw,
        internalItem: T,
        value: rl(T.columns, x.key),
        column: x,
        isSelected: s,
        toggleSelect: a,
        isExpanded: f,
        toggleExpand: m
      }, R = {
        column: x,
        selectAll: d,
        isSorted: p,
        toggleSort: g,
        sortBy: v.value,
        someSelected: l.value,
        allSelected: c.value,
        getSortIcon: () => ""
      }, $ = typeof e.cellProps == "function" ? e.cellProps({
        index: D.index,
        item: D.item,
        internalItem: D.internalItem,
        value: D.value,
        column: x
      }) : e.cellProps, A = typeof x.cellProps == "function" ? x.cellProps({
        index: D.index,
        item: D.item,
        internalItem: D.internalItem,
        value: D.value
      }) : x.cellProps;
      return b(Mc, fe({
        align: x.align,
        class: {
          "v-data-table__td--expanded-row": x.key === "data-table-expand",
          "v-data-table__td--select-row": x.key === "data-table-select"
        },
        fixed: x.fixed,
        fixedOffset: x.fixedOffset,
        lastFixed: x.lastFixed,
        maxWidth: r.value ? void 0 : x.maxWidth,
        noPadding: x.key === "data-table-select" || x.key === "data-table-expand",
        nowrap: x.nowrap,
        width: r.value ? void 0 : x.width
      }, $, A), {
        default: () => {
          var H, B, N, q, X;
          if (n[M] && !r.value)
            return (H = n[M]) == null ? void 0 : H.call(n, D);
          if (x.key === "data-table-select")
            return ((B = n["item.data-table-select"]) == null ? void 0 : B.call(n, D)) ?? b(Ra, {
              disabled: !T.selectable,
              modelValue: s([T]),
              onClick: Dt(() => a(T), ["stop"])
            }, null);
          if (x.key === "data-table-expand")
            return ((N = n["item.data-table-expand"]) == null ? void 0 : N.call(n, D)) ?? b(rt, {
              icon: f(T) ? "$collapse" : "$expand",
              size: "small",
              variant: "text",
              onClick: Dt(() => m(T), ["stop"])
            }, null);
          const V = At(D.value);
          return r.value ? b(Le, null, [b("div", {
            class: "v-data-table__td-title"
          }, [((q = n[E]) == null ? void 0 : q.call(n, R)) ?? x.title]), b("div", {
            class: "v-data-table__td-value"
          }, [((X = n[M]) == null ? void 0 : X.call(n, D)) ?? V])]) : V;
        }
      });
    })]));
  }
}), Fw = ee({
  loading: [Boolean, String],
  loadingText: {
    type: String,
    default: "$vuetify.dataIterator.loadingText"
  },
  hideNoData: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  noDataText: {
    type: String,
    default: "$vuetify.noDataText"
  },
  rowProps: [Object, Function],
  cellProps: [Object, Function],
  ...Jc()
}, "VDataTableRows"), Kp = pe()({
  name: "VDataTableRows",
  inheritAttrs: !1,
  props: Fw(),
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const {
      columns: r
    } = md(), {
      expandOnClick: s,
      toggleExpand: a,
      isExpanded: l
    } = Lw(), {
      isSelected: c,
      toggleSelect: d
    } = gd(), {
      toggleGroup: f,
      isGroupOpen: m
    } = Aw(), {
      t: g
    } = os(), {
      mobile: v
    } = js(e);
    return ke(() => {
      var p, _;
      return e.loading && (!e.items.length || i.loading) ? b("tr", {
        class: "v-data-table-rows-loading",
        key: "loading"
      }, [b("td", {
        colspan: r.value.length
      }, [((p = i.loading) == null ? void 0 : p.call(i)) ?? g(e.loadingText)])]) : !e.loading && !e.items.length && !e.hideNoData ? b("tr", {
        class: "v-data-table-rows-no-data",
        key: "no-data"
      }, [b("td", {
        colspan: r.value.length
      }, [((_ = i["no-data"]) == null ? void 0 : _.call(i)) ?? g(e.noDataText)])]) : b(Le, null, [e.items.map((x, S) => {
        var E;
        if (x.type === "group") {
          const D = {
            index: S,
            item: x,
            columns: r.value,
            isExpanded: l,
            toggleExpand: a,
            isSelected: c,
            toggleSelect: d,
            toggleGroup: f,
            isGroupOpen: m
          };
          return i["group-header"] ? i["group-header"](D) : b(zL, fe({
            key: `group-header_${x.id}`,
            item: x
          }, Zy(n, ":group-header", () => D)), i);
        }
        const T = {
          index: S,
          item: x.raw,
          internalItem: x,
          columns: r.value,
          isExpanded: l,
          toggleExpand: a,
          isSelected: c,
          toggleSelect: d
        }, M = {
          ...T,
          props: fe({
            key: `item_${x.key ?? x.index}`,
            onClick: s.value ? () => {
              a(x);
            } : void 0,
            index: S,
            item: x,
            cellProps: e.cellProps,
            mobile: v.value
          }, Zy(n, ":row", () => T), typeof e.rowProps == "function" ? e.rowProps({
            item: T.item,
            index: T.index,
            internalItem: T.internalItem
          }) : e.rowProps)
        };
        return b(Le, {
          key: M.props.key
        }, [i.item ? i.item(M) : b(qL, M.props, i), l(x) && ((E = i["expanded-row"]) == null ? void 0 : E.call(i, T))]);
      })]);
    }), {};
  }
}), Rw = ee({
  fixedHeader: Boolean,
  fixedFooter: Boolean,
  height: [Number, String],
  hover: Boolean,
  ...Ae(),
  ...Qn(),
  ...pt(),
  ...$t()
}, "VTable"), Xp = pe()({
  name: "VTable",
  props: Rw(),
  setup(e, t) {
    let {
      slots: n,
      emit: i
    } = t;
    const {
      themeClasses: r
    } = Zt(e), {
      densityClasses: s
    } = Mi(e);
    return ke(() => b(e.tag, {
      class: ["v-table", {
        "v-table--fixed-height": !!e.height,
        "v-table--fixed-header": e.fixedHeader,
        "v-table--fixed-footer": e.fixedFooter,
        "v-table--has-top": !!n.top,
        "v-table--has-bottom": !!n.bottom,
        "v-table--hover": e.hover
      }, r.value, s.value, e.class],
      style: e.style
    }, {
      default: () => {
        var a, l, c;
        return [(a = n.top) == null ? void 0 : a.call(n), n.default ? b("div", {
          class: "v-table__wrapper",
          style: {
            height: Ce(e.height)
          }
        }, [b("table", null, [n.default()])]) : (l = n.wrapper) == null ? void 0 : l.call(n), (c = n.bottom) == null ? void 0 : c.call(n)];
      }
    })), {};
  }
}), jL = ee({
  items: {
    type: Array,
    default: () => []
  },
  itemValue: {
    type: [String, Array, Function],
    default: "id"
  },
  itemSelectable: {
    type: [String, Array, Function],
    default: null
  },
  rowProps: [Object, Function],
  cellProps: [Object, Function],
  returnObject: Boolean
}, "DataTable-items");
function GL(e, t, n, i) {
  const r = e.returnObject ? t : Fn(t, e.itemValue), s = Fn(t, e.itemSelectable, !0), a = i.reduce((l, c) => (c.key != null && (l[c.key] = Fn(t, c.value)), l), {});
  return {
    type: "item",
    key: e.returnObject ? Fn(t, e.itemValue) : r,
    index: n,
    value: r,
    selectable: s,
    columns: a,
    raw: t
  };
}
function YL(e, t, n) {
  return t.map((i, r) => GL(e, i, r, n));
}
function ZL(e, t) {
  return {
    items: I(() => YL(e, e.items, t.value))
  };
}
function KL(e) {
  let {
    page: t,
    itemsPerPage: n,
    sortBy: i,
    groupBy: r,
    search: s
  } = e;
  const a = Nt("VDataTable"), l = I(() => ({
    page: t.value,
    itemsPerPage: n.value,
    sortBy: i.value,
    groupBy: r.value,
    search: s.value
  }));
  let c = null;
  Se(l, () => {
    Sr(c, l.value) || (c && c.search !== l.value.search && (t.value = 1), a.emit("update:options", l.value), c = l.value);
  }, {
    deep: !0,
    immediate: !0
  });
}
const XL = (e, t, n) => e == null || t == null ? -1 : e.toString().toLocaleLowerCase().indexOf(t.toString().toLocaleLowerCase()), JL = ee({
  customFilter: Function,
  customKeyFilter: Object,
  filterKeys: [Array, String],
  filterMode: {
    type: String,
    default: "intersection"
  },
  noFilter: Boolean
}, "filter");
function QL(e, t, n) {
  var l;
  const i = [], r = (n == null ? void 0 : n.default) ?? XL, s = n != null && n.filterKeys ? mn(n.filterKeys) : !1, a = Object.keys((n == null ? void 0 : n.customKeyFilter) ?? {}).length;
  if (!(e != null && e.length))
    return i;
  e:
    for (let c = 0; c < e.length; c++) {
      const [d, f = d] = mn(e[c]), m = {}, g = {};
      let v = -1;
      if ((t || a > 0) && !(n != null && n.noFilter)) {
        if (typeof d == "object") {
          const x = s || Object.keys(f);
          for (const S of x) {
            const T = Fn(f, S), M = (l = n == null ? void 0 : n.customKeyFilter) == null ? void 0 : l[S];
            if (v = M ? M(T, t, d) : r(T, t, d), v !== -1 && v !== !1)
              M ? m[S] = v : g[S] = v;
            else if ((n == null ? void 0 : n.filterMode) === "every")
              continue e;
          }
        } else
          v = r(d, t, d), v !== -1 && v !== !1 && (g.title = v);
        const p = Object.keys(g).length, _ = Object.keys(m).length;
        if (!p && !_ || (n == null ? void 0 : n.filterMode) === "union" && _ !== a && !p || (n == null ? void 0 : n.filterMode) === "intersection" && (_ !== a || !p))
          continue;
      }
      i.push({
        index: c,
        matches: {
          ...g,
          ...m
        }
      });
    }
  return i;
}
function eF(e, t, n, i) {
  const r = Ie([]), s = Ie(/* @__PURE__ */ new Map()), a = I(() => i != null && i.transform ? je(t).map((c) => [c, i.transform(c)]) : je(t));
  Xn(() => {
    const c = typeof n == "function" ? n() : je(n), d = typeof c != "string" && typeof c != "number" ? "" : String(c), f = QL(a.value, d, {
      customKeyFilter: {
        ...e.customKeyFilter,
        ...je(i == null ? void 0 : i.customKeyFilter)
      },
      default: e.customFilter,
      filterKeys: e.filterKeys,
      filterMode: e.filterMode,
      noFilter: e.noFilter
    }), m = je(t), g = [], v = /* @__PURE__ */ new Map();
    f.forEach((p) => {
      let {
        index: _,
        matches: x
      } = p;
      const S = m[_];
      g.push(S), v.set(S.value, x);
    }), r.value = g, s.value = v;
  });
  function l(c) {
    return s.value.get(c.value);
  }
  return {
    filteredItems: r,
    filteredMatches: s,
    getMatches: l
  };
}
const tF = ee({
  ...Fw(),
  hideDefaultBody: Boolean,
  hideDefaultFooter: Boolean,
  hideDefaultHeader: Boolean,
  width: [String, Number],
  search: String,
  ...HL(),
  ...LL(),
  ...xL(),
  ...jL(),
  ...PL(),
  ...EL(),
  ...Ow(),
  ...Rw()
}, "DataTable"), nF = ee({
  ...gL(),
  ...tF(),
  ...JL(),
  ...bw()
}, "VDataTable"), Gm = pe()({
  name: "VDataTable",
  props: nF(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:page": (e) => !0,
    "update:itemsPerPage": (e) => !0,
    "update:sortBy": (e) => !0,
    "update:options": (e) => !0,
    "update:groupBy": (e) => !0,
    "update:expanded": (e) => !0,
    "update:currentItems": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const {
      groupBy: r
    } = FL(e), {
      sortBy: s,
      multiSort: a,
      mustSort: l
    } = AL(e), {
      page: c,
      itemsPerPage: d
    } = vL(e), {
      disableSort: f
    } = am(e), {
      columns: m,
      headers: g,
      sortFunctions: v,
      sortRawFunctions: p,
      filterFunctions: _
    } = TL(e, {
      groupBy: r,
      showSelect: ce(e, "showSelect"),
      showExpand: ce(e, "showExpand")
    }), {
      items: x
    } = ZL(e, m), S = ce(e, "search"), {
      filteredItems: T
    } = eF(e, x, S, {
      transform: (me) => me.columns,
      customKeyFilter: _
    }), {
      toggleSort: M
    } = ML({
      sortBy: s,
      multiSort: a,
      mustSort: l,
      page: c
    }), {
      sortByWithGroups: E,
      opened: D,
      extractRows: R,
      isGroupOpen: $,
      toggleGroup: A
    } = RL({
      groupBy: r,
      sortBy: s,
      disableSort: f
    }), {
      sortedItems: V
    } = DL(e, T, E, {
      transform: (me) => ({
        ...me.raw,
        ...me.columns
      }),
      sortFunctions: v,
      sortRawFunctions: p
    }), {
      flatItems: H
    } = NL(V, r, D), B = I(() => H.value.length), {
      startIndex: N,
      stopIndex: q,
      pageCount: X,
      setItemsPerPage: se
    } = yL({
      page: c,
      itemsPerPage: d,
      itemsLength: B
    }), {
      paginatedItems: de
    } = bL({
      items: H,
      startIndex: N,
      stopIndex: q,
      itemsPerPage: d
    }), _e = I(() => R(de.value)), {
      isSelected: be,
      select: oe,
      selectAll: J,
      toggleSelect: G,
      someSelected: ie,
      allSelected: ge
    } = OL(e, {
      allItems: x,
      currentPage: _e
    }), {
      isExpanded: he,
      toggleExpand: Oe
    } = WL(e);
    KL({
      page: c,
      itemsPerPage: d,
      sortBy: s,
      groupBy: r,
      search: S
    }), yi({
      VDataTableRows: {
        hideNoData: ce(e, "hideNoData"),
        noDataText: ce(e, "noDataText"),
        loading: ce(e, "loading"),
        loadingText: ce(e, "loadingText")
      }
    });
    const Q = I(() => ({
      page: c.value,
      itemsPerPage: d.value,
      sortBy: s.value,
      pageCount: X.value,
      toggleSort: M,
      setItemsPerPage: se,
      someSelected: ie.value,
      allSelected: ge.value,
      isSelected: be,
      select: oe,
      selectAll: J,
      toggleSelect: G,
      isExpanded: he,
      toggleExpand: Oe,
      isGroupOpen: $,
      toggleGroup: A,
      items: _e.value.map((me) => me.raw),
      internalItems: _e.value,
      groupedItems: de.value,
      columns: m.value,
      headers: g.value
    }));
    return ke(() => {
      const me = Zp.filterProps(e), Ze = $h.filterProps(e), We = Kp.filterProps(e), Ue = Xp.filterProps(e);
      return b(Xp, fe({
        class: ["v-data-table", {
          "v-data-table--show-select": e.showSelect,
          "v-data-table--loading": e.loading
        }, e.class],
        style: e.style
      }, Ue, {
        fixedHeader: e.fixedHeader || e.sticky
      }), {
        top: () => {
          var Ot;
          return (Ot = i.top) == null ? void 0 : Ot.call(i, Q.value);
        },
        default: () => {
          var Ot, ft, yn, xt, sn, pn;
          return i.default ? i.default(Q.value) : b(Le, null, [(Ot = i.colgroup) == null ? void 0 : Ot.call(i, Q.value), !e.hideDefaultHeader && b("thead", {
            key: "thead"
          }, [b($h, Ze, i)]), (ft = i.thead) == null ? void 0 : ft.call(i, Q.value), !e.hideDefaultBody && b("tbody", null, [(yn = i["body.prepend"]) == null ? void 0 : yn.call(i, Q.value), i.body ? i.body(Q.value) : b(Kp, fe(n, We, {
            items: de.value
          }), i), (xt = i["body.append"]) == null ? void 0 : xt.call(i, Q.value)]), (sn = i.tbody) == null ? void 0 : sn.call(i, Q.value), (pn = i.tfoot) == null ? void 0 : pn.call(i, Q.value)]);
        },
        bottom: () => i.bottom ? i.bottom(Q.value) : !e.hideDefaultFooter && b(Le, null, [b(Kc, null, null), b(Zp, me, {
          prepend: i["footer.prepend"]
        })])
      });
    }), {};
  }
}), iF = ["onClick"], Bw = /* @__PURE__ */ Je({
  __name: "ProjectDataTable",
  props: {
    items: { type: Array, required: !0 },
    workOrder: {
      type: [Object, null],
      required: !1,
      default: () => ({ title: "Work Order", key: "work_order" })
    },
    getChangePermission: {
      type: Function,
      required: !1,
      default: (e) => !0
    },
    getDeletePermission: {
      type: Function,
      required: !1,
      default: (e) => !0
    },
    headers: {
      type: Array,
      required: !1,
      default: [
        { title: "Name", key: "name" },
        { title: "Location", key: "location" },
        { title: "Client", key: "client" },
        { title: "Description", key: "description" },
        { title: "Date Created", key: "date_created" },
        { title: "Date Modified", key: "date_modified" },
        { title: "Edit", key: "edit", width: "4%" },
        { title: "Delete", key: "delete", width: "4%" }
      ]
    },
    search: { type: String, required: !1, default: "" }
  },
  emits: ["navigateToProject", "editItem", "deleteItem"],
  setup(e, { emit: t }) {
    const n = e, i = I(() => n.workOrder ? [n.workOrder, ...n.headers] : [...n.headers]), r = t;
    return (s, a) => (le(), Te(Gm, fe(s.$attrs, {
      hover: !0,
      density: "comfortable",
      style: { "border-radius": "unset !important" },
      items: n.items,
      headers: i.value,
      search: n.search,
      "items-per-page": "10"
    }), {
      item: Z(({ item: l }) => [
        St("tr", {
          onClick: (c) => r("navigateToProject", l.id),
          class: "clickable-row"
        }, [
          (le(!0), nt(Le, null, um(i.value, (c) => (le(), nt("td", {
            key: c.key
          }, [
            s.$slots[`item.${String(c.key)}`] ? wt(s.$slots, `item.${String(c.key)}`, {
              key: 0,
              value: l[c.key],
              item: l
            }) : c.key === "date_created" ? (le(), nt(Le, { key: 1 }, [
              Ee(At(je(Re).fromISO(l.date_created).toLocaleString(je(Re).DATETIME_MED)), 1)
            ], 64)) : c.key === "date_modified" ? (le(), nt(Le, { key: 2 }, [
              Ee(At(l.date_modified ? je(Re).fromISO(l.date_modified).toLocaleString(je(Re).DATETIME_MED) : "-"), 1)
            ], 64)) : c.key === "edit" ? (le(), nt(Le, { key: 3 }, [
              e.getChangePermission(l.id) ? (le(), Te(rt, {
                key: 0,
                icon: "mdi-pencil",
                onClick: Dt((d) => r("editItem", l), ["stop"]),
                flat: "",
                size: "24",
                variant: "text"
              }, null, 8, ["onClick"])) : it("", !0)
            ], 64)) : c.key === "delete" ? (le(), nt(Le, { key: 4 }, [
              e.getDeletePermission(l.id) ? (le(), Te(rt, {
                key: 0,
                icon: "mdi-delete-outline",
                onClick: Dt((d) => r("deleteItem", l), ["stop"]),
                flat: "",
                size: "24",
                variant: "text"
              }, null, 8, ["onClick"])) : it("", !0)
            ], 64)) : (le(), nt(Le, { key: 5 }, [
              Ee(At(l[c.key]), 1)
            ], 64))
          ]))), 128))
        ], 8, iF)
      ]),
      "no-data": Z(() => [
        e.items.length ? (le(), nt(Le, { key: 1 }, [
          Ee("There are no matching projects available. ")
        ], 64)) : (le(), nt(Le, { key: 0 }, [
          Ee("There are no projects available.")
        ], 64))
      ]),
      _: 3
    }, 16, ["items", "headers", "search"]));
  }
}), Nw = /* @__PURE__ */ Je({
  __name: "ProjectHeaderImage",
  props: {
    src: { type: String, required: !0, default: "" },
    lazySrc: { type: String, required: !0, default: "" },
    loading: { type: Boolean, required: !1, default: !1 },
    height: { type: String, required: !1, default: "8vh" }
  },
  setup(e) {
    const t = e;
    return (n, i) => (le(), nt("div", {
      style: Qr({ height: e.height })
    }, [
      b(vA, {
        fluid: "",
        class: "pa-0"
      }, {
        default: Z(() => [
          b(Tl, fe({
            height: e.height,
            cover: "",
            style: { "background-color": "#dddddd", width: "auto" },
            src: t.src,
            "lazy-src": t.lazySrc
          }, n.$attrs), null, 16, ["height", "src", "lazy-src"])
        ]),
        _: 1
      }),
      e.loading ? (le(), Te(id, {
        key: 0,
        indeterminate: "",
        color: "primary"
      })) : it("", !0)
    ], 4));
  }
}), rF = {
  key: 0,
  ref: "input"
}, qu = 8, $w = /* @__PURE__ */ Je({
  __name: "ProjectCardGrid",
  props: {
    search: { type: String, required: !1, default: "" },
    loading: { type: Boolean, required: !0, default: !1 },
    items: { type: Array, required: !0 },
    workOrderKey: { type: String, required: !1, default: "work_order" },
    getChangePermission: {
      type: Function,
      required: !1,
      default: (e) => !0
    },
    getDeletePermission: {
      type: Function,
      required: !1,
      default: (e) => !0
    },
    disableDelete: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["navigateToProject", "editItem", "deleteItem"],
  setup(e, { emit: t }) {
    const n = e, i = ue(1), r = (d, f, m) => f ? d.filter(
      (g) => m.some((v) => {
        var p;
        return (p = g[v]) == null ? void 0 : p.toString().toLowerCase().includes(f.toLowerCase());
      })
    ) : d, s = I(
      () => r(n.items, n.search, ["name", "work_order", "client", "location"])
    ), a = I(
      () => s.value.length ? Math.ceil(s.value.length / qu) : 1
    );
    Se(a, () => {
      i.value > a.value && (i.value = a.value);
    });
    const l = I(() => s.value.slice((i.value - 1) * qu, i.value * qu)), c = t;
    return (d, f) => n.loading ? it("", !0) : (le(), nt("div", rF, [
      e.items.length ? s.value.length ? (le(), Te(Da, {
        key: 1,
        "no-gutters": ""
      }, {
        default: Z(() => [
          (le(!0), nt(Le, null, um(l.value, (m) => (le(), Te(hi, {
            key: m.id,
            class: "pa-3",
            cols: "12",
            md: "3",
            sm: "6",
            xs: "12"
          }, {
            default: Z(() => [
              b(l_, {
                "work-order-key": e.workOrderKey,
                item: m,
                canEdit: e.getChangePermission(m.id),
                canDelete: e.getDeletePermission(m.id),
                disableDelete: e.disableDelete,
                onNavigateToProject: f[0] || (f[0] = (g) => c("navigateToProject", g)),
                onEdit: f[1] || (f[1] = (g) => c("editItem", g)),
                onDelete: f[2] || (f[2] = (g) => c("deleteItem", g))
              }, {
                "menu-list-items": Z(() => [
                  wt(d.$slots, "menu-list-items")
                ]),
                _: 2
              }, 1032, ["work-order-key", "item", "canEdit", "canDelete", "disableDelete"])
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 3
      })) : (le(), Te(Va, { key: 2 }, {
        default: Z(() => [
          Ee(" There are no matching projects available.")
        ]),
        _: 1
      })) : (le(), Te(Va, { key: 0 }, {
        default: Z(() => [
          Ee(" There are no projects available.")
        ]),
        _: 1
      })),
      s.value.length > qu ? (le(), Te(Bh, {
        key: 3,
        modelValue: i.value,
        "onUpdate:modelValue": f[3] || (f[3] = (m) => i.value = m),
        length: a.value
      }, null, 8, ["modelValue", "length"])) : it("", !0)
    ], 512));
  }
});
function sF(e) {
  return dE() ? (gn(e), !0) : !1;
}
function Ym(e) {
  return typeof e == "function" ? e() : je(e);
}
const aF = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const oF = Object.prototype.toString, lF = (e) => oF.call(e) === "[object Object]", uF = () => {
};
function cF(e, t) {
  function n(...i) {
    return new Promise((r, s) => {
      Promise.resolve(e(() => t.apply(this, i), { fn: t, thisArg: this, args: i })).then(r).catch(s);
    });
  }
  return n;
}
const zw = (e) => e();
function dF(e = zw) {
  const t = ue(!0);
  function n() {
    t.value = !1;
  }
  function i() {
    t.value = !0;
  }
  const r = (...s) => {
    t.value && e(...s);
  };
  return { isActive: jc(t), pause: n, resume: i, eventFilter: r };
}
function fF(e) {
  return E0();
}
function hF(e, t, n = {}) {
  const {
    eventFilter: i = zw,
    ...r
  } = n;
  return Se(
    e,
    cF(
      i,
      t
    ),
    r
  );
}
function mF(e, t, n = {}) {
  const {
    eventFilter: i,
    ...r
  } = n, { eventFilter: s, pause: a, resume: l, isActive: c } = dF(i);
  return { stop: hF(
    e,
    t,
    {
      ...r,
      eventFilter: s
    }
  ), pause: a, resume: l, isActive: c };
}
function gF(e, t = !0, n) {
  fF() ? Jn(e, n) : t ? e() : Ct(e);
}
function vF(e) {
  var t;
  const n = Ym(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const zh = aF ? window : void 0;
function Jp(...e) {
  let t, n, i, r;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, i, r] = e, t = zh) : [t, n, i, r] = e, !t)
    return uF;
  Array.isArray(n) || (n = [n]), Array.isArray(i) || (i = [i]);
  const s = [], a = () => {
    s.forEach((f) => f()), s.length = 0;
  }, l = (f, m, g, v) => (f.addEventListener(m, g, v), () => f.removeEventListener(m, g, v)), c = Se(
    () => [vF(t), Ym(r)],
    ([f, m]) => {
      if (a(), !f)
        return;
      const g = lF(m) ? { ...m } : m;
      s.push(
        ...n.flatMap((v) => i.map((p) => l(f, v, p, g)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    c(), a();
  };
  return sF(d), d;
}
const ju = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Gu = "__vueuse_ssr_handlers__", yF = /* @__PURE__ */ pF();
function pF() {
  return Gu in ju || (ju[Gu] = ju[Gu] || {}), ju[Gu];
}
function bF(e, t) {
  return yF[e] || t;
}
function xF(e) {
  return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
const _F = {
  boolean: {
    read: (e) => e === "true",
    write: (e) => String(e)
  },
  object: {
    read: (e) => JSON.parse(e),
    write: (e) => JSON.stringify(e)
  },
  number: {
    read: (e) => Number.parseFloat(e),
    write: (e) => String(e)
  },
  any: {
    read: (e) => e,
    write: (e) => String(e)
  },
  string: {
    read: (e) => e,
    write: (e) => String(e)
  },
  map: {
    read: (e) => new Map(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e.entries()))
  },
  set: {
    read: (e) => new Set(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e))
  },
  date: {
    read: (e) => new Date(e),
    write: (e) => e.toISOString()
  }
}, Qp = "vueuse-storage";
function Hw(e, t, n, i = {}) {
  var r;
  const {
    flush: s = "pre",
    deep: a = !0,
    listenToStorageChanges: l = !0,
    writeDefaults: c = !0,
    mergeDefaults: d = !1,
    shallow: f,
    window: m = zh,
    eventFilter: g,
    onError: v = (H) => {
      console.error(H);
    },
    initOnMounted: p
  } = i, _ = (f ? Ie : ue)(t);
  if (!n)
    try {
      n = bF("getDefaultStorage", () => {
        var H;
        return (H = zh) == null ? void 0 : H.localStorage;
      })();
    } catch (H) {
      v(H);
    }
  if (!n)
    return _;
  const x = Ym(t), S = xF(x), T = (r = i.serializer) != null ? r : _F[S], { pause: M, resume: E } = mF(
    _,
    () => R(_.value),
    { flush: s, deep: a, eventFilter: g }
  );
  m && l && gF(() => {
    Jp(m, "storage", A), Jp(m, Qp, V), p && A();
  }), p || A();
  function D(H, B) {
    m && m.dispatchEvent(new CustomEvent(Qp, {
      detail: {
        key: e,
        oldValue: H,
        newValue: B,
        storageArea: n
      }
    }));
  }
  function R(H) {
    try {
      const B = n.getItem(e);
      if (H == null)
        D(B, null), n.removeItem(e);
      else {
        const N = T.write(H);
        B !== N && (n.setItem(e, N), D(B, N));
      }
    } catch (B) {
      v(B);
    }
  }
  function $(H) {
    const B = H ? H.newValue : n.getItem(e);
    if (B == null)
      return c && x != null && n.setItem(e, T.write(x)), x;
    if (!H && d) {
      const N = T.read(B);
      return typeof d == "function" ? d(N, x) : S === "object" && !Array.isArray(N) ? { ...x, ...N } : N;
    } else
      return typeof B != "string" ? B : T.read(B);
  }
  function A(H) {
    if (!(H && H.storageArea !== n)) {
      if (H && H.key == null) {
        _.value = x;
        return;
      }
      if (!(H && H.key !== e)) {
        M();
        try {
          (H == null ? void 0 : H.newValue) !== T.write(_.value) && (_.value = $(H));
        } catch (B) {
          v(B);
        } finally {
          H ? Ct(E) : E();
        }
      }
    }
  }
  function V(H) {
    A(H.detail);
  }
  return _;
}
const wF = { class: "d-flex ga-2 justify-center align-center" }, SF = { class: "w-50 d-flex justify-center align-center ga-2" }, kF = { class: "app-font" }, Ww = /* @__PURE__ */ Je({
  __name: "ProjectIndexTitle",
  props: {
    title: {
      type: String,
      required: !0
    },
    loading: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["updateSearch", "add"],
  setup(e, { emit: t }) {
    const n = e, i = ue(""), r = Hw("projectIndexViewMode", "grid"), s = t;
    return Se(i, (a) => {
      s("updateSearch", a);
    }), (a, l) => n.loading ? it("", !0) : (le(), Te(Ir, fe({
      key: 0,
      elevation: "0"
    }, a.$attrs), {
      default: Z(() => [
        b(Gs, { class: "px-3 d-flex justify-space-between" }, {
          default: Z(() => [
            St("div", wF, [
              Ee(" My projects "),
              b(rt, {
                onClick: l[0] || (l[0] = (c) => s("add")),
                "prepend-icon": "mdi-plus",
                class: "text-none",
                color: "primary",
                flat: ""
              }, {
                default: Z(() => [
                  Ee(" Add ")
                ]),
                _: 1
              })
            ]),
            St("div", SF, [
              b(hl, {
                style: { width: "50px" },
                modelValue: i.value,
                "onUpdate:modelValue": l[1] || (l[1] = (c) => i.value = c),
                density: "compact",
                label: "Search",
                "prepend-inner-icon": "mdi-magnify",
                variant: "outlined",
                "hide-details": "",
                "single-line": "",
                clearable: ""
              }, null, 8, ["modelValue"]),
              b(rD, {
                divided: "",
                modelValue: je(r),
                "onUpdate:modelValue": l[2] || (l[2] = (c) => qi(r) ? r.value = c : null),
                variant: "outlined",
                density: "compact",
                mandatory: ""
              }, {
                default: Z(() => [
                  b(rt, { value: "grid" }, {
                    default: Z(() => [
                      b(dt, null, {
                        default: Z(() => [
                          Ee("mdi-view-grid")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  b(rt, { value: "list" }, {
                    default: Z(() => [
                      b(dt, null, {
                        default: Z(() => [
                          Ee(" mdi-view-list")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        b(Va, { class: "px-3" }, {
          default: Z(() => [
            Ee(" To start using "),
            St("span", kF, At(n.title), 1),
            Ee(" , please select an existing project below or create a new project via the "),
            b(rt, {
              class: "mx-1 cursor-default text-none",
              "prepend-icon": "mdi-plus",
              size: "small",
              color: "primary",
              flat: "",
              ripple: !1,
              readonly: ""
            }, {
              default: Z(() => [
                Ee(" Add ")
              ]),
              _: 1
            }),
            Ee(" button. ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16));
  }
}), CF = {
  class: "fill-height",
  style: { display: "flex", "flex-direction": "column" }
}, TF = {
  key: 0,
  class: "d-flex justify-center align-center fill-height"
}, IF = /* @__PURE__ */ Je({
  __name: "ProjectIndex",
  props: {
    title: {
      type: String,
      required: !0
    },
    workOrder: {
      type: [Object, null],
      required: !1,
      default: () => ({ title: "Work Order", key: "work_order" })
    },
    loading: {
      type: Boolean,
      required: !0,
      default: !1
    },
    items: { type: Array, required: !0 },
    getChangePermission: {
      type: Function,
      required: !1,
      default: (e) => !0
    },
    getDeletePermission: {
      type: Function,
      required: !1,
      default: (e) => !0
    },
    disableDelete: {
      type: Boolean,
      required: !1,
      default: !1
    },
    headers: {
      type: Array,
      required: !1,
      default: [
        { title: "Name", key: "name" },
        { title: "Location", key: "location" },
        { title: "Client", key: "client" },
        { title: "Description", key: "description" },
        { title: "Date Created", key: "date_created" },
        { title: "Date Modified", key: "date_modified" },
        { title: "Edit", key: "edit", width: "4%" },
        { title: "Delete", key: "delete", width: "4%" }
      ]
    }
  },
  emits: ["navigateToProject", "addItem", "deleteItem", "editItem"],
  setup(e, { emit: t }) {
    const n = e, i = Hw("projectIndexViewMode", "grid"), r = ue(""), s = (m) => {
      r.value = m;
    };
    function a() {
      d("addItem");
    }
    function l(m) {
      d("deleteItem", m);
    }
    function c(m) {
      d("editItem", m);
    }
    const d = t, f = I(() => {
      const m = [...n.items || []], g = n.headers.some((v) => v.key === "updatedAt") ? "updatedAt" : "date_modified";
      return m.some((v) => v[g]) ? m.sort((v, p) => {
        const _ = new Date(v[g]).getTime();
        return new Date(p[g]).getTime() - _;
      }) : m;
    });
    return (m, g) => (le(), nt("div", CF, [
      b(Nw, {
        "lazy-src": "/header_lazy.jpg",
        src: "/header.jpeg"
      }),
      b(i_, { class: "px-8 py-4" }, {
        default: Z(() => {
          var v;
          return [
            e.loading ? (le(), nt("div", TF, [
              b(Pm, {
                indeterminate: "",
                color: "primary",
                size: "64"
              })
            ])) : (le(), nt(Le, { key: 1 }, [
              b(Ww, {
                class: "position-sticky top-0",
                title: e.title,
                onAdd: a,
                onUpdateSearch: s
              }, null, 8, ["title"]),
              je(i) === "grid" ? (le(), Te($w, {
                key: 0,
                class: "mt-6",
                "get-change-permission": e.getChangePermission,
                "get-delete-permission": e.getDeletePermission,
                items: f.value,
                loading: e.loading,
                search: r.value,
                "work-order-key": ((v = e.workOrder) == null ? void 0 : v.key) ?? "work_order",
                disableDelete: e.disableDelete,
                onNavigateToProject: g[0] || (g[0] = (p) => d("navigateToProject", p)),
                onDeleteItem: l,
                onEditItem: c
              }, null, 8, ["get-change-permission", "get-delete-permission", "items", "loading", "search", "work-order-key", "disableDelete"])) : (le(), Te(Bw, {
                key: 1,
                "filter-keys": ["work_order", "name", "location", "client"],
                "get-change-permission": e.getChangePermission,
                "get-delete-permission": e.getDeletePermission,
                items: f.value,
                search: r.value,
                "work-order": e.workOrder,
                headers: e.headers,
                class: "cursor-pointer mt-6 px-3",
                density: "comfortable",
                "items-per-page": "10",
                onNavigateToProject: g[1] || (g[1] = (p) => d("navigateToProject", p)),
                onDeleteItem: l,
                onEditItem: c
              }, null, 8, ["get-change-permission", "get-delete-permission", "items", "search", "work-order", "headers"]))
            ], 64))
          ];
        }),
        _: 1
      })
    ]));
  }
}), PF = ["innerHTML"], Zm = /* @__PURE__ */ Je({
  __name: "HelpTextTooltip",
  props: {
    text: { type: String, required: !0 },
    size: { type: String, required: !1, default: "small" },
    color: { type: String, required: !1, default: "#757575" },
    vClass: { type: String, required: !1 },
    maxWidth: { type: String, required: !1, default: "500px" },
    location: {
      type: String,
      required: !1,
      default: "bottom"
    }
  },
  setup(e) {
    const t = e;
    return (n, i) => (le(), Te(dl, {
      location: t.location,
      "max-width": t.maxWidth,
      style: {
        zIndex: 9999,
        position: "absolute"
      }
    }, {
      activator: Z(({ props: r }) => [
        b(dt, fe(r, {
          color: e.color,
          class: r.vClass,
          size: r.size
        }), {
          default: Z(() => [
            Ee(" mdi-information ")
          ]),
          _: 2
        }, 1040, ["color", "class", "size"])
      ]),
      default: Z(() => [
        St("div", {
          innerHTML: t.text
        }, null, 8, PF)
      ]),
      _: 1
    }, 8, ["location", "max-width"]));
  }
});
var Fo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function OF(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Dc = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Dc.exports;
(function(e, t) {
  (function() {
    var n, i = "4.17.21", r = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", l = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", d = 500, f = "__lodash_placeholder__", m = 1, g = 2, v = 4, p = 1, _ = 2, x = 1, S = 2, T = 4, M = 8, E = 16, D = 32, R = 64, $ = 128, A = 256, V = 512, H = 30, B = "...", N = 800, q = 16, X = 1, se = 2, de = 3, _e = 1 / 0, be = 9007199254740991, oe = 17976931348623157e292, J = NaN, G = 4294967295, ie = G - 1, ge = G >>> 1, he = [
      ["ary", $],
      ["bind", x],
      ["bindKey", S],
      ["curry", M],
      ["curryRight", E],
      ["flip", V],
      ["partial", D],
      ["partialRight", R],
      ["rearg", A]
    ], Oe = "[object Arguments]", Q = "[object Array]", me = "[object AsyncFunction]", Ze = "[object Boolean]", We = "[object Date]", Ue = "[object DOMException]", Ot = "[object Error]", ft = "[object Function]", yn = "[object GeneratorFunction]", xt = "[object Map]", sn = "[object Number]", pn = "[object Null]", an = "[object Object]", eo = "[object Promise]", Nl = "[object Proxy]", Li = "[object RegExp]", Tt = "[object Set]", cs = "[object String]", Ks = "[object Symbol]", bd = "[object Undefined]", ds = "[object WeakMap]", xd = "[object WeakSet]", Pr = "[object ArrayBuffer]", Qi = "[object DataView]", Xs = "[object Float32Array]", Js = "[object Float64Array]", Or = "[object Int8Array]", fs = "[object Int16Array]", to = "[object Int32Array]", no = "[object Uint8Array]", io = "[object Uint8ClampedArray]", ro = "[object Uint16Array]", so = "[object Uint32Array]", Qs = /\b__p \+= '';/g, _d = /\b(__p \+=) '' \+/g, wd = /(__e\(.*?\)|\b__t\)) \+\n'';/g, ao = /&(?:amp|lt|gt|quot|#39);/g, oo = /[&<>"']/g, lo = RegExp(ao.source), Sd = RegExp(oo.source), kd = /<%-([\s\S]+?)%>/g, Cd = /<%([\s\S]+?)%>/g, uo = /<%=([\s\S]+?)%>/g, Td = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Id = /^\w*$/, Pd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Er = /[\\^$.*+?()[\]{}|]/g, Od = RegExp(Er.source), co = /^\s+/, $l = /\s/, fo = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ed = /\{\n\/\* \[wrapped with (.+)\] \*/, zl = /,? & /, Ad = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Hl = /[()=,{}\[\]\/\s]/, Wl = /\\(\\)?/g, Ul = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ho = /\w*$/, mo = /^[-+]0x[0-9a-f]+$/i, er = /^0b[01]+$/i, hs = /^\[object .+?Constructor\]$/, ms = /^0o[0-7]+$/i, ea = /^(?:0|[1-9]\d*)$/, go = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ta = /($^)/, Md = /['\n\r\u2028\u2029\\]/g, tr = "\\ud800-\\udfff", In = "\\u0300-\\u036f", Ar = "\\ufe20-\\ufe2f", Fi = "\\u20d0-\\u20ff", ti = In + Ar + Fi, Mr = "\\u2700-\\u27bf", Nn = "a-z\\xdf-\\xf6\\xf8-\\xff", bi = "\\xac\\xb1\\xd7\\xf7", ql = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", jl = "\\u2000-\\u206f", na = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Pn = "A-Z\\xc0-\\xd6\\xd8-\\xde", gs = "\\ufe0e\\ufe0f", ia = bi + ql + jl + na, vs = "['’]", vo = "[" + tr + "]", ra = "[" + ia + "]", nr = "[" + ti + "]", xi = "\\d+", Dd = "[" + Mr + "]", yo = "[" + Nn + "]", sa = "[^" + tr + ia + xi + Mr + Nn + Pn + "]", aa = "\\ud83c[\\udffb-\\udfff]", Vd = "(?:" + nr + "|" + aa + ")", Gl = "[^" + tr + "]", k = "(?:\\ud83c[\\udde6-\\uddff]){2}", O = "[\\ud800-\\udbff][\\udc00-\\udfff]", F = "[" + Pn + "]", j = "\\u200d", ae = "(?:" + yo + "|" + sa + ")", xe = "(?:" + F + "|" + sa + ")", Ge = "(?:" + vs + "(?:d|ll|m|re|s|t|ve))?", zt = "(?:" + vs + "(?:D|LL|M|RE|S|T|VE))?", Gt = Vd + "?", Qt = "[" + gs + "]?", ni = "(?:" + j + "(?:" + [Gl, k, O].join("|") + ")" + Qt + Gt + ")*", t1 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", n1 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", pg = Qt + Gt + ni, i1 = "(?:" + [Dd, k, O].join("|") + ")" + pg, r1 = "(?:" + [Gl + nr + "?", nr, k, O, vo].join("|") + ")", s1 = RegExp(vs, "g"), a1 = RegExp(nr, "g"), Ld = RegExp(aa + "(?=" + aa + ")|" + r1 + pg, "g"), o1 = RegExp([
      F + "?" + yo + "+" + Ge + "(?=" + [ra, F, "$"].join("|") + ")",
      xe + "+" + zt + "(?=" + [ra, F + ae, "$"].join("|") + ")",
      F + "?" + ae + "+" + Ge,
      F + "+" + zt,
      n1,
      t1,
      xi,
      i1
    ].join("|"), "g"), l1 = RegExp("[" + j + tr + ti + gs + "]"), u1 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, c1 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], d1 = -1, kt = {};
    kt[Xs] = kt[Js] = kt[Or] = kt[fs] = kt[to] = kt[no] = kt[io] = kt[ro] = kt[so] = !0, kt[Oe] = kt[Q] = kt[Pr] = kt[Ze] = kt[Qi] = kt[We] = kt[Ot] = kt[ft] = kt[xt] = kt[sn] = kt[an] = kt[Li] = kt[Tt] = kt[cs] = kt[ds] = !1;
    var _t = {};
    _t[Oe] = _t[Q] = _t[Pr] = _t[Qi] = _t[Ze] = _t[We] = _t[Xs] = _t[Js] = _t[Or] = _t[fs] = _t[to] = _t[xt] = _t[sn] = _t[an] = _t[Li] = _t[Tt] = _t[cs] = _t[Ks] = _t[no] = _t[io] = _t[ro] = _t[so] = !0, _t[Ot] = _t[ft] = _t[ds] = !1;
    var f1 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, h1 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, m1 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, g1 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, v1 = parseFloat, y1 = parseInt, bg = typeof Fo == "object" && Fo && Fo.Object === Object && Fo, p1 = typeof self == "object" && self && self.Object === Object && self, on = bg || p1 || Function("return this")(), Fd = t && !t.nodeType && t, ys = Fd && !0 && e && !e.nodeType && e, xg = ys && ys.exports === Fd, Rd = xg && bg.process, ii = function() {
      try {
        var W = ys && ys.require && ys.require("util").types;
        return W || Rd && Rd.binding && Rd.binding("util");
      } catch {
      }
    }(), _g = ii && ii.isArrayBuffer, wg = ii && ii.isDate, Sg = ii && ii.isMap, kg = ii && ii.isRegExp, Cg = ii && ii.isSet, Tg = ii && ii.isTypedArray;
    function $n(W, K, Y) {
      switch (Y.length) {
        case 0:
          return W.call(K);
        case 1:
          return W.call(K, Y[0]);
        case 2:
          return W.call(K, Y[0], Y[1]);
        case 3:
          return W.call(K, Y[0], Y[1], Y[2]);
      }
      return W.apply(K, Y);
    }
    function b1(W, K, Y, we) {
      for (var Be = -1, lt = W == null ? 0 : W.length; ++Be < lt; ) {
        var Kt = W[Be];
        K(we, Kt, Y(Kt), W);
      }
      return we;
    }
    function ri(W, K) {
      for (var Y = -1, we = W == null ? 0 : W.length; ++Y < we && K(W[Y], Y, W) !== !1; )
        ;
      return W;
    }
    function x1(W, K) {
      for (var Y = W == null ? 0 : W.length; Y-- && K(W[Y], Y, W) !== !1; )
        ;
      return W;
    }
    function Ig(W, K) {
      for (var Y = -1, we = W == null ? 0 : W.length; ++Y < we; )
        if (!K(W[Y], Y, W))
          return !1;
      return !0;
    }
    function Dr(W, K) {
      for (var Y = -1, we = W == null ? 0 : W.length, Be = 0, lt = []; ++Y < we; ) {
        var Kt = W[Y];
        K(Kt, Y, W) && (lt[Be++] = Kt);
      }
      return lt;
    }
    function Yl(W, K) {
      var Y = W == null ? 0 : W.length;
      return !!Y && oa(W, K, 0) > -1;
    }
    function Bd(W, K, Y) {
      for (var we = -1, Be = W == null ? 0 : W.length; ++we < Be; )
        if (Y(K, W[we]))
          return !0;
      return !1;
    }
    function It(W, K) {
      for (var Y = -1, we = W == null ? 0 : W.length, Be = Array(we); ++Y < we; )
        Be[Y] = K(W[Y], Y, W);
      return Be;
    }
    function Vr(W, K) {
      for (var Y = -1, we = K.length, Be = W.length; ++Y < we; )
        W[Be + Y] = K[Y];
      return W;
    }
    function Nd(W, K, Y, we) {
      var Be = -1, lt = W == null ? 0 : W.length;
      for (we && lt && (Y = W[++Be]); ++Be < lt; )
        Y = K(Y, W[Be], Be, W);
      return Y;
    }
    function _1(W, K, Y, we) {
      var Be = W == null ? 0 : W.length;
      for (we && Be && (Y = W[--Be]); Be--; )
        Y = K(Y, W[Be], Be, W);
      return Y;
    }
    function $d(W, K) {
      for (var Y = -1, we = W == null ? 0 : W.length; ++Y < we; )
        if (K(W[Y], Y, W))
          return !0;
      return !1;
    }
    var w1 = zd("length");
    function S1(W) {
      return W.split("");
    }
    function k1(W) {
      return W.match(Ad) || [];
    }
    function Pg(W, K, Y) {
      var we;
      return Y(W, function(Be, lt, Kt) {
        if (K(Be, lt, Kt))
          return we = lt, !1;
      }), we;
    }
    function Zl(W, K, Y, we) {
      for (var Be = W.length, lt = Y + (we ? 1 : -1); we ? lt-- : ++lt < Be; )
        if (K(W[lt], lt, W))
          return lt;
      return -1;
    }
    function oa(W, K, Y) {
      return K === K ? F1(W, K, Y) : Zl(W, Og, Y);
    }
    function C1(W, K, Y, we) {
      for (var Be = Y - 1, lt = W.length; ++Be < lt; )
        if (we(W[Be], K))
          return Be;
      return -1;
    }
    function Og(W) {
      return W !== W;
    }
    function Eg(W, K) {
      var Y = W == null ? 0 : W.length;
      return Y ? Wd(W, K) / Y : J;
    }
    function zd(W) {
      return function(K) {
        return K == null ? n : K[W];
      };
    }
    function Hd(W) {
      return function(K) {
        return W == null ? n : W[K];
      };
    }
    function Ag(W, K, Y, we, Be) {
      return Be(W, function(lt, Kt, bt) {
        Y = we ? (we = !1, lt) : K(Y, lt, Kt, bt);
      }), Y;
    }
    function T1(W, K) {
      var Y = W.length;
      for (W.sort(K); Y--; )
        W[Y] = W[Y].value;
      return W;
    }
    function Wd(W, K) {
      for (var Y, we = -1, Be = W.length; ++we < Be; ) {
        var lt = K(W[we]);
        lt !== n && (Y = Y === n ? lt : Y + lt);
      }
      return Y;
    }
    function Ud(W, K) {
      for (var Y = -1, we = Array(W); ++Y < W; )
        we[Y] = K(Y);
      return we;
    }
    function I1(W, K) {
      return It(K, function(Y) {
        return [Y, W[Y]];
      });
    }
    function Mg(W) {
      return W && W.slice(0, Fg(W) + 1).replace(co, "");
    }
    function zn(W) {
      return function(K) {
        return W(K);
      };
    }
    function qd(W, K) {
      return It(K, function(Y) {
        return W[Y];
      });
    }
    function po(W, K) {
      return W.has(K);
    }
    function Dg(W, K) {
      for (var Y = -1, we = W.length; ++Y < we && oa(K, W[Y], 0) > -1; )
        ;
      return Y;
    }
    function Vg(W, K) {
      for (var Y = W.length; Y-- && oa(K, W[Y], 0) > -1; )
        ;
      return Y;
    }
    function P1(W, K) {
      for (var Y = W.length, we = 0; Y--; )
        W[Y] === K && ++we;
      return we;
    }
    var O1 = Hd(f1), E1 = Hd(h1);
    function A1(W) {
      return "\\" + g1[W];
    }
    function M1(W, K) {
      return W == null ? n : W[K];
    }
    function la(W) {
      return l1.test(W);
    }
    function D1(W) {
      return u1.test(W);
    }
    function V1(W) {
      for (var K, Y = []; !(K = W.next()).done; )
        Y.push(K.value);
      return Y;
    }
    function jd(W) {
      var K = -1, Y = Array(W.size);
      return W.forEach(function(we, Be) {
        Y[++K] = [Be, we];
      }), Y;
    }
    function Lg(W, K) {
      return function(Y) {
        return W(K(Y));
      };
    }
    function Lr(W, K) {
      for (var Y = -1, we = W.length, Be = 0, lt = []; ++Y < we; ) {
        var Kt = W[Y];
        (Kt === K || Kt === f) && (W[Y] = f, lt[Be++] = Y);
      }
      return lt;
    }
    function Kl(W) {
      var K = -1, Y = Array(W.size);
      return W.forEach(function(we) {
        Y[++K] = we;
      }), Y;
    }
    function L1(W) {
      var K = -1, Y = Array(W.size);
      return W.forEach(function(we) {
        Y[++K] = [we, we];
      }), Y;
    }
    function F1(W, K, Y) {
      for (var we = Y - 1, Be = W.length; ++we < Be; )
        if (W[we] === K)
          return we;
      return -1;
    }
    function R1(W, K, Y) {
      for (var we = Y + 1; we--; )
        if (W[we] === K)
          return we;
      return we;
    }
    function ua(W) {
      return la(W) ? N1(W) : w1(W);
    }
    function _i(W) {
      return la(W) ? $1(W) : S1(W);
    }
    function Fg(W) {
      for (var K = W.length; K-- && $l.test(W.charAt(K)); )
        ;
      return K;
    }
    var B1 = Hd(m1);
    function N1(W) {
      for (var K = Ld.lastIndex = 0; Ld.test(W); )
        ++K;
      return K;
    }
    function $1(W) {
      return W.match(Ld) || [];
    }
    function z1(W) {
      return W.match(o1) || [];
    }
    var H1 = function W(K) {
      K = K == null ? on : ca.defaults(on.Object(), K, ca.pick(on, c1));
      var Y = K.Array, we = K.Date, Be = K.Error, lt = K.Function, Kt = K.Math, bt = K.Object, Gd = K.RegExp, W1 = K.String, si = K.TypeError, Xl = Y.prototype, U1 = lt.prototype, da = bt.prototype, Jl = K["__core-js_shared__"], Ql = U1.toString, mt = da.hasOwnProperty, q1 = 0, Rg = function() {
        var o = /[^.]+$/.exec(Jl && Jl.keys && Jl.keys.IE_PROTO || "");
        return o ? "Symbol(src)_1." + o : "";
      }(), eu = da.toString, j1 = Ql.call(bt), G1 = on._, Y1 = Gd(
        "^" + Ql.call(mt).replace(Er, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), tu = xg ? K.Buffer : n, Fr = K.Symbol, nu = K.Uint8Array, Bg = tu ? tu.allocUnsafe : n, iu = Lg(bt.getPrototypeOf, bt), Ng = bt.create, $g = da.propertyIsEnumerable, ru = Xl.splice, zg = Fr ? Fr.isConcatSpreadable : n, bo = Fr ? Fr.iterator : n, ps = Fr ? Fr.toStringTag : n, su = function() {
        try {
          var o = Ss(bt, "defineProperty");
          return o({}, "", {}), o;
        } catch {
        }
      }(), Z1 = K.clearTimeout !== on.clearTimeout && K.clearTimeout, K1 = we && we.now !== on.Date.now && we.now, X1 = K.setTimeout !== on.setTimeout && K.setTimeout, au = Kt.ceil, ou = Kt.floor, Yd = bt.getOwnPropertySymbols, J1 = tu ? tu.isBuffer : n, Hg = K.isFinite, Q1 = Xl.join, ek = Lg(bt.keys, bt), Xt = Kt.max, dn = Kt.min, tk = we.now, nk = K.parseInt, Wg = Kt.random, ik = Xl.reverse, Zd = Ss(K, "DataView"), xo = Ss(K, "Map"), Kd = Ss(K, "Promise"), fa = Ss(K, "Set"), _o = Ss(K, "WeakMap"), wo = Ss(bt, "create"), lu = _o && new _o(), ha = {}, rk = ks(Zd), sk = ks(xo), ak = ks(Kd), ok = ks(fa), lk = ks(_o), uu = Fr ? Fr.prototype : n, So = uu ? uu.valueOf : n, Ug = uu ? uu.toString : n;
      function C(o) {
        if (Lt(o) && !ze(o) && !(o instanceof tt)) {
          if (o instanceof ai)
            return o;
          if (mt.call(o, "__wrapped__"))
            return qv(o);
        }
        return new ai(o);
      }
      var ma = /* @__PURE__ */ function() {
        function o() {
        }
        return function(u) {
          if (!Et(u))
            return {};
          if (Ng)
            return Ng(u);
          o.prototype = u;
          var h = new o();
          return o.prototype = n, h;
        };
      }();
      function cu() {
      }
      function ai(o, u) {
        this.__wrapped__ = o, this.__actions__ = [], this.__chain__ = !!u, this.__index__ = 0, this.__values__ = n;
      }
      C.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: kd,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Cd,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: uo,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: C
        }
      }, C.prototype = cu.prototype, C.prototype.constructor = C, ai.prototype = ma(cu.prototype), ai.prototype.constructor = ai;
      function tt(o) {
        this.__wrapped__ = o, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = G, this.__views__ = [];
      }
      function uk() {
        var o = new tt(this.__wrapped__);
        return o.__actions__ = On(this.__actions__), o.__dir__ = this.__dir__, o.__filtered__ = this.__filtered__, o.__iteratees__ = On(this.__iteratees__), o.__takeCount__ = this.__takeCount__, o.__views__ = On(this.__views__), o;
      }
      function ck() {
        if (this.__filtered__) {
          var o = new tt(this);
          o.__dir__ = -1, o.__filtered__ = !0;
        } else
          o = this.clone(), o.__dir__ *= -1;
        return o;
      }
      function dk() {
        var o = this.__wrapped__.value(), u = this.__dir__, h = ze(o), y = u < 0, w = h ? o.length : 0, P = SC(0, w, this.__views__), L = P.start, z = P.end, U = z - L, te = y ? z : L - 1, ne = this.__iteratees__, re = ne.length, ve = 0, Pe = dn(U, this.__takeCount__);
        if (!h || !y && w == U && Pe == U)
          return mv(o, this.__actions__);
        var De = [];
        e:
          for (; U-- && ve < Pe; ) {
            te += u;
            for (var Ye = -1, Ve = o[te]; ++Ye < re; ) {
              var Qe = ne[Ye], st = Qe.iteratee, Un = Qe.type, _n = st(Ve);
              if (Un == se)
                Ve = _n;
              else if (!_n) {
                if (Un == X)
                  continue e;
                break e;
              }
            }
            De[ve++] = Ve;
          }
        return De;
      }
      tt.prototype = ma(cu.prototype), tt.prototype.constructor = tt;
      function bs(o) {
        var u = -1, h = o == null ? 0 : o.length;
        for (this.clear(); ++u < h; ) {
          var y = o[u];
          this.set(y[0], y[1]);
        }
      }
      function fk() {
        this.__data__ = wo ? wo(null) : {}, this.size = 0;
      }
      function hk(o) {
        var u = this.has(o) && delete this.__data__[o];
        return this.size -= u ? 1 : 0, u;
      }
      function mk(o) {
        var u = this.__data__;
        if (wo) {
          var h = u[o];
          return h === c ? n : h;
        }
        return mt.call(u, o) ? u[o] : n;
      }
      function gk(o) {
        var u = this.__data__;
        return wo ? u[o] !== n : mt.call(u, o);
      }
      function vk(o, u) {
        var h = this.__data__;
        return this.size += this.has(o) ? 0 : 1, h[o] = wo && u === n ? c : u, this;
      }
      bs.prototype.clear = fk, bs.prototype.delete = hk, bs.prototype.get = mk, bs.prototype.has = gk, bs.prototype.set = vk;
      function ir(o) {
        var u = -1, h = o == null ? 0 : o.length;
        for (this.clear(); ++u < h; ) {
          var y = o[u];
          this.set(y[0], y[1]);
        }
      }
      function yk() {
        this.__data__ = [], this.size = 0;
      }
      function pk(o) {
        var u = this.__data__, h = du(u, o);
        if (h < 0)
          return !1;
        var y = u.length - 1;
        return h == y ? u.pop() : ru.call(u, h, 1), --this.size, !0;
      }
      function bk(o) {
        var u = this.__data__, h = du(u, o);
        return h < 0 ? n : u[h][1];
      }
      function xk(o) {
        return du(this.__data__, o) > -1;
      }
      function _k(o, u) {
        var h = this.__data__, y = du(h, o);
        return y < 0 ? (++this.size, h.push([o, u])) : h[y][1] = u, this;
      }
      ir.prototype.clear = yk, ir.prototype.delete = pk, ir.prototype.get = bk, ir.prototype.has = xk, ir.prototype.set = _k;
      function rr(o) {
        var u = -1, h = o == null ? 0 : o.length;
        for (this.clear(); ++u < h; ) {
          var y = o[u];
          this.set(y[0], y[1]);
        }
      }
      function wk() {
        this.size = 0, this.__data__ = {
          hash: new bs(),
          map: new (xo || ir)(),
          string: new bs()
        };
      }
      function Sk(o) {
        var u = Su(this, o).delete(o);
        return this.size -= u ? 1 : 0, u;
      }
      function kk(o) {
        return Su(this, o).get(o);
      }
      function Ck(o) {
        return Su(this, o).has(o);
      }
      function Tk(o, u) {
        var h = Su(this, o), y = h.size;
        return h.set(o, u), this.size += h.size == y ? 0 : 1, this;
      }
      rr.prototype.clear = wk, rr.prototype.delete = Sk, rr.prototype.get = kk, rr.prototype.has = Ck, rr.prototype.set = Tk;
      function xs(o) {
        var u = -1, h = o == null ? 0 : o.length;
        for (this.__data__ = new rr(); ++u < h; )
          this.add(o[u]);
      }
      function Ik(o) {
        return this.__data__.set(o, c), this;
      }
      function Pk(o) {
        return this.__data__.has(o);
      }
      xs.prototype.add = xs.prototype.push = Ik, xs.prototype.has = Pk;
      function wi(o) {
        var u = this.__data__ = new ir(o);
        this.size = u.size;
      }
      function Ok() {
        this.__data__ = new ir(), this.size = 0;
      }
      function Ek(o) {
        var u = this.__data__, h = u.delete(o);
        return this.size = u.size, h;
      }
      function Ak(o) {
        return this.__data__.get(o);
      }
      function Mk(o) {
        return this.__data__.has(o);
      }
      function Dk(o, u) {
        var h = this.__data__;
        if (h instanceof ir) {
          var y = h.__data__;
          if (!xo || y.length < r - 1)
            return y.push([o, u]), this.size = ++h.size, this;
          h = this.__data__ = new rr(y);
        }
        return h.set(o, u), this.size = h.size, this;
      }
      wi.prototype.clear = Ok, wi.prototype.delete = Ek, wi.prototype.get = Ak, wi.prototype.has = Mk, wi.prototype.set = Dk;
      function qg(o, u) {
        var h = ze(o), y = !h && Cs(o), w = !h && !y && zr(o), P = !h && !y && !w && pa(o), L = h || y || w || P, z = L ? Ud(o.length, W1) : [], U = z.length;
        for (var te in o)
          (u || mt.call(o, te)) && !(L && // Safari 9 has enumerable `arguments.length` in strict mode.
          (te == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          w && (te == "offset" || te == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          P && (te == "buffer" || te == "byteLength" || te == "byteOffset") || // Skip index properties.
          lr(te, U))) && z.push(te);
        return z;
      }
      function jg(o) {
        var u = o.length;
        return u ? o[lf(0, u - 1)] : n;
      }
      function Vk(o, u) {
        return ku(On(o), _s(u, 0, o.length));
      }
      function Lk(o) {
        return ku(On(o));
      }
      function Xd(o, u, h) {
        (h !== n && !Si(o[u], h) || h === n && !(u in o)) && sr(o, u, h);
      }
      function ko(o, u, h) {
        var y = o[u];
        (!(mt.call(o, u) && Si(y, h)) || h === n && !(u in o)) && sr(o, u, h);
      }
      function du(o, u) {
        for (var h = o.length; h--; )
          if (Si(o[h][0], u))
            return h;
        return -1;
      }
      function Fk(o, u, h, y) {
        return Rr(o, function(w, P, L) {
          u(y, w, h(w), L);
        }), y;
      }
      function Gg(o, u) {
        return o && Bi(u, en(u), o);
      }
      function Rk(o, u) {
        return o && Bi(u, An(u), o);
      }
      function sr(o, u, h) {
        u == "__proto__" && su ? su(o, u, {
          configurable: !0,
          enumerable: !0,
          value: h,
          writable: !0
        }) : o[u] = h;
      }
      function Jd(o, u) {
        for (var h = -1, y = u.length, w = Y(y), P = o == null; ++h < y; )
          w[h] = P ? n : Df(o, u[h]);
        return w;
      }
      function _s(o, u, h) {
        return o === o && (h !== n && (o = o <= h ? o : h), u !== n && (o = o >= u ? o : u)), o;
      }
      function oi(o, u, h, y, w, P) {
        var L, z = u & m, U = u & g, te = u & v;
        if (h && (L = w ? h(o, y, w, P) : h(o)), L !== n)
          return L;
        if (!Et(o))
          return o;
        var ne = ze(o);
        if (ne) {
          if (L = CC(o), !z)
            return On(o, L);
        } else {
          var re = fn(o), ve = re == ft || re == yn;
          if (zr(o))
            return yv(o, z);
          if (re == an || re == Oe || ve && !w) {
            if (L = U || ve ? {} : Fv(o), !z)
              return U ? mC(o, Rk(L, o)) : hC(o, Gg(L, o));
          } else {
            if (!_t[re])
              return w ? o : {};
            L = TC(o, re, z);
          }
        }
        P || (P = new wi());
        var Pe = P.get(o);
        if (Pe)
          return Pe;
        P.set(o, L), dy(o) ? o.forEach(function(Ve) {
          L.add(oi(Ve, u, h, Ve, o, P));
        }) : uy(o) && o.forEach(function(Ve, Qe) {
          L.set(Qe, oi(Ve, u, h, Qe, o, P));
        });
        var De = te ? U ? bf : pf : U ? An : en, Ye = ne ? n : De(o);
        return ri(Ye || o, function(Ve, Qe) {
          Ye && (Qe = Ve, Ve = o[Qe]), ko(L, Qe, oi(Ve, u, h, Qe, o, P));
        }), L;
      }
      function Bk(o) {
        var u = en(o);
        return function(h) {
          return Yg(h, o, u);
        };
      }
      function Yg(o, u, h) {
        var y = h.length;
        if (o == null)
          return !y;
        for (o = bt(o); y--; ) {
          var w = h[y], P = u[w], L = o[w];
          if (L === n && !(w in o) || !P(L))
            return !1;
        }
        return !0;
      }
      function Zg(o, u, h) {
        if (typeof o != "function")
          throw new si(a);
        return Ao(function() {
          o.apply(n, h);
        }, u);
      }
      function Co(o, u, h, y) {
        var w = -1, P = Yl, L = !0, z = o.length, U = [], te = u.length;
        if (!z)
          return U;
        h && (u = It(u, zn(h))), y ? (P = Bd, L = !1) : u.length >= r && (P = po, L = !1, u = new xs(u));
        e:
          for (; ++w < z; ) {
            var ne = o[w], re = h == null ? ne : h(ne);
            if (ne = y || ne !== 0 ? ne : 0, L && re === re) {
              for (var ve = te; ve--; )
                if (u[ve] === re)
                  continue e;
              U.push(ne);
            } else
              P(u, re, y) || U.push(ne);
          }
        return U;
      }
      var Rr = wv(Ri), Kg = wv(ef, !0);
      function Nk(o, u) {
        var h = !0;
        return Rr(o, function(y, w, P) {
          return h = !!u(y, w, P), h;
        }), h;
      }
      function fu(o, u, h) {
        for (var y = -1, w = o.length; ++y < w; ) {
          var P = o[y], L = u(P);
          if (L != null && (z === n ? L === L && !Wn(L) : h(L, z)))
            var z = L, U = P;
        }
        return U;
      }
      function $k(o, u, h, y) {
        var w = o.length;
        for (h = qe(h), h < 0 && (h = -h > w ? 0 : w + h), y = y === n || y > w ? w : qe(y), y < 0 && (y += w), y = h > y ? 0 : hy(y); h < y; )
          o[h++] = u;
        return o;
      }
      function Xg(o, u) {
        var h = [];
        return Rr(o, function(y, w, P) {
          u(y, w, P) && h.push(y);
        }), h;
      }
      function ln(o, u, h, y, w) {
        var P = -1, L = o.length;
        for (h || (h = PC), w || (w = []); ++P < L; ) {
          var z = o[P];
          u > 0 && h(z) ? u > 1 ? ln(z, u - 1, h, y, w) : Vr(w, z) : y || (w[w.length] = z);
        }
        return w;
      }
      var Qd = Sv(), Jg = Sv(!0);
      function Ri(o, u) {
        return o && Qd(o, u, en);
      }
      function ef(o, u) {
        return o && Jg(o, u, en);
      }
      function hu(o, u) {
        return Dr(u, function(h) {
          return ur(o[h]);
        });
      }
      function ws(o, u) {
        u = Nr(u, o);
        for (var h = 0, y = u.length; o != null && h < y; )
          o = o[Ni(u[h++])];
        return h && h == y ? o : n;
      }
      function Qg(o, u, h) {
        var y = u(o);
        return ze(o) ? y : Vr(y, h(o));
      }
      function bn(o) {
        return o == null ? o === n ? bd : pn : ps && ps in bt(o) ? wC(o) : LC(o);
      }
      function tf(o, u) {
        return o > u;
      }
      function zk(o, u) {
        return o != null && mt.call(o, u);
      }
      function Hk(o, u) {
        return o != null && u in bt(o);
      }
      function Wk(o, u, h) {
        return o >= dn(u, h) && o < Xt(u, h);
      }
      function nf(o, u, h) {
        for (var y = h ? Bd : Yl, w = o[0].length, P = o.length, L = P, z = Y(P), U = 1 / 0, te = []; L--; ) {
          var ne = o[L];
          L && u && (ne = It(ne, zn(u))), U = dn(ne.length, U), z[L] = !h && (u || w >= 120 && ne.length >= 120) ? new xs(L && ne) : n;
        }
        ne = o[0];
        var re = -1, ve = z[0];
        e:
          for (; ++re < w && te.length < U; ) {
            var Pe = ne[re], De = u ? u(Pe) : Pe;
            if (Pe = h || Pe !== 0 ? Pe : 0, !(ve ? po(ve, De) : y(te, De, h))) {
              for (L = P; --L; ) {
                var Ye = z[L];
                if (!(Ye ? po(Ye, De) : y(o[L], De, h)))
                  continue e;
              }
              ve && ve.push(De), te.push(Pe);
            }
          }
        return te;
      }
      function Uk(o, u, h, y) {
        return Ri(o, function(w, P, L) {
          u(y, h(w), P, L);
        }), y;
      }
      function To(o, u, h) {
        u = Nr(u, o), o = $v(o, u);
        var y = o == null ? o : o[Ni(ui(u))];
        return y == null ? n : $n(y, o, h);
      }
      function ev(o) {
        return Lt(o) && bn(o) == Oe;
      }
      function qk(o) {
        return Lt(o) && bn(o) == Pr;
      }
      function jk(o) {
        return Lt(o) && bn(o) == We;
      }
      function Io(o, u, h, y, w) {
        return o === u ? !0 : o == null || u == null || !Lt(o) && !Lt(u) ? o !== o && u !== u : Gk(o, u, h, y, Io, w);
      }
      function Gk(o, u, h, y, w, P) {
        var L = ze(o), z = ze(u), U = L ? Q : fn(o), te = z ? Q : fn(u);
        U = U == Oe ? an : U, te = te == Oe ? an : te;
        var ne = U == an, re = te == an, ve = U == te;
        if (ve && zr(o)) {
          if (!zr(u))
            return !1;
          L = !0, ne = !1;
        }
        if (ve && !ne)
          return P || (P = new wi()), L || pa(o) ? Dv(o, u, h, y, w, P) : xC(o, u, U, h, y, w, P);
        if (!(h & p)) {
          var Pe = ne && mt.call(o, "__wrapped__"), De = re && mt.call(u, "__wrapped__");
          if (Pe || De) {
            var Ye = Pe ? o.value() : o, Ve = De ? u.value() : u;
            return P || (P = new wi()), w(Ye, Ve, h, y, P);
          }
        }
        return ve ? (P || (P = new wi()), _C(o, u, h, y, w, P)) : !1;
      }
      function Yk(o) {
        return Lt(o) && fn(o) == xt;
      }
      function rf(o, u, h, y) {
        var w = h.length, P = w, L = !y;
        if (o == null)
          return !P;
        for (o = bt(o); w--; ) {
          var z = h[w];
          if (L && z[2] ? z[1] !== o[z[0]] : !(z[0] in o))
            return !1;
        }
        for (; ++w < P; ) {
          z = h[w];
          var U = z[0], te = o[U], ne = z[1];
          if (L && z[2]) {
            if (te === n && !(U in o))
              return !1;
          } else {
            var re = new wi();
            if (y)
              var ve = y(te, ne, U, o, u, re);
            if (!(ve === n ? Io(ne, te, p | _, y, re) : ve))
              return !1;
          }
        }
        return !0;
      }
      function tv(o) {
        if (!Et(o) || EC(o))
          return !1;
        var u = ur(o) ? Y1 : hs;
        return u.test(ks(o));
      }
      function Zk(o) {
        return Lt(o) && bn(o) == Li;
      }
      function Kk(o) {
        return Lt(o) && fn(o) == Tt;
      }
      function Xk(o) {
        return Lt(o) && Eu(o.length) && !!kt[bn(o)];
      }
      function nv(o) {
        return typeof o == "function" ? o : o == null ? Mn : typeof o == "object" ? ze(o) ? sv(o[0], o[1]) : rv(o) : ky(o);
      }
      function sf(o) {
        if (!Eo(o))
          return ek(o);
        var u = [];
        for (var h in bt(o))
          mt.call(o, h) && h != "constructor" && u.push(h);
        return u;
      }
      function Jk(o) {
        if (!Et(o))
          return VC(o);
        var u = Eo(o), h = [];
        for (var y in o)
          y == "constructor" && (u || !mt.call(o, y)) || h.push(y);
        return h;
      }
      function af(o, u) {
        return o < u;
      }
      function iv(o, u) {
        var h = -1, y = En(o) ? Y(o.length) : [];
        return Rr(o, function(w, P, L) {
          y[++h] = u(w, P, L);
        }), y;
      }
      function rv(o) {
        var u = _f(o);
        return u.length == 1 && u[0][2] ? Bv(u[0][0], u[0][1]) : function(h) {
          return h === o || rf(h, o, u);
        };
      }
      function sv(o, u) {
        return Sf(o) && Rv(u) ? Bv(Ni(o), u) : function(h) {
          var y = Df(h, o);
          return y === n && y === u ? Vf(h, o) : Io(u, y, p | _);
        };
      }
      function mu(o, u, h, y, w) {
        o !== u && Qd(u, function(P, L) {
          if (w || (w = new wi()), Et(P))
            Qk(o, u, L, h, mu, y, w);
          else {
            var z = y ? y(Cf(o, L), P, L + "", o, u, w) : n;
            z === n && (z = P), Xd(o, L, z);
          }
        }, An);
      }
      function Qk(o, u, h, y, w, P, L) {
        var z = Cf(o, h), U = Cf(u, h), te = L.get(U);
        if (te) {
          Xd(o, h, te);
          return;
        }
        var ne = P ? P(z, U, h + "", o, u, L) : n, re = ne === n;
        if (re) {
          var ve = ze(U), Pe = !ve && zr(U), De = !ve && !Pe && pa(U);
          ne = U, ve || Pe || De ? ze(z) ? ne = z : Ht(z) ? ne = On(z) : Pe ? (re = !1, ne = yv(U, !0)) : De ? (re = !1, ne = pv(U, !0)) : ne = [] : Mo(U) || Cs(U) ? (ne = z, Cs(z) ? ne = my(z) : (!Et(z) || ur(z)) && (ne = Fv(U))) : re = !1;
        }
        re && (L.set(U, ne), w(ne, U, y, P, L), L.delete(U)), Xd(o, h, ne);
      }
      function av(o, u) {
        var h = o.length;
        if (h)
          return u += u < 0 ? h : 0, lr(u, h) ? o[u] : n;
      }
      function ov(o, u, h) {
        u.length ? u = It(u, function(P) {
          return ze(P) ? function(L) {
            return ws(L, P.length === 1 ? P[0] : P);
          } : P;
        }) : u = [Mn];
        var y = -1;
        u = It(u, zn(Me()));
        var w = iv(o, function(P, L, z) {
          var U = It(u, function(te) {
            return te(P);
          });
          return { criteria: U, index: ++y, value: P };
        });
        return T1(w, function(P, L) {
          return fC(P, L, h);
        });
      }
      function eC(o, u) {
        return lv(o, u, function(h, y) {
          return Vf(o, y);
        });
      }
      function lv(o, u, h) {
        for (var y = -1, w = u.length, P = {}; ++y < w; ) {
          var L = u[y], z = ws(o, L);
          h(z, L) && Po(P, Nr(L, o), z);
        }
        return P;
      }
      function tC(o) {
        return function(u) {
          return ws(u, o);
        };
      }
      function of(o, u, h, y) {
        var w = y ? C1 : oa, P = -1, L = u.length, z = o;
        for (o === u && (u = On(u)), h && (z = It(o, zn(h))); ++P < L; )
          for (var U = 0, te = u[P], ne = h ? h(te) : te; (U = w(z, ne, U, y)) > -1; )
            z !== o && ru.call(z, U, 1), ru.call(o, U, 1);
        return o;
      }
      function uv(o, u) {
        for (var h = o ? u.length : 0, y = h - 1; h--; ) {
          var w = u[h];
          if (h == y || w !== P) {
            var P = w;
            lr(w) ? ru.call(o, w, 1) : df(o, w);
          }
        }
        return o;
      }
      function lf(o, u) {
        return o + ou(Wg() * (u - o + 1));
      }
      function nC(o, u, h, y) {
        for (var w = -1, P = Xt(au((u - o) / (h || 1)), 0), L = Y(P); P--; )
          L[y ? P : ++w] = o, o += h;
        return L;
      }
      function uf(o, u) {
        var h = "";
        if (!o || u < 1 || u > be)
          return h;
        do
          u % 2 && (h += o), u = ou(u / 2), u && (o += o);
        while (u);
        return h;
      }
      function Ke(o, u) {
        return Tf(Nv(o, u, Mn), o + "");
      }
      function iC(o) {
        return jg(ba(o));
      }
      function rC(o, u) {
        var h = ba(o);
        return ku(h, _s(u, 0, h.length));
      }
      function Po(o, u, h, y) {
        if (!Et(o))
          return o;
        u = Nr(u, o);
        for (var w = -1, P = u.length, L = P - 1, z = o; z != null && ++w < P; ) {
          var U = Ni(u[w]), te = h;
          if (U === "__proto__" || U === "constructor" || U === "prototype")
            return o;
          if (w != L) {
            var ne = z[U];
            te = y ? y(ne, U, z) : n, te === n && (te = Et(ne) ? ne : lr(u[w + 1]) ? [] : {});
          }
          ko(z, U, te), z = z[U];
        }
        return o;
      }
      var cv = lu ? function(o, u) {
        return lu.set(o, u), o;
      } : Mn, sC = su ? function(o, u) {
        return su(o, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Ff(u),
          writable: !0
        });
      } : Mn;
      function aC(o) {
        return ku(ba(o));
      }
      function li(o, u, h) {
        var y = -1, w = o.length;
        u < 0 && (u = -u > w ? 0 : w + u), h = h > w ? w : h, h < 0 && (h += w), w = u > h ? 0 : h - u >>> 0, u >>>= 0;
        for (var P = Y(w); ++y < w; )
          P[y] = o[y + u];
        return P;
      }
      function oC(o, u) {
        var h;
        return Rr(o, function(y, w, P) {
          return h = u(y, w, P), !h;
        }), !!h;
      }
      function gu(o, u, h) {
        var y = 0, w = o == null ? y : o.length;
        if (typeof u == "number" && u === u && w <= ge) {
          for (; y < w; ) {
            var P = y + w >>> 1, L = o[P];
            L !== null && !Wn(L) && (h ? L <= u : L < u) ? y = P + 1 : w = P;
          }
          return w;
        }
        return cf(o, u, Mn, h);
      }
      function cf(o, u, h, y) {
        var w = 0, P = o == null ? 0 : o.length;
        if (P === 0)
          return 0;
        u = h(u);
        for (var L = u !== u, z = u === null, U = Wn(u), te = u === n; w < P; ) {
          var ne = ou((w + P) / 2), re = h(o[ne]), ve = re !== n, Pe = re === null, De = re === re, Ye = Wn(re);
          if (L)
            var Ve = y || De;
          else
            te ? Ve = De && (y || ve) : z ? Ve = De && ve && (y || !Pe) : U ? Ve = De && ve && !Pe && (y || !Ye) : Pe || Ye ? Ve = !1 : Ve = y ? re <= u : re < u;
          Ve ? w = ne + 1 : P = ne;
        }
        return dn(P, ie);
      }
      function dv(o, u) {
        for (var h = -1, y = o.length, w = 0, P = []; ++h < y; ) {
          var L = o[h], z = u ? u(L) : L;
          if (!h || !Si(z, U)) {
            var U = z;
            P[w++] = L === 0 ? 0 : L;
          }
        }
        return P;
      }
      function fv(o) {
        return typeof o == "number" ? o : Wn(o) ? J : +o;
      }
      function Hn(o) {
        if (typeof o == "string")
          return o;
        if (ze(o))
          return It(o, Hn) + "";
        if (Wn(o))
          return Ug ? Ug.call(o) : "";
        var u = o + "";
        return u == "0" && 1 / o == -_e ? "-0" : u;
      }
      function Br(o, u, h) {
        var y = -1, w = Yl, P = o.length, L = !0, z = [], U = z;
        if (h)
          L = !1, w = Bd;
        else if (P >= r) {
          var te = u ? null : pC(o);
          if (te)
            return Kl(te);
          L = !1, w = po, U = new xs();
        } else
          U = u ? [] : z;
        e:
          for (; ++y < P; ) {
            var ne = o[y], re = u ? u(ne) : ne;
            if (ne = h || ne !== 0 ? ne : 0, L && re === re) {
              for (var ve = U.length; ve--; )
                if (U[ve] === re)
                  continue e;
              u && U.push(re), z.push(ne);
            } else
              w(U, re, h) || (U !== z && U.push(re), z.push(ne));
          }
        return z;
      }
      function df(o, u) {
        return u = Nr(u, o), o = $v(o, u), o == null || delete o[Ni(ui(u))];
      }
      function hv(o, u, h, y) {
        return Po(o, u, h(ws(o, u)), y);
      }
      function vu(o, u, h, y) {
        for (var w = o.length, P = y ? w : -1; (y ? P-- : ++P < w) && u(o[P], P, o); )
          ;
        return h ? li(o, y ? 0 : P, y ? P + 1 : w) : li(o, y ? P + 1 : 0, y ? w : P);
      }
      function mv(o, u) {
        var h = o;
        return h instanceof tt && (h = h.value()), Nd(u, function(y, w) {
          return w.func.apply(w.thisArg, Vr([y], w.args));
        }, h);
      }
      function ff(o, u, h) {
        var y = o.length;
        if (y < 2)
          return y ? Br(o[0]) : [];
        for (var w = -1, P = Y(y); ++w < y; )
          for (var L = o[w], z = -1; ++z < y; )
            z != w && (P[w] = Co(P[w] || L, o[z], u, h));
        return Br(ln(P, 1), u, h);
      }
      function gv(o, u, h) {
        for (var y = -1, w = o.length, P = u.length, L = {}; ++y < w; ) {
          var z = y < P ? u[y] : n;
          h(L, o[y], z);
        }
        return L;
      }
      function hf(o) {
        return Ht(o) ? o : [];
      }
      function mf(o) {
        return typeof o == "function" ? o : Mn;
      }
      function Nr(o, u) {
        return ze(o) ? o : Sf(o, u) ? [o] : Uv(ht(o));
      }
      var lC = Ke;
      function $r(o, u, h) {
        var y = o.length;
        return h = h === n ? y : h, !u && h >= y ? o : li(o, u, h);
      }
      var vv = Z1 || function(o) {
        return on.clearTimeout(o);
      };
      function yv(o, u) {
        if (u)
          return o.slice();
        var h = o.length, y = Bg ? Bg(h) : new o.constructor(h);
        return o.copy(y), y;
      }
      function gf(o) {
        var u = new o.constructor(o.byteLength);
        return new nu(u).set(new nu(o)), u;
      }
      function uC(o, u) {
        var h = u ? gf(o.buffer) : o.buffer;
        return new o.constructor(h, o.byteOffset, o.byteLength);
      }
      function cC(o) {
        var u = new o.constructor(o.source, ho.exec(o));
        return u.lastIndex = o.lastIndex, u;
      }
      function dC(o) {
        return So ? bt(So.call(o)) : {};
      }
      function pv(o, u) {
        var h = u ? gf(o.buffer) : o.buffer;
        return new o.constructor(h, o.byteOffset, o.length);
      }
      function bv(o, u) {
        if (o !== u) {
          var h = o !== n, y = o === null, w = o === o, P = Wn(o), L = u !== n, z = u === null, U = u === u, te = Wn(u);
          if (!z && !te && !P && o > u || P && L && U && !z && !te || y && L && U || !h && U || !w)
            return 1;
          if (!y && !P && !te && o < u || te && h && w && !y && !P || z && h && w || !L && w || !U)
            return -1;
        }
        return 0;
      }
      function fC(o, u, h) {
        for (var y = -1, w = o.criteria, P = u.criteria, L = w.length, z = h.length; ++y < L; ) {
          var U = bv(w[y], P[y]);
          if (U) {
            if (y >= z)
              return U;
            var te = h[y];
            return U * (te == "desc" ? -1 : 1);
          }
        }
        return o.index - u.index;
      }
      function xv(o, u, h, y) {
        for (var w = -1, P = o.length, L = h.length, z = -1, U = u.length, te = Xt(P - L, 0), ne = Y(U + te), re = !y; ++z < U; )
          ne[z] = u[z];
        for (; ++w < L; )
          (re || w < P) && (ne[h[w]] = o[w]);
        for (; te--; )
          ne[z++] = o[w++];
        return ne;
      }
      function _v(o, u, h, y) {
        for (var w = -1, P = o.length, L = -1, z = h.length, U = -1, te = u.length, ne = Xt(P - z, 0), re = Y(ne + te), ve = !y; ++w < ne; )
          re[w] = o[w];
        for (var Pe = w; ++U < te; )
          re[Pe + U] = u[U];
        for (; ++L < z; )
          (ve || w < P) && (re[Pe + h[L]] = o[w++]);
        return re;
      }
      function On(o, u) {
        var h = -1, y = o.length;
        for (u || (u = Y(y)); ++h < y; )
          u[h] = o[h];
        return u;
      }
      function Bi(o, u, h, y) {
        var w = !h;
        h || (h = {});
        for (var P = -1, L = u.length; ++P < L; ) {
          var z = u[P], U = y ? y(h[z], o[z], z, h, o) : n;
          U === n && (U = o[z]), w ? sr(h, z, U) : ko(h, z, U);
        }
        return h;
      }
      function hC(o, u) {
        return Bi(o, wf(o), u);
      }
      function mC(o, u) {
        return Bi(o, Vv(o), u);
      }
      function yu(o, u) {
        return function(h, y) {
          var w = ze(h) ? b1 : Fk, P = u ? u() : {};
          return w(h, o, Me(y, 2), P);
        };
      }
      function ga(o) {
        return Ke(function(u, h) {
          var y = -1, w = h.length, P = w > 1 ? h[w - 1] : n, L = w > 2 ? h[2] : n;
          for (P = o.length > 3 && typeof P == "function" ? (w--, P) : n, L && xn(h[0], h[1], L) && (P = w < 3 ? n : P, w = 1), u = bt(u); ++y < w; ) {
            var z = h[y];
            z && o(u, z, y, P);
          }
          return u;
        });
      }
      function wv(o, u) {
        return function(h, y) {
          if (h == null)
            return h;
          if (!En(h))
            return o(h, y);
          for (var w = h.length, P = u ? w : -1, L = bt(h); (u ? P-- : ++P < w) && y(L[P], P, L) !== !1; )
            ;
          return h;
        };
      }
      function Sv(o) {
        return function(u, h, y) {
          for (var w = -1, P = bt(u), L = y(u), z = L.length; z--; ) {
            var U = L[o ? z : ++w];
            if (h(P[U], U, P) === !1)
              break;
          }
          return u;
        };
      }
      function gC(o, u, h) {
        var y = u & x, w = Oo(o);
        function P() {
          var L = this && this !== on && this instanceof P ? w : o;
          return L.apply(y ? h : this, arguments);
        }
        return P;
      }
      function kv(o) {
        return function(u) {
          u = ht(u);
          var h = la(u) ? _i(u) : n, y = h ? h[0] : u.charAt(0), w = h ? $r(h, 1).join("") : u.slice(1);
          return y[o]() + w;
        };
      }
      function va(o) {
        return function(u) {
          return Nd(wy(_y(u).replace(s1, "")), o, "");
        };
      }
      function Oo(o) {
        return function() {
          var u = arguments;
          switch (u.length) {
            case 0:
              return new o();
            case 1:
              return new o(u[0]);
            case 2:
              return new o(u[0], u[1]);
            case 3:
              return new o(u[0], u[1], u[2]);
            case 4:
              return new o(u[0], u[1], u[2], u[3]);
            case 5:
              return new o(u[0], u[1], u[2], u[3], u[4]);
            case 6:
              return new o(u[0], u[1], u[2], u[3], u[4], u[5]);
            case 7:
              return new o(u[0], u[1], u[2], u[3], u[4], u[5], u[6]);
          }
          var h = ma(o.prototype), y = o.apply(h, u);
          return Et(y) ? y : h;
        };
      }
      function vC(o, u, h) {
        var y = Oo(o);
        function w() {
          for (var P = arguments.length, L = Y(P), z = P, U = ya(w); z--; )
            L[z] = arguments[z];
          var te = P < 3 && L[0] !== U && L[P - 1] !== U ? [] : Lr(L, U);
          if (P -= te.length, P < h)
            return Ov(
              o,
              u,
              pu,
              w.placeholder,
              n,
              L,
              te,
              n,
              n,
              h - P
            );
          var ne = this && this !== on && this instanceof w ? y : o;
          return $n(ne, this, L);
        }
        return w;
      }
      function Cv(o) {
        return function(u, h, y) {
          var w = bt(u);
          if (!En(u)) {
            var P = Me(h, 3);
            u = en(u), h = function(z) {
              return P(w[z], z, w);
            };
          }
          var L = o(u, h, y);
          return L > -1 ? w[P ? u[L] : L] : n;
        };
      }
      function Tv(o) {
        return or(function(u) {
          var h = u.length, y = h, w = ai.prototype.thru;
          for (o && u.reverse(); y--; ) {
            var P = u[y];
            if (typeof P != "function")
              throw new si(a);
            if (w && !L && wu(P) == "wrapper")
              var L = new ai([], !0);
          }
          for (y = L ? y : h; ++y < h; ) {
            P = u[y];
            var z = wu(P), U = z == "wrapper" ? xf(P) : n;
            U && kf(U[0]) && U[1] == ($ | M | D | A) && !U[4].length && U[9] == 1 ? L = L[wu(U[0])].apply(L, U[3]) : L = P.length == 1 && kf(P) ? L[z]() : L.thru(P);
          }
          return function() {
            var te = arguments, ne = te[0];
            if (L && te.length == 1 && ze(ne))
              return L.plant(ne).value();
            for (var re = 0, ve = h ? u[re].apply(this, te) : ne; ++re < h; )
              ve = u[re].call(this, ve);
            return ve;
          };
        });
      }
      function pu(o, u, h, y, w, P, L, z, U, te) {
        var ne = u & $, re = u & x, ve = u & S, Pe = u & (M | E), De = u & V, Ye = ve ? n : Oo(o);
        function Ve() {
          for (var Qe = arguments.length, st = Y(Qe), Un = Qe; Un--; )
            st[Un] = arguments[Un];
          if (Pe)
            var _n = ya(Ve), qn = P1(st, _n);
          if (y && (st = xv(st, y, w, Pe)), P && (st = _v(st, P, L, Pe)), Qe -= qn, Pe && Qe < te) {
            var Wt = Lr(st, _n);
            return Ov(
              o,
              u,
              pu,
              Ve.placeholder,
              h,
              st,
              Wt,
              z,
              U,
              te - Qe
            );
          }
          var ki = re ? h : this, dr = ve ? ki[o] : o;
          return Qe = st.length, z ? st = FC(st, z) : De && Qe > 1 && st.reverse(), ne && U < Qe && (st.length = U), this && this !== on && this instanceof Ve && (dr = Ye || Oo(dr)), dr.apply(ki, st);
        }
        return Ve;
      }
      function Iv(o, u) {
        return function(h, y) {
          return Uk(h, o, u(y), {});
        };
      }
      function bu(o, u) {
        return function(h, y) {
          var w;
          if (h === n && y === n)
            return u;
          if (h !== n && (w = h), y !== n) {
            if (w === n)
              return y;
            typeof h == "string" || typeof y == "string" ? (h = Hn(h), y = Hn(y)) : (h = fv(h), y = fv(y)), w = o(h, y);
          }
          return w;
        };
      }
      function vf(o) {
        return or(function(u) {
          return u = It(u, zn(Me())), Ke(function(h) {
            var y = this;
            return o(u, function(w) {
              return $n(w, y, h);
            });
          });
        });
      }
      function xu(o, u) {
        u = u === n ? " " : Hn(u);
        var h = u.length;
        if (h < 2)
          return h ? uf(u, o) : u;
        var y = uf(u, au(o / ua(u)));
        return la(u) ? $r(_i(y), 0, o).join("") : y.slice(0, o);
      }
      function yC(o, u, h, y) {
        var w = u & x, P = Oo(o);
        function L() {
          for (var z = -1, U = arguments.length, te = -1, ne = y.length, re = Y(ne + U), ve = this && this !== on && this instanceof L ? P : o; ++te < ne; )
            re[te] = y[te];
          for (; U--; )
            re[te++] = arguments[++z];
          return $n(ve, w ? h : this, re);
        }
        return L;
      }
      function Pv(o) {
        return function(u, h, y) {
          return y && typeof y != "number" && xn(u, h, y) && (h = y = n), u = cr(u), h === n ? (h = u, u = 0) : h = cr(h), y = y === n ? u < h ? 1 : -1 : cr(y), nC(u, h, y, o);
        };
      }
      function _u(o) {
        return function(u, h) {
          return typeof u == "string" && typeof h == "string" || (u = ci(u), h = ci(h)), o(u, h);
        };
      }
      function Ov(o, u, h, y, w, P, L, z, U, te) {
        var ne = u & M, re = ne ? L : n, ve = ne ? n : L, Pe = ne ? P : n, De = ne ? n : P;
        u |= ne ? D : R, u &= ~(ne ? R : D), u & T || (u &= ~(x | S));
        var Ye = [
          o,
          u,
          w,
          Pe,
          re,
          De,
          ve,
          z,
          U,
          te
        ], Ve = h.apply(n, Ye);
        return kf(o) && zv(Ve, Ye), Ve.placeholder = y, Hv(Ve, o, u);
      }
      function yf(o) {
        var u = Kt[o];
        return function(h, y) {
          if (h = ci(h), y = y == null ? 0 : dn(qe(y), 292), y && Hg(h)) {
            var w = (ht(h) + "e").split("e"), P = u(w[0] + "e" + (+w[1] + y));
            return w = (ht(P) + "e").split("e"), +(w[0] + "e" + (+w[1] - y));
          }
          return u(h);
        };
      }
      var pC = fa && 1 / Kl(new fa([, -0]))[1] == _e ? function(o) {
        return new fa(o);
      } : Nf;
      function Ev(o) {
        return function(u) {
          var h = fn(u);
          return h == xt ? jd(u) : h == Tt ? L1(u) : I1(u, o(u));
        };
      }
      function ar(o, u, h, y, w, P, L, z) {
        var U = u & S;
        if (!U && typeof o != "function")
          throw new si(a);
        var te = y ? y.length : 0;
        if (te || (u &= ~(D | R), y = w = n), L = L === n ? L : Xt(qe(L), 0), z = z === n ? z : qe(z), te -= w ? w.length : 0, u & R) {
          var ne = y, re = w;
          y = w = n;
        }
        var ve = U ? n : xf(o), Pe = [
          o,
          u,
          h,
          y,
          w,
          ne,
          re,
          P,
          L,
          z
        ];
        if (ve && DC(Pe, ve), o = Pe[0], u = Pe[1], h = Pe[2], y = Pe[3], w = Pe[4], z = Pe[9] = Pe[9] === n ? U ? 0 : o.length : Xt(Pe[9] - te, 0), !z && u & (M | E) && (u &= ~(M | E)), !u || u == x)
          var De = gC(o, u, h);
        else
          u == M || u == E ? De = vC(o, u, z) : (u == D || u == (x | D)) && !w.length ? De = yC(o, u, h, y) : De = pu.apply(n, Pe);
        var Ye = ve ? cv : zv;
        return Hv(Ye(De, Pe), o, u);
      }
      function Av(o, u, h, y) {
        return o === n || Si(o, da[h]) && !mt.call(y, h) ? u : o;
      }
      function Mv(o, u, h, y, w, P) {
        return Et(o) && Et(u) && (P.set(u, o), mu(o, u, n, Mv, P), P.delete(u)), o;
      }
      function bC(o) {
        return Mo(o) ? n : o;
      }
      function Dv(o, u, h, y, w, P) {
        var L = h & p, z = o.length, U = u.length;
        if (z != U && !(L && U > z))
          return !1;
        var te = P.get(o), ne = P.get(u);
        if (te && ne)
          return te == u && ne == o;
        var re = -1, ve = !0, Pe = h & _ ? new xs() : n;
        for (P.set(o, u), P.set(u, o); ++re < z; ) {
          var De = o[re], Ye = u[re];
          if (y)
            var Ve = L ? y(Ye, De, re, u, o, P) : y(De, Ye, re, o, u, P);
          if (Ve !== n) {
            if (Ve)
              continue;
            ve = !1;
            break;
          }
          if (Pe) {
            if (!$d(u, function(Qe, st) {
              if (!po(Pe, st) && (De === Qe || w(De, Qe, h, y, P)))
                return Pe.push(st);
            })) {
              ve = !1;
              break;
            }
          } else if (!(De === Ye || w(De, Ye, h, y, P))) {
            ve = !1;
            break;
          }
        }
        return P.delete(o), P.delete(u), ve;
      }
      function xC(o, u, h, y, w, P, L) {
        switch (h) {
          case Qi:
            if (o.byteLength != u.byteLength || o.byteOffset != u.byteOffset)
              return !1;
            o = o.buffer, u = u.buffer;
          case Pr:
            return !(o.byteLength != u.byteLength || !P(new nu(o), new nu(u)));
          case Ze:
          case We:
          case sn:
            return Si(+o, +u);
          case Ot:
            return o.name == u.name && o.message == u.message;
          case Li:
          case cs:
            return o == u + "";
          case xt:
            var z = jd;
          case Tt:
            var U = y & p;
            if (z || (z = Kl), o.size != u.size && !U)
              return !1;
            var te = L.get(o);
            if (te)
              return te == u;
            y |= _, L.set(o, u);
            var ne = Dv(z(o), z(u), y, w, P, L);
            return L.delete(o), ne;
          case Ks:
            if (So)
              return So.call(o) == So.call(u);
        }
        return !1;
      }
      function _C(o, u, h, y, w, P) {
        var L = h & p, z = pf(o), U = z.length, te = pf(u), ne = te.length;
        if (U != ne && !L)
          return !1;
        for (var re = U; re--; ) {
          var ve = z[re];
          if (!(L ? ve in u : mt.call(u, ve)))
            return !1;
        }
        var Pe = P.get(o), De = P.get(u);
        if (Pe && De)
          return Pe == u && De == o;
        var Ye = !0;
        P.set(o, u), P.set(u, o);
        for (var Ve = L; ++re < U; ) {
          ve = z[re];
          var Qe = o[ve], st = u[ve];
          if (y)
            var Un = L ? y(st, Qe, ve, u, o, P) : y(Qe, st, ve, o, u, P);
          if (!(Un === n ? Qe === st || w(Qe, st, h, y, P) : Un)) {
            Ye = !1;
            break;
          }
          Ve || (Ve = ve == "constructor");
        }
        if (Ye && !Ve) {
          var _n = o.constructor, qn = u.constructor;
          _n != qn && "constructor" in o && "constructor" in u && !(typeof _n == "function" && _n instanceof _n && typeof qn == "function" && qn instanceof qn) && (Ye = !1);
        }
        return P.delete(o), P.delete(u), Ye;
      }
      function or(o) {
        return Tf(Nv(o, n, Yv), o + "");
      }
      function pf(o) {
        return Qg(o, en, wf);
      }
      function bf(o) {
        return Qg(o, An, Vv);
      }
      var xf = lu ? function(o) {
        return lu.get(o);
      } : Nf;
      function wu(o) {
        for (var u = o.name + "", h = ha[u], y = mt.call(ha, u) ? h.length : 0; y--; ) {
          var w = h[y], P = w.func;
          if (P == null || P == o)
            return w.name;
        }
        return u;
      }
      function ya(o) {
        var u = mt.call(C, "placeholder") ? C : o;
        return u.placeholder;
      }
      function Me() {
        var o = C.iteratee || Rf;
        return o = o === Rf ? nv : o, arguments.length ? o(arguments[0], arguments[1]) : o;
      }
      function Su(o, u) {
        var h = o.__data__;
        return OC(u) ? h[typeof u == "string" ? "string" : "hash"] : h.map;
      }
      function _f(o) {
        for (var u = en(o), h = u.length; h--; ) {
          var y = u[h], w = o[y];
          u[h] = [y, w, Rv(w)];
        }
        return u;
      }
      function Ss(o, u) {
        var h = M1(o, u);
        return tv(h) ? h : n;
      }
      function wC(o) {
        var u = mt.call(o, ps), h = o[ps];
        try {
          o[ps] = n;
          var y = !0;
        } catch {
        }
        var w = eu.call(o);
        return y && (u ? o[ps] = h : delete o[ps]), w;
      }
      var wf = Yd ? function(o) {
        return o == null ? [] : (o = bt(o), Dr(Yd(o), function(u) {
          return $g.call(o, u);
        }));
      } : $f, Vv = Yd ? function(o) {
        for (var u = []; o; )
          Vr(u, wf(o)), o = iu(o);
        return u;
      } : $f, fn = bn;
      (Zd && fn(new Zd(new ArrayBuffer(1))) != Qi || xo && fn(new xo()) != xt || Kd && fn(Kd.resolve()) != eo || fa && fn(new fa()) != Tt || _o && fn(new _o()) != ds) && (fn = function(o) {
        var u = bn(o), h = u == an ? o.constructor : n, y = h ? ks(h) : "";
        if (y)
          switch (y) {
            case rk:
              return Qi;
            case sk:
              return xt;
            case ak:
              return eo;
            case ok:
              return Tt;
            case lk:
              return ds;
          }
        return u;
      });
      function SC(o, u, h) {
        for (var y = -1, w = h.length; ++y < w; ) {
          var P = h[y], L = P.size;
          switch (P.type) {
            case "drop":
              o += L;
              break;
            case "dropRight":
              u -= L;
              break;
            case "take":
              u = dn(u, o + L);
              break;
            case "takeRight":
              o = Xt(o, u - L);
              break;
          }
        }
        return { start: o, end: u };
      }
      function kC(o) {
        var u = o.match(Ed);
        return u ? u[1].split(zl) : [];
      }
      function Lv(o, u, h) {
        u = Nr(u, o);
        for (var y = -1, w = u.length, P = !1; ++y < w; ) {
          var L = Ni(u[y]);
          if (!(P = o != null && h(o, L)))
            break;
          o = o[L];
        }
        return P || ++y != w ? P : (w = o == null ? 0 : o.length, !!w && Eu(w) && lr(L, w) && (ze(o) || Cs(o)));
      }
      function CC(o) {
        var u = o.length, h = new o.constructor(u);
        return u && typeof o[0] == "string" && mt.call(o, "index") && (h.index = o.index, h.input = o.input), h;
      }
      function Fv(o) {
        return typeof o.constructor == "function" && !Eo(o) ? ma(iu(o)) : {};
      }
      function TC(o, u, h) {
        var y = o.constructor;
        switch (u) {
          case Pr:
            return gf(o);
          case Ze:
          case We:
            return new y(+o);
          case Qi:
            return uC(o, h);
          case Xs:
          case Js:
          case Or:
          case fs:
          case to:
          case no:
          case io:
          case ro:
          case so:
            return pv(o, h);
          case xt:
            return new y();
          case sn:
          case cs:
            return new y(o);
          case Li:
            return cC(o);
          case Tt:
            return new y();
          case Ks:
            return dC(o);
        }
      }
      function IC(o, u) {
        var h = u.length;
        if (!h)
          return o;
        var y = h - 1;
        return u[y] = (h > 1 ? "& " : "") + u[y], u = u.join(h > 2 ? ", " : " "), o.replace(fo, `{
/* [wrapped with ` + u + `] */
`);
      }
      function PC(o) {
        return ze(o) || Cs(o) || !!(zg && o && o[zg]);
      }
      function lr(o, u) {
        var h = typeof o;
        return u = u ?? be, !!u && (h == "number" || h != "symbol" && ea.test(o)) && o > -1 && o % 1 == 0 && o < u;
      }
      function xn(o, u, h) {
        if (!Et(h))
          return !1;
        var y = typeof u;
        return (y == "number" ? En(h) && lr(u, h.length) : y == "string" && u in h) ? Si(h[u], o) : !1;
      }
      function Sf(o, u) {
        if (ze(o))
          return !1;
        var h = typeof o;
        return h == "number" || h == "symbol" || h == "boolean" || o == null || Wn(o) ? !0 : Id.test(o) || !Td.test(o) || u != null && o in bt(u);
      }
      function OC(o) {
        var u = typeof o;
        return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? o !== "__proto__" : o === null;
      }
      function kf(o) {
        var u = wu(o), h = C[u];
        if (typeof h != "function" || !(u in tt.prototype))
          return !1;
        if (o === h)
          return !0;
        var y = xf(h);
        return !!y && o === y[0];
      }
      function EC(o) {
        return !!Rg && Rg in o;
      }
      var AC = Jl ? ur : zf;
      function Eo(o) {
        var u = o && o.constructor, h = typeof u == "function" && u.prototype || da;
        return o === h;
      }
      function Rv(o) {
        return o === o && !Et(o);
      }
      function Bv(o, u) {
        return function(h) {
          return h == null ? !1 : h[o] === u && (u !== n || o in bt(h));
        };
      }
      function MC(o) {
        var u = Pu(o, function(y) {
          return h.size === d && h.clear(), y;
        }), h = u.cache;
        return u;
      }
      function DC(o, u) {
        var h = o[1], y = u[1], w = h | y, P = w < (x | S | $), L = y == $ && h == M || y == $ && h == A && o[7].length <= u[8] || y == ($ | A) && u[7].length <= u[8] && h == M;
        if (!(P || L))
          return o;
        y & x && (o[2] = u[2], w |= h & x ? 0 : T);
        var z = u[3];
        if (z) {
          var U = o[3];
          o[3] = U ? xv(U, z, u[4]) : z, o[4] = U ? Lr(o[3], f) : u[4];
        }
        return z = u[5], z && (U = o[5], o[5] = U ? _v(U, z, u[6]) : z, o[6] = U ? Lr(o[5], f) : u[6]), z = u[7], z && (o[7] = z), y & $ && (o[8] = o[8] == null ? u[8] : dn(o[8], u[8])), o[9] == null && (o[9] = u[9]), o[0] = u[0], o[1] = w, o;
      }
      function VC(o) {
        var u = [];
        if (o != null)
          for (var h in bt(o))
            u.push(h);
        return u;
      }
      function LC(o) {
        return eu.call(o);
      }
      function Nv(o, u, h) {
        return u = Xt(u === n ? o.length - 1 : u, 0), function() {
          for (var y = arguments, w = -1, P = Xt(y.length - u, 0), L = Y(P); ++w < P; )
            L[w] = y[u + w];
          w = -1;
          for (var z = Y(u + 1); ++w < u; )
            z[w] = y[w];
          return z[u] = h(L), $n(o, this, z);
        };
      }
      function $v(o, u) {
        return u.length < 2 ? o : ws(o, li(u, 0, -1));
      }
      function FC(o, u) {
        for (var h = o.length, y = dn(u.length, h), w = On(o); y--; ) {
          var P = u[y];
          o[y] = lr(P, h) ? w[P] : n;
        }
        return o;
      }
      function Cf(o, u) {
        if (!(u === "constructor" && typeof o[u] == "function") && u != "__proto__")
          return o[u];
      }
      var zv = Wv(cv), Ao = X1 || function(o, u) {
        return on.setTimeout(o, u);
      }, Tf = Wv(sC);
      function Hv(o, u, h) {
        var y = u + "";
        return Tf(o, IC(y, RC(kC(y), h)));
      }
      function Wv(o) {
        var u = 0, h = 0;
        return function() {
          var y = tk(), w = q - (y - h);
          if (h = y, w > 0) {
            if (++u >= N)
              return arguments[0];
          } else
            u = 0;
          return o.apply(n, arguments);
        };
      }
      function ku(o, u) {
        var h = -1, y = o.length, w = y - 1;
        for (u = u === n ? y : u; ++h < u; ) {
          var P = lf(h, w), L = o[P];
          o[P] = o[h], o[h] = L;
        }
        return o.length = u, o;
      }
      var Uv = MC(function(o) {
        var u = [];
        return o.charCodeAt(0) === 46 && u.push(""), o.replace(Pd, function(h, y, w, P) {
          u.push(w ? P.replace(Wl, "$1") : y || h);
        }), u;
      });
      function Ni(o) {
        if (typeof o == "string" || Wn(o))
          return o;
        var u = o + "";
        return u == "0" && 1 / o == -_e ? "-0" : u;
      }
      function ks(o) {
        if (o != null) {
          try {
            return Ql.call(o);
          } catch {
          }
          try {
            return o + "";
          } catch {
          }
        }
        return "";
      }
      function RC(o, u) {
        return ri(he, function(h) {
          var y = "_." + h[0];
          u & h[1] && !Yl(o, y) && o.push(y);
        }), o.sort();
      }
      function qv(o) {
        if (o instanceof tt)
          return o.clone();
        var u = new ai(o.__wrapped__, o.__chain__);
        return u.__actions__ = On(o.__actions__), u.__index__ = o.__index__, u.__values__ = o.__values__, u;
      }
      function BC(o, u, h) {
        (h ? xn(o, u, h) : u === n) ? u = 1 : u = Xt(qe(u), 0);
        var y = o == null ? 0 : o.length;
        if (!y || u < 1)
          return [];
        for (var w = 0, P = 0, L = Y(au(y / u)); w < y; )
          L[P++] = li(o, w, w += u);
        return L;
      }
      function NC(o) {
        for (var u = -1, h = o == null ? 0 : o.length, y = 0, w = []; ++u < h; ) {
          var P = o[u];
          P && (w[y++] = P);
        }
        return w;
      }
      function $C() {
        var o = arguments.length;
        if (!o)
          return [];
        for (var u = Y(o - 1), h = arguments[0], y = o; y--; )
          u[y - 1] = arguments[y];
        return Vr(ze(h) ? On(h) : [h], ln(u, 1));
      }
      var zC = Ke(function(o, u) {
        return Ht(o) ? Co(o, ln(u, 1, Ht, !0)) : [];
      }), HC = Ke(function(o, u) {
        var h = ui(u);
        return Ht(h) && (h = n), Ht(o) ? Co(o, ln(u, 1, Ht, !0), Me(h, 2)) : [];
      }), WC = Ke(function(o, u) {
        var h = ui(u);
        return Ht(h) && (h = n), Ht(o) ? Co(o, ln(u, 1, Ht, !0), n, h) : [];
      });
      function UC(o, u, h) {
        var y = o == null ? 0 : o.length;
        return y ? (u = h || u === n ? 1 : qe(u), li(o, u < 0 ? 0 : u, y)) : [];
      }
      function qC(o, u, h) {
        var y = o == null ? 0 : o.length;
        return y ? (u = h || u === n ? 1 : qe(u), u = y - u, li(o, 0, u < 0 ? 0 : u)) : [];
      }
      function jC(o, u) {
        return o && o.length ? vu(o, Me(u, 3), !0, !0) : [];
      }
      function GC(o, u) {
        return o && o.length ? vu(o, Me(u, 3), !0) : [];
      }
      function YC(o, u, h, y) {
        var w = o == null ? 0 : o.length;
        return w ? (h && typeof h != "number" && xn(o, u, h) && (h = 0, y = w), $k(o, u, h, y)) : [];
      }
      function jv(o, u, h) {
        var y = o == null ? 0 : o.length;
        if (!y)
          return -1;
        var w = h == null ? 0 : qe(h);
        return w < 0 && (w = Xt(y + w, 0)), Zl(o, Me(u, 3), w);
      }
      function Gv(o, u, h) {
        var y = o == null ? 0 : o.length;
        if (!y)
          return -1;
        var w = y - 1;
        return h !== n && (w = qe(h), w = h < 0 ? Xt(y + w, 0) : dn(w, y - 1)), Zl(o, Me(u, 3), w, !0);
      }
      function Yv(o) {
        var u = o == null ? 0 : o.length;
        return u ? ln(o, 1) : [];
      }
      function ZC(o) {
        var u = o == null ? 0 : o.length;
        return u ? ln(o, _e) : [];
      }
      function KC(o, u) {
        var h = o == null ? 0 : o.length;
        return h ? (u = u === n ? 1 : qe(u), ln(o, u)) : [];
      }
      function XC(o) {
        for (var u = -1, h = o == null ? 0 : o.length, y = {}; ++u < h; ) {
          var w = o[u];
          y[w[0]] = w[1];
        }
        return y;
      }
      function Zv(o) {
        return o && o.length ? o[0] : n;
      }
      function JC(o, u, h) {
        var y = o == null ? 0 : o.length;
        if (!y)
          return -1;
        var w = h == null ? 0 : qe(h);
        return w < 0 && (w = Xt(y + w, 0)), oa(o, u, w);
      }
      function QC(o) {
        var u = o == null ? 0 : o.length;
        return u ? li(o, 0, -1) : [];
      }
      var eT = Ke(function(o) {
        var u = It(o, hf);
        return u.length && u[0] === o[0] ? nf(u) : [];
      }), tT = Ke(function(o) {
        var u = ui(o), h = It(o, hf);
        return u === ui(h) ? u = n : h.pop(), h.length && h[0] === o[0] ? nf(h, Me(u, 2)) : [];
      }), nT = Ke(function(o) {
        var u = ui(o), h = It(o, hf);
        return u = typeof u == "function" ? u : n, u && h.pop(), h.length && h[0] === o[0] ? nf(h, n, u) : [];
      });
      function iT(o, u) {
        return o == null ? "" : Q1.call(o, u);
      }
      function ui(o) {
        var u = o == null ? 0 : o.length;
        return u ? o[u - 1] : n;
      }
      function rT(o, u, h) {
        var y = o == null ? 0 : o.length;
        if (!y)
          return -1;
        var w = y;
        return h !== n && (w = qe(h), w = w < 0 ? Xt(y + w, 0) : dn(w, y - 1)), u === u ? R1(o, u, w) : Zl(o, Og, w, !0);
      }
      function sT(o, u) {
        return o && o.length ? av(o, qe(u)) : n;
      }
      var aT = Ke(Kv);
      function Kv(o, u) {
        return o && o.length && u && u.length ? of(o, u) : o;
      }
      function oT(o, u, h) {
        return o && o.length && u && u.length ? of(o, u, Me(h, 2)) : o;
      }
      function lT(o, u, h) {
        return o && o.length && u && u.length ? of(o, u, n, h) : o;
      }
      var uT = or(function(o, u) {
        var h = o == null ? 0 : o.length, y = Jd(o, u);
        return uv(o, It(u, function(w) {
          return lr(w, h) ? +w : w;
        }).sort(bv)), y;
      });
      function cT(o, u) {
        var h = [];
        if (!(o && o.length))
          return h;
        var y = -1, w = [], P = o.length;
        for (u = Me(u, 3); ++y < P; ) {
          var L = o[y];
          u(L, y, o) && (h.push(L), w.push(y));
        }
        return uv(o, w), h;
      }
      function If(o) {
        return o == null ? o : ik.call(o);
      }
      function dT(o, u, h) {
        var y = o == null ? 0 : o.length;
        return y ? (h && typeof h != "number" && xn(o, u, h) ? (u = 0, h = y) : (u = u == null ? 0 : qe(u), h = h === n ? y : qe(h)), li(o, u, h)) : [];
      }
      function fT(o, u) {
        return gu(o, u);
      }
      function hT(o, u, h) {
        return cf(o, u, Me(h, 2));
      }
      function mT(o, u) {
        var h = o == null ? 0 : o.length;
        if (h) {
          var y = gu(o, u);
          if (y < h && Si(o[y], u))
            return y;
        }
        return -1;
      }
      function gT(o, u) {
        return gu(o, u, !0);
      }
      function vT(o, u, h) {
        return cf(o, u, Me(h, 2), !0);
      }
      function yT(o, u) {
        var h = o == null ? 0 : o.length;
        if (h) {
          var y = gu(o, u, !0) - 1;
          if (Si(o[y], u))
            return y;
        }
        return -1;
      }
      function pT(o) {
        return o && o.length ? dv(o) : [];
      }
      function bT(o, u) {
        return o && o.length ? dv(o, Me(u, 2)) : [];
      }
      function xT(o) {
        var u = o == null ? 0 : o.length;
        return u ? li(o, 1, u) : [];
      }
      function _T(o, u, h) {
        return o && o.length ? (u = h || u === n ? 1 : qe(u), li(o, 0, u < 0 ? 0 : u)) : [];
      }
      function wT(o, u, h) {
        var y = o == null ? 0 : o.length;
        return y ? (u = h || u === n ? 1 : qe(u), u = y - u, li(o, u < 0 ? 0 : u, y)) : [];
      }
      function ST(o, u) {
        return o && o.length ? vu(o, Me(u, 3), !1, !0) : [];
      }
      function kT(o, u) {
        return o && o.length ? vu(o, Me(u, 3)) : [];
      }
      var CT = Ke(function(o) {
        return Br(ln(o, 1, Ht, !0));
      }), TT = Ke(function(o) {
        var u = ui(o);
        return Ht(u) && (u = n), Br(ln(o, 1, Ht, !0), Me(u, 2));
      }), IT = Ke(function(o) {
        var u = ui(o);
        return u = typeof u == "function" ? u : n, Br(ln(o, 1, Ht, !0), n, u);
      });
      function PT(o) {
        return o && o.length ? Br(o) : [];
      }
      function OT(o, u) {
        return o && o.length ? Br(o, Me(u, 2)) : [];
      }
      function ET(o, u) {
        return u = typeof u == "function" ? u : n, o && o.length ? Br(o, n, u) : [];
      }
      function Pf(o) {
        if (!(o && o.length))
          return [];
        var u = 0;
        return o = Dr(o, function(h) {
          if (Ht(h))
            return u = Xt(h.length, u), !0;
        }), Ud(u, function(h) {
          return It(o, zd(h));
        });
      }
      function Xv(o, u) {
        if (!(o && o.length))
          return [];
        var h = Pf(o);
        return u == null ? h : It(h, function(y) {
          return $n(u, n, y);
        });
      }
      var AT = Ke(function(o, u) {
        return Ht(o) ? Co(o, u) : [];
      }), MT = Ke(function(o) {
        return ff(Dr(o, Ht));
      }), DT = Ke(function(o) {
        var u = ui(o);
        return Ht(u) && (u = n), ff(Dr(o, Ht), Me(u, 2));
      }), VT = Ke(function(o) {
        var u = ui(o);
        return u = typeof u == "function" ? u : n, ff(Dr(o, Ht), n, u);
      }), LT = Ke(Pf);
      function FT(o, u) {
        return gv(o || [], u || [], ko);
      }
      function RT(o, u) {
        return gv(o || [], u || [], Po);
      }
      var BT = Ke(function(o) {
        var u = o.length, h = u > 1 ? o[u - 1] : n;
        return h = typeof h == "function" ? (o.pop(), h) : n, Xv(o, h);
      });
      function Jv(o) {
        var u = C(o);
        return u.__chain__ = !0, u;
      }
      function NT(o, u) {
        return u(o), o;
      }
      function Cu(o, u) {
        return u(o);
      }
      var $T = or(function(o) {
        var u = o.length, h = u ? o[0] : 0, y = this.__wrapped__, w = function(P) {
          return Jd(P, o);
        };
        return u > 1 || this.__actions__.length || !(y instanceof tt) || !lr(h) ? this.thru(w) : (y = y.slice(h, +h + (u ? 1 : 0)), y.__actions__.push({
          func: Cu,
          args: [w],
          thisArg: n
        }), new ai(y, this.__chain__).thru(function(P) {
          return u && !P.length && P.push(n), P;
        }));
      });
      function zT() {
        return Jv(this);
      }
      function HT() {
        return new ai(this.value(), this.__chain__);
      }
      function WT() {
        this.__values__ === n && (this.__values__ = fy(this.value()));
        var o = this.__index__ >= this.__values__.length, u = o ? n : this.__values__[this.__index__++];
        return { done: o, value: u };
      }
      function UT() {
        return this;
      }
      function qT(o) {
        for (var u, h = this; h instanceof cu; ) {
          var y = qv(h);
          y.__index__ = 0, y.__values__ = n, u ? w.__wrapped__ = y : u = y;
          var w = y;
          h = h.__wrapped__;
        }
        return w.__wrapped__ = o, u;
      }
      function jT() {
        var o = this.__wrapped__;
        if (o instanceof tt) {
          var u = o;
          return this.__actions__.length && (u = new tt(this)), u = u.reverse(), u.__actions__.push({
            func: Cu,
            args: [If],
            thisArg: n
          }), new ai(u, this.__chain__);
        }
        return this.thru(If);
      }
      function GT() {
        return mv(this.__wrapped__, this.__actions__);
      }
      var YT = yu(function(o, u, h) {
        mt.call(o, h) ? ++o[h] : sr(o, h, 1);
      });
      function ZT(o, u, h) {
        var y = ze(o) ? Ig : Nk;
        return h && xn(o, u, h) && (u = n), y(o, Me(u, 3));
      }
      function KT(o, u) {
        var h = ze(o) ? Dr : Xg;
        return h(o, Me(u, 3));
      }
      var XT = Cv(jv), JT = Cv(Gv);
      function QT(o, u) {
        return ln(Tu(o, u), 1);
      }
      function eI(o, u) {
        return ln(Tu(o, u), _e);
      }
      function tI(o, u, h) {
        return h = h === n ? 1 : qe(h), ln(Tu(o, u), h);
      }
      function Qv(o, u) {
        var h = ze(o) ? ri : Rr;
        return h(o, Me(u, 3));
      }
      function ey(o, u) {
        var h = ze(o) ? x1 : Kg;
        return h(o, Me(u, 3));
      }
      var nI = yu(function(o, u, h) {
        mt.call(o, h) ? o[h].push(u) : sr(o, h, [u]);
      });
      function iI(o, u, h, y) {
        o = En(o) ? o : ba(o), h = h && !y ? qe(h) : 0;
        var w = o.length;
        return h < 0 && (h = Xt(w + h, 0)), Au(o) ? h <= w && o.indexOf(u, h) > -1 : !!w && oa(o, u, h) > -1;
      }
      var rI = Ke(function(o, u, h) {
        var y = -1, w = typeof u == "function", P = En(o) ? Y(o.length) : [];
        return Rr(o, function(L) {
          P[++y] = w ? $n(u, L, h) : To(L, u, h);
        }), P;
      }), sI = yu(function(o, u, h) {
        sr(o, h, u);
      });
      function Tu(o, u) {
        var h = ze(o) ? It : iv;
        return h(o, Me(u, 3));
      }
      function aI(o, u, h, y) {
        return o == null ? [] : (ze(u) || (u = u == null ? [] : [u]), h = y ? n : h, ze(h) || (h = h == null ? [] : [h]), ov(o, u, h));
      }
      var oI = yu(function(o, u, h) {
        o[h ? 0 : 1].push(u);
      }, function() {
        return [[], []];
      });
      function lI(o, u, h) {
        var y = ze(o) ? Nd : Ag, w = arguments.length < 3;
        return y(o, Me(u, 4), h, w, Rr);
      }
      function uI(o, u, h) {
        var y = ze(o) ? _1 : Ag, w = arguments.length < 3;
        return y(o, Me(u, 4), h, w, Kg);
      }
      function cI(o, u) {
        var h = ze(o) ? Dr : Xg;
        return h(o, Ou(Me(u, 3)));
      }
      function dI(o) {
        var u = ze(o) ? jg : iC;
        return u(o);
      }
      function fI(o, u, h) {
        (h ? xn(o, u, h) : u === n) ? u = 1 : u = qe(u);
        var y = ze(o) ? Vk : rC;
        return y(o, u);
      }
      function hI(o) {
        var u = ze(o) ? Lk : aC;
        return u(o);
      }
      function mI(o) {
        if (o == null)
          return 0;
        if (En(o))
          return Au(o) ? ua(o) : o.length;
        var u = fn(o);
        return u == xt || u == Tt ? o.size : sf(o).length;
      }
      function gI(o, u, h) {
        var y = ze(o) ? $d : oC;
        return h && xn(o, u, h) && (u = n), y(o, Me(u, 3));
      }
      var vI = Ke(function(o, u) {
        if (o == null)
          return [];
        var h = u.length;
        return h > 1 && xn(o, u[0], u[1]) ? u = [] : h > 2 && xn(u[0], u[1], u[2]) && (u = [u[0]]), ov(o, ln(u, 1), []);
      }), Iu = K1 || function() {
        return on.Date.now();
      };
      function yI(o, u) {
        if (typeof u != "function")
          throw new si(a);
        return o = qe(o), function() {
          if (--o < 1)
            return u.apply(this, arguments);
        };
      }
      function ty(o, u, h) {
        return u = h ? n : u, u = o && u == null ? o.length : u, ar(o, $, n, n, n, n, u);
      }
      function ny(o, u) {
        var h;
        if (typeof u != "function")
          throw new si(a);
        return o = qe(o), function() {
          return --o > 0 && (h = u.apply(this, arguments)), o <= 1 && (u = n), h;
        };
      }
      var Of = Ke(function(o, u, h) {
        var y = x;
        if (h.length) {
          var w = Lr(h, ya(Of));
          y |= D;
        }
        return ar(o, y, u, h, w);
      }), iy = Ke(function(o, u, h) {
        var y = x | S;
        if (h.length) {
          var w = Lr(h, ya(iy));
          y |= D;
        }
        return ar(u, y, o, h, w);
      });
      function ry(o, u, h) {
        u = h ? n : u;
        var y = ar(o, M, n, n, n, n, n, u);
        return y.placeholder = ry.placeholder, y;
      }
      function sy(o, u, h) {
        u = h ? n : u;
        var y = ar(o, E, n, n, n, n, n, u);
        return y.placeholder = sy.placeholder, y;
      }
      function ay(o, u, h) {
        var y, w, P, L, z, U, te = 0, ne = !1, re = !1, ve = !0;
        if (typeof o != "function")
          throw new si(a);
        u = ci(u) || 0, Et(h) && (ne = !!h.leading, re = "maxWait" in h, P = re ? Xt(ci(h.maxWait) || 0, u) : P, ve = "trailing" in h ? !!h.trailing : ve);
        function Pe(Wt) {
          var ki = y, dr = w;
          return y = w = n, te = Wt, L = o.apply(dr, ki), L;
        }
        function De(Wt) {
          return te = Wt, z = Ao(Qe, u), ne ? Pe(Wt) : L;
        }
        function Ye(Wt) {
          var ki = Wt - U, dr = Wt - te, Cy = u - ki;
          return re ? dn(Cy, P - dr) : Cy;
        }
        function Ve(Wt) {
          var ki = Wt - U, dr = Wt - te;
          return U === n || ki >= u || ki < 0 || re && dr >= P;
        }
        function Qe() {
          var Wt = Iu();
          if (Ve(Wt))
            return st(Wt);
          z = Ao(Qe, Ye(Wt));
        }
        function st(Wt) {
          return z = n, ve && y ? Pe(Wt) : (y = w = n, L);
        }
        function Un() {
          z !== n && vv(z), te = 0, y = U = w = z = n;
        }
        function _n() {
          return z === n ? L : st(Iu());
        }
        function qn() {
          var Wt = Iu(), ki = Ve(Wt);
          if (y = arguments, w = this, U = Wt, ki) {
            if (z === n)
              return De(U);
            if (re)
              return vv(z), z = Ao(Qe, u), Pe(U);
          }
          return z === n && (z = Ao(Qe, u)), L;
        }
        return qn.cancel = Un, qn.flush = _n, qn;
      }
      var pI = Ke(function(o, u) {
        return Zg(o, 1, u);
      }), bI = Ke(function(o, u, h) {
        return Zg(o, ci(u) || 0, h);
      });
      function xI(o) {
        return ar(o, V);
      }
      function Pu(o, u) {
        if (typeof o != "function" || u != null && typeof u != "function")
          throw new si(a);
        var h = function() {
          var y = arguments, w = u ? u.apply(this, y) : y[0], P = h.cache;
          if (P.has(w))
            return P.get(w);
          var L = o.apply(this, y);
          return h.cache = P.set(w, L) || P, L;
        };
        return h.cache = new (Pu.Cache || rr)(), h;
      }
      Pu.Cache = rr;
      function Ou(o) {
        if (typeof o != "function")
          throw new si(a);
        return function() {
          var u = arguments;
          switch (u.length) {
            case 0:
              return !o.call(this);
            case 1:
              return !o.call(this, u[0]);
            case 2:
              return !o.call(this, u[0], u[1]);
            case 3:
              return !o.call(this, u[0], u[1], u[2]);
          }
          return !o.apply(this, u);
        };
      }
      function _I(o) {
        return ny(2, o);
      }
      var wI = lC(function(o, u) {
        u = u.length == 1 && ze(u[0]) ? It(u[0], zn(Me())) : It(ln(u, 1), zn(Me()));
        var h = u.length;
        return Ke(function(y) {
          for (var w = -1, P = dn(y.length, h); ++w < P; )
            y[w] = u[w].call(this, y[w]);
          return $n(o, this, y);
        });
      }), Ef = Ke(function(o, u) {
        var h = Lr(u, ya(Ef));
        return ar(o, D, n, u, h);
      }), oy = Ke(function(o, u) {
        var h = Lr(u, ya(oy));
        return ar(o, R, n, u, h);
      }), SI = or(function(o, u) {
        return ar(o, A, n, n, n, u);
      });
      function kI(o, u) {
        if (typeof o != "function")
          throw new si(a);
        return u = u === n ? u : qe(u), Ke(o, u);
      }
      function CI(o, u) {
        if (typeof o != "function")
          throw new si(a);
        return u = u == null ? 0 : Xt(qe(u), 0), Ke(function(h) {
          var y = h[u], w = $r(h, 0, u);
          return y && Vr(w, y), $n(o, this, w);
        });
      }
      function TI(o, u, h) {
        var y = !0, w = !0;
        if (typeof o != "function")
          throw new si(a);
        return Et(h) && (y = "leading" in h ? !!h.leading : y, w = "trailing" in h ? !!h.trailing : w), ay(o, u, {
          leading: y,
          maxWait: u,
          trailing: w
        });
      }
      function II(o) {
        return ty(o, 1);
      }
      function PI(o, u) {
        return Ef(mf(u), o);
      }
      function OI() {
        if (!arguments.length)
          return [];
        var o = arguments[0];
        return ze(o) ? o : [o];
      }
      function EI(o) {
        return oi(o, v);
      }
      function AI(o, u) {
        return u = typeof u == "function" ? u : n, oi(o, v, u);
      }
      function MI(o) {
        return oi(o, m | v);
      }
      function DI(o, u) {
        return u = typeof u == "function" ? u : n, oi(o, m | v, u);
      }
      function VI(o, u) {
        return u == null || Yg(o, u, en(u));
      }
      function Si(o, u) {
        return o === u || o !== o && u !== u;
      }
      var LI = _u(tf), FI = _u(function(o, u) {
        return o >= u;
      }), Cs = ev(/* @__PURE__ */ function() {
        return arguments;
      }()) ? ev : function(o) {
        return Lt(o) && mt.call(o, "callee") && !$g.call(o, "callee");
      }, ze = Y.isArray, RI = _g ? zn(_g) : qk;
      function En(o) {
        return o != null && Eu(o.length) && !ur(o);
      }
      function Ht(o) {
        return Lt(o) && En(o);
      }
      function BI(o) {
        return o === !0 || o === !1 || Lt(o) && bn(o) == Ze;
      }
      var zr = J1 || zf, NI = wg ? zn(wg) : jk;
      function $I(o) {
        return Lt(o) && o.nodeType === 1 && !Mo(o);
      }
      function zI(o) {
        if (o == null)
          return !0;
        if (En(o) && (ze(o) || typeof o == "string" || typeof o.splice == "function" || zr(o) || pa(o) || Cs(o)))
          return !o.length;
        var u = fn(o);
        if (u == xt || u == Tt)
          return !o.size;
        if (Eo(o))
          return !sf(o).length;
        for (var h in o)
          if (mt.call(o, h))
            return !1;
        return !0;
      }
      function HI(o, u) {
        return Io(o, u);
      }
      function WI(o, u, h) {
        h = typeof h == "function" ? h : n;
        var y = h ? h(o, u) : n;
        return y === n ? Io(o, u, n, h) : !!y;
      }
      function Af(o) {
        if (!Lt(o))
          return !1;
        var u = bn(o);
        return u == Ot || u == Ue || typeof o.message == "string" && typeof o.name == "string" && !Mo(o);
      }
      function UI(o) {
        return typeof o == "number" && Hg(o);
      }
      function ur(o) {
        if (!Et(o))
          return !1;
        var u = bn(o);
        return u == ft || u == yn || u == me || u == Nl;
      }
      function ly(o) {
        return typeof o == "number" && o == qe(o);
      }
      function Eu(o) {
        return typeof o == "number" && o > -1 && o % 1 == 0 && o <= be;
      }
      function Et(o) {
        var u = typeof o;
        return o != null && (u == "object" || u == "function");
      }
      function Lt(o) {
        return o != null && typeof o == "object";
      }
      var uy = Sg ? zn(Sg) : Yk;
      function qI(o, u) {
        return o === u || rf(o, u, _f(u));
      }
      function jI(o, u, h) {
        return h = typeof h == "function" ? h : n, rf(o, u, _f(u), h);
      }
      function GI(o) {
        return cy(o) && o != +o;
      }
      function YI(o) {
        if (AC(o))
          throw new Be(s);
        return tv(o);
      }
      function ZI(o) {
        return o === null;
      }
      function KI(o) {
        return o == null;
      }
      function cy(o) {
        return typeof o == "number" || Lt(o) && bn(o) == sn;
      }
      function Mo(o) {
        if (!Lt(o) || bn(o) != an)
          return !1;
        var u = iu(o);
        if (u === null)
          return !0;
        var h = mt.call(u, "constructor") && u.constructor;
        return typeof h == "function" && h instanceof h && Ql.call(h) == j1;
      }
      var Mf = kg ? zn(kg) : Zk;
      function XI(o) {
        return ly(o) && o >= -be && o <= be;
      }
      var dy = Cg ? zn(Cg) : Kk;
      function Au(o) {
        return typeof o == "string" || !ze(o) && Lt(o) && bn(o) == cs;
      }
      function Wn(o) {
        return typeof o == "symbol" || Lt(o) && bn(o) == Ks;
      }
      var pa = Tg ? zn(Tg) : Xk;
      function JI(o) {
        return o === n;
      }
      function QI(o) {
        return Lt(o) && fn(o) == ds;
      }
      function eP(o) {
        return Lt(o) && bn(o) == xd;
      }
      var tP = _u(af), nP = _u(function(o, u) {
        return o <= u;
      });
      function fy(o) {
        if (!o)
          return [];
        if (En(o))
          return Au(o) ? _i(o) : On(o);
        if (bo && o[bo])
          return V1(o[bo]());
        var u = fn(o), h = u == xt ? jd : u == Tt ? Kl : ba;
        return h(o);
      }
      function cr(o) {
        if (!o)
          return o === 0 ? o : 0;
        if (o = ci(o), o === _e || o === -_e) {
          var u = o < 0 ? -1 : 1;
          return u * oe;
        }
        return o === o ? o : 0;
      }
      function qe(o) {
        var u = cr(o), h = u % 1;
        return u === u ? h ? u - h : u : 0;
      }
      function hy(o) {
        return o ? _s(qe(o), 0, G) : 0;
      }
      function ci(o) {
        if (typeof o == "number")
          return o;
        if (Wn(o))
          return J;
        if (Et(o)) {
          var u = typeof o.valueOf == "function" ? o.valueOf() : o;
          o = Et(u) ? u + "" : u;
        }
        if (typeof o != "string")
          return o === 0 ? o : +o;
        o = Mg(o);
        var h = er.test(o);
        return h || ms.test(o) ? y1(o.slice(2), h ? 2 : 8) : mo.test(o) ? J : +o;
      }
      function my(o) {
        return Bi(o, An(o));
      }
      function iP(o) {
        return o ? _s(qe(o), -be, be) : o === 0 ? o : 0;
      }
      function ht(o) {
        return o == null ? "" : Hn(o);
      }
      var rP = ga(function(o, u) {
        if (Eo(u) || En(u)) {
          Bi(u, en(u), o);
          return;
        }
        for (var h in u)
          mt.call(u, h) && ko(o, h, u[h]);
      }), gy = ga(function(o, u) {
        Bi(u, An(u), o);
      }), Mu = ga(function(o, u, h, y) {
        Bi(u, An(u), o, y);
      }), sP = ga(function(o, u, h, y) {
        Bi(u, en(u), o, y);
      }), aP = or(Jd);
      function oP(o, u) {
        var h = ma(o);
        return u == null ? h : Gg(h, u);
      }
      var lP = Ke(function(o, u) {
        o = bt(o);
        var h = -1, y = u.length, w = y > 2 ? u[2] : n;
        for (w && xn(u[0], u[1], w) && (y = 1); ++h < y; )
          for (var P = u[h], L = An(P), z = -1, U = L.length; ++z < U; ) {
            var te = L[z], ne = o[te];
            (ne === n || Si(ne, da[te]) && !mt.call(o, te)) && (o[te] = P[te]);
          }
        return o;
      }), uP = Ke(function(o) {
        return o.push(n, Mv), $n(vy, n, o);
      });
      function cP(o, u) {
        return Pg(o, Me(u, 3), Ri);
      }
      function dP(o, u) {
        return Pg(o, Me(u, 3), ef);
      }
      function fP(o, u) {
        return o == null ? o : Qd(o, Me(u, 3), An);
      }
      function hP(o, u) {
        return o == null ? o : Jg(o, Me(u, 3), An);
      }
      function mP(o, u) {
        return o && Ri(o, Me(u, 3));
      }
      function gP(o, u) {
        return o && ef(o, Me(u, 3));
      }
      function vP(o) {
        return o == null ? [] : hu(o, en(o));
      }
      function yP(o) {
        return o == null ? [] : hu(o, An(o));
      }
      function Df(o, u, h) {
        var y = o == null ? n : ws(o, u);
        return y === n ? h : y;
      }
      function pP(o, u) {
        return o != null && Lv(o, u, zk);
      }
      function Vf(o, u) {
        return o != null && Lv(o, u, Hk);
      }
      var bP = Iv(function(o, u, h) {
        u != null && typeof u.toString != "function" && (u = eu.call(u)), o[u] = h;
      }, Ff(Mn)), xP = Iv(function(o, u, h) {
        u != null && typeof u.toString != "function" && (u = eu.call(u)), mt.call(o, u) ? o[u].push(h) : o[u] = [h];
      }, Me), _P = Ke(To);
      function en(o) {
        return En(o) ? qg(o) : sf(o);
      }
      function An(o) {
        return En(o) ? qg(o, !0) : Jk(o);
      }
      function wP(o, u) {
        var h = {};
        return u = Me(u, 3), Ri(o, function(y, w, P) {
          sr(h, u(y, w, P), y);
        }), h;
      }
      function SP(o, u) {
        var h = {};
        return u = Me(u, 3), Ri(o, function(y, w, P) {
          sr(h, w, u(y, w, P));
        }), h;
      }
      var kP = ga(function(o, u, h) {
        mu(o, u, h);
      }), vy = ga(function(o, u, h, y) {
        mu(o, u, h, y);
      }), CP = or(function(o, u) {
        var h = {};
        if (o == null)
          return h;
        var y = !1;
        u = It(u, function(P) {
          return P = Nr(P, o), y || (y = P.length > 1), P;
        }), Bi(o, bf(o), h), y && (h = oi(h, m | g | v, bC));
        for (var w = u.length; w--; )
          df(h, u[w]);
        return h;
      });
      function TP(o, u) {
        return yy(o, Ou(Me(u)));
      }
      var IP = or(function(o, u) {
        return o == null ? {} : eC(o, u);
      });
      function yy(o, u) {
        if (o == null)
          return {};
        var h = It(bf(o), function(y) {
          return [y];
        });
        return u = Me(u), lv(o, h, function(y, w) {
          return u(y, w[0]);
        });
      }
      function PP(o, u, h) {
        u = Nr(u, o);
        var y = -1, w = u.length;
        for (w || (w = 1, o = n); ++y < w; ) {
          var P = o == null ? n : o[Ni(u[y])];
          P === n && (y = w, P = h), o = ur(P) ? P.call(o) : P;
        }
        return o;
      }
      function OP(o, u, h) {
        return o == null ? o : Po(o, u, h);
      }
      function EP(o, u, h, y) {
        return y = typeof y == "function" ? y : n, o == null ? o : Po(o, u, h, y);
      }
      var py = Ev(en), by = Ev(An);
      function AP(o, u, h) {
        var y = ze(o), w = y || zr(o) || pa(o);
        if (u = Me(u, 4), h == null) {
          var P = o && o.constructor;
          w ? h = y ? new P() : [] : Et(o) ? h = ur(P) ? ma(iu(o)) : {} : h = {};
        }
        return (w ? ri : Ri)(o, function(L, z, U) {
          return u(h, L, z, U);
        }), h;
      }
      function MP(o, u) {
        return o == null ? !0 : df(o, u);
      }
      function DP(o, u, h) {
        return o == null ? o : hv(o, u, mf(h));
      }
      function VP(o, u, h, y) {
        return y = typeof y == "function" ? y : n, o == null ? o : hv(o, u, mf(h), y);
      }
      function ba(o) {
        return o == null ? [] : qd(o, en(o));
      }
      function LP(o) {
        return o == null ? [] : qd(o, An(o));
      }
      function FP(o, u, h) {
        return h === n && (h = u, u = n), h !== n && (h = ci(h), h = h === h ? h : 0), u !== n && (u = ci(u), u = u === u ? u : 0), _s(ci(o), u, h);
      }
      function RP(o, u, h) {
        return u = cr(u), h === n ? (h = u, u = 0) : h = cr(h), o = ci(o), Wk(o, u, h);
      }
      function BP(o, u, h) {
        if (h && typeof h != "boolean" && xn(o, u, h) && (u = h = n), h === n && (typeof u == "boolean" ? (h = u, u = n) : typeof o == "boolean" && (h = o, o = n)), o === n && u === n ? (o = 0, u = 1) : (o = cr(o), u === n ? (u = o, o = 0) : u = cr(u)), o > u) {
          var y = o;
          o = u, u = y;
        }
        if (h || o % 1 || u % 1) {
          var w = Wg();
          return dn(o + w * (u - o + v1("1e-" + ((w + "").length - 1))), u);
        }
        return lf(o, u);
      }
      var NP = va(function(o, u, h) {
        return u = u.toLowerCase(), o + (h ? xy(u) : u);
      });
      function xy(o) {
        return Lf(ht(o).toLowerCase());
      }
      function _y(o) {
        return o = ht(o), o && o.replace(go, O1).replace(a1, "");
      }
      function $P(o, u, h) {
        o = ht(o), u = Hn(u);
        var y = o.length;
        h = h === n ? y : _s(qe(h), 0, y);
        var w = h;
        return h -= u.length, h >= 0 && o.slice(h, w) == u;
      }
      function zP(o) {
        return o = ht(o), o && Sd.test(o) ? o.replace(oo, E1) : o;
      }
      function HP(o) {
        return o = ht(o), o && Od.test(o) ? o.replace(Er, "\\$&") : o;
      }
      var WP = va(function(o, u, h) {
        return o + (h ? "-" : "") + u.toLowerCase();
      }), UP = va(function(o, u, h) {
        return o + (h ? " " : "") + u.toLowerCase();
      }), qP = kv("toLowerCase");
      function jP(o, u, h) {
        o = ht(o), u = qe(u);
        var y = u ? ua(o) : 0;
        if (!u || y >= u)
          return o;
        var w = (u - y) / 2;
        return xu(ou(w), h) + o + xu(au(w), h);
      }
      function GP(o, u, h) {
        o = ht(o), u = qe(u);
        var y = u ? ua(o) : 0;
        return u && y < u ? o + xu(u - y, h) : o;
      }
      function YP(o, u, h) {
        o = ht(o), u = qe(u);
        var y = u ? ua(o) : 0;
        return u && y < u ? xu(u - y, h) + o : o;
      }
      function ZP(o, u, h) {
        return h || u == null ? u = 0 : u && (u = +u), nk(ht(o).replace(co, ""), u || 0);
      }
      function KP(o, u, h) {
        return (h ? xn(o, u, h) : u === n) ? u = 1 : u = qe(u), uf(ht(o), u);
      }
      function XP() {
        var o = arguments, u = ht(o[0]);
        return o.length < 3 ? u : u.replace(o[1], o[2]);
      }
      var JP = va(function(o, u, h) {
        return o + (h ? "_" : "") + u.toLowerCase();
      });
      function QP(o, u, h) {
        return h && typeof h != "number" && xn(o, u, h) && (u = h = n), h = h === n ? G : h >>> 0, h ? (o = ht(o), o && (typeof u == "string" || u != null && !Mf(u)) && (u = Hn(u), !u && la(o)) ? $r(_i(o), 0, h) : o.split(u, h)) : [];
      }
      var eO = va(function(o, u, h) {
        return o + (h ? " " : "") + Lf(u);
      });
      function tO(o, u, h) {
        return o = ht(o), h = h == null ? 0 : _s(qe(h), 0, o.length), u = Hn(u), o.slice(h, h + u.length) == u;
      }
      function nO(o, u, h) {
        var y = C.templateSettings;
        h && xn(o, u, h) && (u = n), o = ht(o), u = Mu({}, u, y, Av);
        var w = Mu({}, u.imports, y.imports, Av), P = en(w), L = qd(w, P), z, U, te = 0, ne = u.interpolate || ta, re = "__p += '", ve = Gd(
          (u.escape || ta).source + "|" + ne.source + "|" + (ne === uo ? Ul : ta).source + "|" + (u.evaluate || ta).source + "|$",
          "g"
        ), Pe = "//# sourceURL=" + (mt.call(u, "sourceURL") ? (u.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++d1 + "]") + `
`;
        o.replace(ve, function(Ve, Qe, st, Un, _n, qn) {
          return st || (st = Un), re += o.slice(te, qn).replace(Md, A1), Qe && (z = !0, re += `' +
__e(` + Qe + `) +
'`), _n && (U = !0, re += `';
` + _n + `;
__p += '`), st && (re += `' +
((__t = (` + st + `)) == null ? '' : __t) +
'`), te = qn + Ve.length, Ve;
        }), re += `';
`;
        var De = mt.call(u, "variable") && u.variable;
        if (!De)
          re = `with (obj) {
` + re + `
}
`;
        else if (Hl.test(De))
          throw new Be(l);
        re = (U ? re.replace(Qs, "") : re).replace(_d, "$1").replace(wd, "$1;"), re = "function(" + (De || "obj") + `) {
` + (De ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (z ? ", __e = _.escape" : "") + (U ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + re + `return __p
}`;
        var Ye = Sy(function() {
          return lt(P, Pe + "return " + re).apply(n, L);
        });
        if (Ye.source = re, Af(Ye))
          throw Ye;
        return Ye;
      }
      function iO(o) {
        return ht(o).toLowerCase();
      }
      function rO(o) {
        return ht(o).toUpperCase();
      }
      function sO(o, u, h) {
        if (o = ht(o), o && (h || u === n))
          return Mg(o);
        if (!o || !(u = Hn(u)))
          return o;
        var y = _i(o), w = _i(u), P = Dg(y, w), L = Vg(y, w) + 1;
        return $r(y, P, L).join("");
      }
      function aO(o, u, h) {
        if (o = ht(o), o && (h || u === n))
          return o.slice(0, Fg(o) + 1);
        if (!o || !(u = Hn(u)))
          return o;
        var y = _i(o), w = Vg(y, _i(u)) + 1;
        return $r(y, 0, w).join("");
      }
      function oO(o, u, h) {
        if (o = ht(o), o && (h || u === n))
          return o.replace(co, "");
        if (!o || !(u = Hn(u)))
          return o;
        var y = _i(o), w = Dg(y, _i(u));
        return $r(y, w).join("");
      }
      function lO(o, u) {
        var h = H, y = B;
        if (Et(u)) {
          var w = "separator" in u ? u.separator : w;
          h = "length" in u ? qe(u.length) : h, y = "omission" in u ? Hn(u.omission) : y;
        }
        o = ht(o);
        var P = o.length;
        if (la(o)) {
          var L = _i(o);
          P = L.length;
        }
        if (h >= P)
          return o;
        var z = h - ua(y);
        if (z < 1)
          return y;
        var U = L ? $r(L, 0, z).join("") : o.slice(0, z);
        if (w === n)
          return U + y;
        if (L && (z += U.length - z), Mf(w)) {
          if (o.slice(z).search(w)) {
            var te, ne = U;
            for (w.global || (w = Gd(w.source, ht(ho.exec(w)) + "g")), w.lastIndex = 0; te = w.exec(ne); )
              var re = te.index;
            U = U.slice(0, re === n ? z : re);
          }
        } else if (o.indexOf(Hn(w), z) != z) {
          var ve = U.lastIndexOf(w);
          ve > -1 && (U = U.slice(0, ve));
        }
        return U + y;
      }
      function uO(o) {
        return o = ht(o), o && lo.test(o) ? o.replace(ao, B1) : o;
      }
      var cO = va(function(o, u, h) {
        return o + (h ? " " : "") + u.toUpperCase();
      }), Lf = kv("toUpperCase");
      function wy(o, u, h) {
        return o = ht(o), u = h ? n : u, u === n ? D1(o) ? z1(o) : k1(o) : o.match(u) || [];
      }
      var Sy = Ke(function(o, u) {
        try {
          return $n(o, n, u);
        } catch (h) {
          return Af(h) ? h : new Be(h);
        }
      }), dO = or(function(o, u) {
        return ri(u, function(h) {
          h = Ni(h), sr(o, h, Of(o[h], o));
        }), o;
      });
      function fO(o) {
        var u = o == null ? 0 : o.length, h = Me();
        return o = u ? It(o, function(y) {
          if (typeof y[1] != "function")
            throw new si(a);
          return [h(y[0]), y[1]];
        }) : [], Ke(function(y) {
          for (var w = -1; ++w < u; ) {
            var P = o[w];
            if ($n(P[0], this, y))
              return $n(P[1], this, y);
          }
        });
      }
      function hO(o) {
        return Bk(oi(o, m));
      }
      function Ff(o) {
        return function() {
          return o;
        };
      }
      function mO(o, u) {
        return o == null || o !== o ? u : o;
      }
      var gO = Tv(), vO = Tv(!0);
      function Mn(o) {
        return o;
      }
      function Rf(o) {
        return nv(typeof o == "function" ? o : oi(o, m));
      }
      function yO(o) {
        return rv(oi(o, m));
      }
      function pO(o, u) {
        return sv(o, oi(u, m));
      }
      var bO = Ke(function(o, u) {
        return function(h) {
          return To(h, o, u);
        };
      }), xO = Ke(function(o, u) {
        return function(h) {
          return To(o, h, u);
        };
      });
      function Bf(o, u, h) {
        var y = en(u), w = hu(u, y);
        h == null && !(Et(u) && (w.length || !y.length)) && (h = u, u = o, o = this, w = hu(u, en(u)));
        var P = !(Et(h) && "chain" in h) || !!h.chain, L = ur(o);
        return ri(w, function(z) {
          var U = u[z];
          o[z] = U, L && (o.prototype[z] = function() {
            var te = this.__chain__;
            if (P || te) {
              var ne = o(this.__wrapped__), re = ne.__actions__ = On(this.__actions__);
              return re.push({ func: U, args: arguments, thisArg: o }), ne.__chain__ = te, ne;
            }
            return U.apply(o, Vr([this.value()], arguments));
          });
        }), o;
      }
      function _O() {
        return on._ === this && (on._ = G1), this;
      }
      function Nf() {
      }
      function wO(o) {
        return o = qe(o), Ke(function(u) {
          return av(u, o);
        });
      }
      var SO = vf(It), kO = vf(Ig), CO = vf($d);
      function ky(o) {
        return Sf(o) ? zd(Ni(o)) : tC(o);
      }
      function TO(o) {
        return function(u) {
          return o == null ? n : ws(o, u);
        };
      }
      var IO = Pv(), PO = Pv(!0);
      function $f() {
        return [];
      }
      function zf() {
        return !1;
      }
      function OO() {
        return {};
      }
      function EO() {
        return "";
      }
      function AO() {
        return !0;
      }
      function MO(o, u) {
        if (o = qe(o), o < 1 || o > be)
          return [];
        var h = G, y = dn(o, G);
        u = Me(u), o -= G;
        for (var w = Ud(y, u); ++h < o; )
          u(h);
        return w;
      }
      function DO(o) {
        return ze(o) ? It(o, Ni) : Wn(o) ? [o] : On(Uv(ht(o)));
      }
      function VO(o) {
        var u = ++q1;
        return ht(o) + u;
      }
      var LO = bu(function(o, u) {
        return o + u;
      }, 0), FO = yf("ceil"), RO = bu(function(o, u) {
        return o / u;
      }, 1), BO = yf("floor");
      function NO(o) {
        return o && o.length ? fu(o, Mn, tf) : n;
      }
      function $O(o, u) {
        return o && o.length ? fu(o, Me(u, 2), tf) : n;
      }
      function zO(o) {
        return Eg(o, Mn);
      }
      function HO(o, u) {
        return Eg(o, Me(u, 2));
      }
      function WO(o) {
        return o && o.length ? fu(o, Mn, af) : n;
      }
      function UO(o, u) {
        return o && o.length ? fu(o, Me(u, 2), af) : n;
      }
      var qO = bu(function(o, u) {
        return o * u;
      }, 1), jO = yf("round"), GO = bu(function(o, u) {
        return o - u;
      }, 0);
      function YO(o) {
        return o && o.length ? Wd(o, Mn) : 0;
      }
      function ZO(o, u) {
        return o && o.length ? Wd(o, Me(u, 2)) : 0;
      }
      return C.after = yI, C.ary = ty, C.assign = rP, C.assignIn = gy, C.assignInWith = Mu, C.assignWith = sP, C.at = aP, C.before = ny, C.bind = Of, C.bindAll = dO, C.bindKey = iy, C.castArray = OI, C.chain = Jv, C.chunk = BC, C.compact = NC, C.concat = $C, C.cond = fO, C.conforms = hO, C.constant = Ff, C.countBy = YT, C.create = oP, C.curry = ry, C.curryRight = sy, C.debounce = ay, C.defaults = lP, C.defaultsDeep = uP, C.defer = pI, C.delay = bI, C.difference = zC, C.differenceBy = HC, C.differenceWith = WC, C.drop = UC, C.dropRight = qC, C.dropRightWhile = jC, C.dropWhile = GC, C.fill = YC, C.filter = KT, C.flatMap = QT, C.flatMapDeep = eI, C.flatMapDepth = tI, C.flatten = Yv, C.flattenDeep = ZC, C.flattenDepth = KC, C.flip = xI, C.flow = gO, C.flowRight = vO, C.fromPairs = XC, C.functions = vP, C.functionsIn = yP, C.groupBy = nI, C.initial = QC, C.intersection = eT, C.intersectionBy = tT, C.intersectionWith = nT, C.invert = bP, C.invertBy = xP, C.invokeMap = rI, C.iteratee = Rf, C.keyBy = sI, C.keys = en, C.keysIn = An, C.map = Tu, C.mapKeys = wP, C.mapValues = SP, C.matches = yO, C.matchesProperty = pO, C.memoize = Pu, C.merge = kP, C.mergeWith = vy, C.method = bO, C.methodOf = xO, C.mixin = Bf, C.negate = Ou, C.nthArg = wO, C.omit = CP, C.omitBy = TP, C.once = _I, C.orderBy = aI, C.over = SO, C.overArgs = wI, C.overEvery = kO, C.overSome = CO, C.partial = Ef, C.partialRight = oy, C.partition = oI, C.pick = IP, C.pickBy = yy, C.property = ky, C.propertyOf = TO, C.pull = aT, C.pullAll = Kv, C.pullAllBy = oT, C.pullAllWith = lT, C.pullAt = uT, C.range = IO, C.rangeRight = PO, C.rearg = SI, C.reject = cI, C.remove = cT, C.rest = kI, C.reverse = If, C.sampleSize = fI, C.set = OP, C.setWith = EP, C.shuffle = hI, C.slice = dT, C.sortBy = vI, C.sortedUniq = pT, C.sortedUniqBy = bT, C.split = QP, C.spread = CI, C.tail = xT, C.take = _T, C.takeRight = wT, C.takeRightWhile = ST, C.takeWhile = kT, C.tap = NT, C.throttle = TI, C.thru = Cu, C.toArray = fy, C.toPairs = py, C.toPairsIn = by, C.toPath = DO, C.toPlainObject = my, C.transform = AP, C.unary = II, C.union = CT, C.unionBy = TT, C.unionWith = IT, C.uniq = PT, C.uniqBy = OT, C.uniqWith = ET, C.unset = MP, C.unzip = Pf, C.unzipWith = Xv, C.update = DP, C.updateWith = VP, C.values = ba, C.valuesIn = LP, C.without = AT, C.words = wy, C.wrap = PI, C.xor = MT, C.xorBy = DT, C.xorWith = VT, C.zip = LT, C.zipObject = FT, C.zipObjectDeep = RT, C.zipWith = BT, C.entries = py, C.entriesIn = by, C.extend = gy, C.extendWith = Mu, Bf(C, C), C.add = LO, C.attempt = Sy, C.camelCase = NP, C.capitalize = xy, C.ceil = FO, C.clamp = FP, C.clone = EI, C.cloneDeep = MI, C.cloneDeepWith = DI, C.cloneWith = AI, C.conformsTo = VI, C.deburr = _y, C.defaultTo = mO, C.divide = RO, C.endsWith = $P, C.eq = Si, C.escape = zP, C.escapeRegExp = HP, C.every = ZT, C.find = XT, C.findIndex = jv, C.findKey = cP, C.findLast = JT, C.findLastIndex = Gv, C.findLastKey = dP, C.floor = BO, C.forEach = Qv, C.forEachRight = ey, C.forIn = fP, C.forInRight = hP, C.forOwn = mP, C.forOwnRight = gP, C.get = Df, C.gt = LI, C.gte = FI, C.has = pP, C.hasIn = Vf, C.head = Zv, C.identity = Mn, C.includes = iI, C.indexOf = JC, C.inRange = RP, C.invoke = _P, C.isArguments = Cs, C.isArray = ze, C.isArrayBuffer = RI, C.isArrayLike = En, C.isArrayLikeObject = Ht, C.isBoolean = BI, C.isBuffer = zr, C.isDate = NI, C.isElement = $I, C.isEmpty = zI, C.isEqual = HI, C.isEqualWith = WI, C.isError = Af, C.isFinite = UI, C.isFunction = ur, C.isInteger = ly, C.isLength = Eu, C.isMap = uy, C.isMatch = qI, C.isMatchWith = jI, C.isNaN = GI, C.isNative = YI, C.isNil = KI, C.isNull = ZI, C.isNumber = cy, C.isObject = Et, C.isObjectLike = Lt, C.isPlainObject = Mo, C.isRegExp = Mf, C.isSafeInteger = XI, C.isSet = dy, C.isString = Au, C.isSymbol = Wn, C.isTypedArray = pa, C.isUndefined = JI, C.isWeakMap = QI, C.isWeakSet = eP, C.join = iT, C.kebabCase = WP, C.last = ui, C.lastIndexOf = rT, C.lowerCase = UP, C.lowerFirst = qP, C.lt = tP, C.lte = nP, C.max = NO, C.maxBy = $O, C.mean = zO, C.meanBy = HO, C.min = WO, C.minBy = UO, C.stubArray = $f, C.stubFalse = zf, C.stubObject = OO, C.stubString = EO, C.stubTrue = AO, C.multiply = qO, C.nth = sT, C.noConflict = _O, C.noop = Nf, C.now = Iu, C.pad = jP, C.padEnd = GP, C.padStart = YP, C.parseInt = ZP, C.random = BP, C.reduce = lI, C.reduceRight = uI, C.repeat = KP, C.replace = XP, C.result = PP, C.round = jO, C.runInContext = W, C.sample = dI, C.size = mI, C.snakeCase = JP, C.some = gI, C.sortedIndex = fT, C.sortedIndexBy = hT, C.sortedIndexOf = mT, C.sortedLastIndex = gT, C.sortedLastIndexBy = vT, C.sortedLastIndexOf = yT, C.startCase = eO, C.startsWith = tO, C.subtract = GO, C.sum = YO, C.sumBy = ZO, C.template = nO, C.times = MO, C.toFinite = cr, C.toInteger = qe, C.toLength = hy, C.toLower = iO, C.toNumber = ci, C.toSafeInteger = iP, C.toString = ht, C.toUpper = rO, C.trim = sO, C.trimEnd = aO, C.trimStart = oO, C.truncate = lO, C.unescape = uO, C.uniqueId = VO, C.upperCase = cO, C.upperFirst = Lf, C.each = Qv, C.eachRight = ey, C.first = Zv, Bf(C, function() {
        var o = {};
        return Ri(C, function(u, h) {
          mt.call(C.prototype, h) || (o[h] = u);
        }), o;
      }(), { chain: !1 }), C.VERSION = i, ri(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(o) {
        C[o].placeholder = C;
      }), ri(["drop", "take"], function(o, u) {
        tt.prototype[o] = function(h) {
          h = h === n ? 1 : Xt(qe(h), 0);
          var y = this.__filtered__ && !u ? new tt(this) : this.clone();
          return y.__filtered__ ? y.__takeCount__ = dn(h, y.__takeCount__) : y.__views__.push({
            size: dn(h, G),
            type: o + (y.__dir__ < 0 ? "Right" : "")
          }), y;
        }, tt.prototype[o + "Right"] = function(h) {
          return this.reverse()[o](h).reverse();
        };
      }), ri(["filter", "map", "takeWhile"], function(o, u) {
        var h = u + 1, y = h == X || h == de;
        tt.prototype[o] = function(w) {
          var P = this.clone();
          return P.__iteratees__.push({
            iteratee: Me(w, 3),
            type: h
          }), P.__filtered__ = P.__filtered__ || y, P;
        };
      }), ri(["head", "last"], function(o, u) {
        var h = "take" + (u ? "Right" : "");
        tt.prototype[o] = function() {
          return this[h](1).value()[0];
        };
      }), ri(["initial", "tail"], function(o, u) {
        var h = "drop" + (u ? "" : "Right");
        tt.prototype[o] = function() {
          return this.__filtered__ ? new tt(this) : this[h](1);
        };
      }), tt.prototype.compact = function() {
        return this.filter(Mn);
      }, tt.prototype.find = function(o) {
        return this.filter(o).head();
      }, tt.prototype.findLast = function(o) {
        return this.reverse().find(o);
      }, tt.prototype.invokeMap = Ke(function(o, u) {
        return typeof o == "function" ? new tt(this) : this.map(function(h) {
          return To(h, o, u);
        });
      }), tt.prototype.reject = function(o) {
        return this.filter(Ou(Me(o)));
      }, tt.prototype.slice = function(o, u) {
        o = qe(o);
        var h = this;
        return h.__filtered__ && (o > 0 || u < 0) ? new tt(h) : (o < 0 ? h = h.takeRight(-o) : o && (h = h.drop(o)), u !== n && (u = qe(u), h = u < 0 ? h.dropRight(-u) : h.take(u - o)), h);
      }, tt.prototype.takeRightWhile = function(o) {
        return this.reverse().takeWhile(o).reverse();
      }, tt.prototype.toArray = function() {
        return this.take(G);
      }, Ri(tt.prototype, function(o, u) {
        var h = /^(?:filter|find|map|reject)|While$/.test(u), y = /^(?:head|last)$/.test(u), w = C[y ? "take" + (u == "last" ? "Right" : "") : u], P = y || /^find/.test(u);
        w && (C.prototype[u] = function() {
          var L = this.__wrapped__, z = y ? [1] : arguments, U = L instanceof tt, te = z[0], ne = U || ze(L), re = function(Qe) {
            var st = w.apply(C, Vr([Qe], z));
            return y && ve ? st[0] : st;
          };
          ne && h && typeof te == "function" && te.length != 1 && (U = ne = !1);
          var ve = this.__chain__, Pe = !!this.__actions__.length, De = P && !ve, Ye = U && !Pe;
          if (!P && ne) {
            L = Ye ? L : new tt(this);
            var Ve = o.apply(L, z);
            return Ve.__actions__.push({ func: Cu, args: [re], thisArg: n }), new ai(Ve, ve);
          }
          return De && Ye ? o.apply(this, z) : (Ve = this.thru(re), De ? y ? Ve.value()[0] : Ve.value() : Ve);
        });
      }), ri(["pop", "push", "shift", "sort", "splice", "unshift"], function(o) {
        var u = Xl[o], h = /^(?:push|sort|unshift)$/.test(o) ? "tap" : "thru", y = /^(?:pop|shift)$/.test(o);
        C.prototype[o] = function() {
          var w = arguments;
          if (y && !this.__chain__) {
            var P = this.value();
            return u.apply(ze(P) ? P : [], w);
          }
          return this[h](function(L) {
            return u.apply(ze(L) ? L : [], w);
          });
        };
      }), Ri(tt.prototype, function(o, u) {
        var h = C[u];
        if (h) {
          var y = h.name + "";
          mt.call(ha, y) || (ha[y] = []), ha[y].push({ name: u, func: h });
        }
      }), ha[pu(n, S).name] = [{
        name: "wrapper",
        func: n
      }], tt.prototype.clone = uk, tt.prototype.reverse = ck, tt.prototype.value = dk, C.prototype.at = $T, C.prototype.chain = zT, C.prototype.commit = HT, C.prototype.next = WT, C.prototype.plant = qT, C.prototype.reverse = jT, C.prototype.toJSON = C.prototype.valueOf = C.prototype.value = GT, C.prototype.first = C.prototype.head, bo && (C.prototype[bo] = UT), C;
    }, ca = H1();
    ys ? ((ys.exports = ca)._ = ca, Fd._ = ca) : on._ = ca;
  }).call(Fo);
})(Dc, Dc.exports);
var EF = Dc.exports;
const AF = ee({
  autoGrow: Boolean,
  autofocus: Boolean,
  counter: [Boolean, Number, String],
  counterValue: Function,
  prefix: String,
  placeholder: String,
  persistentPlaceholder: Boolean,
  persistentCounter: Boolean,
  noResize: Boolean,
  rows: {
    type: [Number, String],
    default: 5,
    validator: (e) => !isNaN(parseFloat(e))
  },
  maxRows: {
    type: [Number, String],
    validator: (e) => !isNaN(parseFloat(e))
  },
  suffix: String,
  modelModifiers: Object,
  ...Fl(),
  ...Um()
}, "VTextarea"), MF = pe()({
  name: "VTextarea",
  directives: {
    Intersect: ed
  },
  inheritAttrs: !1,
  props: AF(),
  emits: {
    "click:control": (e) => !0,
    "mousedown:control": (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: i,
      slots: r
    } = t;
    const s = at(e, "modelValue"), {
      isFocused: a,
      focus: l,
      blur: c
    } = Ll(e), d = I(() => typeof e.counterValue == "function" ? e.counterValue(s.value) : (s.value || "").toString().length), f = I(() => {
      if (n.maxlength)
        return n.maxlength;
      if (!(!e.counter || typeof e.counter != "number" && typeof e.counter != "string"))
        return e.counter;
    });
    function m(B, N) {
      var q, X;
      !e.autofocus || !B || (X = (q = N[0].target) == null ? void 0 : q.focus) == null || X.call(q);
    }
    const g = ue(), v = ue(), p = Ie(""), _ = ue(), x = I(() => e.persistentPlaceholder || a.value || e.active);
    function S() {
      var B;
      _.value !== document.activeElement && ((B = _.value) == null || B.focus()), a.value || l();
    }
    function T(B) {
      S(), i("click:control", B);
    }
    function M(B) {
      i("mousedown:control", B);
    }
    function E(B) {
      B.stopPropagation(), S(), Ct(() => {
        s.value = "", hm(e["onClick:clear"], B);
      });
    }
    function D(B) {
      var q;
      const N = B.target;
      if (s.value = N.value, (q = e.modelModifiers) != null && q.trim) {
        const X = [N.selectionStart, N.selectionEnd];
        Ct(() => {
          N.selectionStart = X[0], N.selectionEnd = X[1];
        });
      }
    }
    const R = ue(), $ = ue(+e.rows), A = I(() => ["plain", "underlined"].includes(e.variant));
    Xn(() => {
      e.autoGrow || ($.value = +e.rows);
    });
    function V() {
      e.autoGrow && Ct(() => {
        if (!R.value || !v.value)
          return;
        const B = getComputedStyle(R.value), N = getComputedStyle(v.value.$el), q = parseFloat(B.getPropertyValue("--v-field-padding-top")) + parseFloat(B.getPropertyValue("--v-input-padding-top")) + parseFloat(B.getPropertyValue("--v-field-padding-bottom")), X = R.value.scrollHeight, se = parseFloat(B.lineHeight), de = Math.max(parseFloat(e.rows) * se + q, parseFloat(N.getPropertyValue("--v-input-control-height"))), _e = parseFloat(e.maxRows) * se + q || 1 / 0, be = Jt(X ?? 0, de, _e);
        $.value = Math.floor((be - q) / se), p.value = Ce(be);
      });
    }
    Jn(V), Se(s, V), Se(() => e.rows, V), Se(() => e.maxRows, V), Se(() => e.density, V);
    let H;
    return Se(R, (B) => {
      B ? (H = new ResizeObserver(V), H.observe(R.value)) : H == null || H.disconnect();
    }), kn(() => {
      H == null || H.disconnect();
    }), ke(() => {
      const B = !!(r.counter || e.counter || e.counterValue), N = !!(B || r.details), [q, X] = Yc(n), {
        modelValue: se,
        ...de
      } = is.filterProps(e), _e = vw(e);
      return b(is, fe({
        ref: g,
        modelValue: s.value,
        "onUpdate:modelValue": (be) => s.value = be,
        class: ["v-textarea v-text-field", {
          "v-textarea--prefixed": e.prefix,
          "v-textarea--suffixed": e.suffix,
          "v-text-field--prefixed": e.prefix,
          "v-text-field--suffixed": e.suffix,
          "v-textarea--auto-grow": e.autoGrow,
          "v-textarea--no-resize": e.noResize || e.autoGrow,
          "v-input--plain-underlined": A.value
        }, e.class],
        style: e.style
      }, q, de, {
        centerAffix: $.value === 1 && !A.value,
        focused: a.value
      }), {
        ...r,
        default: (be) => {
          let {
            id: oe,
            isDisabled: J,
            isDirty: G,
            isReadonly: ie,
            isValid: ge
          } = be;
          return b(qm, fe({
            ref: v,
            style: {
              "--v-textarea-control-height": p.value
            },
            onClick: T,
            onMousedown: M,
            "onClick:clear": E,
            "onClick:prependInner": e["onClick:prependInner"],
            "onClick:appendInner": e["onClick:appendInner"]
          }, _e, {
            id: oe.value,
            active: x.value || G.value,
            centerAffix: $.value === 1 && !A.value,
            dirty: G.value || e.dirty,
            disabled: J.value,
            focused: a.value,
            error: ge.value === !1
          }), {
            ...r,
            default: (he) => {
              let {
                props: {
                  class: Oe,
                  ...Q
                }
              } = he;
              return b(Le, null, [e.prefix && b("span", {
                class: "v-text-field__prefix"
              }, [e.prefix]), rn(b("textarea", fe({
                ref: _,
                class: Oe,
                value: s.value,
                onInput: D,
                autofocus: e.autofocus,
                readonly: ie.value,
                disabled: J.value,
                placeholder: e.placeholder,
                rows: e.rows,
                name: e.name,
                onFocus: S,
                onBlur: c
              }, Q, X), null), [[ji("intersect"), {
                handler: m
              }, null, {
                once: !0
              }]]), e.autoGrow && rn(b("textarea", {
                class: [Oe, "v-textarea__sizer"],
                id: `${Q.id}-sizer`,
                "onUpdate:modelValue": (me) => s.value = me,
                ref: R,
                readonly: !0,
                "aria-hidden": "true"
              }, null), [[fE, s.value]]), e.suffix && b("span", {
                class: "v-text-field__suffix"
              }, [e.suffix])]);
            }
          });
        },
        details: N ? (be) => {
          var oe;
          return b(Le, null, [(oe = r.details) == null ? void 0 : oe.call(r, be), B && b(Le, null, [b("span", null, null), b(gw, {
            active: e.persistentCounter || a.value,
            value: d.value,
            max: f.value,
            disabled: e.disabled
          }, r.counter)])]);
        } : void 0
      });
    }), ls({}, g, v, _);
  }
}), DF = { class: "pt-1" }, VF = {
  key: 0,
  class: "pt-1",
  style: { color: "darkorange", "white-space": "break-spaces" }
}, LF = /* @__PURE__ */ Je({
  __name: "TextField",
  props: {
    modelValue: { type: Object, required: !0 },
    itemKey: { type: String, required: !1 },
    field: { type: Object, required: !0 },
    label: { type: String, required: !1 },
    hideDetails: { type: Boolean, required: !1, default: !1 },
    center: { type: Boolean, required: !1, default: !1 },
    shrink: { type: Boolean, required: !1, default: !1 },
    warning: { type: Boolean, required: !1, default: !1 },
    warningRules: { type: Array, required: !1, default: [] },
    required: { type: Boolean, required: !1, default: !1 },
    customErrorRules: { type: Array, required: !1, default: [] },
    noLabel: { type: Boolean, required: !1, default: !1 },
    noUpdateOnError: { type: Boolean, required: !1, default: !1 },
    showErrorWithoutUpdate: { type: Boolean, required: !1, default: !1 },
    noPadding: { type: Boolean, required: !1, default: !1 },
    noHelpText: { type: Boolean, required: !1, default: !1 },
    useLock: { type: Boolean, required: !1, default: !1 },
    isLocked: { type: Boolean, required: !1, default: !1 },
    density: {
      type: String,
      required: !1,
      default: "default"
    },
    fractionDigits: { type: Number, required: !1, default: 2 },
    showFractionDigits: { type: Boolean, required: !1, default: !1 },
    step: { type: Number, required: !1, default: 1 },
    fontSize: { type: String, required: !1 }
  },
  emits: ["toggleIsLocked", "update", "update:modelValue", "click:prepend-inner"],
  setup(e, { emit: t }) {
    hE((A) => ({
      "327f059f": e.fontSize
    }));
    const n = e, i = t, r = ce(n, "modelValue"), s = ue({
      float: "number",
      integer: "number",
      string: "text"
    }), a = ue(null), l = ue(null), c = ue(!1), d = ue(1), f = ue(""), m = I(() => n.itemKey ?? n.field.parameter);
    function g(A) {
      let V = A.target.value;
      const H = R(V);
      if (!isNaN(V) && n.field.type !== "string" && (V = V === "" ? null : EF.toNumber(V)), c.value = !H, !H) {
        if (n.noUpdateOnError) {
          f.value = r.value[m.value];
          return;
        }
        if (n.showErrorWithoutUpdate)
          return;
      }
      r.value[m.value] = V, i("update:modelValue", r.value), i("update");
    }
    const v = I(() => n.noLabel ? void 0 : n.label ? n.label : n.field.label);
    Se(
      () => r.value,
      () => {
        let A = r.value[m.value];
        typeof A == "number" && n.showFractionDigits && (A = A.toFixed(n.fractionDigits)), f.value = A;
      }
    );
    const p = I(() => {
      var A;
      return n.shrink ? `width:${((A = f.value) == null ? void 0 : A.length) - 1}.5rem` : "";
    }), _ = I(() => n.density === "compact" && n.hideDetails && c.value), x = I(() => n.noPadding ? "no-padding" : ""), S = I(() => n.center ? "field-input-center" : ""), T = I(() => _.value ? "border-bottom-red" : ""), M = (A) => n.required && A == null ? "Required." : !0, E = I(() => {
      const A = "required" in n.field && n.field.required ? $.value.required : !0, V = "max_value" in n.field ? $.value.maxValue : !0, H = "min_value" in n.field ? $.value.minValue : !0, B = n.customErrorRules ?? [];
      return [A, M, V, H, ...B];
    }), D = I(() => {
      let A = "";
      return n.warningRules.forEach((V) => {
        "min_value" in V && f.value && f.value < V.min_value && (A = V.message), "max_value" in V && f.value && f.value > V.max_value && (A = V.message);
      }), A;
    });
    function R(A) {
      return E.value.every((V) => !(V !== !0 && V(A) !== !0));
    }
    const $ = ue({
      required: (A) => A === 0 || !!A || "Required.",
      maxValue: (A) => !A || n.field.max_value === void 0 || A <= n.field.max_value || `The max value is ${n.field.max_value}.`,
      minValue: (A) => !A || n.field.min_value === void 0 || A >= n.field.min_value || `The min value is ${n.field.min_value}.`
    });
    return Jn(() => {
      var A, V, H, B, N, q;
      typeof r.value[m.value] == "number" && n.showFractionDigits ? f.value = r.value[m.value].toFixed(n.fractionDigits) : f.value = r.value[m.value];
      try {
        a.value && a.value.clientWidth > (((H = (V = (A = a.value.parentElement) == null ? void 0 : A.parentElement) == null ? void 0 : V.parentElement) == null ? void 0 : H.clientWidth) ?? 1) && (d.value = ((((q = (N = (B = a.value.parentElement) == null ? void 0 : B.parentElement) == null ? void 0 : N.parentElement) == null ? void 0 : q.clientWidth) ?? 1) + 20) / a.value.clientWidth);
      } catch {
      }
    }), (A, V) => e.field ? (le(), nt("div", {
      key: 0,
      onClick: V[7] || (V[7] = Dt(() => {
      }, ["stop"]))
    }, [
      e.field.field_type === "textfield" ? (le(), Te(MF, fe({
        key: 0,
        color: "primary",
        label: v.value,
        type: s.value[e.field.type],
        "hide-details": e.hideDetails,
        onChange: V[0] || (V[0] = (H) => g(H)),
        modelValue: f.value,
        "onUpdate:modelValue": V[1] || (V[1] = (H) => f.value = H)
      }, A.$attrs), null, 16, ["label", "type", "hide-details", "modelValue"])) : (le(), Te(hl, fe({
        key: 1,
        "onClick:prependInner": V[3] || (V[3] = (H) => i("click:prepend-inner")),
        onClick: V[4] || (V[4] = Dt(() => {
        }, ["stop"])),
        step: e.step,
        rules: E.value,
        ref_key: "fieldRef",
        ref: l,
        color: "primary",
        class: `${x.value} ${T.value} ${S.value} font-size`,
        density: e.density,
        type: s.value[e.field.type],
        "hide-details": e.hideDetails,
        style: `white-space: nowrap; ${p.value}`,
        disabled: e.isLocked,
        onChange: V[5] || (V[5] = (H) => g(H)),
        modelValue: f.value,
        "onUpdate:modelValue": V[6] || (V[6] = (H) => f.value = H)
      }, A.$attrs), {
        label: Z(() => [
          St("span", {
            style: Qr(`font-size: ${d.value}em;`),
            ref_key: "span",
            ref: a
          }, At(v.value), 5)
        ]),
        "append-inner": Z(() => [
          St("div", DF, [
            e.field.help_text && !e.noHelpText ? (le(), Te(Zm, {
              key: 0,
              text: e.field.help_text
            }, null, 8, ["text"])) : it("", !0),
            e.useLock ? (le(), Te(dt, {
              key: 1,
              icon: e.isLocked ? "mdi-lock" : "mdi-lock-open",
              style: { "pointer-events": "auto" },
              onClick: V[2] || (V[2] = (H) => i("toggleIsLocked"))
            }, null, 8, ["icon"])) : it("", !0)
          ])
        ]),
        details: Z(({ isValid: H }) => [
          H ? (le(), nt(Le, { key: 0 }, [
            H.value && n.warning ? (le(), nt("div", VF, At(D.value), 1)) : it("", !0)
          ], 64)) : it("", !0)
        ]),
        _: 1
      }, 16, ["step", "rules", "class", "density", "type", "hide-details", "style", "disabled", "modelValue"]))
    ])) : it("", !0);
  }
}), Km = /* @__PURE__ */ Tr(LF, [["__scopeId", "data-v-83f8d374"]]), FF = ee({
  ...Ae(),
  ...YV()
}, "VForm"), RF = pe()({
  name: "VForm",
  props: FF(),
  emits: {
    "update:modelValue": (e) => !0,
    submit: (e) => !0
  },
  setup(e, t) {
    let {
      slots: n,
      emit: i
    } = t;
    const r = ZV(e), s = ue();
    function a(c) {
      c.preventDefault(), r.reset();
    }
    function l(c) {
      const d = c, f = r.validate();
      d.then = f.then.bind(f), d.catch = f.catch.bind(f), d.finally = f.finally.bind(f), i("submit", d), d.defaultPrevented || f.then((m) => {
        var v;
        let {
          valid: g
        } = m;
        g && ((v = s.value) == null || v.submit());
      }), d.preventDefault();
    }
    return ke(() => {
      var c;
      return b("form", {
        ref: s,
        class: ["v-form", e.class],
        style: e.style,
        novalidate: !0,
        onReset: a,
        onSubmit: l
      }, [(c = n.default) == null ? void 0 : c.call(n, r)]);
    }), ls(r, s);
  }
}), Uw = /* @__PURE__ */ Je({
  __name: "RHDHVForm",
  props: {
    store: { type: Object, required: !0 },
    stateName: { type: String, required: !0 },
    modelValue: { type: Boolean },
    disabledFields: { type: Array, required: !1, default: () => [] }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, i = ce(n, "store"), r = I({
      get: () => n.modelValue,
      set(a) {
        s("update:modelValue", a);
      }
    }), s = t;
    return (a, l) => (le(), Te(RF, {
      modelValue: r.value,
      "onUpdate:modelValue": l[0] || (l[0] = (c) => r.value = c)
    }, {
      default: Z(() => [
        wt(a.$slots, "prepend"),
        (le(!0), nt(Le, null, um(i.value.fieldsFiltered, (c) => {
          var d;
          return le(), nt(Le, null, [
            c.type === "choice" ? (le(), Te(hd, {
              color: "primary",
              items: (d = c.choices) == null ? void 0 : d.map((f) => f.display_name),
              label: c.label,
              modelValue: i.value[e.stateName][c.parameter],
              "onUpdate:modelValue": (f) => i.value[e.stateName][c.parameter] = f,
              rules: [
                (f) => !c.required || f != null || "Required."
              ],
              readonly: c.read_only,
              key: "choice-" + c.parameter,
              disabled: e.disabledFields.includes(c.parameter)
            }, null, 8, ["items", "label", "modelValue", "onUpdate:modelValue", "rules", "readonly", "disabled"])) : (le(), Te(Km, {
              field: c,
              key: c.parameter,
              "model-value": i.value[e.stateName],
              disabled: e.disabledFields.includes(c.parameter)
            }, null, 8, ["field", "model-value", "disabled"]))
          ], 64);
        }), 256)),
        wt(a.$slots, "append")
      ]),
      _: 3
    }, 8, ["modelValue"]));
  }
}), BF = { class: "w-75 ml-4" }, NF = /* @__PURE__ */ Je({
  __name: "DataTableTitle",
  props: {
    title: { type: String, required: !0 },
    addTitle: { type: String, required: !1, default: "Add" },
    favorite: { type: Boolean, required: !0 },
    canChangeTitle: { type: Boolean, required: !1, default: !1 },
    canAddItem: { type: Boolean, required: !1, default: !1 },
    showViewFavoritesButton: { type: Boolean, required: !1, default: !1 }
  },
  emits: ["changeTitle", "addItem", "updateSearch", "updateFavorite"],
  setup(e, { emit: t }) {
    const n = t, i = ue("");
    return Se(i, (r) => {
      n("updateSearch", r);
    }), (r, s) => (le(), Te(Ir, { elevation: "0" }, {
      default: Z(() => [
        b(Da, {
          "no-gutters": "",
          justify: "center",
          align: "center"
        }, {
          default: Z(() => [
            b(hi, {
              cols: "12 ",
              md: "4",
              class: "d-flex justify-start"
            }, {
              default: Z(() => [
                b(Gs, { class: "px-0 text-h5 header-font" }, {
                  default: Z(() => [
                    Ee(At(e.title) + " ", 1),
                    e.canChangeTitle ? (le(), Te(rt, {
                      key: 0,
                      class: "mb-1",
                      color: "primary",
                      variant: "text",
                      icon: "$edit",
                      onClick: s[0] || (s[0] = Dt(() => n("changeTitle"), ["stop"]))
                    })) : it("", !0),
                    e.canAddItem ? (le(), Te(rt, {
                      key: 1,
                      class: "text-none mb-1",
                      color: "primary",
                      variant: "flat",
                      "prepend-icon": "mdi-plus",
                      onClick: s[1] || (s[1] = Dt(() => n("addItem"), ["stop"]))
                    }, {
                      default: Z(() => [
                        Ee(At(e.addTitle), 1)
                      ]),
                      _: 1
                    })) : it("", !0)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            b(hi, {
              cols: "12",
              md: "2"
            }),
            b(hi, {
              cols: "12",
              md: "6",
              class: "d-flex justify-end"
            }, {
              default: Z(() => [
                e.showViewFavoritesButton ? (le(), Te(rt, {
                  key: 0,
                  class: "text-none",
                  rounded: "lg",
                  color: "primary",
                  variant: "tonal",
                  "prepend-icon": e.favorite ? "mdi-check" : "",
                  onClick: s[2] || (s[2] = Dt(() => n("updateFavorite"), ["stop"]))
                }, {
                  default: Z(() => [
                    Ee(" View favorites ")
                  ]),
                  _: 1
                }, 8, ["prepend-icon"])) : it("", !0),
                St("div", BF, [
                  b(hl, {
                    modelValue: i.value,
                    "onUpdate:modelValue": s[3] || (s[3] = (a) => i.value = a),
                    density: "compact",
                    label: "Search",
                    "prepend-inner-icon": "mdi-magnify",
                    variant: "outlined",
                    "hide-details": ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), $F = /* @__PURE__ */ Tr(NF, [["__scopeId", "data-v-1bbebeb3"]]), zF = /* @__PURE__ */ Je({
  __name: "DataTableMenu",
  props: {
    filteredItems: { type: Array, required: !0 },
    selectedItems: { type: Array, required: !0 },
    canAddItem: { type: Boolean, required: !1, default: !0 },
    canChangeItem: { type: Boolean, required: !1, default: !0 },
    canDeleteItem: { type: Boolean, required: !1, default: !0 },
    showMoveToArchiveButton: { type: Boolean, required: !1, default: !1 },
    showDuplicateButton: { type: Boolean, required: !1, default: !1 },
    showDeleteButton: { type: Boolean, required: !1, default: !1 },
    hideSelectAll: { type: Boolean, required: !1, default: !1 }
  },
  emits: [
    "updateSelectedItems",
    "moveSelectedItemsToArchive",
    "duplicateSelectedItems",
    "deleteSelectedItems"
  ],
  setup(e, { emit: t }) {
    const n = e, i = t, r = I({
      get() {
        return n.filteredItems.every((l) => n.selectedItems.includes(l));
      },
      set: (l) => {
        i("updateSelectedItems", l, n.filteredItems);
      }
    }), s = I(() => a.value ? "revert" : "primary"), a = I(() => !n.selectedItems || !n.selectedItems.length);
    return (l, c) => (le(), Te(Da, {
      justify: "center",
      align: "center",
      class: "pa-4"
    }, {
      default: Z(() => [
        b(hi, {
          cols: "12",
          md: "6",
          class: "d-flex justify-start"
        }, {
          default: Z(() => {
            var d;
            return [
              (e.canAddItem || e.canChangeItem || e.canDeleteItem) && ((d = n.filteredItems) != null && d.length) && !e.hideSelectAll ? (le(), Te(Wm, {
                key: 0,
                modelValue: r.value,
                "onUpdate:modelValue": c[0] || (c[0] = (f) => r.value = f),
                label: "Select all",
                density: "compact",
                "hide-details": ""
              }, null, 8, ["modelValue"])) : it("", !0)
            ];
          }),
          _: 1
        }),
        b(hi, {
          cols: "12",
          md: "6",
          class: "d-flex justify-end"
        }, {
          default: Z(() => [
            e.canChangeItem && e.showMoveToArchiveButton ? (le(), Te(rt, {
              key: 0,
              class: "text-none my-1 mx-2",
              variant: "tonal",
              "prepend-icon": "mdi-archive-outline",
              color: s.value,
              disabled: a.value,
              onClick: c[1] || (c[1] = Dt(() => i("moveSelectedItemsToArchive"), ["stop"]))
            }, {
              default: Z(() => [
                Ee(" Move to archive ")
              ]),
              _: 1
            }, 8, ["color", "disabled"])) : it("", !0),
            e.canAddItem && e.showDuplicateButton ? (le(), Te(rt, {
              key: 1,
              class: "text-none my-1 mx-2",
              variant: "tonal",
              "prepend-icon": "mdi-content-duplicate",
              color: s.value,
              disabled: a.value,
              onClick: c[2] || (c[2] = Dt(() => i("duplicateSelectedItems"), ["stop"]))
            }, {
              default: Z(() => [
                Ee(" Duplicate ")
              ]),
              _: 1
            }, 8, ["color", "disabled"])) : it("", !0),
            e.canDeleteItem && e.showDeleteButton ? (le(), Te(rt, {
              key: 2,
              class: "text-none my-1 mx-2",
              variant: "tonal",
              "prepend-icon": "mdi-trash-can-outline",
              color: s.value,
              disabled: a.value,
              onClick: c[3] || (c[3] = Dt(() => i("deleteSelectedItems"), ["stop"]))
            }, {
              default: Z(() => [
                Ee(" Delete ")
              ]),
              _: 1
            }, 8, ["color", "disabled"])) : it("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), HF = /* @__PURE__ */ Je({
  __name: "DataTable",
  props: {
    headers: { type: Array, required: !0 },
    filteredItems: { type: Array, required: !0 }
  },
  setup(e) {
    return (t, n) => (le(), Te(Gm, {
      hover: "",
      headers: e.headers,
      items: e.filteredItems,
      itemsPerPage: 50
    }, {
      item: Z(({ item: i }) => [
        wt(t.$slots, "item", { item: i })
      ]),
      "no-data": Z(() => [
        e.filteredItems.length ? (le(), nt(Le, { key: 1 }, [
          Ee(" There are no matching items available.")
        ], 64)) : (le(), nt(Le, { key: 0 }, [
          Ee(" There are no items available.")
        ], 64))
      ]),
      _: 3
    }, 8, ["headers", "items"]));
  }
}), WF = /* @__PURE__ */ Je({
  __name: "RHDHVDataTable",
  props: {
    title: { type: String, required: !0 },
    addTitle: { type: String, required: !1, default: "Add" },
    headers: { type: Array, required: !0 },
    items: { type: Array, required: !0 },
    selectedItems: { type: Array, required: !0 },
    getFilteredItems: { type: Function, required: !0 },
    canChangeTitle: { type: Boolean, required: !1, default: !1 },
    canAddItem: { type: Boolean, required: !1, default: !1 },
    canChangeItem: { type: Boolean, required: !1, default: !1 },
    canDeleteItem: { type: Boolean, required: !1, default: !1 },
    showViewFavoritesButton: { type: Boolean, required: !1, default: !1 },
    showMoveToArchiveButton: { type: Boolean, required: !1, default: !1 },
    showDuplicateButton: { type: Boolean, required: !1, default: !1 },
    showDeleteButton: { type: Boolean, required: !1, default: !1 },
    hideSelectAll: { type: Boolean, required: !1, default: !1 }
  },
  emits: [
    "changeTitle",
    "addItem",
    "updateSelectedItems",
    "moveSelectedItemsToArchive",
    "duplicateSelectedItems",
    "deleteSelectedItems"
  ],
  setup(e, { emit: t }) {
    const n = e, i = t, r = ue(!1), s = ue(""), a = () => {
      r.value = !r.value;
    }, l = (d) => {
      s.value = d;
    }, c = I(() => n.getFilteredItems(n.items, s.value, r.value));
    return (d, f) => (le(), nt(Le, null, [
      b($F, {
        title: e.title,
        "add-title": e.addTitle,
        favorite: r.value,
        "can-change-title": e.canChangeTitle,
        "can-add-item": e.canAddItem,
        "show-view-favorites-button": e.showViewFavoritesButton,
        onChangeTitle: f[0] || (f[0] = () => i("changeTitle")),
        onAddItem: f[1] || (f[1] = () => i("addItem")),
        onUpdateFavorite: a,
        onUpdateSearch: l
      }, null, 8, ["title", "add-title", "favorite", "can-change-title", "can-add-item", "show-view-favorites-button"]),
      b(Ir, {
        border: "opacity-35 sm",
        class: "mx-auto mt-2",
        variant: "text"
      }, {
        default: Z(() => [
          b(zF, {
            "filtered-items": c.value,
            "selected-items": e.selectedItems,
            "can-add-item": e.canAddItem,
            "can-change-item": e.canChangeItem,
            "can-delete-item": e.canDeleteItem,
            "show-move-to-archive-button": e.showMoveToArchiveButton,
            "show-duplicate-button": e.showDuplicateButton,
            "show-delete-button": e.showDeleteButton,
            "hide-select-all": e.hideSelectAll,
            onUpdateSelectedItems: f[2] || (f[2] = (m, g) => i("updateSelectedItems", m, g)),
            onMoveSelectedItemsToArchive: f[3] || (f[3] = () => i("moveSelectedItemsToArchive")),
            onDuplicateSelectedItems: f[4] || (f[4] = () => i("duplicateSelectedItems")),
            onDeleteSelectedItems: f[5] || (f[5] = () => i("deleteSelectedItems"))
          }, null, 8, ["filtered-items", "selected-items", "can-add-item", "can-change-item", "can-delete-item", "show-move-to-archive-button", "show-duplicate-button", "show-delete-button", "hide-select-all"]),
          b(HF, {
            headers: e.headers,
            filteredItems: c.value
          }, {
            item: Z(({ item: m }) => [
              wt(d.$slots, "item", { item: m })
            ]),
            _: 3
          }, 8, ["headers", "filteredItems"])
        ]),
        _: 3
      })
    ], 64));
  }
}), UF = /* @__PURE__ */ Je({
  __name: "FavoriteButton",
  props: {
    item: { type: Object, required: !0 }
  },
  emits: ["updateFavorite"],
  setup(e, { emit: t }) {
    const n = e, i = I(() => n.item.favorite ? "mdi-star" : "mdi-star-outline"), r = I(() => n.item.favorite ? "yellow-darken-3" : "secondary"), s = I(
      () => n.item.favorite ? "Remove from favorites" : "Save as favorites"
    ), a = t;
    return (l, c) => (le(), Te(dl, { location: "top" }, {
      activator: Z(({ props: d }) => [
        b(rt, fe({
          color: r.value,
          icon: i.value
        }, d, {
          variant: "text",
          onClick: c[0] || (c[0] = Dt((f) => a("updateFavorite"), ["stop"]))
        }), null, 16, ["color", "icon"])
      ]),
      default: Z(() => [
        Ee(" " + At(s.value), 1)
      ]),
      _: 1
    }));
  }
}), qF = ee({
  color: {
    type: Object
  },
  disabled: Boolean,
  dotSize: {
    type: [Number, String],
    default: 10
  },
  height: {
    type: [Number, String],
    default: 150
  },
  width: {
    type: [Number, String],
    default: 300
  },
  ...Ae()
}, "VColorPickerCanvas"), jF = Zi({
  name: "VColorPickerCanvas",
  props: qF(),
  emits: {
    "update:color": (e) => !0,
    "update:position": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    const i = Ie(!1), r = ue(), s = Ie(parseFloat(e.width)), a = Ie(parseFloat(e.height)), l = ue({
      x: 0,
      y: 0
    }), c = I({
      get: () => l.value,
      set(x) {
        var M, E;
        if (!r.value)
          return;
        const {
          x: S,
          y: T
        } = x;
        l.value = x, n("update:color", {
          h: ((M = e.color) == null ? void 0 : M.h) ?? 0,
          s: Jt(S, 0, s.value) / s.value,
          v: 1 - Jt(T, 0, a.value) / a.value,
          a: ((E = e.color) == null ? void 0 : E.a) ?? 1
        });
      }
    }), d = I(() => {
      const {
        x,
        y: S
      } = c.value, T = parseInt(e.dotSize, 10) / 2;
      return {
        width: Ce(e.dotSize),
        height: Ce(e.dotSize),
        transform: `translate(${Ce(x - T)}, ${Ce(S - T)})`
      };
    }), {
      resizeRef: f
    } = Ws((x) => {
      var M;
      if (!((M = f.el) != null && M.offsetParent))
        return;
      const {
        width: S,
        height: T
      } = x[0].contentRect;
      s.value = S, a.value = T;
    });
    function m(x, S, T) {
      const {
        left: M,
        top: E,
        width: D,
        height: R
      } = T;
      c.value = {
        x: Jt(x - M, 0, D),
        y: Jt(S - E, 0, R)
      };
    }
    function g(x) {
      x.type === "mousedown" && x.preventDefault(), !e.disabled && (v(x), window.addEventListener("mousemove", v), window.addEventListener("mouseup", p), window.addEventListener("touchmove", v), window.addEventListener("touchend", p));
    }
    function v(x) {
      if (e.disabled || !r.value)
        return;
      i.value = !0;
      const S = xE(x);
      m(S.clientX, S.clientY, r.value.getBoundingClientRect());
    }
    function p() {
      window.removeEventListener("mousemove", v), window.removeEventListener("mouseup", p), window.removeEventListener("touchmove", v), window.removeEventListener("touchend", p);
    }
    function _() {
      var E;
      if (!r.value)
        return;
      const x = r.value, S = x.getContext("2d");
      if (!S)
        return;
      const T = S.createLinearGradient(0, 0, x.width, 0);
      T.addColorStop(0, "hsla(0, 0%, 100%, 1)"), T.addColorStop(1, `hsla(${((E = e.color) == null ? void 0 : E.h) ?? 0}, 100%, 50%, 1)`), S.fillStyle = T, S.fillRect(0, 0, x.width, x.height);
      const M = S.createLinearGradient(0, 0, 0, x.height);
      M.addColorStop(0, "hsla(0, 0%, 0%, 0)"), M.addColorStop(1, "hsla(0, 0%, 0%, 1)"), S.fillStyle = M, S.fillRect(0, 0, x.width, x.height);
    }
    return Se(() => {
      var x;
      return (x = e.color) == null ? void 0 : x.h;
    }, _, {
      immediate: !0
    }), Se(() => [s.value, a.value], (x, S) => {
      _(), l.value = {
        x: c.value.x * x[0] / S[0],
        y: c.value.y * x[1] / S[1]
      };
    }, {
      flush: "post"
    }), Se(() => e.color, () => {
      if (i.value) {
        i.value = !1;
        return;
      }
      l.value = e.color ? {
        x: e.color.s * s.value,
        y: (1 - e.color.v) * a.value
      } : {
        x: 0,
        y: 0
      };
    }, {
      deep: !0,
      immediate: !0
    }), Jn(() => _()), ke(() => b("div", {
      ref: f,
      class: ["v-color-picker-canvas", e.class],
      style: e.style,
      onMousedown: g,
      onTouchstartPassive: g
    }, [b("canvas", {
      ref: r,
      width: s.value,
      height: a.value
    }, null), e.color && b("div", {
      class: ["v-color-picker-canvas__dot", {
        "v-color-picker-canvas__dot--disabled": e.disabled
      }],
      style: d.value
    }, null)])), {};
  }
});
function GF(e, t) {
  if (t) {
    const {
      a: n,
      ...i
    } = e;
    return i;
  }
  return e;
}
function YF(e, t) {
  if (t == null || typeof t == "string") {
    const n = K0(e);
    return e.a === 1 ? n.slice(0, 7) : n;
  }
  if (typeof t == "object") {
    let n;
    return Ds(t, ["r", "g", "b"]) ? n = xr(e) : Ds(t, ["h", "s", "l"]) ? n = j0(e) : Ds(t, ["h", "s", "v"]) && (n = e), GF(n, !Ds(t, ["a"]) && e.a === 1);
  }
  return e;
}
const Ia = {
  h: 0,
  s: 0,
  v: 0,
  a: 1
}, Hh = {
  inputProps: {
    type: "number",
    min: 0
  },
  inputs: [{
    label: "R",
    max: 255,
    step: 1,
    getValue: (e) => Math.round(e.r),
    getColor: (e, t) => ({
      ...e,
      r: Number(t)
    })
  }, {
    label: "G",
    max: 255,
    step: 1,
    getValue: (e) => Math.round(e.g),
    getColor: (e, t) => ({
      ...e,
      g: Number(t)
    })
  }, {
    label: "B",
    max: 255,
    step: 1,
    getValue: (e) => Math.round(e.b),
    getColor: (e, t) => ({
      ...e,
      b: Number(t)
    })
  }, {
    label: "A",
    max: 1,
    step: 0.01,
    getValue: (e) => {
      let {
        a: t
      } = e;
      return t != null ? Math.round(t * 100) / 100 : 1;
    },
    getColor: (e, t) => ({
      ...e,
      a: Number(t)
    })
  }],
  to: xr,
  from: wl
};
var O0;
const ZF = {
  ...Hh,
  inputs: (O0 = Hh.inputs) == null ? void 0 : O0.slice(0, 3)
}, Wh = {
  inputProps: {
    type: "number",
    min: 0
  },
  inputs: [{
    label: "H",
    max: 360,
    step: 1,
    getValue: (e) => Math.round(e.h),
    getColor: (e, t) => ({
      ...e,
      h: Number(t)
    })
  }, {
    label: "S",
    max: 1,
    step: 0.01,
    getValue: (e) => Math.round(e.s * 100) / 100,
    getColor: (e, t) => ({
      ...e,
      s: Number(t)
    })
  }, {
    label: "L",
    max: 1,
    step: 0.01,
    getValue: (e) => Math.round(e.l * 100) / 100,
    getColor: (e, t) => ({
      ...e,
      l: Number(t)
    })
  }, {
    label: "A",
    max: 1,
    step: 0.01,
    getValue: (e) => {
      let {
        a: t
      } = e;
      return t != null ? Math.round(t * 100) / 100 : 1;
    },
    getColor: (e, t) => ({
      ...e,
      a: Number(t)
    })
  }],
  to: j0,
  from: vm
}, KF = {
  ...Wh,
  inputs: Wh.inputs.slice(0, 3)
}, qw = {
  inputProps: {
    type: "text"
  },
  inputs: [{
    label: "HEXA",
    getValue: (e) => e,
    getColor: (e, t) => t
  }],
  to: K0,
  from: $E
}, XF = {
  ...qw,
  inputs: [{
    label: "HEX",
    getValue: (e) => e.slice(0, 7),
    getColor: (e, t) => t
  }]
}, Ns = {
  rgb: ZF,
  rgba: Hh,
  hsl: KF,
  hsla: Wh,
  hex: XF,
  hexa: qw
}, JF = (e) => {
  let {
    label: t,
    ...n
  } = e;
  return b("div", {
    class: "v-color-picker-edit__input"
  }, [b("input", n, null), b("span", null, [t])]);
}, QF = ee({
  color: Object,
  disabled: Boolean,
  mode: {
    type: String,
    default: "rgba",
    validator: (e) => Object.keys(Ns).includes(e)
  },
  modes: {
    type: Array,
    default: () => Object.keys(Ns),
    validator: (e) => Array.isArray(e) && e.every((t) => Object.keys(Ns).includes(t))
  },
  ...Ae()
}, "VColorPickerEdit"), eR = Zi({
  name: "VColorPickerEdit",
  props: QF(),
  emits: {
    "update:color": (e) => !0,
    "update:mode": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    const i = I(() => e.modes.map((s) => ({
      ...Ns[s],
      name: s
    }))), r = I(() => {
      var l;
      const s = i.value.find((c) => c.name === e.mode);
      if (!s)
        return [];
      const a = e.color ? s.to(e.color) : null;
      return (l = s.inputs) == null ? void 0 : l.map((c) => {
        let {
          getValue: d,
          getColor: f,
          ...m
        } = c;
        return {
          ...s.inputProps,
          ...m,
          disabled: e.disabled,
          value: a && d(a),
          onChange: (g) => {
            const v = g.target;
            v && n("update:color", s.from(f(a ?? s.to(Ia), v.value)));
          }
        };
      });
    });
    return ke(() => {
      var s;
      return b("div", {
        class: ["v-color-picker-edit", e.class],
        style: e.style
      }, [(s = r.value) == null ? void 0 : s.map((a) => b(JF, a, null)), i.value.length > 1 && b(rt, {
        icon: "$unfold",
        size: "x-small",
        variant: "plain",
        onClick: () => {
          const a = i.value.findIndex((l) => l.name === e.mode);
          n("update:mode", i.value[(a + 1) % i.value.length].name);
        }
      }, null)]);
    }), {};
  }
}), Xm = Symbol.for("vuetify:v-slider");
function tR(e, t, n) {
  const i = n === "vertical", r = t.getBoundingClientRect(), s = "touches" in e ? e.touches[0] : e;
  return i ? s.clientY - (r.top + r.height / 2) : s.clientX - (r.left + r.width / 2);
}
function nR(e, t) {
  return "touches" in e && e.touches.length ? e.touches[0][t] : "changedTouches" in e && e.changedTouches.length ? e.changedTouches[0][t] : e[t];
}
const iR = ee({
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  readonly: {
    type: Boolean,
    default: null
  },
  max: {
    type: [Number, String],
    default: 100
  },
  min: {
    type: [Number, String],
    default: 0
  },
  step: {
    type: [Number, String],
    default: 0
  },
  thumbColor: String,
  thumbLabel: {
    type: [Boolean, String],
    default: void 0,
    validator: (e) => typeof e == "boolean" || e === "always"
  },
  thumbSize: {
    type: [Number, String],
    default: 20
  },
  showTicks: {
    type: [Boolean, String],
    default: !1,
    validator: (e) => typeof e == "boolean" || e === "always"
  },
  ticks: {
    type: [Array, Object]
  },
  tickSize: {
    type: [Number, String],
    default: 2
  },
  color: String,
  trackColor: String,
  trackFillColor: String,
  trackSize: {
    type: [Number, String],
    default: 4
  },
  direction: {
    type: String,
    default: "horizontal",
    validator: (e) => ["vertical", "horizontal"].includes(e)
  },
  reverse: Boolean,
  ...vn(),
  ...Xi({
    elevation: 2
  }),
  ripple: {
    type: Boolean,
    default: !0
  }
}, "Slider"), rR = (e) => {
  const t = I(() => parseFloat(e.min)), n = I(() => parseFloat(e.max)), i = I(() => +e.step > 0 ? parseFloat(e.step) : 0), r = I(() => Math.max(Ey(i.value), Ey(t.value)));
  function s(a) {
    if (a = parseFloat(a), i.value <= 0)
      return a;
    const l = Jt(a, t.value, n.value), c = t.value % i.value, d = Math.round((l - c) / i.value) * i.value + c;
    return parseFloat(Math.min(d, n.value).toFixed(r.value));
  }
  return {
    min: t,
    max: n,
    step: i,
    decimals: r,
    roundValue: s
  };
}, sR = (e) => {
  let {
    props: t,
    steps: n,
    onSliderStart: i,
    onSliderMove: r,
    onSliderEnd: s,
    getActiveThumb: a
  } = e;
  const {
    isRtl: l
  } = Tn(), c = ce(t, "reverse"), d = I(() => t.direction === "vertical"), f = I(() => d.value !== c.value), {
    min: m,
    max: g,
    step: v,
    decimals: p,
    roundValue: _
  } = n, x = I(() => parseInt(t.thumbSize, 10)), S = I(() => parseInt(t.tickSize, 10)), T = I(() => parseInt(t.trackSize, 10)), M = I(() => (g.value - m.value) / v.value), E = ce(t, "disabled"), D = I(() => t.error || t.disabled ? void 0 : t.thumbColor ?? t.color), R = I(() => t.error || t.disabled ? void 0 : t.trackColor ?? t.color), $ = I(() => t.error || t.disabled ? void 0 : t.trackFillColor ?? t.color), A = Ie(!1), V = Ie(0), H = ue(), B = ue();
  function N(Q) {
    var sn;
    const me = t.direction === "vertical", Ze = me ? "top" : "left", We = me ? "height" : "width", Ue = me ? "clientY" : "clientX", {
      [Ze]: Ot,
      [We]: ft
    } = (sn = H.value) == null ? void 0 : sn.$el.getBoundingClientRect(), yn = nR(Q, Ue);
    let xt = Math.min(Math.max((yn - Ot - V.value) / ft, 0), 1) || 0;
    return (me ? f.value : f.value !== l.value) && (xt = 1 - xt), _(m.value + xt * (g.value - m.value));
  }
  const q = (Q) => {
    s({
      value: N(Q)
    }), A.value = !1, V.value = 0;
  }, X = (Q) => {
    B.value = a(Q), B.value && (A.value = !0, B.value.contains(Q.target) ? V.value = tR(Q, B.value, t.direction) : (V.value = 0, r({
      value: N(Q)
    })), i({
      value: N(Q)
    }), Ct(() => {
      var me;
      return (me = B.value) == null ? void 0 : me.focus();
    }));
  }, se = {
    passive: !0,
    capture: !0
  };
  function de(Q) {
    r({
      value: N(Q)
    });
  }
  function _e(Q) {
    Q.stopPropagation(), Q.preventDefault(), q(Q), window.removeEventListener("mousemove", de, se), window.removeEventListener("mouseup", _e);
  }
  function be(Q) {
    var me;
    q(Q), window.removeEventListener("touchmove", de, se), (me = Q.target) == null || me.removeEventListener("touchend", be);
  }
  function oe(Q) {
    var me;
    X(Q), window.addEventListener("touchmove", de, se), (me = Q.target) == null || me.addEventListener("touchend", be, {
      passive: !1
    });
  }
  function J(Q) {
    Q.preventDefault(), X(Q), window.addEventListener("mousemove", de, se), window.addEventListener("mouseup", _e, {
      passive: !1
    });
  }
  const G = (Q) => {
    const me = (Q - m.value) / (g.value - m.value) * 100;
    return Jt(isNaN(me) ? 0 : me, 0, 100);
  }, ie = ce(t, "showTicks"), ge = I(() => ie.value ? t.ticks ? Array.isArray(t.ticks) ? t.ticks.map((Q) => ({
    value: Q,
    position: G(Q),
    label: Q.toString()
  })) : Object.keys(t.ticks).map((Q) => ({
    value: parseFloat(Q),
    position: G(parseFloat(Q)),
    label: t.ticks[Q]
  })) : M.value !== 1 / 0 ? Ho(M.value + 1).map((Q) => {
    const me = m.value + Q * v.value;
    return {
      value: me,
      position: G(me)
    };
  }) : [] : []), he = I(() => ge.value.some((Q) => {
    let {
      label: me
    } = Q;
    return !!me;
  })), Oe = {
    activeThumbRef: B,
    color: ce(t, "color"),
    decimals: p,
    disabled: E,
    direction: ce(t, "direction"),
    elevation: ce(t, "elevation"),
    hasLabels: he,
    isReversed: c,
    indexFromEnd: f,
    min: m,
    max: g,
    mousePressed: A,
    numTicks: M,
    onSliderMousedown: J,
    onSliderTouchstart: oe,
    parsedTicks: ge,
    parseMouseMove: N,
    position: G,
    readonly: ce(t, "readonly"),
    rounded: ce(t, "rounded"),
    roundValue: _,
    showTicks: ie,
    startOffset: V,
    step: v,
    thumbSize: x,
    thumbColor: D,
    thumbLabel: ce(t, "thumbLabel"),
    ticks: ce(t, "ticks"),
    tickSize: S,
    trackColor: R,
    trackContainerRef: H,
    trackFillColor: $,
    trackSize: T,
    vertical: d
  };
  return jt(Xm, Oe), Oe;
}, aR = ee({
  focused: Boolean,
  max: {
    type: Number,
    required: !0
  },
  min: {
    type: Number,
    required: !0
  },
  modelValue: {
    type: Number,
    required: !0
  },
  position: {
    type: Number,
    required: !0
  },
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  name: String,
  ...Ae()
}, "VSliderThumb"), oR = pe()({
  name: "VSliderThumb",
  directives: {
    Ripple: ja
  },
  props: aR(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n,
      emit: i
    } = t;
    const r = gt(Xm), {
      isRtl: s,
      rtlClasses: a
    } = Tn();
    if (!r)
      throw new Error("[Vuetify] v-slider-thumb must be used inside v-slider or v-range-slider");
    const {
      thumbColor: l,
      step: c,
      disabled: d,
      thumbSize: f,
      thumbLabel: m,
      direction: g,
      isReversed: v,
      vertical: p,
      readonly: _,
      elevation: x,
      mousePressed: S,
      decimals: T,
      indexFromEnd: M
    } = r, E = I(() => d.value ? void 0 : x.value), {
      elevationClasses: D
    } = Cr(E), {
      textColorClasses: R,
      textColorStyles: $
    } = Ei(l), {
      pageup: A,
      pagedown: V,
      end: H,
      home: B,
      left: N,
      right: q,
      down: X,
      up: se
    } = xh, de = [A, V, H, B, N, q, X, se], _e = I(() => c.value ? [1, 2, 3] : [1, 5, 10]);
    function be(J, G) {
      if (!de.includes(J.key))
        return;
      J.preventDefault();
      const ie = c.value || 0.1, ge = (e.max - e.min) / ie;
      if ([N, q, X, se].includes(J.key)) {
        const Oe = (p.value ? [s.value ? N : q, v.value ? X : se] : M.value !== s.value ? [N, se] : [q, se]).includes(J.key) ? 1 : -1, Q = J.shiftKey ? 2 : J.ctrlKey ? 1 : 0;
        G = G + Oe * ie * _e.value[Q];
      } else if (J.key === B)
        G = e.min;
      else if (J.key === H)
        G = e.max;
      else {
        const he = J.key === V ? 1 : -1;
        G = G - he * ie * (ge > 100 ? ge / 10 : 10);
      }
      return Math.max(e.min, Math.min(e.max, G));
    }
    function oe(J) {
      const G = be(J, e.modelValue);
      G != null && i("update:modelValue", G);
    }
    return ke(() => {
      const J = Ce(M.value ? 100 - e.position : e.position, "%");
      return b("div", {
        class: ["v-slider-thumb", {
          "v-slider-thumb--focused": e.focused,
          "v-slider-thumb--pressed": e.focused && S.value
        }, e.class, a.value],
        style: [{
          "--v-slider-thumb-position": J,
          "--v-slider-thumb-size": Ce(f.value)
        }, e.style],
        role: "slider",
        tabindex: d.value ? -1 : 0,
        "aria-label": e.name,
        "aria-valuemin": e.min,
        "aria-valuemax": e.max,
        "aria-valuenow": e.modelValue,
        "aria-readonly": !!_.value,
        "aria-orientation": g.value,
        onKeydown: _.value ? void 0 : oe
      }, [b("div", {
        class: ["v-slider-thumb__surface", R.value, D.value],
        style: {
          ...$.value
        }
      }, null), rn(b("div", {
        class: ["v-slider-thumb__ripple", R.value],
        style: $.value
      }, null), [[ji("ripple"), e.ripple, null, {
        circle: !0,
        center: !0
      }]]), b(EA, {
        origin: "bottom center"
      }, {
        default: () => {
          var G;
          return [rn(b("div", {
            class: "v-slider-thumb__label-container"
          }, [b("div", {
            class: ["v-slider-thumb__label"]
          }, [b("div", null, [((G = n["thumb-label"]) == null ? void 0 : G.call(n, {
            modelValue: e.modelValue
          })) ?? e.modelValue.toFixed(c.value ? T.value : 1)])])]), [[qs, m.value && e.focused || m.value === "always"]])];
        }
      })]);
    }), {};
  }
}), lR = ee({
  start: {
    type: Number,
    required: !0
  },
  stop: {
    type: Number,
    required: !0
  },
  ...Ae()
}, "VSliderTrack"), uR = pe()({
  name: "VSliderTrack",
  props: lR(),
  emits: {},
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = gt(Xm);
    if (!i)
      throw new Error("[Vuetify] v-slider-track must be inside v-slider or v-range-slider");
    const {
      color: r,
      parsedTicks: s,
      rounded: a,
      showTicks: l,
      tickSize: c,
      trackColor: d,
      trackFillColor: f,
      trackSize: m,
      vertical: g,
      min: v,
      max: p,
      indexFromEnd: _
    } = i, {
      roundedClasses: x
    } = Cn(a), {
      backgroundColorClasses: S,
      backgroundColorStyles: T
    } = Bn(f), {
      backgroundColorClasses: M,
      backgroundColorStyles: E
    } = Bn(d), D = I(() => `inset-${g.value ? "block" : "inline"}-${_.value ? "end" : "start"}`), R = I(() => g.value ? "height" : "width"), $ = I(() => ({
      [D.value]: "0%",
      [R.value]: "100%"
    })), A = I(() => e.stop - e.start), V = I(() => ({
      [D.value]: Ce(e.start, "%"),
      [R.value]: Ce(A.value, "%")
    })), H = I(() => l.value ? (g.value ? s.value.slice().reverse() : s.value).map((N, q) => {
      var se;
      const X = N.value !== v.value && N.value !== p.value ? Ce(N.position, "%") : void 0;
      return b("div", {
        key: N.value,
        class: ["v-slider-track__tick", {
          "v-slider-track__tick--filled": N.position >= e.start && N.position <= e.stop,
          "v-slider-track__tick--first": N.value === v.value,
          "v-slider-track__tick--last": N.value === p.value
        }],
        style: {
          [D.value]: X
        }
      }, [(N.label || n["tick-label"]) && b("div", {
        class: "v-slider-track__tick-label"
      }, [((se = n["tick-label"]) == null ? void 0 : se.call(n, {
        tick: N,
        index: q
      })) ?? N.label])]);
    }) : []);
    return ke(() => b("div", {
      class: ["v-slider-track", x.value, e.class],
      style: [{
        "--v-slider-track-size": Ce(m.value),
        "--v-slider-tick-size": Ce(c.value)
      }, e.style]
    }, [b("div", {
      class: ["v-slider-track__background", M.value, {
        "v-slider-track__background--opacity": !!r.value || !f.value
      }],
      style: {
        ...$.value,
        ...E.value
      }
    }, null), b("div", {
      class: ["v-slider-track__fill", S.value],
      style: {
        ...V.value,
        ...T.value
      }
    }, null), l.value && b("div", {
      class: ["v-slider-track__ticks", {
        "v-slider-track__ticks--always-show": l.value === "always"
      }]
    }, [H.value])])), {};
  }
}), cR = ee({
  ...Hm(),
  ...iR(),
  ...Fl(),
  modelValue: {
    type: [Number, String],
    default: 0
  }
}, "VSlider"), eb = pe()({
  name: "VSlider",
  props: cR(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    start: (e) => !0,
    end: (e) => !0
  },
  setup(e, t) {
    let {
      slots: n,
      emit: i
    } = t;
    const r = ue(), {
      rtlClasses: s
    } = Tn(), a = rR(e), l = at(e, "modelValue", void 0, (R) => a.roundValue(R ?? a.min.value)), {
      min: c,
      max: d,
      mousePressed: f,
      roundValue: m,
      onSliderMousedown: g,
      onSliderTouchstart: v,
      trackContainerRef: p,
      position: _,
      hasLabels: x,
      readonly: S
    } = sR({
      props: e,
      steps: a,
      onSliderStart: () => {
        i("start", l.value);
      },
      onSliderEnd: (R) => {
        let {
          value: $
        } = R;
        const A = m($);
        l.value = A, i("end", A);
      },
      onSliderMove: (R) => {
        let {
          value: $
        } = R;
        return l.value = m($);
      },
      getActiveThumb: () => {
        var R;
        return (R = r.value) == null ? void 0 : R.$el;
      }
    }), {
      isFocused: T,
      focus: M,
      blur: E
    } = Ll(e), D = I(() => _(l.value));
    return ke(() => {
      const R = is.filterProps(e), $ = !!(e.label || n.label || n.prepend);
      return b(is, fe({
        class: ["v-slider", {
          "v-slider--has-labels": !!n["tick-label"] || x.value,
          "v-slider--focused": T.value,
          "v-slider--pressed": f.value,
          "v-slider--disabled": e.disabled
        }, s.value, e.class],
        style: e.style
      }, R, {
        focused: T.value
      }), {
        ...n,
        prepend: $ ? (A) => {
          var V, H;
          return b(Le, null, [((V = n.label) == null ? void 0 : V.call(n, A)) ?? (e.label ? b(zm, {
            id: A.id.value,
            class: "v-slider__label",
            text: e.label
          }, null) : void 0), (H = n.prepend) == null ? void 0 : H.call(n, A)]);
        } : void 0,
        default: (A) => {
          let {
            id: V,
            messagesId: H
          } = A;
          return b("div", {
            class: "v-slider__container",
            onMousedown: S.value ? void 0 : g,
            onTouchstartPassive: S.value ? void 0 : v
          }, [b("input", {
            id: V.value,
            name: e.name || V.value,
            disabled: !!e.disabled,
            readonly: !!e.readonly,
            tabindex: "-1",
            value: l.value
          }, null), b(uR, {
            ref: p,
            start: 0,
            stop: D.value
          }, {
            "tick-label": n["tick-label"]
          }), b(oR, {
            ref: r,
            "aria-describedby": H.value,
            focused: T.value,
            min: c.value,
            max: d.value,
            modelValue: l.value,
            "onUpdate:modelValue": (B) => l.value = B,
            position: D.value,
            elevation: e.elevation,
            onFocus: M,
            onBlur: E,
            ripple: e.ripple,
            name: e.name
          }, {
            "thumb-label": n["thumb-label"]
          })]);
        }
      });
    }), {};
  }
}), dR = ee({
  color: {
    type: Object
  },
  disabled: Boolean,
  hideAlpha: Boolean,
  ...Ae()
}, "VColorPickerPreview"), fR = Zi({
  name: "VColorPickerPreview",
  props: dR(),
  emits: {
    "update:color": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    const i = new AbortController();
    V0(() => i.abort());
    async function r() {
      if (!Ty)
        return;
      const s = new window.EyeDropper();
      try {
        const a = await s.open({
          signal: i.signal
        }), l = wl(yr(a.sRGBHex));
        n("update:color", {
          ...e.color ?? Ia,
          ...l
        });
      } catch {
      }
    }
    return ke(() => {
      var s, a;
      return b("div", {
        class: ["v-color-picker-preview", {
          "v-color-picker-preview--hide-alpha": e.hideAlpha
        }, e.class],
        style: e.style
      }, [Ty && b("div", {
        class: "v-color-picker-preview__eye-dropper",
        key: "eyeDropper"
      }, [b(rt, {
        onClick: r,
        icon: "$eyeDropper",
        variant: "plain",
        density: "comfortable"
      }, null)]), b("div", {
        class: "v-color-picker-preview__dot"
      }, [b("div", {
        style: {
          background: Y0(e.color ?? Ia)
        }
      }, null)]), b("div", {
        class: "v-color-picker-preview__sliders"
      }, [b(eb, {
        class: "v-color-picker-preview__track v-color-picker-preview__hue",
        modelValue: (s = e.color) == null ? void 0 : s.h,
        "onUpdate:modelValue": (l) => n("update:color", {
          ...e.color ?? Ia,
          h: l
        }),
        step: 0,
        min: 0,
        max: 360,
        disabled: e.disabled,
        thumbSize: 14,
        trackSize: 8,
        trackFillColor: "white",
        hideDetails: !0
      }, null), !e.hideAlpha && b(eb, {
        class: "v-color-picker-preview__track v-color-picker-preview__alpha",
        modelValue: ((a = e.color) == null ? void 0 : a.a) ?? 1,
        "onUpdate:modelValue": (l) => n("update:color", {
          ...e.color ?? Ia,
          a: l
        }),
        step: 1 / 256,
        min: 0,
        max: 1,
        disabled: e.disabled,
        thumbSize: 14,
        trackSize: 8,
        trackFillColor: "white",
        hideDetails: !0
      }, null)])]);
    }), {};
  }
}), hR = {
  base: "#f44336",
  lighten5: "#ffebee",
  lighten4: "#ffcdd2",
  lighten3: "#ef9a9a",
  lighten2: "#e57373",
  lighten1: "#ef5350",
  darken1: "#e53935",
  darken2: "#d32f2f",
  darken3: "#c62828",
  darken4: "#b71c1c",
  accent1: "#ff8a80",
  accent2: "#ff5252",
  accent3: "#ff1744",
  accent4: "#d50000"
}, mR = {
  base: "#e91e63",
  lighten5: "#fce4ec",
  lighten4: "#f8bbd0",
  lighten3: "#f48fb1",
  lighten2: "#f06292",
  lighten1: "#ec407a",
  darken1: "#d81b60",
  darken2: "#c2185b",
  darken3: "#ad1457",
  darken4: "#880e4f",
  accent1: "#ff80ab",
  accent2: "#ff4081",
  accent3: "#f50057",
  accent4: "#c51162"
}, gR = {
  base: "#9c27b0",
  lighten5: "#f3e5f5",
  lighten4: "#e1bee7",
  lighten3: "#ce93d8",
  lighten2: "#ba68c8",
  lighten1: "#ab47bc",
  darken1: "#8e24aa",
  darken2: "#7b1fa2",
  darken3: "#6a1b9a",
  darken4: "#4a148c",
  accent1: "#ea80fc",
  accent2: "#e040fb",
  accent3: "#d500f9",
  accent4: "#aa00ff"
}, vR = {
  base: "#673ab7",
  lighten5: "#ede7f6",
  lighten4: "#d1c4e9",
  lighten3: "#b39ddb",
  lighten2: "#9575cd",
  lighten1: "#7e57c2",
  darken1: "#5e35b1",
  darken2: "#512da8",
  darken3: "#4527a0",
  darken4: "#311b92",
  accent1: "#b388ff",
  accent2: "#7c4dff",
  accent3: "#651fff",
  accent4: "#6200ea"
}, yR = {
  base: "#3f51b5",
  lighten5: "#e8eaf6",
  lighten4: "#c5cae9",
  lighten3: "#9fa8da",
  lighten2: "#7986cb",
  lighten1: "#5c6bc0",
  darken1: "#3949ab",
  darken2: "#303f9f",
  darken3: "#283593",
  darken4: "#1a237e",
  accent1: "#8c9eff",
  accent2: "#536dfe",
  accent3: "#3d5afe",
  accent4: "#304ffe"
}, pR = {
  base: "#2196f3",
  lighten5: "#e3f2fd",
  lighten4: "#bbdefb",
  lighten3: "#90caf9",
  lighten2: "#64b5f6",
  lighten1: "#42a5f5",
  darken1: "#1e88e5",
  darken2: "#1976d2",
  darken3: "#1565c0",
  darken4: "#0d47a1",
  accent1: "#82b1ff",
  accent2: "#448aff",
  accent3: "#2979ff",
  accent4: "#2962ff"
}, bR = {
  base: "#03a9f4",
  lighten5: "#e1f5fe",
  lighten4: "#b3e5fc",
  lighten3: "#81d4fa",
  lighten2: "#4fc3f7",
  lighten1: "#29b6f6",
  darken1: "#039be5",
  darken2: "#0288d1",
  darken3: "#0277bd",
  darken4: "#01579b",
  accent1: "#80d8ff",
  accent2: "#40c4ff",
  accent3: "#00b0ff",
  accent4: "#0091ea"
}, xR = {
  base: "#00bcd4",
  lighten5: "#e0f7fa",
  lighten4: "#b2ebf2",
  lighten3: "#80deea",
  lighten2: "#4dd0e1",
  lighten1: "#26c6da",
  darken1: "#00acc1",
  darken2: "#0097a7",
  darken3: "#00838f",
  darken4: "#006064",
  accent1: "#84ffff",
  accent2: "#18ffff",
  accent3: "#00e5ff",
  accent4: "#00b8d4"
}, _R = {
  base: "#009688",
  lighten5: "#e0f2f1",
  lighten4: "#b2dfdb",
  lighten3: "#80cbc4",
  lighten2: "#4db6ac",
  lighten1: "#26a69a",
  darken1: "#00897b",
  darken2: "#00796b",
  darken3: "#00695c",
  darken4: "#004d40",
  accent1: "#a7ffeb",
  accent2: "#64ffda",
  accent3: "#1de9b6",
  accent4: "#00bfa5"
}, wR = {
  base: "#4caf50",
  lighten5: "#e8f5e9",
  lighten4: "#c8e6c9",
  lighten3: "#a5d6a7",
  lighten2: "#81c784",
  lighten1: "#66bb6a",
  darken1: "#43a047",
  darken2: "#388e3c",
  darken3: "#2e7d32",
  darken4: "#1b5e20",
  accent1: "#b9f6ca",
  accent2: "#69f0ae",
  accent3: "#00e676",
  accent4: "#00c853"
}, SR = {
  base: "#8bc34a",
  lighten5: "#f1f8e9",
  lighten4: "#dcedc8",
  lighten3: "#c5e1a5",
  lighten2: "#aed581",
  lighten1: "#9ccc65",
  darken1: "#7cb342",
  darken2: "#689f38",
  darken3: "#558b2f",
  darken4: "#33691e",
  accent1: "#ccff90",
  accent2: "#b2ff59",
  accent3: "#76ff03",
  accent4: "#64dd17"
}, kR = {
  base: "#cddc39",
  lighten5: "#f9fbe7",
  lighten4: "#f0f4c3",
  lighten3: "#e6ee9c",
  lighten2: "#dce775",
  lighten1: "#d4e157",
  darken1: "#c0ca33",
  darken2: "#afb42b",
  darken3: "#9e9d24",
  darken4: "#827717",
  accent1: "#f4ff81",
  accent2: "#eeff41",
  accent3: "#c6ff00",
  accent4: "#aeea00"
}, CR = {
  base: "#ffeb3b",
  lighten5: "#fffde7",
  lighten4: "#fff9c4",
  lighten3: "#fff59d",
  lighten2: "#fff176",
  lighten1: "#ffee58",
  darken1: "#fdd835",
  darken2: "#fbc02d",
  darken3: "#f9a825",
  darken4: "#f57f17",
  accent1: "#ffff8d",
  accent2: "#ffff00",
  accent3: "#ffea00",
  accent4: "#ffd600"
}, TR = {
  base: "#ffc107",
  lighten5: "#fff8e1",
  lighten4: "#ffecb3",
  lighten3: "#ffe082",
  lighten2: "#ffd54f",
  lighten1: "#ffca28",
  darken1: "#ffb300",
  darken2: "#ffa000",
  darken3: "#ff8f00",
  darken4: "#ff6f00",
  accent1: "#ffe57f",
  accent2: "#ffd740",
  accent3: "#ffc400",
  accent4: "#ffab00"
}, IR = {
  base: "#ff9800",
  lighten5: "#fff3e0",
  lighten4: "#ffe0b2",
  lighten3: "#ffcc80",
  lighten2: "#ffb74d",
  lighten1: "#ffa726",
  darken1: "#fb8c00",
  darken2: "#f57c00",
  darken3: "#ef6c00",
  darken4: "#e65100",
  accent1: "#ffd180",
  accent2: "#ffab40",
  accent3: "#ff9100",
  accent4: "#ff6d00"
}, PR = {
  base: "#ff5722",
  lighten5: "#fbe9e7",
  lighten4: "#ffccbc",
  lighten3: "#ffab91",
  lighten2: "#ff8a65",
  lighten1: "#ff7043",
  darken1: "#f4511e",
  darken2: "#e64a19",
  darken3: "#d84315",
  darken4: "#bf360c",
  accent1: "#ff9e80",
  accent2: "#ff6e40",
  accent3: "#ff3d00",
  accent4: "#dd2c00"
}, OR = {
  base: "#795548",
  lighten5: "#efebe9",
  lighten4: "#d7ccc8",
  lighten3: "#bcaaa4",
  lighten2: "#a1887f",
  lighten1: "#8d6e63",
  darken1: "#6d4c41",
  darken2: "#5d4037",
  darken3: "#4e342e",
  darken4: "#3e2723"
}, ER = {
  base: "#607d8b",
  lighten5: "#eceff1",
  lighten4: "#cfd8dc",
  lighten3: "#b0bec5",
  lighten2: "#90a4ae",
  lighten1: "#78909c",
  darken1: "#546e7a",
  darken2: "#455a64",
  darken3: "#37474f",
  darken4: "#263238"
}, AR = {
  base: "#9e9e9e",
  lighten5: "#fafafa",
  lighten4: "#f5f5f5",
  lighten3: "#eeeeee",
  lighten2: "#e0e0e0",
  lighten1: "#bdbdbd",
  darken1: "#757575",
  darken2: "#616161",
  darken3: "#424242",
  darken4: "#212121"
}, MR = {
  black: "#000000",
  white: "#ffffff",
  transparent: "#ffffff00"
}, DR = {
  red: hR,
  pink: mR,
  purple: gR,
  deepPurple: vR,
  indigo: yR,
  blue: pR,
  lightBlue: bR,
  cyan: xR,
  teal: _R,
  green: wR,
  lightGreen: SR,
  lime: kR,
  yellow: CR,
  amber: TR,
  orange: IR,
  deepOrange: PR,
  brown: OR,
  blueGrey: ER,
  grey: AR,
  shades: MR
}, VR = ee({
  swatches: {
    type: Array,
    default: () => LR(DR)
  },
  disabled: Boolean,
  color: Object,
  maxHeight: [Number, String],
  ...Ae()
}, "VColorPickerSwatches");
function LR(e) {
  return Object.keys(e).map((t) => {
    const n = e[t];
    return n.base ? [n.base, n.darken4, n.darken3, n.darken2, n.darken1, n.lighten1, n.lighten2, n.lighten3, n.lighten4, n.lighten5] : [n.black, n.white, n.transparent];
  });
}
const FR = Zi({
  name: "VColorPickerSwatches",
  props: VR(),
  emits: {
    "update:color": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    return ke(() => b("div", {
      class: ["v-color-picker-swatches", e.class],
      style: [{
        maxHeight: Ce(e.maxHeight)
      }, e.style]
    }, [b("div", null, [e.swatches.map((i) => b("div", {
      class: "v-color-picker-swatches__swatch"
    }, [i.map((r) => {
      const s = yr(r), a = wl(s), l = G0(s);
      return b("div", {
        class: "v-color-picker-swatches__color",
        onClick: () => a && n("update:color", a)
      }, [b("div", {
        style: {
          background: l
        }
      }, [e.color && Sr(e.color, a) ? b(dt, {
        size: "x-small",
        icon: "$success",
        color: HE(r, "#FFFFFF") > 2 ? "white" : "black"
      }, null) : void 0])]);
    })]))])])), {};
  }
}), jw = ee({
  color: String,
  ...Ki(),
  ...Ae(),
  ...Di(),
  ...Xi(),
  ...El(),
  ...ad(),
  ...vn(),
  ...pt(),
  ...$t()
}, "VSheet"), tb = pe()({
  name: "VSheet",
  props: jw(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: i
    } = Zt(e), {
      backgroundColorClasses: r,
      backgroundColorStyles: s
    } = Bn(ce(e, "color")), {
      borderClasses: a
    } = kr(e), {
      dimensionStyles: l
    } = Vi(e), {
      elevationClasses: c
    } = Cr(e), {
      locationStyles: d
    } = nd(e), {
      positionClasses: f
    } = od(e), {
      roundedClasses: m
    } = Cn(e);
    return ke(() => b(e.tag, {
      class: ["v-sheet", i.value, r.value, a.value, c.value, f.value, m.value, e.class],
      style: [s.value, l.value, d.value, e.style]
    }, n)), {};
  }
}), RR = ee({
  canvasHeight: {
    type: [String, Number],
    default: 150
  },
  disabled: Boolean,
  dotSize: {
    type: [Number, String],
    default: 10
  },
  hideCanvas: Boolean,
  hideSliders: Boolean,
  hideInputs: Boolean,
  mode: {
    type: String,
    default: "rgba",
    validator: (e) => Object.keys(Ns).includes(e)
  },
  modes: {
    type: Array,
    default: () => Object.keys(Ns),
    validator: (e) => Array.isArray(e) && e.every((t) => Object.keys(Ns).includes(t))
  },
  showSwatches: Boolean,
  swatches: Array,
  swatchesMaxHeight: {
    type: [Number, String],
    default: 150
  },
  modelValue: {
    type: [Object, String]
  },
  ...Gi(jw({
    width: 300
  }), ["height", "location", "minHeight", "maxHeight", "minWidth", "maxWidth"])
}, "VColorPicker"), BR = Zi({
  name: "VColorPicker",
  props: RR(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:mode": (e) => !0
  },
  setup(e) {
    const t = at(e, "mode"), n = ue(null), i = at(e, "modelValue", void 0, (c) => {
      if (c == null || c === "")
        return null;
      let d;
      try {
        d = wl(yr(c));
      } catch (f) {
        return Ui(f), null;
      }
      return d;
    }, (c) => c ? YF(c, e.modelValue) : null), r = I(() => i.value ? {
      ...i.value,
      h: n.value ?? i.value.h
    } : null), {
      rtlClasses: s
    } = Tn();
    let a = !0;
    Se(i, (c) => {
      if (!a) {
        a = !0;
        return;
      }
      c && (n.value = c.h);
    }, {
      immediate: !0
    });
    const l = (c) => {
      a = !1, n.value = c.h, i.value = c;
    };
    return _l(() => {
      e.modes.includes(t.value) || (t.value = e.modes[0]);
    }), yi({
      VSlider: {
        color: void 0,
        trackColor: void 0,
        trackFillColor: void 0
      }
    }), ke(() => {
      const c = tb.filterProps(e);
      return b(tb, fe({
        rounded: e.rounded,
        elevation: e.elevation,
        theme: e.theme,
        class: ["v-color-picker", s.value, e.class],
        style: [{
          "--v-color-picker-color-hsv": Y0({
            ...r.value ?? Ia,
            a: 1
          })
        }, e.style]
      }, c, {
        maxWidth: e.width
      }), {
        default: () => [!e.hideCanvas && b(jF, {
          key: "canvas",
          color: r.value,
          "onUpdate:color": l,
          disabled: e.disabled,
          dotSize: e.dotSize,
          width: e.width,
          height: e.canvasHeight
        }, null), (!e.hideSliders || !e.hideInputs) && b("div", {
          key: "controls",
          class: "v-color-picker__controls"
        }, [!e.hideSliders && b(fR, {
          key: "preview",
          color: r.value,
          "onUpdate:color": l,
          hideAlpha: !t.value.endsWith("a"),
          disabled: e.disabled
        }, null), !e.hideInputs && b(eR, {
          key: "edit",
          modes: e.modes,
          mode: t.value,
          "onUpdate:mode": (d) => t.value = d,
          color: r.value,
          "onUpdate:color": l,
          disabled: e.disabled
        }, null)]), e.showSwatches && b(FR, {
          key: "swatches",
          color: r.value,
          "onUpdate:color": l,
          maxHeight: e.swatchesMaxHeight,
          swatches: e.swatches,
          disabled: e.disabled
        }, null)]
      });
    }), {};
  }
}), NR = { class: "d-flex justify-center" }, $R = /* @__PURE__ */ Je({
  __name: "ColourPicker",
  props: {
    item: { type: Object, required: !0 },
    isEditing: { type: Boolean, required: !0 }
  },
  emits: ["updateColour"],
  setup(e, { emit: t }) {
    const i = ce(e, "item"), r = t;
    return (s, a) => (le(), nt("div", NR, [
      b(td, {
        "offset-y": "",
        "close-on-content-click": !1,
        disabled: !e.isEditing
      }, {
        activator: Z(({ props: l }) => [
          St("div", fe(l, {
            style: {
              width: "25px",
              height: "20px",
              borderRadius: "4px",
              backgroundColor: i.value.colour
            },
            class: { "cursor-pointer": e.isEditing }
          }), null, 16)
        ]),
        default: Z(() => [
          b(BR, {
            modelValue: i.value.colour,
            "onUpdate:modelValue": [
              a[0] || (a[0] = (l) => i.value.colour = l),
              a[1] || (a[1] = (l) => r("updateColour", l))
            ]
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["disabled"])
    ]));
  }
}), zR = /* @__PURE__ */ Tr($R, [["__scopeId", "data-v-7e288c85"]]), HR = {
  key: 0,
  class: "pt-0"
}, WR = /* @__PURE__ */ Je({
  __name: "ChoiceField",
  props: {
    modelValue: { type: Object, required: !0 },
    itemKey: { type: String, required: !1 },
    label: { type: String, required: !1 },
    field: { type: Object, required: !0 },
    hideDetails: { type: Boolean, required: !1, default: !1 },
    center: { type: Boolean, required: !1, default: !1 },
    noPadding: { type: Boolean, required: !1, default: !1 },
    noLabel: { type: Boolean, required: !1, default: !1 },
    noHelpText: { type: Boolean, required: !1, default: !1 }
  },
  emits: ["update", "update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = ce(n, "modelValue"), s = ce(n, "field"), a = ue({
      required: (p) => p.length > 0 || "Required."
    }), l = I(() => n.itemKey ?? s.value.parameter), c = I({
      get() {
        return n.modelValue[l.value];
      },
      set(p) {
        r.value[l.value] = p, i("update:modelValue", n.modelValue), i("update");
      }
    }), d = I(() => ["required" in n.field && n.field.required ? a.value.required : !0]), f = I(() => n.noPadding ? "no-padding no-padding-append-inner" : ""), m = I(() => n.center ? "field-input-center" : ""), g = I(() => n.noLabel ? void 0 : n.label ? n.label : n.field.label), v = I(() => s.value.child ? s.value.child.choices : s.value.choices ?? []);
    return (p, _) => s.value ? (le(), nt("div", {
      key: 0,
      onClick: _[2] || (_[2] = Dt(() => {
      }, ["stop"]))
    }, [
      s.value.type === "choice" || s.value.type === "list" ? (le(), Te(hd, fe({
        key: 0,
        class: `${f.value} ${m.value}`,
        label: g.value,
        multiple: s.value.type === "list",
        color: "primary",
        items: v.value,
        "item-value": "value",
        "item-title": "display_name",
        rules: d.value,
        "hide-details": e.hideDetails,
        modelValue: c.value,
        "onUpdate:modelValue": _[0] || (_[0] = (x) => c.value = x)
      }, p.$attrs, {
        onClick: _[1] || (_[1] = Dt(() => {
        }, ["stop"]))
      }), {
        "append-inner": Z(() => [
          s.value.help_text && !e.noHelpText ? (le(), nt("div", HR, [
            b(Zm, {
              text: s.value.help_text
            }, null, 8, ["text"])
          ])) : it("", !0)
        ]),
        _: 1
      }, 16, ["class", "label", "multiple", "items", "rules", "hide-details", "modelValue"])) : it("", !0)
    ])) : it("", !0);
  }
}), UR = /* @__PURE__ */ Tr(WR, [["__scopeId", "data-v-a05b33cc"]]), qR = /* @__PURE__ */ Je({
  __name: "CheckboxField",
  props: {
    field: { type: Object, required: !0 },
    modelValue: { type: Object, required: !0 },
    label: { type: String, required: !1 },
    itemKey: { type: String, required: !1 },
    noLabel: { type: Boolean, required: !1, default: !1 }
  },
  emits: ["update", "update:modelValue", "click:prepend-inner"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = ce(n, "modelValue"), s = I(() => n.noLabel ? void 0 : n.label ? n.label : n.field.label), a = I(() => n.itemKey ?? n.field.parameter), l = I({
      get: () => r.value[a.value],
      set: (c) => {
        r.value[a.value] = c, i("update:modelValue", n.modelValue), i("update");
      }
    });
    return (c, d) => (le(), Te(Wm, fe({
      color: "primary",
      label: s.value,
      modelValue: l.value,
      "onUpdate:modelValue": d[0] || (d[0] = (f) => l.value = f)
    }, c.$attrs), null, 16, ["label", "modelValue"]));
  }
});
/*!
 * pinia v2.1.7
 * (c) 2023 Eduardo San Martin Morote
 * @license MIT
 */
process.env.NODE_ENV !== "production" ? Symbol("pinia") : (
  /* istanbul ignore next */
  Symbol()
);
var nb;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(nb || (nb = {}));
const jR = typeof window < "u";
process.env.NODE_ENV !== "production" && process.env.NODE_ENV;
process.env.NODE_ENV !== "production" ? Symbol("pinia:skipHydration") : (
  /* istanbul ignore next */
  Symbol()
);
function Jm(e) {
  {
    e = Pt(e);
    const t = {};
    for (const n in e) {
      const i = e[n];
      (qi(i) || mE(i)) && (t[n] = // ---
      ce(e, n));
    }
    return t;
  }
}
const GR = ee({
  fullscreen: Boolean,
  retainFocus: {
    type: Boolean,
    default: !0
  },
  scrollable: Boolean,
  ...Pl({
    origin: "center center",
    scrollStrategy: "block",
    transition: {
      component: Sm
    },
    zIndex: 2400
  })
}, "VDialog"), Qm = pe()({
  name: "VDialog",
  props: GR(),
  emits: {
    "update:modelValue": (e) => !0,
    afterEnter: () => !0,
    afterLeave: () => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: i
    } = t;
    const r = at(e, "modelValue"), {
      scopeId: s
    } = Il(), a = ue();
    function l(f) {
      var v, p;
      const m = f.relatedTarget, g = f.target;
      if (m !== g && ((v = a.value) != null && v.contentEl) && // We're the topmost dialog
      ((p = a.value) != null && p.globalTop) && // It isn't the document or the dialog body
      ![document, a.value.contentEl].includes(g) && // It isn't inside the dialog body
      !a.value.contentEl.contains(g)) {
        const _ = sl(a.value.contentEl);
        if (!_.length)
          return;
        const x = _[0], S = _[_.length - 1];
        m === x ? S.focus() : x.focus();
      }
    }
    kn(() => {
      document.removeEventListener("focusin", l);
    }), Bt && Se(() => r.value && e.retainFocus, (f) => {
      f ? document.addEventListener("focusin", l) : document.removeEventListener("focusin", l);
    }, {
      immediate: !0
    });
    function c() {
      var f;
      n("afterEnter"), (f = a.value) != null && f.contentEl && !a.value.contentEl.contains(document.activeElement) && a.value.contentEl.focus({
        preventScroll: !0
      });
    }
    function d() {
      n("afterLeave");
    }
    return Se(r, async (f) => {
      var m;
      f || (await Ct(), (m = a.value.activatorEl) == null || m.focus({
        preventScroll: !0
      }));
    }), ke(() => {
      const f = ns.filterProps(e), m = fe({
        "aria-haspopup": "dialog"
      }, e.activatorProps), g = fe({
        tabindex: -1
      }, e.contentProps);
      return b(ns, fe({
        ref: a,
        class: ["v-dialog", {
          "v-dialog--fullscreen": e.fullscreen,
          "v-dialog--scrollable": e.scrollable
        }, e.class],
        style: e.style
      }, f, {
        modelValue: r.value,
        "onUpdate:modelValue": (v) => r.value = v,
        "aria-modal": "true",
        activatorProps: m,
        contentProps: g,
        height: e.fullscreen ? void 0 : e.height,
        width: e.fullscreen ? void 0 : e.width,
        maxHeight: e.fullscreen ? void 0 : e.maxHeight,
        maxWidth: e.fullscreen ? void 0 : e.maxWidth,
        role: "dialog",
        onAfterEnter: c,
        onAfterLeave: d
      }, s), {
        activator: i.activator,
        default: function() {
          for (var v = arguments.length, p = new Array(v), _ = 0; _ < v; _++)
            p[_] = arguments[_];
          return b(Mt, {
            root: "VDialog"
          }, {
            default: () => {
              var x;
              return [(x = i.default) == null ? void 0 : x.call(i, ...p)];
            }
          });
        }
      });
    }), ls({}, a);
  }
}), YR = /* @__PURE__ */ Je({
  __name: "CreateOrUpdateDialog",
  props: {
    name: { type: String, required: !1 },
    store: { type: Object, required: !0 },
    overrideCreateUpdate: { type: Boolean, required: !1, default: !1 },
    disabledFields: { type: Array, required: !1, default: () => [] }
  },
  emits: ["postOrUpdate"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = n.store, { createUpdateDialog: s, writeLoading: a, currentItem: l } = Jm(r), c = ue(!1), d = I(() => {
      var m, g;
      return (m = l.value) != null && m.id ? "Update" : (g = l.value) != null && g.duplicated_id ? "Duplicate" : "Create";
    });
    async function f() {
      n.overrideCreateUpdate ? (await i("postOrUpdate", l.value), r.closeCreateUpdateDialog()) : (await r.postOrUpdate(l.value), r.closeCreateUpdateDialog());
    }
    return (m, g) => (le(), Te(Qm, {
      "model-value": je(s),
      "onClick:outside": g[3] || (g[3] = (v) => je(r).closeCreateUpdateDialog()),
      "max-width": "400"
    }, {
      default: Z(() => [
        b(Ir, { class: "pa-3" }, {
          default: Z(() => [
            b(Gs, null, {
              default: Z(() => [
                Ee(At(d.value) + " " + At(e.name), 1)
              ]),
              _: 1
            }),
            b(La, { class: "pl-4" }, {
              default: Z(() => [
                b(je(Uw), {
                  store: je(r),
                  "state-name": "currentItem",
                  modelValue: c.value,
                  "onUpdate:modelValue": g[0] || (g[0] = (v) => c.value = v),
                  "disabled-fields": e.disabledFields
                }, {
                  prepend: Z(() => [
                    wt(m.$slots, "default")
                  ]),
                  _: 3
                }, 8, ["store", "modelValue", "disabled-fields"])
              ]),
              _: 3
            }),
            b(Ol, null, {
              default: Z(() => [
                b(Qc),
                b(rt, {
                  disabled: je(a),
                  color: "primary text-none",
                  onClick: g[1] || (g[1] = (v) => je(r).closeCreateUpdateDialog())
                }, {
                  default: Z(() => [
                    Ee(" Cancel ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                b(rt, {
                  loading: je(a),
                  color: "primary text-none",
                  onClick: g[2] || (g[2] = (v) => f()),
                  disabled: !c.value
                }, {
                  default: Z(() => [
                    Ee(" Save ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["model-value"]));
  }
}), ZR = /* @__PURE__ */ St("span", null, "Delete", -1), KR = /* @__PURE__ */ Je({
  __name: "DeleteDialog",
  props: {
    name: {
      type: String,
      required: !1
    },
    message: {
      type: String,
      required: !1,
      default: "Delete <strong>{name}</strong>?"
    },
    store: {
      type: Object,
      required: !0
    },
    bulkDelete: {
      type: Boolean,
      required: !1,
      default: !1
    },
    itemsToDelete: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  emits: ["clearItemsToDelete"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = n.store, { deleteDialog: s, deleteLoading: a, deleteItem: l } = Jm(r);
    async function c() {
      n.bulkDelete && n.itemsToDelete.length ? (await r.bulkDelete(n.itemsToDelete), r.closeDeleteDialog(), i("clearItemsToDelete")) : (await r.delete(l.value), r.closeDeleteDialog());
    }
    const d = I(() => {
      var m;
      if (n.bulkDelete)
        return `Are you sure you want to delete these ${n.itemsToDelete.length} items?`;
      let f = "";
      return n.name ? f = n.name : f = (m = l.value) == null ? void 0 : m.name, n.message.replace(/{name}/g, f);
    });
    return (f, m) => (le(), Te(Qm, {
      modelValue: je(s),
      "onUpdate:modelValue": m[2] || (m[2] = (g) => qi(s) ? s.value = g : null),
      "max-width": "600",
      "onClick:outside": m[3] || (m[3] = (g) => je(r).closeDeleteDialog())
    }, {
      default: Z(() => [
        b(Ir, { class: "pa-3" }, {
          default: Z(() => [
            b(Gs, null, {
              default: Z(() => [
                ZR
              ]),
              _: 1
            }),
            b(La, {
              class: "pt-3 pl-4",
              innerHTML: d.value
            }, null, 8, ["innerHTML"]),
            wt(f.$slots, "info"),
            b(Ol, { class: "pa-0" }, {
              default: Z(() => [
                b(Qc),
                b(rt, {
                  onClick: m[0] || (m[0] = (g) => je(r).closeDeleteDialog()),
                  disabled: je(a),
                  variant: "text",
                  class: "text-none",
                  color: "primary"
                }, {
                  default: Z(() => [
                    Ee(" Cancel ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                b(rt, {
                  loading: je(a),
                  color: "red darken-1",
                  variant: "text",
                  class: "text-none",
                  onClick: m[1] || (m[1] = (g) => c())
                }, {
                  default: Z(() => [
                    Ee(" Delete ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["modelValue"]));
  }
}), XR = /* @__PURE__ */ St("span", null, "Duplicate", -1), JR = /* @__PURE__ */ Je({
  __name: "DuplicateDialog",
  props: {
    name: {
      type: String,
      required: !1
    },
    message: {
      type: String,
      required: !1,
      default: "Duplicate <strong>{name}</strong>?"
    },
    store: {
      type: Object,
      required: !0
    },
    bulkDuplicate: {
      type: Boolean,
      required: !1,
      default: !1
    },
    itemsToDuplicate: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  emits: ["clearItemsToDuplicate"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = n.store, { duplicateDialog: s, writeLoading: a, currentItem: l } = Jm(r);
    async function c() {
      n.bulkDuplicate && n.itemsToDuplicate.length ? (await r.bulkDuplicate(n.itemsToDuplicate), r.closeDuplicateDialog(), i("clearItemsToDuplicate")) : (await r.duplicate(l.value), r.closeDuplicateDialog());
    }
    const d = I(() => {
      var m;
      if (n.bulkDuplicate)
        return `Are you sure you want to duplicate these ${n.itemsToDuplicate.length} items?`;
      let f = "";
      return n.name ? f = n.name : f = (m = l.value) == null ? void 0 : m.name, n.message.replace(/{name}/g, f);
    });
    return (f, m) => (le(), Te(Qm, {
      modelValue: je(s),
      "onUpdate:modelValue": m[2] || (m[2] = (g) => qi(s) ? s.value = g : null),
      "max-width": "600",
      "onClick:outside": m[3] || (m[3] = (g) => je(r).closeDuplicateDialog())
    }, {
      default: Z(() => [
        b(Ir, { class: "pa-3" }, {
          default: Z(() => [
            b(Gs, null, {
              default: Z(() => [
                XR
              ]),
              _: 1
            }),
            b(La, {
              class: "pt-3 pl-4",
              innerHTML: d.value
            }, null, 8, ["innerHTML"]),
            wt(f.$slots, "info"),
            b(Ol, { class: "pa-0" }, {
              default: Z(() => [
                b(Qc),
                b(rt, {
                  onClick: m[0] || (m[0] = (g) => je(r).closeDuplicateDialog()),
                  disabled: je(a),
                  variant: "text",
                  class: "text-none",
                  color: "primary"
                }, {
                  default: Z(() => [
                    Ee(" Cancel ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                b(rt, {
                  loading: je(a),
                  color: "primary",
                  variant: "text",
                  class: "text-none",
                  onClick: m[1] || (m[1] = Dt((g) => c(), ["stop"]))
                }, {
                  default: Z(() => [
                    Ee(" Duplicate ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["modelValue"]));
  }
}), Gw = /* @__PURE__ */ Je({
  __name: "ShipTable",
  props: {
    items: { type: Array, required: !0 },
    loading: { type: Boolean, required: !1, default: !1 },
    headers: { type: Array, required: !0 },
    density: { type: String, required: !1, default: "default" },
    fixedHeader: { type: Boolean, required: !1, default: !0 },
    height: { type: String, required: !1, default: null },
    overflow: { type: Boolean, required: !1, default: !1 }
  },
  setup(e) {
    return (t, n) => (le(), Te(Gm, {
      items: e.items,
      headers: e.headers,
      density: e.density,
      loading: e.loading,
      "items-per-page": -1,
      height: e.height,
      "fixed-header": e.fixedHeader,
      class: D0({ "overflow-auto": e.overflow }),
      color: "primary",
      hover: ""
    }, {
      loader: Z(() => [
        b(id, {
          indeterminate: !0,
          color: "primary"
        })
      ]),
      loading: Z(() => [
        Ee(" Loading... ")
      ]),
      headers: Z(() => [
        wt(t.$slots, "table-header", {}, () => [
          b($h)
        ])
      ]),
      item: Z(({ item: i }) => [
        wt(t.$slots, "table-row", { item: i })
      ]),
      bottom: Z(() => []),
      _: 3
    }, 8, ["items", "headers", "density", "loading", "height", "fixed-header", "class"]));
  }
});
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function Rl(e) {
  return e + 0.5 | 0;
}
const Yr = (e, t, n) => Math.max(Math.min(e, n), t);
function qo(e) {
  return Yr(Rl(e * 2.55), 0, 255);
}
function Jr(e) {
  return Yr(Rl(e * 255), 0, 255);
}
function gr(e) {
  return Yr(Rl(e / 2.55) / 100, 0, 1);
}
function ib(e) {
  return Yr(Rl(e * 100), 0, 100);
}
const fi = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, Uh = [..."0123456789ABCDEF"], QR = (e) => Uh[e & 15], eB = (e) => Uh[(e & 240) >> 4] + Uh[e & 15], Yu = (e) => (e & 240) >> 4 === (e & 15), tB = (e) => Yu(e.r) && Yu(e.g) && Yu(e.b) && Yu(e.a);
function nB(e) {
  var t = e.length, n;
  return e[0] === "#" && (t === 4 || t === 5 ? n = {
    r: 255 & fi[e[1]] * 17,
    g: 255 & fi[e[2]] * 17,
    b: 255 & fi[e[3]] * 17,
    a: t === 5 ? fi[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (n = {
    r: fi[e[1]] << 4 | fi[e[2]],
    g: fi[e[3]] << 4 | fi[e[4]],
    b: fi[e[5]] << 4 | fi[e[6]],
    a: t === 9 ? fi[e[7]] << 4 | fi[e[8]] : 255
  })), n;
}
const iB = (e, t) => e < 255 ? t(e) : "";
function rB(e) {
  var t = tB(e) ? QR : eB;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + iB(e.a, t) : void 0;
}
const sB = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function Yw(e, t, n) {
  const i = t * Math.min(n, 1 - n), r = (s, a = (s + e / 30) % 12) => n - i * Math.max(Math.min(a - 3, 9 - a, 1), -1);
  return [r(0), r(8), r(4)];
}
function aB(e, t, n) {
  const i = (r, s = (r + e / 60) % 6) => n - n * t * Math.max(Math.min(s, 4 - s, 1), 0);
  return [i(5), i(3), i(1)];
}
function oB(e, t, n) {
  const i = Yw(e, 1, 0.5);
  let r;
  for (t + n > 1 && (r = 1 / (t + n), t *= r, n *= r), r = 0; r < 3; r++)
    i[r] *= 1 - t - n, i[r] += t;
  return i;
}
function lB(e, t, n, i, r) {
  return e === r ? (t - n) / i + (t < n ? 6 : 0) : t === r ? (n - e) / i + 2 : (e - t) / i + 4;
}
function eg(e) {
  const n = e.r / 255, i = e.g / 255, r = e.b / 255, s = Math.max(n, i, r), a = Math.min(n, i, r), l = (s + a) / 2;
  let c, d, f;
  return s !== a && (f = s - a, d = l > 0.5 ? f / (2 - s - a) : f / (s + a), c = lB(n, i, r, f, s), c = c * 60 + 0.5), [c | 0, d || 0, l];
}
function tg(e, t, n, i) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, i)).map(Jr);
}
function ng(e, t, n) {
  return tg(Yw, e, t, n);
}
function uB(e, t, n) {
  return tg(oB, e, t, n);
}
function cB(e, t, n) {
  return tg(aB, e, t, n);
}
function Zw(e) {
  return (e % 360 + 360) % 360;
}
function dB(e) {
  const t = sB.exec(e);
  let n = 255, i;
  if (!t)
    return;
  t[5] !== i && (n = t[6] ? qo(+t[5]) : Jr(+t[5]));
  const r = Zw(+t[2]), s = +t[3] / 100, a = +t[4] / 100;
  return t[1] === "hwb" ? i = uB(r, s, a) : t[1] === "hsv" ? i = cB(r, s, a) : i = ng(r, s, a), {
    r: i[0],
    g: i[1],
    b: i[2],
    a: n
  };
}
function fB(e, t) {
  var n = eg(e);
  n[0] = Zw(n[0] + t), n = ng(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
function hB(e) {
  if (!e)
    return;
  const t = eg(e), n = t[0], i = ib(t[1]), r = ib(t[2]);
  return e.a < 255 ? `hsla(${n}, ${i}%, ${r}%, ${gr(e.a)})` : `hsl(${n}, ${i}%, ${r}%)`;
}
const rb = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, sb = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function mB() {
  const e = {}, t = Object.keys(sb), n = Object.keys(rb);
  let i, r, s, a, l;
  for (i = 0; i < t.length; i++) {
    for (a = l = t[i], r = 0; r < n.length; r++)
      s = n[r], l = l.replace(s, rb[s]);
    s = parseInt(sb[a], 16), e[l] = [s >> 16 & 255, s >> 8 & 255, s & 255];
  }
  return e;
}
let Zu;
function gB(e) {
  Zu || (Zu = mB(), Zu.transparent = [0, 0, 0, 0]);
  const t = Zu[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const vB = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function yB(e) {
  const t = vB.exec(e);
  let n = 255, i, r, s;
  if (t) {
    if (t[7] !== i) {
      const a = +t[7];
      n = t[8] ? qo(a) : Yr(a * 255, 0, 255);
    }
    return i = +t[1], r = +t[3], s = +t[5], i = 255 & (t[2] ? qo(i) : Yr(i, 0, 255)), r = 255 & (t[4] ? qo(r) : Yr(r, 0, 255)), s = 255 & (t[6] ? qo(s) : Yr(s, 0, 255)), {
      r: i,
      g: r,
      b: s,
      a: n
    };
  }
}
function pB(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${gr(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const sh = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, Sa = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function bB(e, t, n) {
  const i = Sa(gr(e.r)), r = Sa(gr(e.g)), s = Sa(gr(e.b));
  return {
    r: Jr(sh(i + n * (Sa(gr(t.r)) - i))),
    g: Jr(sh(r + n * (Sa(gr(t.g)) - r))),
    b: Jr(sh(s + n * (Sa(gr(t.b)) - s))),
    a: e.a + n * (t.a - e.a)
  };
}
function Ku(e, t, n) {
  if (e) {
    let i = eg(e);
    i[t] = Math.max(0, Math.min(i[t] + i[t] * n, t === 0 ? 360 : 1)), i = ng(i), e.r = i[0], e.g = i[1], e.b = i[2];
  }
}
function Kw(e, t) {
  return e && Object.assign(t || {}, e);
}
function ab(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = Jr(e[3]))) : (t = Kw(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = Jr(t.a)), t;
}
function xB(e) {
  return e.charAt(0) === "r" ? yB(e) : dB(e);
}
class ml {
  constructor(t) {
    if (t instanceof ml)
      return t;
    const n = typeof t;
    let i;
    n === "object" ? i = ab(t) : n === "string" && (i = nB(t) || gB(t) || xB(t)), this._rgb = i, this._valid = !!i;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = Kw(this._rgb);
    return t && (t.a = gr(t.a)), t;
  }
  set rgb(t) {
    this._rgb = ab(t);
  }
  rgbString() {
    return this._valid ? pB(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? rB(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? hB(this._rgb) : void 0;
  }
  mix(t, n) {
    if (t) {
      const i = this.rgb, r = t.rgb;
      let s;
      const a = n === s ? 0.5 : n, l = 2 * a - 1, c = i.a - r.a, d = ((l * c === -1 ? l : (l + c) / (1 + l * c)) + 1) / 2;
      s = 1 - d, i.r = 255 & d * i.r + s * r.r + 0.5, i.g = 255 & d * i.g + s * r.g + 0.5, i.b = 255 & d * i.b + s * r.b + 0.5, i.a = a * i.a + (1 - a) * r.a, this.rgb = i;
    }
    return this;
  }
  interpolate(t, n) {
    return t && (this._rgb = bB(this._rgb, t._rgb, n)), this;
  }
  clone() {
    return new ml(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = Jr(t), this;
  }
  clearer(t) {
    const n = this._rgb;
    return n.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, n = Rl(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = n, this;
  }
  opaquer(t) {
    const n = this._rgb;
    return n.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return Ku(this._rgb, 2, t), this;
  }
  darken(t) {
    return Ku(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return Ku(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return Ku(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return fB(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.4.8
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
function fr() {
}
const _B = /* @__PURE__ */ (() => {
  let e = 0;
  return () => e++;
})();
function yt(e) {
  return e == null;
}
function qt(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function ct(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function tn(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function Gn(e, t) {
  return tn(e) ? e : t;
}
function Xe(e, t) {
  return typeof e > "u" ? t : e;
}
const wB = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function Fe(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
function et(e, t, n, i) {
  let r, s, a;
  if (qt(e))
    for (s = e.length, r = 0; r < s; r++)
      t.call(n, e[r], r);
  else if (ct(e))
    for (a = Object.keys(e), s = a.length, r = 0; r < s; r++)
      t.call(n, e[a[r]], a[r]);
}
function Vc(e, t) {
  let n, i, r, s;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, i = e.length; n < i; ++n)
    if (r = e[n], s = t[n], r.datasetIndex !== s.datasetIndex || r.index !== s.index)
      return !1;
  return !0;
}
function Lc(e) {
  if (qt(e))
    return e.map(Lc);
  if (ct(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), i = n.length;
    let r = 0;
    for (; r < i; ++r)
      t[n[r]] = Lc(e[n[r]]);
    return t;
  }
  return e;
}
function Xw(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function SB(e, t, n, i) {
  if (!Xw(e))
    return;
  const r = t[e], s = n[e];
  ct(r) && ct(s) ? gl(r, s, i) : t[e] = Lc(s);
}
function gl(e, t, n) {
  const i = qt(t) ? t : [
    t
  ], r = i.length;
  if (!ct(e))
    return e;
  n = n || {};
  const s = n.merger || SB;
  let a;
  for (let l = 0; l < r; ++l) {
    if (a = i[l], !ct(a))
      continue;
    const c = Object.keys(a);
    for (let d = 0, f = c.length; d < f; ++d)
      s(c[d], e, a, n);
  }
  return e;
}
function Jo(e, t) {
  return gl(e, t, {
    merger: kB
  });
}
function kB(e, t, n) {
  if (!Xw(e))
    return;
  const i = t[e], r = n[e];
  ct(i) && ct(r) ? Jo(i, r) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = Lc(r));
}
const ob = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function CB(e) {
  const t = e.split("."), n = [];
  let i = "";
  for (const r of t)
    i += r, i.endsWith("\\") ? i = i.slice(0, -1) + "." : (n.push(i), i = "");
  return n;
}
function TB(e) {
  const t = CB(e);
  return (n) => {
    for (const i of t) {
      if (i === "")
        break;
      n = n && n[i];
    }
    return n;
  };
}
function Fc(e, t) {
  return (ob[t] || (ob[t] = TB(t)))(e);
}
function ig(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const Rc = (e) => typeof e < "u", rs = (e) => typeof e == "function", lb = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
};
function IB(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const nn = Math.PI, vi = 2 * nn, PB = vi + nn, Bc = Number.POSITIVE_INFINITY, OB = nn / 180, Zn = nn / 2, Ps = nn / 4, ub = nn * 2 / 3, Zr = Math.log10, ss = Math.sign;
function $s(e, t, n) {
  return Math.abs(e - t) < n;
}
function cb(e) {
  const t = Math.round(e);
  e = $s(e, t, e / 1e3) ? t : e;
  const n = Math.pow(10, Math.floor(Zr(e))), i = e / n;
  return (i <= 1 ? 1 : i <= 2 ? 2 : i <= 5 ? 5 : 10) * n;
}
function EB(e) {
  const t = [], n = Math.sqrt(e);
  let i;
  for (i = 1; i < n; i++)
    e % i === 0 && (t.push(i), t.push(e / i));
  return n === (n | 0) && t.push(n), t.sort((r, s) => r - s).pop(), t;
}
function AB(e) {
  return typeof e == "symbol" || typeof e == "object" && e !== null && !(Symbol.toPrimitive in e || "toString" in e || "valueOf" in e);
}
function vl(e) {
  return !AB(e) && !isNaN(parseFloat(e)) && isFinite(e);
}
function MB(e, t) {
  const n = Math.round(e);
  return n - t <= e && n + t >= e;
}
function Jw(e, t, n) {
  let i, r, s;
  for (i = 0, r = e.length; i < r; i++)
    s = e[i][n], isNaN(s) || (t.min = Math.min(t.min, s), t.max = Math.max(t.max, s));
}
function Kr(e) {
  return e * (nn / 180);
}
function rg(e) {
  return e * (180 / nn);
}
function db(e) {
  if (!tn(e))
    return;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
function DB(e, t) {
  const n = t.x - e.x, i = t.y - e.y, r = Math.sqrt(n * n + i * i);
  let s = Math.atan2(i, n);
  return s < -0.5 * nn && (s += vi), {
    angle: s,
    distance: r
  };
}
function qh(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function VB(e, t) {
  return (e - t + PB) % vi - nn;
}
function Ii(e) {
  return (e % vi + vi) % vi;
}
function Qw(e, t, n, i) {
  const r = Ii(e), s = Ii(t), a = Ii(n), l = Ii(s - r), c = Ii(a - r), d = Ii(r - s), f = Ii(r - a);
  return r === s || r === a || i && s === a || l > c && d < f;
}
function Oi(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function LB(e) {
  return Oi(e, -32768, 32767);
}
function jo(e, t, n, i = 1e-6) {
  return e >= Math.min(t, n) - i && e <= Math.max(t, n) + i;
}
function sg(e, t, n) {
  n = n || ((a) => e[a] < t);
  let i = e.length - 1, r = 0, s;
  for (; i - r > 1; )
    s = r + i >> 1, n(s) ? r = s : i = s;
  return {
    lo: r,
    hi: i
  };
}
const Ls = (e, t, n, i) => sg(e, n, i ? (r) => {
  const s = e[r][t];
  return s < n || s === n && e[r + 1][t] === n;
} : (r) => e[r][t] < n), FB = (e, t, n) => sg(e, n, (i) => e[i][t] >= n);
function RB(e, t, n) {
  let i = 0, r = e.length;
  for (; i < r && e[i] < t; )
    i++;
  for (; r > i && e[r - 1] > n; )
    r--;
  return i > 0 || r < e.length ? e.slice(i, r) : e;
}
const eS = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function BB(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), eS.forEach((n) => {
    const i = "_onData" + ig(n), r = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...s) {
        const a = r.apply(this, s);
        return e._chartjs.listeners.forEach((l) => {
          typeof l[i] == "function" && l[i](...s);
        }), a;
      }
    });
  });
}
function fb(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const i = n.listeners, r = i.indexOf(t);
  r !== -1 && i.splice(r, 1), !(i.length > 0) && (eS.forEach((s) => {
    delete e[s];
  }), delete e._chartjs);
}
function NB(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const tS = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function nS(e, t) {
  let n = [], i = !1;
  return function(...r) {
    n = r, i || (i = !0, tS.call(window, () => {
      i = !1, e.apply(t, n);
    }));
  };
}
function $B(e, t) {
  let n;
  return function(...i) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, i)) : e.apply(this, i), t;
  };
}
const iS = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", jn = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2, zB = (e, t, n, i) => e === (i ? "left" : "right") ? n : e === "center" ? (t + n) / 2 : t;
function HB(e, t, n) {
  const i = t.length;
  let r = 0, s = i;
  if (e._sorted) {
    const { iScale: a, vScale: l, _parsed: c } = e, d = e.dataset && e.dataset.options ? e.dataset.options.spanGaps : null, f = a.axis, { min: m, max: g, minDefined: v, maxDefined: p } = a.getUserBounds();
    if (v) {
      if (r = Math.min(
        // @ts-expect-error Need to type _parsed
        Ls(c, f, m).lo,
        // @ts-expect-error Need to fix types on _lookupByKey
        n ? i : Ls(t, f, a.getPixelForValue(m)).lo
      ), d) {
        const _ = c.slice(0, r + 1).reverse().findIndex((x) => !yt(x[l.axis]));
        r -= Math.max(0, _);
      }
      r = Oi(r, 0, i - 1);
    }
    if (p) {
      let _ = Math.max(
        // @ts-expect-error Need to type _parsed
        Ls(c, a.axis, g, !0).hi + 1,
        // @ts-expect-error Need to fix types on _lookupByKey
        n ? 0 : Ls(t, f, a.getPixelForValue(g), !0).hi + 1
      );
      if (d) {
        const x = c.slice(_ - 1).findIndex((S) => !yt(S[l.axis]));
        _ += Math.max(0, x);
      }
      s = Oi(_, r, i) - r;
    } else
      s = i - r;
  }
  return {
    start: r,
    count: s
  };
}
function WB(e) {
  const { xScale: t, yScale: n, _scaleRanges: i } = e, r = {
    xmin: t.min,
    xmax: t.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!i)
    return e._scaleRanges = r, !0;
  const s = i.xmin !== t.min || i.xmax !== t.max || i.ymin !== n.min || i.ymax !== n.max;
  return Object.assign(i, r), s;
}
const Xu = (e) => e === 0 || e === 1, hb = (e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * vi / n)), mb = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * vi / n) + 1, Qo = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * Zn) + 1,
  easeOutSine: (e) => Math.sin(e * Zn),
  easeInOutSine: (e) => -0.5 * (Math.cos(nn * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => Xu(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => Xu(e) ? e : hb(e, 0.075, 0.3),
  easeOutElastic: (e) => Xu(e) ? e : mb(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return Xu(e) ? e : e < 0.5 ? 0.5 * hb(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * mb(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - Qo.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? Qo.easeInBounce(e * 2) * 0.5 : Qo.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function ag(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function gb(e) {
  return ag(e) ? e : new ml(e);
}
function ah(e) {
  return ag(e) ? e : new ml(e).saturate(0.5).darken(0.1).hexString();
}
const UB = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], qB = [
  "color",
  "borderColor",
  "backgroundColor"
];
function jB(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: qB
    },
    numbers: {
      type: "number",
      properties: UB
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function GB(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const vb = /* @__PURE__ */ new Map();
function YB(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let i = vb.get(n);
  return i || (i = new Intl.NumberFormat(e, t), vb.set(n, i)), i;
}
function og(e, t, n) {
  return YB(t, n).format(e);
}
const rS = {
  values(e) {
    return qt(e) ? e : "" + e;
  },
  numeric(e, t, n) {
    if (e === 0)
      return "0";
    const i = this.chart.options.locale;
    let r, s = e;
    if (n.length > 1) {
      const d = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (d < 1e-4 || d > 1e15) && (r = "scientific"), s = ZB(e, n);
    }
    const a = Zr(Math.abs(s)), l = isNaN(a) ? 1 : Math.max(Math.min(-1 * Math.floor(a), 20), 0), c = {
      notation: r,
      minimumFractionDigits: l,
      maximumFractionDigits: l
    };
    return Object.assign(c, this.options.ticks.format), og(e, i, c);
  },
  logarithmic(e, t, n) {
    if (e === 0)
      return "0";
    const i = n[t].significand || e / Math.pow(10, Math.floor(Zr(e)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(i) || t > 0.8 * n.length ? rS.numeric.call(this, e, t, n) : "";
  }
};
function ZB(e, t) {
  let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
var vd = {
  formatters: rS
};
function KB(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, n) => n.lineWidth,
      tickColor: (t, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: vd.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const Us = /* @__PURE__ */ Object.create(null), jh = /* @__PURE__ */ Object.create(null);
function el(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let i = 0, r = n.length; i < r; ++i) {
    const s = n[i];
    e = e[s] || (e[s] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function oh(e, t, n) {
  return typeof t == "string" ? gl(el(e, t), n) : gl(el(e, ""), t);
}
class XB {
  constructor(t, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (i) => i.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (i, r) => ah(r.backgroundColor), this.hoverBorderColor = (i, r) => ah(r.borderColor), this.hoverColor = (i, r) => ah(r.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(n);
  }
  set(t, n) {
    return oh(this, t, n);
  }
  get(t) {
    return el(this, t);
  }
  describe(t, n) {
    return oh(jh, t, n);
  }
  override(t, n) {
    return oh(Us, t, n);
  }
  route(t, n, i, r) {
    const s = el(this, t), a = el(this, i), l = "_" + n;
    Object.defineProperties(s, {
      [l]: {
        value: s[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const c = this[l], d = a[r];
          return ct(c) ? Object.assign({}, d, c) : Xe(c, d);
        },
        set(c) {
          this[l] = c;
        }
      }
    });
  }
  apply(t) {
    t.forEach((n) => n(this));
  }
}
var Rt = /* @__PURE__ */ new XB({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  jB,
  GB,
  KB
]);
function JB(e) {
  return !e || yt(e.size) || yt(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function Nc(e, t, n, i, r) {
  let s = t[r];
  return s || (s = t[r] = e.measureText(r).width, n.push(r)), s > i && (i = s), i;
}
function QB(e, t, n, i) {
  i = i || {};
  let r = i.data = i.data || {}, s = i.garbageCollect = i.garbageCollect || [];
  i.font !== t && (r = i.data = {}, s = i.garbageCollect = [], i.font = t), e.save(), e.font = t;
  let a = 0;
  const l = n.length;
  let c, d, f, m, g;
  for (c = 0; c < l; c++)
    if (m = n[c], m != null && !qt(m))
      a = Nc(e, r, s, a, m);
    else if (qt(m))
      for (d = 0, f = m.length; d < f; d++)
        g = m[d], g != null && !qt(g) && (a = Nc(e, r, s, a, g));
  e.restore();
  const v = s.length / 2;
  if (v > n.length) {
    for (c = 0; c < v; c++)
      delete r[s[c]];
    s.splice(0, v);
  }
  return a;
}
function Os(e, t, n) {
  const i = e.currentDevicePixelRatio, r = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - r) * i) / i + r;
}
function yb(e, t) {
  !t && !e || (t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore());
}
function Gh(e, t, n, i) {
  sS(e, t, n, i, null);
}
function sS(e, t, n, i, r) {
  let s, a, l, c, d, f, m, g;
  const v = t.pointStyle, p = t.rotation, _ = t.radius;
  let x = (p || 0) * OB;
  if (v && typeof v == "object" && (s = v.toString(), s === "[object HTMLImageElement]" || s === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(n, i), e.rotate(x), e.drawImage(v, -v.width / 2, -v.height / 2, v.width, v.height), e.restore();
    return;
  }
  if (!(isNaN(_) || _ <= 0)) {
    switch (e.beginPath(), v) {
      default:
        r ? e.ellipse(n, i, r / 2, _, 0, 0, vi) : e.arc(n, i, _, 0, vi), e.closePath();
        break;
      case "triangle":
        f = r ? r / 2 : _, e.moveTo(n + Math.sin(x) * f, i - Math.cos(x) * _), x += ub, e.lineTo(n + Math.sin(x) * f, i - Math.cos(x) * _), x += ub, e.lineTo(n + Math.sin(x) * f, i - Math.cos(x) * _), e.closePath();
        break;
      case "rectRounded":
        d = _ * 0.516, c = _ - d, a = Math.cos(x + Ps) * c, m = Math.cos(x + Ps) * (r ? r / 2 - d : c), l = Math.sin(x + Ps) * c, g = Math.sin(x + Ps) * (r ? r / 2 - d : c), e.arc(n - m, i - l, d, x - nn, x - Zn), e.arc(n + g, i - a, d, x - Zn, x), e.arc(n + m, i + l, d, x, x + Zn), e.arc(n - g, i + a, d, x + Zn, x + nn), e.closePath();
        break;
      case "rect":
        if (!p) {
          c = Math.SQRT1_2 * _, f = r ? r / 2 : c, e.rect(n - f, i - c, 2 * f, 2 * c);
          break;
        }
        x += Ps;
      case "rectRot":
        m = Math.cos(x) * (r ? r / 2 : _), a = Math.cos(x) * _, l = Math.sin(x) * _, g = Math.sin(x) * (r ? r / 2 : _), e.moveTo(n - m, i - l), e.lineTo(n + g, i - a), e.lineTo(n + m, i + l), e.lineTo(n - g, i + a), e.closePath();
        break;
      case "crossRot":
        x += Ps;
      case "cross":
        m = Math.cos(x) * (r ? r / 2 : _), a = Math.cos(x) * _, l = Math.sin(x) * _, g = Math.sin(x) * (r ? r / 2 : _), e.moveTo(n - m, i - l), e.lineTo(n + m, i + l), e.moveTo(n + g, i - a), e.lineTo(n - g, i + a);
        break;
      case "star":
        m = Math.cos(x) * (r ? r / 2 : _), a = Math.cos(x) * _, l = Math.sin(x) * _, g = Math.sin(x) * (r ? r / 2 : _), e.moveTo(n - m, i - l), e.lineTo(n + m, i + l), e.moveTo(n + g, i - a), e.lineTo(n - g, i + a), x += Ps, m = Math.cos(x) * (r ? r / 2 : _), a = Math.cos(x) * _, l = Math.sin(x) * _, g = Math.sin(x) * (r ? r / 2 : _), e.moveTo(n - m, i - l), e.lineTo(n + m, i + l), e.moveTo(n + g, i - a), e.lineTo(n - g, i + a);
        break;
      case "line":
        a = r ? r / 2 : Math.cos(x) * _, l = Math.sin(x) * _, e.moveTo(n - a, i - l), e.lineTo(n + a, i + l);
        break;
      case "dash":
        e.moveTo(n, i), e.lineTo(n + Math.cos(x) * (r ? r / 2 : _), i + Math.sin(x) * _);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function Wi(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function lg(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function ug(e) {
  e.restore();
}
function eN(e, t, n, i, r) {
  if (!t)
    return e.lineTo(n.x, n.y);
  if (r === "middle") {
    const s = (t.x + n.x) / 2;
    e.lineTo(s, t.y), e.lineTo(s, n.y);
  } else
    r === "after" != !!i ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
  e.lineTo(n.x, n.y);
}
function tN(e, t, n, i) {
  if (!t)
    return e.lineTo(n.x, n.y);
  e.bezierCurveTo(i ? t.cp1x : t.cp2x, i ? t.cp1y : t.cp2y, i ? n.cp2x : n.cp1x, i ? n.cp2y : n.cp1y, n.x, n.y);
}
function nN(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), yt(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function iN(e, t, n, i, r) {
  if (r.strikethrough || r.underline) {
    const s = e.measureText(i), a = t - s.actualBoundingBoxLeft, l = t + s.actualBoundingBoxRight, c = n - s.actualBoundingBoxAscent, d = n + s.actualBoundingBoxDescent, f = r.strikethrough ? (c + d) / 2 : d;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = r.decorationWidth || 2, e.moveTo(a, f), e.lineTo(l, f), e.stroke();
  }
}
function rN(e, t) {
  const n = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = n;
}
function Ba(e, t, n, i, r, s = {}) {
  const a = qt(t) ? t : [
    t
  ], l = s.strokeWidth > 0 && s.strokeColor !== "";
  let c, d;
  for (e.save(), e.font = r.string, nN(e, s), c = 0; c < a.length; ++c)
    d = a[c], s.backdrop && rN(e, s.backdrop), l && (s.strokeColor && (e.strokeStyle = s.strokeColor), yt(s.strokeWidth) || (e.lineWidth = s.strokeWidth), e.strokeText(d, n, i, s.maxWidth)), e.fillText(d, n, i, s.maxWidth), iN(e, n, i, d, s), i += Number(r.lineHeight);
  e.restore();
}
function $c(e, t) {
  const { x: n, y: i, w: r, h: s, radius: a } = t;
  e.arc(n + a.topLeft, i + a.topLeft, a.topLeft, 1.5 * nn, nn, !0), e.lineTo(n, i + s - a.bottomLeft), e.arc(n + a.bottomLeft, i + s - a.bottomLeft, a.bottomLeft, nn, Zn, !0), e.lineTo(n + r - a.bottomRight, i + s), e.arc(n + r - a.bottomRight, i + s - a.bottomRight, a.bottomRight, Zn, 0, !0), e.lineTo(n + r, i + a.topRight), e.arc(n + r - a.topRight, i + a.topRight, a.topRight, 0, -Zn, !0), e.lineTo(n + a.topLeft, i);
}
const sN = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, aN = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function oN(e, t) {
  const n = ("" + e).match(sN);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const lN = (e) => +e || 0;
function aS(e, t) {
  const n = {}, i = ct(t), r = i ? Object.keys(t) : t, s = ct(e) ? i ? (a) => Xe(e[a], e[t[a]]) : (a) => e[a] : () => e;
  for (const a of r)
    n[a] = lN(s(a));
  return n;
}
function uN(e) {
  return aS(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Ea(e) {
  return aS(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function Sn(e) {
  const t = uN(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function un(e, t) {
  e = e || {}, t = t || Rt.font;
  let n = Xe(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let i = Xe(e.style, t.style);
  i && !("" + i).match(aN) && (console.warn('Invalid font style specified: "' + i + '"'), i = void 0);
  const r = {
    family: Xe(e.family, t.family),
    lineHeight: oN(Xe(e.lineHeight, t.lineHeight), n),
    size: n,
    style: i,
    weight: Xe(e.weight, t.weight),
    string: ""
  };
  return r.string = JB(r), r;
}
function Ju(e, t, n, i) {
  let r, s, a;
  for (r = 0, s = e.length; r < s; ++r)
    if (a = e[r], a !== void 0 && a !== void 0)
      return a;
}
function cN(e, t, n) {
  const { min: i, max: r } = e, s = wB(t, (r - i) / 2), a = (l, c) => n && l === 0 ? 0 : l + c;
  return {
    min: a(i, -Math.abs(s)),
    max: a(r, s)
  };
}
function us(e, t) {
  return Object.assign(Object.create(e), t);
}
function cg(e, t = [
  ""
], n, i, r = () => e[0]) {
  const s = n || e;
  typeof i > "u" && (i = cS("_fallback", e));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: s,
    _fallback: i,
    _getTarget: r,
    override: (l) => cg([
      l,
      ...e
    ], t, s, i)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(l, c) {
      return delete l[c], delete l._keys, delete e[0][c], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(l, c) {
      return lS(l, c, () => pN(c, t, e, l));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(l, c) {
      return Reflect.getOwnPropertyDescriptor(l._scopes[0], c);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(l, c) {
      return bb(l).includes(c);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(l) {
      return bb(l);
    },
    /**
    * A trap for setting property values.
    */
    set(l, c, d) {
      const f = l._storage || (l._storage = r());
      return l[c] = f[c] = d, delete l._keys, !0;
    }
  });
}
function Na(e, t, n, i) {
  const r = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: oS(e, i),
    setContext: (s) => Na(e, s, n, i),
    override: (s) => Na(e.override(s), t, n, i)
  };
  return new Proxy(r, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(s, a) {
      return delete s[a], delete e[a], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(s, a, l) {
      return lS(s, a, () => fN(s, a, l));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(s, a) {
      return s._descriptors.allKeys ? Reflect.has(e, a) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, a);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(s, a) {
      return Reflect.has(e, a);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(s, a, l) {
      return e[a] = l, delete s[a], !0;
    }
  });
}
function oS(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = t.scriptable, _indexable: i = t.indexable, _allKeys: r = t.allKeys } = e;
  return {
    allKeys: r,
    scriptable: n,
    indexable: i,
    isScriptable: rs(n) ? n : () => n,
    isIndexable: rs(i) ? i : () => i
  };
}
const dN = (e, t) => e ? e + ig(t) : t, dg = (e, t) => ct(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function lS(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t) || t === "constructor")
    return e[t];
  const i = n();
  return e[t] = i, i;
}
function fN(e, t, n) {
  const { _proxy: i, _context: r, _subProxy: s, _descriptors: a } = e;
  let l = i[t];
  return rs(l) && a.isScriptable(t) && (l = hN(t, l, e, n)), qt(l) && l.length && (l = mN(t, l, e, a.isIndexable)), dg(t, l) && (l = Na(l, r, s && s[t], a)), l;
}
function hN(e, t, n, i) {
  const { _proxy: r, _context: s, _subProxy: a, _stack: l } = n;
  if (l.has(e))
    throw new Error("Recursion detected: " + Array.from(l).join("->") + "->" + e);
  l.add(e);
  let c = t(s, a || i);
  return l.delete(e), dg(e, c) && (c = fg(r._scopes, r, e, c)), c;
}
function mN(e, t, n, i) {
  const { _proxy: r, _context: s, _subProxy: a, _descriptors: l } = n;
  if (typeof s.index < "u" && i(e))
    return t[s.index % t.length];
  if (ct(t[0])) {
    const c = t, d = r._scopes.filter((f) => f !== c);
    t = [];
    for (const f of c) {
      const m = fg(d, r, e, f);
      t.push(Na(m, s, a && a[e], l));
    }
  }
  return t;
}
function uS(e, t, n) {
  return rs(e) ? e(t, n) : e;
}
const gN = (e, t) => e === !0 ? t : typeof e == "string" ? Fc(t, e) : void 0;
function vN(e, t, n, i, r) {
  for (const s of t) {
    const a = gN(n, s);
    if (a) {
      e.add(a);
      const l = uS(a._fallback, n, r);
      if (typeof l < "u" && l !== n && l !== i)
        return l;
    } else if (a === !1 && typeof i < "u" && n !== i)
      return null;
  }
  return !1;
}
function fg(e, t, n, i) {
  const r = t._rootScopes, s = uS(t._fallback, n, i), a = [
    ...e,
    ...r
  ], l = /* @__PURE__ */ new Set();
  l.add(i);
  let c = pb(l, a, n, s || n, i);
  return c === null || typeof s < "u" && s !== n && (c = pb(l, a, s, c, i), c === null) ? !1 : cg(Array.from(l), [
    ""
  ], r, s, () => yN(t, n, i));
}
function pb(e, t, n, i, r) {
  for (; n; )
    n = vN(e, t, n, i, r);
  return n;
}
function yN(e, t, n) {
  const i = e._getTarget();
  t in i || (i[t] = {});
  const r = i[t];
  return qt(r) && ct(n) ? n : r || {};
}
function pN(e, t, n, i) {
  let r;
  for (const s of t)
    if (r = cS(dN(s, e), n), typeof r < "u")
      return dg(e, r) ? fg(n, i, e, r) : r;
}
function cS(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const i = n[e];
    if (typeof i < "u")
      return i;
  }
}
function bb(e) {
  let t = e._keys;
  return t || (t = e._keys = bN(e._scopes)), t;
}
function bN(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const i of Object.keys(n).filter((r) => !r.startsWith("_")))
      t.add(i);
  return Array.from(t);
}
const xN = Number.EPSILON || 1e-14, $a = (e, t) => t < e.length && !e[t].skip && e[t], dS = (e) => e === "x" ? "y" : "x";
function _N(e, t, n, i) {
  const r = e.skip ? t : e, s = t, a = n.skip ? t : n, l = qh(s, r), c = qh(a, s);
  let d = l / (l + c), f = c / (l + c);
  d = isNaN(d) ? 0 : d, f = isNaN(f) ? 0 : f;
  const m = i * d, g = i * f;
  return {
    previous: {
      x: s.x - m * (a.x - r.x),
      y: s.y - m * (a.y - r.y)
    },
    next: {
      x: s.x + g * (a.x - r.x),
      y: s.y + g * (a.y - r.y)
    }
  };
}
function wN(e, t, n) {
  const i = e.length;
  let r, s, a, l, c, d = $a(e, 0);
  for (let f = 0; f < i - 1; ++f)
    if (c = d, d = $a(e, f + 1), !(!c || !d)) {
      if ($s(t[f], 0, xN)) {
        n[f] = n[f + 1] = 0;
        continue;
      }
      r = n[f] / t[f], s = n[f + 1] / t[f], l = Math.pow(r, 2) + Math.pow(s, 2), !(l <= 9) && (a = 3 / Math.sqrt(l), n[f] = r * a * t[f], n[f + 1] = s * a * t[f]);
    }
}
function SN(e, t, n = "x") {
  const i = dS(n), r = e.length;
  let s, a, l, c = $a(e, 0);
  for (let d = 0; d < r; ++d) {
    if (a = l, l = c, c = $a(e, d + 1), !l)
      continue;
    const f = l[n], m = l[i];
    a && (s = (f - a[n]) / 3, l[`cp1${n}`] = f - s, l[`cp1${i}`] = m - s * t[d]), c && (s = (c[n] - f) / 3, l[`cp2${n}`] = f + s, l[`cp2${i}`] = m + s * t[d]);
  }
}
function kN(e, t = "x") {
  const n = dS(t), i = e.length, r = Array(i).fill(0), s = Array(i);
  let a, l, c, d = $a(e, 0);
  for (a = 0; a < i; ++a)
    if (l = c, c = d, d = $a(e, a + 1), !!c) {
      if (d) {
        const f = d[t] - c[t];
        r[a] = f !== 0 ? (d[n] - c[n]) / f : 0;
      }
      s[a] = l ? d ? ss(r[a - 1]) !== ss(r[a]) ? 0 : (r[a - 1] + r[a]) / 2 : r[a - 1] : r[a];
    }
  wN(e, r, s), SN(e, s, t);
}
function Qu(e, t, n) {
  return Math.max(Math.min(e, n), t);
}
function CN(e, t) {
  let n, i, r, s, a, l = Wi(e[0], t);
  for (n = 0, i = e.length; n < i; ++n)
    a = s, s = l, l = n < i - 1 && Wi(e[n + 1], t), s && (r = e[n], a && (r.cp1x = Qu(r.cp1x, t.left, t.right), r.cp1y = Qu(r.cp1y, t.top, t.bottom)), l && (r.cp2x = Qu(r.cp2x, t.left, t.right), r.cp2y = Qu(r.cp2y, t.top, t.bottom)));
}
function TN(e, t, n, i, r) {
  let s, a, l, c;
  if (t.spanGaps && (e = e.filter((d) => !d.skip)), t.cubicInterpolationMode === "monotone")
    kN(e, r);
  else {
    let d = i ? e[e.length - 1] : e[0];
    for (s = 0, a = e.length; s < a; ++s)
      l = e[s], c = _N(d, l, e[Math.min(s + 1, a - (i ? 0 : 1)) % a], t.tension), l.cp1x = c.previous.x, l.cp1y = c.previous.y, l.cp2x = c.next.x, l.cp2y = c.next.y, d = l;
  }
  t.capBezierPoints && CN(e, n);
}
function hg() {
  return typeof window < "u" && typeof document < "u";
}
function mg(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function zc(e, t, n) {
  let i;
  return typeof e == "string" ? (i = parseInt(e, 10), e.indexOf("%") !== -1 && (i = i / 100 * t.parentNode[n])) : i = e, i;
}
const yd = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function IN(e, t) {
  return yd(e).getPropertyValue(t);
}
const PN = [
  "top",
  "right",
  "bottom",
  "left"
];
function zs(e, t, n) {
  const i = {};
  n = n ? "-" + n : "";
  for (let r = 0; r < 4; r++) {
    const s = PN[r];
    i[s] = parseFloat(e[t + "-" + s + n]) || 0;
  }
  return i.width = i.left + i.right, i.height = i.top + i.bottom, i;
}
const ON = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function EN(e, t) {
  const n = e.touches, i = n && n.length ? n[0] : e, { offsetX: r, offsetY: s } = i;
  let a = !1, l, c;
  if (ON(r, s, e.target))
    l = r, c = s;
  else {
    const d = t.getBoundingClientRect();
    l = i.clientX - d.left, c = i.clientY - d.top, a = !0;
  }
  return {
    x: l,
    y: c,
    box: a
  };
}
function Hi(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: i } = t, r = yd(n), s = r.boxSizing === "border-box", a = zs(r, "padding"), l = zs(r, "border", "width"), { x: c, y: d, box: f } = EN(e, n), m = a.left + (f && l.left), g = a.top + (f && l.top);
  let { width: v, height: p } = t;
  return s && (v -= a.width + l.width, p -= a.height + l.height), {
    x: Math.round((c - m) / v * n.width / i),
    y: Math.round((d - g) / p * n.height / i)
  };
}
function AN(e, t, n) {
  let i, r;
  if (t === void 0 || n === void 0) {
    const s = e && mg(e);
    if (!s)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const a = s.getBoundingClientRect(), l = yd(s), c = zs(l, "border", "width"), d = zs(l, "padding");
      t = a.width - d.width - c.width, n = a.height - d.height - c.height, i = zc(l.maxWidth, s, "clientWidth"), r = zc(l.maxHeight, s, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: i || Bc,
    maxHeight: r || Bc
  };
}
const ec = (e) => Math.round(e * 10) / 10;
function MN(e, t, n, i) {
  const r = yd(e), s = zs(r, "margin"), a = zc(r.maxWidth, e, "clientWidth") || Bc, l = zc(r.maxHeight, e, "clientHeight") || Bc, c = AN(e, t, n);
  let { width: d, height: f } = c;
  if (r.boxSizing === "content-box") {
    const g = zs(r, "border", "width"), v = zs(r, "padding");
    d -= v.width + g.width, f -= v.height + g.height;
  }
  return d = Math.max(0, d - s.width), f = Math.max(0, i ? d / i : f - s.height), d = ec(Math.min(d, a, c.maxWidth)), f = ec(Math.min(f, l, c.maxHeight)), d && !f && (f = ec(d / 2)), (t !== void 0 || n !== void 0) && i && c.height && f > c.height && (f = c.height, d = ec(Math.floor(f * i))), {
    width: d,
    height: f
  };
}
function xb(e, t, n) {
  const i = t || 1, r = Math.floor(e.height * i), s = Math.floor(e.width * i);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const a = e.canvas;
  return a.style && (n || !a.style.height && !a.style.width) && (a.style.height = `${e.height}px`, a.style.width = `${e.width}px`), e.currentDevicePixelRatio !== i || a.height !== r || a.width !== s ? (e.currentDevicePixelRatio = i, a.height = r, a.width = s, e.ctx.setTransform(i, 0, 0, i, 0, 0), !0) : !1;
}
const DN = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    hg() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch {
  }
  return e;
}();
function _b(e, t) {
  const n = IN(e, t), i = n && n.match(/^(\d+)(\.\d+)?px$/);
  return i ? +i[1] : void 0;
}
function Ms(e, t, n, i) {
  return {
    x: e.x + n * (t.x - e.x),
    y: e.y + n * (t.y - e.y)
  };
}
function VN(e, t, n, i) {
  return {
    x: e.x + n * (t.x - e.x),
    y: i === "middle" ? n < 0.5 ? e.y : t.y : i === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
  };
}
function LN(e, t, n, i) {
  const r = {
    x: e.cp2x,
    y: e.cp2y
  }, s = {
    x: t.cp1x,
    y: t.cp1y
  }, a = Ms(e, r, n), l = Ms(r, s, n), c = Ms(s, t, n), d = Ms(a, l, n), f = Ms(l, c, n);
  return Ms(d, f, n);
}
const FN = function(e, t) {
  return {
    x(n) {
      return e + e + t - n;
    },
    setWidth(n) {
      t = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, i) {
      return n - i;
    },
    leftForLtr(n, i) {
      return n - i;
    }
  };
}, RN = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function Aa(e, t, n) {
  return e ? FN(t, n) : RN();
}
function fS(e, t) {
  let n, i;
  (t === "ltr" || t === "rtl") && (n = e.canvas.style, i = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", t, "important"), e.prevTextDirection = i);
}
function hS(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function mS(e) {
  return e === "angle" ? {
    between: Qw,
    compare: VB,
    normalize: Ii
  } : {
    between: jo,
    compare: (t, n) => t - n,
    normalize: (t) => t
  };
}
function wb({ start: e, end: t, count: n, loop: i, style: r }) {
  return {
    start: e % n,
    end: t % n,
    loop: i && (t - e + 1) % n === 0,
    style: r
  };
}
function BN(e, t, n) {
  const { property: i, start: r, end: s } = n, { between: a, normalize: l } = mS(i), c = t.length;
  let { start: d, end: f, loop: m } = e, g, v;
  if (m) {
    for (d += c, f += c, g = 0, v = c; g < v && a(l(t[d % c][i]), r, s); ++g)
      d--, f--;
    d %= c, f %= c;
  }
  return f < d && (f += c), {
    start: d,
    end: f,
    loop: m,
    style: e.style
  };
}
function NN(e, t, n) {
  if (!n)
    return [
      e
    ];
  const { property: i, start: r, end: s } = n, a = t.length, { compare: l, between: c, normalize: d } = mS(i), { start: f, end: m, loop: g, style: v } = BN(e, t, n), p = [];
  let _ = !1, x = null, S, T, M;
  const E = () => c(r, M, S) && l(r, M) !== 0, D = () => l(s, S) === 0 || c(s, M, S), R = () => _ || E(), $ = () => !_ || D();
  for (let A = f, V = f; A <= m; ++A)
    T = t[A % a], !T.skip && (S = d(T[i]), S !== M && (_ = c(S, r, s), x === null && R() && (x = l(S, r) === 0 ? A : V), x !== null && $() && (p.push(wb({
      start: x,
      end: A,
      loop: g,
      count: a,
      style: v
    })), x = null), V = A, M = S));
  return x !== null && p.push(wb({
    start: x,
    end: m,
    loop: g,
    count: a,
    style: v
  })), p;
}
function $N(e, t) {
  const n = [], i = e.segments;
  for (let r = 0; r < i.length; r++) {
    const s = NN(i[r], e.points, t);
    s.length && n.push(...s);
  }
  return n;
}
function zN(e, t, n, i) {
  let r = 0, s = t - 1;
  if (n && !i)
    for (; r < t && !e[r].skip; )
      r++;
  for (; r < t && e[r].skip; )
    r++;
  for (r %= t, n && (s += r); s > r && e[s % t].skip; )
    s--;
  return s %= t, {
    start: r,
    end: s
  };
}
function HN(e, t, n, i) {
  const r = e.length, s = [];
  let a = t, l = e[t], c;
  for (c = t + 1; c <= n; ++c) {
    const d = e[c % r];
    d.skip || d.stop ? l.skip || (i = !1, s.push({
      start: t % r,
      end: (c - 1) % r,
      loop: i
    }), t = a = d.stop ? c : null) : (a = c, l.skip && (t = c)), l = d;
  }
  return a !== null && s.push({
    start: t % r,
    end: a % r,
    loop: i
  }), s;
}
function WN(e, t) {
  const n = e.points, i = e.options.spanGaps, r = n.length;
  if (!r)
    return [];
  const s = !!e._loop, { start: a, end: l } = zN(n, r, s, i);
  if (i === !0)
    return Sb(e, [
      {
        start: a,
        end: l,
        loop: s
      }
    ], n, t);
  const c = l < a ? l + r : l, d = !!e._fullLoop && a === 0 && l === r - 1;
  return Sb(e, HN(n, a, c, d), n, t);
}
function Sb(e, t, n, i) {
  return !i || !i.setContext || !n ? t : UN(e, t, n, i);
}
function UN(e, t, n, i) {
  const r = e._chart.getContext(), s = kb(e.options), { _datasetIndex: a, options: { spanGaps: l } } = e, c = n.length, d = [];
  let f = s, m = t[0].start, g = m;
  function v(p, _, x, S) {
    const T = l ? -1 : 1;
    if (p !== _) {
      for (p += c; n[p % c].skip; )
        p -= T;
      for (; n[_ % c].skip; )
        _ += T;
      p % c !== _ % c && (d.push({
        start: p % c,
        end: _ % c,
        loop: x,
        style: S
      }), f = S, m = _ % c);
    }
  }
  for (const p of t) {
    m = l ? m : p.start;
    let _ = n[m % c], x;
    for (g = m + 1; g <= p.end; g++) {
      const S = n[g % c];
      x = kb(i.setContext(us(r, {
        type: "segment",
        p0: _,
        p1: S,
        p0DataIndex: (g - 1) % c,
        p1DataIndex: g % c,
        datasetIndex: a
      }))), qN(x, f) && v(m, g - 1, p.loop, f), _ = S, f = x;
    }
    m < g - 1 && v(m, g - 1, p.loop, f);
  }
  return d;
}
function kb(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function qN(e, t) {
  if (!t)
    return !1;
  const n = [], i = function(r, s) {
    return ag(s) ? (n.includes(s) || n.push(s), n.indexOf(s)) : s;
  };
  return JSON.stringify(e, i) !== JSON.stringify(t, i);
}
/*!
 * Chart.js v4.4.8
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
class jN {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, n, i, r) {
    const s = n.listeners[r], a = n.duration;
    s.forEach((l) => l({
      chart: t,
      initial: n.initial,
      numSteps: a,
      currentStep: Math.min(i - n.start, a)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = tS.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let n = 0;
    this._charts.forEach((i, r) => {
      if (!i.running || !i.items.length)
        return;
      const s = i.items;
      let a = s.length - 1, l = !1, c;
      for (; a >= 0; --a)
        c = s[a], c._active ? (c._total > i.duration && (i.duration = c._total), c.tick(t), l = !0) : (s[a] = s[s.length - 1], s.pop());
      l && (r.draw(), this._notify(r, i, t, "progress")), s.length || (i.running = !1, this._notify(r, i, t, "complete"), i.initial = !1), n += s.length;
    }), this._lastDate = t, n === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const n = this._charts;
    let i = n.get(t);
    return i || (i = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(t, i)), i;
  }
  listen(t, n, i) {
    this._getAnims(t).listeners[n].push(i);
  }
  add(t, n) {
    !n || !n.length || this._getAnims(t).items.push(...n);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const n = this._charts.get(t);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((i, r) => Math.max(i, r._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const n = this._charts.get(t);
    return !(!n || !n.running || !n.items.length);
  }
  stop(t) {
    const n = this._charts.get(t);
    if (!n || !n.items.length)
      return;
    const i = n.items;
    let r = i.length - 1;
    for (; r >= 0; --r)
      i[r].cancel();
    n.items = [], this._notify(t, n, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var hr = /* @__PURE__ */ new jN();
const Cb = "transparent", GN = {
  boolean(e, t, n) {
    return n > 0.5 ? t : e;
  },
  color(e, t, n) {
    const i = gb(e || Cb), r = i.valid && gb(t || Cb);
    return r && r.valid ? r.mix(i, n).hexString() : t;
  },
  number(e, t, n) {
    return e + (t - e) * n;
  }
};
class YN {
  constructor(t, n, i, r) {
    const s = n[i];
    r = Ju([
      t.to,
      r,
      s,
      t.from
    ]);
    const a = Ju([
      t.from,
      s,
      r
    ]);
    this._active = !0, this._fn = t.fn || GN[t.type || typeof a], this._easing = Qo[t.easing] || Qo.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = n, this._prop = i, this._from = a, this._to = r, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, n, i) {
    if (this._active) {
      this._notify(!1);
      const r = this._target[this._prop], s = i - this._start, a = this._duration - s;
      this._start = i, this._duration = Math.floor(Math.max(a, t.duration)), this._total += s, this._loop = !!t.loop, this._to = Ju([
        t.to,
        n,
        r,
        t.from
      ]), this._from = Ju([
        t.from,
        r,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const n = t - this._start, i = this._duration, r = this._prop, s = this._from, a = this._loop, l = this._to;
    let c;
    if (this._active = s !== l && (a || n < i), !this._active) {
      this._target[r] = l, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[r] = s;
      return;
    }
    c = n / i % 2, c = a && c > 1 ? 2 - c : c, c = this._easing(Math.min(1, Math.max(0, c))), this._target[r] = this._fn(s, l, c);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((n, i) => {
      t.push({
        res: n,
        rej: i
      });
    });
  }
  _notify(t) {
    const n = t ? "res" : "rej", i = this._promises || [];
    for (let r = 0; r < i.length; r++)
      i[r][n]();
  }
}
class gS {
  constructor(t, n) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(t) {
    if (!ct(t))
      return;
    const n = Object.keys(Rt.animation), i = this._properties;
    Object.getOwnPropertyNames(t).forEach((r) => {
      const s = t[r];
      if (!ct(s))
        return;
      const a = {};
      for (const l of n)
        a[l] = s[l];
      (qt(s.properties) && s.properties || [
        r
      ]).forEach((l) => {
        (l === r || !i.has(l)) && i.set(l, a);
      });
    });
  }
  _animateOptions(t, n) {
    const i = n.options, r = KN(t, i);
    if (!r)
      return [];
    const s = this._createAnimations(r, i);
    return i.$shared && ZN(t.options.$animations, i).then(() => {
      t.options = i;
    }, () => {
    }), s;
  }
  _createAnimations(t, n) {
    const i = this._properties, r = [], s = t.$animations || (t.$animations = {}), a = Object.keys(n), l = Date.now();
    let c;
    for (c = a.length - 1; c >= 0; --c) {
      const d = a[c];
      if (d.charAt(0) === "$")
        continue;
      if (d === "options") {
        r.push(...this._animateOptions(t, n));
        continue;
      }
      const f = n[d];
      let m = s[d];
      const g = i.get(d);
      if (m)
        if (g && m.active()) {
          m.update(g, f, l);
          continue;
        } else
          m.cancel();
      if (!g || !g.duration) {
        t[d] = f;
        continue;
      }
      s[d] = m = new YN(g, t, d, f), r.push(m);
    }
    return r;
  }
  update(t, n) {
    if (this._properties.size === 0) {
      Object.assign(t, n);
      return;
    }
    const i = this._createAnimations(t, n);
    if (i.length)
      return hr.add(this._chart, i), !0;
  }
}
function ZN(e, t) {
  const n = [], i = Object.keys(t);
  for (let r = 0; r < i.length; r++) {
    const s = e[i[r]];
    s && s.active() && n.push(s.wait());
  }
  return Promise.all(n);
}
function KN(e, t) {
  if (!t)
    return;
  let n = e.options;
  if (!n) {
    e.options = t;
    return;
  }
  return n.$shared && (e.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function Tb(e, t) {
  const n = e && e.options || {}, i = n.reverse, r = n.min === void 0 ? t : 0, s = n.max === void 0 ? t : 0;
  return {
    start: i ? s : r,
    end: i ? r : s
  };
}
function XN(e, t, n) {
  if (n === !1)
    return !1;
  const i = Tb(e, n), r = Tb(t, n);
  return {
    top: r.end,
    right: i.end,
    bottom: r.start,
    left: i.start
  };
}
function JN(e) {
  let t, n, i, r;
  return ct(e) ? (t = e.top, n = e.right, i = e.bottom, r = e.left) : t = n = i = r = e, {
    top: t,
    right: n,
    bottom: i,
    left: r,
    disabled: e === !1
  };
}
function vS(e, t) {
  const n = [], i = e._getSortedDatasetMetas(t);
  let r, s;
  for (r = 0, s = i.length; r < s; ++r)
    n.push(i[r].index);
  return n;
}
function Ib(e, t, n, i = {}) {
  const r = e.keys, s = i.mode === "single";
  let a, l, c, d;
  if (t === null)
    return;
  let f = !1;
  for (a = 0, l = r.length; a < l; ++a) {
    if (c = +r[a], c === n) {
      if (f = !0, i.all)
        continue;
      break;
    }
    d = e.values[c], tn(d) && (s || t === 0 || ss(t) === ss(d)) && (t += d);
  }
  return !f && !i.all ? 0 : t;
}
function QN(e, t) {
  const { iScale: n, vScale: i } = t, r = n.axis === "x" ? "x" : "y", s = i.axis === "x" ? "x" : "y", a = Object.keys(e), l = new Array(a.length);
  let c, d, f;
  for (c = 0, d = a.length; c < d; ++c)
    f = a[c], l[c] = {
      [r]: f,
      [s]: e[f]
    };
  return l;
}
function lh(e, t) {
  const n = e && e.options.stacked;
  return n || n === void 0 && t.stack !== void 0;
}
function e$(e, t, n) {
  return `${e.id}.${t.id}.${n.stack || n.type}`;
}
function t$(e) {
  const { min: t, max: n, minDefined: i, maxDefined: r } = e.getUserBounds();
  return {
    min: i ? t : Number.NEGATIVE_INFINITY,
    max: r ? n : Number.POSITIVE_INFINITY
  };
}
function n$(e, t, n) {
  const i = e[t] || (e[t] = {});
  return i[n] || (i[n] = {});
}
function Pb(e, t, n, i) {
  for (const r of t.getMatchingVisibleMetas(i).reverse()) {
    const s = e[r.index];
    if (n && s > 0 || !n && s < 0)
      return r.index;
  }
  return null;
}
function Ob(e, t) {
  const { chart: n, _cachedMeta: i } = e, r = n._stacks || (n._stacks = {}), { iScale: s, vScale: a, index: l } = i, c = s.axis, d = a.axis, f = e$(s, a, i), m = t.length;
  let g;
  for (let v = 0; v < m; ++v) {
    const p = t[v], { [c]: _, [d]: x } = p, S = p._stacks || (p._stacks = {});
    g = S[d] = n$(r, f, _), g[l] = x, g._top = Pb(g, a, !0, i.type), g._bottom = Pb(g, a, !1, i.type);
    const T = g._visualValues || (g._visualValues = {});
    T[l] = x;
  }
}
function uh(e, t) {
  const n = e.scales;
  return Object.keys(n).filter((i) => n[i].axis === t).shift();
}
function i$(e, t) {
  return us(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function r$(e, t, n) {
  return us(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: t,
    mode: "default",
    type: "data"
  });
}
function Ro(e, t) {
  const n = e.controller.index, i = e.vScale && e.vScale.axis;
  if (i) {
    t = t || e._parsed;
    for (const r of t) {
      const s = r._stacks;
      if (!s || s[i] === void 0 || s[i][n] === void 0)
        return;
      delete s[i][n], s[i]._visualValues !== void 0 && s[i]._visualValues[n] !== void 0 && delete s[i]._visualValues[n];
    }
  }
}
const ch = (e) => e === "reset" || e === "none", Eb = (e, t) => t ? e : Object.assign({}, e), s$ = (e, t, n) => e && !t.hidden && t._stacked && {
  keys: vS(n, !0),
  values: null
};
class tl {
  constructor(t, n) {
    this.chart = t, this._ctx = t.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = lh(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && Ro(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, n = this._cachedMeta, i = this.getDataset(), r = (m, g, v, p) => m === "x" ? g : m === "r" ? p : v, s = n.xAxisID = Xe(i.xAxisID, uh(t, "x")), a = n.yAxisID = Xe(i.yAxisID, uh(t, "y")), l = n.rAxisID = Xe(i.rAxisID, uh(t, "r")), c = n.indexAxis, d = n.iAxisID = r(c, s, a, l), f = n.vAxisID = r(c, a, s, l);
    n.xScale = this.getScaleForId(s), n.yScale = this.getScaleForId(a), n.rScale = this.getScaleForId(l), n.iScale = this.getScaleForId(d), n.vScale = this.getScaleForId(f);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const n = this._cachedMeta;
    return t === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && fb(this._data, this), t._stacked && Ro(t);
  }
  _dataCheck() {
    const t = this.getDataset(), n = t.data || (t.data = []), i = this._data;
    if (ct(n)) {
      const r = this._cachedMeta;
      this._data = QN(n, r);
    } else if (i !== n) {
      if (i) {
        fb(i, this);
        const r = this._cachedMeta;
        Ro(r), r._parsed = [];
      }
      n && Object.isExtensible(n) && BB(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const n = this._cachedMeta, i = this.getDataset();
    let r = !1;
    this._dataCheck();
    const s = n._stacked;
    n._stacked = lh(n.vScale, n), n.stack !== i.stack && (r = !0, Ro(n), n.stack = i.stack), this._resyncElements(t), (r || s !== n._stacked) && (Ob(this, n._parsed), n._stacked = lh(n.vScale, n));
  }
  configure() {
    const t = this.chart.config, n = t.datasetScopeKeys(this._type), i = t.getOptionScopes(this.getDataset(), n, !0);
    this.options = t.createResolver(i, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, n) {
    const { _cachedMeta: i, _data: r } = this, { iScale: s, _stacked: a } = i, l = s.axis;
    let c = t === 0 && n === r.length ? !0 : i._sorted, d = t > 0 && i._parsed[t - 1], f, m, g;
    if (this._parsing === !1)
      i._parsed = r, i._sorted = !0, g = r;
    else {
      qt(r[t]) ? g = this.parseArrayData(i, r, t, n) : ct(r[t]) ? g = this.parseObjectData(i, r, t, n) : g = this.parsePrimitiveData(i, r, t, n);
      const v = () => m[l] === null || d && m[l] < d[l];
      for (f = 0; f < n; ++f)
        i._parsed[f + t] = m = g[f], c && (v() && (c = !1), d = m);
      i._sorted = c;
    }
    a && Ob(this, g);
  }
  parsePrimitiveData(t, n, i, r) {
    const { iScale: s, vScale: a } = t, l = s.axis, c = a.axis, d = s.getLabels(), f = s === a, m = new Array(r);
    let g, v, p;
    for (g = 0, v = r; g < v; ++g)
      p = g + i, m[g] = {
        [l]: f || s.parse(d[p], p),
        [c]: a.parse(n[p], p)
      };
    return m;
  }
  parseArrayData(t, n, i, r) {
    const { xScale: s, yScale: a } = t, l = new Array(r);
    let c, d, f, m;
    for (c = 0, d = r; c < d; ++c)
      f = c + i, m = n[f], l[c] = {
        x: s.parse(m[0], f),
        y: a.parse(m[1], f)
      };
    return l;
  }
  parseObjectData(t, n, i, r) {
    const { xScale: s, yScale: a } = t, { xAxisKey: l = "x", yAxisKey: c = "y" } = this._parsing, d = new Array(r);
    let f, m, g, v;
    for (f = 0, m = r; f < m; ++f)
      g = f + i, v = n[g], d[f] = {
        x: s.parse(Fc(v, l), g),
        y: a.parse(Fc(v, c), g)
      };
    return d;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, n, i) {
    const r = this.chart, s = this._cachedMeta, a = n[t.axis], l = {
      keys: vS(r, !0),
      values: n._stacks[t.axis]._visualValues
    };
    return Ib(l, a, s.index, {
      mode: i
    });
  }
  updateRangeFromParsed(t, n, i, r) {
    const s = i[n.axis];
    let a = s === null ? NaN : s;
    const l = r && i._stacks[n.axis];
    r && l && (r.values = l, a = Ib(r, s, this._cachedMeta.index)), t.min = Math.min(t.min, a), t.max = Math.max(t.max, a);
  }
  getMinMax(t, n) {
    const i = this._cachedMeta, r = i._parsed, s = i._sorted && t === i.iScale, a = r.length, l = this._getOtherScale(t), c = s$(n, i, this.chart), d = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: f, max: m } = t$(l);
    let g, v;
    function p() {
      v = r[g];
      const _ = v[l.axis];
      return !tn(v[t.axis]) || f > _ || m < _;
    }
    for (g = 0; g < a && !(!p() && (this.updateRangeFromParsed(d, t, v, c), s)); ++g)
      ;
    if (s) {
      for (g = a - 1; g >= 0; --g)
        if (!p()) {
          this.updateRangeFromParsed(d, t, v, c);
          break;
        }
    }
    return d;
  }
  getAllParsedValues(t) {
    const n = this._cachedMeta._parsed, i = [];
    let r, s, a;
    for (r = 0, s = n.length; r < s; ++r)
      a = n[r][t.axis], tn(a) && i.push(a);
    return i;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, i = n.iScale, r = n.vScale, s = this.getParsed(t);
    return {
      label: i ? "" + i.getLabelForValue(s[i.axis]) : "",
      value: r ? "" + r.getLabelForValue(s[r.axis]) : ""
    };
  }
  _update(t) {
    const n = this._cachedMeta;
    this.update(t || "default"), n._clip = JN(Xe(this.options.clip, XN(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, n = this.chart, i = this._cachedMeta, r = i.data || [], s = n.chartArea, a = [], l = this._drawStart || 0, c = this._drawCount || r.length - l, d = this.options.drawActiveElementsOnTop;
    let f;
    for (i.dataset && i.dataset.draw(t, s, l, c), f = l; f < l + c; ++f) {
      const m = r[f];
      m.hidden || (m.active && d ? a.push(m) : m.draw(t, s));
    }
    for (f = 0; f < a.length; ++f)
      a[f].draw(t, s);
  }
  getStyle(t, n) {
    const i = n ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(i) : this.resolveDataElementOptions(t || 0, i);
  }
  getContext(t, n, i) {
    const r = this.getDataset();
    let s;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const a = this._cachedMeta.data[t];
      s = a.$context || (a.$context = r$(this.getContext(), t, a)), s.parsed = this.getParsed(t), s.raw = r.data[t], s.index = s.dataIndex = t;
    } else
      s = this.$context || (this.$context = i$(this.chart.getContext(), this.index)), s.dataset = r, s.index = s.datasetIndex = this.index;
    return s.active = !!n, s.mode = i, s;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, t);
  }
  _resolveElementOptions(t, n = "default", i) {
    const r = n === "active", s = this._cachedDataOpts, a = t + "-" + n, l = s[a], c = this.enableOptionSharing && Rc(i);
    if (l)
      return Eb(l, c);
    const d = this.chart.config, f = d.datasetElementScopeKeys(this._type, t), m = r ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], g = d.getOptionScopes(this.getDataset(), f), v = Object.keys(Rt.elements[t]), p = () => this.getContext(i, r, n), _ = d.resolveNamedOptions(g, v, p, m);
    return _.$shared && (_.$shared = c, s[a] = Object.freeze(Eb(_, c))), _;
  }
  _resolveAnimations(t, n, i) {
    const r = this.chart, s = this._cachedDataOpts, a = `animation-${n}`, l = s[a];
    if (l)
      return l;
    let c;
    if (r.options.animation !== !1) {
      const f = this.chart.config, m = f.datasetAnimationScopeKeys(this._type, n), g = f.getOptionScopes(this.getDataset(), m);
      c = f.createResolver(g, this.getContext(t, i, n));
    }
    const d = new gS(r, c && c.animations);
    return c && c._cacheable && (s[a] = Object.freeze(d)), d;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, n) {
    return !n || ch(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, n) {
    const i = this.resolveDataElementOptions(t, n), r = this._sharedOptions, s = this.getSharedOptions(i), a = this.includeOptions(n, s) || s !== r;
    return this.updateSharedOptions(s, n, i), {
      sharedOptions: s,
      includeOptions: a
    };
  }
  updateElement(t, n, i, r) {
    ch(r) ? Object.assign(t, i) : this._resolveAnimations(n, r).update(t, i);
  }
  updateSharedOptions(t, n, i) {
    t && !ch(n) && this._resolveAnimations(void 0, n).update(t, i);
  }
  _setStyle(t, n, i, r) {
    t.active = r;
    const s = this.getStyle(n, r);
    this._resolveAnimations(n, i, r).update(t, {
      options: !r && this.getSharedOptions(s) || s
    });
  }
  removeHoverStyle(t, n, i) {
    this._setStyle(t, i, "active", !1);
  }
  setHoverStyle(t, n, i) {
    this._setStyle(t, i, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const n = this._data, i = this._cachedMeta.data;
    for (const [l, c, d] of this._syncList)
      this[l](c, d);
    this._syncList = [];
    const r = i.length, s = n.length, a = Math.min(s, r);
    a && this.parse(0, a), s > r ? this._insertElements(r, s - r, t) : s < r && this._removeElements(s, r - s);
  }
  _insertElements(t, n, i = !0) {
    const r = this._cachedMeta, s = r.data, a = t + n;
    let l;
    const c = (d) => {
      for (d.length += n, l = d.length - 1; l >= a; l--)
        d[l] = d[l - n];
    };
    for (c(s), l = t; l < a; ++l)
      s[l] = new this.dataElementType();
    this._parsing && c(r._parsed), this.parse(t, n), i && this.updateElements(s, t, n, "reset");
  }
  updateElements(t, n, i, r) {
  }
  _removeElements(t, n) {
    const i = this._cachedMeta;
    if (this._parsing) {
      const r = i._parsed.splice(t, n);
      i._stacked && Ro(i, r);
    }
    i.data.splice(t, n);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [n, i, r] = t;
      this[n](i, r);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, n) {
    n && this._sync([
      "_removeElements",
      t,
      n
    ]);
    const i = arguments.length - 2;
    i && this._sync([
      "_insertElements",
      t,
      i
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
Ne(tl, "defaults", {}), Ne(tl, "datasetElementType", null), Ne(tl, "dataElementType", null);
class vc extends tl {
  getLabelAndValue(t) {
    const n = this._cachedMeta, i = this.chart.data.labels || [], { xScale: r, yScale: s } = n, a = this.getParsed(t), l = r.getLabelForValue(a.x), c = s.getLabelForValue(a.y);
    return {
      label: i[t] || "",
      value: "(" + l + ", " + c + ")"
    };
  }
  update(t) {
    const n = this._cachedMeta, { data: i = [] } = n, r = this.chart._animationsDisabled;
    let { start: s, count: a } = HB(n, i, r);
    if (this._drawStart = s, this._drawCount = a, WB(n) && (s = 0, a = i.length), this.options.showLine) {
      this.datasetElementType || this.addElements();
      const { dataset: l, _dataset: c } = n;
      l._chart = this.chart, l._datasetIndex = this.index, l._decimated = !!c._decimated, l.points = i;
      const d = this.resolveDatasetElementOptions(t);
      d.segment = this.options.segment, this.updateElement(l, void 0, {
        animated: !r,
        options: d
      }, t);
    } else
      this.datasetElementType && (delete n.dataset, this.datasetElementType = !1);
    this.updateElements(i, s, a, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(t, n, i, r) {
    const s = r === "reset", { iScale: a, vScale: l, _stacked: c, _dataset: d } = this._cachedMeta, f = this.resolveDataElementOptions(n, r), m = this.getSharedOptions(f), g = this.includeOptions(r, m), v = a.axis, p = l.axis, { spanGaps: _, segment: x } = this.options, S = vl(_) ? _ : Number.POSITIVE_INFINITY, T = this.chart._animationsDisabled || s || r === "none";
    let M = n > 0 && this.getParsed(n - 1);
    for (let E = n; E < n + i; ++E) {
      const D = t[E], R = this.getParsed(E), $ = T ? D : {}, A = yt(R[p]), V = $[v] = a.getPixelForValue(R[v], E), H = $[p] = s || A ? l.getBasePixel() : l.getPixelForValue(c ? this.applyStack(l, R, c) : R[p], E);
      $.skip = isNaN(V) || isNaN(H) || A, $.stop = E > 0 && Math.abs(R[v] - M[v]) > S, x && ($.parsed = R, $.raw = d.data[E]), g && ($.options = m || this.resolveDataElementOptions(E, D.active ? "active" : r)), T || this.updateElement(D, E, $, r), M = R;
    }
    this.updateSharedOptions(m, r, f);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.data || [];
    if (!this.options.showLine) {
      let l = 0;
      for (let c = n.length - 1; c >= 0; --c)
        l = Math.max(l, n[c].size(this.resolveDataElementOptions(c)) / 2);
      return l > 0 && l;
    }
    const i = t.dataset, r = i.options && i.options.borderWidth || 0;
    if (!n.length)
      return r;
    const s = n[0].size(this.resolveDataElementOptions(0)), a = n[n.length - 1].size(this.resolveDataElementOptions(n.length - 1));
    return Math.max(r, s, a) / 2;
  }
}
Ne(vc, "id", "scatter"), Ne(vc, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), Ne(vc, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function Es() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class gg {
  constructor(t) {
    Ne(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(gg.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return Es();
  }
  parse() {
    return Es();
  }
  format() {
    return Es();
  }
  add() {
    return Es();
  }
  diff() {
    return Es();
  }
  startOf() {
    return Es();
  }
  endOf() {
    return Es();
  }
}
var a$ = {
  _date: gg
};
function o$(e, t, n, i) {
  const { controller: r, data: s, _sorted: a } = e, l = r._cachedMeta.iScale, c = e.dataset && e.dataset.options ? e.dataset.options.spanGaps : null;
  if (l && t === l.axis && t !== "r" && a && s.length) {
    const d = l._reversePixels ? FB : Ls;
    if (i) {
      if (r._sharedOptions) {
        const f = s[0], m = typeof f.getRange == "function" && f.getRange(t);
        if (m) {
          const g = d(s, t, n - m), v = d(s, t, n + m);
          return {
            lo: g.lo,
            hi: v.hi
          };
        }
      }
    } else {
      const f = d(s, t, n);
      if (c) {
        const { vScale: m } = r._cachedMeta, { _parsed: g } = e, v = g.slice(0, f.lo + 1).reverse().findIndex((_) => !yt(_[m.axis]));
        f.lo -= Math.max(0, v);
        const p = g.slice(f.hi).findIndex((_) => !yt(_[m.axis]));
        f.hi += Math.max(0, p);
      }
      return f;
    }
  }
  return {
    lo: 0,
    hi: s.length - 1
  };
}
function Bl(e, t, n, i, r) {
  const s = e.getSortedVisibleDatasetMetas(), a = n[t];
  for (let l = 0, c = s.length; l < c; ++l) {
    const { index: d, data: f } = s[l], { lo: m, hi: g } = o$(s[l], t, a, r);
    for (let v = m; v <= g; ++v) {
      const p = f[v];
      p.skip || i(p, d, v);
    }
  }
}
function l$(e) {
  const t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
  return function(i, r) {
    const s = t ? Math.abs(i.x - r.x) : 0, a = n ? Math.abs(i.y - r.y) : 0;
    return Math.sqrt(Math.pow(s, 2) + Math.pow(a, 2));
  };
}
function dh(e, t, n, i, r) {
  const s = [];
  return !r && !e.isPointInArea(t) || Bl(e, n, t, function(l, c, d) {
    !r && !Wi(l, e.chartArea, 0) || l.inRange(t.x, t.y, i) && s.push({
      element: l,
      datasetIndex: c,
      index: d
    });
  }, !0), s;
}
function u$(e, t, n, i) {
  let r = [];
  function s(a, l, c) {
    const { startAngle: d, endAngle: f } = a.getProps([
      "startAngle",
      "endAngle"
    ], i), { angle: m } = DB(a, {
      x: t.x,
      y: t.y
    });
    Qw(m, d, f) && r.push({
      element: a,
      datasetIndex: l,
      index: c
    });
  }
  return Bl(e, n, t, s), r;
}
function c$(e, t, n, i, r, s) {
  let a = [];
  const l = l$(n);
  let c = Number.POSITIVE_INFINITY;
  function d(f, m, g) {
    const v = f.inRange(t.x, t.y, r);
    if (i && !v)
      return;
    const p = f.getCenterPoint(r);
    if (!(!!s || e.isPointInArea(p)) && !v)
      return;
    const x = l(t, p);
    x < c ? (a = [
      {
        element: f,
        datasetIndex: m,
        index: g
      }
    ], c = x) : x === c && a.push({
      element: f,
      datasetIndex: m,
      index: g
    });
  }
  return Bl(e, n, t, d), a;
}
function fh(e, t, n, i, r, s) {
  return !s && !e.isPointInArea(t) ? [] : n === "r" && !i ? u$(e, t, n, r) : c$(e, t, n, i, r, s);
}
function Ab(e, t, n, i, r) {
  const s = [], a = n === "x" ? "inXRange" : "inYRange";
  let l = !1;
  return Bl(e, n, t, (c, d, f) => {
    c[a] && c[a](t[n], r) && (s.push({
      element: c,
      datasetIndex: d,
      index: f
    }), l = l || c.inRange(t.x, t.y, r));
  }), i && !l ? [] : s;
}
var d$ = {
  evaluateInteractionItems: Bl,
  modes: {
    index(e, t, n, i) {
      const r = Hi(t, e), s = n.axis || "x", a = n.includeInvisible || !1, l = n.intersect ? dh(e, r, s, i, a) : fh(e, r, s, !1, i, a), c = [];
      return l.length ? (e.getSortedVisibleDatasetMetas().forEach((d) => {
        const f = l[0].index, m = d.data[f];
        m && !m.skip && c.push({
          element: m,
          datasetIndex: d.index,
          index: f
        });
      }), c) : [];
    },
    dataset(e, t, n, i) {
      const r = Hi(t, e), s = n.axis || "xy", a = n.includeInvisible || !1;
      let l = n.intersect ? dh(e, r, s, i, a) : fh(e, r, s, !1, i, a);
      if (l.length > 0) {
        const c = l[0].datasetIndex, d = e.getDatasetMeta(c).data;
        l = [];
        for (let f = 0; f < d.length; ++f)
          l.push({
            element: d[f],
            datasetIndex: c,
            index: f
          });
      }
      return l;
    },
    point(e, t, n, i) {
      const r = Hi(t, e), s = n.axis || "xy", a = n.includeInvisible || !1;
      return dh(e, r, s, i, a);
    },
    nearest(e, t, n, i) {
      const r = Hi(t, e), s = n.axis || "xy", a = n.includeInvisible || !1;
      return fh(e, r, s, n.intersect, i, a);
    },
    x(e, t, n, i) {
      const r = Hi(t, e);
      return Ab(e, r, "x", n.intersect, i);
    },
    y(e, t, n, i) {
      const r = Hi(t, e);
      return Ab(e, r, "y", n.intersect, i);
    }
  }
};
const yS = [
  "left",
  "top",
  "right",
  "bottom"
];
function Bo(e, t) {
  return e.filter((n) => n.pos === t);
}
function Mb(e, t) {
  return e.filter((n) => yS.indexOf(n.pos) === -1 && n.box.axis === t);
}
function No(e, t) {
  return e.sort((n, i) => {
    const r = t ? i : n, s = t ? n : i;
    return r.weight === s.weight ? r.index - s.index : r.weight - s.weight;
  });
}
function f$(e) {
  const t = [];
  let n, i, r, s, a, l;
  for (n = 0, i = (e || []).length; n < i; ++n)
    r = e[n], { position: s, options: { stack: a, stackWeight: l = 1 } } = r, t.push({
      index: n,
      box: r,
      pos: s,
      horizontal: r.isHorizontal(),
      weight: r.weight,
      stack: a && s + a,
      stackWeight: l
    });
  return t;
}
function h$(e) {
  const t = {};
  for (const n of e) {
    const { stack: i, pos: r, stackWeight: s } = n;
    if (!i || !yS.includes(r))
      continue;
    const a = t[i] || (t[i] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    a.count++, a.weight += s;
  }
  return t;
}
function m$(e, t) {
  const n = h$(e), { vBoxMaxWidth: i, hBoxMaxHeight: r } = t;
  let s, a, l;
  for (s = 0, a = e.length; s < a; ++s) {
    l = e[s];
    const { fullSize: c } = l.box, d = n[l.stack], f = d && l.stackWeight / d.weight;
    l.horizontal ? (l.width = f ? f * i : c && t.availableWidth, l.height = r) : (l.width = i, l.height = f ? f * r : c && t.availableHeight);
  }
  return n;
}
function g$(e) {
  const t = f$(e), n = No(t.filter((d) => d.box.fullSize), !0), i = No(Bo(t, "left"), !0), r = No(Bo(t, "right")), s = No(Bo(t, "top"), !0), a = No(Bo(t, "bottom")), l = Mb(t, "x"), c = Mb(t, "y");
  return {
    fullSize: n,
    leftAndTop: i.concat(s),
    rightAndBottom: r.concat(c).concat(a).concat(l),
    chartArea: Bo(t, "chartArea"),
    vertical: i.concat(r).concat(c),
    horizontal: s.concat(a).concat(l)
  };
}
function Db(e, t, n, i) {
  return Math.max(e[n], t[n]) + Math.max(e[i], t[i]);
}
function pS(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function v$(e, t, n, i) {
  const { pos: r, box: s } = n, a = e.maxPadding;
  if (!ct(r)) {
    n.size && (e[r] -= n.size);
    const m = i[n.stack] || {
      size: 0,
      count: 1
    };
    m.size = Math.max(m.size, n.horizontal ? s.height : s.width), n.size = m.size / m.count, e[r] += n.size;
  }
  s.getPadding && pS(a, s.getPadding());
  const l = Math.max(0, t.outerWidth - Db(a, e, "left", "right")), c = Math.max(0, t.outerHeight - Db(a, e, "top", "bottom")), d = l !== e.w, f = c !== e.h;
  return e.w = l, e.h = c, n.horizontal ? {
    same: d,
    other: f
  } : {
    same: f,
    other: d
  };
}
function y$(e) {
  const t = e.maxPadding;
  function n(i) {
    const r = Math.max(t[i] - e[i], 0);
    return e[i] += r, r;
  }
  e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
function p$(e, t) {
  const n = t.maxPadding;
  function i(r) {
    const s = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return r.forEach((a) => {
      s[a] = Math.max(t[a], n[a]);
    }), s;
  }
  return i(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Go(e, t, n, i) {
  const r = [];
  let s, a, l, c, d, f;
  for (s = 0, a = e.length, d = 0; s < a; ++s) {
    l = e[s], c = l.box, c.update(l.width || t.w, l.height || t.h, p$(l.horizontal, t));
    const { same: m, other: g } = v$(t, n, l, i);
    d |= m && r.length, f = f || g, c.fullSize || r.push(l);
  }
  return d && Go(r, t, n, i) || f;
}
function tc(e, t, n, i, r) {
  e.top = n, e.left = t, e.right = t + i, e.bottom = n + r, e.width = i, e.height = r;
}
function Vb(e, t, n, i) {
  const r = n.padding;
  let { x: s, y: a } = t;
  for (const l of e) {
    const c = l.box, d = i[l.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, f = l.stackWeight / d.weight || 1;
    if (l.horizontal) {
      const m = t.w * f, g = d.size || c.height;
      Rc(d.start) && (a = d.start), c.fullSize ? tc(c, r.left, a, n.outerWidth - r.right - r.left, g) : tc(c, t.left + d.placed, a, m, g), d.start = a, d.placed += m, a = c.bottom;
    } else {
      const m = t.h * f, g = d.size || c.width;
      Rc(d.start) && (s = d.start), c.fullSize ? tc(c, s, r.top, g, n.outerHeight - r.bottom - r.top) : tc(c, s, t.top + d.placed, g, m), d.start = s, d.placed += m, s = c.right;
    }
  }
  t.x = s, t.y = a;
}
var Xr = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            t.draw(n);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const n = e.boxes ? e.boxes.indexOf(t) : -1;
    n !== -1 && e.boxes.splice(n, 1);
  },
  configure(e, t, n) {
    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
  },
  update(e, t, n, i) {
    if (!e)
      return;
    const r = Sn(e.options.layout.padding), s = Math.max(t - r.width, 0), a = Math.max(n - r.height, 0), l = g$(e.boxes), c = l.vertical, d = l.horizontal;
    et(e.boxes, (_) => {
      typeof _.beforeLayout == "function" && _.beforeLayout();
    });
    const f = c.reduce((_, x) => x.box.options && x.box.options.display === !1 ? _ : _ + 1, 0) || 1, m = Object.freeze({
      outerWidth: t,
      outerHeight: n,
      padding: r,
      availableWidth: s,
      availableHeight: a,
      vBoxMaxWidth: s / 2 / f,
      hBoxMaxHeight: a / 2
    }), g = Object.assign({}, r);
    pS(g, Sn(i));
    const v = Object.assign({
      maxPadding: g,
      w: s,
      h: a,
      x: r.left,
      y: r.top
    }, r), p = m$(c.concat(d), m);
    Go(l.fullSize, v, m, p), Go(c, v, m, p), Go(d, v, m, p) && Go(c, v, m, p), y$(v), Vb(l.leftAndTop, v, m, p), v.x += v.w, v.y += v.h, Vb(l.rightAndBottom, v, m, p), e.chartArea = {
      left: v.left,
      top: v.top,
      right: v.left + v.w,
      bottom: v.top + v.h,
      height: v.h,
      width: v.w
    }, et(l.chartArea, (_) => {
      const x = _.box;
      Object.assign(x, e.chartArea), x.update(v.w, v.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class bS {
  acquireContext(t, n) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, n, i) {
  }
  removeEventListener(t, n, i) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, n, i, r) {
    return n = Math.max(0, n || t.width), i = i || t.height, {
      width: n,
      height: Math.max(0, r ? Math.floor(n / r) : i)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class b$ extends bS {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const yc = "$chartjs", x$ = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, Lb = (e) => e === null || e === "";
function _$(e, t) {
  const n = e.style, i = e.getAttribute("height"), r = e.getAttribute("width");
  if (e[yc] = {
    initial: {
      height: i,
      width: r,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", Lb(r)) {
    const s = _b(e, "width");
    s !== void 0 && (e.width = s);
  }
  if (Lb(i))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const s = _b(e, "height");
      s !== void 0 && (e.height = s);
    }
  return e;
}
const xS = DN ? {
  passive: !0
} : !1;
function w$(e, t, n) {
  e && e.addEventListener(t, n, xS);
}
function S$(e, t, n) {
  e && e.canvas && e.canvas.removeEventListener(t, n, xS);
}
function k$(e, t) {
  const n = x$[e.type] || e.type, { x: i, y: r } = Hi(e, t);
  return {
    type: n,
    chart: t,
    native: e,
    x: i !== void 0 ? i : null,
    y: r !== void 0 ? r : null
  };
}
function Hc(e, t) {
  for (const n of e)
    if (n === t || n.contains(t))
      return !0;
}
function C$(e, t, n) {
  const i = e.canvas, r = new MutationObserver((s) => {
    let a = !1;
    for (const l of s)
      a = a || Hc(l.addedNodes, i), a = a && !Hc(l.removedNodes, i);
    a && n();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
function T$(e, t, n) {
  const i = e.canvas, r = new MutationObserver((s) => {
    let a = !1;
    for (const l of s)
      a = a || Hc(l.removedNodes, i), a = a && !Hc(l.addedNodes, i);
    a && n();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
const yl = /* @__PURE__ */ new Map();
let Fb = 0;
function _S() {
  const e = window.devicePixelRatio;
  e !== Fb && (Fb = e, yl.forEach((t, n) => {
    n.currentDevicePixelRatio !== e && t();
  }));
}
function I$(e, t) {
  yl.size || window.addEventListener("resize", _S), yl.set(e, t);
}
function P$(e) {
  yl.delete(e), yl.size || window.removeEventListener("resize", _S);
}
function O$(e, t, n) {
  const i = e.canvas, r = i && mg(i);
  if (!r)
    return;
  const s = nS((l, c) => {
    const d = r.clientWidth;
    n(l, c), d < r.clientWidth && n();
  }, window), a = new ResizeObserver((l) => {
    const c = l[0], d = c.contentRect.width, f = c.contentRect.height;
    d === 0 && f === 0 || s(d, f);
  });
  return a.observe(r), I$(e, s), a;
}
function hh(e, t, n) {
  n && n.disconnect(), t === "resize" && P$(e);
}
function E$(e, t, n) {
  const i = e.canvas, r = nS((s) => {
    e.ctx !== null && n(k$(s, e));
  }, e);
  return w$(i, t, r), r;
}
class A$ extends bS {
  acquireContext(t, n) {
    const i = t && t.getContext && t.getContext("2d");
    return i && i.canvas === t ? (_$(t, n), i) : null;
  }
  releaseContext(t) {
    const n = t.canvas;
    if (!n[yc])
      return !1;
    const i = n[yc].initial;
    [
      "height",
      "width"
    ].forEach((s) => {
      const a = i[s];
      yt(a) ? n.removeAttribute(s) : n.setAttribute(s, a);
    });
    const r = i.style || {};
    return Object.keys(r).forEach((s) => {
      n.style[s] = r[s];
    }), n.width = n.width, delete n[yc], !0;
  }
  addEventListener(t, n, i) {
    this.removeEventListener(t, n);
    const r = t.$proxies || (t.$proxies = {}), a = {
      attach: C$,
      detach: T$,
      resize: O$
    }[n] || E$;
    r[n] = a(t, n, i);
  }
  removeEventListener(t, n) {
    const i = t.$proxies || (t.$proxies = {}), r = i[n];
    if (!r)
      return;
    ({
      attach: hh,
      detach: hh,
      resize: hh
    }[n] || S$)(t, n, r), i[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, n, i, r) {
    return MN(t, n, i, r);
  }
  isAttached(t) {
    const n = t && mg(t);
    return !!(n && n.isConnected);
  }
}
function M$(e) {
  return !hg() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? b$ : A$;
}
var cc;
let Xa = (cc = class {
  constructor() {
    Ne(this, "x");
    Ne(this, "y");
    Ne(this, "active", !1);
    Ne(this, "options");
    Ne(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: n, y: i } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: n,
      y: i
    };
  }
  hasValue() {
    return vl(this.x) && vl(this.y);
  }
  getProps(t, n) {
    const i = this.$animations;
    if (!n || !i)
      return this;
    const r = {};
    return t.forEach((s) => {
      r[s] = i[s] && i[s].active() ? i[s]._to : this[s];
    }), r;
  }
}, Ne(cc, "defaults", {}), Ne(cc, "defaultRoutes"), cc);
function D$(e, t) {
  const n = e.options.ticks, i = V$(e), r = Math.min(n.maxTicksLimit || i, i), s = n.major.enabled ? F$(t) : [], a = s.length, l = s[0], c = s[a - 1], d = [];
  if (a > r)
    return R$(t, d, s, a / r), d;
  const f = L$(s, t, r);
  if (a > 0) {
    let m, g;
    const v = a > 1 ? Math.round((c - l) / (a - 1)) : null;
    for (nc(t, d, f, yt(v) ? 0 : l - v, l), m = 0, g = a - 1; m < g; m++)
      nc(t, d, f, s[m], s[m + 1]);
    return nc(t, d, f, c, yt(v) ? t.length : c + v), d;
  }
  return nc(t, d, f), d;
}
function V$(e) {
  const t = e.options.offset, n = e._tickSize(), i = e._length / n + (t ? 0 : 1), r = e._maxLength / n;
  return Math.floor(Math.min(i, r));
}
function L$(e, t, n) {
  const i = B$(e), r = t.length / n;
  if (!i)
    return Math.max(r, 1);
  const s = EB(i);
  for (let a = 0, l = s.length - 1; a < l; a++) {
    const c = s[a];
    if (c > r)
      return c;
  }
  return Math.max(r, 1);
}
function F$(e) {
  const t = [];
  let n, i;
  for (n = 0, i = e.length; n < i; n++)
    e[n].major && t.push(n);
  return t;
}
function R$(e, t, n, i) {
  let r = 0, s = n[0], a;
  for (i = Math.ceil(i), a = 0; a < e.length; a++)
    a === s && (t.push(e[a]), r++, s = n[r * i]);
}
function nc(e, t, n, i, r) {
  const s = Xe(i, 0), a = Math.min(Xe(r, e.length), e.length);
  let l = 0, c, d, f;
  for (n = Math.ceil(n), r && (c = r - i, n = c / Math.floor(c / n)), f = s; f < 0; )
    l++, f = Math.round(s + l * n);
  for (d = Math.max(s, 0); d < a; d++)
    d === f && (t.push(e[d]), l++, f = Math.round(s + l * n));
}
function B$(e) {
  const t = e.length;
  let n, i;
  if (t < 2)
    return !1;
  for (i = e[0], n = 1; n < t; ++n)
    if (e[n] - e[n - 1] !== i)
      return !1;
  return i;
}
const N$ = (e) => e === "left" ? "right" : e === "right" ? "left" : e, Rb = (e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n, Bb = (e, t) => Math.min(t || e, e);
function Nb(e, t) {
  const n = [], i = e.length / t, r = e.length;
  let s = 0;
  for (; s < r; s += i)
    n.push(e[Math.floor(s)]);
  return n;
}
function $$(e, t, n) {
  const i = e.ticks.length, r = Math.min(t, i - 1), s = e._startPixel, a = e._endPixel, l = 1e-6;
  let c = e.getPixelForTick(r), d;
  if (!(n && (i === 1 ? d = Math.max(c - s, a - c) : t === 0 ? d = (e.getPixelForTick(1) - c) / 2 : d = (c - e.getPixelForTick(r - 1)) / 2, c += r < t ? d : -d, c < s - l || c > a + l)))
    return c;
}
function z$(e, t) {
  et(e, (n) => {
    const i = n.gc, r = i.length / 2;
    let s;
    if (r > t) {
      for (s = 0; s < r; ++s)
        delete n.data[i[s]];
      i.splice(0, r);
    }
  });
}
function $o(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function $b(e, t) {
  if (!e.display)
    return 0;
  const n = un(e.font, t), i = Sn(e.padding);
  return (qt(e.text) ? e.text.length : 1) * n.lineHeight + i.height;
}
function H$(e, t) {
  return us(e, {
    scale: t,
    type: "scale"
  });
}
function W$(e, t, n) {
  return us(e, {
    tick: n,
    index: t,
    type: "tick"
  });
}
function U$(e, t, n) {
  let i = iS(e);
  return (n && t !== "right" || !n && t === "right") && (i = N$(i)), i;
}
function q$(e, t, n, i) {
  const { top: r, left: s, bottom: a, right: l, chart: c } = e, { chartArea: d, scales: f } = c;
  let m = 0, g, v, p;
  const _ = a - r, x = l - s;
  if (e.isHorizontal()) {
    if (v = jn(i, s, l), ct(n)) {
      const S = Object.keys(n)[0], T = n[S];
      p = f[S].getPixelForValue(T) + _ - t;
    } else
      n === "center" ? p = (d.bottom + d.top) / 2 + _ - t : p = Rb(e, n, t);
    g = l - s;
  } else {
    if (ct(n)) {
      const S = Object.keys(n)[0], T = n[S];
      v = f[S].getPixelForValue(T) - x + t;
    } else
      n === "center" ? v = (d.left + d.right) / 2 - x + t : v = Rb(e, n, t);
    p = jn(i, a, r), m = n === "left" ? -Zn : Zn;
  }
  return {
    titleX: v,
    titleY: p,
    maxWidth: g,
    rotation: m
  };
}
class Ja extends Xa {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, n) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: n, _suggestedMin: i, _suggestedMax: r } = this;
    return t = Gn(t, Number.POSITIVE_INFINITY), n = Gn(n, Number.NEGATIVE_INFINITY), i = Gn(i, Number.POSITIVE_INFINITY), r = Gn(r, Number.NEGATIVE_INFINITY), {
      min: Gn(t, i),
      max: Gn(n, r),
      minDefined: tn(t),
      maxDefined: tn(n)
    };
  }
  getMinMax(t) {
    let { min: n, max: i, minDefined: r, maxDefined: s } = this.getUserBounds(), a;
    if (r && s)
      return {
        min: n,
        max: i
      };
    const l = this.getMatchingVisibleMetas();
    for (let c = 0, d = l.length; c < d; ++c)
      a = l[c].controller.getMinMax(this, t), r || (n = Math.min(n, a.min)), s || (i = Math.max(i, a.max));
    return n = s && n > i ? i : n, i = r && n > i ? n : i, {
      min: Gn(n, Gn(i, n)),
      max: Gn(i, Gn(n, i))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Fe(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, n, i) {
    const { beginAtZero: r, grace: s, ticks: a } = this.options, l = a.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = n, this._margins = i = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, i), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + i.left + i.right : this.height + i.top + i.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = cN(this, s, r), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const c = l < this.ticks.length;
    this._convertTicksToLabels(c ? Nb(this.ticks, l) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), a.display && (a.autoSkip || a.source === "auto") && (this.ticks = D$(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), c && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, n, i;
    this.isHorizontal() ? (n = this.left, i = this.right) : (n = this.top, i = this.bottom, t = !t), this._startPixel = n, this._endPixel = i, this._reversePixels = t, this._length = i - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Fe(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    Fe(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Fe(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), Fe(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Fe(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const n = this.options.ticks;
    let i, r, s;
    for (i = 0, r = t.length; i < r; i++)
      s = t[i], s.label = Fe(n.callback, [
        s.value,
        i,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    Fe(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    Fe(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, n = t.ticks, i = Bb(this.ticks.length, t.ticks.maxTicksLimit), r = n.minRotation || 0, s = n.maxRotation;
    let a = r, l, c, d;
    if (!this._isVisible() || !n.display || r >= s || i <= 1 || !this.isHorizontal()) {
      this.labelRotation = r;
      return;
    }
    const f = this._getLabelSizes(), m = f.widest.width, g = f.highest.height, v = Oi(this.chart.width - m, 0, this.maxWidth);
    l = t.offset ? this.maxWidth / i : v / (i - 1), m + 6 > l && (l = v / (i - (t.offset ? 0.5 : 1)), c = this.maxHeight - $o(t.grid) - n.padding - $b(t.title, this.chart.options.font), d = Math.sqrt(m * m + g * g), a = rg(Math.min(Math.asin(Oi((f.highest.height + 6) / l, -1, 1)), Math.asin(Oi(c / d, -1, 1)) - Math.asin(Oi(g / d, -1, 1)))), a = Math.max(r, Math.min(s, a))), this.labelRotation = a;
  }
  afterCalculateLabelRotation() {
    Fe(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Fe(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: i, title: r, grid: s } } = this, a = this._isVisible(), l = this.isHorizontal();
    if (a) {
      const c = $b(r, n.options.font);
      if (l ? (t.width = this.maxWidth, t.height = $o(s) + c) : (t.height = this.maxHeight, t.width = $o(s) + c), i.display && this.ticks.length) {
        const { first: d, last: f, widest: m, highest: g } = this._getLabelSizes(), v = i.padding * 2, p = Kr(this.labelRotation), _ = Math.cos(p), x = Math.sin(p);
        if (l) {
          const S = i.mirror ? 0 : x * m.width + _ * g.height;
          t.height = Math.min(this.maxHeight, t.height + S + v);
        } else {
          const S = i.mirror ? 0 : _ * m.width + x * g.height;
          t.width = Math.min(this.maxWidth, t.width + S + v);
        }
        this._calculatePadding(d, f, x, _);
      }
    }
    this._handleMargins(), l ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, n, i, r) {
    const { ticks: { align: s, padding: a }, position: l } = this.options, c = this.labelRotation !== 0, d = l !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const f = this.getPixelForTick(0) - this.left, m = this.right - this.getPixelForTick(this.ticks.length - 1);
      let g = 0, v = 0;
      c ? d ? (g = r * t.width, v = i * n.height) : (g = i * t.height, v = r * n.width) : s === "start" ? v = n.width : s === "end" ? g = t.width : s !== "inner" && (g = t.width / 2, v = n.width / 2), this.paddingLeft = Math.max((g - f + a) * this.width / (this.width - f), 0), this.paddingRight = Math.max((v - m + a) * this.width / (this.width - m), 0);
    } else {
      let f = n.height / 2, m = t.height / 2;
      s === "start" ? (f = 0, m = t.height) : s === "end" && (f = n.height, m = 0), this.paddingTop = f + a, this.paddingBottom = m + a;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Fe(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: n } = this.options;
    return n === "top" || n === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let n, i;
    for (n = 0, i = t.length; n < i; n++)
      yt(t[n].label) && (t.splice(n, 1), i--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const n = this.options.ticks.sampleSize;
      let i = this.ticks;
      n < i.length && (i = Nb(i, n)), this._labelSizes = t = this._computeLabelSizes(i, i.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, n, i) {
    const { ctx: r, _longestTextCache: s } = this, a = [], l = [], c = Math.floor(n / Bb(n, i));
    let d = 0, f = 0, m, g, v, p, _, x, S, T, M, E, D;
    for (m = 0; m < n; m += c) {
      if (p = t[m].label, _ = this._resolveTickFontOptions(m), r.font = x = _.string, S = s[x] = s[x] || {
        data: {},
        gc: []
      }, T = _.lineHeight, M = E = 0, !yt(p) && !qt(p))
        M = Nc(r, S.data, S.gc, M, p), E = T;
      else if (qt(p))
        for (g = 0, v = p.length; g < v; ++g)
          D = p[g], !yt(D) && !qt(D) && (M = Nc(r, S.data, S.gc, M, D), E += T);
      a.push(M), l.push(E), d = Math.max(M, d), f = Math.max(E, f);
    }
    z$(s, n);
    const R = a.indexOf(d), $ = l.indexOf(f), A = (V) => ({
      width: a[V] || 0,
      height: l[V] || 0
    });
    return {
      first: A(0),
      last: A(n - 1),
      widest: A(R),
      highest: A($),
      widths: a,
      heights: l
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, n) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const n = this._startPixel + t * this._length;
    return LB(this._alignToPixels ? Os(this.chart, n, 0) : n);
  }
  getDecimalForPixel(t) {
    const n = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: n } = this;
    return t < 0 && n < 0 ? n : t > 0 && n > 0 ? t : 0;
  }
  getContext(t) {
    const n = this.ticks || [];
    if (t >= 0 && t < n.length) {
      const i = n[t];
      return i.$context || (i.$context = W$(this.getContext(), t, i));
    }
    return this.$context || (this.$context = H$(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, n = Kr(this.labelRotation), i = Math.abs(Math.cos(n)), r = Math.abs(Math.sin(n)), s = this._getLabelSizes(), a = t.autoSkipPadding || 0, l = s ? s.widest.width + a : 0, c = s ? s.highest.height + a : 0;
    return this.isHorizontal() ? c * i > l * r ? l / i : c / r : c * r < l * i ? c / i : l / r;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const n = this.axis, i = this.chart, r = this.options, { grid: s, position: a, border: l } = r, c = s.offset, d = this.isHorizontal(), m = this.ticks.length + (c ? 1 : 0), g = $o(s), v = [], p = l.setContext(this.getContext()), _ = p.display ? p.width : 0, x = _ / 2, S = function(de) {
      return Os(i, de, _);
    };
    let T, M, E, D, R, $, A, V, H, B, N, q;
    if (a === "top")
      T = S(this.bottom), $ = this.bottom - g, V = T - x, B = S(t.top) + x, q = t.bottom;
    else if (a === "bottom")
      T = S(this.top), B = t.top, q = S(t.bottom) - x, $ = T + x, V = this.top + g;
    else if (a === "left")
      T = S(this.right), R = this.right - g, A = T - x, H = S(t.left) + x, N = t.right;
    else if (a === "right")
      T = S(this.left), H = t.left, N = S(t.right) - x, R = T + x, A = this.left + g;
    else if (n === "x") {
      if (a === "center")
        T = S((t.top + t.bottom) / 2 + 0.5);
      else if (ct(a)) {
        const de = Object.keys(a)[0], _e = a[de];
        T = S(this.chart.scales[de].getPixelForValue(_e));
      }
      B = t.top, q = t.bottom, $ = T + x, V = $ + g;
    } else if (n === "y") {
      if (a === "center")
        T = S((t.left + t.right) / 2);
      else if (ct(a)) {
        const de = Object.keys(a)[0], _e = a[de];
        T = S(this.chart.scales[de].getPixelForValue(_e));
      }
      R = T - x, A = R - g, H = t.left, N = t.right;
    }
    const X = Xe(r.ticks.maxTicksLimit, m), se = Math.max(1, Math.ceil(m / X));
    for (M = 0; M < m; M += se) {
      const de = this.getContext(M), _e = s.setContext(de), be = l.setContext(de), oe = _e.lineWidth, J = _e.color, G = be.dash || [], ie = be.dashOffset, ge = _e.tickWidth, he = _e.tickColor, Oe = _e.tickBorderDash || [], Q = _e.tickBorderDashOffset;
      E = $$(this, M, c), E !== void 0 && (D = Os(i, E, oe), d ? R = A = H = N = D : $ = V = B = q = D, v.push({
        tx1: R,
        ty1: $,
        tx2: A,
        ty2: V,
        x1: H,
        y1: B,
        x2: N,
        y2: q,
        width: oe,
        color: J,
        borderDash: G,
        borderDashOffset: ie,
        tickWidth: ge,
        tickColor: he,
        tickBorderDash: Oe,
        tickBorderDashOffset: Q
      }));
    }
    return this._ticksLength = m, this._borderValue = T, v;
  }
  _computeLabelItems(t) {
    const n = this.axis, i = this.options, { position: r, ticks: s } = i, a = this.isHorizontal(), l = this.ticks, { align: c, crossAlign: d, padding: f, mirror: m } = s, g = $o(i.grid), v = g + f, p = m ? -f : v, _ = -Kr(this.labelRotation), x = [];
    let S, T, M, E, D, R, $, A, V, H, B, N, q = "middle";
    if (r === "top")
      R = this.bottom - p, $ = this._getXAxisLabelAlignment();
    else if (r === "bottom")
      R = this.top + p, $ = this._getXAxisLabelAlignment();
    else if (r === "left") {
      const se = this._getYAxisLabelAlignment(g);
      $ = se.textAlign, D = se.x;
    } else if (r === "right") {
      const se = this._getYAxisLabelAlignment(g);
      $ = se.textAlign, D = se.x;
    } else if (n === "x") {
      if (r === "center")
        R = (t.top + t.bottom) / 2 + v;
      else if (ct(r)) {
        const se = Object.keys(r)[0], de = r[se];
        R = this.chart.scales[se].getPixelForValue(de) + v;
      }
      $ = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (r === "center")
        D = (t.left + t.right) / 2 - v;
      else if (ct(r)) {
        const se = Object.keys(r)[0], de = r[se];
        D = this.chart.scales[se].getPixelForValue(de);
      }
      $ = this._getYAxisLabelAlignment(g).textAlign;
    }
    n === "y" && (c === "start" ? q = "top" : c === "end" && (q = "bottom"));
    const X = this._getLabelSizes();
    for (S = 0, T = l.length; S < T; ++S) {
      M = l[S], E = M.label;
      const se = s.setContext(this.getContext(S));
      A = this.getPixelForTick(S) + s.labelOffset, V = this._resolveTickFontOptions(S), H = V.lineHeight, B = qt(E) ? E.length : 1;
      const de = B / 2, _e = se.color, be = se.textStrokeColor, oe = se.textStrokeWidth;
      let J = $;
      a ? (D = A, $ === "inner" && (S === T - 1 ? J = this.options.reverse ? "left" : "right" : S === 0 ? J = this.options.reverse ? "right" : "left" : J = "center"), r === "top" ? d === "near" || _ !== 0 ? N = -B * H + H / 2 : d === "center" ? N = -X.highest.height / 2 - de * H + H : N = -X.highest.height + H / 2 : d === "near" || _ !== 0 ? N = H / 2 : d === "center" ? N = X.highest.height / 2 - de * H : N = X.highest.height - B * H, m && (N *= -1), _ !== 0 && !se.showLabelBackdrop && (D += H / 2 * Math.sin(_))) : (R = A, N = (1 - B) * H / 2);
      let G;
      if (se.showLabelBackdrop) {
        const ie = Sn(se.backdropPadding), ge = X.heights[S], he = X.widths[S];
        let Oe = N - ie.top, Q = 0 - ie.left;
        switch (q) {
          case "middle":
            Oe -= ge / 2;
            break;
          case "bottom":
            Oe -= ge;
            break;
        }
        switch ($) {
          case "center":
            Q -= he / 2;
            break;
          case "right":
            Q -= he;
            break;
          case "inner":
            S === T - 1 ? Q -= he : S > 0 && (Q -= he / 2);
            break;
        }
        G = {
          left: Q,
          top: Oe,
          width: he + ie.width,
          height: ge + ie.height,
          color: se.backdropColor
        };
      }
      x.push({
        label: E,
        font: V,
        textOffset: N,
        options: {
          rotation: _,
          color: _e,
          strokeColor: be,
          strokeWidth: oe,
          textAlign: J,
          textBaseline: q,
          translation: [
            D,
            R
          ],
          backdrop: G
        }
      });
    }
    return x;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: n } = this.options;
    if (-Kr(this.labelRotation))
      return t === "top" ? "left" : "right";
    let r = "center";
    return n.align === "start" ? r = "left" : n.align === "end" ? r = "right" : n.align === "inner" && (r = "inner"), r;
  }
  _getYAxisLabelAlignment(t) {
    const { position: n, ticks: { crossAlign: i, mirror: r, padding: s } } = this.options, a = this._getLabelSizes(), l = t + s, c = a.widest.width;
    let d, f;
    return n === "left" ? r ? (f = this.right + s, i === "near" ? d = "left" : i === "center" ? (d = "center", f += c / 2) : (d = "right", f += c)) : (f = this.right - l, i === "near" ? d = "right" : i === "center" ? (d = "center", f -= c / 2) : (d = "left", f = this.left)) : n === "right" ? r ? (f = this.left + s, i === "near" ? d = "right" : i === "center" ? (d = "center", f -= c / 2) : (d = "left", f -= c)) : (f = this.left + l, i === "near" ? d = "left" : i === "center" ? (d = "center", f += c / 2) : (d = "right", f = this.right)) : d = "right", {
      textAlign: d,
      x: f
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: n }, left: i, top: r, width: s, height: a } = this;
    n && (t.save(), t.fillStyle = n, t.fillRect(i, r, s, a), t.restore());
  }
  getLineWidthForValue(t) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const r = this.ticks.findIndex((s) => s.value === t);
    return r >= 0 ? n.setContext(this.getContext(r)).lineWidth : 0;
  }
  drawGrid(t) {
    const n = this.options.grid, i = this.ctx, r = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let s, a;
    const l = (c, d, f) => {
      !f.width || !f.color || (i.save(), i.lineWidth = f.width, i.strokeStyle = f.color, i.setLineDash(f.borderDash || []), i.lineDashOffset = f.borderDashOffset, i.beginPath(), i.moveTo(c.x, c.y), i.lineTo(d.x, d.y), i.stroke(), i.restore());
    };
    if (n.display)
      for (s = 0, a = r.length; s < a; ++s) {
        const c = r[s];
        n.drawOnChartArea && l({
          x: c.x1,
          y: c.y1
        }, {
          x: c.x2,
          y: c.y2
        }, c), n.drawTicks && l({
          x: c.tx1,
          y: c.ty1
        }, {
          x: c.tx2,
          y: c.ty2
        }, {
          color: c.tickColor,
          width: c.tickWidth,
          borderDash: c.tickBorderDash,
          borderDashOffset: c.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: n, options: { border: i, grid: r } } = this, s = i.setContext(this.getContext()), a = i.display ? s.width : 0;
    if (!a)
      return;
    const l = r.setContext(this.getContext(0)).lineWidth, c = this._borderValue;
    let d, f, m, g;
    this.isHorizontal() ? (d = Os(t, this.left, a) - a / 2, f = Os(t, this.right, l) + l / 2, m = g = c) : (m = Os(t, this.top, a) - a / 2, g = Os(t, this.bottom, l) + l / 2, d = f = c), n.save(), n.lineWidth = s.width, n.strokeStyle = s.color, n.beginPath(), n.moveTo(d, m), n.lineTo(f, g), n.stroke(), n.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const i = this.ctx, r = this._computeLabelArea();
    r && lg(i, r);
    const s = this.getLabelItems(t);
    for (const a of s) {
      const l = a.options, c = a.font, d = a.label, f = a.textOffset;
      Ba(i, d, 0, f, c, l);
    }
    r && ug(i);
  }
  drawTitle() {
    const { ctx: t, options: { position: n, title: i, reverse: r } } = this;
    if (!i.display)
      return;
    const s = un(i.font), a = Sn(i.padding), l = i.align;
    let c = s.lineHeight / 2;
    n === "bottom" || n === "center" || ct(n) ? (c += a.bottom, qt(i.text) && (c += s.lineHeight * (i.text.length - 1))) : c += a.top;
    const { titleX: d, titleY: f, maxWidth: m, rotation: g } = q$(this, c, n, l);
    Ba(t, i.text, 0, 0, s, {
      color: i.color,
      maxWidth: m,
      rotation: g,
      textAlign: U$(l, n, r),
      textBaseline: "middle",
      translation: [
        d,
        f
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, n = t.ticks && t.ticks.z || 0, i = Xe(t.grid && t.grid.z, -1), r = Xe(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Ja.prototype.draw ? [
      {
        z: n,
        draw: (s) => {
          this.draw(s);
        }
      }
    ] : [
      {
        z: i,
        draw: (s) => {
          this.drawBackground(), this.drawGrid(s), this.drawTitle();
        }
      },
      {
        z: r,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (s) => {
          this.drawLabels(s);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const n = this.chart.getSortedVisibleDatasetMetas(), i = this.axis + "AxisID", r = [];
    let s, a;
    for (s = 0, a = n.length; s < a; ++s) {
      const l = n[s];
      l[i] === this.id && (!t || l.type === t) && r.push(l);
    }
    return r;
  }
  _resolveTickFontOptions(t) {
    const n = this.options.ticks.setContext(this.getContext(t));
    return un(n.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class ic {
  constructor(t, n, i) {
    this.type = t, this.scope = n, this.override = i, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const n = Object.getPrototypeOf(t);
    let i;
    Y$(n) && (i = this.register(n));
    const r = this.items, s = t.id, a = this.scope + "." + s;
    if (!s)
      throw new Error("class does not have id: " + t);
    return s in r || (r[s] = t, j$(t, a, i), this.override && Rt.override(t.id, t.overrides)), a;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const n = this.items, i = t.id, r = this.scope;
    i in n && delete n[i], r && i in Rt[r] && (delete Rt[r][i], this.override && delete Us[i]);
  }
}
function j$(e, t, n) {
  const i = gl(/* @__PURE__ */ Object.create(null), [
    n ? Rt.get(n) : {},
    Rt.get(t),
    e.defaults
  ]);
  Rt.set(t, i), e.defaultRoutes && G$(t, e.defaultRoutes), e.descriptors && Rt.describe(t, e.descriptors);
}
function G$(e, t) {
  Object.keys(t).forEach((n) => {
    const i = n.split("."), r = i.pop(), s = [
      e
    ].concat(i).join("."), a = t[n].split("."), l = a.pop(), c = a.join(".");
    Rt.route(s, r, c, l);
  });
}
function Y$(e) {
  return "id" in e && "defaults" in e;
}
class Z$ {
  constructor() {
    this.controllers = new ic(tl, "datasets", !0), this.elements = new ic(Xa, "elements"), this.plugins = new ic(Object, "plugins"), this.scales = new ic(Ja, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, n, i) {
    [
      ...n
    ].forEach((r) => {
      const s = i || this._getRegistryForType(r);
      i || s.isForType(r) || s === this.plugins && r.id ? this._exec(t, s, r) : et(r, (a) => {
        const l = i || this._getRegistryForType(a);
        this._exec(t, l, a);
      });
    });
  }
  _exec(t, n, i) {
    const r = ig(t);
    Fe(i["before" + r], [], i), n[t](i), Fe(i["after" + r], [], i);
  }
  _getRegistryForType(t) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const i = this._typedRegistries[n];
      if (i.isForType(t))
        return i;
    }
    return this.plugins;
  }
  _get(t, n, i) {
    const r = n.get(t);
    if (r === void 0)
      throw new Error('"' + t + '" is not a registered ' + i + ".");
    return r;
  }
}
var zi = /* @__PURE__ */ new Z$();
class K$ {
  constructor() {
    this._init = [];
  }
  notify(t, n, i, r) {
    n === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const s = r ? this._descriptors(t).filter(r) : this._descriptors(t), a = this._notify(s, t, n, i);
    return n === "afterDestroy" && (this._notify(s, t, "stop"), this._notify(this._init, t, "uninstall")), a;
  }
  _notify(t, n, i, r) {
    r = r || {};
    for (const s of t) {
      const a = s.plugin, l = a[i], c = [
        n,
        r,
        s.options
      ];
      if (Fe(l, c, a) === !1 && r.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    yt(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), n;
  }
  _createDescriptors(t, n) {
    const i = t && t.config, r = Xe(i.options && i.options.plugins, {}), s = X$(i);
    return r === !1 && !n ? [] : Q$(t, s, r, n);
  }
  _notifyStateChanges(t) {
    const n = this._oldCache || [], i = this._cache, r = (s, a) => s.filter((l) => !a.some((c) => l.plugin.id === c.plugin.id));
    this._notify(r(n, i), t, "stop"), this._notify(r(i, n), t, "start");
  }
}
function X$(e) {
  const t = {}, n = [], i = Object.keys(zi.plugins.items);
  for (let s = 0; s < i.length; s++)
    n.push(zi.getPlugin(i[s]));
  const r = e.plugins || [];
  for (let s = 0; s < r.length; s++) {
    const a = r[s];
    n.indexOf(a) === -1 && (n.push(a), t[a.id] = !0);
  }
  return {
    plugins: n,
    localIds: t
  };
}
function J$(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function Q$(e, { plugins: t, localIds: n }, i, r) {
  const s = [], a = e.getContext();
  for (const l of t) {
    const c = l.id, d = J$(i[c], r);
    d !== null && s.push({
      plugin: l,
      options: ez(e.config, {
        plugin: l,
        local: n[c]
      }, d, a)
    });
  }
  return s;
}
function ez(e, { plugin: t, local: n }, i, r) {
  const s = e.pluginScopeKeys(t), a = e.getOptionScopes(i, s);
  return n && t.defaults && a.push(t.defaults), e.createResolver(a, r, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function Yh(e, t) {
  const n = Rt.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
function tz(e, t) {
  let n = e;
  return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
function nz(e, t) {
  return e === t ? "_index_" : "_value_";
}
function zb(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
function iz(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function Zh(e, ...t) {
  if (zb(e))
    return e;
  for (const n of t) {
    const i = n.axis || iz(n.position) || e.length > 1 && zb(e[0].toLowerCase());
    if (i)
      return i;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function Hb(e, t, n) {
  if (n[t + "AxisID"] === e)
    return {
      axis: t
    };
}
function rz(e, t) {
  if (t.data && t.data.datasets) {
    const n = t.data.datasets.filter((i) => i.xAxisID === e || i.yAxisID === e);
    if (n.length)
      return Hb(e, "x", n[0]) || Hb(e, "y", n[0]);
  }
  return {};
}
function sz(e, t) {
  const n = Us[e.type] || {
    scales: {}
  }, i = t.scales || {}, r = Yh(e.type, t), s = /* @__PURE__ */ Object.create(null);
  return Object.keys(i).forEach((a) => {
    const l = i[a];
    if (!ct(l))
      return console.error(`Invalid scale configuration for scale: ${a}`);
    if (l._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${a}`);
    const c = Zh(a, l, rz(a, e), Rt.scales[l.type]), d = nz(c, r), f = n.scales || {};
    s[a] = Jo(/* @__PURE__ */ Object.create(null), [
      {
        axis: c
      },
      l,
      f[c],
      f[d]
    ]);
  }), e.data.datasets.forEach((a) => {
    const l = a.type || e.type, c = a.indexAxis || Yh(l, t), f = (Us[l] || {}).scales || {};
    Object.keys(f).forEach((m) => {
      const g = tz(m, c), v = a[g + "AxisID"] || g;
      s[v] = s[v] || /* @__PURE__ */ Object.create(null), Jo(s[v], [
        {
          axis: g
        },
        i[v],
        f[m]
      ]);
    });
  }), Object.keys(s).forEach((a) => {
    const l = s[a];
    Jo(l, [
      Rt.scales[l.type],
      Rt.scale
    ]);
  }), s;
}
function wS(e) {
  const t = e.options || (e.options = {});
  t.plugins = Xe(t.plugins, {}), t.scales = sz(e, t);
}
function SS(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function az(e) {
  return e = e || {}, e.data = SS(e.data), wS(e), e;
}
const Wb = /* @__PURE__ */ new Map(), kS = /* @__PURE__ */ new Set();
function rc(e, t) {
  let n = Wb.get(e);
  return n || (n = t(), Wb.set(e, n), kS.add(n)), n;
}
const zo = (e, t, n) => {
  const i = Fc(t, n);
  i !== void 0 && e.add(i);
};
class oz {
  constructor(t) {
    this._config = az(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = SS(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), wS(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return rc(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, n) {
    return rc(`${t}.transition.${n}`, () => [
      [
        `datasets.${t}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, n) {
    return rc(`${t}-${n}`, () => [
      [
        `datasets.${t}.elements.${n}`,
        `datasets.${t}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const n = t.id, i = this.type;
    return rc(`${i}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, n) {
    const i = this._scopeCache;
    let r = i.get(t);
    return (!r || n) && (r = /* @__PURE__ */ new Map(), i.set(t, r)), r;
  }
  getOptionScopes(t, n, i) {
    const { options: r, type: s } = this, a = this._cachedScopes(t, i), l = a.get(n);
    if (l)
      return l;
    const c = /* @__PURE__ */ new Set();
    n.forEach((f) => {
      t && (c.add(t), f.forEach((m) => zo(c, t, m))), f.forEach((m) => zo(c, r, m)), f.forEach((m) => zo(c, Us[s] || {}, m)), f.forEach((m) => zo(c, Rt, m)), f.forEach((m) => zo(c, jh, m));
    });
    const d = Array.from(c);
    return d.length === 0 && d.push(/* @__PURE__ */ Object.create(null)), kS.has(n) && a.set(n, d), d;
  }
  chartOptionScopes() {
    const { options: t, type: n } = this;
    return [
      t,
      Us[n] || {},
      Rt.datasets[n] || {},
      {
        type: n
      },
      Rt,
      jh
    ];
  }
  resolveNamedOptions(t, n, i, r = [
    ""
  ]) {
    const s = {
      $shared: !0
    }, { resolver: a, subPrefixes: l } = Ub(this._resolverCache, t, r);
    let c = a;
    if (uz(a, n)) {
      s.$shared = !1, i = rs(i) ? i() : i;
      const d = this.createResolver(t, i, l);
      c = Na(a, i, d);
    }
    for (const d of n)
      s[d] = c[d];
    return s;
  }
  createResolver(t, n, i = [
    ""
  ], r) {
    const { resolver: s } = Ub(this._resolverCache, t, i);
    return ct(n) ? Na(s, n, void 0, r) : s;
  }
}
function Ub(e, t, n) {
  let i = e.get(t);
  i || (i = /* @__PURE__ */ new Map(), e.set(t, i));
  const r = n.join();
  let s = i.get(r);
  return s || (s = {
    resolver: cg(t, n),
    subPrefixes: n.filter((l) => !l.toLowerCase().includes("hover"))
  }, i.set(r, s)), s;
}
const lz = (e) => ct(e) && Object.getOwnPropertyNames(e).some((t) => rs(e[t]));
function uz(e, t) {
  const { isScriptable: n, isIndexable: i } = oS(e);
  for (const r of t) {
    const s = n(r), a = i(r), l = (a || s) && e[r];
    if (s && (rs(l) || lz(l)) || a && qt(l))
      return !0;
  }
  return !1;
}
var cz = "4.4.8";
const dz = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function qb(e, t) {
  return e === "top" || e === "bottom" || dz.indexOf(e) === -1 && t === "x";
}
function jb(e, t) {
  return function(n, i) {
    return n[e] === i[e] ? n[t] - i[t] : n[e] - i[e];
  };
}
function Gb(e) {
  const t = e.chart, n = t.options.animation;
  t.notifyPlugins("afterRender"), Fe(n && n.onComplete, [
    e
  ], t);
}
function fz(e) {
  const t = e.chart, n = t.options.animation;
  Fe(n && n.onProgress, [
    e
  ], t);
}
function CS(e) {
  return hg() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const pc = {}, Yb = (e) => {
  const t = CS(e);
  return Object.values(pc).filter((n) => n.canvas === t).pop();
};
function hz(e, t, n) {
  const i = Object.keys(e);
  for (const r of i) {
    const s = +r;
    if (s >= t) {
      const a = e[r];
      delete e[r], (n > 0 || s > t) && (e[s + n] = a);
    }
  }
}
function mz(e, t, n, i) {
  return !n || e.type === "mouseout" ? null : i ? t : e;
}
function sc(e, t, n) {
  return e.options.clip ? e[n] : t[n];
}
function gz(e, t) {
  const { xScale: n, yScale: i } = e;
  return n && i ? {
    left: sc(n, t, "left"),
    right: sc(n, t, "right"),
    top: sc(i, t, "top"),
    bottom: sc(i, t, "bottom")
  } : t;
}
var qr;
let pl = (qr = class {
  static register(...t) {
    zi.add(...t), Zb();
  }
  static unregister(...t) {
    zi.remove(...t), Zb();
  }
  constructor(t, n) {
    const i = this.config = new oz(n), r = CS(t), s = Yb(r);
    if (s)
      throw new Error("Canvas is already in use. Chart with ID '" + s.id + "' must be destroyed before the canvas with ID '" + s.canvas.id + "' can be reused.");
    const a = i.createResolver(i.chartOptionScopes(), this.getContext());
    this.platform = new (i.platform || M$(r))(), this.platform.updateConfig(i);
    const l = this.platform.acquireContext(r, a.aspectRatio), c = l && l.canvas, d = c && c.height, f = c && c.width;
    if (this.id = _B(), this.ctx = l, this.canvas = c, this.width = f, this.height = d, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new K$(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = $B((m) => this.update(m), a.resizeDelay || 0), this._dataChanges = [], pc[this.id] = this, !l || !c) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    hr.listen(this, "complete", Gb), hr.listen(this, "progress", fz), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: n }, width: i, height: r, _aspectRatio: s } = this;
    return yt(t) ? n && s ? s : r ? i / r : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return zi;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : xb(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return yb(this.canvas, this.ctx), this;
  }
  stop() {
    return hr.stop(this), this;
  }
  resize(t, n) {
    hr.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: n
    } : this._resize(t, n);
  }
  _resize(t, n) {
    const i = this.options, r = this.canvas, s = i.maintainAspectRatio && this.aspectRatio, a = this.platform.getMaximumSize(r, t, n, s), l = i.devicePixelRatio || this.platform.getDevicePixelRatio(), c = this.width ? "resize" : "attach";
    this.width = a.width, this.height = a.height, this._aspectRatio = this.aspectRatio, xb(this, l, !0) && (this.notifyPlugins("resize", {
      size: a
    }), Fe(i.onResize, [
      this,
      a
    ], this), this.attached && this._doResize(c) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    et(n, (i, r) => {
      i.id = r;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, n = t.scales, i = this.scales, r = Object.keys(i).reduce((a, l) => (a[l] = !1, a), {});
    let s = [];
    n && (s = s.concat(Object.keys(n).map((a) => {
      const l = n[a], c = Zh(a, l), d = c === "r", f = c === "x";
      return {
        options: l,
        dposition: d ? "chartArea" : f ? "bottom" : "left",
        dtype: d ? "radialLinear" : f ? "category" : "linear"
      };
    }))), et(s, (a) => {
      const l = a.options, c = l.id, d = Zh(c, l), f = Xe(l.type, a.dtype);
      (l.position === void 0 || qb(l.position, d) !== qb(a.dposition)) && (l.position = a.dposition), r[c] = !0;
      let m = null;
      if (c in i && i[c].type === f)
        m = i[c];
      else {
        const g = zi.getScale(f);
        m = new g({
          id: c,
          type: f,
          ctx: this.ctx,
          chart: this
        }), i[m.id] = m;
      }
      m.init(l, t);
    }), et(r, (a, l) => {
      a || delete i[l];
    }), et(i, (a) => {
      Xr.configure(this, a, a.options), Xr.addBox(this, a);
    });
  }
  _updateMetasets() {
    const t = this._metasets, n = this.data.datasets.length, i = t.length;
    if (t.sort((r, s) => r.index - s.index), i > n) {
      for (let r = n; r < i; ++r)
        this._destroyDatasetMeta(r);
      t.splice(n, i - n);
    }
    this._sortedMetasets = t.slice(0).sort(jb("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: n } } = this;
    t.length > n.length && delete this._stacks, t.forEach((i, r) => {
      n.filter((s) => s === i._dataset).length === 0 && this._destroyDatasetMeta(r);
    });
  }
  buildOrUpdateControllers() {
    const t = [], n = this.data.datasets;
    let i, r;
    for (this._removeUnreferencedMetasets(), i = 0, r = n.length; i < r; i++) {
      const s = n[i];
      let a = this.getDatasetMeta(i);
      const l = s.type || this.config.type;
      if (a.type && a.type !== l && (this._destroyDatasetMeta(i), a = this.getDatasetMeta(i)), a.type = l, a.indexAxis = s.indexAxis || Yh(l, this.options), a.order = s.order || 0, a.index = i, a.label = "" + s.label, a.visible = this.isDatasetVisible(i), a.controller)
        a.controller.updateIndex(i), a.controller.linkScales();
      else {
        const c = zi.getController(l), { datasetElementType: d, dataElementType: f } = Rt.datasets[l];
        Object.assign(c, {
          dataElementType: zi.getElement(f),
          datasetElementType: d && zi.getElement(d)
        }), a.controller = new c(this, i), t.push(a.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    et(this.data.datasets, (t, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const n = this.config;
    n.update();
    const i = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), r = this._animationsDisabled = !i.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const s = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let a = 0;
    for (let d = 0, f = this.data.datasets.length; d < f; d++) {
      const { controller: m } = this.getDatasetMeta(d), g = !r && s.indexOf(m) === -1;
      m.buildOrUpdateElements(g), a = Math.max(+m.getMaxOverflow(), a);
    }
    a = this._minPadding = i.layout.autoPadding ? a : 0, this._updateLayout(a), r || et(s, (d) => {
      d.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(jb("z", "_idx"));
    const { _active: l, _lastEvent: c } = this;
    c ? this._eventHandler(c, !0) : l.length && this._updateHoverStyles(l, l, !0), this.render();
  }
  _updateScales() {
    et(this.scales, (t) => {
      Xr.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, n = new Set(Object.keys(this._listeners)), i = new Set(t.events);
    (!lb(n, i) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, n = this._getUniformDataChanges() || [];
    for (const { method: i, start: r, count: s } of n) {
      const a = i === "_removeElements" ? -s : s;
      hz(t, r, a);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, i = (s) => new Set(t.filter((a) => a[0] === s).map((a, l) => l + "," + a.splice(1).join(","))), r = i(0);
    for (let s = 1; s < n; s++)
      if (!lb(r, i(s)))
        return;
    return Array.from(r).map((s) => s.split(",")).map((s) => ({
      method: s[1],
      start: +s[2],
      count: +s[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    Xr.update(this, this.width, this.height, t);
    const n = this.chartArea, i = n.width <= 0 || n.height <= 0;
    this._layers = [], et(this.boxes, (r) => {
      i && r.position === "chartArea" || (r.configure && r.configure(), this._layers.push(...r._layers()));
    }, this), this._layers.forEach((r, s) => {
      r._idx = s;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, i = this.data.datasets.length; n < i; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, i = this.data.datasets.length; n < i; ++n)
        this._updateDataset(n, rs(t) ? t({
          datasetIndex: n
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, n) {
    const i = this.getDatasetMeta(t), r = {
      meta: i,
      index: t,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", r) !== !1 && (i.controller._update(n), r.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", r));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (hr.has(this) ? this.attached && !hr.running(this) && hr.start(this) : (this.draw(), Gb({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: i, height: r } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(i, r);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (t = 0; t < n.length && n[t].z <= 0; ++t)
      n[t].draw(this.chartArea);
    for (this._drawDatasets(); t < n.length; ++t)
      n[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const n = this._sortedMetasets, i = [];
    let r, s;
    for (r = 0, s = n.length; r < s; ++r) {
      const a = n[r];
      (!t || a.visible) && i.push(a);
    }
    return i;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let n = t.length - 1; n >= 0; --n)
      this._drawDataset(t[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const n = this.ctx, i = t._clip, r = !i.disabled, s = gz(t, this.chartArea), a = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", a) !== !1 && (r && lg(n, {
      left: i.left === !1 ? 0 : s.left - i.left,
      right: i.right === !1 ? this.width : s.right + i.right,
      top: i.top === !1 ? 0 : s.top - i.top,
      bottom: i.bottom === !1 ? this.height : s.bottom + i.bottom
    }), t.controller.draw(), r && ug(n), a.cancelable = !1, this.notifyPlugins("afterDatasetDraw", a));
  }
  isPointInArea(t) {
    return Wi(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, n, i, r) {
    const s = d$.modes[n];
    return typeof s == "function" ? s(this, t, i, r) : [];
  }
  getDatasetMeta(t) {
    const n = this.data.datasets[t], i = this._metasets;
    let r = i.filter((s) => s && s._dataset === n).pop();
    return r || (r = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: t,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, i.push(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = us(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const n = this.data.datasets[t];
    if (!n)
      return !1;
    const i = this.getDatasetMeta(t);
    return typeof i.hidden == "boolean" ? !i.hidden : !n.hidden;
  }
  setDatasetVisibility(t, n) {
    const i = this.getDatasetMeta(t);
    i.hidden = !n;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, n, i) {
    const r = i ? "show" : "hide", s = this.getDatasetMeta(t), a = s.controller._resolveAnimations(void 0, r);
    Rc(n) ? (s.data[n].hidden = !i, this.update()) : (this.setDatasetVisibility(t, i), a.update(s, {
      visible: i
    }), this.update((l) => l.datasetIndex === t ? r : void 0));
  }
  hide(t, n) {
    this._updateVisibility(t, n, !1);
  }
  show(t, n) {
    this._updateVisibility(t, n, !0);
  }
  _destroyDatasetMeta(t) {
    const n = this._metasets[t];
    n && n.controller && n.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, n;
    for (this.stop(), hr.remove(this), t = 0, n = this.data.datasets.length; t < n; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: n } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), yb(t, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete pc[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, n = this.platform, i = (s, a) => {
      n.addEventListener(this, s, a), t[s] = a;
    }, r = (s, a, l) => {
      s.offsetX = a, s.offsetY = l, this._eventHandler(s);
    };
    et(this.options.events, (s) => i(s, r));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, n = this.platform, i = (c, d) => {
      n.addEventListener(this, c, d), t[c] = d;
    }, r = (c, d) => {
      t[c] && (n.removeEventListener(this, c, d), delete t[c]);
    }, s = (c, d) => {
      this.canvas && this.resize(c, d);
    };
    let a;
    const l = () => {
      r("attach", l), this.attached = !0, this.resize(), i("resize", s), i("detach", a);
    };
    a = () => {
      this.attached = !1, r("resize", s), this._stop(), this._resize(0, 0), i("attach", l);
    }, n.isAttached(this.canvas) ? l() : a();
  }
  unbindEvents() {
    et(this._listeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._listeners = {}, et(this._responsiveListeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, n, i) {
    const r = i ? "set" : "remove";
    let s, a, l, c;
    for (n === "dataset" && (s = this.getDatasetMeta(t[0].datasetIndex), s.controller["_" + r + "DatasetHoverStyle"]()), l = 0, c = t.length; l < c; ++l) {
      a = t[l];
      const d = a && this.getDatasetMeta(a.datasetIndex).controller;
      d && d[r + "HoverStyle"](a.element, a.datasetIndex, a.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const n = this._active || [], i = t.map(({ datasetIndex: s, index: a }) => {
      const l = this.getDatasetMeta(s);
      if (!l)
        throw new Error("No dataset found at index " + s);
      return {
        datasetIndex: s,
        element: l.data[a],
        index: a
      };
    });
    !Vc(i, n) && (this._active = i, this._lastEvent = null, this._updateHoverStyles(i, n));
  }
  notifyPlugins(t, n, i) {
    return this._plugins.notify(this, t, n, i);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((n) => n.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, n, i) {
    const r = this.options.hover, s = (c, d) => c.filter((f) => !d.some((m) => f.datasetIndex === m.datasetIndex && f.index === m.index)), a = s(n, t), l = i ? t : s(t, n);
    a.length && this.updateHoverStyle(a, r.mode, !1), l.length && r.mode && this.updateHoverStyle(l, r.mode, !0);
  }
  _eventHandler(t, n) {
    const i = {
      event: t,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, r = (a) => (a.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", i, r) === !1)
      return;
    const s = this._handleEvent(t, n, i.inChartArea);
    return i.cancelable = !1, this.notifyPlugins("afterEvent", i, r), (s || i.changed) && this.render(), this;
  }
  _handleEvent(t, n, i) {
    const { _active: r = [], options: s } = this, a = n, l = this._getActiveElements(t, r, i, a), c = IB(t), d = mz(t, this._lastEvent, i, c);
    i && (this._lastEvent = null, Fe(s.onHover, [
      t,
      l,
      this
    ], this), c && Fe(s.onClick, [
      t,
      l,
      this
    ], this));
    const f = !Vc(l, r);
    return (f || n) && (this._active = l, this._updateHoverStyles(l, r, n)), this._lastEvent = d, f;
  }
  _getActiveElements(t, n, i, r) {
    if (t.type === "mouseout")
      return [];
    if (!i)
      return n;
    const s = this.options.hover;
    return this.getElementsAtEventForMode(t, s.mode, s, r);
  }
}, Ne(qr, "defaults", Rt), Ne(qr, "instances", pc), Ne(qr, "overrides", Us), Ne(qr, "registry", zi), Ne(qr, "version", cz), Ne(qr, "getChart", Yb), qr);
function Zb() {
  return et(pl.instances, (e) => e._plugins.invalidate());
}
function TS(e, t, n = t) {
  e.lineCap = Xe(n.borderCapStyle, t.borderCapStyle), e.setLineDash(Xe(n.borderDash, t.borderDash)), e.lineDashOffset = Xe(n.borderDashOffset, t.borderDashOffset), e.lineJoin = Xe(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = Xe(n.borderWidth, t.borderWidth), e.strokeStyle = Xe(n.borderColor, t.borderColor);
}
function vz(e, t, n) {
  e.lineTo(n.x, n.y);
}
function yz(e) {
  return e.stepped ? eN : e.tension || e.cubicInterpolationMode === "monotone" ? tN : vz;
}
function IS(e, t, n = {}) {
  const i = e.length, { start: r = 0, end: s = i - 1 } = n, { start: a, end: l } = t, c = Math.max(r, a), d = Math.min(s, l), f = r < a && s < a || r > l && s > l;
  return {
    count: i,
    start: c,
    loop: t.loop,
    ilen: d < c && !f ? i + d - c : d - c
  };
}
function pz(e, t, n, i) {
  const { points: r, options: s } = t, { count: a, start: l, loop: c, ilen: d } = IS(r, n, i), f = yz(s);
  let { move: m = !0, reverse: g } = i || {}, v, p, _;
  for (v = 0; v <= d; ++v)
    p = r[(l + (g ? d - v : v)) % a], !p.skip && (m ? (e.moveTo(p.x, p.y), m = !1) : f(e, _, p, g, s.stepped), _ = p);
  return c && (p = r[(l + (g ? d : 0)) % a], f(e, _, p, g, s.stepped)), !!c;
}
function bz(e, t, n, i) {
  const r = t.points, { count: s, start: a, ilen: l } = IS(r, n, i), { move: c = !0, reverse: d } = i || {};
  let f = 0, m = 0, g, v, p, _, x, S;
  const T = (E) => (a + (d ? l - E : E)) % s, M = () => {
    _ !== x && (e.lineTo(f, x), e.lineTo(f, _), e.lineTo(f, S));
  };
  for (c && (v = r[T(0)], e.moveTo(v.x, v.y)), g = 0; g <= l; ++g) {
    if (v = r[T(g)], v.skip)
      continue;
    const E = v.x, D = v.y, R = E | 0;
    R === p ? (D < _ ? _ = D : D > x && (x = D), f = (m * f + E) / ++m) : (M(), e.lineTo(E, D), p = R, m = 0, _ = x = D), S = D;
  }
  M();
}
function Kh(e) {
  const t = e.options, n = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? bz : pz;
}
function xz(e) {
  return e.stepped ? VN : e.tension || e.cubicInterpolationMode === "monotone" ? LN : Ms;
}
function _z(e, t, n, i) {
  let r = t._path;
  r || (r = t._path = new Path2D(), t.path(r, n, i) && r.closePath()), TS(e, t.options), e.stroke(r);
}
function wz(e, t, n, i) {
  const { segments: r, options: s } = t, a = Kh(t);
  for (const l of r)
    TS(e, s, l.style), e.beginPath(), a(e, t, l, {
      start: n,
      end: n + i - 1
    }) && e.closePath(), e.stroke();
}
const Sz = typeof Path2D == "function";
function kz(e, t, n, i) {
  Sz && !t.options.segment ? _z(e, t, n, i) : wz(e, t, n, i);
}
class Yo extends Xa {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, n) {
    const i = this.options;
    if ((i.tension || i.cubicInterpolationMode === "monotone") && !i.stepped && !this._pointsUpdated) {
      const r = i.spanGaps ? this._loop : this._fullLoop;
      TN(this._points, i, t, r, n), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = WN(this, this.options.segment));
  }
  first() {
    const t = this.segments, n = this.points;
    return t.length && n[t[0].start];
  }
  last() {
    const t = this.segments, n = this.points, i = t.length;
    return i && n[t[i - 1].end];
  }
  interpolate(t, n) {
    const i = this.options, r = t[n], s = this.points, a = $N(this, {
      property: n,
      start: r,
      end: r
    });
    if (!a.length)
      return;
    const l = [], c = xz(i);
    let d, f;
    for (d = 0, f = a.length; d < f; ++d) {
      const { start: m, end: g } = a[d], v = s[m], p = s[g];
      if (v === p) {
        l.push(v);
        continue;
      }
      const _ = Math.abs((r - v[n]) / (p[n] - v[n])), x = c(v, p, _, i.stepped);
      x[n] = t[n], l.push(x);
    }
    return l.length === 1 ? l[0] : l;
  }
  pathSegment(t, n, i) {
    return Kh(this)(t, this, n, i);
  }
  path(t, n, i) {
    const r = this.segments, s = Kh(this);
    let a = this._loop;
    n = n || 0, i = i || this.points.length - n;
    for (const l of r)
      a &= s(t, this, l, {
        start: n,
        end: n + i - 1
      });
    return !!a;
  }
  draw(t, n, i, r) {
    const s = this.options || {};
    (this.points || []).length && s.borderWidth && (t.save(), kz(t, this, i, r), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
Ne(Yo, "id", "line"), Ne(Yo, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), Ne(Yo, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), Ne(Yo, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function Kb(e, t, n, i) {
  const r = e.options, { [n]: s } = e.getProps([
    n
  ], i);
  return Math.abs(t - s) < r.radius + r.hitRadius;
}
class bc extends Xa {
  constructor(n) {
    super();
    Ne(this, "parsed");
    Ne(this, "skip");
    Ne(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, i, r) {
    const s = this.options, { x: a, y: l } = this.getProps([
      "x",
      "y"
    ], r);
    return Math.pow(n - a, 2) + Math.pow(i - l, 2) < Math.pow(s.hitRadius + s.radius, 2);
  }
  inXRange(n, i) {
    return Kb(this, n, "x", i);
  }
  inYRange(n, i) {
    return Kb(this, n, "y", i);
  }
  getCenterPoint(n) {
    const { x: i, y: r } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: i,
      y: r
    };
  }
  size(n) {
    n = n || this.options || {};
    let i = n.radius || 0;
    i = Math.max(i, i && n.hoverRadius || 0);
    const r = i && n.borderWidth || 0;
    return (i + r) * 2;
  }
  draw(n, i) {
    const r = this.options;
    this.skip || r.radius < 0.1 || !Wi(this, i, this.size(r) / 2) || (n.strokeStyle = r.borderColor, n.lineWidth = r.borderWidth, n.fillStyle = r.backgroundColor, Gh(n, r, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
Ne(bc, "id", "point"), /**
* @type {any}
*/
Ne(bc, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
Ne(bc, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
const Xb = (e, t) => {
  let { boxHeight: n = t, boxWidth: i = t } = e;
  return e.usePointStyle && (n = Math.min(n, t), i = e.pointStyleWidth || Math.min(i, t)), {
    boxWidth: i,
    boxHeight: n,
    itemHeight: Math.max(t, n)
  };
}, Cz = (e, t) => e !== null && t !== null && e.datasetIndex === t.datasetIndex && e.index === t.index;
class Jb extends Xa {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n, i) {
    this.maxWidth = t, this.maxHeight = n, this._margins = i, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let n = Fe(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (n = n.filter((i) => t.filter(i, this.chart.data))), t.sort && (n = n.sort((i, r) => t.sort(i, r, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: t, ctx: n } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const i = t.labels, r = un(i.font), s = r.size, a = this._computeTitleHeight(), { boxWidth: l, itemHeight: c } = Xb(i, s);
    let d, f;
    n.font = r.string, this.isHorizontal() ? (d = this.maxWidth, f = this._fitRows(a, s, l, c) + 10) : (f = this.maxHeight, d = this._fitCols(a, r, l, c) + 10), this.width = Math.min(d, t.maxWidth || this.maxWidth), this.height = Math.min(f, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, n, i, r) {
    const { ctx: s, maxWidth: a, options: { labels: { padding: l } } } = this, c = this.legendHitBoxes = [], d = this.lineWidths = [
      0
    ], f = r + l;
    let m = t;
    s.textAlign = "left", s.textBaseline = "middle";
    let g = -1, v = -f;
    return this.legendItems.forEach((p, _) => {
      const x = i + n / 2 + s.measureText(p.text).width;
      (_ === 0 || d[d.length - 1] + x + 2 * l > a) && (m += f, d[d.length - (_ > 0 ? 0 : 1)] = 0, v += f, g++), c[_] = {
        left: 0,
        top: v,
        row: g,
        width: x,
        height: r
      }, d[d.length - 1] += x + l;
    }), m;
  }
  _fitCols(t, n, i, r) {
    const { ctx: s, maxHeight: a, options: { labels: { padding: l } } } = this, c = this.legendHitBoxes = [], d = this.columnSizes = [], f = a - t;
    let m = l, g = 0, v = 0, p = 0, _ = 0;
    return this.legendItems.forEach((x, S) => {
      const { itemWidth: T, itemHeight: M } = Tz(i, n, s, x, r);
      S > 0 && v + M + 2 * l > f && (m += g + l, d.push({
        width: g,
        height: v
      }), p += g + l, _++, g = v = 0), c[S] = {
        left: p,
        top: v,
        col: _,
        width: T,
        height: M
      }, g = Math.max(g, T), v += M + l;
    }), m += g, d.push({
      width: g,
      height: v
    }), m;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: i, labels: { padding: r }, rtl: s } } = this, a = Aa(s, this.left, this.width);
    if (this.isHorizontal()) {
      let l = 0, c = jn(i, this.left + r, this.right - this.lineWidths[l]);
      for (const d of n)
        l !== d.row && (l = d.row, c = jn(i, this.left + r, this.right - this.lineWidths[l])), d.top += this.top + t + r, d.left = a.leftForLtr(a.x(c), d.width), c += d.width + r;
    } else {
      let l = 0, c = jn(i, this.top + t + r, this.bottom - this.columnSizes[l].height);
      for (const d of n)
        d.col !== l && (l = d.col, c = jn(i, this.top + t + r, this.bottom - this.columnSizes[l].height)), d.top = c, d.left += this.left + r, d.left = a.leftForLtr(a.x(d.left), d.width), c += d.height + r;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      lg(t, this), this._draw(), ug(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: n, lineWidths: i, ctx: r } = this, { align: s, labels: a } = t, l = Rt.color, c = Aa(t.rtl, this.left, this.width), d = un(a.font), { padding: f } = a, m = d.size, g = m / 2;
    let v;
    this.drawTitle(), r.textAlign = c.textAlign("left"), r.textBaseline = "middle", r.lineWidth = 0.5, r.font = d.string;
    const { boxWidth: p, boxHeight: _, itemHeight: x } = Xb(a, m), S = function(R, $, A) {
      if (isNaN(p) || p <= 0 || isNaN(_) || _ < 0)
        return;
      r.save();
      const V = Xe(A.lineWidth, 1);
      if (r.fillStyle = Xe(A.fillStyle, l), r.lineCap = Xe(A.lineCap, "butt"), r.lineDashOffset = Xe(A.lineDashOffset, 0), r.lineJoin = Xe(A.lineJoin, "miter"), r.lineWidth = V, r.strokeStyle = Xe(A.strokeStyle, l), r.setLineDash(Xe(A.lineDash, [])), a.usePointStyle) {
        const H = {
          radius: _ * Math.SQRT2 / 2,
          pointStyle: A.pointStyle,
          rotation: A.rotation,
          borderWidth: V
        }, B = c.xPlus(R, p / 2), N = $ + g;
        sS(r, H, B, N, a.pointStyleWidth && p);
      } else {
        const H = $ + Math.max((m - _) / 2, 0), B = c.leftForLtr(R, p), N = Ea(A.borderRadius);
        r.beginPath(), Object.values(N).some((q) => q !== 0) ? $c(r, {
          x: B,
          y: H,
          w: p,
          h: _,
          radius: N
        }) : r.rect(B, H, p, _), r.fill(), V !== 0 && r.stroke();
      }
      r.restore();
    }, T = function(R, $, A) {
      Ba(r, A.text, R, $ + x / 2, d, {
        strikethrough: A.hidden,
        textAlign: c.textAlign(A.textAlign)
      });
    }, M = this.isHorizontal(), E = this._computeTitleHeight();
    M ? v = {
      x: jn(s, this.left + f, this.right - i[0]),
      y: this.top + f + E,
      line: 0
    } : v = {
      x: this.left + f,
      y: jn(s, this.top + E + f, this.bottom - n[0].height),
      line: 0
    }, fS(this.ctx, t.textDirection);
    const D = x + f;
    this.legendItems.forEach((R, $) => {
      r.strokeStyle = R.fontColor, r.fillStyle = R.fontColor;
      const A = r.measureText(R.text).width, V = c.textAlign(R.textAlign || (R.textAlign = a.textAlign)), H = p + g + A;
      let B = v.x, N = v.y;
      c.setWidth(this.width), M ? $ > 0 && B + H + f > this.right && (N = v.y += D, v.line++, B = v.x = jn(s, this.left + f, this.right - i[v.line])) : $ > 0 && N + D > this.bottom && (B = v.x = B + n[v.line].width + f, v.line++, N = v.y = jn(s, this.top + E + f, this.bottom - n[v.line].height));
      const q = c.x(B);
      if (S(q, N, R), B = zB(V, B + p + g, M ? B + H : this.right, t.rtl), T(c.x(B), N, R), M)
        v.x += H + f;
      else if (typeof R.text != "string") {
        const X = d.lineHeight;
        v.y += PS(R, X) + f;
      } else
        v.y += D;
    }), hS(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, n = t.title, i = un(n.font), r = Sn(n.padding);
    if (!n.display)
      return;
    const s = Aa(t.rtl, this.left, this.width), a = this.ctx, l = n.position, c = i.size / 2, d = r.top + c;
    let f, m = this.left, g = this.width;
    if (this.isHorizontal())
      g = Math.max(...this.lineWidths), f = this.top + d, m = jn(t.align, m, this.right - g);
    else {
      const p = this.columnSizes.reduce((_, x) => Math.max(_, x.height), 0);
      f = d + jn(t.align, this.top, this.bottom - p - t.labels.padding - this._computeTitleHeight());
    }
    const v = jn(l, m, m + g);
    a.textAlign = s.textAlign(iS(l)), a.textBaseline = "middle", a.strokeStyle = n.color, a.fillStyle = n.color, a.font = i.string, Ba(a, n.text, v, f, i);
  }
  _computeTitleHeight() {
    const t = this.options.title, n = un(t.font), i = Sn(t.padding);
    return t.display ? n.lineHeight + i.height : 0;
  }
  _getLegendItemAt(t, n) {
    let i, r, s;
    if (jo(t, this.left, this.right) && jo(n, this.top, this.bottom)) {
      for (s = this.legendHitBoxes, i = 0; i < s.length; ++i)
        if (r = s[i], jo(t, r.left, r.left + r.width) && jo(n, r.top, r.top + r.height))
          return this.legendItems[i];
    }
    return null;
  }
  handleEvent(t) {
    const n = this.options;
    if (!Oz(t.type, n))
      return;
    const i = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const r = this._hoveredItem, s = Cz(r, i);
      r && !s && Fe(n.onLeave, [
        t,
        r,
        this
      ], this), this._hoveredItem = i, i && !s && Fe(n.onHover, [
        t,
        i,
        this
      ], this);
    } else
      i && Fe(n.onClick, [
        t,
        i,
        this
      ], this);
  }
}
function Tz(e, t, n, i, r) {
  const s = Iz(i, e, t, n), a = Pz(r, i, t.lineHeight);
  return {
    itemWidth: s,
    itemHeight: a
  };
}
function Iz(e, t, n, i) {
  let r = e.text;
  return r && typeof r != "string" && (r = r.reduce((s, a) => s.length > a.length ? s : a)), t + n.size / 2 + i.measureText(r).width;
}
function Pz(e, t, n) {
  let i = e;
  return typeof t.text != "string" && (i = PS(t, n)), i;
}
function PS(e, t) {
  const n = e.text ? e.text.length : 0;
  return t * n;
}
function Oz(e, t) {
  return !!((e === "mousemove" || e === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (e === "click" || e === "mouseup"));
}
var Ez = {
  id: "legend",
  _element: Jb,
  start(e, t, n) {
    const i = e.legend = new Jb({
      ctx: e.ctx,
      options: n,
      chart: e
    });
    Xr.configure(e, i, n), Xr.addBox(e, i);
  },
  stop(e) {
    Xr.removeBox(e, e.legend), delete e.legend;
  },
  beforeUpdate(e, t, n) {
    const i = e.legend;
    Xr.configure(e, i, n), i.options = n;
  },
  afterUpdate(e) {
    const t = e.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(e, t) {
    t.replay || e.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(e, t, n) {
      const i = t.datasetIndex, r = n.chart;
      r.isDatasetVisible(i) ? (r.hide(i), t.hidden = !0) : (r.show(i), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (e) => e.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(e) {
        const t = e.data.datasets, { labels: { usePointStyle: n, pointStyle: i, textAlign: r, color: s, useBorderRadius: a, borderRadius: l } } = e.legend.options;
        return e._getSortedDatasetMetas().map((c) => {
          const d = c.controller.getStyle(n ? 0 : void 0), f = Sn(d.borderWidth);
          return {
            text: t[c.index].label,
            fillStyle: d.backgroundColor,
            fontColor: s,
            hidden: !c.visible,
            lineCap: d.borderCapStyle,
            lineDash: d.borderDash,
            lineDashOffset: d.borderDashOffset,
            lineJoin: d.borderJoinStyle,
            lineWidth: (f.width + f.height) / 4,
            strokeStyle: d.borderColor,
            pointStyle: i || d.pointStyle,
            rotation: d.rotation,
            textAlign: r || d.textAlign,
            borderRadius: a && (l || d.borderRadius),
            datasetIndex: c.index
          };
        }, this);
      }
    },
    title: {
      color: (e) => e.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (e) => !e.startsWith("on"),
    labels: {
      _scriptable: (e) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(e)
    }
  }
};
const Zo = {
  average(e) {
    if (!e.length)
      return !1;
    let t, n, i = /* @__PURE__ */ new Set(), r = 0, s = 0;
    for (t = 0, n = e.length; t < n; ++t) {
      const l = e[t].element;
      if (l && l.hasValue()) {
        const c = l.tooltipPosition();
        i.add(c.x), r += c.y, ++s;
      }
    }
    return s === 0 || i.size === 0 ? !1 : {
      x: [
        ...i
      ].reduce((l, c) => l + c) / i.size,
      y: r / s
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let n = t.x, i = t.y, r = Number.POSITIVE_INFINITY, s, a, l;
    for (s = 0, a = e.length; s < a; ++s) {
      const c = e[s].element;
      if (c && c.hasValue()) {
        const d = c.getCenterPoint(), f = qh(t, d);
        f < r && (r = f, l = c);
      }
    }
    if (l) {
      const c = l.tooltipPosition();
      n = c.x, i = c.y;
    }
    return {
      x: n,
      y: i
    };
  }
};
function $i(e, t) {
  return t && (qt(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function mr(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function Az(e, t) {
  const { element: n, datasetIndex: i, index: r } = t, s = e.getDatasetMeta(i).controller, { label: a, value: l } = s.getLabelAndValue(r);
  return {
    chart: e,
    label: a,
    parsed: s.getParsed(r),
    raw: e.data.datasets[i].data[r],
    formattedValue: l,
    dataset: s.getDataset(),
    dataIndex: r,
    datasetIndex: i,
    element: n
  };
}
function Qb(e, t) {
  const n = e.chart.ctx, { body: i, footer: r, title: s } = e, { boxWidth: a, boxHeight: l } = t, c = un(t.bodyFont), d = un(t.titleFont), f = un(t.footerFont), m = s.length, g = r.length, v = i.length, p = Sn(t.padding);
  let _ = p.height, x = 0, S = i.reduce((E, D) => E + D.before.length + D.lines.length + D.after.length, 0);
  if (S += e.beforeBody.length + e.afterBody.length, m && (_ += m * d.lineHeight + (m - 1) * t.titleSpacing + t.titleMarginBottom), S) {
    const E = t.displayColors ? Math.max(l, c.lineHeight) : c.lineHeight;
    _ += v * E + (S - v) * c.lineHeight + (S - 1) * t.bodySpacing;
  }
  g && (_ += t.footerMarginTop + g * f.lineHeight + (g - 1) * t.footerSpacing);
  let T = 0;
  const M = function(E) {
    x = Math.max(x, n.measureText(E).width + T);
  };
  return n.save(), n.font = d.string, et(e.title, M), n.font = c.string, et(e.beforeBody.concat(e.afterBody), M), T = t.displayColors ? a + 2 + t.boxPadding : 0, et(i, (E) => {
    et(E.before, M), et(E.lines, M), et(E.after, M);
  }), T = 0, n.font = f.string, et(e.footer, M), n.restore(), x += p.width, {
    width: x,
    height: _
  };
}
function Mz(e, t) {
  const { y: n, height: i } = t;
  return n < i / 2 ? "top" : n > e.height - i / 2 ? "bottom" : "center";
}
function Dz(e, t, n, i) {
  const { x: r, width: s } = i, a = n.caretSize + n.caretPadding;
  if (e === "left" && r + s + a > t.width || e === "right" && r - s - a < 0)
    return !0;
}
function Vz(e, t, n, i) {
  const { x: r, width: s } = n, { width: a, chartArea: { left: l, right: c } } = e;
  let d = "center";
  return i === "center" ? d = r <= (l + c) / 2 ? "left" : "right" : r <= s / 2 ? d = "left" : r >= a - s / 2 && (d = "right"), Dz(d, e, t, n) && (d = "center"), d;
}
function e0(e, t, n) {
  const i = n.yAlign || t.yAlign || Mz(e, n);
  return {
    xAlign: n.xAlign || t.xAlign || Vz(e, t, n, i),
    yAlign: i
  };
}
function Lz(e, t) {
  let { x: n, width: i } = e;
  return t === "right" ? n -= i : t === "center" && (n -= i / 2), n;
}
function Fz(e, t, n) {
  let { y: i, height: r } = e;
  return t === "top" ? i += n : t === "bottom" ? i -= r + n : i -= r / 2, i;
}
function t0(e, t, n, i) {
  const { caretSize: r, caretPadding: s, cornerRadius: a } = e, { xAlign: l, yAlign: c } = n, d = r + s, { topLeft: f, topRight: m, bottomLeft: g, bottomRight: v } = Ea(a);
  let p = Lz(t, l);
  const _ = Fz(t, c, d);
  return c === "center" ? l === "left" ? p += d : l === "right" && (p -= d) : l === "left" ? p -= Math.max(f, g) + r : l === "right" && (p += Math.max(m, v) + r), {
    x: Oi(p, 0, i.width - t.width),
    y: Oi(_, 0, i.height - t.height)
  };
}
function ac(e, t, n) {
  const i = Sn(n.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - i.right : e.x + i.left;
}
function n0(e) {
  return $i([], mr(e));
}
function Rz(e, t, n) {
  return us(e, {
    tooltip: t,
    tooltipItems: n,
    type: "tooltip"
  });
}
function i0(e, t) {
  const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return n ? e.override(n) : e;
}
const OS = {
  beforeTitle: fr,
  title(e) {
    if (e.length > 0) {
      const t = e[0], n = t.chart.data.labels, i = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (i > 0 && t.dataIndex < i)
        return n[t.dataIndex];
    }
    return "";
  },
  afterTitle: fr,
  beforeBody: fr,
  beforeLabel: fr,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const n = e.formattedValue;
    return yt(n) || (t += n), t;
  },
  labelColor(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: fr,
  afterBody: fr,
  beforeFooter: fr,
  footer: fr,
  afterFooter: fr
};
function Dn(e, t, n, i) {
  const r = e[t].call(n, i);
  return typeof r > "u" ? OS[t].call(n, i) : r;
}
class Xh extends Xa {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const n = this.chart, i = this.options.setContext(this.getContext()), r = i.enabled && n.options.animation && i.animations, s = new gS(this.chart, r);
    return r._cacheable && (this._cachedAnimations = Object.freeze(s)), s;
  }
  getContext() {
    return this.$context || (this.$context = Rz(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, n) {
    const { callbacks: i } = n, r = Dn(i, "beforeTitle", this, t), s = Dn(i, "title", this, t), a = Dn(i, "afterTitle", this, t);
    let l = [];
    return l = $i(l, mr(r)), l = $i(l, mr(s)), l = $i(l, mr(a)), l;
  }
  getBeforeBody(t, n) {
    return n0(Dn(n.callbacks, "beforeBody", this, t));
  }
  getBody(t, n) {
    const { callbacks: i } = n, r = [];
    return et(t, (s) => {
      const a = {
        before: [],
        lines: [],
        after: []
      }, l = i0(i, s);
      $i(a.before, mr(Dn(l, "beforeLabel", this, s))), $i(a.lines, Dn(l, "label", this, s)), $i(a.after, mr(Dn(l, "afterLabel", this, s))), r.push(a);
    }), r;
  }
  getAfterBody(t, n) {
    return n0(Dn(n.callbacks, "afterBody", this, t));
  }
  getFooter(t, n) {
    const { callbacks: i } = n, r = Dn(i, "beforeFooter", this, t), s = Dn(i, "footer", this, t), a = Dn(i, "afterFooter", this, t);
    let l = [];
    return l = $i(l, mr(r)), l = $i(l, mr(s)), l = $i(l, mr(a)), l;
  }
  _createItems(t) {
    const n = this._active, i = this.chart.data, r = [], s = [], a = [];
    let l = [], c, d;
    for (c = 0, d = n.length; c < d; ++c)
      l.push(Az(this.chart, n[c]));
    return t.filter && (l = l.filter((f, m, g) => t.filter(f, m, g, i))), t.itemSort && (l = l.sort((f, m) => t.itemSort(f, m, i))), et(l, (f) => {
      const m = i0(t.callbacks, f);
      r.push(Dn(m, "labelColor", this, f)), s.push(Dn(m, "labelPointStyle", this, f)), a.push(Dn(m, "labelTextColor", this, f));
    }), this.labelColors = r, this.labelPointStyles = s, this.labelTextColors = a, this.dataPoints = l, l;
  }
  update(t, n) {
    const i = this.options.setContext(this.getContext()), r = this._active;
    let s, a = [];
    if (!r.length)
      this.opacity !== 0 && (s = {
        opacity: 0
      });
    else {
      const l = Zo[i.position].call(this, r, this._eventPosition);
      a = this._createItems(i), this.title = this.getTitle(a, i), this.beforeBody = this.getBeforeBody(a, i), this.body = this.getBody(a, i), this.afterBody = this.getAfterBody(a, i), this.footer = this.getFooter(a, i);
      const c = this._size = Qb(this, i), d = Object.assign({}, l, c), f = e0(this.chart, i, d), m = t0(i, d, f, this.chart);
      this.xAlign = f.xAlign, this.yAlign = f.yAlign, s = {
        opacity: 1,
        x: m.x,
        y: m.y,
        width: c.width,
        height: c.height,
        caretX: l.x,
        caretY: l.y
      };
    }
    this._tooltipItems = a, this.$context = void 0, s && this._resolveAnimations().update(this, s), t && i.external && i.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(t, n, i, r) {
    const s = this.getCaretPosition(t, i, r);
    n.lineTo(s.x1, s.y1), n.lineTo(s.x2, s.y2), n.lineTo(s.x3, s.y3);
  }
  getCaretPosition(t, n, i) {
    const { xAlign: r, yAlign: s } = this, { caretSize: a, cornerRadius: l } = i, { topLeft: c, topRight: d, bottomLeft: f, bottomRight: m } = Ea(l), { x: g, y: v } = t, { width: p, height: _ } = n;
    let x, S, T, M, E, D;
    return s === "center" ? (E = v + _ / 2, r === "left" ? (x = g, S = x - a, M = E + a, D = E - a) : (x = g + p, S = x + a, M = E - a, D = E + a), T = x) : (r === "left" ? S = g + Math.max(c, f) + a : r === "right" ? S = g + p - Math.max(d, m) - a : S = this.caretX, s === "top" ? (M = v, E = M - a, x = S - a, T = S + a) : (M = v + _, E = M + a, x = S + a, T = S - a), D = M), {
      x1: x,
      x2: S,
      x3: T,
      y1: M,
      y2: E,
      y3: D
    };
  }
  drawTitle(t, n, i) {
    const r = this.title, s = r.length;
    let a, l, c;
    if (s) {
      const d = Aa(i.rtl, this.x, this.width);
      for (t.x = ac(this, i.titleAlign, i), n.textAlign = d.textAlign(i.titleAlign), n.textBaseline = "middle", a = un(i.titleFont), l = i.titleSpacing, n.fillStyle = i.titleColor, n.font = a.string, c = 0; c < s; ++c)
        n.fillText(r[c], d.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + l, c + 1 === s && (t.y += i.titleMarginBottom - l);
    }
  }
  _drawColorBox(t, n, i, r, s) {
    const a = this.labelColors[i], l = this.labelPointStyles[i], { boxHeight: c, boxWidth: d } = s, f = un(s.bodyFont), m = ac(this, "left", s), g = r.x(m), v = c < f.lineHeight ? (f.lineHeight - c) / 2 : 0, p = n.y + v;
    if (s.usePointStyle) {
      const _ = {
        radius: Math.min(d, c) / 2,
        pointStyle: l.pointStyle,
        rotation: l.rotation,
        borderWidth: 1
      }, x = r.leftForLtr(g, d) + d / 2, S = p + c / 2;
      t.strokeStyle = s.multiKeyBackground, t.fillStyle = s.multiKeyBackground, Gh(t, _, x, S), t.strokeStyle = a.borderColor, t.fillStyle = a.backgroundColor, Gh(t, _, x, S);
    } else {
      t.lineWidth = ct(a.borderWidth) ? Math.max(...Object.values(a.borderWidth)) : a.borderWidth || 1, t.strokeStyle = a.borderColor, t.setLineDash(a.borderDash || []), t.lineDashOffset = a.borderDashOffset || 0;
      const _ = r.leftForLtr(g, d), x = r.leftForLtr(r.xPlus(g, 1), d - 2), S = Ea(a.borderRadius);
      Object.values(S).some((T) => T !== 0) ? (t.beginPath(), t.fillStyle = s.multiKeyBackground, $c(t, {
        x: _,
        y: p,
        w: d,
        h: c,
        radius: S
      }), t.fill(), t.stroke(), t.fillStyle = a.backgroundColor, t.beginPath(), $c(t, {
        x,
        y: p + 1,
        w: d - 2,
        h: c - 2,
        radius: S
      }), t.fill()) : (t.fillStyle = s.multiKeyBackground, t.fillRect(_, p, d, c), t.strokeRect(_, p, d, c), t.fillStyle = a.backgroundColor, t.fillRect(x, p + 1, d - 2, c - 2));
    }
    t.fillStyle = this.labelTextColors[i];
  }
  drawBody(t, n, i) {
    const { body: r } = this, { bodySpacing: s, bodyAlign: a, displayColors: l, boxHeight: c, boxWidth: d, boxPadding: f } = i, m = un(i.bodyFont);
    let g = m.lineHeight, v = 0;
    const p = Aa(i.rtl, this.x, this.width), _ = function(A) {
      n.fillText(A, p.x(t.x + v), t.y + g / 2), t.y += g + s;
    }, x = p.textAlign(a);
    let S, T, M, E, D, R, $;
    for (n.textAlign = a, n.textBaseline = "middle", n.font = m.string, t.x = ac(this, x, i), n.fillStyle = i.bodyColor, et(this.beforeBody, _), v = l && x !== "right" ? a === "center" ? d / 2 + f : d + 2 + f : 0, E = 0, R = r.length; E < R; ++E) {
      for (S = r[E], T = this.labelTextColors[E], n.fillStyle = T, et(S.before, _), M = S.lines, l && M.length && (this._drawColorBox(n, t, E, p, i), g = Math.max(m.lineHeight, c)), D = 0, $ = M.length; D < $; ++D)
        _(M[D]), g = m.lineHeight;
      et(S.after, _);
    }
    v = 0, g = m.lineHeight, et(this.afterBody, _), t.y -= s;
  }
  drawFooter(t, n, i) {
    const r = this.footer, s = r.length;
    let a, l;
    if (s) {
      const c = Aa(i.rtl, this.x, this.width);
      for (t.x = ac(this, i.footerAlign, i), t.y += i.footerMarginTop, n.textAlign = c.textAlign(i.footerAlign), n.textBaseline = "middle", a = un(i.footerFont), n.fillStyle = i.footerColor, n.font = a.string, l = 0; l < s; ++l)
        n.fillText(r[l], c.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + i.footerSpacing;
    }
  }
  drawBackground(t, n, i, r) {
    const { xAlign: s, yAlign: a } = this, { x: l, y: c } = t, { width: d, height: f } = i, { topLeft: m, topRight: g, bottomLeft: v, bottomRight: p } = Ea(r.cornerRadius);
    n.fillStyle = r.backgroundColor, n.strokeStyle = r.borderColor, n.lineWidth = r.borderWidth, n.beginPath(), n.moveTo(l + m, c), a === "top" && this.drawCaret(t, n, i, r), n.lineTo(l + d - g, c), n.quadraticCurveTo(l + d, c, l + d, c + g), a === "center" && s === "right" && this.drawCaret(t, n, i, r), n.lineTo(l + d, c + f - p), n.quadraticCurveTo(l + d, c + f, l + d - p, c + f), a === "bottom" && this.drawCaret(t, n, i, r), n.lineTo(l + v, c + f), n.quadraticCurveTo(l, c + f, l, c + f - v), a === "center" && s === "left" && this.drawCaret(t, n, i, r), n.lineTo(l, c + m), n.quadraticCurveTo(l, c, l + m, c), n.closePath(), n.fill(), r.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(t) {
    const n = this.chart, i = this.$animations, r = i && i.x, s = i && i.y;
    if (r || s) {
      const a = Zo[t.position].call(this, this._active, this._eventPosition);
      if (!a)
        return;
      const l = this._size = Qb(this, t), c = Object.assign({}, a, this._size), d = e0(n, t, c), f = t0(t, c, d, n);
      (r._to !== f.x || s._to !== f.y) && (this.xAlign = d.xAlign, this.yAlign = d.yAlign, this.width = l.width, this.height = l.height, this.caretX = a.x, this.caretY = a.y, this._resolveAnimations().update(this, f));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const n = this.options.setContext(this.getContext());
    let i = this.opacity;
    if (!i)
      return;
    this._updateAnimationTarget(n);
    const r = {
      width: this.width,
      height: this.height
    }, s = {
      x: this.x,
      y: this.y
    };
    i = Math.abs(i) < 1e-3 ? 0 : i;
    const a = Sn(n.padding), l = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && l && (t.save(), t.globalAlpha = i, this.drawBackground(s, t, r, n), fS(t, n.textDirection), s.y += a.top, this.drawTitle(s, t, n), this.drawBody(s, t, n), this.drawFooter(s, t, n), hS(t, n.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, n) {
    const i = this._active, r = t.map(({ datasetIndex: l, index: c }) => {
      const d = this.chart.getDatasetMeta(l);
      if (!d)
        throw new Error("Cannot find a dataset at index " + l);
      return {
        datasetIndex: l,
        element: d.data[c],
        index: c
      };
    }), s = !Vc(i, r), a = this._positionChanged(r, n);
    (s || a) && (this._active = r, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, n, i = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const r = this.options, s = this._active || [], a = this._getActiveElements(t, s, n, i), l = this._positionChanged(a, t), c = n || !Vc(a, s) || l;
    return c && (this._active = a, (r.enabled || r.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, n))), c;
  }
  _getActiveElements(t, n, i, r) {
    const s = this.options;
    if (t.type === "mouseout")
      return [];
    if (!r)
      return n.filter((l) => this.chart.data.datasets[l.datasetIndex] && this.chart.getDatasetMeta(l.datasetIndex).controller.getParsed(l.index) !== void 0);
    const a = this.chart.getElementsAtEventForMode(t, s.mode, s, i);
    return s.reverse && a.reverse(), a;
  }
  _positionChanged(t, n) {
    const { caretX: i, caretY: r, options: s } = this, a = Zo[s.position].call(this, t, n);
    return a !== !1 && (i !== a.x || r !== a.y);
  }
}
Ne(Xh, "positioners", Zo);
var Bz = {
  id: "tooltip",
  _element: Xh,
  positioners: Zo,
  afterInit(e, t, n) {
    n && (e.tooltip = new Xh({
      chart: e,
      options: n
    }));
  },
  beforeUpdate(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  reset(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const n = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const n = t.replay;
      e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: OS
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
function Nz(e, t) {
  const n = [], { bounds: r, step: s, min: a, max: l, precision: c, count: d, maxTicks: f, maxDigits: m, includeBounds: g } = e, v = s || 1, p = f - 1, { min: _, max: x } = t, S = !yt(a), T = !yt(l), M = !yt(d), E = (x - _) / (m + 1);
  let D = cb((x - _) / p / v) * v, R, $, A, V;
  if (D < 1e-14 && !S && !T)
    return [
      {
        value: _
      },
      {
        value: x
      }
    ];
  V = Math.ceil(x / D) - Math.floor(_ / D), V > p && (D = cb(V * D / p / v) * v), yt(c) || (R = Math.pow(10, c), D = Math.ceil(D * R) / R), r === "ticks" ? ($ = Math.floor(_ / D) * D, A = Math.ceil(x / D) * D) : ($ = _, A = x), S && T && s && MB((l - a) / s, D / 1e3) ? (V = Math.round(Math.min((l - a) / D, f)), D = (l - a) / V, $ = a, A = l) : M ? ($ = S ? a : $, A = T ? l : A, V = d - 1, D = (A - $) / V) : (V = (A - $) / D, $s(V, Math.round(V), D / 1e3) ? V = Math.round(V) : V = Math.ceil(V));
  const H = Math.max(db(D), db($));
  R = Math.pow(10, yt(c) ? H : c), $ = Math.round($ * R) / R, A = Math.round(A * R) / R;
  let B = 0;
  for (S && (g && $ !== a ? (n.push({
    value: a
  }), $ < a && B++, $s(Math.round(($ + B * D) * R) / R, a, r0(a, E, e)) && B++) : $ < a && B++); B < V; ++B) {
    const N = Math.round(($ + B * D) * R) / R;
    if (T && N > l)
      break;
    n.push({
      value: N
    });
  }
  return T && g && A !== l ? n.length && $s(n[n.length - 1].value, l, r0(l, E, e)) ? n[n.length - 1].value = l : n.push({
    value: l
  }) : (!T || A === l) && n.push({
    value: A
  }), n;
}
function r0(e, t, { horizontal: n, minRotation: i }) {
  const r = Kr(i), s = (n ? Math.sin(r) : Math.cos(r)) || 1e-3, a = 0.75 * t * ("" + e).length;
  return Math.min(t / s, a);
}
class Wc extends Ja {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    return yt(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: n, maxDefined: i } = this.getUserBounds();
    let { min: r, max: s } = this;
    const a = (c) => r = n ? r : c, l = (c) => s = i ? s : c;
    if (t) {
      const c = ss(r), d = ss(s);
      c < 0 && d < 0 ? l(0) : c > 0 && d > 0 && a(0);
    }
    if (r === s) {
      let c = s === 0 ? 1 : Math.abs(s * 0.05);
      l(s + c), t || a(r - c);
    }
    this.min = r, this.max = s;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: n, stepSize: i } = t, r;
    return i ? (r = Math.ceil(this.max / i) - Math.floor(this.min / i) + 1, r > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${i} would result generating up to ${r} ticks. Limiting to 1000.`), r = 1e3)) : (r = this.computeTickLimit(), n = n || 11), n && (r = Math.min(n, r)), r;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, n = t.ticks;
    let i = this.getTickLimit();
    i = Math.max(2, i);
    const r = {
      maxTicks: i,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, s = this._range || this, a = Nz(r, s);
    return t.bounds === "ticks" && Jw(a, this, "value"), t.reverse ? (a.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), a;
  }
  configure() {
    const t = this.ticks;
    let n = this.min, i = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const r = (i - n) / Math.max(t.length - 1, 1) / 2;
      n -= r, i += r;
    }
    this._startValue = n, this._endValue = i, this._valueRange = i - n;
  }
  getLabelForValue(t) {
    return og(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class Jh extends Wc {
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = tn(t) ? t : 0, this.max = tn(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), n = t ? this.width : this.height, i = Kr(this.options.ticks.minRotation), r = (t ? Math.sin(i) : Math.cos(i)) || 1e-3, s = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, s.lineHeight / r));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
Ne(Jh, "id", "linear"), Ne(Jh, "defaults", {
  ticks: {
    callback: vd.formatters.numeric
  }
});
const bl = (e) => Math.floor(Zr(e)), As = (e, t) => Math.pow(10, bl(e) + t);
function s0(e) {
  return e / Math.pow(10, bl(e)) === 1;
}
function a0(e, t, n) {
  const i = Math.pow(10, n), r = Math.floor(e / i);
  return Math.ceil(t / i) - r;
}
function $z(e, t) {
  const n = t - e;
  let i = bl(n);
  for (; a0(e, t, i) > 10; )
    i++;
  for (; a0(e, t, i) < 10; )
    i--;
  return Math.min(i, bl(e));
}
function zz(e, { min: t, max: n }) {
  t = Gn(e.min, t);
  const i = [], r = bl(t);
  let s = $z(t, n), a = s < 0 ? Math.pow(10, Math.abs(s)) : 1;
  const l = Math.pow(10, s), c = r > s ? Math.pow(10, r) : 0, d = Math.round((t - c) * a) / a, f = Math.floor((t - c) / l / 10) * l * 10;
  let m = Math.floor((d - f) / Math.pow(10, s)), g = Gn(e.min, Math.round((c + f + m * Math.pow(10, s)) * a) / a);
  for (; g < n; )
    i.push({
      value: g,
      major: s0(g),
      significand: m
    }), m >= 10 ? m = m < 15 ? 15 : 20 : m++, m >= 20 && (s++, m = 2, a = s >= 0 ? 1 : a), g = Math.round((c + f + m * Math.pow(10, s)) * a) / a;
  const v = Gn(e.max, g);
  return i.push({
    value: v,
    major: s0(v),
    significand: m
  }), i;
}
class o0 extends Ja {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    const i = Wc.prototype.parse.apply(this, [
      t,
      n
    ]);
    if (i === 0) {
      this._zero = !0;
      return;
    }
    return tn(i) && i > 0 ? i : null;
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = tn(t) ? Math.max(0, t) : null, this.max = tn(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !tn(this._userMin) && (this.min = t === As(this.min, 0) ? As(this.min, -1) : As(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let i = this.min, r = this.max;
    const s = (l) => i = t ? i : l, a = (l) => r = n ? r : l;
    i === r && (i <= 0 ? (s(1), a(10)) : (s(As(i, -1)), a(As(r, 1)))), i <= 0 && s(As(r, -1)), r <= 0 && a(As(i, 1)), this.min = i, this.max = r;
  }
  buildTicks() {
    const t = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, i = zz(n, this);
    return t.bounds === "ticks" && Jw(i, this, "value"), t.reverse ? (i.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), i;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : og(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = Zr(t), this._valueRange = Zr(this.max) - Zr(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (Zr(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const n = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
Ne(o0, "id", "logarithmic"), Ne(o0, "defaults", {
  ticks: {
    callback: vd.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function Qh(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const n = Sn(t.backdropPadding);
    return Xe(t.font && t.font.size, Rt.font.size) + n.height;
  }
  return 0;
}
function Hz(e, t, n) {
  return n = qt(n) ? n : [
    n
  ], {
    w: QB(e, t.string, n),
    h: n.length * t.lineHeight
  };
}
function l0(e, t, n, i, r) {
  return e === i || e === r ? {
    start: t - n / 2,
    end: t + n / 2
  } : e < i || e > r ? {
    start: t - n,
    end: t
  } : {
    start: t,
    end: t + n
  };
}
function Wz(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, n = Object.assign({}, t), i = [], r = [], s = e._pointLabels.length, a = e.options.pointLabels, l = a.centerPointLabels ? nn / s : 0;
  for (let c = 0; c < s; c++) {
    const d = a.setContext(e.getPointLabelContext(c));
    r[c] = d.padding;
    const f = e.getPointPosition(c, e.drawingArea + r[c], l), m = un(d.font), g = Hz(e.ctx, m, e._pointLabels[c]);
    i[c] = g;
    const v = Ii(e.getIndexAngle(c) + l), p = Math.round(rg(v)), _ = l0(p, f.x, g.w, 0, 180), x = l0(p, f.y, g.h, 90, 270);
    Uz(n, t, v, _, x);
  }
  e.setCenterPoint(t.l - n.l, n.r - t.r, t.t - n.t, n.b - t.b), e._pointLabelItems = Gz(e, i, r);
}
function Uz(e, t, n, i, r) {
  const s = Math.abs(Math.sin(n)), a = Math.abs(Math.cos(n));
  let l = 0, c = 0;
  i.start < t.l ? (l = (t.l - i.start) / s, e.l = Math.min(e.l, t.l - l)) : i.end > t.r && (l = (i.end - t.r) / s, e.r = Math.max(e.r, t.r + l)), r.start < t.t ? (c = (t.t - r.start) / a, e.t = Math.min(e.t, t.t - c)) : r.end > t.b && (c = (r.end - t.b) / a, e.b = Math.max(e.b, t.b + c));
}
function qz(e, t, n) {
  const i = e.drawingArea, { extra: r, additionalAngle: s, padding: a, size: l } = n, c = e.getPointPosition(t, i + r + a, s), d = Math.round(rg(Ii(c.angle + Zn))), f = Kz(c.y, l.h, d), m = Yz(d), g = Zz(c.x, l.w, m);
  return {
    visible: !0,
    x: c.x,
    y: f,
    textAlign: m,
    left: g,
    top: f,
    right: g + l.w,
    bottom: f + l.h
  };
}
function jz(e, t) {
  if (!t)
    return !0;
  const { left: n, top: i, right: r, bottom: s } = e;
  return !(Wi({
    x: n,
    y: i
  }, t) || Wi({
    x: n,
    y: s
  }, t) || Wi({
    x: r,
    y: i
  }, t) || Wi({
    x: r,
    y: s
  }, t));
}
function Gz(e, t, n) {
  const i = [], r = e._pointLabels.length, s = e.options, { centerPointLabels: a, display: l } = s.pointLabels, c = {
    extra: Qh(s) / 2,
    additionalAngle: a ? nn / r : 0
  };
  let d;
  for (let f = 0; f < r; f++) {
    c.padding = n[f], c.size = t[f];
    const m = qz(e, f, c);
    i.push(m), l === "auto" && (m.visible = jz(m, d), m.visible && (d = m));
  }
  return i;
}
function Yz(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function Zz(e, t, n) {
  return n === "right" ? e -= t : n === "center" && (e -= t / 2), e;
}
function Kz(e, t, n) {
  return n === 90 || n === 270 ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e;
}
function Xz(e, t, n) {
  const { left: i, top: r, right: s, bottom: a } = n, { backdropColor: l } = t;
  if (!yt(l)) {
    const c = Ea(t.borderRadius), d = Sn(t.backdropPadding);
    e.fillStyle = l;
    const f = i - d.left, m = r - d.top, g = s - i + d.width, v = a - r + d.height;
    Object.values(c).some((p) => p !== 0) ? (e.beginPath(), $c(e, {
      x: f,
      y: m,
      w: g,
      h: v,
      radius: c
    }), e.fill()) : e.fillRect(f, m, g, v);
  }
}
function Jz(e, t) {
  const { ctx: n, options: { pointLabels: i } } = e;
  for (let r = t - 1; r >= 0; r--) {
    const s = e._pointLabelItems[r];
    if (!s.visible)
      continue;
    const a = i.setContext(e.getPointLabelContext(r));
    Xz(n, a, s);
    const l = un(a.font), { x: c, y: d, textAlign: f } = s;
    Ba(n, e._pointLabels[r], c, d + l.lineHeight / 2, l, {
      color: a.color,
      textAlign: f,
      textBaseline: "middle"
    });
  }
}
function ES(e, t, n, i) {
  const { ctx: r } = e;
  if (n)
    r.arc(e.xCenter, e.yCenter, t, 0, vi);
  else {
    let s = e.getPointPosition(0, t);
    r.moveTo(s.x, s.y);
    for (let a = 1; a < i; a++)
      s = e.getPointPosition(a, t), r.lineTo(s.x, s.y);
  }
}
function Qz(e, t, n, i, r) {
  const s = e.ctx, a = t.circular, { color: l, lineWidth: c } = t;
  !a && !i || !l || !c || n < 0 || (s.save(), s.strokeStyle = l, s.lineWidth = c, s.setLineDash(r.dash || []), s.lineDashOffset = r.dashOffset, s.beginPath(), ES(e, n, a, i), s.closePath(), s.stroke(), s.restore());
}
function eH(e, t, n) {
  return us(e, {
    label: n,
    index: t,
    type: "pointLabel"
  });
}
class oc extends Wc {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = Sn(Qh(this.options) / 2), n = this.width = this.maxWidth - t.width, i = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + n / 2 + t.left), this.yCenter = Math.floor(this.top + i / 2 + t.top), this.drawingArea = Math.floor(Math.min(n, i) / 2);
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!1);
    this.min = tn(t) && !isNaN(t) ? t : 0, this.max = tn(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / Qh(this.options));
  }
  generateTickLabels(t) {
    Wc.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((n, i) => {
      const r = Fe(this.options.pointLabels.callback, [
        n,
        i
      ], this);
      return r || r === 0 ? r : "";
    }).filter((n, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? Wz(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, n, i, r) {
    this.xCenter += Math.floor((t - n) / 2), this.yCenter += Math.floor((i - r) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, n, i, r));
  }
  getIndexAngle(t) {
    const n = vi / (this._pointLabels.length || 1), i = this.options.startAngle || 0;
    return Ii(t * n + Kr(i));
  }
  getDistanceFromCenterForValue(t) {
    if (yt(t))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * n : (t - this.min) * n;
  }
  getValueForDistanceFromCenter(t) {
    if (yt(t))
      return NaN;
    const n = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(t) {
    const n = this._pointLabels || [];
    if (t >= 0 && t < n.length) {
      const i = n[t];
      return eH(this.getContext(), t, i);
    }
  }
  getPointPosition(t, n, i = 0) {
    const r = this.getIndexAngle(t) - Zn + i;
    return {
      x: Math.cos(r) * n + this.xCenter,
      y: Math.sin(r) * n + this.yCenter,
      angle: r
    };
  }
  getPointPositionForValue(t, n) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: n, top: i, right: r, bottom: s } = this._pointLabelItems[t];
    return {
      left: n,
      top: i,
      right: r,
      bottom: s
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: n } } = this.options;
    if (t) {
      const i = this.ctx;
      i.save(), i.beginPath(), ES(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), i.closePath(), i.fillStyle = t, i.fill(), i.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, n = this.options, { angleLines: i, grid: r, border: s } = n, a = this._pointLabels.length;
    let l, c, d;
    if (n.pointLabels.display && Jz(this, a), r.display && this.ticks.forEach((f, m) => {
      if (m !== 0 || m === 0 && this.min < 0) {
        c = this.getDistanceFromCenterForValue(f.value);
        const g = this.getContext(m), v = r.setContext(g), p = s.setContext(g);
        Qz(this, v, c, a, p);
      }
    }), i.display) {
      for (t.save(), l = a - 1; l >= 0; l--) {
        const f = i.setContext(this.getPointLabelContext(l)), { color: m, lineWidth: g } = f;
        !g || !m || (t.lineWidth = g, t.strokeStyle = m, t.setLineDash(f.borderDash), t.lineDashOffset = f.borderDashOffset, c = this.getDistanceFromCenterForValue(n.reverse ? this.min : this.max), d = this.getPointPosition(l, c), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(d.x, d.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, n = this.options, i = n.ticks;
    if (!i.display)
      return;
    const r = this.getIndexAngle(0);
    let s, a;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(r), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((l, c) => {
      if (c === 0 && this.min >= 0 && !n.reverse)
        return;
      const d = i.setContext(this.getContext(c)), f = un(d.font);
      if (s = this.getDistanceFromCenterForValue(this.ticks[c].value), d.showLabelBackdrop) {
        t.font = f.string, a = t.measureText(l.label).width, t.fillStyle = d.backdropColor;
        const m = Sn(d.backdropPadding);
        t.fillRect(-a / 2 - m.left, -s - f.size / 2 - m.top, a + m.width, f.size + m.height);
      }
      Ba(t, l.label, 0, -s, f, {
        color: d.color,
        strokeColor: d.textStrokeColor,
        strokeWidth: d.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
Ne(oc, "id", "radialLinear"), Ne(oc, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: vd.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), Ne(oc, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), Ne(oc, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const pd = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, Rn = /* @__PURE__ */ Object.keys(pd);
function u0(e, t) {
  return e - t;
}
function c0(e, t) {
  if (yt(t))
    return null;
  const n = e._adapter, { parser: i, round: r, isoWeekday: s } = e._parseOpts;
  let a = t;
  return typeof i == "function" && (a = i(a)), tn(a) || (a = typeof i == "string" ? n.parse(a, i) : n.parse(a)), a === null ? null : (r && (a = r === "week" && (vl(s) || s === !0) ? n.startOf(a, "isoWeek", s) : n.startOf(a, r)), +a);
}
function d0(e, t, n, i) {
  const r = Rn.length;
  for (let s = Rn.indexOf(e); s < r - 1; ++s) {
    const a = pd[Rn[s]], l = a.steps ? a.steps : Number.MAX_SAFE_INTEGER;
    if (a.common && Math.ceil((n - t) / (l * a.size)) <= i)
      return Rn[s];
  }
  return Rn[r - 1];
}
function tH(e, t, n, i, r) {
  for (let s = Rn.length - 1; s >= Rn.indexOf(n); s--) {
    const a = Rn[s];
    if (pd[a].common && e._adapter.diff(r, i, a) >= t - 1)
      return a;
  }
  return Rn[n ? Rn.indexOf(n) : 0];
}
function nH(e) {
  for (let t = Rn.indexOf(e) + 1, n = Rn.length; t < n; ++t)
    if (pd[Rn[t]].common)
      return Rn[t];
}
function f0(e, t, n) {
  if (!n)
    e[t] = !0;
  else if (n.length) {
    const { lo: i, hi: r } = sg(n, t), s = n[i] >= t ? n[i] : n[r];
    e[s] = !0;
  }
}
function iH(e, t, n, i) {
  const r = e._adapter, s = +r.startOf(t[0].value, i), a = t[t.length - 1].value;
  let l, c;
  for (l = s; l <= a; l = +r.add(l, 1, i))
    c = n[l], c >= 0 && (t[c].major = !0);
  return t;
}
function h0(e, t, n) {
  const i = [], r = {}, s = t.length;
  let a, l;
  for (a = 0; a < s; ++a)
    l = t[a], r[l] = a, i.push({
      value: l,
      major: !1
    });
  return s === 0 || !n ? i : iH(e, i, r, n);
}
class Uc extends Ja {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, n = {}) {
    const i = t.time || (t.time = {}), r = this._adapter = new a$._date(t.adapters.date);
    r.init(n), Jo(i.displayFormats, r.formats()), this._parseOpts = {
      parser: i.parser,
      round: i.round,
      isoWeekday: i.isoWeekday
    }, super.init(t), this._normalized = n.normalized;
  }
  parse(t, n) {
    return t === void 0 ? null : c0(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, n = this._adapter, i = t.time.unit || "day";
    let { min: r, max: s, minDefined: a, maxDefined: l } = this.getUserBounds();
    function c(d) {
      !a && !isNaN(d.min) && (r = Math.min(r, d.min)), !l && !isNaN(d.max) && (s = Math.max(s, d.max));
    }
    (!a || !l) && (c(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && c(this.getMinMax(!1))), r = tn(r) && !isNaN(r) ? r : +n.startOf(Date.now(), i), s = tn(s) && !isNaN(s) ? s : +n.endOf(Date.now(), i) + 1, this.min = Math.min(r, s - 1), this.max = Math.max(r + 1, s);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, i = Number.NEGATIVE_INFINITY;
    return t.length && (n = t[0], i = t[t.length - 1]), {
      min: n,
      max: i
    };
  }
  buildTicks() {
    const t = this.options, n = t.time, i = t.ticks, r = i.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && r.length && (this.min = this._userMin || r[0], this.max = this._userMax || r[r.length - 1]);
    const s = this.min, a = this.max, l = RB(r, s, a);
    return this._unit = n.unit || (i.autoSkip ? d0(n.minUnit, this.min, this.max, this._getLabelCapacity(s)) : tH(this, l.length, n.minUnit, this.min, this.max)), this._majorUnit = !i.major.enabled || this._unit === "year" ? void 0 : nH(this._unit), this.initOffsets(r), t.reverse && l.reverse(), h0(this, l, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let n = 0, i = 0, r, s;
    this.options.offset && t.length && (r = this.getDecimalForValue(t[0]), t.length === 1 ? n = 1 - r : n = (this.getDecimalForValue(t[1]) - r) / 2, s = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? i = s : i = (s - this.getDecimalForValue(t[t.length - 2])) / 2);
    const a = t.length < 3 ? 0.5 : 0.25;
    n = Oi(n, 0, a), i = Oi(i, 0, a), this._offsets = {
      start: n,
      end: i,
      factor: 1 / (n + 1 + i)
    };
  }
  _generate() {
    const t = this._adapter, n = this.min, i = this.max, r = this.options, s = r.time, a = s.unit || d0(s.minUnit, n, i, this._getLabelCapacity(n)), l = Xe(r.ticks.stepSize, 1), c = a === "week" ? s.isoWeekday : !1, d = vl(c) || c === !0, f = {};
    let m = n, g, v;
    if (d && (m = +t.startOf(m, "isoWeek", c)), m = +t.startOf(m, d ? "day" : a), t.diff(i, n, a) > 1e5 * l)
      throw new Error(n + " and " + i + " are too far apart with stepSize of " + l + " " + a);
    const p = r.ticks.source === "data" && this.getDataTimestamps();
    for (g = m, v = 0; g < i; g = +t.add(g, l, a), v++)
      f0(f, g, p);
    return (g === i || r.bounds === "ticks" || v === 1) && f0(f, g, p), Object.keys(f).sort(u0).map((_) => +_);
  }
  getLabelForValue(t) {
    const n = this._adapter, i = this.options.time;
    return i.tooltipFormat ? n.format(t, i.tooltipFormat) : n.format(t, i.displayFormats.datetime);
  }
  format(t, n) {
    const r = this.options.time.displayFormats, s = this._unit, a = n || r[s];
    return this._adapter.format(t, a);
  }
  _tickFormatFunction(t, n, i, r) {
    const s = this.options, a = s.ticks.callback;
    if (a)
      return Fe(a, [
        t,
        n,
        i
      ], this);
    const l = s.time.displayFormats, c = this._unit, d = this._majorUnit, f = c && l[c], m = d && l[d], g = i[n], v = d && m && g && g.major;
    return this._adapter.format(t, r || (v ? m : f));
  }
  generateTickLabels(t) {
    let n, i, r;
    for (n = 0, i = t.length; n < i; ++n)
      r = t[n], r.label = this._tickFormatFunction(r.value, n, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const n = this._offsets, i = this.getDecimalForValue(t);
    return this.getPixelForDecimal((n.start + i) * n.factor);
  }
  getValueForPixel(t) {
    const n = this._offsets, i = this.getDecimalForPixel(t) / n.factor - n.end;
    return this.min + i * (this.max - this.min);
  }
  _getLabelSize(t) {
    const n = this.options.ticks, i = this.ctx.measureText(t).width, r = Kr(this.isHorizontal() ? n.maxRotation : n.minRotation), s = Math.cos(r), a = Math.sin(r), l = this._resolveTickFontOptions(0).size;
    return {
      w: i * s + l * a,
      h: i * a + l * s
    };
  }
  _getLabelCapacity(t) {
    const n = this.options.time, i = n.displayFormats, r = i[n.unit] || i.millisecond, s = this._tickFormatFunction(t, 0, h0(this, [
      t
    ], this._majorUnit), r), a = this._getLabelSize(s), l = Math.floor(this.isHorizontal() ? this.width / a.w : this.height / a.h) - 1;
    return l > 0 ? l : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], n, i;
    if (t.length)
      return t;
    const r = this.getMatchingVisibleMetas();
    if (this._normalized && r.length)
      return this._cache.data = r[0].controller.getAllParsedValues(this);
    for (n = 0, i = r.length; n < i; ++n)
      t = t.concat(r[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let n, i;
    if (t.length)
      return t;
    const r = this.getLabels();
    for (n = 0, i = r.length; n < i; ++n)
      t.push(c0(this, r[n]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return NB(t.sort(u0));
  }
}
Ne(Uc, "id", "time"), Ne(Uc, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function lc(e, t, n) {
  let i = 0, r = e.length - 1, s, a, l, c;
  n ? (t >= e[i].pos && t <= e[r].pos && ({ lo: i, hi: r } = Ls(e, "pos", t)), { pos: s, time: l } = e[i], { pos: a, time: c } = e[r]) : (t >= e[i].time && t <= e[r].time && ({ lo: i, hi: r } = Ls(e, "time", t)), { time: s, pos: l } = e[i], { time: a, pos: c } = e[r]);
  const d = a - s;
  return d ? l + (c - l) * (t - s) / d : l;
}
class m0 extends Uc {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(t);
    this._minPos = lc(n, this.min), this._tableRange = lc(n, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: n, max: i } = this, r = [], s = [];
    let a, l, c, d, f;
    for (a = 0, l = t.length; a < l; ++a)
      d = t[a], d >= n && d <= i && r.push(d);
    if (r.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: i,
          pos: 1
        }
      ];
    for (a = 0, l = r.length; a < l; ++a)
      f = r[a + 1], c = r[a - 1], d = r[a], Math.round((f + c) / 2) !== d && s.push({
        time: d,
        pos: a / (l - 1)
      });
    return s;
  }
  _generate() {
    const t = this.min, n = this.max;
    let i = super.getDataTimestamps();
    return (!i.includes(t) || !i.length) && i.splice(0, 0, t), (!i.includes(n) || i.length === 1) && i.push(n), i.sort((r, s) => r - s);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const n = this.getDataTimestamps(), i = this.getLabelTimestamps();
    return n.length && i.length ? t = this.normalize(n.concat(i)) : t = n.length ? n : i, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (lc(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const n = this._offsets, i = this.getDecimalForPixel(t) / n.factor - n.end;
    return lc(this._table, i * this._tableRange + this._minPos, !0);
  }
}
Ne(m0, "id", "timeseries"), Ne(m0, "defaults", Uc.defaults);
const AS = {
  data: {
    type: Object,
    required: !0
  },
  options: {
    type: Object,
    default: () => ({})
  },
  plugins: {
    type: Array,
    default: () => []
  },
  datasetIdKey: {
    type: String,
    default: "label"
  },
  updateMode: {
    type: String,
    default: void 0
  }
}, rH = {
  ariaLabel: {
    type: String
  },
  ariaDescribedby: {
    type: String
  }
}, sH = {
  type: {
    type: String,
    required: !0
  },
  destroyDelay: {
    type: Number,
    default: 0
    // No delay by default
  },
  ...AS,
  ...rH
}, aH = gE[0] === "2" ? (e, t) => Object.assign(e, {
  attrs: t
}) : (e, t) => Object.assign(e, t);
function ka(e) {
  return L0(e) ? Pt(e) : e;
}
function oH(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e;
  return L0(t) ? new Proxy(e, {}) : e;
}
function lH(e, t) {
  const n = e.options;
  n && t && Object.assign(n, t);
}
function MS(e, t) {
  e.labels = t;
}
function DS(e, t, n) {
  const i = [];
  e.datasets = t.map((r) => {
    const s = e.datasets.find((a) => a[n] === r[n]);
    return !s || !r.data || i.includes(s) ? {
      ...r
    } : (i.push(s), Object.assign(s, r), s);
  });
}
function uH(e, t) {
  const n = {
    labels: [],
    datasets: []
  };
  return MS(n, e.labels), DS(n, e.datasets, t), n;
}
const cH = Je({
  props: sH,
  setup(e, t) {
    let { expose: n, slots: i } = t;
    const r = ue(null), s = Ie(null);
    n({
      chart: s
    });
    const a = () => {
      if (!r.value)
        return;
      const { type: d, data: f, options: m, plugins: g, datasetIdKey: v } = e, p = uH(f, v), _ = oH(p, f);
      s.value = new pl(r.value, {
        type: d,
        data: _,
        options: {
          ...m
        },
        plugins: g
      });
    }, l = () => {
      const d = Pt(s.value);
      d && (e.destroyDelay > 0 ? setTimeout(() => {
        d.destroy(), s.value = null;
      }, e.destroyDelay) : (d.destroy(), s.value = null));
    }, c = (d) => {
      d.update(e.updateMode);
    };
    return Jn(a), V0(l), Se([
      () => e.options,
      () => e.data
    ], (d, f) => {
      let [m, g] = d, [v, p] = f;
      const _ = Pt(s.value);
      if (!_)
        return;
      let x = !1;
      if (m) {
        const S = ka(m), T = ka(v);
        S && S !== T && (lH(_, S), x = !0);
      }
      if (g) {
        const S = ka(g.labels), T = ka(p.labels), M = ka(g.datasets), E = ka(p.datasets);
        S !== T && (MS(_.config.data, S), x = !0), M && M !== E && (DS(_.config.data, M, e.datasetIdKey), x = !0);
      }
      x && Ct(() => {
        c(_);
      });
    }, {
      deep: !0
    }), () => br("canvas", {
      role: "img",
      ariaLabel: e.ariaLabel,
      ariaDescribedby: e.ariaDescribedby,
      ref: r
    }, [
      br("p", {}, [
        i.default ? i.default() : ""
      ])
    ]);
  }
});
function dH(e, t) {
  return pl.register(t), Je({
    props: AS,
    setup(n, i) {
      let { expose: r } = i;
      const s = Ie(null), a = (l) => {
        s.value = l == null ? void 0 : l.chart;
      };
      return r({
        chart: s
      }), () => br(cH, aH({
        ref: a
      }, {
        type: e,
        ...n
      }));
    }
  });
}
const fH = /* @__PURE__ */ dH("scatter", vc);
var VS = { exports: {} };
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(e) {
  (function(t, n, i, r) {
    var s = ["", "webkit", "Moz", "MS", "ms", "o"], a = n.createElement("div"), l = "function", c = Math.round, d = Math.abs, f = Date.now;
    function m(k, O, F) {
      return setTimeout(M(k, F), O);
    }
    function g(k, O, F) {
      return Array.isArray(k) ? (v(k, F[O], F), !0) : !1;
    }
    function v(k, O, F) {
      var j;
      if (k)
        if (k.forEach)
          k.forEach(O, F);
        else if (k.length !== r)
          for (j = 0; j < k.length; )
            O.call(F, k[j], j, k), j++;
        else
          for (j in k)
            k.hasOwnProperty(j) && O.call(F, k[j], j, k);
    }
    function p(k, O, F) {
      var j = "DEPRECATED METHOD: " + O + `
` + F + ` AT 
`;
      return function() {
        var ae = new Error("get-stack-trace"), xe = ae && ae.stack ? ae.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace", Ge = t.console && (t.console.warn || t.console.log);
        return Ge && Ge.call(t.console, j, xe), k.apply(this, arguments);
      };
    }
    var _;
    typeof Object.assign != "function" ? _ = function(O) {
      if (O === r || O === null)
        throw new TypeError("Cannot convert undefined or null to object");
      for (var F = Object(O), j = 1; j < arguments.length; j++) {
        var ae = arguments[j];
        if (ae !== r && ae !== null)
          for (var xe in ae)
            ae.hasOwnProperty(xe) && (F[xe] = ae[xe]);
      }
      return F;
    } : _ = Object.assign;
    var x = p(function(O, F, j) {
      for (var ae = Object.keys(F), xe = 0; xe < ae.length; )
        (!j || j && O[ae[xe]] === r) && (O[ae[xe]] = F[ae[xe]]), xe++;
      return O;
    }, "extend", "Use `assign`."), S = p(function(O, F) {
      return x(O, F, !0);
    }, "merge", "Use `assign`.");
    function T(k, O, F) {
      var j = O.prototype, ae;
      ae = k.prototype = Object.create(j), ae.constructor = k, ae._super = j, F && _(ae, F);
    }
    function M(k, O) {
      return function() {
        return k.apply(O, arguments);
      };
    }
    function E(k, O) {
      return typeof k == l ? k.apply(O && O[0] || r, O) : k;
    }
    function D(k, O) {
      return k === r ? O : k;
    }
    function R(k, O, F) {
      v(H(O), function(j) {
        k.addEventListener(j, F, !1);
      });
    }
    function $(k, O, F) {
      v(H(O), function(j) {
        k.removeEventListener(j, F, !1);
      });
    }
    function A(k, O) {
      for (; k; ) {
        if (k == O)
          return !0;
        k = k.parentNode;
      }
      return !1;
    }
    function V(k, O) {
      return k.indexOf(O) > -1;
    }
    function H(k) {
      return k.trim().split(/\s+/g);
    }
    function B(k, O, F) {
      if (k.indexOf && !F)
        return k.indexOf(O);
      for (var j = 0; j < k.length; ) {
        if (F && k[j][F] == O || !F && k[j] === O)
          return j;
        j++;
      }
      return -1;
    }
    function N(k) {
      return Array.prototype.slice.call(k, 0);
    }
    function q(k, O, F) {
      for (var j = [], ae = [], xe = 0; xe < k.length; ) {
        var Ge = k[xe][O];
        B(ae, Ge) < 0 && j.push(k[xe]), ae[xe] = Ge, xe++;
      }
      return j = j.sort(function(Gt, Qt) {
        return Gt[O] > Qt[O];
      }), j;
    }
    function X(k, O) {
      for (var F, j, ae = O[0].toUpperCase() + O.slice(1), xe = 0; xe < s.length; ) {
        if (F = s[xe], j = F ? F + ae : O, j in k)
          return j;
        xe++;
      }
      return r;
    }
    var se = 1;
    function de() {
      return se++;
    }
    function _e(k) {
      var O = k.ownerDocument || k;
      return O.defaultView || O.parentWindow || t;
    }
    var be = /mobile|tablet|ip(ad|hone|od)|android/i, oe = "ontouchstart" in t, J = X(t, "PointerEvent") !== r, G = oe && be.test(navigator.userAgent), ie = "touch", ge = "pen", he = "mouse", Oe = "kinect", Q = 25, me = 1, Ze = 2, We = 4, Ue = 8, Ot = 1, ft = 2, yn = 4, xt = 8, sn = 16, pn = ft | yn, an = xt | sn, eo = pn | an, Nl = ["x", "y"], Li = ["clientX", "clientY"];
    function Tt(k, O) {
      var F = this;
      this.manager = k, this.callback = O, this.element = k.element, this.target = k.options.inputTarget, this.domHandler = function(j) {
        E(k.options.enable, [k]) && F.handler(j);
      }, this.init();
    }
    Tt.prototype = {
      /**
       * should handle the inputEvent data and trigger the callback
       * @virtual
       */
      handler: function() {
      },
      /**
       * bind the events
       */
      init: function() {
        this.evEl && R(this.element, this.evEl, this.domHandler), this.evTarget && R(this.target, this.evTarget, this.domHandler), this.evWin && R(_e(this.element), this.evWin, this.domHandler);
      },
      /**
       * unbind the events
       */
      destroy: function() {
        this.evEl && $(this.element, this.evEl, this.domHandler), this.evTarget && $(this.target, this.evTarget, this.domHandler), this.evWin && $(_e(this.element), this.evWin, this.domHandler);
      }
    };
    function cs(k) {
      var O, F = k.options.inputClass;
      return F ? O = F : J ? O = lo : G ? O = Er : oe ? O = fo : O = Qs, new O(k, Ks);
    }
    function Ks(k, O, F) {
      var j = F.pointers.length, ae = F.changedPointers.length, xe = O & me && j - ae === 0, Ge = O & (We | Ue) && j - ae === 0;
      F.isFirst = !!xe, F.isFinal = !!Ge, xe && (k.session = {}), F.eventType = O, bd(k, F), k.emit("hammer.input", F), k.recognize(F), k.session.prevInput = F;
    }
    function bd(k, O) {
      var F = k.session, j = O.pointers, ae = j.length;
      F.firstInput || (F.firstInput = Pr(O)), ae > 1 && !F.firstMultiple ? F.firstMultiple = Pr(O) : ae === 1 && (F.firstMultiple = !1);
      var xe = F.firstInput, Ge = F.firstMultiple, zt = Ge ? Ge.center : xe.center, Gt = O.center = Qi(j);
      O.timeStamp = f(), O.deltaTime = O.timeStamp - xe.timeStamp, O.angle = fs(zt, Gt), O.distance = Or(zt, Gt), ds(F, O), O.offsetDirection = Js(O.deltaX, O.deltaY);
      var Qt = Xs(O.deltaTime, O.deltaX, O.deltaY);
      O.overallVelocityX = Qt.x, O.overallVelocityY = Qt.y, O.overallVelocity = d(Qt.x) > d(Qt.y) ? Qt.x : Qt.y, O.scale = Ge ? no(Ge.pointers, j) : 1, O.rotation = Ge ? to(Ge.pointers, j) : 0, O.maxPointers = F.prevInput ? O.pointers.length > F.prevInput.maxPointers ? O.pointers.length : F.prevInput.maxPointers : O.pointers.length, xd(F, O);
      var ni = k.element;
      A(O.srcEvent.target, ni) && (ni = O.srcEvent.target), O.target = ni;
    }
    function ds(k, O) {
      var F = O.center, j = k.offsetDelta || {}, ae = k.prevDelta || {}, xe = k.prevInput || {};
      (O.eventType === me || xe.eventType === We) && (ae = k.prevDelta = {
        x: xe.deltaX || 0,
        y: xe.deltaY || 0
      }, j = k.offsetDelta = {
        x: F.x,
        y: F.y
      }), O.deltaX = ae.x + (F.x - j.x), O.deltaY = ae.y + (F.y - j.y);
    }
    function xd(k, O) {
      var F = k.lastInterval || O, j = O.timeStamp - F.timeStamp, ae, xe, Ge, zt;
      if (O.eventType != Ue && (j > Q || F.velocity === r)) {
        var Gt = O.deltaX - F.deltaX, Qt = O.deltaY - F.deltaY, ni = Xs(j, Gt, Qt);
        xe = ni.x, Ge = ni.y, ae = d(ni.x) > d(ni.y) ? ni.x : ni.y, zt = Js(Gt, Qt), k.lastInterval = O;
      } else
        ae = F.velocity, xe = F.velocityX, Ge = F.velocityY, zt = F.direction;
      O.velocity = ae, O.velocityX = xe, O.velocityY = Ge, O.direction = zt;
    }
    function Pr(k) {
      for (var O = [], F = 0; F < k.pointers.length; )
        O[F] = {
          clientX: c(k.pointers[F].clientX),
          clientY: c(k.pointers[F].clientY)
        }, F++;
      return {
        timeStamp: f(),
        pointers: O,
        center: Qi(O),
        deltaX: k.deltaX,
        deltaY: k.deltaY
      };
    }
    function Qi(k) {
      var O = k.length;
      if (O === 1)
        return {
          x: c(k[0].clientX),
          y: c(k[0].clientY)
        };
      for (var F = 0, j = 0, ae = 0; ae < O; )
        F += k[ae].clientX, j += k[ae].clientY, ae++;
      return {
        x: c(F / O),
        y: c(j / O)
      };
    }
    function Xs(k, O, F) {
      return {
        x: O / k || 0,
        y: F / k || 0
      };
    }
    function Js(k, O) {
      return k === O ? Ot : d(k) >= d(O) ? k < 0 ? ft : yn : O < 0 ? xt : sn;
    }
    function Or(k, O, F) {
      F || (F = Nl);
      var j = O[F[0]] - k[F[0]], ae = O[F[1]] - k[F[1]];
      return Math.sqrt(j * j + ae * ae);
    }
    function fs(k, O, F) {
      F || (F = Nl);
      var j = O[F[0]] - k[F[0]], ae = O[F[1]] - k[F[1]];
      return Math.atan2(ae, j) * 180 / Math.PI;
    }
    function to(k, O) {
      return fs(O[1], O[0], Li) + fs(k[1], k[0], Li);
    }
    function no(k, O) {
      return Or(O[0], O[1], Li) / Or(k[0], k[1], Li);
    }
    var io = {
      mousedown: me,
      mousemove: Ze,
      mouseup: We
    }, ro = "mousedown", so = "mousemove mouseup";
    function Qs() {
      this.evEl = ro, this.evWin = so, this.pressed = !1, Tt.apply(this, arguments);
    }
    T(Qs, Tt, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(O) {
        var F = io[O.type];
        F & me && O.button === 0 && (this.pressed = !0), F & Ze && O.which !== 1 && (F = We), this.pressed && (F & We && (this.pressed = !1), this.callback(this.manager, F, {
          pointers: [O],
          changedPointers: [O],
          pointerType: he,
          srcEvent: O
        }));
      }
    });
    var _d = {
      pointerdown: me,
      pointermove: Ze,
      pointerup: We,
      pointercancel: Ue,
      pointerout: Ue
    }, wd = {
      2: ie,
      3: ge,
      4: he,
      5: Oe
      // see https://twitter.com/jacobrossi/status/480596438489890816
    }, ao = "pointerdown", oo = "pointermove pointerup pointercancel";
    t.MSPointerEvent && !t.PointerEvent && (ao = "MSPointerDown", oo = "MSPointerMove MSPointerUp MSPointerCancel");
    function lo() {
      this.evEl = ao, this.evWin = oo, Tt.apply(this, arguments), this.store = this.manager.session.pointerEvents = [];
    }
    T(lo, Tt, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(O) {
        var F = this.store, j = !1, ae = O.type.toLowerCase().replace("ms", ""), xe = _d[ae], Ge = wd[O.pointerType] || O.pointerType, zt = Ge == ie, Gt = B(F, O.pointerId, "pointerId");
        xe & me && (O.button === 0 || zt) ? Gt < 0 && (F.push(O), Gt = F.length - 1) : xe & (We | Ue) && (j = !0), !(Gt < 0) && (F[Gt] = O, this.callback(this.manager, xe, {
          pointers: F,
          changedPointers: [O],
          pointerType: Ge,
          srcEvent: O
        }), j && F.splice(Gt, 1));
      }
    });
    var Sd = {
      touchstart: me,
      touchmove: Ze,
      touchend: We,
      touchcancel: Ue
    }, kd = "touchstart", Cd = "touchstart touchmove touchend touchcancel";
    function uo() {
      this.evTarget = kd, this.evWin = Cd, this.started = !1, Tt.apply(this, arguments);
    }
    T(uo, Tt, {
      handler: function(O) {
        var F = Sd[O.type];
        if (F === me && (this.started = !0), !!this.started) {
          var j = Td.call(this, O, F);
          F & (We | Ue) && j[0].length - j[1].length === 0 && (this.started = !1), this.callback(this.manager, F, {
            pointers: j[0],
            changedPointers: j[1],
            pointerType: ie,
            srcEvent: O
          });
        }
      }
    });
    function Td(k, O) {
      var F = N(k.touches), j = N(k.changedTouches);
      return O & (We | Ue) && (F = q(F.concat(j), "identifier")), [F, j];
    }
    var Id = {
      touchstart: me,
      touchmove: Ze,
      touchend: We,
      touchcancel: Ue
    }, Pd = "touchstart touchmove touchend touchcancel";
    function Er() {
      this.evTarget = Pd, this.targetIds = {}, Tt.apply(this, arguments);
    }
    T(Er, Tt, {
      handler: function(O) {
        var F = Id[O.type], j = Od.call(this, O, F);
        j && this.callback(this.manager, F, {
          pointers: j[0],
          changedPointers: j[1],
          pointerType: ie,
          srcEvent: O
        });
      }
    });
    function Od(k, O) {
      var F = N(k.touches), j = this.targetIds;
      if (O & (me | Ze) && F.length === 1)
        return j[F[0].identifier] = !0, [F, F];
      var ae, xe, Ge = N(k.changedTouches), zt = [], Gt = this.target;
      if (xe = F.filter(function(Qt) {
        return A(Qt.target, Gt);
      }), O === me)
        for (ae = 0; ae < xe.length; )
          j[xe[ae].identifier] = !0, ae++;
      for (ae = 0; ae < Ge.length; )
        j[Ge[ae].identifier] && zt.push(Ge[ae]), O & (We | Ue) && delete j[Ge[ae].identifier], ae++;
      if (zt.length)
        return [
          // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
          q(xe.concat(zt), "identifier"),
          zt
        ];
    }
    var co = 2500, $l = 25;
    function fo() {
      Tt.apply(this, arguments);
      var k = M(this.handler, this);
      this.touch = new Er(this.manager, k), this.mouse = new Qs(this.manager, k), this.primaryTouch = null, this.lastTouches = [];
    }
    T(fo, Tt, {
      /**
       * handle mouse and touch events
       * @param {Hammer} manager
       * @param {String} inputEvent
       * @param {Object} inputData
       */
      handler: function(O, F, j) {
        var ae = j.pointerType == ie, xe = j.pointerType == he;
        if (!(xe && j.sourceCapabilities && j.sourceCapabilities.firesTouchEvents)) {
          if (ae)
            Ed.call(this, F, j);
          else if (xe && Ad.call(this, j))
            return;
          this.callback(O, F, j);
        }
      },
      /**
       * remove the event listeners
       */
      destroy: function() {
        this.touch.destroy(), this.mouse.destroy();
      }
    });
    function Ed(k, O) {
      k & me ? (this.primaryTouch = O.changedPointers[0].identifier, zl.call(this, O)) : k & (We | Ue) && zl.call(this, O);
    }
    function zl(k) {
      var O = k.changedPointers[0];
      if (O.identifier === this.primaryTouch) {
        var F = { x: O.clientX, y: O.clientY };
        this.lastTouches.push(F);
        var j = this.lastTouches, ae = function() {
          var xe = j.indexOf(F);
          xe > -1 && j.splice(xe, 1);
        };
        setTimeout(ae, co);
      }
    }
    function Ad(k) {
      for (var O = k.srcEvent.clientX, F = k.srcEvent.clientY, j = 0; j < this.lastTouches.length; j++) {
        var ae = this.lastTouches[j], xe = Math.abs(O - ae.x), Ge = Math.abs(F - ae.y);
        if (xe <= $l && Ge <= $l)
          return !0;
      }
      return !1;
    }
    var Hl = X(a.style, "touchAction"), Wl = Hl !== r, Ul = "compute", ho = "auto", mo = "manipulation", er = "none", hs = "pan-x", ms = "pan-y", ea = Md();
    function go(k, O) {
      this.manager = k, this.set(O);
    }
    go.prototype = {
      /**
       * set the touchAction value on the element or enable the polyfill
       * @param {String} value
       */
      set: function(k) {
        k == Ul && (k = this.compute()), Wl && this.manager.element.style && ea[k] && (this.manager.element.style[Hl] = k), this.actions = k.toLowerCase().trim();
      },
      /**
       * just re-set the touchAction value
       */
      update: function() {
        this.set(this.manager.options.touchAction);
      },
      /**
       * compute the value for the touchAction property based on the recognizer's settings
       * @returns {String} value
       */
      compute: function() {
        var k = [];
        return v(this.manager.recognizers, function(O) {
          E(O.options.enable, [O]) && (k = k.concat(O.getTouchAction()));
        }), ta(k.join(" "));
      },
      /**
       * this method is called on each input cycle and provides the preventing of the browser behavior
       * @param {Object} input
       */
      preventDefaults: function(k) {
        var O = k.srcEvent, F = k.offsetDirection;
        if (this.manager.session.prevented) {
          O.preventDefault();
          return;
        }
        var j = this.actions, ae = V(j, er) && !ea[er], xe = V(j, ms) && !ea[ms], Ge = V(j, hs) && !ea[hs];
        if (ae) {
          var zt = k.pointers.length === 1, Gt = k.distance < 2, Qt = k.deltaTime < 250;
          if (zt && Gt && Qt)
            return;
        }
        if (!(Ge && xe) && (ae || xe && F & pn || Ge && F & an))
          return this.preventSrc(O);
      },
      /**
       * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
       * @param {Object} srcEvent
       */
      preventSrc: function(k) {
        this.manager.session.prevented = !0, k.preventDefault();
      }
    };
    function ta(k) {
      if (V(k, er))
        return er;
      var O = V(k, hs), F = V(k, ms);
      return O && F ? er : O || F ? O ? hs : ms : V(k, mo) ? mo : ho;
    }
    function Md() {
      if (!Wl)
        return !1;
      var k = {}, O = t.CSS && t.CSS.supports;
      return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(F) {
        k[F] = O ? t.CSS.supports("touch-action", F) : !0;
      }), k;
    }
    var tr = 1, In = 2, Ar = 4, Fi = 8, ti = Fi, Mr = 16, Nn = 32;
    function bi(k) {
      this.options = _({}, this.defaults, k || {}), this.id = de(), this.manager = null, this.options.enable = D(this.options.enable, !0), this.state = tr, this.simultaneous = {}, this.requireFail = [];
    }
    bi.prototype = {
      /**
       * @virtual
       * @type {Object}
       */
      defaults: {},
      /**
       * set options
       * @param {Object} options
       * @return {Recognizer}
       */
      set: function(k) {
        return _(this.options, k), this.manager && this.manager.touchAction.update(), this;
      },
      /**
       * recognize simultaneous with an other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      recognizeWith: function(k) {
        if (g(k, "recognizeWith", this))
          return this;
        var O = this.simultaneous;
        return k = na(k, this), O[k.id] || (O[k.id] = k, k.recognizeWith(this)), this;
      },
      /**
       * drop the simultaneous link. it doesnt remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRecognizeWith: function(k) {
        return g(k, "dropRecognizeWith", this) ? this : (k = na(k, this), delete this.simultaneous[k.id], this);
      },
      /**
       * recognizer can only run when an other is failing
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      requireFailure: function(k) {
        if (g(k, "requireFailure", this))
          return this;
        var O = this.requireFail;
        return k = na(k, this), B(O, k) === -1 && (O.push(k), k.requireFailure(this)), this;
      },
      /**
       * drop the requireFailure link. it does not remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRequireFailure: function(k) {
        if (g(k, "dropRequireFailure", this))
          return this;
        k = na(k, this);
        var O = B(this.requireFail, k);
        return O > -1 && this.requireFail.splice(O, 1), this;
      },
      /**
       * has require failures boolean
       * @returns {boolean}
       */
      hasRequireFailures: function() {
        return this.requireFail.length > 0;
      },
      /**
       * if the recognizer can recognize simultaneous with an other recognizer
       * @param {Recognizer} otherRecognizer
       * @returns {Boolean}
       */
      canRecognizeWith: function(k) {
        return !!this.simultaneous[k.id];
      },
      /**
       * You should use `tryEmit` instead of `emit` directly to check
       * that all the needed recognizers has failed before emitting.
       * @param {Object} input
       */
      emit: function(k) {
        var O = this, F = this.state;
        function j(ae) {
          O.manager.emit(ae, k);
        }
        F < Fi && j(O.options.event + ql(F)), j(O.options.event), k.additionalEvent && j(k.additionalEvent), F >= Fi && j(O.options.event + ql(F));
      },
      /**
       * Check that all the require failure recognizers has failed,
       * if true, it emits a gesture event,
       * otherwise, setup the state to FAILED.
       * @param {Object} input
       */
      tryEmit: function(k) {
        if (this.canEmit())
          return this.emit(k);
        this.state = Nn;
      },
      /**
       * can we emit?
       * @returns {boolean}
       */
      canEmit: function() {
        for (var k = 0; k < this.requireFail.length; ) {
          if (!(this.requireFail[k].state & (Nn | tr)))
            return !1;
          k++;
        }
        return !0;
      },
      /**
       * update the recognizer
       * @param {Object} inputData
       */
      recognize: function(k) {
        var O = _({}, k);
        if (!E(this.options.enable, [this, O])) {
          this.reset(), this.state = Nn;
          return;
        }
        this.state & (ti | Mr | Nn) && (this.state = tr), this.state = this.process(O), this.state & (In | Ar | Fi | Mr) && this.tryEmit(O);
      },
      /**
       * return the state of the recognizer
       * the actual recognizing happens in this method
       * @virtual
       * @param {Object} inputData
       * @returns {Const} STATE
       */
      process: function(k) {
      },
      // jshint ignore:line
      /**
       * return the preferred touch-action
       * @virtual
       * @returns {Array}
       */
      getTouchAction: function() {
      },
      /**
       * called when the gesture isn't allowed to recognize
       * like when another is being recognized or it is disabled
       * @virtual
       */
      reset: function() {
      }
    };
    function ql(k) {
      return k & Mr ? "cancel" : k & Fi ? "end" : k & Ar ? "move" : k & In ? "start" : "";
    }
    function jl(k) {
      return k == sn ? "down" : k == xt ? "up" : k == ft ? "left" : k == yn ? "right" : "";
    }
    function na(k, O) {
      var F = O.manager;
      return F ? F.get(k) : k;
    }
    function Pn() {
      bi.apply(this, arguments);
    }
    T(Pn, bi, {
      /**
       * @namespace
       * @memberof AttrRecognizer
       */
      defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
      },
      /**
       * Used to check if it the recognizer receives valid input, like input.distance > 10.
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {Boolean} recognized
       */
      attrTest: function(k) {
        var O = this.options.pointers;
        return O === 0 || k.pointers.length === O;
      },
      /**
       * Process the input and return the state for the recognizer
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {*} State
       */
      process: function(k) {
        var O = this.state, F = k.eventType, j = O & (In | Ar), ae = this.attrTest(k);
        return j && (F & Ue || !ae) ? O | Mr : j || ae ? F & We ? O | Fi : O & In ? O | Ar : In : Nn;
      }
    });
    function gs() {
      Pn.apply(this, arguments), this.pX = null, this.pY = null;
    }
    T(gs, Pn, {
      /**
       * @namespace
       * @memberof PanRecognizer
       */
      defaults: {
        event: "pan",
        threshold: 10,
        pointers: 1,
        direction: eo
      },
      getTouchAction: function() {
        var k = this.options.direction, O = [];
        return k & pn && O.push(ms), k & an && O.push(hs), O;
      },
      directionTest: function(k) {
        var O = this.options, F = !0, j = k.distance, ae = k.direction, xe = k.deltaX, Ge = k.deltaY;
        return ae & O.direction || (O.direction & pn ? (ae = xe === 0 ? Ot : xe < 0 ? ft : yn, F = xe != this.pX, j = Math.abs(k.deltaX)) : (ae = Ge === 0 ? Ot : Ge < 0 ? xt : sn, F = Ge != this.pY, j = Math.abs(k.deltaY))), k.direction = ae, F && j > O.threshold && ae & O.direction;
      },
      attrTest: function(k) {
        return Pn.prototype.attrTest.call(this, k) && (this.state & In || !(this.state & In) && this.directionTest(k));
      },
      emit: function(k) {
        this.pX = k.deltaX, this.pY = k.deltaY;
        var O = jl(k.direction);
        O && (k.additionalEvent = this.options.event + O), this._super.emit.call(this, k);
      }
    });
    function ia() {
      Pn.apply(this, arguments);
    }
    T(ia, Pn, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "pinch",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [er];
      },
      attrTest: function(k) {
        return this._super.attrTest.call(this, k) && (Math.abs(k.scale - 1) > this.options.threshold || this.state & In);
      },
      emit: function(k) {
        if (k.scale !== 1) {
          var O = k.scale < 1 ? "in" : "out";
          k.additionalEvent = this.options.event + O;
        }
        this._super.emit.call(this, k);
      }
    });
    function vs() {
      bi.apply(this, arguments), this._timer = null, this._input = null;
    }
    T(vs, bi, {
      /**
       * @namespace
       * @memberof PressRecognizer
       */
      defaults: {
        event: "press",
        pointers: 1,
        time: 251,
        // minimal time of the pointer to be pressed
        threshold: 9
        // a minimal movement is ok, but keep it low
      },
      getTouchAction: function() {
        return [ho];
      },
      process: function(k) {
        var O = this.options, F = k.pointers.length === O.pointers, j = k.distance < O.threshold, ae = k.deltaTime > O.time;
        if (this._input = k, !j || !F || k.eventType & (We | Ue) && !ae)
          this.reset();
        else if (k.eventType & me)
          this.reset(), this._timer = m(function() {
            this.state = ti, this.tryEmit();
          }, O.time, this);
        else if (k.eventType & We)
          return ti;
        return Nn;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function(k) {
        this.state === ti && (k && k.eventType & We ? this.manager.emit(this.options.event + "up", k) : (this._input.timeStamp = f(), this.manager.emit(this.options.event, this._input)));
      }
    });
    function vo() {
      Pn.apply(this, arguments);
    }
    T(vo, Pn, {
      /**
       * @namespace
       * @memberof RotateRecognizer
       */
      defaults: {
        event: "rotate",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [er];
      },
      attrTest: function(k) {
        return this._super.attrTest.call(this, k) && (Math.abs(k.rotation) > this.options.threshold || this.state & In);
      }
    });
    function ra() {
      Pn.apply(this, arguments);
    }
    T(ra, Pn, {
      /**
       * @namespace
       * @memberof SwipeRecognizer
       */
      defaults: {
        event: "swipe",
        threshold: 10,
        velocity: 0.3,
        direction: pn | an,
        pointers: 1
      },
      getTouchAction: function() {
        return gs.prototype.getTouchAction.call(this);
      },
      attrTest: function(k) {
        var O = this.options.direction, F;
        return O & (pn | an) ? F = k.overallVelocity : O & pn ? F = k.overallVelocityX : O & an && (F = k.overallVelocityY), this._super.attrTest.call(this, k) && O & k.offsetDirection && k.distance > this.options.threshold && k.maxPointers == this.options.pointers && d(F) > this.options.velocity && k.eventType & We;
      },
      emit: function(k) {
        var O = jl(k.offsetDirection);
        O && this.manager.emit(this.options.event + O, k), this.manager.emit(this.options.event, k);
      }
    });
    function nr() {
      bi.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0;
    }
    T(nr, bi, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "tap",
        pointers: 1,
        taps: 1,
        interval: 300,
        // max time between the multi-tap taps
        time: 250,
        // max time of the pointer to be down (like finger on the screen)
        threshold: 9,
        // a minimal movement is ok, but keep it low
        posThreshold: 10
        // a multi-tap can be a bit off the initial position
      },
      getTouchAction: function() {
        return [mo];
      },
      process: function(k) {
        var O = this.options, F = k.pointers.length === O.pointers, j = k.distance < O.threshold, ae = k.deltaTime < O.time;
        if (this.reset(), k.eventType & me && this.count === 0)
          return this.failTimeout();
        if (j && ae && F) {
          if (k.eventType != We)
            return this.failTimeout();
          var xe = this.pTime ? k.timeStamp - this.pTime < O.interval : !0, Ge = !this.pCenter || Or(this.pCenter, k.center) < O.posThreshold;
          this.pTime = k.timeStamp, this.pCenter = k.center, !Ge || !xe ? this.count = 1 : this.count += 1, this._input = k;
          var zt = this.count % O.taps;
          if (zt === 0)
            return this.hasRequireFailures() ? (this._timer = m(function() {
              this.state = ti, this.tryEmit();
            }, O.interval, this), In) : ti;
        }
        return Nn;
      },
      failTimeout: function() {
        return this._timer = m(function() {
          this.state = Nn;
        }, this.options.interval, this), Nn;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function() {
        this.state == ti && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
      }
    });
    function xi(k, O) {
      return O = O || {}, O.recognizers = D(O.recognizers, xi.defaults.preset), new sa(k, O);
    }
    xi.VERSION = "2.0.7", xi.defaults = {
      /**
       * set if DOM events are being triggered.
       * But this is slower and unused by simple implementations, so disabled by default.
       * @type {Boolean}
       * @default false
       */
      domEvents: !1,
      /**
       * The value for the touchAction property/fallback.
       * When set to `compute` it will magically set the correct value based on the added recognizers.
       * @type {String}
       * @default compute
       */
      touchAction: Ul,
      /**
       * @type {Boolean}
       * @default true
       */
      enable: !0,
      /**
       * EXPERIMENTAL FEATURE -- can be removed/changed
       * Change the parent input target element.
       * If Null, then it is being set the to main element.
       * @type {Null|EventTarget}
       * @default null
       */
      inputTarget: null,
      /**
       * force an input class
       * @type {Null|Function}
       * @default null
       */
      inputClass: null,
      /**
       * Default recognizer setup when calling `Hammer()`
       * When creating a new Manager these will be skipped.
       * @type {Array}
       */
      preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [vo, { enable: !1 }],
        [ia, { enable: !1 }, ["rotate"]],
        [ra, { direction: pn }],
        [gs, { direction: pn }, ["swipe"]],
        [nr],
        [nr, { event: "doubletap", taps: 2 }, ["tap"]],
        [vs]
      ],
      /**
       * Some CSS properties can be used to improve the working of Hammer.
       * Add them to this method and they will be set when creating a new Manager.
       * @namespace
       */
      cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: "none",
        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: "none",
        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: "none",
        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: "none",
        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: "none",
        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: "rgba(0,0,0,0)"
      }
    };
    var Dd = 1, yo = 2;
    function sa(k, O) {
      this.options = _({}, xi.defaults, O || {}), this.options.inputTarget = this.options.inputTarget || k, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = k, this.input = cs(this), this.touchAction = new go(this, this.options.touchAction), aa(this, !0), v(this.options.recognizers, function(F) {
        var j = this.add(new F[0](F[1]));
        F[2] && j.recognizeWith(F[2]), F[3] && j.requireFailure(F[3]);
      }, this);
    }
    sa.prototype = {
      /**
       * set options
       * @param {Object} options
       * @returns {Manager}
       */
      set: function(k) {
        return _(this.options, k), k.touchAction && this.touchAction.update(), k.inputTarget && (this.input.destroy(), this.input.target = k.inputTarget, this.input.init()), this;
      },
      /**
       * stop recognizing for this session.
       * This session will be discarded, when a new [input]start event is fired.
       * When forced, the recognizer cycle is stopped immediately.
       * @param {Boolean} [force]
       */
      stop: function(k) {
        this.session.stopped = k ? yo : Dd;
      },
      /**
       * run the recognizers!
       * called by the inputHandler function on every movement of the pointers (touches)
       * it walks through all the recognizers and tries to detect the gesture that is being made
       * @param {Object} inputData
       */
      recognize: function(k) {
        var O = this.session;
        if (!O.stopped) {
          this.touchAction.preventDefaults(k);
          var F, j = this.recognizers, ae = O.curRecognizer;
          (!ae || ae && ae.state & ti) && (ae = O.curRecognizer = null);
          for (var xe = 0; xe < j.length; )
            F = j[xe], O.stopped !== yo && // 1
            (!ae || F == ae || // 2
            F.canRecognizeWith(ae)) ? F.recognize(k) : F.reset(), !ae && F.state & (In | Ar | Fi) && (ae = O.curRecognizer = F), xe++;
        }
      },
      /**
       * get a recognizer by its event name.
       * @param {Recognizer|String} recognizer
       * @returns {Recognizer|Null}
       */
      get: function(k) {
        if (k instanceof bi)
          return k;
        for (var O = this.recognizers, F = 0; F < O.length; F++)
          if (O[F].options.event == k)
            return O[F];
        return null;
      },
      /**
       * add a recognizer to the manager
       * existing recognizers with the same event name will be removed
       * @param {Recognizer} recognizer
       * @returns {Recognizer|Manager}
       */
      add: function(k) {
        if (g(k, "add", this))
          return this;
        var O = this.get(k.options.event);
        return O && this.remove(O), this.recognizers.push(k), k.manager = this, this.touchAction.update(), k;
      },
      /**
       * remove a recognizer by name or instance
       * @param {Recognizer|String} recognizer
       * @returns {Manager}
       */
      remove: function(k) {
        if (g(k, "remove", this))
          return this;
        if (k = this.get(k), k) {
          var O = this.recognizers, F = B(O, k);
          F !== -1 && (O.splice(F, 1), this.touchAction.update());
        }
        return this;
      },
      /**
       * bind event
       * @param {String} events
       * @param {Function} handler
       * @returns {EventEmitter} this
       */
      on: function(k, O) {
        if (k !== r && O !== r) {
          var F = this.handlers;
          return v(H(k), function(j) {
            F[j] = F[j] || [], F[j].push(O);
          }), this;
        }
      },
      /**
       * unbind event, leave emit blank to remove all handlers
       * @param {String} events
       * @param {Function} [handler]
       * @returns {EventEmitter} this
       */
      off: function(k, O) {
        if (k !== r) {
          var F = this.handlers;
          return v(H(k), function(j) {
            O ? F[j] && F[j].splice(B(F[j], O), 1) : delete F[j];
          }), this;
        }
      },
      /**
       * emit event to the listeners
       * @param {String} event
       * @param {Object} data
       */
      emit: function(k, O) {
        this.options.domEvents && Vd(k, O);
        var F = this.handlers[k] && this.handlers[k].slice();
        if (!(!F || !F.length)) {
          O.type = k, O.preventDefault = function() {
            O.srcEvent.preventDefault();
          };
          for (var j = 0; j < F.length; )
            F[j](O), j++;
        }
      },
      /**
       * destroy the manager and unbinds all events
       * it doesn't unbind dom events, that is the user own responsibility
       */
      destroy: function() {
        this.element && aa(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
      }
    };
    function aa(k, O) {
      var F = k.element;
      if (F.style) {
        var j;
        v(k.options.cssProps, function(ae, xe) {
          j = X(F.style, xe), O ? (k.oldCssProps[j] = F.style[j], F.style[j] = ae) : F.style[j] = k.oldCssProps[j] || "";
        }), O || (k.oldCssProps = {});
      }
    }
    function Vd(k, O) {
      var F = n.createEvent("Event");
      F.initEvent(k, !0, !0), F.gesture = O, O.target.dispatchEvent(F);
    }
    _(xi, {
      INPUT_START: me,
      INPUT_MOVE: Ze,
      INPUT_END: We,
      INPUT_CANCEL: Ue,
      STATE_POSSIBLE: tr,
      STATE_BEGAN: In,
      STATE_CHANGED: Ar,
      STATE_ENDED: Fi,
      STATE_RECOGNIZED: ti,
      STATE_CANCELLED: Mr,
      STATE_FAILED: Nn,
      DIRECTION_NONE: Ot,
      DIRECTION_LEFT: ft,
      DIRECTION_RIGHT: yn,
      DIRECTION_UP: xt,
      DIRECTION_DOWN: sn,
      DIRECTION_HORIZONTAL: pn,
      DIRECTION_VERTICAL: an,
      DIRECTION_ALL: eo,
      Manager: sa,
      Input: Tt,
      TouchAction: go,
      TouchInput: Er,
      MouseInput: Qs,
      PointerEventInput: lo,
      TouchMouseInput: fo,
      SingleTouchInput: uo,
      Recognizer: bi,
      AttrRecognizer: Pn,
      Tap: nr,
      Pan: gs,
      Swipe: ra,
      Pinch: ia,
      Rotate: vo,
      Press: vs,
      on: R,
      off: $,
      each: v,
      merge: S,
      extend: x,
      assign: _,
      inherit: T,
      bindFn: M,
      prefixed: X
    });
    var Gl = typeof t < "u" ? t : typeof self < "u" ? self : {};
    Gl.Hammer = xi, e.exports ? e.exports = xi : t[i] = xi;
  })(window, document, "Hammer");
})(VS);
var hH = VS.exports;
const nl = /* @__PURE__ */ OF(hH);
/*!
* chartjs-plugin-zoom v2.2.0
* https://www.chartjs.org/chartjs-plugin-zoom/2.2.0/
 * (c) 2016-2024 chartjs-plugin-zoom Contributors
 * Released under the MIT License
 */
const xl = (e) => e && e.enabled && e.modifierKey, LS = (e, t) => e && t[e + "Key"], vg = (e, t) => e && !t[e + "Key"];
function as(e, t, n) {
  return e === void 0 ? !0 : typeof e == "string" ? e.indexOf(t) !== -1 : typeof e == "function" ? e({ chart: n }).indexOf(t) !== -1 : !1;
}
function mh(e, t) {
  return typeof e == "function" && (e = e({ chart: t })), typeof e == "string" ? { x: e.indexOf("x") !== -1, y: e.indexOf("y") !== -1 } : { x: !1, y: !1 };
}
function mH(e, t) {
  let n;
  return function() {
    return clearTimeout(n), n = setTimeout(e, t), t;
  };
}
function gH({ x: e, y: t }, n) {
  const i = n.scales, r = Object.keys(i);
  for (let s = 0; s < r.length; s++) {
    const a = i[r[s]];
    if (t >= a.top && t <= a.bottom && e >= a.left && e <= a.right)
      return a;
  }
  return null;
}
function FS(e, t, n) {
  const { mode: i = "xy", scaleMode: r, overScaleMode: s } = e || {}, a = gH(t, n), l = mh(i, n), c = mh(r, n);
  if (s) {
    const f = mh(s, n);
    for (const m of ["x", "y"])
      f[m] && (c[m] = l[m], l[m] = !1);
  }
  if (a && c[a.axis])
    return [a];
  const d = [];
  return et(n.scales, function(f) {
    l[f.axis] && d.push(f);
  }), d;
}
const em = /* @__PURE__ */ new WeakMap();
function Vt(e) {
  let t = em.get(e);
  return t || (t = {
    originalScaleLimits: {},
    updatedScaleLimits: {},
    handlers: {},
    panDelta: {},
    dragging: !1,
    panning: !1
  }, em.set(e, t)), t;
}
function vH(e) {
  em.delete(e);
}
function RS(e, t, n, i) {
  const r = Math.max(0, Math.min(1, (e - t) / n || 0)), s = 1 - r;
  return {
    min: i * r,
    max: i * s
  };
}
function BS(e, t) {
  const n = e.isHorizontal() ? t.x : t.y;
  return e.getValueForPixel(n);
}
function NS(e, t, n) {
  const i = e.max - e.min, r = i * (t - 1), s = BS(e, n);
  return RS(s, e.min, i, r);
}
function yH(e, t, n) {
  const i = BS(e, n);
  if (i === void 0)
    return { min: e.min, max: e.max };
  const r = Math.log10(e.min), s = Math.log10(e.max), a = Math.log10(i), l = s - r, c = l * (t - 1), d = RS(a, r, l, c);
  return {
    min: Math.pow(10, r + d.min),
    max: Math.pow(10, s - d.max)
  };
}
function pH(e, t) {
  return t && (t[e.id] || t[e.axis]) || {};
}
function g0(e, t, n, i, r) {
  let s = n[i];
  if (s === "original") {
    const a = e.originalScaleLimits[t.id][i];
    s = Xe(a.options, a.scale);
  }
  return Xe(s, r);
}
function bH(e, t, n) {
  const i = e.getValueForPixel(t), r = e.getValueForPixel(n);
  return {
    min: Math.min(i, r),
    max: Math.max(i, r)
  };
}
function xH(e, { min: t, max: n, minLimit: i, maxLimit: r }, s) {
  const a = (e - n + t) / 2;
  t -= a, n += a;
  const l = s.min.options ?? s.min.scale, c = s.max.options ?? s.max.scale, d = e / 1e6;
  return $s(t, l, d) && (t = l), $s(n, c, d) && (n = c), t < i ? (t = i, n = Math.min(i + e, r)) : n > r && (n = r, t = Math.max(r - e, i)), { min: t, max: n };
}
function Zs(e, { min: t, max: n }, i, r = !1) {
  const s = Vt(e.chart), { options: a } = e, l = pH(e, i), { minRange: c = 0 } = l, d = g0(s, e, l, "min", -1 / 0), f = g0(s, e, l, "max", 1 / 0);
  if (r === "pan" && (t < d || n > f))
    return !0;
  const m = e.max - e.min, g = r ? Math.max(n - t, c) : m;
  if (r && g === c && m <= c)
    return !0;
  const v = xH(g, { min: t, max: n, minLimit: d, maxLimit: f }, s.originalScaleLimits[e.id]);
  return a.min = v.min, a.max = v.max, s.updatedScaleLimits[e.id] = v, e.parse(v.min) !== e.min || e.parse(v.max) !== e.max;
}
function _H(e, t, n, i) {
  const r = NS(e, t, n), s = { min: e.min + r.min, max: e.max - r.max };
  return Zs(e, s, i, !0);
}
function wH(e, t, n, i) {
  const r = yH(e, t, n);
  return Zs(e, r, i, !0);
}
function SH(e, t, n, i) {
  Zs(e, bH(e, t, n), i, !0);
}
const v0 = (e) => e === 0 || isNaN(e) ? 0 : e < 0 ? Math.min(Math.round(e), -1) : Math.max(Math.round(e), 1);
function kH(e) {
  const n = e.getLabels().length - 1;
  e.min > 0 && (e.min -= 1), e.max < n && (e.max += 1);
}
function CH(e, t, n, i) {
  const r = NS(e, t, n);
  e.min === e.max && t < 1 && kH(e);
  const s = { min: e.min + v0(r.min), max: e.max - v0(r.max) };
  return Zs(e, s, i, !0);
}
function TH(e) {
  return e.isHorizontal() ? e.width : e.height;
}
function IH(e, t, n) {
  const r = e.getLabels().length - 1;
  let { min: s, max: a } = e;
  const l = Math.max(a - s, 1), c = Math.round(TH(e) / Math.max(l, 10)), d = Math.round(Math.abs(t / c));
  let f;
  return t < -c ? (a = Math.min(a + d, r), s = l === 1 ? a : a - l, f = a === r) : t > c && (s = Math.max(0, s - d), a = l === 1 ? s : s + l, f = s === 0), Zs(e, { min: s, max: a }, n) || f;
}
const PH = {
  second: 500,
  minute: 30 * 1e3,
  hour: 30 * 60 * 1e3,
  day: 12 * 60 * 60 * 1e3,
  week: 3.5 * 24 * 60 * 60 * 1e3,
  month: 15 * 24 * 60 * 60 * 1e3,
  quarter: 60 * 24 * 60 * 60 * 1e3,
  year: 182 * 24 * 60 * 60 * 1e3
};
function $S(e, t, n, i = !1) {
  const { min: r, max: s, options: a } = e, l = a.time && a.time.round, c = PH[l] || 0, d = e.getValueForPixel(e.getPixelForValue(r + c) - t), f = e.getValueForPixel(e.getPixelForValue(s + c) - t);
  return isNaN(d) || isNaN(f) ? !0 : Zs(e, { min: d, max: f }, n, i ? "pan" : !1);
}
function y0(e, t, n) {
  return $S(e, t, n, !0);
}
const tm = {
  category: CH,
  default: _H,
  logarithmic: wH
}, nm = {
  default: SH
}, im = {
  category: IH,
  default: $S,
  logarithmic: y0,
  timeseries: y0
};
function OH(e, t, n) {
  const { id: i, options: { min: r, max: s } } = e;
  if (!t[i] || !n[i])
    return !0;
  const a = n[i];
  return a.min !== r || a.max !== s;
}
function p0(e, t) {
  et(e, (n, i) => {
    t[i] || delete e[i];
  });
}
function Qa(e, t) {
  const { scales: n } = e, { originalScaleLimits: i, updatedScaleLimits: r } = t;
  return et(n, function(s) {
    OH(s, i, r) && (i[s.id] = {
      min: { scale: s.min, options: s.options.min },
      max: { scale: s.max, options: s.options.max }
    });
  }), p0(i, n), p0(r, n), i;
}
function b0(e, t, n, i) {
  const r = tm[e.type] || tm.default;
  Fe(r, [e, t, n, i]);
}
function x0(e, t, n, i) {
  const r = nm[e.type] || nm.default;
  Fe(r, [e, t, n, i]);
}
function EH(e) {
  const t = e.chartArea;
  return {
    x: (t.left + t.right) / 2,
    y: (t.top + t.bottom) / 2
  };
}
function yg(e, t, n = "none", i = "api") {
  const { x: r = 1, y: s = 1, focalPoint: a = EH(e) } = typeof t == "number" ? { x: t, y: t } : t, l = Vt(e), { options: { limits: c, zoom: d } } = l;
  Qa(e, l);
  const f = r !== 1, m = s !== 1, g = FS(d, a, e);
  et(g || e.scales, function(v) {
    v.isHorizontal() && f ? b0(v, r, a, c) : !v.isHorizontal() && m && b0(v, s, a, c);
  }), e.update(n), Fe(d.onZoom, [{ chart: e, trigger: i }]);
}
function zS(e, t, n, i = "none", r = "api") {
  const s = Vt(e), { options: { limits: a, zoom: l } } = s, { mode: c = "xy" } = l;
  Qa(e, s);
  const d = as(c, "x", e), f = as(c, "y", e);
  et(e.scales, function(m) {
    m.isHorizontal() && d ? x0(m, t.x, n.x, a) : !m.isHorizontal() && f && x0(m, t.y, n.y, a);
  }), e.update(i), Fe(l.onZoom, [{ chart: e, trigger: r }]);
}
function AH(e, t, n, i = "none", r = "api") {
  var l;
  const s = Vt(e);
  Qa(e, s);
  const a = e.scales[t];
  Zs(a, n, void 0, !0), e.update(i), Fe((l = s.options.zoom) == null ? void 0 : l.onZoom, [{ chart: e, trigger: r }]);
}
function MH(e, t = "default") {
  const n = Vt(e), i = Qa(e, n);
  et(e.scales, function(r) {
    const s = r.options;
    i[r.id] ? (s.min = i[r.id].min.options, s.max = i[r.id].max.options) : (delete s.min, delete s.max), delete n.updatedScaleLimits[r.id];
  }), e.update(t), Fe(n.options.zoom.onZoomComplete, [{ chart: e }]);
}
function DH(e, t) {
  const n = e.originalScaleLimits[t];
  if (!n)
    return;
  const { min: i, max: r } = n;
  return Xe(r.options, r.scale) - Xe(i.options, i.scale);
}
function VH(e) {
  const t = Vt(e);
  let n = 1, i = 1;
  return et(e.scales, function(r) {
    const s = DH(t, r.id);
    if (s) {
      const a = Math.round(s / (r.max - r.min) * 100) / 100;
      n = Math.min(n, a), i = Math.max(i, a);
    }
  }), n < 1 ? n : i;
}
function _0(e, t, n, i) {
  const { panDelta: r } = i, s = r[e.id] || 0;
  ss(s) === ss(t) && (t += s);
  const a = im[e.type] || im.default;
  Fe(a, [e, t, n]) ? r[e.id] = 0 : r[e.id] = t;
}
function HS(e, t, n, i = "none") {
  const { x: r = 0, y: s = 0 } = typeof t == "number" ? { x: t, y: t } : t, a = Vt(e), { options: { pan: l, limits: c } } = a, { onPan: d } = l || {};
  Qa(e, a);
  const f = r !== 0, m = s !== 0;
  et(n || e.scales, function(g) {
    g.isHorizontal() && f ? _0(g, r, c, a) : !g.isHorizontal() && m && _0(g, s, c, a);
  }), e.update(i), Fe(d, [{ chart: e }]);
}
function WS(e) {
  const t = Vt(e);
  Qa(e, t);
  const n = {};
  for (const i of Object.keys(e.scales)) {
    const { min: r, max: s } = t.originalScaleLimits[i] || { min: {}, max: {} };
    n[i] = { min: r.scale, max: s.scale };
  }
  return n;
}
function LH(e) {
  const t = Vt(e), n = {};
  for (const i of Object.keys(e.scales))
    n[i] = t.updatedScaleLimits[i];
  return n;
}
function FH(e) {
  const t = WS(e);
  for (const n of Object.keys(e.scales)) {
    const { min: i, max: r } = t[n];
    if (i !== void 0 && e.scales[n].min !== i || r !== void 0 && e.scales[n].max !== r)
      return !0;
  }
  return !1;
}
function w0(e) {
  const t = Vt(e);
  return t.panning || t.dragging;
}
const S0 = (e, t, n) => Math.min(n, Math.max(t, e));
function Ln(e, t) {
  const { handlers: n } = Vt(e), i = n[t];
  i && i.target && (i.target.removeEventListener(t, i), delete n[t]);
}
function il(e, t, n, i) {
  const { handlers: r, options: s } = Vt(e), a = r[n];
  if (a && a.target === t)
    return;
  Ln(e, n), r[n] = (c) => i(e, c, s), r[n].target = t;
  const l = n === "wheel" ? !1 : void 0;
  t.addEventListener(n, r[n], { passive: l });
}
function RH(e, t) {
  const n = Vt(e);
  n.dragStart && (n.dragging = !0, n.dragEnd = t, e.update("none"));
}
function BH(e, t) {
  const n = Vt(e);
  !n.dragStart || t.key !== "Escape" || (Ln(e, "keydown"), n.dragging = !1, n.dragStart = n.dragEnd = null, e.update("none"));
}
function rm(e, t) {
  if (e.target !== t.canvas) {
    const n = t.canvas.getBoundingClientRect();
    return {
      x: e.clientX - n.left,
      y: e.clientY - n.top
    };
  }
  return Hi(e, t);
}
function US(e, t, n) {
  const { onZoomStart: i, onZoomRejected: r } = n;
  if (i) {
    const s = rm(t, e);
    if (Fe(i, [{ chart: e, event: t, point: s }]) === !1)
      return Fe(r, [{ chart: e, event: t }]), !1;
  }
}
function NH(e, t) {
  if (e.legend) {
    const s = Hi(t, e);
    if (Wi(s, e.legend))
      return;
  }
  const n = Vt(e), { pan: i, zoom: r = {} } = n.options;
  if (t.button !== 0 || LS(xl(i), t) || vg(xl(r.drag), t))
    return Fe(r.onZoomRejected, [{ chart: e, event: t }]);
  US(e, t, r) !== !1 && (n.dragStart = t, il(e, e.canvas.ownerDocument, "mousemove", RH), il(e, window.document, "keydown", BH));
}
function $H({ begin: e, end: t }, n) {
  let i = t.x - e.x, r = t.y - e.y;
  const s = Math.abs(i / r);
  s > n ? i = Math.sign(i) * Math.abs(r * n) : s < n && (r = Math.sign(r) * Math.abs(i / n)), t.x = e.x + i, t.y = e.y + r;
}
function k0(e, t, n, { min: i, max: r, prop: s }) {
  e[i] = S0(Math.min(n.begin[s], n.end[s]), t[i], t[r]), e[r] = S0(Math.max(n.begin[s], n.end[s]), t[i], t[r]);
}
function zH(e, t, n) {
  const i = {
    begin: rm(t.dragStart, e),
    end: rm(t.dragEnd, e)
  };
  if (n) {
    const r = e.chartArea.width / e.chartArea.height;
    $H(i, r);
  }
  return i;
}
function qS(e, t, n, i) {
  const r = as(t, "x", e), s = as(t, "y", e), { top: a, left: l, right: c, bottom: d, width: f, height: m } = e.chartArea, g = { top: a, left: l, right: c, bottom: d }, v = zH(e, n, i && r && s);
  r && k0(g, e.chartArea, v, { min: "left", max: "right", prop: "x" }), s && k0(g, e.chartArea, v, { min: "top", max: "bottom", prop: "y" });
  const p = g.right - g.left, _ = g.bottom - g.top;
  return {
    ...g,
    width: p,
    height: _,
    zoomX: r && p ? 1 + (f - p) / f : 1,
    zoomY: s && _ ? 1 + (m - _) / m : 1
  };
}
function HH(e, t) {
  const n = Vt(e);
  if (!n.dragStart)
    return;
  Ln(e, "mousemove");
  const { mode: i, onZoomComplete: r, drag: { threshold: s = 0, maintainAspectRatio: a } } = n.options.zoom, l = qS(e, i, { dragStart: n.dragStart, dragEnd: t }, a), c = as(i, "x", e) ? l.width : 0, d = as(i, "y", e) ? l.height : 0, f = Math.sqrt(c * c + d * d);
  if (n.dragStart = n.dragEnd = null, f <= s) {
    n.dragging = !1, e.update("none");
    return;
  }
  zS(e, { x: l.left, y: l.top }, { x: l.right, y: l.bottom }, "zoom", "drag"), n.dragging = !1, n.filterNextClick = !0, Fe(r, [{ chart: e }]);
}
function WH(e, t, n) {
  if (vg(xl(n.wheel), t)) {
    Fe(n.onZoomRejected, [{ chart: e, event: t }]);
    return;
  }
  if (US(e, t, n) !== !1 && (t.cancelable && t.preventDefault(), t.deltaY !== void 0))
    return !0;
}
function UH(e, t) {
  const { handlers: { onZoomComplete: n }, options: { zoom: i } } = Vt(e);
  if (!WH(e, t, i))
    return;
  const r = t.target.getBoundingClientRect(), s = i.wheel.speed, a = t.deltaY >= 0 ? 2 - 1 / (1 - s) : 1 + s, l = {
    x: a,
    y: a,
    focalPoint: {
      x: t.clientX - r.left,
      y: t.clientY - r.top
    }
  };
  yg(e, l, "zoom", "wheel"), Fe(n, [{ chart: e }]);
}
function qH(e, t, n, i) {
  n && (Vt(e).handlers[t] = mH(() => Fe(n, [{ chart: e }]), i));
}
function jH(e, t) {
  const n = e.canvas, { wheel: i, drag: r, onZoomComplete: s } = t.zoom;
  i.enabled ? (il(e, n, "wheel", UH), qH(e, "onZoomComplete", s, 250)) : Ln(e, "wheel"), r.enabled ? (il(e, n, "mousedown", NH), il(e, n.ownerDocument, "mouseup", HH)) : (Ln(e, "mousedown"), Ln(e, "mousemove"), Ln(e, "mouseup"), Ln(e, "keydown"));
}
function GH(e) {
  Ln(e, "mousedown"), Ln(e, "mousemove"), Ln(e, "mouseup"), Ln(e, "wheel"), Ln(e, "click"), Ln(e, "keydown");
}
function YH(e, t) {
  return function(n, i) {
    const { pan: r, zoom: s = {} } = t.options;
    if (!r || !r.enabled)
      return !1;
    const a = i && i.srcEvent;
    return a && !t.panning && i.pointerType === "mouse" && (vg(xl(r), a) || LS(xl(s.drag), a)) ? (Fe(r.onPanRejected, [{ chart: e, event: i }]), !1) : !0;
  };
}
function ZH(e, t) {
  const n = Math.abs(e.clientX - t.clientX), i = Math.abs(e.clientY - t.clientY), r = n / i;
  let s, a;
  return r > 0.3 && r < 1.7 ? s = a = !0 : n > i ? s = !0 : a = !0, { x: s, y: a };
}
function jS(e, t, n) {
  if (t.scale) {
    const { center: i, pointers: r } = n, s = 1 / t.scale * n.scale, a = n.target.getBoundingClientRect(), l = ZH(r[0], r[1]), c = t.options.zoom.mode, d = {
      x: l.x && as(c, "x", e) ? s : 1,
      y: l.y && as(c, "y", e) ? s : 1,
      focalPoint: {
        x: i.x - a.left,
        y: i.y - a.top
      }
    };
    yg(e, d, "zoom", "pinch"), t.scale = n.scale;
  }
}
function KH(e, t, n) {
  if (t.options.zoom.pinch.enabled) {
    const i = Hi(n, e);
    Fe(t.options.zoom.onZoomStart, [{ chart: e, event: n, point: i }]) === !1 ? (t.scale = null, Fe(t.options.zoom.onZoomRejected, [{ chart: e, event: n }])) : t.scale = 1;
  }
}
function XH(e, t, n) {
  t.scale && (jS(e, t, n), t.scale = null, Fe(t.options.zoom.onZoomComplete, [{ chart: e }]));
}
function GS(e, t, n) {
  const i = t.delta;
  i && (t.panning = !0, HS(e, { x: n.deltaX - i.x, y: n.deltaY - i.y }, t.panScales), t.delta = { x: n.deltaX, y: n.deltaY });
}
function JH(e, t, n) {
  const { enabled: i, onPanStart: r, onPanRejected: s } = t.options.pan;
  if (!i)
    return;
  const a = n.target.getBoundingClientRect(), l = {
    x: n.center.x - a.left,
    y: n.center.y - a.top
  };
  if (Fe(r, [{ chart: e, event: n, point: l }]) === !1)
    return Fe(s, [{ chart: e, event: n }]);
  t.panScales = FS(t.options.pan, l, e), t.delta = { x: 0, y: 0 }, GS(e, t, n);
}
function QH(e, t) {
  t.delta = null, t.panning && (t.panning = !1, t.filterNextClick = !0, Fe(t.options.pan.onPanComplete, [{ chart: e }]));
}
const sm = /* @__PURE__ */ new WeakMap();
function C0(e, t) {
  const n = Vt(e), i = e.canvas, { pan: r, zoom: s } = t, a = new nl.Manager(i);
  s && s.pinch.enabled && (a.add(new nl.Pinch()), a.on("pinchstart", (l) => KH(e, n, l)), a.on("pinch", (l) => jS(e, n, l)), a.on("pinchend", (l) => XH(e, n, l))), r && r.enabled && (a.add(new nl.Pan({
    threshold: r.threshold,
    enable: YH(e, n)
  })), a.on("panstart", (l) => JH(e, n, l)), a.on("panmove", (l) => GS(e, n, l)), a.on("panend", () => QH(e, n))), sm.set(e, a);
}
function T0(e) {
  const t = sm.get(e);
  t && (t.remove("pinchstart"), t.remove("pinch"), t.remove("pinchend"), t.remove("panstart"), t.remove("pan"), t.remove("panend"), t.destroy(), sm.delete(e));
}
function eW(e, t) {
  var a, l, c, d;
  const { pan: n, zoom: i } = e, { pan: r, zoom: s } = t;
  return ((l = (a = i == null ? void 0 : i.zoom) == null ? void 0 : a.pinch) == null ? void 0 : l.enabled) !== ((d = (c = s == null ? void 0 : s.zoom) == null ? void 0 : c.pinch) == null ? void 0 : d.enabled) || (n == null ? void 0 : n.enabled) !== (r == null ? void 0 : r.enabled) || (n == null ? void 0 : n.threshold) !== (r == null ? void 0 : r.threshold);
}
var tW = "2.2.0";
function uc(e, t, n) {
  const i = n.zoom.drag, { dragStart: r, dragEnd: s } = Vt(e);
  if (i.drawTime !== t || !s)
    return;
  const { left: a, top: l, width: c, height: d } = qS(e, n.zoom.mode, { dragStart: r, dragEnd: s }, i.maintainAspectRatio), f = e.ctx;
  f.save(), f.beginPath(), f.fillStyle = i.backgroundColor || "rgba(225,225,225,0.3)", f.fillRect(a, l, c, d), i.borderWidth > 0 && (f.lineWidth = i.borderWidth, f.strokeStyle = i.borderColor || "rgba(225,225,225)", f.strokeRect(a, l, c, d)), f.restore();
}
var nW = {
  id: "zoom",
  version: tW,
  defaults: {
    pan: {
      enabled: !1,
      mode: "xy",
      threshold: 10,
      modifierKey: null
    },
    zoom: {
      wheel: {
        enabled: !1,
        speed: 0.1,
        modifierKey: null
      },
      drag: {
        enabled: !1,
        drawTime: "beforeDatasetsDraw",
        modifierKey: null
      },
      pinch: {
        enabled: !1
      },
      mode: "xy"
    }
  },
  start: function(e, t, n) {
    const i = Vt(e);
    i.options = n, Object.prototype.hasOwnProperty.call(n.zoom, "enabled") && console.warn("The option `zoom.enabled` is no longer supported. Please use `zoom.wheel.enabled`, `zoom.drag.enabled`, or `zoom.pinch.enabled`."), (Object.prototype.hasOwnProperty.call(n.zoom, "overScaleMode") || Object.prototype.hasOwnProperty.call(n.pan, "overScaleMode")) && console.warn("The option `overScaleMode` is deprecated. Please use `scaleMode` instead (and update `mode` as desired)."), nl && C0(e, n), e.pan = (r, s, a) => HS(e, r, s, a), e.zoom = (r, s) => yg(e, r, s), e.zoomRect = (r, s, a) => zS(e, r, s, a), e.zoomScale = (r, s, a) => AH(e, r, s, a), e.resetZoom = (r) => MH(e, r), e.getZoomLevel = () => VH(e), e.getInitialScaleBounds = () => WS(e), e.getZoomedScaleBounds = () => LH(e), e.isZoomedOrPanned = () => FH(e), e.isZoomingOrPanning = () => w0(e);
  },
  beforeEvent(e, { event: t }) {
    if (w0(e))
      return !1;
    if (t.type === "click" || t.type === "mouseup") {
      const n = Vt(e);
      if (n.filterNextClick)
        return n.filterNextClick = !1, !1;
    }
  },
  beforeUpdate: function(e, t, n) {
    const i = Vt(e), r = i.options;
    i.options = n, eW(r, n) && (T0(e), C0(e, n)), jH(e, n);
  },
  beforeDatasetsDraw(e, t, n) {
    uc(e, "beforeDatasetsDraw", n);
  },
  afterDatasetsDraw(e, t, n) {
    uc(e, "afterDatasetsDraw", n);
  },
  beforeDraw(e, t, n) {
    uc(e, "beforeDraw", n);
  },
  afterDraw(e, t, n) {
    uc(e, "afterDraw", n);
  },
  stop: function(e) {
    GH(e), nl && T0(e), vH(e);
  },
  panFunctions: im,
  zoomFunctions: tm,
  zoomRectFunctions: nm
};
const YS = "Fairleads", ZS = "Winches", KS = "Pedestals", XS = "Mooring lines", JS = "Ship Contour", gh = "#B80000", vh = "#4F81BD", yh = "#F79646", ph = "#3A870E", I0 = "#000000", iW = "BOW_STERN", rW = "BREAST", sW = "SPRING", bh = (e, t) => {
  const n = (a) => a.toFixed(2), i = n(t.x), r = n(t.y), s = n(t.z);
  return e + (t.index + 1) + ` (x: ${i}, y: ${r}, z: ${s})`;
}, aW = (e) => {
  const t = e.dataset.label || "", n = e.dataset.data[e.dataIndex];
  return t ? t.includes(YS) ? bh("F", n) : t.includes(ZS) ? bh("W", n) : t.includes(KS) ? bh("P", n) : "" : "";
}, Ur = {
  responsive: !0,
  maintainAspectRatio: !1,
  plugins: {
    tooltip: {
      callbacks: {
        label: aW
      },
      filter: function(e) {
        return e.dataset.label !== JS && e.dataset.label !== XS;
      }
    },
    zoom: {
      pan: { enabled: !0, modifierKey: void 0 },
      zoom: {
        wheel: {
          enabled: !0,
          modifierKey: "ctrl"
        },
        pinch: {
          enabled: !0
        },
        mode: "xy"
      }
    },
    legend: {
      position: "top",
      align: "center",
      display: !0,
      labels: {
        usePointStyle: !0
      }
    }
  },
  scales: {
    x: {
      ticks: {
        display: !0,
        z: 1,
        showLabelBackdrop: !0,
        minRotation: 0,
        maxRotation: 0,
        crossAlign: "near",
        color: (e, t) => e.tick.value === 0 ? "rgb(0,0,0)" : "rgba(0,0,0,0.75)",
        callback: (e) => (e = Number(e), e === 0 ? e : e.toFixed(0))
      },
      grid: {
        color: (e, t) => e.tick.value === 0 ? "rgba(0,0,0,0.25)" : "rgba(0,0,0,0.1)",
        lineWidth: function(e) {
          return e.tick.value === 0 ? 2 : 1;
        }
      }
    },
    y: {
      position: "right",
      ticks: {
        display: !0,
        mirror: !0,
        padding: 30,
        showLabelBackdrop: !0,
        z: 1,
        color: (e, t) => e.tick.value === 0 ? "rgb(0,0,0)" : "rgba(0,0,0,0.75)",
        callback: (e) => (e = Number(e), e === 0 ? e : e.toFixed(0))
      },
      grid: {
        color: (e, t) => e.tick.value === 0 ? "rgba(0,0,0,0.25)" : "rgba(0,0,0,0.1)",
        lineWidth: function(e) {
          return e.tick.value === 0 ? 2 : 1;
        }
      }
    }
  }
}, oW = {
  style: { position: "absolute" },
  class: "mx-1 my-3"
}, lW = /* @__PURE__ */ St("span", null, "Reset graph to origin location and zoom location", -1), uW = /* @__PURE__ */ St("span", null, "Click + drag to change the viewport, CTRL + scroll to zoom", -1), QS = /* @__PURE__ */ Je({
  __name: "ChartControls",
  emits: ["resetZoom"],
  setup(e, { emit: t }) {
    const n = t;
    return (i, r) => (le(), nt("div", oW, [
      b(dl, {
        location: "right",
        "open-delay": "500"
      }, {
        activator: Z(({ props: s }) => [
          b(rt, fe({ class: "mr-0" }, s, {
            icon: "mdi-arrow-expand-all",
            variant: "text",
            onClick: r[0] || (r[0] = (a) => n("resetZoom"))
          }), null, 16)
        ]),
        default: Z(() => [
          lW
        ]),
        _: 1
      }),
      b(dl, {
        location: "right",
        "open-delay": "500"
      }, {
        activator: Z(({ props: s }) => [
          b(rt, fe({ class: "mr-0" }, s, {
            icon: "mdi-help-circle",
            variant: "text",
            onClick: r[1] || (r[1] = (a) => n("resetZoom"))
          }), null, 16)
        ]),
        default: Z(() => [
          uW
        ]),
        _: 1
      })
    ]));
  }
}), cW = /* @__PURE__ */ Je({
  __name: "ShipChart",
  props: {
    ship: { type: Object, required: !0 },
    height: { type: String, default: "65vh" }
  },
  setup(e) {
    const n = ce(e, "ship");
    pl.register(Jh, bc, Yo, Bz, Ez, nW);
    const i = I(() => (n.value.shipcontour_set ? [...n.value.shipcontour_set] : []).sort((D, R) => D.id - R.id)), r = I(() => {
      var E;
      return ((E = n.value) == null ? void 0 : E.winch_set) ?? [];
    }), s = I(() => {
      var E;
      return ((E = n.value) == null ? void 0 : E.pedestal_set) ?? [];
    }), a = I(() => {
      var E;
      return ((E = n.value) == null ? void 0 : E.fairlead_set) ?? [];
    }), l = I(() => {
      var E;
      return ((E = n.value) == null ? void 0 : E.length_overall) * 0.6;
    }), c = I(() => {
      var E;
      return ((E = n.value) == null ? void 0 : E.length_overall) * 0.4;
    }), d = I(() => {
      var E;
      return ((E = n.value) == null ? void 0 : E.length_overall) * 0.2;
    }), f = I(() => {
      var E;
      return ((E = n.value) == null ? void 0 : E.breadth) * 1.4;
    }), m = I(() => {
      var E;
      return (E = n.value) == null ? void 0 : E.breadth;
    }), g = I(() => {
      var E;
      return ((E = n.value) == null ? void 0 : E.breadth) * 0.9;
    }), v = (E, D) => {
      const R = E.find(($) => $.id === D);
      return R ? { x: R.x, y: R.y } : { x: null, y: null };
    }, p = I(() => {
      const E = [];
      return a.value.forEach((D) => {
        const R = _(D);
        E.push(...R);
      }), [
        {
          label: XS,
          data: E,
          borderColor: I0,
          backgroundColor: I0,
          hover: {
            mode: !1
          },
          pointRadius: 1,
          borderWidth: 1,
          hoverRadius: 1,
          hoverBorderWidth: 1,
          showLine: !0
        }
      ];
    }), _ = (E) => {
      if (E.winch) {
        const D = E.x > 0 ? 1 : -1;
        let R = { x: 0, y: 0 };
        E.line_type === iW ? (R.x = D * l.value, R.y = -f.value) : E.line_type === rW ? (R.x = D * c.value, R.y = -m.value) : E.line_type === sW && (R.x = D * d.value, R.y = -g.value);
        let $ = [];
        return E.pedestal ? $ = [
          v(r.value, E.winch),
          v(s.value, E.pedestal),
          { x: E.x, y: E.y },
          R,
          { x: null, y: null }
        ] : $ = [
          v(r.value, E.winch),
          { x: E.x, y: E.y },
          R,
          { x: null, y: null }
        ], $;
      }
      return [];
    }, x = I(() => {
      let E = [];
      return i.value && E.push({
        label: JS,
        hover: {
          mode: !1
        },
        pointRadius: 1,
        borderWidth: 1,
        hoverRadius: 1,
        hoverBorderWidth: 1,
        showLine: !0,
        borderColor: gh,
        backgroundColor: gh,
        pointBackgroundColor: gh,
        data: i.value.map((D) => ({ x: D.x, y: D.y }))
      }), a.value && E.push({
        label: YS,
        fill: !1,
        pointStyle: "rectRot",
        radius: 4,
        borderColor: vh,
        backgroundColor: vh,
        pointBackgroundColor: vh,
        data: a.value.map((D, R) => ({ index: R, id: D.id, x: D.x, y: D.y, z: D.z }))
      }), r.value && E.push({
        label: ZS,
        fill: !1,
        pointStyle: "triangle",
        radius: 4,
        borderColor: yh,
        backgroundColor: yh,
        pointBackgroundColor: yh,
        data: r.value.map((D, R) => ({ index: R, id: D.id, x: D.x, y: D.y, z: D.z }))
      }), s.value && E.push({
        label: KS,
        fill: !1,
        borderColor: ph,
        backgroundColor: ph,
        pointBackgroundColor: ph,
        data: s.value.map((D, R) => ({ index: R, id: D.id, x: D.x, y: D.y, z: D.z }))
      }), E.push(...p.value), { datasets: E };
    }), S = I(() => {
      var H, B;
      const E = { ...Ur.scales }, D = ((H = Ur == null ? void 0 : Ur.scales) == null ? void 0 : H.x) ?? {}, R = ((B = Ur == null ? void 0 : Ur.scales) == null ? void 0 : B.y) ?? {}, $ = {
        ...D,
        min: -T.value,
        max: T.value,
        stepSize: 10
      }, A = {
        ...R,
        min: -T.value,
        max: T.value,
        stepSize: 10
      }, V = { ...E, x: $, y: A };
      return { ...Ur, scales: V };
    }), T = I(() => {
      const E = n.value.length_overall;
      return E ? Math.ceil(E / 2) * 1.25 : 0;
    });
    function M() {
      const E = pl.getChart("chartRef");
      E && E.resetZoom();
    }
    return (E, D) => (le(), nt("div", {
      style: Qr({ height: e.height })
    }, [
      b(QS, {
        onResetZoom: D[0] || (D[0] = (R) => M())
      }),
      b(je(fH), {
        id: "chartRef",
        ref: "chartRef",
        data: x.value,
        options: S.value
      }, null, 8, ["data", "options"])
    ], 4));
  }
}), e1 = /* @__PURE__ */ Tr(cW, [["__scopeId", "data-v-43bcd7f3"]]), dW = ee({
  modelValue: Boolean,
  options: {
    type: Object,
    // For more information on types, navigate to:
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    default: () => ({
      root: void 0,
      rootMargin: void 0,
      threshold: void 0
    })
  },
  ...Ae(),
  ...Di(),
  ...pt(),
  ...Wa({
    transition: "fade-transition"
  })
}, "VLazy"), P0 = pe()({
  name: "VLazy",
  directives: {
    intersect: ed
  },
  props: dW(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      dimensionStyles: i
    } = Vi(e), r = at(e, "modelValue");
    function s(a) {
      r.value || (r.value = a);
    }
    return ke(() => rn(b(e.tag, {
      class: ["v-lazy", e.class],
      style: [i.value, e.style]
    }, {
      default: () => [r.value && b(pr, {
        transition: e.transition,
        appear: !0
      }, {
        default: () => {
          var a;
          return [(a = n.default) == null ? void 0 : a.call(n)];
        }
      })]
    }), [[ji("intersect"), {
      handler: s,
      options: e.options
    }, null]])), {};
  }
}), fW = {
  key: 1,
  class: "fill-height",
  style: { "align-content": "center", "text-align": "center" }
}, hW = /* @__PURE__ */ St("span", null, "No plan view of ship", -1), mW = [
  hW
], gW = /* @__PURE__ */ Je({
  __name: "ShipIndex",
  props: {
    currentItem: { type: [Object, null], required: !0 },
    items: { type: Array, required: !0 },
    selectedItems: { type: Array, required: !0 },
    loading: { type: Boolean, required: !1, default: !1 },
    density: { type: String, required: !1, default: "default" },
    showCheckAll: { type: Boolean, required: !1, default: !0 },
    checkAllDisabled: { type: Boolean, required: !1, default: !1 },
    headers: { type: Array, required: !0 },
    fixedHeader: { type: Boolean, required: !1, default: !0 },
    showPlanView: { type: Boolean, required: !1, default: !1 }
  },
  emits: ["updateSelectedItems"],
  setup(e, { emit: t }) {
    const n = e, i = ue(null), r = ue("0px");
    let s = null;
    const a = t, l = I({
      get() {
        return n.items.length ? n.items.every((f) => n.selectedItems.includes(f)) : !1;
      },
      set: (f) => {
        a("updateSelectedItems", f, n.items);
      }
    }), c = I(() => n.showPlanView ? 8 : 12), d = I(() => {
      const f = n.showCheckAll ? 52 : 0;
      return `calc(${r.value} - ${f}px)`;
    });
    return Jn(async () => {
      await Ct(), i.value && i.value.$el instanceof Element && (s = new ResizeObserver(() => {
        var f, m;
        r.value = (((m = (f = i.value) == null ? void 0 : f.$el) == null ? void 0 : m.offsetHeight) || 0) + "px";
      }), s.observe(i.value.$el));
    }), kn(() => {
      s && s.disconnect();
    }), (f, m) => (le(), Te(Ir, {
      border: "opacity-35 sm",
      variant: "text",
      ref_key: "outer",
      ref: i
    }, {
      default: Z(() => [
        b(Da, {
          "no-gutters": "",
          style: Qr({ height: r.value })
        }, {
          default: Z(() => [
            b(hi, { cols: c.value }, {
              default: Z(() => [
                e.showCheckAll ? (le(), Te(Wm, {
                  key: 0,
                  label: "Select all",
                  modelValue: l.value,
                  "onUpdate:modelValue": m[0] || (m[0] = (g) => l.value = g),
                  disabled: e.checkAllDisabled,
                  density: "compact",
                  class: "pt-3 pl-4",
                  "hide-details": ""
                }, null, 8, ["modelValue", "disabled"])) : it("", !0),
                b(P0, null, {
                  default: Z(() => [
                    b(Gw, {
                      items: e.items,
                      loading: e.loading,
                      headers: e.headers,
                      density: e.density,
                      "fixed-header": e.fixedHeader,
                      height: d.value,
                      overflow: !0
                    }, {
                      "table-header": Z(() => [
                        wt(f.$slots, "table-header")
                      ]),
                      "table-row": Z(({ item: g }) => [
                        wt(f.$slots, "table-row", { item: g })
                      ]),
                      _: 3
                    }, 8, ["items", "loading", "headers", "density", "fixed-header", "height"])
                  ]),
                  _: 3
                })
              ]),
              _: 3
            }, 8, ["cols"]),
            b(Kc, { vertical: "" }),
            e.showPlanView ? (le(), Te(hi, {
              key: 0,
              cols: 12 - c.value,
              style: Qr({ height: r.value })
            }, {
              default: Z(() => {
                var g;
                return [
                  (g = e.currentItem) != null && g.has_ship_design ? (le(), Te(P0, { key: 0 }, {
                    default: Z(() => [
                      b(e1, {
                        ship: e.currentItem,
                        height: r.value,
                        class: "pl-2"
                      }, null, 8, ["ship", "height"])
                    ]),
                    _: 1
                  })) : (le(), nt("div", fW, mW))
                ];
              }),
              _: 1
            }, 8, ["cols", "style"])) : it("", !0)
          ]),
          _: 3
        }, 8, ["style"])
      ]),
      _: 3
    }, 512));
  }
}), vW = /* @__PURE__ */ Je({
  __name: "ValidationButton",
  props: {
    modelValue: {
      type: Boolean,
      required: !0
    },
    showValidationButton: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = t;
    return (i, r) => e.showValidationButton ? (le(), Te(rt, {
      key: 0,
      class: "text-none",
      rounded: "lg",
      color: "primary",
      variant: "tonal",
      "prepend-icon": e.modelValue ? "mdi-check" : "",
      onClick: r[0] || (r[0] = Dt(() => n("update:modelValue", !e.modelValue), ["stop"]))
    }, {
      default: Z(() => [
        Ee(" Only validated data ")
      ]),
      _: 1
    }, 8, ["prepend-icon"])) : it("", !0);
  }
}), yW = /* @__PURE__ */ Je({
  __name: "RHDHVWorkOrderField",
  props: {
    modelValue: { type: Object, required: !0 },
    itemKey: { type: String, required: !1 },
    field: { type: Object, required: !0 },
    customErrorRules: { type: Array, required: !1, default: [] },
    label: {
      type: String,
      default: "Work Order"
    }
  },
  setup(e) {
    const t = e, n = I({
      get: () => t.modelValue,
      set() {
      }
    }), i = (r) => {
      if (!r)
        return `${t.label} is required.`;
      const s = r.trim();
      return /^[A-Z]{2}\d{4}$/.test(s) || `${t.label} must be in AA1111 format.`;
    };
    return (r, s) => (le(), Te(je(Km), fe({
      modelValue: n.value,
      "onUpdate:modelValue": s[0] || (s[0] = (a) => n.value = a),
      field: t.field,
      label: t.label,
      "show-error-without-update": "",
      "custom-error-rules": [i, ...e.customErrorRules]
    }, r.$attrs), null, 16, ["modelValue", "field", "label", "custom-error-rules"]));
  }
}), wW = {
  install: (e, t = {}) => {
    e.component("RHDHVWorkOrderField", yW), e.component("RHDHVHeaderLogo", Gx), e.component("RHDHVHeaderMenu", jx), e.component("RHDHVToolbar", xx), e.component("RHDHVLoader", Zx), e.component("RHDHVHeader", yD), e.component("AppBackground", i_), e.component("RHDHVSnackbar", OD), e.component("ProjectCard", l_), e.component("ProjectCardMenu", zD), e.component("ProjectDataTable", Bw), e.component("ProjectHeaderImage", Nw), e.component("ProjectCardGrid", $w), e.component("ProjectIndexTitle", Ww), e.component("ProjectIndex", IF), e.component("RHDHVForm", Uw), e.component("RHDHVDataTable", WF), e.component("FavoriteButton", UF), e.component("ColourPicker", zR), e.component("HelpTextTooltip", Zm), e.component("ChoiceField", UR), e.component("TextField", Km), e.component("CheckboxField", qR), e.component("CreateOrUpdateDialog", YR), e.component("DeleteDialog", KR), e.component("DuplicateDialog", JR), e.component("DocumentationButton", t_), e.component("ShipAPIIndex", gW), e.component("ShipAPITable", Gw), e.component("ShipChart", e1), e.component("ChartControls", QS), e.component("ValidationButton", vW);
    const n = t.externalBus || n_();
    e.provide("eventBus", n);
  }
};
export {
  i_ as AppBackground,
  QS as ChartControls,
  qR as CheckboxField,
  UR as ChoiceField,
  zR as ColourPicker,
  wW as ComponentLibrary,
  YR as CreateOrUpdateDialog,
  KR as DeleteDialog,
  t_ as DocumentationButton,
  JR as DuplicateDialog,
  UF as FavoriteButton,
  Zm as HelpTextTooltip,
  l_ as ProjectCard,
  $w as ProjectCardGrid,
  zD as ProjectCardMenu,
  Bw as ProjectDataTable,
  Nw as ProjectHeaderImage,
  IF as ProjectIndex,
  Ww as ProjectIndexTitle,
  WF as RHDHVDataTable,
  Uw as RHDHVForm,
  yD as RHDHVHeader,
  Gx as RHDHVHeaderLogo,
  jx as RHDHVHeaderMenu,
  Zx as RHDHVLoader,
  OD as RHDHVSnackbar,
  xx as RHDHVToolbar,
  yW as RHDHVWorkOrderField,
  e1 as ShipChart,
  gW as ShipIndex,
  Gw as ShipTable,
  Km as TextField,
  vW as ValidationButton,
  n_ as useEventsBus
};
